// src/i18n/locales/de.js
//
// MINIMAL FALLBACK: Diese Datei dient nur als Fallback für:
// - Offline-Funktionalität
// - Initial Load (bevor DB-Daten geladen sind)
// - Kritische System-Texte
//
// Die primäre Quelle für alle Übersetzungen ist die Datenbank (i18n.i18n_keys).
// Diese Datei sollte nur minimale, kritische Texte enthalten.

import trainerDe from "./trainer.de.js";
import marketingDe from "./marketing.de.js";
import matchflowDe from "./matchflow.de.js";
import winterdoppelSwapDe from "./winterdoppel-swap.de.js";
import winterdoppelWhatsappDe from "./winterdoppel-whatsapp.de.js";

export default {
  // Minimaler Fallback - alle Texte sollten aus der DB kommen
  // Diese Keys werden nur verwendet, wenn die DB nicht verfügbar ist
  "appFeedback.session.created": "Training wurde angelegt.",
  "appFeedback.session.seriesCreated": "{count} Trainings wurden angelegt.",
  "appFeedback.session.updated": "Training wurde gespeichert.",
  "appFeedback.session.rescheduled":
    "Training wurde auf {date} um {time} Uhr verschoben.",
  "appFeedback.session.attendanceSaved": "Anwesenheit wurde gespeichert.",
  "appFeedback.session.confirmed": "Training wurde als durchgeführt bestätigt.",
  "appFeedback.session.cancelled": "Training wurde abgesagt.",
  "appFeedback.session.deleted": "Training wurde gelöscht.",
  "appFeedback.session.restored": "Training wurde wiederhergestellt.",
  "appFeedback.person.created": "Person wurde angelegt.",
  "appFeedback.person.updated": "Person wurde gespeichert.",
  "appFeedback.person.deleted": "Person wurde gelöscht.",
  "appFeedback.trainer.created": "Trainer wurde angelegt.",
  "appFeedback.trainer.assistantCreated": "Trainerassistent wurde angelegt.",
  "appFeedback.trainer.updated": "Trainer wurde gespeichert.",
  "appFeedback.trainer.deactivated": "Trainer wurde deaktiviert.",
  "appFeedback.trainer.reactivated": "Trainer wurde reaktiviert.",
  "appFeedback.location.created": "Ort wurde angelegt.",
  "appFeedback.location.updated": "Ort wurde gespeichert.",
  "appFeedback.location.deleted": "Ort wurde gelöscht.",
  "appFeedback.billingContact.created": "Rechnungsempfänger wurde angelegt.",
  "appFeedback.billingContact.updated": "Rechnungsempfänger wurde gespeichert.",
  "appFeedback.billingContact.deleted": "Rechnungsempfänger wurde gelöscht.",
  "appFeedback.payment.created": "Zahlung wurde erfasst.",
  "appFeedback.payment.updated": "Zahlung wurde gespeichert.",
  "appFeedback.payment.deleted": "Zahlung wurde gelöscht.",
  "appFeedback.payment.receiptMailSent":
    "Zahlungsbestätigung wurde an {email} gesendet.",
  "appFeedback.payment.receiptMailSimulated":
    "Zahlungsbestätigung simuliert (Testmodus) – Ziel: {email}.",
  "appFeedback.payment.receiptMailFailed":
    "Zahlung erfasst, aber die Bestätigungs-Mail konnte nicht gesendet werden.",
  "appFeedback.billing.correctionSaved": "Korrektur wurde gespeichert.",
  "appFeedback.billing.dispatched": "Versand wurde protokolliert.",
  "appFeedback.billing.statementSaved": "Rechnung wurde gespeichert.",
  "appFeedback.billing.statementCreatedFor":
    "Rechnung für {name} wurde erfolgreich erstellt.",
  "appFeedback.billing.creditAppliedOnDraft":
    "{amount} Guthaben wurden auf den Entwurf verrechnet.",
  "appFeedback.billing.creditRecorded":
    "Guthaben aus der abgesagten Stunde wurde notiert.",
  "appFeedback.billing.manualCreditRecorded":
    "Gutschrift über {amount} wurde erfasst.",
  "appFeedback.billing.positionCreditCreated":
    "Gutschrift {number} wurde erstellt.",
  "appFeedback.billing.positionCreditsCreatedBulk":
    "Gutschriften für {count} Position(en) wurden erstellt.",
  "appFeedback.billing.manualCreditApplied":
    "Gutschrift über {credited} erfasst — {applied} auf die Rechnung verrechnet.",
  "appFeedback.billing.manualCreditFailed":
    "Gutschrift konnte nicht gespeichert werden.",
  "appFeedback.billing.itemRebooked":
    "Umbuchung gespeichert: {credited} gutgeschrieben, {rebilled} nachbelastet.",
  "appFeedback.billing.itemRebookFailed":
    "Umbuchung konnte nicht gespeichert werden.",
  "appFeedback.billing.statementUpdated": "Rechnung wurde aktualisiert.",
  "appFeedback.billing.statementsGenerated": "Rechnungen wurden erstellt.",
  "appFeedback.billing.statementSent": "Rechnung wurde als versendet markiert.",
  "appFeedback.billing.invoiceMailBatchSentOne":
    "Rechnung wurde per E-Mail versendet.",
  "appFeedback.billing.invoiceMailBatchSentMany":
    "{count} Rechnungen wurden per E-Mail versendet.",
  "appFeedback.billing.statementPaid": "Rechnung wurde als bezahlt markiert.",
  "appFeedback.billing.statementPaymentReverted":
    "Zahlung wurde zurückgenommen.",
  "appFeedback.billing.statementCancelled": "Rechnung wurde storniert.",
  "appFeedback.billing.statementStornoWithDraft":
    "Stornorechnung erstellt — neuer Entwurf liegt unter Rechnungen bereit.",
  "appFeedback.billing.statementReverted":
    "Rechnung wurde zurück in den Entwurf gesetzt.",
  "appFeedback.billing.settlementSaved": "Trainerabrechnung wurde gespeichert.",
  "appFeedback.billing.settlementFinalized":
    "Trainerabrechnung wurde abgeschlossen.",
  "appFeedback.billing.settlementPaid":
    "Trainerabrechnung wurde als bezahlt markiert.",
  "appFeedback.billing.settlementCancelled":
    "Trainerabrechnung wurde storniert.",
  "appFeedback.settings.saved": "Einstellungen wurden gespeichert.",
  "appFeedback.settings.invoiceLayoutSaved":
    "Rechnungslayout wurde gespeichert.",
  "appFeedback.settings.invoiceLayoutActivated":
    "Version {number} ist jetzt der aktive Standard.",
  "appFeedback.settings.invoiceLayoutDeleted": "Layout-Version wurde gelöscht.",
  "appFeedback.invite.sent": "Einladung wurde versendet.",
  "common.loading": "Lade…",
  "common.requiredFieldAsterisk": "*",
  "common.required": "Pflicht",
  "common.requiredAria": "Pflichtfeld",
  "common.requiredFootnote": "* Pflichtfeld",
  "common.valueMissing": "—",
  "common.loading.aria": "Lädt",
  "public.money.eur": "{amount} €",
  "public.parentConfirm.title": "Trainingsstunden bestätigen",
  "public.parentConfirm.subtitle":
    "Bitte bestätige kurz die Trainingsstunden. Danach erhältst du die Zahlungsinformationen.",
  "public.parentConfirm.loading": "Lade Trainingsstunden…",
  "public.parentConfirm.invalidLink":
    "Dieser Link ist ungültig oder abgelaufen.",
  "public.parentConfirm.childLabel": "Kind",
  "public.parentConfirm.childFallback": "—",
  "public.parentConfirm.periodLabel": "Zeitraum",
  "public.parentConfirm.itemsEmpty": "Keine Stunden gefunden.",
  "public.parentConfirm.totalLabel": "Gesamt",
  "public.parentConfirm.confirmCta": "✅ Bestätigen",
  "public.parentConfirm.questionCta": "❌ Rückfrage",
  "public.parentConfirm.confirmFailed":
    "Bestätigung konnte nicht gespeichert werden.",
  "public.parentConfirm.questionFailed":
    "Rückfrage konnte nicht gespeichert werden.",
  "public.parentConfirm.doneHint":
    "Danke! Du kannst dieses Fenster jetzt schließen.",
  "public.sessionRsvp.title": "Training bestätigen",
  "public.sessionRsvp.subtitle":
    "Bitte teile kurz mit, ob du beim Training dabei bist.",
  "public.sessionRsvp.loading": "Lade Training…",
  "public.sessionRsvp.invalidLink": "Dieser Link ist ungültig oder abgelaufen.",
  "public.sessionRsvp.personLabel": "Für",
  "public.sessionRsvp.whenLabel": "Termin",
  "public.sessionRsvp.trainerLabel": "Trainer: {name}",
  "public.sessionRsvp.attendCta": "Ich bin dabei",
  "public.sessionRsvp.declineCta": "Ich sage ab",
  "public.sessionRsvp.saveFailed":
    "Speichern fehlgeschlagen. Bitte erneut versuchen.",
  "public.sessionRsvp.doneAttending": "Danke — du bist als dabei gespeichert.",
  "public.sessionRsvp.doneDeclined": "Danke — deine Absage wurde gespeichert.",
  "public.pay.title": "Zahlung",
  "public.pay.subtitle":
    "Vielen Dank für die Bestätigung. Hier findest du die Zahlungsinformationen.",
  "public.pay.loading": "Lade Zahlungsdaten…",
  "public.pay.invalidLink": "Dieser Zahlungslink ist ungültig oder abgelaufen.",
  "public.pay.amountLabel": "Offener Betrag",
  "public.pay.paypalTitle": "PayPal",
  "public.pay.paypalCta": "Mit PayPal bezahlen",
  "public.pay.paypalUnavailable": "PayPal ist aktuell nicht verfügbar.",
  "public.pay.bankTitle": "Überweisung",
  "public.pay.bank.iban": "IBAN",
  "public.pay.bank.bic": "BIC",
  "public.pay.bank.holder": "Empfänger",
  "public.pay.bank.reference": "Verwendungszweck",
  "public.pay.testMode.title": "Testmodus",
  "public.pay.testMode.hint": "Es wird kein echtes Geld bewegt.",
  "public.pay.testMode.simulateCta": "Testzahlung simulieren",
  "public.pay.simulateFailed": "Testzahlung konnte nicht simuliert werden.",
  "public.pay.success.title": "Zahlung erfolgreich",
  "public.pay.success.working": "Zahlung wird bestätigt…",
  "public.pay.success.ok": "Danke! Die Zahlung wurde verbucht.",
  "public.pay.success.failed": "Zahlung konnte nicht bestätigt werden.",
  "public.pay.success.invalid": "Ungültiger Zahlungsstatus.",
  "public.pay.success.backToPay": "Zur Zahlungsseite",
  "public.pay.success.backToPortal": "Zurück zu meinen Rechnungen",
  "public.pay.cancel.title": "Zahlung abgebrochen",
  "public.pay.cancel.hint": "Du kannst die Zahlung später erneut durchführen.",
  "public.pay.cancel.backToPay": "Zurück zur Zahlungsseite",
  "public.pay.cancel.backHome": "Zur Startseite",
  "public.booking.title": "Online-Terminbuchung",
  "public.booking.subtitle":
    "Trage deine Anfrage ein: zuerst Verein und Trainer wählen, dann Termin und Details.",
  "public.booking.subtitleCalendar":
    "Verein und Trainer wählen, Termin im Kalender anklicken, Kontaktdaten prüfen und Anfrage senden.",
  "public.booking.sectionRequester": "Deine Kontaktdaten",
  "public.booking.requesterHint":
    "Diese Angaben werden dem Trainer als Anfragender übermittelt. Änderungen im Profil unter Kontaktdaten.",
  "public.booking.fieldClub": "Verein",
  "public.booking.clubSearch.placeholder": "Verein suchen (Name oder Ort)…",
  "public.booking.clubSearch.hint":
    "Tippe mindestens zwei Zeichen, um aus allen buchbaren Vereinen zu wählen.",
  "public.booking.clubSearch.noResults": "Kein passender Verein gefunden.",
  "public.booking.clubSearch.clear": "Vereinsauswahl löschen",
  "public.booking.fieldTrainingFor": "Training für",
  "public.booking.trainingForSelf": "Mich selbst",
  "public.booking.pickClub": "Verein auswählen",
  "public.booking.pickClubFirst": "Zuerst Verein wählen",
  "public.booking.loading": "Lade Buchungsbereich…",
  "public.booking.loginHint":
    "Du hast schon ein Konto? Melde dich an, damit deine Kontaktdaten vorausgefüllt werden.",
  "public.booking.loginCta": "Anmelden (bereits registriert)",
  "public.booking.guestHint":
    "Noch kein Konto? Trage deine Kontaktdaten ein und sende die Anfrage direkt ab.",
  "public.booking.errors.invalidEmail":
    "Bitte eine gültige E-Mail-Adresse eingeben.",
  "public.booking.errors.loginRequired":
    "Bitte anmelden oder als Gast fortfahren.",
  "public.booking.registerPrompt.title": "Konto anlegen?",
  "public.booking.registerPrompt.lead":
    "Deine Anfrage ist unterwegs. Möchtest du dich jetzt registrieren, um künftige Termine schneller anzufragen?",
  "public.booking.registerPrompt.cta": "Jetzt registrieren",
  "public.booking.registerPrompt.later": "Später",
  "public.booking.pickTrainer": "Trainer auswählen",
  "public.booking.consent.privacyPrefix": "Ich habe die",
  "public.booking.consent.privacySuffix":
    " gelesen und willige in die Verarbeitung meiner Angaben zur Bearbeitung dieser Trainingsanfrage ein.",
  "public.booking.errors.consentPrivacyRequired":
    "Bitte bestätige die Datenschutzerklärung.",
  "hub.publicBookingRequests.title": "Deine Trainingsanfragen",
  "hub.publicBookingRequests.lead":
    "Hier siehst du den Stand deiner Terminanfrage nach der Gastbuchung.",
  "hub.publicBookingRequests.slotLabel": "{date}, {time} Uhr · {duration} Min.",
  "hub.publicBookingRequests.confirmedTitle": "Termin bestätigt",
  "hub.publicBookingRequests.confirmedLead":
    "Der Trainer hat deine Anfrage bestätigt.",
  "hub.publicBookingRequests.confirmedBadge": "Bestätigt",
  "public.booking.errors.requesterRequired":
    "Bitte Vorname und Nachname als Anfragender ausfüllen.",
  "public.booking.errors.loadFailed":
    "Buchungsdaten konnten nicht geladen werden.",
  "public.booking.errors.prefillInvalid":
    "Der Buchungslink ist ungültig oder abgelaufen. Du kannst den Termin manuell auswählen.",
  "public.booking.errors.slotRequired":
    "Bitte zuerst einen freien Termin im Kalender auswählen.",
  "public.booking.directory.title": "Vereine & Trainer",
  "public.booking.directory.loading": "Lade Trainerverzeichnis…",
  "public.booking.directory.empty":
    "Derzeit sind keine Trainer für die öffentliche Buchung sichtbar.",
  "public.booking.calendar.title": "Kalender & Auslastung",
  "public.booking.calendar.subtitle":
    "Der Trainer steuert, welche Kalenderinformationen öffentlich sichtbar sind.",
  "public.booking.calendar.loading": "Lade Kalender…",
  "public.booking.calendar.empty":
    "Für den gewählten Zeitraum gibt es keine sichtbaren Trainings.",
  "public.booking.calendar.visibilityAllNoNames":
    "Sichtbarkeit aktiv: alle Trainings sichtbar, ohne Spielernamen.",
  "public.booking.calendar.busySlotLabel":
    "{time} Uhr ({duration} Min.) belegt",
  "public.booking.calendar.prevWeek": "Zurück",
  "public.booking.calendar.nextWeek": "Weiter",
  "public.booking.calendar.prevDay": "Vorheriger Tag",
  "public.booking.calendar.nextDay": "Nächster Tag",
  "public.booking.calendar.today": "Heute",
  "public.booking.calendar.dayStripAria": "Wochentage",
  "public.booking.calendar.pickSlotHint":
    "Im weißen Bereich Startzeit anklicken und nach unten ziehen – wie in Outlook. 30–120 Min. im 30-Min-Raster.",
  "public.booking.calendar.availabilityWindows": "Buchbare Zeiten: {windows}",
  "public.booking.calendar.jumpToNextSlot":
    "Nächste freie Zeit im Kalender wählen",
  "public.booking.calendar.dayColumnAria": "Tag {date}",
  "public.booking.calendar.selectionBlockLabel": "{time} Uhr · {duration} Min.",
  "public.booking.calendar.freeLegend": "Weiß: frei wählbar",
  "public.booking.calendar.blockedLegend": "Schraffiert: nicht buchbar",
  "public.booking.calendar.selectionLegend": "Grün: deine Auswahl",
  "public.booking.calendar.weekInPast":
    "Diese Woche liegt in der Vergangenheit. Bitte „Heute“ oder „Weiter“ wählen.",
  "public.booking.calendar.noAvailabilityHint":
    "Dieser Trainer hat noch keine buchbaren Zeiten hinterlegt. Bitte wende dich an den Verein.",
  "public.booking.calendar.busyLegend": "Blau: bestehendes Training",
  "public.booking.calendar.availabilityLegend": "Grün: buchbare Verfügbarkeit",
  "public.booking.errors.availabilityNotConfigured":
    "Für diesen Trainer sind noch keine Online-Buchungszeiten hinterlegt.",
  "public.booking.errors.outsideAvailability":
    "Der gewählte Termin liegt außerhalb der buchbaren Verfügbarkeit.",
  "public.booking.calendar.slotAria": "{date}, {time} Uhr",
  "public.booking.calendar.selectionLabel":
    "{date}, {time} Uhr · {duration} Min.",
  "public.booking.panel.title": "Terminanfrage",
  "public.booking.linkCreate.cta": "Terminvorschlag teilen",
  "public.booking.linkCreate.creating": "Link wird erstellt…",
  "public.booking.linkCreate.copied":
    "Terminvorschlag-Link wurde in die Zwischenablage kopiert.",
  "public.booking.linkCreate.copyPrompt": "Terminvorschlag-Link kopieren",
  "public.booking.linkCreate.failed":
    "Terminvorschlag-Link konnte nicht erstellt werden.",
  "public.booking.linkCreate.authRequired":
    "Bitte erneut einloggen, um einen Terminvorschlag-Link zu erstellen.",
  "public.booking.linkShare.whatsappCta": "Per WhatsApp teilen",
  "public.booking.linkShare.mailCta": "Per E-Mail teilen",
  "public.booking.linkShare.whatsappText":
    "Hier ist dein Link zur Online-Terminbuchung: {url}",
  "public.booking.linkShare.mailSubject": "Online-Terminbuchung",
  "public.booking.linkShare.mailBody":
    "Hier ist dein Link zur Online-Terminbuchung:\n{url}",
  "public.booking.durableLink.whatsappText":
    "Hier kannst du bei mir online Training anfragen: {url}",
  "public.booking.durableLink.mailSubject": "Mein Buchungslink",
  "public.booking.durableLink.mailBody":
    "Über diesen Link kannst du bei mir online einen Trainingstermin anfragen:\n{url}",

  "ballmates.loader.seitenwechsel.1": "Seitenwechsel...",
  "ballmates.loader.seitenwechsel.2": "Kurze Trinkpause...",
  "ballmates.loader.seitenwechsel.3": "Handtuch holen...",
  "ballmates.loader.seitenwechsel.4": "Durchatmen...",
  "ballmates.loader.seitenwechsel.5": "Gleich geht's weiter...",
  "ballmates.loader.creatingSchedule": "Spielplan wird erstellt...",
  "ballmates.loader.startingTournament": "Turnier wird gestartet...",

  "common.error": "Fehler",
  "common.page.renderError.title": "Fehler beim Laden der Seite",
  "common.goHome": "Zur Startseite",
  "common.code": "Code",
  "common.position": "Position",

  "admin.title": "Admin",
  "admin.status.checkingSession": "Prüfe Session…",
  "admin.status.redirectingToLogin": "Weiterleitung zum Login…",
  "admin.status.redirecting": "Weiterleitung…",

  "react.routeNotMapped.title": "Route nicht gemappt",
  "react.routeNotMapped.hint":
    "React-Mode aktiv, aber diese Route ist noch nicht angebunden:",
  "react.superadminHint.title": "Superadmin – eigene App",
  "react.superadminHint.body":
    "Der Superadmin hat eine eigene Shell und ist eine eigene App. Dort steuerst du zentral Einstellungen der Enduser-Apps, Informationspflege usw.",
  "react.superadminHint.cta": "Zur Superadmin-App",
  "react.legacy.contentRendererNotice":
    "Content wird jetzt in React gerendert.",

  "player.matches.publicViewHint": "Öffentliche Ansicht (ohne Login)",
  "player.matches.schedule": "Spiele",
  "player.matches.error.snapshotNotFound":
    'Kein öffentliches Snapshot für Code "{code}" gefunden. (Bootstrap fehlt)',
  "player.matches.error.publicLoadFailed":
    "Öffentliche Daten konnten nicht geladen werden ({reason}).",
  "player.matches.error.publicUnavailable":
    "Öffentliche Daten konnten nicht geladen werden (API/Snapshot nicht erreichbar).",

  // Auth (Fallback)
  "auth.login.title": "Anmelden",
  "auth.login.subtitle": "Bitte melde dich an, um fortzufahren.",
  "auth.login.google": "Mit Google anmelden",
  "auth.mode.login": "Anmelden",
  "auth.mode.register": "Registrieren",
  "auth.login.orEmail": "oder mit E-Mail",
  "auth.login.email": "E-Mail",
  "auth.login.password": "Passwort",
  "auth.login.submit": "Anmelden",
  "auth.login.error": "Fehler",
  "auth.login.forgotPassword": "Passwort vergessen?",
  "auth.login.rememberMe":
    "Angemeldet bleiben (auch nach dem Schließen des Browsers)",
  "auth.login.errorInvalidCredentials": "E-Mail oder Passwort ist falsch.",
  "auth.login.errorWrongPassword": "Das Passwort ist falsch.",
  "auth.login.alreadyRegisteredMessage": "Du bist bereits registriert.",
  "auth.login.alreadyRegisteredForgot": "Passwort vergessen?",
  "auth.login.alreadyRegisteredOr": "Oder zurück:",
  "auth.login.alreadyRegisteredBack": "melde dich an",
  "auth.login.redirectToRegisterInfo":
    "Für diese E-Mail gibt es noch kein Konto. Bitte schließe die Registrierung ab.",
  "auth.login.redirectToRegisterBackendUnavailable":
    "Die E-Mail-Prüfung ist gerade nicht verfügbar. Bitte schließe die Registrierung ab — falls du bereits ein Konto hast, gib dein Passwort ein und melde dich an.",
  "auth.register.emailCheck.errorBackendUnavailable":
    "Die E-Mail-Prüfung ist gerade nicht verfügbar. Du kannst dich registrieren oder mit Passwort anmelden, falls du bereits ein Konto hast.",
  "auth.forgotPassword.title": "Passwort zurücksetzen",
  "auth.forgotPassword.subtitle":
    "Gib deine E-Mail ein – du erhältst einen Link zum Zurücksetzen des Passworts.",
  "auth.forgotPassword.submit": "Link senden",
  "auth.forgotPassword.sending": "Wird gesendet …",
  "auth.forgotPassword.success":
    "Falls ein Konto mit dieser E-Mail existiert, wurde ein Link zum Zurücksetzen gesendet. Bitte prüfe deinen Posteingang.",
  "auth.forgotPassword.backToLogin": "Zurück zur Anmeldung",
  "auth.forgotPassword.error.missingEmail": "Bitte E-Mail eingeben.",
  "auth.forgotPassword.error.sendFailed":
    "Link konnte nicht gesendet werden. Bitte später erneut versuchen.",
  "auth.resetPassword.title": "Neues Passwort setzen",
  "auth.resetPassword.subtitle":
    "Wähle ein neues Passwort (mindestens 8 Zeichen).",
  "auth.resetPassword.newPassword": "Neues Passwort",
  "auth.resetPassword.confirmPassword": "Passwort bestätigen",
  "auth.resetPassword.submit": "Passwort speichern",
  "auth.resetPassword.saving": "Wird gespeichert …",
  "auth.resetPassword.success":
    "Dein Passwort wurde gespeichert. Du kannst dich jetzt anmelden.",
  "auth.resetPassword.backToLogin": "Zur Anmeldung",
  "auth.resetPassword.loading": "Link wird geprüft …",
  "auth.resetPassword.error.tooShort":
    "Passwort muss mindestens 8 Zeichen haben.",
  "auth.resetPassword.error.mismatch": "Passwörter stimmen nicht überein.",
  "auth.resetPassword.error.noSession":
    "Der Link ist ungültig oder abgelaufen. Bitte fordere einen neuen Link an.",
  "auth.resetPassword.error.failed":
    "Passwort konnte nicht gespeichert werden.",
  "auth.login.showPassword": "Passwort anzeigen",
  "auth.login.hidePassword": "Passwort verbergen",
  "auth.page.brandMark": "TENNIS-MATCHES.DE",
  "auth.page.brandPanelAria": "Über Tennis-Matches",
  "auth.page.headlineLine1": "Deine Matches.",
  "auth.page.headlineLine2": "Dein Spiel.",
  "auth.page.headlineLine3": "Deine Community.",
  "auth.page.tagline":
    "Organisiere Training, Teams und Turniere an einem Ort. Einfach. Fair. Für alle.",
  "auth.page.feature.teams.title": "Teams & Spieler",
  "auth.page.feature.teams.desc": "Verwalte Teams und finde neue Spielpartner.",
  "auth.page.feature.training.title": "Training planen",
  "auth.page.feature.training.desc":
    "Erstelle Trainings und behalte alles im Blick.",
  "auth.page.feature.tournaments.title": "Turniere & Matches",
  "auth.page.feature.tournaments.desc":
    "Spiele, vergleiche und wachse gemeinsam.",
  "auth.page.mobileHeadline": "Deine Matches. Dein Spiel.",
  "auth.page.mobileTagline": "Training, Teams und Turniere an einem Ort.",
  "auth.page.mobileChip.teams": "Teams",
  "auth.page.mobileChip.training": "Training",
  "auth.page.mobileChip.tournaments": "Turniere",
  "auth.page.mobileChipsAria": "Kernfunktionen",
  "auth.page.welcomeTitle": "Willkommen zurück",
  "auth.page.welcomeSubtitle": "Schön, dass du wieder da bist!",
  "auth.page.registerTitle": "Konto erstellen",
  "auth.page.registerSubtitle":
    "Registriere dich und beantrage deinen Vereinszugang.",
  "auth.page.modeTabsAria": "Anmelden oder Registrieren",
  "auth.page.footerNoAccount": "Noch kein Konto?",
  "auth.page.footerRegister": "Jetzt registrieren",
  "auth.page.footerHasAccount": "Bereits ein Konto?",
  "auth.page.footerLogin": "Jetzt anmelden",
  "auth.register.title": "Einladung nutzen",
  "auth.register.subtitle":
    "Diese Einladung ist fuer {inviteEmail}. Erstelle mit dieser E-Mail ein Konto oder melde dich mit ihr an.",
  "auth.register.passwordPlaceholder": "Passwort fuer dein Konto",
  "auth.register.loginWithInviteEmail": "Mit dieser E-Mail anmelden",
  "auth.register.createAccountAndAccept":
    "Konto erstellen und Einladung annehmen",
  "auth.register.verifyEmailHint":
    "Bitte pruefe deine E-Mails und bestaetige die Registrierung. Danach wird die Einladung angenommen.",
  "auth.register.verifyEmailHintPublic":
    "Wir haben dir eine Aktivierungs-E-Mail gesendet. Bitte bestätige deine Adresse; danach wird deine Zugriffsanfrage (pending) sichtbar.",
  "auth.register.verifyEmailHintSimple":
    "Wir haben dir eine Aktivierungs-E-Mail gesendet. Bitte bestätige deine Adresse – danach landest du direkt in deiner Tenniswelt.",
  "auth.register.success.title": "Fast geschafft!",
  "auth.register.success.lead":
    "Wir haben dir eine Aktivierungs-E-Mail geschickt. Bestätige sie, um dein Konto freizuschalten.",
  "auth.register.success.sentToAria": "Gesendet an",
  "auth.register.success.step1": "Öffne dein Postfach (auch den Spam-Ordner).",
  "auth.register.success.step2":
    "Klicke auf den Bestätigungs-Link in der E-Mail.",
  "auth.register.success.step3": "Du landest direkt in deiner Tenniswelt.",
  "auth.register.success.openMailbox": "Postfach öffnen",
  "auth.register.success.backToLogin": "Zur Anmeldung",
  "auth.register.success.resend": "E-Mail erneut senden",
  "auth.register.success.resending": "Sende erneut …",
  "auth.register.success.resendOk":
    "Wir haben dir die Aktivierungs-E-Mail nochmals zugeschickt.",
  "auth.register.success.resendFailed":
    "Erneutes Senden hat nicht geklappt. Bitte etwas warten und nochmal versuchen.",
  "auth.register.success.useDifferentEmail": "Andere E-Mail verwenden",
  "auth.register.success.hint":
    "Keine E-Mail erhalten? Prüfe Spam/Werbung oder fordere die Mail erneut an.",
  "auth.register.simple.submit": "Konto erstellen",
  "auth.register.simple.hintsTitle": "Im nächsten Schritt kannst du:",
  "auth.register.simple.hintsChooseIntent":
    "Wähle oben, wofür du Tennis-Matches nutzt – dann zeigen wir dir die nächsten Schritte.",
  "auth.register.simple.hint.club": "deinen Verein verbinden",
  "auth.register.simple.hint.family": "Familie hinzufügen",
  "auth.register.simple.hint.training": "Trainings buchen",
  "auth.register.simple.hint.trainer": "Trainerfunktionen aktivieren",
  "auth.register.signupIntent.heading": "Wofür nutzt du Tennis-Matches?",
  "auth.register.signupIntent.player.title": "Spieler",
  "auth.register.signupIntent.player.description":
    "Trainings buchen und deinen Verein verbinden.",
  "auth.register.signupIntent.trainer.title": "Trainer",
  "auth.register.signupIntent.trainer.description":
    "Trainings planen, Honorare und Vereine verwalten.",
  "auth.register.signupIntent.both.title": "Beides",
  "auth.register.signupIntent.both.description":
    "Als Spieler und Trainer auf der Plattform unterwegs sein.",
  "auth.register.signupIntent.errorRequired":
    "Bitte wähle aus, wofür du Tennis-Matches nutzen möchtest.",
  "auth.register.accessRequestPersistFailed":
    "Dein Konto wurde erstellt, aber die Zugriffsanfrage konnte nicht gespeichert werden.",
  "auth.register.publicSubtitle":
    "Erstelle dein Konto in wenigen Sekunden. Verein, Familie und Trainerfunktionen aktivierst du danach mit einem Klick in deiner Tenniswelt.",
  "auth.register.email": "E-Mail",
  "auth.register.emailCheck.checking": "E-Mail wird geprüft…",
  "auth.register.emailCheck.rateLimited":
    "Zu viele Anfragen von deiner Verbindung. Bitte warte {seconds} Sekunden und versuche es erneut.",
  "auth.register.emailCheck.errorTechnical":
    "Die E-Mail konnte gerade nicht geprüft werden. Bitte versuche es erneut.",
  "auth.register.password": "Passwort",
  "auth.register.passwordConfirm": "Passwort bestätigen",
  "auth.register.passwordRules.title": "Passwort-Anforderungen",
  "auth.register.passwordRules.aria": "Passwort-Anforderungen",
  "auth.register.passwordRules.minLength": "Mindestens 8 Zeichen",
  "auth.register.passwordRules.match": "Passwörter stimmen überein",
  "auth.register.passwordRules.allOk":
    "Passwort ist sicher und die Eingaben stimmen überein.",
  "auth.register.displayName": "Name (optional)",
  "auth.register.displayNameHint":
    "Wird Administratoren bei der Freigabe angezeigt.",
  "auth.register.firstName": "Vorname",
  "auth.register.lastName": "Nachname",
  "auth.register.nameHint": "Wird Administratoren bei der Freigabe angezeigt.",
  "auth.register.rolesTitle": "Welche Rolle hast du im Verein?",
  "auth.register.scopeId": "Club / Verein",
  "auth.register.scopePlaceholder": "z. B. Name deines Vereins",
  "auth.register.scopeHint":
    "Technische ID des Vereins (Tenant). Ohne Vereinsbindung „Unabhängiger Trainer“ wählen.",
  "auth.register.independentTrainer":
    "Ich bin unabhängiger Trainer (ohne Vereinszuordnung)",
  "auth.register.independentTrainerHint":
    "Es wird eine Zugriffsanfrage ohne Vereins-ID eingereicht.",
  "auth.register.coordinationTitle": "Koordinierst du andere Trainer?",
  "auth.register.submit": "Registrieren und Zugriff beantragen",
  "auth.register.wizard.progress": "Schritt {current} von {total}",
  "auth.register.wizard.progressAria":
    "Registrierung, Schritt {current} von {total}",
  "auth.register.wizard.stepLabel.konto": "Konto",
  "auth.register.wizard.stepLabel.rolle": "Rolle",
  "auth.register.wizard.stepLabel.verein": "Verein",
  "auth.register.wizard.stepLabel.pruefen": "Prüfen",
  "auth.register.wizard.step2Heading": "Wie nutzt du Tennis Matches?",
  "auth.register.wizard.step3Lead":
    "Der Zugriff wird von Vereins-Administratorinnen und -Administratoren geprüft und freigegeben.",
  "auth.register.wizard.clubScopeGroupAria": "Vereinszuordnung",
  "auth.register.wizard.clubModeWithScope":
    "Verein: Suche oder Verein hinzufügen",
  "auth.register.wizard.clubModeWithScopeDesc":
    "Finde deinen Verein in der Liste oder erfasse einen neuen Verein als Wunsch.",
  "auth.register.wizard.clubModeIndependent":
    "Unabhängiger Trainer ohne Vereinsbindung",
  "auth.register.wizard.clubModeIndependentDesc":
    "Du arbeitest ohne festen Vereinsbezug.",
  "auth.register.wizard.reviewHeading": "Bitte prüfe deine Angaben",
  "auth.register.wizard.summary.email": "E-Mail",
  "auth.register.wizard.summary.name": "Name",
  "auth.register.wizard.summary.roles": "Rollen",
  "auth.register.wizard.summary.scope": "Club / Verein",
  "auth.register.wizard.summary.coordination": "Trainer-Koordination",
  "auth.register.wizard.summary.scopeIndependentLabel": "Unabhängiger Trainer",
  "auth.register.wizard.ctaSubmit": "Zugriff anfragen",
  "auth.register.consent.heading": "Rechtliches",
  "auth.register.consent.privacyPrefix": "Ich habe die",
  "auth.register.consent.privacySuffix": " gelesen und akzeptiere sie.",
  "auth.register.consent.termsPrefix": "Ich akzeptiere die",
  "auth.register.consent.termsLinkLabel": "Nutzungsbedingungen (AGB)",
  "auth.register.consent.termsSuffix": ".",
  "auth.register.consent.hint":
    "Ohne diese Zustimmungen kann kein Konto angelegt werden. Nach dem Absenden erhältst du eine E-Mail zur Bestätigung deiner Adresse.",
  "auth.register.consent.errorPrivacyRequired":
    "Bitte bestätige die Datenschutzerklärung.",
  "auth.register.consent.errorTermsRequired":
    "Bitte akzeptiere die Nutzungsbedingungen.",
  "auth.register.consent.errorRequired":
    "Bitte bestätige Datenschutz und Nutzungsbedingungen.",
  "auth.register.clubSearch.label": "Verein suchen",
  "auth.register.clubSearch.placeholder": "Vereinsname oder Ort eingeben",
  "auth.register.clubSearch.notListed": "Mein Verein ist nicht dabei",
  "auth.register.clubSearch.createInline.title":
    "„{name}“ als neuen Verein anlegen",
  "auth.register.clubSearch.createInline.hint":
    "Wenige Angaben – der Verein ist sofort aktiv und du bist verbunden.",
  "auth.register.clubSearch.addSectionTitle": "Verein hinzufügen",
  "auth.register.clubSearch.clubName": "Vereinsname",
  "auth.register.clubSearch.city": "Ort",
  "auth.register.clubSearch.websiteOptional": "Website (optional)",
  "auth.register.clubSearch.contactOptional":
    "Ansprechpartner oder Rolle (optional)",
  "auth.register.clubSearch.pendingReviewHint":
    "Der Verein wird als Anfrage mitgesendet und später von uns geprüft — es wird noch kein Vereinskonto angelegt.",
  "auth.register.clubSearch.selectedLabel": "Ausgewählter Verein",
  "auth.register.clubSearch.noResults": "Kein passender Verein gefunden.",
  "auth.register.clubSearch.noResultsHint":
    "Du kannst unten „Mein Verein ist nicht dabei“ wählen, um einen neuen Verein zu beantragen.",
  "auth.register.clubSearch.pickExistingHint":
    "Bestehenden Verein suchen und aus der Liste auswählen.",
  "auth.register.clubSearch.existingBadge": "Bereits angelegt",
  "auth.register.clubSearch.backToSearch": "Zurück zur Suche",
  "auth.register.clubSearch.changeSelection": "Ändern",
  "auth.register.clubSearch.summaryNewClub":
    "{name}, {city} (neuer Verein, wird geprüft)",
  "auth.register.clubSearch.independentReviewHint":
    "Die Zugriffsanfrage wird ohne Vereinsbindung geprüft — Freigabe durch die Administration.",
  "auth.register.clubSearch.unavailableHint":
    "Die Vereinsliste kann hier nicht geladen werden. Erfasse deinen Verein als Wunsch über „Mein Verein ist nicht dabei“.",
  "auth.register.clubSearch.errorTechnical":
    "Die Vereinssuche ist gerade nicht erreichbar. Das bedeutet nicht, dass es keine Vereine gibt — bitte später erneut versuchen oder unten einen neuen Verein beantragen.",
  "auth.register.clubSearch.errorNoClient":
    "Es besteht keine Verbindung zum Server für die Vereinssuche. Bitte Internet prüfen oder später erneut versuchen; unten kannst du einen neuen Verein beantragen.",
  "auth.register.clubSearch.issueContinueHint":
    "Du kannst die Suche mit einem anderen Begriff wiederholen oder unten „Mein Verein ist nicht dabei“ nutzen.",
  "auth.register.clubSearch.minCharsHint": "Mindestens {n} Zeichen zum Suchen.",
  "auth.signupError.generic":
    "Die Registrierung ist fehlgeschlagen. Bitte versuche es später erneut.",
  "auth.signupError.confirmationEmailFailed":
    "Die Bestätigungs-E-Mail konnte nicht gesendet werden. Bitte später erneut versuchen oder den Administrator kontaktieren.",
  "auth.signupError.confirmationEmailRateLimited":
    "Der Mailversand ist gerade ausgelastet (Rate-Limit). Dein Konto kann trotzdem angelegt sein – warte ein paar Minuten und fordere die Bestätigungs-Mail erneut an.",
  "auth.signupError.confirmationEmailServer":
    "Die Registrierung konnte nicht abgeschlossen werden, weil der Bestätigungs-Mailversand fehlgeschlagen oder zeitüberschritten ist. Bitte prüfe die SMTP-Konfiguration in Supabase oder deaktiviere die E-Mail-Bestätigung für lokale Tests.",
  "auth.signupError.userAlreadyRegistered":
    "Diese E-Mail-Adresse ist bereits registriert. Bitte melde dich an oder nutze die Passwort-Zurücksetzen-Funktion.",
  "auth.signupError.invalidEmail":
    "Die E-Mail-Adresse ist ungültig. Bitte prüfe die Eingabe.",
  "auth.signupError.weakPassword": "Das Passwort ist zu schwach oder zu kurz.",
  "auth.signupError.network":
    "Keine Verbindung zum Server. Bitte Internet prüfen und erneut versuchen.",
  "auth.register.roleCardDesc.trainer":
    "Trainingszeiten planen, Stunden dokumentieren oder abrechnen.",
  "auth.register.roleCardDesc.club_official":
    "Verein organisieren und verwalten — z. B. als Vorstand, Jugendwart oder Vereinsadmin.",
  "auth.register.roleCardDesc.trainer_coordinator":
    "Mehrere Trainer oder Gruppen im Verein koordinieren.",
  "auth.register.roleCardDesc.jugendwart":
    "Nachwuchs und Jugendbereich organisieren.",
  "auth.register.roleCardDesc.sportwart":
    "Sportlichen Spielbetrieb und Organisation unterstützen.",
  "auth.register.roleCardDesc.vorstand":
    "Vereinsleitung und strategische Aufgaben.",
  "auth.register.roleCardDesc.vereinsadmin":
    "Administrative Verwaltung des Vereins in der Plattform.",
  "auth.register.roleCardDesc.kassenwart":
    "Finanzen, Gebühren und Abrechnungen.",
  "auth.register.roleCardDesc.event_organizer":
    "Turniere, Events und Wettkämpfe organisieren.",
  "auth.register.roleCardDesc.team_captain":
    "Mannschaft führen und das Team organisieren.",
  "auth.register.roleCardDesc.player":
    "Als Spieler oder Mitglied am Vereinsleben teilnehmen.",
  "auth.register.roleCardDesc.parent":
    "Kinder begleiten und bei Teams unterstützen.",
  "auth.validation.emailPasswordRequired":
    "Bitte E-Mail und Passwort eingeben.",
  "auth.validation.emailInvalid": "Bitte eine gültige E-Mail-Adresse eingeben.",
  "auth.validation.passwordMinLength":
    "Passwort muss mindestens 8 Zeichen haben.",
  "auth.validation.passwordMismatch": "Passwörter stimmen nicht überein.",
  "auth.validation.firstNameRequired": "Bitte gib deinen Vornamen ein.",
  "auth.validation.lastNameRequired": "Bitte gib deinen Nachnamen ein.",
  "auth.validation.rolesRequired": "Bitte mindestens eine Rolle auswählen.",
  "auth.validation.scopeRequired":
    "Bitte Club/Verein angeben oder „Unabhängiger Trainer“ wählen.",
  "auth.validation.clubSelectionRequired":
    "Bitte einen Verein auswählen oder einen neuen Verein mit Namen und Ort erfassen.",
  "auth.validation.clubNameRequired": "Bitte den Vereinsnamen angeben.",
  "auth.validation.cityRequired": "Bitte den Ort angeben.",
  "auth.callback.title": "Anmeldung wird abgeschlossen…",
  "auth.callback.subtitle": "Bitte warten…",
  "auth.callback.error": "Fehler",
  "auth.callback.noSession": "Keine Session gefunden.",
  "auth.callback.bootstrapTimeout":
    "Die Anmeldung hat zu lange gedauert. Bitte laden Sie die Seite neu oder melden Sie sich erneut an.",
  "auth.bootstrap.blockedTitle": "Anmeldung nicht abgeschlossen",
  "auth.bootstrap.blockedBodyTimeout":
    "Die Sitzungsprüfung hat zu lange gedauert. Bitte laden Sie die Seite neu und versuchen Sie es erneut.",
  "auth.bootstrap.blockedBodyFailed":
    "Die Sitzungsprüfung ist fehlgeschlagen. Bitte laden Sie die Seite neu.",
  "auth.bootstrap.reloadCta": "Seite neu laden",
  "auth.debug.boxTitle": "Auth-Debug",
  "auth.debug.recheckCta": "Session erneut prüfen",
  "auth.debug.signOutCta": "Abmelden",
  "auth.debug.label.href": "Aktuelle URL (ohne Tokens)",
  "auth.debug.label.origin": "Origin",
  "auth.debug.label.pathname": "Pfad (pathname)",
  "auth.debug.label.hash": "Hash vorhanden",
  "auth.debug.label.session": "Session vorhanden",
  "auth.debug.label.userId": "session.user.id",
  "auth.debug.label.email": "session.user.email",
  "auth.debug.label.lastOk": "Letzter erfolgreicher Bootstrap-Schritt",
  "auth.debug.label.lastFail": "Letzter fehlgeschlagener Bootstrap-Schritt",
  "auth.debug.label.rpc": "Letzter RPC-/Netzwerkfehler (redaktioniert)",
  "auth.debug.label.timeoutMs": "Bootstrap-Timeout (ms)",
  "auth.debug.value.none": "—",
  "auth.debug.value.yes": "Ja",
  "auth.debug.value.no": "Nein",
  "auth.signOut": "Abmelden",
  "auth.signIn": "Anmelden",
  "auth.signedInAs": "Angemeldet als",
  "nav.settings": "Einstellungen",
  "nav.requestAccess": "Weitere Berechtigungen beantragen",
  "appTopbar.menu.account": "Konto",
  "appTopbar.menu.myData": "Meine Daten",
  "appTopbar.identityFallback": "Angemeldetes Konto",
  "appTopbar.platformMark": "Tennis-Matches.de",
  "appTopbar.platformMarkShort": "TM",
  "appTopbar.launcherHint": "Apps und Start",
  "appTopbar.launcherRestrictedPending":
    "App-Auswahl ist nach Freigabe deiner Zugriffsanfrage verfügbar.",
  "appShell.identity.marketplaceDetailTitle": "App-Profil",
  "appShell.identity.marketplaceDetailSubtitle":
    "Details und Zugriff im Marketplace.",
  "title.app": "Tennis-Matches.de",
  "nav.home": "Startseite",
  "nav.menu": "Menü",
  "nav.side.aria": "Hauptnavigation",
  "nav.side.collapse": "Navigation einklappen",
  "nav.side.expand": "Navigation ausklappen",
  "nav.side.search.placeholder": "Suchen",
  "nav.side.search.clear": "Suche löschen",
  "nav.side.search.empty": "Keine Treffer",
  "nav.side.search.aria": "Navigation durchsuchen",
  "nav.side.shortcuts.title": "Shortcuts",
  "nav.side.shortcuts.pin": "Als Favorit merken",
  "nav.side.shortcuts.unpin": "Favorit entfernen",
  "nav.side.shortcuts.emptyHint":
    "Oft genutzte Punkte erscheinen hier — oder per Stern/Ziehen als Favorit setzen.",
  "nav.side.shortcuts.autoBadge": "Häufig",
  "nav.side.shortcuts.dropHint": "Hierher ziehen",
  "nav.side.group.training": "Training",
  "nav.side.group.tournaments": "Turniere & Teams",
  "nav.side.group.club": "Verein",
  "nav.side.group.menschen": "Menschen",
  "nav.side.menschen.customers": "Kunden",
  "nav.side.menschen.vendors": "Lieferanten",
  "nav.side.group.settings": "Einstellungen",
  "nav.side.settings.overview": "Übersicht",
  "nav.side.group.insights": "Insights",
  "nav.side.insights.overview": "Übersicht",
  "nav.side.insights.trainings": "Trainings",
  "nav.side.insights.tournaments": "Turniere",
  "nav.side.insights.clubmeisterschaft": "Clubmeisterschaft",
  "settings.hub.title": "Einstellungen",
  "settings.hub.workspaceLabel": "Verein: {name}",
  "settings.hub.navAria": "Einstellungsbereiche",
  "settings.hub.areaLabel": "Bereich",
  "settings.hub.empty": "Keine Einstellungen für freigeschaltete Apps.",
  "settings.hub.help": "Hilfe",
  "settings.hub.scope.personal": "Persönlich",
  "settings.hub.scope.tenant": "Verein",
  "settings.hub.action.open": "Öffnen",
  "settings.hub.action.change": "Ändern",
  "settings.hub.action.setup": "Einrichten",
  "settings.hub.action.manage": "Verwalten",
  "settings.hub.action.customize": "Anpassen",
  "settings.hub.status.active": "Aktiv",
  "settings.hub.status.connected": "Verbunden",
  "settings.hub.category.club.title": "Verein & Berechtigungen",
  "settings.hub.category.club.description":
    "Benutzer, Rollen und vereinsweite Zugriffe.",
  "settings.hub.category.planning.title": "Planung & Teilnahme",
  "settings.hub.category.planning.description":
    "Trainingsformular, Kalender, Ferien, Anwesenheit und Erinnerungen.",
  "settings.hub.category.venues.title": "Anlagen & Plätze",
  "settings.hub.category.venues.description":
    "Orte, Plätze, Buchungsregeln und Tennify.",
  "settings.hub.category.billing.title": "Rechnungen & Zahlungen",
  "settings.hub.category.billing.description":
    "Rechnungslayout, Versand, Bankkonten und PayPal.",
  "settings.hub.category.apps.title": "Apps & Abo",
  "settings.hub.category.apps.description":
    "Freischaltungen, Tarif und Abostatus.",
  "settings.hub.item.usersRoles.title": "Benutzer & Rollen",
  "settings.hub.item.usersRoles.description":
    "Zugriffe verwalten und Rollen zuweisen.",
  "settings.hub.item.outlook.title": "Outlook-Kalender",
  "settings.hub.item.outlook.description":
    "Persönliche Kalenderverbindung und Synchronisation.",
  "settings.hub.item.outlook.descriptionConnected":
    "Kalenderverbindung verwalten, trennen oder neu synchronisieren.",
  "settings.hub.item.belegungSettings.title": "Buchungs- & Belegungsregeln",
  "settings.hub.item.belegungSettings.description":
    "Hinweise und Optionen zur Platzbuchung.",
  "settings.hub.item.belegungCourts.title": "Plätze verwalten",
  "settings.hub.item.belegungCourts.description":
    "Plätze anlegen und aktivieren.",
  "nav.side.section.trainingOrg": "Organisation",
  "nav.side.section.trainingDesign": "Trainingsgestaltung",
  "nav.side.section.trainingBilling": "Abrechnung & Verwaltung",
  "nav.side.section.trainingSeries": "Serientermine",
  "nav.side.training.trainers": "Trainer",
  "nav.side.training.settings": "Trainingseinstellungen",
  "nav.side.training.studioSessions": "Studio-Sessions",
  "nav.side.account.settings": "Kontoeinstellungen",
  "nav.side.training.planNew": "+ Training planen",
  "nav.side.breadcrumb.training": "Training",
  "nav.side.breadcrumb.trainingTermine": "Trainingstermine",
  "nav.side.breadcrumb.trainingOverview": "Übersicht",
  "platform.launcher.showAllApps": "Alle Apps anzeigen",
  "platform.launcher.allApps": "Alle Apps",
  "platform.launcher.home": "Startseite",
  "platform.launcher.discoverApps.title": "Weitere Apps",
  "platform.launcher.discoverApps.hint":
    "Entdecke weitere Module und beantrage Zugriff für deinen Club.",
  "platform.launcher.discoverApps.cta": "Weitere Apps entdecken",
  "nav.profile": "Profil",

  // Schleifchen (Fallback)
  "schleifchen.title": "MatchMixer",
  "schleifchen.participant.loading": "Turnierdaten werden geladen …",
  "schleifchen.participant.errorInvalidCode":
    "Dieser Code ist ungültig oder die Daten konnten nicht geladen werden. Bitte prüfe den Link oder versuche es später erneut.",
  "schleifchen.participant.emptyNoSchedule":
    "Für dieses Turnier liegt noch kein Spielplan vor. Sobald die Turnierleitung den Plan veröffentlicht, siehst du hier die Spiele.",
  "schleifchen.participant.emptyInvalidCode":
    "Es konnte kein Turnier zu diesem Code gefunden werden.",
  "schleifchen.participant.brandLine": "MatchMixer · Teilnehmer",
  "schleifchen.participant.tabCurrent": "Aktuell",
  "schleifchen.participant.tabSchedule": "Spielplan",
  "schleifchen.participant.tabTable": "Tabelle",
  "schleifchen.participant.tabResults": "Ergebnisse",
  "schleifchen.participant.tabsAria": "Bereiche wechseln",
  "schleifchen.participant.heroNextMatch": "Dein nächstes Spiel",
  "schleifchen.participant.roundCourtLine": "{round} · {court}",
  "schleifchen.participant.vs": "gegen",
  "schleifchen.participant.statusFinished": "Beendet",
  "schleifchen.participant.statusEntry": "Ergebniseintrag",
  "schleifchen.participant.statusRunning": "Läuft",
  "schleifchen.participant.statusPlanned": "Startet bald",
  "schleifchen.participant.refresh": "Aktualisieren",
  "schleifchen.participant.lastUpdated": "Zuletzt aktualisiert: {time}",
  "schleifchen.participant.heroNoMatchesThisRound":
    "Für diese Runde sind noch keine Paarungen auf den Plätzen sichtbar.",
  "schleifchen.participant.heroRoundScoresPending":
    "Alle sichtbaren Spiele dieser Runde haben bereits ein Ergebnis. Die Turnierleitung schaltet die nächste Runde frei.",
  "schleifchen.participant.resultsManagedByOrganizer":
    "Ergebnisse werden von der Turnierleitung gepflegt. Sobald die Eingabe freigegeben ist, kannst du hier mittragen.",
  "schleifchen.participant.resultsTabEntryHint":
    "Trage deine Ergebnisse im Tab „Aktuell“ ein – dort findest du die großen Eingabefelder.",
  "schleifchen.participant.resultsEmpty": "Noch keine Ergebnisse eingetragen.",
  "schleifchen.participant.stickyNavAria": "Schnellzugriff",
  "schleifchen.participant.ctaReportResult": "Ergebnis melden",
  "schleifchen.setup.subtitle": "MatchMixer – Rotation & Social-Format.",
  "matchmixer.setup.overview.title": "MatchMixer konfigurieren",
  "matchmixer.simple.backToOverview": "Zur Übersicht",
  "matchmixer.simple.untitled": "Neuer Spieltag",
  "matchmixer.simple.next": "Weiter",
  "matchmixer.simple.steps.aria": "Schritte",
  "matchmixer.simple.steps.day": "Spieltag",
  "matchmixer.simple.steps.players": "Spieler",
  "matchmixer.simple.steps.flow": "Ablauf",
  "matchmixer.simple.day.title": "Was möchtest du spielen?",
  "matchmixer.simple.day.formatAria": "Spielmodus",
  "matchmixer.simple.day.mode": "Spieltyp",
  "matchmixer.simple.day.modeAria": "Klassisch oder Playoffs",
  "matchmixer.simple.format.singles": "Einzel",
  "matchmixer.simple.format.doubles": "Wechselnde Doppel",
  "matchmixer.simple.format.fixedDoubles": "Feste Teams",
  "matchmixer.simple.day.name": "Name",
  "matchmixer.simple.day.date": "Datum",
  "matchmixer.simple.day.time": "Beginn",
  "matchmixer.simple.players.title": "Wer spielt mit?",
  "matchmixer.simple.players.count": "{count} Spieler",
  "matchmixer.simple.players.addLabel": "Spielername",
  "matchmixer.simple.players.placeholder": "Name eingeben …",
  "matchmixer.simple.players.add": "Hinzufügen",
  "matchmixer.simple.players.contactsHint":
    "Aus Kontakten wählen: tippe den Namen und wähle einen Vorschlag.",
  "matchmixer.simple.players.contactsPick": "Aus Kontakten wählen",
  "matchmixer.simple.players.contactsSearchLabel": "Kontakt suchen",
  "matchmixer.simple.players.contactsSearchPlaceholder": "Kontakt suchen …",
  "matchmixer.simple.players.contactsTypeHint":
    "Tippe einen Namen, um Kontakte zu finden.",
  "matchmixer.simple.players.contactsEmpty": "Kein Kontakt gefunden.",
  "matchmixer.simple.players.empty": "Noch niemand hinzugefügt",
  "matchmixer.simple.players.removeAria": "{name} entfernen",
  "matchmixer.simple.players.lkOptionalHint":
    "LK optional – hilft bei Stark+Schwach. Ohne Angabe werden Teams trotzdem gebildet.",
  "matchmixer.simple.partners.label": "Partner",
  "matchmixer.simple.partners.aria": "Partner-Modus wählen",
  "matchmixer.simple.partners.rotating": "Wechselnde Partner",
  "matchmixer.simple.partners.fixed": "Feste Partner",
  "matchmixer.simple.partners.hint.rotating":
    "Partner wechseln von Runde zu Runde.",
  "matchmixer.simple.partners.hint.fixed":
    "Paare bleiben das ganze Turnier zusammen.",
  "matchmixer.simple.courts": "Plätze",
  "matchmixer.simple.courtsMinus": "Platz weniger",
  "matchmixer.simple.courtsPlus": "Platz mehr",
  "matchmixer.simple.courtsHint.singles": "Pro Platz spielen zwei Personen.",
  "matchmixer.simple.courtsHint.doubles": "Pro Platz spielen vier Personen.",
  "matchmixer.simple.courtsHint.fixedDoubles":
    "Pro Platz spielt ein Team gegen ein anderes.",
  "matchmixer.simple.registration.toggle": "Anmeldelink aktivieren",
  "matchmixer.simple.registration.scope": "Wer darf sich anmelden?",
  "matchmixer.simple.registration.publishLater":
    "Link freigeben speichert ohne Spielplan – den Plan erstellst du später bewusst.",
  "matchmixer.simple.registration.moreSummary": "Anmeldung (optional)",
  "matchmixer.simple.registration.registerIntentTitle":
    "Anmeldung planen — Kapazität festlegen",
  "matchmixer.simple.finish.prepare": "Turnier vorbereiten",
  "matchmixer.simple.finish.prepareHint":
    "Speichert Datum, Spieler und Ablauf ohne Spielplan.",
  "matchmixer.simple.teams.alloc": "Teamzuordnung",
  "matchmixer.simple.flow.title": "Wie lange spielt ihr?",
  "matchmixer.simple.flow.total": "Gesamtdauer",
  "matchmixer.simple.flow.round": "Dauer pro Runde",
  "matchmixer.simple.flow.minutesValue": "{minutes} Min",
  "matchmixer.simple.flow.totalMinus": "Gesamtdauer verkürzen",
  "matchmixer.simple.flow.totalPlus": "Gesamtdauer verlängern",
  "matchmixer.simple.flow.roundMinus": "Rundendauer verkürzen",
  "matchmixer.simple.flow.roundPlus": "Rundendauer verlängern",
  "matchmixer.simple.flow.result": "{rounds} Runden à {minutes} Minuten",
  "matchmixer.simple.flow.moreOptions": "Weitere Optionen",
  "matchmixer.simple.flow.pause": "Pause zwischen Runden (Min)",
  "matchmixer.simple.flow.warmup": "Aufwärmen (Min)",
  "matchmixer.simple.summary.aria": "Zusammenfassung",
  "matchmixer.simple.summary.title": "Dein Spieltag",
  "matchmixer.simple.summary.mobileToggle": "Dein Spieltag",
  "matchmixer.simple.summary.formatHint.singles": "Jeder spielt für sich.",
  "matchmixer.simple.summary.formatHint.doubles":
    "Partner wechseln von Runde zu Runde.",
  "matchmixer.simple.summary.formatHint.fixedDoubles":
    "Paare bleiben das ganze Turnier zusammen.",
  "matchmixer.simple.summary.players": "Teilnehmer",
  "matchmixer.simple.summary.courts": "Plätze",
  "matchmixer.simple.summary.roundsValue": "{rounds} × {minutes} Min",
  "matchmixer.simple.errors.startDate": "Bitte ein Datum wählen.",
  "matchmixer.simple.errors.startTime": "Bitte eine Uhrzeit wählen.",
  "matchmixer.simple.errors.format": "Bitte einen Spielmodus wählen.",
  "matchmixer.simple.saveAsTemplate": "Als Vorlage speichern",
  "matchmixer.setup.overview.subtitle":
    "Stelle Spieler, Format und Zeit ein – dann Plan erstellen.",
  "matchmixer.setup.overview.shellSubtitleMini":
    "Schnell einrichten, dann starten.",
  "matchmixer.setup.flow.stepWho": "Wer spielt?",
  "matchmixer.setup.flow.stepHow": "Wie wird gespielt?",
  "matchmixer.setup.flow.stepMode": "Modus",
  "matchmixer.setup.flow.stepTimePlace": "Zeit & Plätze",
  "matchmixer.setup.flow.stepTimePlaceRules": "Zeit, Plätze & Modus",
  "matchmixer.setup.overview.section.flow": "Ablauf",
  "matchmixer.setup.overview.wizardModeSection": "Ansicht",
  "matchmixer.setup.overview.section.name": "Veranstaltung",
  "matchmixer.setup.overview.name.label": "Turniername",
  "matchmixer.setup.overview.name.placeholder":
    "z. B. Frühjahrs-Schleifchen 2026",
  "matchmixer.setup.overview.name.requiredHint":
    "Bitte gib einen Namen für das Turnier an.",
  "matchmixer.setup.overview.participants.minLabel": "Mindestens",
  "matchmixer.setup.overview.participants.maxLabel": "Maximal",
  "matchmixer.setup.overview.participants.minAria": "Mindestanzahl Teilnehmer",
  "matchmixer.setup.overview.participants.maxAria":
    "Maximale Anzahl Teilnehmer",
  "matchmixer.setup.overview.moreDetails": "Übersicht & Hinweise",
  "matchmixer.setup.overview.configSectionTitle": "Konfiguration",
  "matchmixer.setup.overview.row.participants": "Teilnehmer",
  "matchmixer.setup.overview.row.format": "Format",
  "matchmixer.setup.overview.row.duration": "Dauer / Runden",
  "matchmixer.setup.overview.row.courts": "Plätze",
  "matchmixer.setup.overview.row.teamAllocation": "Team-Zuteilung",
  "matchmixer.setup.overview.row.teamAllocationShort": "Teams",
  "matchmixer.setup.overview.row.mode": "Modus",
  "matchmixer.setup.inline.formatGroupAria": "Format wählen",
  "matchmixer.setup.inline.teamAllocGroupAria": "Team-Zuteilung wählen",
  "matchmixer.setup.inline.teamAlloc.random": "Zufällig",
  "matchmixer.setup.inline.teamAlloc.manual": "Manuell",
  "matchmixer.setup.inline.teamAlloc.lkBased": "Nach LK",
  "matchmixer.setup.overview.auto.title": "Automatisch berechnet",
  "matchmixer.setup.overview.auto.rotation": "Faire Rotation",
  "matchmixer.setup.overview.auto.pauseDistribution": "Pausenverteilung",
  "matchmixer.setup.overview.auto.scheduleOptimization":
    "Spielplan-Optimierung",
  "matchmixer.setup.overview.value.participantsCount": "{count} Teilnehmer",
  "matchmixer.setup.overview.participants.countShort": "{count} Spieler",
  "matchmixer.setup.overview.participants.heroAdd": "Spieler hinzufügen",
  "matchmixer.setup.overview.participants.heroAddHint":
    "Teilnehmerliste öffnen",
  "matchmixer.setup.overview.participants.heroEdit":
    "{count} Spieler bearbeiten",
  "matchmixer.setup.overview.participants.emptyHeadline": "Noch keine Spieler",
  "matchmixer.setup.overview.participants.emptyHint": "Zum Hinzufügen tippen",
  "matchmixer.setup.overview.value.durationRounds":
    "{rounds} Runden × {minutes} Min",
  "matchmixer.setup.overview.value.courtsCount": "{count}",
  "matchmixer.setup.overview.value.modeFallback": "Modus",
  "matchmixer.setup.overview.participantsRowAria": "Teilnehmer bearbeiten",
  "matchmixer.setup.editor.done": "Fertig",
  "matchmixer.setup.sheet.done": "Fertig",
  "matchmixer.setup.sheet.closeAria": "Schließen",
  "matchmixer.setup.sheet.title.format": "Format",
  "matchmixer.setup.sheet.title.duration": "Dauer und Runden",
  "matchmixer.setup.sheet.subtitle.duration":
    "Runden, Minuten pro Runde und Schnellwahl für die Gesamtzeit.",
  "matchmixer.setup.sheet.subtitle.mode":
    "Feineinstellungen zu Punkten, Sätzen und Playoffs.",
  "matchmixer.setup.sheet.duration.presetsAria": "Schnellwahl Gesamtzeit",
  "matchmixer.setup.sheet.duration.presetsLabel": "Schnellwahl",
  "matchmixer.setup.sheet.duration.presetMinutes": "{minutes} Min",
  "matchmixer.setup.sheet.duration.presetRoundsMinutes":
    "{rounds} × {minutes} Min",
  "matchmixer.setup.sheet.duration.customSection": "Benutzerdefiniert",
  "matchmixer.setup.sheet.duration.customOption": "Benutzerdefiniert",
  "matchmixer.setup.sheet.mode.listAria": "Spielmodus wählen",
  "matchmixer.setup.sheet.subtitle.teamAllocation":
    "Wie Paare für feste Teams gebildet werden.",
  "matchmixer.setup.expert.openSheetHint": "Details öffnen",
  "matchmixer.setup.expert.rowAria": "{title}. {detail}",
  "matchmixer.setup.expert.rowSummary.sep": "·",
  "matchmixer.setup.expert.rowSummary.timePause": "Pause {minutes}",
  "matchmixer.setup.expert.rowSummary.timeHalftime": "Halbzeit {minutes}",
  "matchmixer.setup.expert.rowSummary.timeWarmup": "Einspielen {minutes}",
  "matchmixer.setup.expert.rowSummary.scoringPts":
    "Sieg {win} · Remis {draw} · Niederlage {loss}",
  "matchmixer.setup.expert.rowSummary.noAdShort": "No-Ad",
  "matchmixer.setup.expert.rowSummary.rotPartnerWechsel": "Partnerwechsel",
  "matchmixer.setup.expert.rowSummary.rotWechselEinzel": "Wechselnde Gegner",
  "matchmixer.setup.expert.rowSummary.rotFixedTeams": "Feste Teams",
  "matchmixer.setup.expert.rowSummary.teamAllocLk": "LK-Zuteilung",
  "matchmixer.setup.expert.rowSummary.teamAllocRandom": "Zufall",
  "matchmixer.setup.expert.rowSummary.teamAllocManual": "Manuell",
  "matchmixer.setup.expert.rowSummary.fairPauses": "Pausen fair",
  "matchmixer.setup.expert.rowSummary.playoffsOff": "Playoffs aus",
  "matchmixer.setup.expert.rowSummary.playoffsVorKo":
    "Vorrunde {vor} · Top {ko}",
  "matchmixer.setup.expert.rowSummary.playThirdShort": "Platz 3",
  "matchmixer.setup.expert.rowSummary.advName": "{name}",
  "matchmixer.setup.expert.rowSummary.advCourts": "Plätze {courts}",
  "matchmixer.setup.sheet.title.courts": "Plätze",
  "matchmixer.setup.sheet.title.mode": "Spielmodus",
  "matchmixer.setup.sheet.title.teamAllocation": "Team-Zuteilung",
  "matchmixer.setup.overview.formatRowAria": "Format ändern",
  "matchmixer.setup.overview.durationRowAria": "Dauer und Runden ändern",
  "matchmixer.setup.overview.row.dateTime": "Datum & Uhrzeit",
  "matchmixer.setup.overview.dateTime.setNow": "Jetzt festlegen",
  "matchmixer.setup.overview.dateTime.rowValue": "{date}, {time}",
  "matchmixer.setup.dateTime.today": "Heute",
  "matchmixer.setup.validation.startInPast":
    "Der Turnierstart darf nicht in der Vergangenheit liegen.",
  "matchmixer.setup.overview.dateTimeRowAria": "Datum und Uhrzeit bearbeiten",
  "matchmixer.setup.sheet.title.dateTime": "Datum & Uhrzeit",
  "matchmixer.setup.sheet.subtitle.dateTime": "Wann startet das Turnier?",
  "matchmixer.setup.sheet.dateTime.sectionTitle": "Startzeit",
  "matchmixer.setup.sheet.dateTime.dateField": "Datum",
  "matchmixer.setup.sheet.dateTime.timeField": "Uhrzeit",
  "matchmixer.setup.overview.row.venue": "Spielort",
  "matchmixer.setup.overview.venueRowAria":
    "Spielort und Zielgruppe bearbeiten",
  "matchmixer.setup.overview.row.audience": "Zielgruppe",
  "matchmixer.setup.sheet.title.venueAudience": "Ort & Zielgruppe",
  "matchmixer.setup.sheet.subtitle.venueAudience":
    "Wo findet das Turnier statt und wer darf mitspielen?",
  "matchmixer.setup.sheet.title.template": "Aus Vorlage laden",
  "matchmixer.setup.sheet.subtitle.template":
    "Wähle eine gespeicherte Setup-Vorlage von dir oder aus deinem Verein.",
  "matchmixer.setup.template.load.label": "Aus Vorlage laden",
  "matchmixer.setup.template.load.rowLabel": "Vorlage",
  "matchmixer.setup.template.load.aria": "MatchMixer-Vorlage auswählen",
  "matchmixer.setup.template.load.placeholder": "Vorlage auswählen…",
  "matchmixer.setup.template.save.cta": "Als Vorlage speichern",
  "matchmixer.setup.template.saveCta": "Speichern",
  "matchmixer.setup.template.save.title": "Vorlage speichern",
  "matchmixer.setup.template.save.labelField": "Bezeichnung",
  "matchmixer.setup.template.save.labelHint":
    "Kurzer Name, der dir hilft, die Vorlage später wiederzufinden.",
  "matchmixer.setup.template.save.suggestionPrefix": "Vorschlag",
  "matchmixer.setup.template.save.overwrite":
    'Bestehende Vorlage „{label}" überschreiben',
  "matchmixer.setup.template.save.errorLabel":
    "Bitte gib einen Namen für die Vorlage ein.",
  "matchmixer.setup.template.save.errorTooLong":
    "Der Name ist zu lang (max. 120 Zeichen).",
  "matchmixer.setup.template.save.errorGeneric":
    "Vorlage konnte nicht gespeichert werden.",
  "matchmixer.setup.template.loaded": "Vorlage geladen.",
  "matchmixer.setup.template.saved": "Vorlage gespeichert.",
  "matchmixer.setup.template.deleted": "Vorlage gelöscht.",
  "matchmixer.setup.template.limitReached":
    "Du hast bereits 10 Vorlagen. Lösche eine alte, um eine neue zu speichern.",
  "matchmixer.setup.template.suggestion.classic": "Klassisch",
  "matchmixer.setup.template.suggestion.competitive": "Wettkampf",
  "matchmixer.setup.template.suggestion.playoffs": "Playoffs",
  "matchmixer.setup.template.suggestion.short": "{format} · {rounds}×{minutes}",
  "matchmixer.setup.template.suggestion.long":
    "{format} · {rounds}×{minutes} · {mode}",
  "matchmixer.setup.archive.cta": "Turnier abbrechen & ausblenden",
  "matchmixer.setup.archive.hint":
    "Bricht das Turnier ab und blendet es für alle Anwender aus. Daten bleiben in der Datenbank.",
  "matchmixer.setup.archive.confirm.title": "Turnier abbrechen?",
  "matchmixer.setup.archive.confirm.body":
    "Möchtest du „{name}“ wirklich abbrechen und für Anwender ausblenden?",
  "matchmixer.setup.archive.confirm.hint":
    "Das Turnier bleibt in unserer Datenbank gespeichert, ist aber für dich und alle anderen nicht mehr sichtbar. Bereits abgegebene Anmeldungen werden ebenfalls ausgeblendet.",
  "matchmixer.setup.archive.confirm.cta": "Endgültig ausblenden",
  "matchmixer.setup.archive.confirm.submitting": "Wird ausgeblendet…",
  "matchmixer.setup.archive.error.generic":
    "Turnier konnte nicht ausgeblendet werden. Bitte erneut versuchen.",
  "matchmixer.setup.archive.error.notAuthorized":
    "Du darfst dieses Turnier nicht abbrechen.",
  "matchmixer.setup.archive.error.notFound":
    "Das Turnier wurde nicht gefunden.",
  "matchmixer.setup.template.suggestion.fallback": "Vorlage {date}",
  "matchmixer.setup.template.deleteFailed":
    "Vorlage konnte nicht gelöscht werden.",
  "matchmixer.setup.template.saveFailed":
    "Vorlage konnte nicht gespeichert werden.",
  "matchmixer.setup.venue.sectionTitle": "Spielort",
  "matchmixer.setup.venue.modeAria": "Spielort wählen",
  "matchmixer.setup.venue.mode.club": "Im Verein",
  "matchmixer.setup.venue.mode.custom": "Anderer Ort",
  "matchmixer.setup.venue.clubDefault": "Vereinsstandort",
  "matchmixer.setup.venue.clubResolved": "Standard: {place}",
  "matchmixer.setup.venue.clubResolvedPending":
    "Adresse wird aus dem Vereinsprofil übernommen.",
  "matchmixer.setup.venue.customName": "Bezeichnung (optional)",
  "matchmixer.setup.venue.customAddress": "Adresse",
  "matchmixer.setup.venue.customHint":
    "Nur nötig, wenn das Turnier nicht am Vereinsstandort stattfindet.",
  "matchmixer.setup.venue.customEmpty": "Anderer Ort (noch nicht angegeben)",
  "matchmixer.setup.audience.sectionTitle": "Zielgruppe",
  "matchmixer.setup.audience.genderAria": "Geschlecht der Teilnahme",
  "matchmixer.setup.audience.gender.ladies": "Damen",
  "matchmixer.setup.audience.gender.men": "Herren",
  "matchmixer.setup.audience.gender.mixed": "Mixed",
  "matchmixer.setup.audience.ageClassLabel": "Altersklasse / Hinweis",
  "matchmixer.setup.audience.ageClassPlaceholder":
    "z. B. U12, 30+, Spaßrunde, alle willkommen",
  "matchmixer.setup.audience.ageClassHint":
    "Frei formulieren – leer lassen bedeutet: offen für alle.",
  "matchmixer.setup.audience.ageOpen": "offen für alle",
  "matchmixer.setup.audience.youth": "Jugend",
  "matchmixer.registration.overview.row": "Anmeldung",
  "matchmixer.registration.overview.rowAria":
    "Anmeldung und Freigabe bearbeiten",
  "matchmixer.registration.sheet.title": "Anmeldung freigeben",
  "matchmixer.registration.sheet.subtitle":
    "Teilnehmer können sich anmelden, bevor der Spielplan erstellt wird.",
  "matchmixer.registration.sheet.scopeTitle": "Sichtbarkeit",
  "matchmixer.registration.sheet.scopeAria": "Wer das Turnier finden kann",
  "matchmixer.registration.sheet.deadline": "Anmeldung bis",
  "matchmixer.registration.sheet.deadlineHint":
    "Spätestens zum Turnierbeginn; danach keine Selbstanmeldung mehr.",
  "matchmixer.registration.scope.link": "Nur per Link",
  "matchmixer.registration.scope.club": "Im Verein",
  "matchmixer.registration.scope.platform": "Plattformweit",
  "matchmixer.registration.scopeHint.link":
    "Nur über Link oder QR-Code – ohne Login. Nicht in der Vereins-Übersicht.",
  "matchmixer.registration.scopeHint.club":
    "Erscheint im Verein für Mitglieder; Anmeldung nur für Vereinsmitglieder.",
  "matchmixer.registration.scopeHint.platform":
    "Für alle angemeldeten Nutzer der Plattform sichtbar und anmeldbar.",
  "matchmixer.registration.scopeWithDeadline": "{scope} · bis {deadline}",
  "matchmixer.setup.players.scope.title": "Wer darf sich anmelden?",
  "matchmixer.setup.players.scope.aria": "Reichweite der Anmeldung",
  "matchmixer.setup.players.scope.link": "Nur per Link",
  "matchmixer.setup.players.scope.club": "Nur eigener Verein",
  "matchmixer.setup.players.scope.platform": "Clubübergreifend",
  "matchmixer.setup.players.scope.hint.link":
    "Anmeldung über Link oder QR-Code – ohne Login.",
  "matchmixer.setup.players.scope.hint.club": "Nur Mitglieder deines Vereins.",
  "matchmixer.setup.players.scope.hint.platform":
    "Alle angemeldeten Nutzer:innen der Plattform.",
  "matchmixer.registration.publish.cta": "Für Anmeldung freigeben",
  "matchmixer.registration.publish.invalid":
    "Bitte Anmeldefrist und Sichtbarkeit festlegen.",
  "matchmixer.registration.publish.shortPrepTitle": "Kurze Vorbereitungszeit",
  "matchmixer.registration.publish.shortPrepMessage":
    "Bis zum geplanten Start ({start}) liegen weniger als 24 Stunden. Möchtest du die Anmeldung trotzdem freigeben?",
  "matchmixer.registration.publish.shortPrepConfirm": "Trotzdem freigeben",
  "matchmixer.registration.status.openShort": "Anmeldung läuft",
  "matchmixer.registration.blocked.name": "Trag oben einen Turniernamen ein.",
  "matchmixer.registration.blocked.startDate":
    "Trag das Startdatum bei „Datum & Uhrzeit“ ein.",
  "matchmixer.registration.blocked.startPast":
    "Der Turnierstart liegt in der Vergangenheit – bitte Datum und Uhrzeit anpassen.",
  "matchmixer.registration.blocked.deadline":
    "Tippe auf „Anmeldung“ und setze eine Anmeldefrist.",
  "matchmixer.registration.blocked.deadlinePast":
    "Die Anmeldefrist muss in der Zukunft liegen.",
  "matchmixer.registration.blocked.deadlineAfterStart":
    "Die Anmeldefrist darf nicht nach dem Turnierbeginn liegen.",
  "matchmixer.registration.blocked.time": "Bitte Dauer und Plätze prüfen.",
  "matchmixer.registration.blocked.rules":
    "Bitte Spielwertung im Expert-Modus prüfen.",
  "matchmixer.registration.blocked.generic":
    "Bitte fehlende Pflichtangaben ergänzen.",
  "matchmixer.registration.share.title": "Link & QR-Code",
  "matchmixer.registration.share.hint":
    "Anmelde-Link zum Aushang oder Chat. Nach der Anmeldung bekommt jede Person einen persönlichen Link für ihre Ergebnisse.",
  "matchmixer.registration.share.copy": "Link kopieren",
  "matchmixer.registration.share.copied": "Kopiert",
  "matchmixer.registration.share.qrAlt": "QR-Code zur Anmeldung",
  "matchmixer.registration.page.title": "Turnier-Anmeldung",
  "matchmixer.registration.page.intro":
    "Melde dich an – du wirst danach als Spieler im Turnier eingetragen.",
  "matchmixer.registration.page.cta": "Jetzt anmelden",
  "matchmixer.registration.page.ctaLogin": "Anmelden und teilnehmen",
  "matchmixer.registration.page.deadline": "Anmeldung möglich bis {date}.",
  "matchmixer.registration.page.missingCode": "Kein Turniercode in der URL.",
  "matchmixer.registration.page.notFound": "Turnier nicht gefunden.",
  "matchmixer.registration.page.closed":
    "Die Anmeldung ist nicht (mehr) geöffnet.",
  "matchmixer.registration.page.deadlinePassed":
    "Die Anmeldefrist ist abgelaufen.",
  "matchmixer.registration.page.clubOnly":
    "Dieses Turnier ist nur für Mitglieder des ausrichtenden Vereins.",
  "matchmixer.registration.page.failed":
    "Anmeldung fehlgeschlagen. Bitte später erneut versuchen.",
  "hub.matchmixer.openRegistrations.title": "Offene Anmeldungen",
  "hub.matchmixer.openRegistrations.empty":
    "Aktuell keine Turniere mit offener Anmeldung.",
  "hub.matchmixer.openRegistrations.cta": "Zur Anmeldung",
  "hub.matchmixer.openRegistrations.count": "{count} Anmeldungen",
  "hub.matchmixer.promo.registration.title": "Turnier mit offener Anmeldung",
  "hub.matchmixer.promo.registration.desc":
    "Lass Spieler sich selbst anmelden – du erstellst den Spielplan später.",
  "hub.matchmixer.promo.registration.action": "Alle anzeigen",
  "hub.matchmixer.action.own.title": "Meine Turniere",
  "hub.matchmixer.action.own.desc":
    "Alle deine Turniere finden, suchen und filtern.",
  "hub.matchmixer.action.templates.title": "Vorlagen",
  "hub.matchmixer.action.templates.desc":
    "Wiederkehrende Setups speichern und im Verein teilen.",
  "hub.matchmixer.templates.title": "Vorlagen",
  "hub.matchmixer.templates.subtitle":
    "Wiederkehrende MatchMixer-Setups speichern und im Verein teilen.",
  "hub.matchmixer.templates.new": "Neue Vorlage erstellen",
  "hub.matchmixer.templates.empty":
    "Noch keine Vorlagen. Speichere dein erstes Setup als Vorlage.",
  "hub.matchmixer.templates.limit": "{count} von {max} Vorlagen genutzt.",
  "hub.matchmixer.templates.action.load": "In Setup laden",
  "hub.matchmixer.templates.action.edit": "Bearbeiten",
  "hub.matchmixer.templates.action.delete": "Löschen",
  "hub.matchmixer.templates.owner.self": "Von dir",
  "hub.matchmixer.templates.owner.other": "Von {name}",
  "hub.matchmixer.templates.owner.fallback": "Vereinsmitglied",
  "hub.matchmixer.templates.confirmDelete":
    'Vorlage „{label}" wirklich löschen?',
  "hub.matchmixer.templates.editTitle": "Vorlage bearbeiten",
  "hub.matchmixer.templates.editLabelField": "Bezeichnung",
  "hub.matchmixer.templates.summary.format": "Format",
  "hub.matchmixer.templates.summary.rounds": "{rounds} × {minutes} Min",
  "hub.matchmixer.templates.summary.mode": "Modus",
  "hub.matchmixer.templates.loadHint":
    "Erstelle dein Setup und speichere es als Vorlage.",
  "hub.matchmixer.templates.errorGeneric":
    "Vorlagen konnten nicht geladen werden.",
  "hub.matchmixer.templates.saved": "Vorlage gespeichert.",
  "hub.matchmixer.templates.deleted": "Vorlage gelöscht.",
  "hub.matchmixer.templates.action.create": "Neue Vorlage erstellen",
  "hub.matchmixer.templates.loadError":
    "Vorlagen konnten nicht geladen werden. Bitte später erneut versuchen.",
  "hub.matchmixer.own.title": "Meine Turniere",
  "hub.matchmixer.own.subtitle":
    "Alle deine MatchMixer-Turniere – such und filter nach Status.",
  "hub.matchmixer.own.search.placeholder": "Name oder Code suchen…",
  "hub.matchmixer.own.search.aria": "Turnier suchen",
  "hub.matchmixer.own.filter.aria": "Status-Filter",
  "hub.matchmixer.own.filter.all": "Alle",
  "hub.matchmixer.own.filter.active": "Aktiv",
  "hub.matchmixer.own.filter.registration": "Anmeldung",
  "hub.matchmixer.own.filter.finished": "Abgeschlossen",
  "hub.matchmixer.own.status.planned": "Geplant",
  "hub.matchmixer.own.status.running": "Läuft gerade",
  "hub.matchmixer.own.status.registration": "Anmeldung läuft",
  "hub.matchmixer.own.status.finished": "Abgeschlossen",
  "hub.matchmixer.own.empty":
    "Du hast noch keine MatchMixer-Turniere. Leg oben los.",
  "hub.matchmixer.own.emptyFiltered":
    "Keine Turniere passen zu Suche und Filter.",
  "hub.matchmixer.own.archive.button": "Abbrechen & ausblenden",
  "hub.matchmixer.own.archive.aria": "{name} abbrechen und ausblenden",
  "hub.matchmixer.own.archive.error":
    "Turnier konnte nicht ausgeblendet werden. Bitte erneut versuchen.",
  "hub.matchmixer.own.archive.confirm.title": "Turnier abbrechen?",
  "hub.matchmixer.own.archive.confirm.body":
    "Möchtest du „{name}“ wirklich abbrechen und für Anwender ausblenden?",
  "hub.matchmixer.own.archive.confirm.hint":
    "Das Turnier bleibt in unserer Datenbank gespeichert, ist für dich und alle anderen aber nicht mehr sichtbar. Bereits abgegebene Anmeldungen werden ebenfalls ausgeblendet.",
  "hub.matchmixer.own.archive.confirm.cta": "Endgültig ausblenden",
  "hub.matchmixer.own.archive.confirm.archiving": "Wird ausgeblendet…",
  "hub.matchmixer.own.archive.success": "„{name}“ wurde ausgeblendet.",
  "matchmixer.setup.audience.ageGroup.u10": "U10",
  "matchmixer.setup.audience.ageGroup.u12": "U12",
  "matchmixer.setup.audience.ageGroup.u14": "U14",
  "matchmixer.setup.audience.ageGroup.u16": "U16",
  "matchmixer.setup.audience.ageGroup.u18": "U18",
  "matchmixer.setup.audience.ageGroup.adult": "Erwachsene",
  "matchmixer.setup.audience.ageGroup.seniors": "Senioren",
  "matchmixer.setup.smart.startEndApprox": "Start: {start}. Ende ca.: {end}.",
  "matchmixer.setup.overview.courtsRowAria": "Platzanzahl ändern",
  "matchmixer.setup.overview.modeRowAria": "Spielmodus ändern",
  "matchmixer.setup.overview.teamAllocationRowAria": "Team-Zuteilung ändern",
  "matchmixer.setup.overview.auto.approxDurationMinutes":
    "Gesamtblock etwa {minutes} Minuten",
  "matchmixer.setup.overview.auto.roundsDetail":
    "{rounds} Runden à {minutes} Minuten",
  "matchmixer.setup.overview.auto.parallelPlayers":
    "Bis zu {count} Spieler parallel auf {courts} Plätzen",
  "matchmixer.setup.overview.auto.partnerExclusions":
    "Partner-Ausschlüsse werden im Spielplan berücksichtigt",
  "matchmixer.setup.status.ariaRegion": "Setup-Status",
  "matchmixer.setup.status.blockedTitle": "Noch offen",
  "matchmixer.setup.status.blockedSubtitle":
    "Kurz vervollständigen, dann Plan erstellen.",
  "matchmixer.setup.status.readyTitle": "Bereit",
  "matchmixer.setup.status.readySubtitle": "Du kannst den Spielplan anlegen.",
  "matchmixer.setup.status.warnSubtitle":
    "Es gibt Hinweise – Start ist trotzdem möglich.",
  "matchmixer.setup.cta.blocked.generic":
    "Bitte die markierten Angaben prüfen.",
  "matchmixer.setup.cta.blocked.manualTeams":
    "Team-Zuteilung ist noch unvollständig.",
  "matchmixer.setup.cta.blocked.noParticipants": "Noch Teilnehmer hinzufügen.",
  "matchmixer.setup.cta.blocked.tooFewPlayers":
    "Zu wenige Teilnehmer ({count}, mindestens {min}).",
  "matchmixer.setup.cta.blocked.playersFix": "Teilnehmer oder Namen prüfen.",
  "matchmixer.setup.cta.blocked.meta": "Turnierdetails prüfen.",
  "matchmixer.setup.cta.blocked.timeCourts": "Dauer oder Plätze prüfen.",
  "matchmixer.setup.cta.blocked.rules": "Spielregeln prüfen.",
  "matchmixer.setup.smartSummary.title": "Aus deinen Angaben berechnet",
  "matchmixer.setup.calculatedSummary.title": "Aus deinen Angaben berechnet",
  "matchmixer.setup.calculatedSummary.shortTitle": "Aus deinen Angaben",
  "matchmixer.setup.calculated.courtsInPlan": "{count} Plätze im Zeitplan",
  "matchmixer.setup.warnings.title": "Hinweise",
  "matchmixer.setup.warnings.shortTitle": "Hinweise",
  "matchmixer.setup.plannedDuration.asMinutes": "{minutes} Minuten",
  "matchmixer.setup.plannedDuration.asApproxHours": "{hours} Std.",
  "matchmixer.setup.plannedDuration.asApproxHoursMinutes":
    "{hours} Std. {restMinutes} Min.",
  "matchmixer.setup.smart.plannedDuration": "Geplante Gesamtdauer etwa {label}",
  "matchmixer.setup.smart.plannedRounds":
    "Ungefähr {rounds} Runden im Zeitfenster",
  "matchmixer.setup.smart.rotatingDoubles":
    "Wechselnde Doppel-Zusammenstellungen",
  "matchmixer.setup.smart.fixedTeamsPairing": "Paarungen aus festen Teams",
  "matchmixer.setup.smart.rotatingSingles": "Wechselnde Einzel-Gegner",
  "matchmixer.setup.smart.balancedRotation":
    "Rotation wird über die Spielzeit ausgeglichen",
  "matchmixer.setup.smart.pausesAveraged": "Pausen werden gleichmäßig verteilt",
  "matchmixer.setup.smart.scheduleFitsSlots":
    "Zeit und Plätze fließen in den Spielplan ein",
  "matchmixer.setup.smart.pauseBetweenSet":
    "Pause zwischen den Runden: {minutes} Minuten",
  "matchmixer.setup.smart.respectsPartnerExclusions":
    "Partner-Ausschlüsse werden berücksichtigt",
  "matchmixer.setup.smart.parallelCapacity":
    "Bis zu {count} Spieler parallel auf {courts} Plätzen",
  "matchmixer.setup.optimized.title": "Automatisch optimiert",
  "matchmixer.setup.optimized.shortTitle": "Optimierung",
  "matchmixer.setup.optimized.introSimple":
    "Feineinstellungen wie Wertung oder Zeiten laufen mit denselben Standardwerten weiter – du entscheidest nur das Wesentliche.",
  "matchmixer.setup.optimized.introSimpleShort":
    "Standardwerte für Wertung und Zeiten – du steuerst das Wesentliche hier.",
  "matchmixer.setup.optimized.introExpert":
    "Das wirkt im Spielplan aus deinen Experteneinstellungen.",
  "matchmixer.setup.optimized.placeholderMoreSetup":
    "Mit gültigem Setup und Teilnehmern erscheinen hier kurze Hinweise zu Rotation, Pausen und Co.",
  "matchmixer.setup.optimized.placeholderShort":
    "Mit Spielern und gültigem Setup erscheinen hier Kurzhinweise.",
  "matchmixer.setup.optimized.chip.rotationBalanced":
    "Rotation wird über die Runden ausgeglichen",
  "matchmixer.setup.optimized.chip.rotatingPartners":
    "Wechselnde Doppelpartner",
  "matchmixer.setup.optimized.chip.rotatingSingles": "Wechselnde Einzelgegner",
  "matchmixer.setup.optimized.chip.fixedTeamsFlow":
    "Feste Teams mit wechselnden Gegnern",
  "matchmixer.setup.optimized.chip.pauseMinutesInPlan":
    "Pausen zwischen den Runden eingeplant ({minutes} Min)",
  "matchmixer.setup.optimized.chip.warmupInTimeline":
    "Einspielzeit eingeplant ({minutes} Min)",
  "matchmixer.setup.optimized.chip.halftimeInTimeline":
    "Halbzeitpause eingeplant ({minutes} Min)",
  "matchmixer.setup.optimized.chip.roundsDerivedFromTime":
    "Rundenzahl aus Gesamtzeit abgeleitet ({rounds})",
  "matchmixer.setup.optimized.chip.partnerExclusionsHonored":
    "Partner-Ausschlüsse werden berücksichtigt",
  "matchmixer.setup.optimized.chip.scoringWinDraw":
    "Wertung aktiv (Sieg {win}, Remis {draw})",
  "matchmixer.setup.softWarn.playerCountRange":
    "Die Teilnehmerzahl ({count}) liegt außerhalb des konfigurierten Bereichs ({min}–{max}).",
  "matchmixer.setup.softWarn.fewCourtsVsSuggested":
    "Relativ wenige Plätze ({courts}) – für alle aktiv sind oft {suggested} Plätze angenehmer.",
  "matchmixer.setup.softWarn.shortRoundDuration":
    "Sehr kurze Rundendauer ({minutes} Min).",
  "matchmixer.setup.softWarn.oddPlayerCountDoubles":
    "Ungerade Teilnehmerzahl – pro Runde pausiert mindestens eine Person.",
  "matchmixer.setup.softWarn.morePlayersThanFitOneRound":
    "Mehr aktive Spieler ({players}) als Platz auf allen Plätzen gleichzeitig ({capacity}) – es gibt Wartepausen.",
  "matchmixer.setup.expert.regionAria": "Experten-Einstellungen",
  "matchmixer.setup.expert.intro":
    "Optional: nur aufklappen, was du ändern willst.",
  "matchmixer.setup.expert.mobileSectionTitle": "Feineinstellungen",
  "matchmixer.setup.overview.modeScrollerAria": "Spielmodus wählen",
  "matchmixer.setup.overview.modeMoreInSheet":
    "Alle Regeln & Playoffs im Detail",
  "matchmixer.setup.expert.section.time.title": "Zeit & Ablauf",
  "matchmixer.setup.expert.section.time.desc":
    "Pausen, Einspielzeit und Halbzeit – fließen in Ende & Ablauf ein.",
  "matchmixer.setup.expert.section.scoring.title": "Spielwertung",
  "matchmixer.setup.expert.section.scoring.desc":
    "Punkte, Satzende und No-Ad – wie gewertet wird.",
  "matchmixer.setup.expert.section.rotation.title": "Rotation & Fairness",
  "matchmixer.setup.expert.section.rotation.desc":
    "Teams bilden und Partner-Regeln unter Teilnehmern.",
  "matchmixer.setup.expert.section.rotation.onlyFixedTeams":
    "Team-Zuteilung gilt bei festen Teams.",
  "matchmixer.setup.expert.section.rotation.inlineHint":
    "Die Team-Zuteilung steuerst du direkt oben in der Übersicht.",
  "matchmixer.setup.expert.section.rotation.participantsCta":
    "Zu Teilnehmern & Ausschlüssen",
  "matchmixer.setup.expert.section.schedule.title": "Spielplan & Turniermodus",
  "matchmixer.setup.expert.section.schedule.desc":
    "Modus wählen und optional Playoffs konfigurieren.",
  "matchmixer.setup.expert.section.advanced.title": "Erweiterte Optionen",
  "matchmixer.setup.expert.section.advanced.desc":
    "Platznummern für die Anzeige.",
  "schleifchen.welcome": "Willkommen! Starten Sie ein neues Turnier.",
  "schleifchen.actions.newTournament": "Neues Turnier starten",
  "schleifchen.actions.editResults": "Ergebnisse korrigieren",
  "schleifchen.execution.title": "Turnier-Durchführung",
  "schleifchen.execution.roundOf": "Runde {current} von {total}",
  "schleifchen.execution.modusPreview": "Modus-Vorschau",
  "schleifchen.wechselbank.title": "Wechselbank",
  "schleifchen.wechselbank.changeBeforeStart": "Vor Rundenstart ändern",
  "schleifchen.wechselbank.resting": "{name} pausiert",
  "schleifchen.wechselbank.noneResting": "Niemand pausiert",
  "schleifchen.wechselbank.instruction":
    "Wähle Spieler, die diese Runde pausieren sollen. Die Runde wird danach neu ausgelost.",
  "schleifchen.wechselbank.summaryResting":
    "{count} Spieler pausieren – Runde wird neu ausgelost",
  "schleifchen.wechselbank.summaryRestingOne":
    "1 Spieler pausiert – Runde wird neu ausgelost",
  "schleifchen.wechselbank.redraw": "Neu auslosen",
  "schleifchen.wechselbank.close": "Schließen",
  "schleifchen.roundConfig.title": "Runde {nextRound} konfigurieren",
  "schleifchen.roundConfig.statusPlaying": "Spielt",
  "schleifchen.roundConfig.statusResting": "Pausiert",
  "schleifchen.roundConfig.confirm": "Konfiguration übernehmen",
  "schleifchen.roundConfig.err.noPlayers":
    "Mindestens ein Spieler muss spielen.",
  "schleifchen.roundConfig.err.invalidCount":
    "Aktuell {count} Spieler – für {expected} (Format) nötig.",
  "schleifchen.roundConfig.warningCount":
    "Aktuell {count} Spieler (teilbar durch {divisor} nötig).",
  "schleifchen.wizard.ariaLabel": "Fortschritt",
  "schleifchen.schedule.title": "Spielplan",
  "schleifchen.schedule.subtitle":
    "Überprüfe die Paarungen und starte die Durchführung",
  "schleifchen.schedule.empty": "Noch kein Spielplan.",
  "schleifchen.schedule.roundLabel": "Runde {n}",
  "schleifchen.schedule.badge.current": "Aktuell",
  "schleifchen.schedule.badge.upcoming": "Bevorstehend",
  "schleifchen.schedule.badge.completed": "Abgeschlossen",
  "schleifchen.schedule.warning.title": "Letzte Kontrolle",
  "schleifchen.schedule.warning.hint":
    "Prüfe Spielplan und Einstellungen sorgfältig. Nach dem Start können Spieler und Paarungen nicht mehr geändert werden.",
  "schleifchen.schedule.review.group.tournament": "Turnier",
  "schleifchen.schedule.review.group.flow": "Ablauf",
  "schleifchen.schedule.review.group.playersSection": "Spieler",
  "schleifchen.schedule.review.label.name": "Name",
  "schleifchen.schedule.review.label.time": "Zeit",
  "schleifchen.schedule.review.label.minPerRoundShort": "Min./Runde",
  "schleifchen.schedule.review.label.count": "Anzahl",
  "schleifchen.schedule.backToSettings": "Einstellungen korrigieren",
  "schleifchen.schedule.startTournament": "Turnier starten",
  "schleifchen.schedule.confirm.title": "Turnier wirklich starten?",
  "schleifchen.schedule.confirm.intro":
    "Nach dem Start sind folgende Änderungen nicht mehr möglich:",
  "schleifchen.schedule.confirm.noPlayers": "Spieler hinzufügen oder entfernen",
  "schleifchen.schedule.confirm.noPairs": "Teams und Paarungen ändern",
  "schleifchen.schedule.confirm.noMode": "Turniermodus oder Format anpassen",
  "schleifchen.schedule.confirm.cancel": "Nochmal prüfen",
  "schleifchen.schedule.confirm.start": "Jetzt starten",
  "schleifchen.schedule.fixedTeams.title": "Feste Teams",
  "schleifchen.schedule.fixedTeams.lkPairingHint":
    "LK-Stärker mit LK-Schwächer zugelost (Stark + Schwach).",
  "schleifchen.schedule.fixedTeams.playerWithLk": "{name} (LK {lk})",
  "schleifchen.schedule.fixedTeams.zulosung": "Zulosung",
  "schleifchen.schedule.fixedTeams.ausschluesse": "Ausschlüsse",
  "schleifchen.schedule.fixedTeams.excludePair": "{a} darf nicht mit {b}",
  "schleifchen.schedule.timePlan.title": "Zeitplan",
  "schleifchen.schedule.timePlan.noStartTimeHint":
    "Startzeit in den Einstellungen eintragen (z.B. 09:00), dann erscheint hier die Zeitplanung.",
  "schleifchen.schedule.timePlan.exampleHint":
    "Beispiel mit 09:00 – Startzeit in Einstellungen eintragen, um Ihre Zeit zu übernehmen.",
  "schleifchen.schedule.timePlan.start": "Start (gemäß Planung)",
  "schleifchen.schedule.timePlan.warmup": "Einspielzeit",
  "schleifchen.schedule.timePlan.roundN": "Runde {n}",
  "schleifchen.schedule.timePlan.changeover": "Wechselpause",
  "schleifchen.schedule.timePlan.changeoverWithDuration":
    "Wechselpause ({minutes} Min.)",

  "schedule.print": "Spielplan drucken",
  "schedule.courtPrefix": "Platz {n}",
  "schedule.status.pending": "Ausstehend",
  "schedule.status.entered": "Eingetragen",
  "schleifchen.currentRound.title": "Runde {n}",
  "schleifchen.currentRound.gameMode": "Spielmodus: {mode}",
  "schleifchen.currentRound.gameModeShort.oneSetOpen": "1 Satz offen",
  "schleifchen.currentRound.gameModeShort.oneSetTb": "1 Satz TB",
  "schleifchen.currentRound.gameModeShort.twoSetsMtb": "2 Sätze + MTB",
  "schleifchen.currentRound.setLabel": "Satz",
  "schleifchen.currentRound.setPlaceholder": "— : —",
  "schleifchen.currentRound.team1": "Team 1",
  "schleifchen.currentRound.team2": "Team 2",
  "schedule.correctRound": "Korrigieren",
  "schedule.correctSave": "Speichern",
  "schedule.correctCancel": "Abbrechen",
  "schedule.correctHint": "Ergebnis dieser Runde bearbeiten",
  "schedule.scoreEditLabel": "Ergebnis Platz {court}",
  "schedule.playoffs.phaseGroup": "Vorrunde",
  "schedule.playoffs.phaseKnockout": "K.O.-Phase",
  "schedule.playoffs.standingsTitle": "Rangliste nach Runde {current}/{total}",
  "schedule.playoffs.koPhaseTitle": "K.O.-Phase",
  "schedule.playoffs.koPhaseSubtitle": "Halbfinale → Finale",
  "schedule.playoffs.koPhasePreview":
    "Vorschau: Halbfinale und Finale nach der Vorrunde",
  "schedule.playoffs.quarterFinals": "Viertelfinale",
  "schedule.playoffs.semiFinals": "Halbfinale",
  "schedule.playoffs.final": "Finale",
  "schedule.playoffs.thirdPlace": "Platz 3",
  "schedule.playoffs.fifthPlace": "Platz 5/6",
  "schedule.playoffs.matchForPlace56": "Spiel um Platz 5&6",
  "schedule.playoffs.qualifier": "K.O.",
  "schedule.playoffs.topN": "Top {n}",
  "schedule.playoffs.rankLabel": "Platz {n}",
  "schedule.playoffs.rankLabelDoubles": "Platz {a}&{b}",
  "schedule.playoffs.roundRobinQualificationRank": "Vorrunde Rang {n}",
  "schedule.playoffs.roundRobinQualificationRankWithNames":
    "Vorrunde Rang {n} ({names})",
  "schedule.playoffs.rankLabelKo": "Vorrunde Rang {n}",
  "schedule.playoffs.rankLabelKoWithNames": "Vorrunde Rang {n} ({names})",
  "schedule.playoffs.winnerVF": "Sieger VF{n}",
  "schedule.playoffs.winnerHF1": "Sieger HF1",
  "schedule.playoffs.winnerHF2": "Sieger HF2",
  "schedule.playoffs.loserHF1": "Verlierer HF1",
  "schedule.playoffs.loserHF2": "Verlierer HF2",
  "schedule.playoffs.loserR1": "Verlierer R1{n}",
  "schedule.playoffs.winnerR1": "Sieger R1{n}",
  "schedule.playoffs.koRound1": "K.O. Runde 1",
  "schedule.playoffs.roundTitleTop6Ko1":
    "Runde {n} (Halbfinale & Spiel um Platz 5&6)",
  "schedule.playoffs.roundTitleTop6Ko2":
    "Runde {n} (Finale und Spiel um Platz 3)",
  "playoffs.settings.title": "Playoffs-Einstellungen",
  "playoffs.settings.subtitle": "Vorrunde + K.O.-Phase",
  "playoffs.settings.vorrunden": "Vorrunden",
  "playoffs.settings.vorrundenHint": "Jeder gegen jeden",
  "playoffs.settings.vorrundenRoundRobinHint":
    "Bei Jeder-gegen-jeden wären {n} Runden nötig.",
  "playoffs.settings.vorrundenUseSuggestion": "Als Vorschlag übernehmen",
  "playoffs.settings.koTeilnehmer": "K.O.-Phase Teilnehmer",
  "setup.playoffs.playThirdPlace.label": "Platz 3 ausspielen",
  "setup.playoffs.playThirdPlace.help":
    "Erzeugt ein Spiel um Platz 3 (kleines Finale) in der K.O.-Phase.",
  "schleifchen.setup.playoffs.hintMinPlayers":
    "Playoffs sind ab 8 Spielern möglich.",
  "schleifchen.setup.playoffs.confirmFixedTeamsBody":
    "Für Playoffs werden feste Teams benötigt. Wenn du Playoffs aktivierst, wechseln wir automatisch zu „Feste Teams“. Fortfahren?",
  "playoffs.settings.infoPlayers":
    "Bei {playerCount} Spielern und {vorrunden} Vorrunden:",
  "playoffs.settings.infoMatches": "{count} Matches in der Vorrunde",
  "playoffs.settings.infoQualify": "Top {n} qualifizieren sich für K.O.",
  "playoffs.settings.infoBracket2": "Finale",
  "playoffs.settings.infoBracket4": "HF → Finale",
  "playoffs.settings.infoBracket6": "HF + Platz 5/6 → Finale",
  "playoffs.settings.infoBracket8": "VF → HF → Finale",
  "schedule.overview.title": "Spielplan-Übersicht",
  "schedule.overview.openAll": "Alle öffnen",
  "schedule.overview.toggleAll.open": "Alle öffnen",
  "schedule.overview.toggleAll.close": "Alle schließen",
  "schedule.overview.meta": "{n} Runden",
  "schedule.overview.done": "Abgeschlossen",
  "schedule.overview.current": "Aktuell",
  "schedule.overview.upcoming": "Bevorstehend",
  "schedule.overview.empty": "Noch keine Runden.",
  "schedule.status.running": "Laufend",
  "schedule.pauseLabel": "(Pause: {name})",
  "schedule.restInRound": "Pause in dieser Runde: {name}",
  "schedule.playersIdle": "{list}",

  "schleifchen.entry.titleRound": "Runde {round} – Ergebnisse",
  "schleifchen.entry.hintN": "{count} Spiele",
  "schleifchen.entry.modeLabel": "Spielmodus",
  "schleifchen.entry.matchLabel": "Spiel {n}",
  "schleifchen.entry.teamLabel": "Team {n}",
  "schleifchen.entry.teamLabelWithNames": "Team {n} ({names})",
  "schleifchen.entry.confirm": "Ergebnisse eintragen",
  "schleifchen.entry.hintFillAll": "Bitte alle Ergebnisse eintragen.",
  "schleifchen.entry.sep": ":",
  "schleifchen.entry.label.setOpen": "Satz",
  "schleifchen.entry.label.set1": "Satz 1",
  "schleifchen.entry.label.set2": "Satz 2",
  "schleifchen.entry.label.tb": "TB",
  "schleifchen.entry.label.mtb": "MTB",
  "schleifchen.entry.err.required": "Bitte eintragen.",
  "schleifchen.entry.err.negative": "Keine negativen Werte.",
  "schleifchen.entry.err.set1Required": "Satz 1 erforderlich.",
  "schleifchen.entry.err.set2Required": "Satz 2 erforderlich.",
  "schleifchen.entry.err.mtbRequired": "Match-Tiebreak erforderlich.",
  "schleifchen.entry.err.noDrawSet1": "Unentschieden im Satz nicht erlaubt.",
  "schleifchen.entry.err.noDrawSet2": "Unentschieden im Satz nicht erlaubt.",
  "schleifchen.entry.err.noDrawMtb": "Unentschieden im MTB nicht erlaubt.",
  "schleifchen.entry.err.koNoDraw":
    "In der K.O.-Phase darf es kein Unentschieden geben. Einer der beiden Teams muss gewinnen.",
  "schleifchen.entry.warn.gamesPerTime":
    "Ungewöhnlich viele Spiele für die Rundenzeit – bitte prüfen. (Ca. 2 Min. pro Spiel.)",
  "schleifchen.entry.overlay.saveAnyway": "Trotzdem speichern",
  "schleifchen.entry.overlay.cancel": "Abbrechen",
  "schleifchen.entry.overlay.warningTitle": "Hinweis",

  "common.ok": "OK",
  "common.continue": "Weiter",
  "common.vs": "VS",
  "common.pause": "Pause",
  "common.reset": "Zurücksetzen",
  "common.roundN": "Runde {n}",
  "common.emptyDash": "—",

  "timer.title": "Runden-Timer",
  "timer.roundLabel": "Runde {n}",
  "timer.adjust": "Timer anpassen",
  "timer.startRound": "Starten",
  "timer.startRoundButton": "Runde starten",
  "timer.startNextRound": "Nächste Runde starten",
  "timer.endRound": "Beenden",
  "timer.endRoundConfirm":
    "Runde wirklich beenden? Ergebnisseingabe wird freigeschaltet.",

  "btn.resetTournament": "Turnier zurücksetzen?",
  "hint.resetTournament": "Alle Daten werden gelöscht.",

  // Profil (Fallback)
  "profile.title": "Profil",
  "profile.subtitle":
    "Adresse, Familie und Trainingsguthaben – plattformweit für alle Apps.",
  "account.fallback.noFamilyPortal":
    "Für deinen Account ist kein Familienprofil hinterlegt. Bitte wende dich an deinen Verein oder nutze die TrainingsDesk-Navigation.",
  "account.fallback.familySectionPortalOnly":
    "Die Familienverwaltung ist für Eltern- und Spieler-Konten vorgesehen. Deine Kontaktdaten pflegst du unter „Profil“.",
  "account.profile.trainerSection.unavailable":
    "Für dein Konto sind keine Trainer-Stammdaten hinterlegt.",
  "account.profile.title": "Mein Profil",
  "account.profile.subtitle":
    "Adresse, Familie und Trainingsguthaben – plattformweit für alle deine Vereine.",
  "account.profile.settingsTitle": "Profil & Einstellungen",
  "account.profile.settingsSubtitle":
    "Hier pflegst du persönliche Daten, Familie, Standort und Vereinszugehörigkeit – alles an einem Ort.",
  "account.profile.sections.navAria": "Profil-Bereiche",
  "account.profile.sections.contact": "Profil",
  "account.profile.sections.trainer": "Training & Abrechnung",
  "account.profile.sections.contactFlat": "Kontakt",
  "account.profile.unsavedHint":
    "Änderungen vorhanden. Vergiss nicht, deine Änderungen zu speichern.",
  "account.profile.discardChanges": "Änderungen verwerfen",
  "account.profile.password.title": "Passwort",
  "account.profile.password.lead":
    "Hier änderst du dein Login-Passwort für Tennis-Matches.de. Du bleibst danach eingeloggt.",
  "account.profile.password.submit": "Passwort speichern",
  "account.profile.password.saving": "Wird gespeichert …",
  "account.profile.password.success": "Dein Passwort wurde geändert.",
  "account.profile.hero.nameFallback": "Dein Profil",
  "account.profile.hero.roleParent": "Profil",
  "account.profile.hero.memberBadge": "Mitglied bei {clubName}",
  "account.profile.hero.lead":
    "Diese Daten nutzt dein Verein für Trainings, Buchungen und Rechnungen.",
  "account.profile.hero.memberSince": "Mitglied seit {date}",
  "account.profile.hero.lastChange": "Letzte Änderung: {relative}",
  "account.profile.hero.clubProfileLink": "Zum Vereinsprofil",
  "account.profile.hero.editPhotoAria": "Profilbild bearbeiten",
  "account.profile.hero.platformMemberSince":
    "Bei Tennis-Matches.de seit {date}",
  "account.profile.hero.avatarSheet.title": "Profilbild",
  "account.profile.hero.avatarSheet.subtitle":
    "Lade ein Foto von deinem Gerät hoch – JPG, PNG, WebP oder GIF, maximal 5 MB.",
  "account.profile.hero.avatarSheet.uploadCta": "Bild auswählen",
  "account.profile.hero.avatarSheet.uploadHint":
    "Dein Bild wird sicher gespeichert und in deinem Profil angezeigt.",
  "account.profile.hero.avatarSheet.uploadFailed":
    "Das Bild konnte nicht hochgeladen werden. Bitte erneut versuchen.",
  "account.profile.hero.avatarSheet.invalidType":
    "Bitte JPG, PNG, WebP oder GIF verwenden.",
  "account.profile.hero.avatarSheet.tooLarge":
    "Das Bild ist zu groß (maximal 5 MB).",
  "account.profile.hero.avatarSheet.showUrl": "Alternativ Bild-Link eingeben",
  "account.profile.hero.avatarSheet.hideUrl": "Bild-Link ausblenden",
  "account.profile.hero.avatarSheet.urlHelp":
    "Nur https://-Links werden gespeichert. Bei Fehler oder Blockierung durch den Host bleiben die Initialen sichtbar.",
  "account.profile.hero.avatarSheet.remove": "Profilbild entfernen",
  "account.profile.hero.avatarSheet.saved": "Profilbild gespeichert.",
  "account.profile.hero.avatarSheet.invalidUrl":
    "Bitte eine gültige https://-Adresse eingeben.",
  "account.profile.sections.family": "Familie",
  "account.profile.sections.location": "Standort & Wetter",
  "account.profile.sections.appearance": "Darstellung",
  "account.profile.sections.clubs": "Meine Vereine",
  "account.profile.sections.password": "Passwort ändern",
  "account.profile.sections.clubsLead":
    "Verbundene Vereine, Standort für Wetter & Sonnenzeiten sowie Ortssuche.",
  "account.profile.sections.clubsEmpty": "Noch kein Verein verbunden.",
  "account.profile.sections.clubsConnect": "Verein verbinden",
  "account.profile.sections.clubsSelfServiceLockedHint":
    "Weitere Vereine kannst du nicht selbst verbinden. Dein Zugang wird vom Verein bzw. durch den Admin zugeordnet.",
  "account.profile.sections.clubsManageLink":
    "Vereine & Adressen in Meine Vereine verwalten →",
  "account.profile.sections.clubsUseLocation": "Als Standort",
  "account.profile.sections.clubsLocationActive": "Standort aktiv",
  "account.profile.sections.clubsLocationApplied":
    "Standort übernommen – Wetter und Sonnenzeiten aktualisieren sich gleich.",
  "account.profile.sections.clubsLocationHint":
    "Dein Hauptverein (oder einziger Verein) wird automatisch als Standort für Wetter und Sonnenzeiten übernommen.",
  "account.profile.sections.clubsGeocodeFailed":
    "Für {clubName} konnte der Ort nicht automatisch ermittelt werden. Bitte manuell geocodieren oder die Adresse im Vereinsprofil pflegen.",
  "account.profile.sections.clubsDisconnect": "Verbindung lösen",
  "account.profile.sections.clubsDisconnectConfirmTitle":
    "Vereinsverbindung lösen?",
  "account.profile.sections.clubsDisconnectConfirmBody":
    "Du verlierst den Zugang zu Trainings und Funktionen von {clubName}. Du kannst den Verein später erneut verbinden.",
  "account.profile.sections.clubsDisconnectConfirmAction": "Verbindung lösen",
  "account.profile.sections.clubsDisconnectSuccess":
    "Die Verbindung zu {clubName} wurde beendet.",
  "account.profile.sections.clubsDisconnectError":
    "Die Verbindung konnte nicht gelöst werden. Bitte später erneut versuchen.",
  "account.profile.sections.clubsDisconnectNotMember":
    "Du bist mit diesem Verein nicht (mehr) verbunden. Bitte die Seite neu laden.",
  "account.profile.sections.clubsDisconnectUnavailable":
    "Die Verbindung konnte gerade nicht gelöst werden (Serverfehler). Bitte erneut versuchen oder support@tennis-matches.de kontaktieren.",
  "account.profile.sections.clubsDisconnectLastClub":
    "Du bist nur mit diesem Verein verbunden. Eine vollständige Lösung aller Vereinsverbindungen ist nur über support@tennis-matches.de möglich.",
  "account.profile.sections.clubsDisconnectPrimaryClub":
    "Dein Hauptverein kann nicht selbst gelöst werden. Bitte wende dich an support@tennis-matches.de, wenn du die Verbindung beenden möchtest.",
  "account.profile.sections.clubsDisconnectPrimaryHint":
    "Der Hauptverein ist geschützt und kann im Profil nicht gelöst werden. Weitere Vereine nur ohne offene Turnier-Anmeldungen und Trainings.",
  "account.profile.sections.clubsDisconnectOpenRegistrations":
    "Es gibt noch offene Turnier-Anmeldungen bei diesem Verein. Bitte melde dich ab oder warte das Turnier ab, bevor du die Verbindung löst.",
  "account.profile.sections.clubsDisconnectOpenTrainings":
    "Es gibt noch offene oder geplante Trainings bei diesem Verein. Bitte kläre diese zuerst, bevor du die Verbindung löst.",
  "account.profile.sections.clubsDisconnectSupportCta": "Support kontaktieren",
  "account.profile.sections.clubsDisconnectSupportEmail":
    "support@tennis-matches.de",
  "account.profile.openTrainingsDesk":
    "Training, Termine & Rechnungen in TrainingsDesk öffnen",
  "profile.email": "E‑Mail",
  "profile.displayName": "Anzeigename",
  "profile.displayName.placeholder": "z.B. Michael",
  "profile.avatarUrl": "Avatar URL",
  "profile.avatarUrl.placeholder": "https://…",
  "profile.save": "Speichern",
  "profile.saving": "Speichere…",
  "profile.saved": "Gespeichert.",
  "profile.error.load": "Profil konnte nicht geladen werden.",
  "profile.error.save": "Profil konnte nicht gespeichert werden.",

  // Selbstbestimmte Datenfreigabe – Profilfelder + Sichtbarkeit
  "profile.fields.firstName": "Vorname",
  "profile.fields.lastName": "Nachname",
  "profile.fields.birthDate": "Geburtsdatum",
  "profile.fields.city": "Ort",
  "profile.fields.phone": "Telefon",
  "profile.visibility.private": "Privat",
  "profile.visibility.club": "Im Verein",
  "profile.visibility.help": "Lege für jedes Feld fest, wer es sehen darf.",
  "profile.dataConsent.title": "Wer darf was sehen?",
  "profile.dataConsent.description":
    "Standardmäßig sehen Mitglieder deiner Vereine nur deinen Namen. Weitere Details kannst du in deinem Profil freigeben.",
  "hub.dataConsent.title": "Im Verein findbar sein?",
  "hub.dataConsent.prompt":
    "Sollen Vereinskolleg:innen dich unter „{name}“ finden — z. B. bei Turnieren oder Trainingsplanung?",
  "hub.dataConsent.accept": "Ja, freigeben",
  "hub.dataConsent.decline": "Nein, privat lassen",
  "hub.dataConsent.missingName":
    "Ohne Vor- und Nachname können Vereinskolleg:innen dich nicht finden.",
  "hub.dataConsent.profileLink": "Im Profil eintragen",
  "hub.dataConsent.saving": "Speichere…",
  "hub.dataConsent.error":
    "Konnte nicht gespeichert werden. Bitte erneut versuchen.",

  // Share (Fallback)
  "share.page.renderError.title": "Fehler beim Laden der Seite",
  "share.page.renderError.details": "Details",

  "footer.impressum": "Impressum",
  "footer.privacy": "Datenschutz",
  "nav.schleifchen": "MatchMixer",
  "nav.trainerstunden": "TrainingsDesk",
  "nav.minigames": "Mini-Games",
  "club.title": "CourtLeague",
  "club.subtitle": "Clubmeisterschaften verwalten.",
  "club.nav.aria": "ClubChamp Navigation",
  "club.nav.overview": "Übersicht",
  "club.nav.new": "Neu",
  "club.nav.open": "Öffnen",
  "club.nav.stats": "Statistik",
  "club.nav.settings": "Einstellungen",
  "club.actionsTitle": "Aktionen",
  "club.actionNewDesc": "Starte eine neue Clubmeisterschaft.",
  "club.actionOpenDesc": "Turnier über Code oder aus der Liste öffnen",
  "club.actionStatsDesc":
    "Vergangene Turniere analysieren und Statistiken einsehen",
  "club.actionSettingsDesc": "Standardwerte und Vorlagen verwalten",
  "club.lastTournaments": "Deine letzten Clubmeisterschaften",
  "club.empty": "Noch keine Clubmeisterschaften.",
  "club.landing.placeholder": "Startseite folgt (Skeleton).",
  "club.setup.title": "Setup",
  "club.schedule.title": "Spielplan",
  "club.entry.title": "Ergebnisse",
  "club.finish.title": "Abschluss",
  "club.setup.step.meta": "Basics",
  "club.setup.step.players": "Spieler",
  "club.setup.step.mode": "Modus",
  "club.setup.step.details": "Details",
  "club.setup.step.periods": "Zeiträume",
  "club.setup.step.rules": "Regeln",
  "club.setup.players.entryMode.title": "Wie kommen die Spieler hinein?",
  "club.setup.players.entryMode.hint":
    "Wähle, ob du alle Spieler selbst einträgst, eine Registrierung per Link öffnest oder beides kombinierst.",
  "club.setup.players.entryMode.manual": "Alle manuell",
  "club.setup.players.entryMode.manual.desc":
    "Du wählst alle Teilnehmer direkt aus den Kontakten aus.",
  "club.setup.players.entryMode.link": "Nur Registrierungslink",
  "club.setup.players.entryMode.link.desc":
    "Spieler tragen sich selbst über einen öffentlichen Link ein.",
  "club.setup.players.entryMode.hybrid": "Teils / teils",
  "club.setup.players.entryMode.hybrid.desc":
    "Du trägst bekannte Spieler ein und veröffentlichst zusätzlich den Link.",
  "club.setup.players.registrationLink.title": "Registrierungslink",
  "club.setup.players.registrationLink.link.hint":
    "Veröffentliche diesen Link, damit Spieler ihre Kontaktdaten selbst eintragen können.",
  "club.setup.players.registrationLink.hybrid.hint":
    "Du kannst bekannte Spieler direkt eintragen und den Link für alle übrigen Spieler teilen.",
  "club.setup.players.registrationLink.copy": "Link kopieren",
  "club.setup.players.registrationLink.copied": "Kopiert",
  "club.setup.players.registrationLink.aria": "Registrierungslink",
  "club.setup.players.nameConfirm.message":
    "Kontakt für „{{input}}“ anlegen?\n\nErkannt als:\nVorname: {{firstName}}\nNachname: {{lastName}}\n\nWenn das nicht stimmt, bitte den Namen im Feld korrigieren.",
  "club.setup.players.similarConfirm.message":
    "Zu „{{input}}“ gibt es bereits ähnliche Kontakte: {{matches}}\n\nTrotzdem einen neuen Kontakt anlegen?",
  "wizard.error.currentStep":
    "Bitte korrigiere die Eingaben in diesem Schritt.",
  "wizard.error.otherStep": "Ein anderer Schritt ist noch unvollständig.",
  "wizard.error.blockedTitle": "Fortfahren nicht möglich",
  "wizard.error.currentStepDetail": "In diesem Schritt sind noch Fehler.",
  "wizard.error.otherStepDetail":
    "Dieser Schritt ist ok – aber ein anderer Schritt blockiert.",
  "wizard.error.details": "Details",
  "wizard.error.missingInStep": "Fehlende Angaben in: {{step}}",
  "club.wizard.fixToContinue": "Zum Fortfahren bitte korrigieren:",
  "club.wizard.nextDisabledHint":
    "Bitte prüfe die Eingaben im aktuellen Schritt.",
  "club.wizard.blockedByOtherStep":
    "Fortfahren ist blockiert: Es fehlen noch Eingaben in einem anderen Schritt.",
  "club.wizard.nextDisabledHint.otherStep":
    "Ein anderer Schritt ist noch nicht vollständig.",
  "club.wizard.nextDisabledHint.currentStep":
    "Bitte korrigiere die markierten Felder.",
  "club.mode.step.title": "Modus",
  "club.mode.step.hint":
    "Turnierform wählen: reines K.O., Gruppen + K.O. oder Schweizer System.",
  "club.mode.ko.title": "K.O.",
  "club.mode.ko.desc": "Reines K.-o.-Turnier ohne Gruppenphase.",
  "club.mode.ko.placeholder": "K.O.-Konfiguration folgt (Prompt B).",
  "club.mode.groupsKo.title": "Gruppen + K.O.",
  "club.mode.groupsKo.desc": "Gruppenphase, danach K.-o.-Runden.",
  "club.mode.swiss.title": "Schweizer",
  "club.mode.swiss.desc": "Schweizer System (Runden nach Leistung).",
  "club.mode.swiss.comingSoon": "Demnächst",
  "club.mode.swiss.placeholder":
    "Schweizer System folgt in einer späteren Version.",
  "club.ko.title": "K.-o.-System",
  "club.ko.hint.noByes": "Ohne Freilos: KO-Feldgröße sollte {{n}} entsprechen.",
  "club.ko.bracketSize": "KO-Feldgröße",
  "club.ko.bracket.4": "4er Feld",
  "club.ko.bracket.8": "8er Feld",
  "club.ko.bracket.16": "16er Feld",
  "club.ko.bracket.32": "32er Feld",
  "club.ko.seeding": "Setzliste",
  "club.ko.thirdPlace": "Spiel um Platz 3",
  "club.ko.applySuggestion": "Vorschlag übernehmen: {{n}}",
  "club.ko.error.bracketMustEqualEntrants":
    "Ohne Freilos muss das KO-Feld {{entrants}} Teilnehmer aufnehmen.",
  "club.ko.info.entrants": "Teilnehmer: {{entrants}}",
  "club.groupsko.step.title": "Gruppen & K.O.",
  "club.groupsko.step.hint":
    "Gruppenanzahl, Qualifikation und KO-Feld einstellen.",
  "club.groupsko.groups.title": "Gruppen",
  "club.groupsko.groups.count": "Anzahl Gruppen",
  "club.groupsko.groups.seeding": "Setzliste",
  "club.groupsko.seeding.random": "Zufällig",
  "club.groupsko.seeding.seeded": "Nach Eingabereihenfolge (Setzliste)",
  "club.groupsko.seeding.seededLk": "Nach LK (Setzliste)",
  "club.seeding.noLkHint":
    "Ohne hinterlegte LK wird die Auslosung zufällig durchgeführt.",
  "club.seeding.count": "Anzahl Gesetzte",
  "club.seeding.countOption": "{n} Gesetzte",
  "club.seeding.suggested": "Offizieller Vorschlag (ITF): {n} Gesetzte",
  "club.seeding.applySuggested": "Vorschlag übernehmen ({n})",
  "club.seeding.lkPerPlayer.hint":
    "Optional: LK pro Spieler für Setzliste und faire Gruppeneinteilung.",
  "club.groupsko.qualification.title": "Qualifikation",
  "club.groupsko.qualification.advance": "Weiter pro Gruppe",
  "club.groupsko.qualification.bestThirds": "Beste Dritte",
  "club.groupsko.ko.title": "K.-o.-Phase",
  "club.groupsko.ko.bracketSize": "KO-Feldgröße",
  "club.groupsko.ko.bracket.4": "4er Feld",
  "club.groupsko.ko.bracket.8": "8er Feld",
  "club.groupsko.ko.bracket.16": "16er Feld",
  "club.groupsko.ko.bracket.32": "32er Feld",
  "club.groupsko.ko.thirdPlace": "Spiel um Platz 3",
  "club.groupsko.validation.groupCountMin":
    "Mindestens 2 Gruppen erforderlich.",
  "club.groupsko.validation.advanceMin": "Mindestens 1 Qualifikant pro Gruppe.",
  "club.groupsko.validation.bracketSize":
    "KO-Feldgröße muss 4, 8, 16 oder 32 sein.",
  "club.groupsko.validation.qualifiedExceedsBracket":
    "Qualifizierte ({{qualified}}) dürfen KO-Feld ({{bracket}}) nicht überschreiten.",
  "club.groupsko.validation.advancePerGroupTooHigh":
    "Weiter pro Gruppe darf maximal {{max}} bei {{groupCount}} Gruppen sein.",
  "club.groupsko.error.groupCount": "Bitte mindestens 2 Gruppen wählen.",
  "club.groupsko.error.advancePerGroup":
    "Bitte mindestens 1 Teilnehmer pro Gruppe qualifizieren.",
  "club.groupsko.error.bracketSize":
    "Bitte eine gültige KO-Feldgröße wählen (4/8/16/32).",
  "club.groupsko.error.tooManyQualified":
    "Zu viele Qualifizierte ({{qualified}}) für das KO-Feld ({{bracket}}).",
  "club.groupsko.error.tooManyGroups":
    "Zu viele Gruppen ({{groups}}) für {{entrants}} Teilnehmer.",
  "club.groupsko.error.bracketMustEqualQualified":
    "KO-Feld muss {{qualified}} Qualifizierte aufnehmen (ohne Freilos).",
  "club.groupsko.error.tooManyBestThirds":
    "Beste Dritte darf nicht größer als Gruppenanzahl sein ({{groups}}).",
  "club.groupsko.status.title": "Prüfung",
  "club.groupsko.status.entrants": "Teilnehmer: {{n}}",
  "club.groupsko.status.qualified": "Qualifizierte: {{n}}",
  "club.groupsko.status.bracket": "KO-Feld: {{n}}",
  "club.groupsko.suggested":
    "Vorschlag basierend auf {{n}} Teilnehmern (editierbar).",
  "club.groupsko.info.qualifiedTotal": "Qualifizierte: {{qualified}}",
  "club.groupsko.fix.bracketToQualified": "KO-Feld auf {{qualified}} setzen",
  "club.rules.step.title": "Regeln",
  "club.rules.step.hint": "Spielmodus für Gruppen- und K.-o.-Spiele.",
  "club.rules.title": "Spielregeln",
  "club.rules.scoring.bo3": "Best of 3",
  "club.rules.scoring.bo3.desc": "Standard Einzel: zwei Gewinnsätze.",
  "club.rules.scoring.mtb": "Match-Tiebreak",
  "club.rules.scoring.mtb.desc":
    "Standard Doppel: Satz, Satz, Match-Tiebreak bei 1:1.",
  "club.rules.setEnd.title": "Satzende",
  "club.rules.setEnd.tb": "Tiebreak",
  "club.rules.setEnd.tb.desc": "Bei 6:6 Tiebreak bis 7.",
  "club.rules.setEnd.open": "Open",
  "club.rules.setEnd.open.desc": "Bei 6:6 weiter bis 2 Spiele Vorsprung.",
  "club.matchRules.bo3.title": "Best of 3",
  "club.matchRules.bo3.desc": "Standard Einzel: zwei Gewinnsätze.",
  "club.matchRules.mtb.title": "Match-Tiebreak",
  "club.matchRules.mtb.desc":
    "Standard Doppel: Satz, Satz, Match-Tiebreak bei 1:1.",
  "club.matchRules.oneSet.title": "Ein Satz",
  "club.matchRules.oneSet.desc": "Nur ein Satz pro Match (optional).",
  "club.entry.error.teamsNeedEvenPlayers":
    "Für feste Doppel brauchst du eine gerade Spieleranzahl.",
  "club.entry.error.minEntrants":
    "Bitte mindestens {{count}} Teilnehmer eintragen.",
  "club.entry.sep": ":",
  "club.entry.save": "Speichern",
  "club.entry.team1": "Spieler A",
  "club.entry.team2": "Spieler B",
  "club.entry.error.incompleteSet": "Bitte Satz vollständig eintragen.",
  "club.entry.error.invalidNumber": "Bitte gültige Zahlen eintragen.",
  "club.entry.error.negative": "Keine negativen Werte.",
  "club.entry.error.drawNotAllowed":
    "Unentschieden ist im K.-o. nicht erlaubt.",
  "club.schedule.loading": "Spielplan wird erstellt…",
  "club.schedule.groups": "Gruppen",
  "club.schedule.matches": "Gruppenspiele",
  "club.schedule.ko": "KO-Feldgröße",
  "club.schedule.group.playersCount": "{{count}} Spieler",
  "club.schedule.groupMatches": "Gruppenspiele",
  "club.schedule.qualifiersPreview": "Qualifiziert (Preview)",
  "club.schedule.place": "Platz {{n}}",
  "club.schedule.koMatches": "K.-o.-Spiele",
  "club.schedule.tbd": "offen",
  "club.schedule.koNotReady": "Paarung noch offen.",
  "club.match.vs": "vs",
  "club.match.enterResult": "Ergebnis eintragen",
  "club.match.saved": "Gespeichert",
  "club.match.sets": "Sätze",
  "club.match.games": "Spiele",
  "club.match.confirmed": "Bestätigt",
  "clubmeisterschaft.placeholder": "Turnier-Setup für Clubmeisterschaften.",
  "club.details.step.title": "Details",
  "club.details.step.hint": "Gruppen- oder K.-o.-Konfiguration festlegen.",
  "club.periods.step.title": "Zeiträume",
  "club.periods.step.hint": "Gruppenphase und K.-o.-Phase festlegen.",
  "club.periods.overall.title": "Gesamtzeitraum (optional)",
  "club.periods.groups.title": "Gruppenphase",
  "club.periods.ko.title": "K.-o.-Phase",
  "club.periods.start": "Von",
  "club.periods.end": "Bis",
  "club.periods.error.requiredGroups":
    "Bitte Zeitraum für die Gruppenphase setzen.",
  "club.periods.error.requiredKo": "Bitte Zeitraum für die K.-o.-Phase setzen.",
  "club.periods.error.orderGroups":
    "Gruppenphase: 'Von' muss vor 'Bis' liegen.",
  "club.periods.error.orderKo": "K.-o.-Phase: 'Von' muss vor 'Bis' liegen.",
  "club.periods.error.phasesOrder":
    "K.-o.-Phase muss nach der Gruppenphase starten.",
  "club.periods.error.overallIncomplete":
    "Gesamtzeitraum: bitte 'Von' und 'Bis' setzen.",
  "club.periods.error.overallNotCovering":
    "Gesamtzeitraum muss Gruppen- und K.-o.-Phase abdecken.",
  "mobile.clubmeisterschaft.home.newButton": "Neue Clubmeisterschaft",
  "mobile.clubmeisterschaft.home.statusSetup": "Setup läuft",
  "mobile.clubmeisterschaft.home.statusBuilt": "Spielplan aktiv",
  "mobile.clubmeisterschaft.home.statusFinished": "Abgeschlossen",
  "mobile.clubmeisterschaft.home.confirmDelete":
    "Dieses Turnier wirklich löschen? Spielplan und Ergebnisse gehen verloren.",
  "mobile.clubmeisterschaft.setup.players.addButton": "+ Spieler",
  "mobile.clubmeisterschaft.setup.players.namePlaceholder": "Spieler {{n}}",
  "mobile.clubmeisterschaft.setup.mode.otherModesWeb":
    "Reines K.-o. und Schweizer System sind aktuell nur im Web verfügbar.",
  "mobile.clubmeisterschaft.setup.review.create": "Turnier erstellen",
  "mobile.clubmeisterschaft.setup.review.groups": "{{count}} Gruppen",
  "mobile.clubmeisterschaft.entry.hint":
    "Ergebnisse trägst du direkt im Spielplan ein.",
  "mobile.clubmeisterschaft.entry.openSchedule": "Zum Spielplan",
  "mobile.clubmeisterschaft.finish.champion": "Sieger",
  "mobile.clubmeisterschaft.finish.runnerUp": "Finalist",
  "mobile.clubmeisterschaft.finish.thirdPlace": "Platz 3",
  "mobile.clubmeisterschaft.finish.notReady":
    "Das Turnier ist noch nicht abgeschlossen.",
  "mobile.clubmeisterschaft.finish.backToHome": "Zurück zur Übersicht",
  "trainerstunden.title": "TrainingsDesk",
  "trainerstunden.family.title": "Mein Training",
  "trainerstunden.family.brandEyebrow": "TrainingsDesk",
  "trainerstunden.family.subtitle":
    "Als Erziehungsberechtigter für dein Kind – Termine, Teilnahme, Rechnungen, Zahlungen und Freigaben.",
  "trainerstunden.family.player.title": "Mein Training",
  "trainerstunden.family.player.subtitle":
    "Dein persönlicher Bereich für Trainings beim Verein – Termine, Teilnahme und deine Daten.",
  "trainerstunden.family.childLabel": "Kind / Spieler",
  "trainerstunden.family.childLabelParent": "Kind",
  "trainerstunden.family.childSingle": "Tennis-Training für dein Kind {name}",
  "trainerstunden.family.childContextMany":
    "Tennis-Training für deine Kinder: {names}",
  "trainerstunden.family.headerLeadGeneric":
    "Tennis-Training für dich & deine Familie",
  "trainerstunden.family.backToHub": "Zurück zur Startseite",
  "trainerstunden.family.welcome.title": "Alles rund ums Training im Blick",
  "trainerstunden.family.welcome.subtitle": "So hilft dir diese Seite",
  "trainerstunden.family.welcome.bullet1.title": "Trainings bestätigen",
  "trainerstunden.family.welcome.bullet1.desc":
    "Zu- oder absagen in einem Klick",
  "trainerstunden.family.welcome.bullet2.title": "Rechnungen einsehen",
  "trainerstunden.family.welcome.bullet2.desc": "Monatliche Kosten transparent",
  "trainerstunden.family.welcome.bullet3.title": "Extra-Stunden buchen",
  "trainerstunden.family.welcome.bullet3.desc": "Einzel oder Gruppe auf Abruf",
  "trainerstunden.family.welcome.dismiss": "Verstanden",
  "trainerstunden.family.welcome.dismissAria":
    "Begrüßung schließen und nicht mehr anzeigen",
  "trainerstunden.family.childFilter.all": "Familienansicht",
  "trainerstunden.family.childFilter.aria": "Personen-Filter",
  "trainerstunden.family.childBadge": "{name}",
  "trainerstunden.family.loadError":
    "Daten konnten nicht geladen werden ({reason}).",
  "trainerstunden.family.empty.title": "Noch niemand hinterlegt",
  "trainerstunden.family.empty.hint":
    "Lege unter Kontaktdaten Kinder oder weitere Spieler selbst an – dein Verein muss dafür nichts einrichten.",
  "trainerstunden.parentBooking.confirm.title": "Trainingsanfrage prüfen",
  "trainerstunden.parentBooking.confirm.lead":
    "Ein Spieler hat eine Stunde außerhalb deiner Verfügbarkeit angefragt. Kannst du zu diesem Zeitpunkt trainieren?",
  "trainerstunden.parentBooking.confirm.hintCourt":
    "Bitte prüfe, ob im Club zu diesem Zeitpunkt ein Platz zur Verfügung steht.",
  "trainerstunden.parentBooking.confirm.participants": "Spieler: {names}",
  "trainerstunden.parentBooking.confirm.button": "Anfrage annehmen",
  "trainerstunden.parentBooking.confirm.success": "Buchung bestätigt.",
  "trainerstunden.parentBooking.confirm.error":
    "Bestätigung ist fehlgeschlagen.",
  "trainerstunden.parentBooking.review.title":
    "Offene Trainingsstunden-Anfrage",
  "trainerstunden.parentBooking.review.titleMissed": "Verpasste Chance",
  "trainerstunden.parentBooking.review.lead":
    "Ein Spieler hat eine Trainingsstunde angefragt. Du kannst annehmen, ablehnen oder einen Gegenvorschlag senden.",
  "trainerstunden.parentBooking.review.leadMissed":
    "Die angefragte Stunde ist ohne deine Bestätigung verstrichen. Du kannst sie noch annehmen, ablehnen oder nachbearbeiten – der Hinweis verschwindet nach 24 Stunden.",
  "trainerstunden.parentBooking.review.accept": "Anfrage annehmen",
  "trainerstunden.parentBooking.review.reject": "Anfrage ablehnen",
  "trainerstunden.parentBooking.review.counterToggle": "Gegenvorschlag",
  "trainerstunden.parentBooking.review.counterTitle": "Gegenvorschlag senden",
  "trainerstunden.parentBooking.review.counterDate": "Datum",
  "trainerstunden.parentBooking.review.counterTime": "Uhrzeit",
  "trainerstunden.parentBooking.review.counterDuration": "Dauer (Min.)",
  "trainerstunden.parentBooking.review.counterLocation": "Ort",
  "trainerstunden.parentBooking.review.counterLocationPlaceholder":
    "Ort wählen …",
  "trainerstunden.parentBooking.review.counterNoteLabel":
    "Nachricht an den Spieler (optional)",
  "trainerstunden.parentBooking.review.counterNotePlaceholder":
    "Kurz erklären, warum du Zeit oder Ort anpasst …",
  "trainerstunden.parentBooking.review.counterSubmit": "Gegenvorschlag senden",
  "trainerstunden.parentBooking.review.rejectNoteLabel":
    "Begründung bei Ablehnung (optional)",
  "trainerstunden.parentBooking.review.rejectNotePlaceholder":
    "Optional: kurze Begründung für den Spieler …",
  "trainerstunden.parentBooking.review.successAccepted":
    "Trainingsanfrage bestätigt.",
  "trainerstunden.parentBooking.review.successRejected":
    "Trainingsanfrage abgelehnt.",
  "trainerstunden.parentBooking.review.successCounter":
    "Gegenvorschlag wurde gesendet.",
  "trainerstunden.parentBooking.review.errors.notPending":
    "Diese Anfrage ist nicht mehr offen.",
  "trainerstunden.parentBooking.review.errors.notAllowed":
    "Du darfst diese Anfrage nicht bearbeiten.",
  "trainerstunden.parentBooking.review.errors.invalidLocation":
    "Der gewählte Ort ist ungültig.",
  "trainerstunden.parentBooking.review.errors.migrationRequired":
    "Die Datenbank ist noch nicht aktualisiert (Migration 161/162). Bitte kurz beim Admin melden.",
  "trainerstunden.parentBooking.review.errors.failed":
    "Aktion fehlgeschlagen. Bitte erneut versuchen.",
  "trainerstunden.family.booking.notice.aria": "Hinweise zu Trainingsanfragen",
  "trainerstunden.family.booking.notice.counterTitle":
    "Gegenvorschlag vom Trainer",
  "trainerstunden.family.booking.notice.counterLead":
    "Der Trainer schlägt einen anderen Termin vor. Bitte prüfe Datum, Uhrzeit und Ort.",
  "trainerstunden.family.booking.notice.acceptCounter":
    "Gegenvorschlag annehmen",
  "trainerstunden.family.booking.notice.declineCounter":
    "Gegenvorschlag ablehnen",
  "trainerstunden.family.booking.counterComparison.myRequestLabel":
    "Meine Anfrage:",
  "trainerstunden.family.booking.counterComparison.counterLabel":
    "Gegenvorschlag:",
  "trainerstunden.family.booking.counterComparison.noSnapshot":
    "Der ursprüngliche Wunschtermin ist nicht mehr gespeichert. Bitte prüfe nur den Gegenvorschlag unten.",
  "trainerstunden.family.booking.notice.rejectedTitle":
    "Trainingsanfrage abgelehnt",
  "trainerstunden.family.booking.notice.rejectedLead":
    "Der Trainer hat deine Anfrage abgelehnt.",
  "trainerstunden.family.booking.notice.missedTitle": "Verpasste Chance",
  "trainerstunden.family.booking.notice.missedLead":
    "Die angefragte Stunde ist ohne Bestätigung durch den Trainer verstrichen.",
  "trainerstunden.family.booking.notice.ack": "OK, gelesen",
  "trainerstunden.family.booking.notice.ackFailed":
    "Hinweis konnte nicht quittiert werden.",
  "trainerstunden.family.booking.listRejected.badge": "Anfrage abgelehnt",
  "trainerstunden.family.booking.listRejected.lead":
    "Der Trainer hat diese Trainingsstunden-Anfrage abgelehnt. Bitte bestätigen Sie, dass Sie die Information zur Kenntnis genommen haben.",
  "trainerstunden.family.booking.listRejected.trainer": "Trainer: {name}",
  "trainerstunden.family.booking.status.sectionTitle":
    "Deine Trainingsanfragen",
  "trainerstunden.family.booking.status.sectionBadge": "{count} offen",
  "trainerstunden.family.booking.status.pendingGuardianTitle":
    "Freigabe durch Erziehungsberechtigten",
  "trainerstunden.family.booking.status.pendingTrainerTitle":
    "Freigabe durch Trainer",
  "trainerstunden.family.booking.status.pendingGuardianLead":
    "Deine Anfrage wartet auf die Freigabe durch deinen Erziehungsberechtigten.",
  "trainerstunden.family.booking.status.pendingTrainerLead":
    "Deine Anfrage wartet auf die Bestätigung durch den Trainer.",
  "trainerstunden.family.booking.status.badgeGuardian":
    "Freigabe offen (Erziehungsberechtigter)",
  "trainerstunden.family.booking.status.badgeTrainer":
    "Freigabe offen (Trainer)",
  "trainerstunden.family.booking.status.rejectedTitle":
    "Trainingsanfrage abgelehnt",
  "trainerstunden.family.booking.status.rejectedByGuardianLead":
    "Dein Erziehungsberechtigter hat diese Trainingsanfrage abgelehnt. Bitte bestätige mit OK, dass du die Information zur Kenntnis genommen hast.",
  "trainerstunden.family.booking.status.rejectedByGuardianDeclinerLead":
    "Du hast die Anfrage abgelehnt. Dein Gegenüber erhält eine Information mit der Bitte, dies mit OK zu bestätigen, damit die Information zur Kenntnis genommen wird.",
  "trainerstunden.family.booking.status.rejectedByTrainerLead":
    "Der Trainer hat diese Trainingsanfrage abgelehnt. Bitte bestätige mit OK, dass du die Information zur Kenntnis genommen hast.",
  "trainerstunden.family.booking.status.trainerLine": "Trainer: {name}",
  "trainerstunden.family.booking.status.ack": "OK",
  "trainerstunden.family.sessions.status.pendingStudent":
    "Gegenvorschlag offen",
  "trainerstunden.family.sessions.ownBookingRequest":
    "Du hast diese Trainingsstunde angefragt.",
  "trainerstunden.family.sessions.counterLead":
    "Der Trainer schlägt einen anderen Termin vor. Bitte prüfe Datum, Uhrzeit und Ort.",
  "trainerstunden.family.sessions.counterDeclineHint":
    "Wenn du den Gegenvorschlag ablehnst, ist die Anfrage erledigt. Bei weiterem Interesse bitte eine neue Stunde buchen.",
  "trainerstunden.contactAppInvite.status.none": "Noch nicht in der App",
  "trainerstunden.contactAppInvite.status.registered": "In der App registriert",
  "trainerstunden.contactAppInvite.status.invited": "Einladung versendet",
  "trainerstunden.contactAppInvite.status.invitedAt":
    "Einladung versendet am {date}",
  "trainerstunden.contactAppInvite.status.accepted": "Einladung angenommen",
  "trainerstunden.contactAppInvite.status.acceptedAt":
    "Einladung angenommen am {date}",
  "trainerstunden.contactAppInvite.status.lastLoginAt":
    "Letzter Login am {date}",
  "trainerstunden.contactAppInvite.status.noLoginYet": "Noch kein Login",
  "trainerstunden.contactAppInvite.status.registeredWithAccepted":
    "In der App registriert · Einladung angenommen am {date}",
  "trainerstunden.contactAppInvite.status.registeredWithInvited":
    "In der App registriert · eingeladen am {date}",
  "trainerstunden.contactAppInvite.status.noEmail": "Keine E-Mail hinterlegt",
  "trainerstunden.contactAppInvite.send.cta": "Zur App einladen",
  "trainerstunden.contactAppInvite.send.resendCta": "Einladung erneut senden",
  "trainerstunden.contactAppInvite.send.busy": "Sende Einladung…",
  "trainerstunden.contactAppInvite.send.success":
    "Einladung wurde an {email} gesendet.",
  "trainerstunden.contactAppInvite.send.mockSuccess":
    "Einladung erstellt (Testmodus — keine E-Mail versendet).",
  "trainerstunden.contactAppInvite.send.mockLinkCopied":
    "Einladungslink wurde kopiert. Ohne SMTP kannst du ihn manuell öffnen oder an {email} weiterleiten.",
  "trainerstunden.contactAppInvite.send.mockHint":
    "Testmodus: Es wurde keine E-Mail versendet. Für echten Versand SMTP in server/.env setzen (MAIL_MODE=smtp). Der Link steht im API-Server-Log unter [mail:mock].",
  "trainerstunden.contactAppInvite.errors.alreadyRegistered":
    "Diese Person ist bereits in der App registriert.",
  "trainerstunden.contactAppInvite.errors.missingEmail":
    "Für diesen Kontakt ist keine E-Mail hinterlegt.",
  "trainerstunden.contactAppInvite.errors.missingTenant":
    "Für diesen Kontakt ist kein Verein hinterlegt. Bitte Stammdaten prüfen.",
  "trainerstunden.contactAppInvite.errors.notAuthorized":
    "Du darfst für diesen Kontakt keine Einladung senden.",
  "trainerstunden.contactAppInvite.errors.sessionExpired":
    "Deine Anmeldung ist abgelaufen. Bitte die Seite neu laden, ggf. ab- und wieder anmelden, dann die Einladung erneut senden.",
  "trainerstunden.contactAppInvite.errors.emailMismatch":
    "Bitte mit der eingeladenen E-Mail-Adresse anmelden.",
  "trainerstunden.contactAppInvite.errors.expired":
    "Die Einladung ist abgelaufen. Bitte den Trainer um eine neue Einladung bitten.",
  "trainerstunden.contactAppInvite.errors.notFound":
    "Einladung nicht gefunden.",
  "trainerstunden.contactAppInvite.errors.prepareFailed":
    "Die Einladung konnte nicht vorbereitet werden. Bitte Seite neu laden und erneut versuchen.",
  "trainerstunden.contactAppInvite.errors.mailFailed":
    "Die Einladungs-E-Mail konnte nicht versendet werden. Bitte später erneut versuchen.",
  "trainerstunden.contactAppInvite.errors.authFailed":
    "Der Zugangsaccount konnte nicht angelegt werden. Prüfe, ob die E-Mail bereits registriert ist.",
  "trainerstunden.contactAppInvite.errors.apiUnreachable":
    "API-Server nicht erreichbar. Express-Backend deployen und API_BACKEND_URL in Cloudflare setzen.",
  "trainerstunden.contactAppInvite.errors.pagesMailNotConfigured":
    "Mailversand ist in Cloudflare Pages noch nicht korrekt konfiguriert.",
  "trainerstunden.contactAppInvite.errors.missingSupabaseUrl":
    "Cloudflare: Secret SUPABASE_URL fehlt (z. B. https://….supabase.co).",
  "trainerstunden.contactAppInvite.errors.missingSupabaseAnonKey":
    "Cloudflare: Secret SUPABASE_ANON_KEY fehlt.",
  "trainerstunden.contactAppInvite.errors.missingSupabaseServiceKey":
    "Cloudflare: Secret SUPABASE_SERVICE_ROLE_KEY fehlt.",
  "trainerstunden.contactAppInvite.errors.missingPublicOrigin":
    "Cloudflare: Secret PUBLIC_ORIGIN fehlt (z. B. https://app.tennis-matches.de).",
  "trainerstunden.contactAppInvite.errors.missingSmtpFrom":
    "Cloudflare: Secret SMTP_FROM fehlt (verifizierte Absender-Adresse bei Resend).",
  "trainerstunden.contactAppInvite.errors.sendFailed":
    "Einladung konnte nicht gesendet werden.",
  "trainerstunden.contactAppInvite.accept.title":
    "TrainingsDesk – Einladung annehmen",
  "trainerstunden.contactAppInvite.accept.stepOtp":
    "Schritt 1 von 2: Einmal-Passwort",
  "trainerstunden.contactAppInvite.accept.stepPassword":
    "Schritt 2 von 2: Dein Passwort",
  "trainerstunden.contactAppInvite.accept.lead":
    "Gib das Einmal-Passwort aus der E-Mail ein. Im nächsten Schritt legst du dein persönliches Passwort fest – erst danach ist dein Zugang aktiv.",
  "trainerstunden.contactAppInvite.accept.passwordRequired":
    "Bitte lege zuerst dein persönliches Passwort fest.",
  "trainerstunden.contactAppInvite.accept.missingToken":
    "Einladungslink unvollständig.",
  "trainerstunden.contactAppInvite.accept.notPending":
    "Diese Einladung ist nicht mehr gültig.",
  "trainerstunden.contactAppInvite.accept.emailLabel": "E-Mail",
  "trainerstunden.contactAppInvite.accept.otpLabel": "Einmal-Passwort (OTP)",
  "trainerstunden.contactAppInvite.accept.loginCta": "Anmelden",
  "trainerstunden.contactAppInvite.accept.invalidOtp":
    "Einmal-Passwort ist ungültig.",
  "trainerstunden.contactAppInvite.accept.passwordLead":
    "Lege jetzt dein persönliches Passwort fest. Das Einmal-Passwort aus der E-Mail wird damit ersetzt.",
  "trainerstunden.contactAppInvite.accept.newPasswordLabel": "Neues Passwort",
  "trainerstunden.contactAppInvite.accept.newPasswordConfirmLabel":
    "Passwort bestätigen",
  "trainerstunden.contactAppInvite.accept.passwordTooShort":
    "Das Passwort muss mindestens 8 Zeichen haben.",
  "trainerstunden.contactAppInvite.accept.passwordMismatch":
    "Die Passwörter stimmen nicht überein.",
  "trainerstunden.contactAppInvite.accept.passwordUpdateFailed":
    "Passwort konnte nicht gespeichert werden.",
  "trainerstunden.contactAppInvite.accept.finishCta":
    "Passwort speichern und starten",
  "trainerstunden.deskInvite.lead.contact":
    "Öffne den Einladungslink aus der E-Mail und lege dort dein persönliches Passwort fest. Danach ist dein Zugang zu TrainingsDesk aktiv.",
  "trainerstunden.deskInvite.lead.child":
    "Dein Erziehungsberechtigter hat dich eingeladen. Lege hier dein persönliches Passwort fest, um deine Trainings und Termine einzusehen.",
  "trainerstunden.deskInvite.lead.trainer":
    "Du wurdest als Trainer eingeladen. Lege hier dein persönliches Passwort fest, um TrainingsDesk zu nutzen.",
  "trainerstunden.deskInvite.accept.title":
    "TrainingsDesk – Einladung annehmen",
  "trainerstunden.deskInvite.accept.missingToken":
    "Einladungslink unvollständig.",
  "trainerstunden.deskInvite.accept.notPending":
    "Diese Einladung ist nicht mehr gültig.",
  "trainerstunden.deskInvite.accept.nameLabel": "Name",
  "trainerstunden.deskInvite.accept.emailLabel": "E-Mail",
  "trainerstunden.deskInvite.accept.newPasswordLabel": "Neues Passwort",
  "trainerstunden.deskInvite.accept.newPasswordConfirmLabel":
    "Passwort bestätigen",
  "trainerstunden.deskInvite.accept.passwordTooShort":
    "Das Passwort muss mindestens 8 Zeichen haben.",
  "trainerstunden.deskInvite.accept.passwordMismatch":
    "Die Passwörter stimmen nicht überein.",
  "trainerstunden.deskInvite.accept.finishCta": "Einladung annehmen",
  "trainerstunden.deskInvite.accept.signInFailed":
    "Anmeldung nach Passwort-Setzung fehlgeschlagen. Bitte erneut versuchen.",
  "trainerstunden.deskInvite.errors.notFound": "Einladung nicht gefunden.",
  "trainerstunden.deskInvite.errors.expired":
    "Die Einladung ist abgelaufen. Bitte um eine neue Einladung bitten.",
  "trainerstunden.deskInvite.errors.emailMismatch":
    "Bitte mit der eingeladenen E-Mail-Adresse anmelden.",
  "trainerstunden.deskInvite.errors.authFailed":
    "Der Zugang konnte nicht vorbereitet werden. Bitte erneut versuchen oder den Support kontaktieren.",
  "trainerstunden.deskInvite.errors.failed":
    "Einladung konnte nicht abgeschlossen werden. Bitte erneut versuchen.",
  "trainerstunden.trainerLoginInvite.status.label": "Login-Status",
  "trainerstunden.trainerLoginInvite.status.none":
    "Noch kein Login eingerichtet",
  "trainerstunden.trainerLoginInvite.status.registered": "Login aktiv",
  "trainerstunden.trainerLoginInvite.status.invited": "Einladung versendet",
  "trainerstunden.trainerLoginInvite.status.authProvisioned":
    "Zugang in Auth angelegt – Einladung zum Passwort senden",
  "trainerstunden.trainerLoginInvite.status.noEmail":
    "Keine Login-E-Mail hinterlegt",
  "trainerstunden.trainerLoginInvite.status.lastLoginAt":
    "Letzter Login am {date}",
  "trainerstunden.trainerLoginInvite.status.noLoginYet": "Noch kein Login",
  "trainerstunden.trainerLoginInvite.send.cta": "Zum Login einladen",
  "trainerstunden.trainerLoginInvite.send.resendCta": "Einladung erneut senden",
  "trainerstunden.trainerLoginInvite.send.busy": "Sende Einladung…",
  "trainerstunden.trainerLoginInvite.send.success":
    "Login-Einladung wurde an {email} gesendet.",
  "trainerstunden.trainerLoginInvite.errors.alreadyRegistered":
    "Dieser Trainer hat bereits einen aktiven Login.",
  "trainerstunden.trainerLoginInvite.errors.missingEmail":
    "Für diesen Trainer ist keine Login-E-Mail hinterlegt.",
  "trainerstunden.trainerLoginInvite.errors.notAuthorized":
    "Du darfst für diesen Trainer keine Einladung senden.",
  "trainerstunden.trainerLoginInvite.errors.sessionExpired":
    "Deine Anmeldung ist abgelaufen. Bitte die Seite neu laden, ggf. ab- und wieder anmelden, dann die Einladung erneut senden.",
  "trainerstunden.trainerLoginInvite.errors.emailMismatch":
    "Bitte mit der eingeladenen E-Mail-Adresse anmelden.",
  "trainerstunden.trainerLoginInvite.errors.expired":
    "Die Einladung ist abgelaufen. Bitte den Koordinator um eine neue Einladung bitten.",
  "trainerstunden.trainerLoginInvite.errors.notFound":
    "Einladung nicht gefunden.",
  "trainerstunden.trainerLoginInvite.errors.notApplicable":
    "Für diesen Eintrag ist keine Login-Einladung vorgesehen.",
  "trainerstunden.trainerLoginInvite.errors.missingTenant":
    "Für diesen Trainer ist kein Verein (Tenant) hinterlegt. Bitte Trainer speichern oder den Support kontaktieren.",
  "trainerstunden.trainerLoginInvite.errors.prepareFailed":
    "Die Einladung konnte nicht vorbereitet werden. Bitte Seite neu laden und erneut versuchen.",
  "trainerstunden.trainerLoginInvite.errors.mailFailed":
    "Die Einladungs-E-Mail konnte nicht versendet werden. Bitte später erneut versuchen.",
  "trainerstunden.trainerLoginInvite.errors.authFailed":
    "Der Zugang konnte nicht für die Einladung vorbereitet werden. Bitte erneut versuchen oder den Support kontaktieren.",
  "trainerstunden.trainerLoginInvite.errors.trainerNotFound":
    "Trainer-Datensatz nicht gefunden. Bitte Seite neu laden.",
  "trainerstunden.trainerLoginInvite.errors.notAuthenticated":
    "Du bist nicht angemeldet. Bitte erneut anmelden und es noch einmal versuchen.",
  "trainerstunden.trainerLoginInvite.errors.serverConfig":
    "Server-Konfiguration unvollständig. Bitte den Support kontaktieren.",
  "trainerstunden.trainerLoginInvite.errors.apiUnreachable":
    "API-Server nicht erreichbar. Express-Backend deployen und API_BACKEND_URL in Cloudflare setzen.",
  "trainerstunden.trainerLoginInvite.errors.pagesMailNotConfigured":
    "Mailversand ist in Cloudflare Pages noch nicht korrekt konfiguriert.",
  "trainerstunden.trainerLoginInvite.errors.missingSupabaseUrl":
    "Cloudflare: Secret SUPABASE_URL fehlt (z. B. https://….supabase.co).",
  "trainerstunden.trainerLoginInvite.errors.missingSupabaseAnonKey":
    "Cloudflare: Secret SUPABASE_ANON_KEY fehlt.",
  "trainerstunden.trainerLoginInvite.errors.missingSupabaseServiceKey":
    "Cloudflare: Secret SUPABASE_SERVICE_ROLE_KEY fehlt.",
  "trainerstunden.trainerLoginInvite.errors.missingPublicOrigin":
    "Cloudflare: Secret PUBLIC_ORIGIN fehlt (z. B. https://app.tennis-matches.de).",
  "trainerstunden.trainerLoginInvite.errors.missingSmtpFrom":
    "Cloudflare: Secret SMTP_FROM fehlt (verifizierte Absender-Adresse bei Resend).",
  "trainerstunden.trainerLoginInvite.errors.sendFailed":
    "Login-Einladung konnte nicht gesendet werden.",
  "trainerstunden.trainerLoginInvite.accept.title":
    "TrainingsDesk – Trainer-Zugang einrichten",
  "trainerstunden.trainerLoginInvite.accept.lead":
    "Melde dich mit deiner E-Mail und dem Einmal-Passwort aus der Einladungsmail an. Anschließend legst du dein persönliches Passwort fest.",
  "trainerstunden.trainerLoginInvite.accept.missingToken":
    "Einladungslink unvollständig.",
  "trainerstunden.trainerLoginInvite.accept.notPending":
    "Diese Einladung ist nicht mehr gültig.",
  "trainerstunden.trainerLoginInvite.accept.emailLabel": "E-Mail",
  "trainerstunden.trainerLoginInvite.accept.otpLabel": "Einmal-Passwort (OTP)",
  "trainerstunden.trainerLoginInvite.accept.loginCta": "Anmelden",
  "trainerstunden.trainerLoginInvite.accept.invalidOtp":
    "Einmal-Passwort ist ungültig.",
  "trainerstunden.trainerLoginInvite.accept.passwordLead":
    "Lege jetzt dein persönliches Passwort fest. Das Einmal-Passwort aus der E-Mail wird damit ersetzt.",
  "trainerstunden.trainerLoginInvite.accept.newPasswordLabel": "Neues Passwort",
  "trainerstunden.trainerLoginInvite.accept.newPasswordConfirmLabel":
    "Passwort bestätigen",
  "trainerstunden.trainerLoginInvite.accept.passwordTooShort":
    "Das Passwort muss mindestens 8 Zeichen haben.",
  "trainerstunden.trainerLoginInvite.accept.passwordMismatch":
    "Die Passwörter stimmen nicht überein.",
  "trainerstunden.trainerLoginInvite.accept.passwordUpdateFailed":
    "Passwort konnte nicht gespeichert werden.",
  "trainerstunden.trainerLoginInvite.accept.finishCta":
    "Passwort speichern und TrainingsDesk öffnen",
  "trainerstunden.family.futureFeatures":
    "Terminabsagen folgen in einer späteren Version.",
  "trainerstunden.family.booking.openCta":
    "Zusätzliche Tennistrainerstunde buchen",
  "trainerstunden.family.booking.openCtaChild":
    "Zusätzliche Tennistrainerstunde für {name} buchen",
  "trainerstunden.family.selfBookingBudget.sectionTitle":
    "Eigenständig buchen (Freibetrag)",
  "trainerstunden.family.selfBookingBudget.profileCardTitle":
    "Freibetrag für eigenständige Buchungen",
  "trainerstunden.family.selfBookingBudget.profileCardLead":
    "Lege pro Kind fest, bis zu welchem Betrag es zusätzliche Trainingsstunden ohne deine Freigabe anfragen darf. Diese Einstellung gilt für alle Kinder gleichermaßen und kann jederzeit angepasst werden.",
  "trainerstunden.family.selfBookingBudget.badgeSummary":
    "{remaining} € verfügbar",
  "trainerstunden.family.selfBookingBudget.badgeSummaryMany": "{count} Kinder",
  "trainerstunden.family.selfBookingBudget.sectionLead":
    "Lege pro Kind fest, bis zu welchem Betrag es zusätzliche Trainingsstunden ohne deine Freigabe anfragen darf. Ohne Eintrag oder bei 0 € gilt jede kostenpflichtige Anfrage als freigabepflichtig.",
  "trainerstunden.family.selfBookingBudget.budgetLabel": "Freibetrag pro Kind",
  "trainerstunden.family.selfBookingBudget.spentRemaining":
    "Verbraucht: {spent} € · Verfügbar: {remaining} €",
  "trainerstunden.family.selfBookingBudget.zeroHint":
    "Freibetrag 0 €: Jede Anfrage mit Kosten erscheint zuerst bei dir zur Freigabe, danach beim Trainer.",
  "trainerstunden.family.selfBookingBudget.saved": "Freibetrag gespeichert.",
  "trainerstunden.family.selfBookingBudget.errors.failed":
    "Freibetrag konnte nicht gespeichert werden.",
  "trainerstunden.family.selfBookingBudget.errors.guardianNotAllowed":
    "Du darfst den Freibetrag für dieses Kind nicht ändern.",
  "trainerstunden.family.selfBookingBudget.errors.childNotFound":
    "Kind nicht gefunden.",
  "trainerstunden.family.selfBookingBudget.errors.missingChild":
    "Kein Kind ausgewählt.",
  "trainerstunden.family.guardianPending.sectionTitle":
    "Offene Freigaben für Trainingsanfragen",
  "trainerstunden.family.guardianPending.sectionLead":
    "Diese Anfragen warten auf deine Freigabe. Danach gehen sie an den Trainer. Liegt der Termin in der Vergangenheit, werden sie automatisch geschlossen und erscheinen in der Historie.",
  "trainerstunden.family.guardianPending.cardTitle": "Freigabe erforderlich",
  "trainerstunden.family.guardianPending.badgeRequest": "Anfrage",
  "trainerstunden.family.guardianPending.childLine": "{name}",
  "trainerstunden.family.guardianPending.trainerLine":
    "Trainer {name} · ca. {amount} €",
  "trainerstunden.family.guardianPending.reasonAge": "Grund: Minderjährigkeit",
  "trainerstunden.family.guardianPending.reasonBudget":
    "Grund: Freibetrag überschritten oder 0 €",
  "trainerstunden.family.guardianPending.reasonAgeAndBudget":
    "Grund: Minderjährigkeit und Freibetrag",
  "trainerstunden.family.guardianPending.approveCta": "Freigabe erteilen",
  "trainerstunden.family.guardianPending.declineCta": "Ablehnen",
  "trainerstunden.family.guardianPending.declineSuccess":
    "Du hast die Anfrage abgelehnt. Dein Gegenüber erhält eine Information mit der Bitte, dies mit OK zu bestätigen, damit die Information zur Kenntnis genommen wird.",
  "trainerstunden.family.guardianPending.declineConfirm":
    "Trainingsanfrage von {name} wirklich ablehnen? Der Termin wird nicht gebucht.",
  "trainerstunden.family.booking.errors.partialFailed":
    "{failed} von {total} Buchungen sind fehlgeschlagen. Die übrigen Termine wurden angelegt.",
  "trainerstunden.family.booking.errors.guardianPortalRequired":
    "Für diese Buchung ist ein Erziehungsberechtigter mit Elternportal-Zugang erforderlich.",
  "trainerstunden.family.sessions.status.approvalExpired": "Freigabe verfallen",
  "trainerstunden.family.booking.forChild": "Die Stunde gilt für {name}.",
  "trainerstunden.family.booking.title": "Training buchen",
  "trainerstunden.family.booking.lead":
    "Wähle Trainer, Datum und Uhrzeit. Der Trainer bestätigt Anfragen außerhalb seiner Verfügbarkeit.",
  "trainerstunden.family.booking.leadParent":
    "Wähle, für wen die Stunde gilt, sowie Trainer, Datum und Uhrzeit. Der Trainer bestätigt Anfragen außerhalb seiner Verfügbarkeit.",
  "trainerstunden.family.booking.fieldParticipant": "Für wen",
  "trainerstunden.family.booking.participantSelf": "Für mich ({name})",
  "trainerstunden.family.booking.participantAllChildren":
    "Für alle Kinder ({count})",
  "trainerstunden.family.booking.fieldChild": "Spieler",
  "trainerstunden.family.booking.fieldTrainer": "Trainer",
  "trainerstunden.family.booking.fieldDate": "Datum",
  "trainerstunden.family.booking.fieldTime": "Uhrzeit",
  "trainerstunden.family.booking.fieldDuration": "Dauer",
  "trainerstunden.family.booking.noTrainers": "Kein Trainer verfügbar",
  "trainerstunden.family.booking.rateHint":
    "Stundensatz (Einzel): {rate} € / Std.",
  "trainerstunden.family.booking.rateMissing":
    "Für diesen Trainer ist kein Stundensatz hinterlegt. Bitte wende dich an den Verein.",
  "trainerstunden.family.booking.outsideAvailabilityHint":
    "Dieser Termin liegt außerhalb der hinterlegten Trainer-Verfügbarkeit. Der Trainer muss die Anfrage bestätigen.",
  "trainerstunden.family.booking.submit": "Anfrage senden",
  "trainerstunden.family.booking.submitBook": "Stunden buchen",
  "trainerstunden.family.booking.submitRequest": "Trainingsstunde anfragen",
  "trainerstunden.family.booking.guardianApprovalFooterHint":
    "Bei Minderjährigen kann eine Freigabe durch einen Erziehungsberechtigten erforderlich sein.",
  "trainerstunden.family.booking.offlineGuardianConsentHint":
    "Für deinen Erziehungsberechtigten ist noch kein eigener Portal-Zugang hinterlegt. Hole die Zustimmung außerhalb des Portals ein und bestätige sie unten.",
  "trainerstunden.family.booking.offlineGuardianConsentLabel":
    "Ich bestätige, dass ich die Zustimmung meiner Erziehungsberechtigten für diese Trainingsbuchung eingeholt habe.",
  "trainerstunden.family.booking.offlineGuardianProfileCta":
    "Erziehungsberechtigten in Meine Daten pflegen",
  "trainerstunden.family.billingRecipient.title":
    "Wer bezahlt die Trainingsrechnungen?",
  "trainerstunden.family.billingRecipient.lead":
    "Bevor es mit den Buchungen weitergeht, brauchen wir eine kurze Angabe, wer als Rechnungsempfänger hinterlegt wird. Trainer und Trainingskoordinator prüfen die Angabe.",
  "trainerstunden.family.billingRecipient.choiceLegend": "Zahlung durch",
  "trainerstunden.family.billingRecipient.choiceParentsTitle":
    "Meine Eltern / Erziehungsberechtigten",
  "trainerstunden.family.billingRecipient.choiceParentsTitleGuardian":
    "Ich als Erziehungsberechtigter",
  "trainerstunden.family.billingRecipient.choiceParentsHint":
    "Die Rechnungen gehen an den hinterlegten Erziehungsberechtigten.",
  "trainerstunden.family.billingRecipient.choiceParentsHintGuardian":
    "Die Rechnungen gehen an mich als hinterlegten Rechnungsempfänger.",
  "trainerstunden.family.billingRecipient.choiceSelfTitle": "Ich selbst",
  "trainerstunden.family.billingRecipient.choiceSelfTitleGuardian":
    "{name} selbst",
  "trainerstunden.family.billingRecipient.choiceSelfHint":
    "Nur sinnvoll, wenn du die Rechnungen selbst bezahlst (z. B. als Auszubildende:r). Der Verein prüft das.",
  "trainerstunden.family.billingRecipient.choiceSelfHintGuardian":
    "Nur sinnvoll, wenn {name} die Rechnungen selbst bezahlt (z. B. als Auszubildende:r). Der Verein prüft das.",
  "trainerstunden.family.billingRecipient.parentsConsentLabel":
    "Ich bestätige, dass meine Erziehungsberechtigten als Rechnungsempfänger eingetragen werden dürfen.",
  "trainerstunden.family.billingRecipient.parentsConsentLabelGuardian":
    "Ich bestätige, dass ich als Erziehungsberechtigter für {name} Rechnungsempfänger bin.",
  "trainerstunden.family.billingRecipient.selfFieldsLead":
    "Bitte ergänze deine Kontaktdaten für {name} – sie werden für Rechnungen benötigt.",
  "trainerstunden.family.billingRecipient.selfFieldsLeadGuardian":
    "Bitte ergänze die Kontaktdaten von {name} – sie werden für Rechnungen an {name} benötigt.",
  "trainerstunden.family.billingRecipient.selfFieldsComplete":
    "Die Kontaktdaten von {name} sind vollständig — du kannst die Zahlungsart speichern.",
  "trainerstunden.family.billingRecipient.selfFieldsIncomplete":
    "Bitte Telefon oder E-Mail sowie vollständige Adresse angeben.",
  "trainerstunden.family.billingRecipient.submit": "Speichern",
  "trainerstunden.family.billingRecipient.reviewFooterNote":
    "Trainer und Trainingskoordinator erhalten eine Aufmerksamkeitsnotiz und geben die Angabe frei.",
  "trainerstunden.family.billingRecipient.successSubmitted":
    "Danke – deine Angabe wurde gesendet und wird geprüft.",
  "trainerstunden.family.billingRecipient.successSubmittedGuardian":
    "Danke – die Angabe für {name} wurde gesendet und wird geprüft.",
  "trainerstunden.family.billingRecipient.pendingTitle": "Angabe wird geprüft",
  "trainerstunden.family.billingRecipient.pendingParents":
    "Die Zahlung durch deine Eltern wurde gemeldet. Trainer und Trainingskoordinator prüfen die Angabe.",
  "trainerstunden.family.billingRecipient.pendingParentsGuardian":
    "Die Zahlung durch dich als Erziehungsberechtigten wurde gemeldet. Trainer und Trainingskoordinator prüfen die Angabe.",
  "trainerstunden.family.billingRecipient.pendingSelf":
    "Deine Selbstzahlung wurde gemeldet. Trainer und Trainingskoordinator prüfen, ob die Angabe plausibel ist.",
  "trainerstunden.family.billingRecipient.pendingSelfGuardian":
    "Die Selbstzahlung durch {name} wurde gemeldet. Trainer und Trainingskoordinator prüfen die Angabe.",
  "trainerstunden.family.billingRecipient.errors.notMinor":
    "Diese Angabe ist nur für Minderjährige vorgesehen.",
  "trainerstunden.family.billingRecipient.errors.alreadyPending":
    "Es wird bereits eine Angabe geprüft.",
  "trainerstunden.family.billingRecipient.errors.parentsConsentRequired":
    "Bitte bestätige die Einwilligung deiner Eltern.",
  "trainerstunden.family.billingRecipient.errors.parentsConsentRequiredGuardian":
    "Bitte bestätige, dass du als Erziehungsberechtigter Rechnungsempfänger bist.",
  "trainerstunden.family.billingRecipient.errors.profileIncomplete":
    "Bitte ergänze zuerst alle erforderlichen Kontaktdaten.",
  "trainerstunden.family.billingRecipient.errors.guardianMissing":
    "Bitte lege zuerst einen Erziehungsberechtigten in Meine Daten an.",
  "trainerstunden.family.billingRecipient.errors.saveFailed":
    "Die Angabe konnte nicht gespeichert werden.",
  "trainerstunden.family.billingRecipient.errors.notPending":
    "Es liegt keine ausstehende Angabe mehr vor.",
  "trainerstunden.family.billingRecipient.errors.guardianRequired":
    "Nur Erziehungsberechtigte können diese Angabe zurückziehen.",
  "trainerstunden.family.billingRecipient.errors.withdrawFailed":
    "Die Angabe konnte nicht zurückgezogen werden. Bitte später erneut versuchen oder den Support kontaktieren.",
  "trainerstunden.family.billingRecipient.errors.rpcMissing":
    "Diese Funktion ist auf der Datenbank noch nicht verfügbar. Bitte die neuesten Migrationen anwenden (supabase db push) und die Seite neu laden.",
  "trainerstunden.family.billingRecipient.withdrawCta": "Angabe zurückziehen",
  "trainerstunden.family.billingRecipient.withdrawConfirm":
    "Möchtest du die gemeldete Selbstzahlung zurückziehen? Danach kannst du die Einstellung erneut vornehmen.",
  "trainerstunden.family.billingRecipient.withdrawSuccess":
    "Die Angabe wurde zurückgezogen.",
  "trainerstunden.family.dependents.sectionTitle": "Familienmitglieder",
  "trainerstunden.family.dependents.sectionLead":
    "Lege Kinder oder andere Familienmitglieder an oder verknüpfe ein bestehendes Familienmitglied, das bereits im Verein registriert ist.",
  "trainerstunden.family.dependents.createTitle":
    "Neues Familienmitglied anlegen",
  "trainerstunden.family.dependents.createLead":
    "Die Person wird mit deinem Zugang verknüpft. Ab 14 Jahren ist eine E-Mail Pflicht – sie darf im Verein noch nicht vergeben sein.",
  "trainerstunden.family.dependents.linkTitle":
    "Bestehendes Familienmitglied verknüpfen",
  "trainerstunden.family.dependents.linkLead":
    "Wenn ein Familienmitglied bereits einen Vereins-Zugang hat, kann es die Verknüpfung in seinem Spieler-Portal bestätigen.",
  "trainerstunden.family.dependents.fieldRelation": "Bezug zu dir",
  "trainerstunden.family.dependents.relation.child": "Kind",
  "trainerstunden.family.dependents.relation.partner": "Partner / Ehepartner",
  "trainerstunden.family.dependents.relation.grandmother": "Großmutter (Oma)",
  "trainerstunden.family.dependents.relation.grandfather": "Großvater (Opa)",
  "trainerstunden.family.dependents.relation.family": "Familienmitglied",
  "trainerstunden.family.dependents.relation.friend": "Freund / Bekannter",
  "trainerstunden.family.dependents.relation.clubColleague":
    "Vereinskollege / Kollegin",
  "trainerstunden.family.dependents.fieldFirstName": "Vorname",
  "trainerstunden.family.dependents.fieldLastName": "Nachname",
  "trainerstunden.family.dependents.fieldBirthDate": "Geburtsdatum",
  "trainerstunden.family.dependents.fieldEmail": "E-Mail (optional)",
  "trainerstunden.family.dependents.fieldEmailRequired":
    "E-Mail (Pflicht ab 14 Jahren)",
  "trainerstunden.family.dependents.emailRequiredHint":
    "Für Personen ab 14 Jahren ist eine E-Mail nötig, damit sie sich später anmelden können. Die Adresse darf in diesem Verein noch nicht vergeben sein.",
  "trainerstunden.family.dependents.adultEmailRequiredHint":
    "Für Partner, Oma oder Opa ist eine E-Mail nötig — damit die Person ihr eigenes Profil nutzen kann. Die Adresse darf in diesem Verein noch nicht vergeben sein.",
  "trainerstunden.family.dependents.fieldLinkEmail":
    "E-Mail des Familienmitglieds im Verein",
  "trainerstunden.family.dependents.createCta": "Familienmitglied anlegen",
  "trainerstunden.family.dependents.linkCta": "Anfrage senden",
  "trainerstunden.family.dependents.defaultPersonLabel": "Person",
  "trainerstunden.family.dependents.createSuccess":
    "{name} wurde angelegt und erscheint in deinem Profil.",
  "trainerstunden.family.dependents.linkRequestSuccess":
    "Die Verknüpfungsanfrage wurde an {email} gesendet. Sobald die Person zustimmt, erscheint sie in deinem Profil.",
  "trainerstunden.family.dependents.errors.missingName":
    "Bitte Vor- und Nachname angeben.",
  "trainerstunden.family.dependents.errors.invalidEmail":
    "Bitte eine gültige E-Mail-Adresse angeben.",
  "trainerstunden.family.dependents.errors.emailRequired":
    "Für Personen ab 14 Jahren ist eine E-Mail-Adresse erforderlich.",
  "trainerstunden.family.dependents.errors.emailInTenant":
    "Diese E-Mail ist in deinem Verein bereits vergeben. Bitte eine andere Adresse verwenden oder die Person verknüpfen.",
  "trainerstunden.family.dependents.errors.linkRequestPending":
    "Es wartet bereits eine Verknüpfungsanfrage auf die Bestätigung dieser Person.",
  "trainerstunden.family.dependents.errors.notAllowed":
    "Familienmitglieder können gerade nicht angelegt werden. Bitte speichere zuerst deine Kontaktdaten oben.",
  "trainerstunden.family.dependents.errors.relationNotAllowed":
    "Hier können nur Kinder oder andere Familienmitglieder angelegt werden.",
  "trainerstunden.family.dependents.errors.tenantMissing":
    "Kein Vereinskontext gefunden. Bitte Support kontaktieren.",
  "trainerstunden.family.dependents.errors.failed":
    "Die Aktion konnte nicht ausgeführt werden.",
  "trainerstunden.family.guardianLink.sectionTitle": "Verknüpfungsanfragen",
  "trainerstunden.family.guardianLink.sectionLead":
    "Jemand möchte sich mit deinem Spieler-Zugang verknüpfen. Du entscheidest, ob das erlaubt ist.",
  "trainerstunden.family.guardianLink.cardTitle": "Anfrage von {name}",
  "trainerstunden.family.guardianLink.cardHint":
    "Nach deiner Zustimmung kann die Person deine Trainings und Rechnungen in ihrem Portal mitverwalten (je nach Rolle und Freigaben).",
  "trainerstunden.family.guardianLink.approveCta": "Zustimmen",
  "trainerstunden.family.guardianLink.declineCta": "Ablehnen",
  "trainerstunden.family.guardianLink.declineSuccess":
    "Du hast die Anfrage abgelehnt. Dein Gegenüber erhält eine Information mit der Bitte, dies mit OK zu bestätigen, damit die Information zur Kenntnis genommen wird.",
  "trainerstunden.family.guardianLink.declineConfirm":
    "Verknüpfungsanfrage von {name} wirklich ablehnen?",
  "trainerstunden.family.guardianLink.errors.notPending":
    "Diese Anfrage ist nicht mehr offen.",
  "trainerstunden.family.guardianLink.errors.notFound":
    "Anfrage nicht gefunden.",
  "trainerstunden.family.guardianLink.errors.notTargetUser":
    "Du bist nicht die Zielperson dieser Anfrage.",
  "trainerstunden.family.guardianLink.errors.failed":
    "Die Anfrage konnte nicht verarbeitet werden.",
  "trainerstunden.family.minorInvoiceReadAccess.title": "Rechnungen für {name}",
  "trainerstunden.family.minorInvoiceReadAccess.lead":
    "Mit App-Zugang (E-Mail) sieht dein Kind offene Rechnungen automatisch – nur lesen, ohne Zahlung. Du kannst das jederzeit wieder ausschalten.",
  "trainerstunden.family.minorInvoiceReadAccess.toggleLabel":
    "{name} darf Rechnungen einsehen (nur lesen)",
  "trainerstunden.family.minorInvoiceReadAccess.enabledHint":
    "Das Kind sieht im Portal den Tab „Rechnungen“ mit PDF und Details. Zahlungen bleiben bei dir.",
  "trainerstunden.family.minorInvoiceReadAccess.autoGrantedHint":
    "Aktiv, weil {name} einen App-Zugang (E-Mail) hat. Du kannst die Anzeige jederzeit deaktivieren.",
  "trainerstunden.family.minorInvoiceReadAccess.disabledHint":
    "Standard für Minderjährige: keine Rechnungen im eigenen Portal.",
  "trainerstunden.family.minorInvoiceReadAccess.errors.notMinor":
    "Der Lesezugriff gilt nur für Minderjährige.",
  "trainerstunden.family.minorInvoiceReadAccess.errors.guardianRequired":
    "Nur der hinterlegte Erziehungsberechtigte kann diese Einstellung ändern.",
  "trainerstunden.family.minorInvoiceReadAccess.errors.saveFailed":
    "Die Einstellung konnte nicht gespeichert werden.",
  "trainerstunden.family.sessionReminder24h.titleSelf": "Termin-Erinnerungen",
  "trainerstunden.family.sessionReminder24h.title":
    "Termin-Erinnerungen für dich",
  "trainerstunden.family.sessionReminder24h.titleChild":
    "Termin-Erinnerungen für {name}",
  "trainerstunden.family.sessionReminder24h.lead":
    "Etwa 24 Stunden vor dem Training schicken wir eine Erinnerung per E-Mail an die hinterlegte Adresse.",
  "trainerstunden.family.sessionReminder24h.toggleLabelSelf":
    "24h-Erinnerung per E-Mail erhalten",
  "trainerstunden.family.sessionReminder24h.toggleLabel":
    "24h-Erinnerung per E-Mail erhalten",
  "trainerstunden.family.sessionReminder24h.toggleLabelChild":
    "24h-Erinnerung für {name} per E-Mail erhalten",
  "trainerstunden.family.sessionReminder24h.enabledHint":
    "Erinnerungen sind aktiv. Du kannst sie jederzeit ausschalten.",
  "trainerstunden.family.sessionReminder24h.disabledHint":
    "Für diese Person werden keine 24h-Erinnerungen versendet.",
  "trainerstunden.family.sessionReminder24h.errors.notAllowed":
    "Du darfst diese Einstellung nicht ändern.",
  "trainerstunden.family.sessionReminder24h.errors.personNotFound":
    "Person nicht gefunden.",
  "trainerstunden.family.sessionReminder24h.errors.saveFailed":
    "Die Einstellung konnte nicht gespeichert werden.",
  "trainerstunden.family.invoices.readOnlyNotice":
    "Du siehst diese Rechnungen nur zur Information. Bezahlen und reklamieren können deine Eltern.",
  "trainerstunden.billingRecipient.review.queueTitle":
    "Rechnungsempfänger prüfen",
  "trainerstunden.billingRecipient.review.playerLine": "Spieler: {name}",
  "trainerstunden.billingRecipient.review.title": "Rechnungsempfänger prüfen",
  "trainerstunden.billingRecipient.review.lead":
    "Ein minderjähriger Spieler hat angegeben, wer Trainingsrechnungen bezahlt. Bitte prüfen und freigeben.",
  "trainerstunden.billingRecipient.review.payerParents":
    "Zahlung durch Eltern / Erziehungsberechtigte",
  "trainerstunden.billingRecipient.review.payerSelf":
    "Zahlung durch Spieler selbst",
  "trainerstunden.billingRecipient.review.approve": "Angabe bestätigen",
  "trainerstunden.billingRecipient.review.reject": "Ablehnen",
  "trainerstunden.billingRecipient.review.done": "Erledigt",
  "trainerstunden.billingRecipient.review.errors.failed":
    "Freigabe konnte nicht gespeichert werden.",
  "trainerstunden.family.booking.successConfirmed": "Training wurde gebucht.",
  "trainerstunden.family.booking.successConfirmedMultiple":
    "Trainings wurden für {count} Personen gebucht.",
  "trainerstunden.family.booking.successPending":
    "Anfrage gesendet – der Trainer muss den Termin noch bestätigen.",
  "trainerstunden.family.booking.successPendingMultiple":
    "Anfragen gesendet ({count}) – der Trainer muss die Termine noch bestätigen.",
  "trainerstunden.family.booking.errors.overlap":
    "Zu dieser Zeit ist bereits ein Training gebucht.",
  "trainerstunden.family.booking.errors.overlapAtSlot":
    "Zu {slot} ist bereits ein Training für dich eingeplant.",
  "trainerstunden.family.booking.errors.overlapOwn":
    "Du hast für {slot} bereits eine Trainingsanfrage gestellt.",
  "trainerstunden.family.booking.errors.overlapOwnPendingGuardian":
    "Für {slot} wartet bereits deine Trainingsanfrage auf Freigabe durch einen Erziehungsberechtigten – eine zweite Buchung ist nicht nötig.",
  "trainerstunden.family.booking.errors.overlapOwnPendingTrainer":
    "Für {slot} wartet bereits deine Trainingsanfrage auf Bestätigung durch den Trainer.",
  "trainerstunden.family.booking.errors.past":
    "Trainings in der Vergangenheit können nur vom Trainer angelegt werden.",
  "trainerstunden.family.booking.errors.notAllowed":
    "Du darfst für dieses Kind keine Trainings buchen.",
  "trainerstunden.family.booking.errors.trainerNotFound":
    "Der gewählte Trainer ist nicht verfügbar.",
  "trainerstunden.family.booking.errors.invalidRate":
    "Es ist kein gültiger Stundensatz hinterlegt.",
  "trainerstunden.family.booking.errors.validation":
    "Bitte alle Pflichtfelder ausfüllen.",
  "trainerstunden.family.booking.errors.saveFailed":
    "Buchung konnte nicht gespeichert werden.",
  "trainerstunden.family.booking.withdraw.aria":
    "Trainings-Anfrage zurückziehen",
  "trainerstunden.family.booking.withdraw.cta": "Anfrage zurückziehen",
  "trainerstunden.family.booking.withdraw.ctaCompact": "Zurückziehen",
  "trainerstunden.family.booking.withdraw.confirm":
    "Diese Trainings-Anfrage wirklich zurückziehen? Der Termin entfällt dann.",
  "trainerstunden.family.booking.withdraw.hintPending":
    "Diese Anfrage wartet auf Bestätigung durch den Trainer. Du kannst sie jederzeit zurückziehen.",
  "trainerstunden.family.booking.withdraw.hintConfirmed":
    "Du hast dieses Training selbst gebucht. Solange es noch nicht stattgefunden hat, kannst du die Buchung zurückziehen.",
  "trainerstunden.family.booking.withdraw.errors.failed":
    "Anfrage konnte nicht zurückgezogen werden.",
  "trainerstunden.family.booking.withdraw.errors.notOwner":
    "Du kannst nur eigene Anfragen zurückziehen.",
  "trainerstunden.family.booking.withdraw.errors.alreadyConfirmed":
    "Dieses Training wurde bereits durchgeführt.",
  "trainerstunden.family.booking.withdraw.errors.alreadyWithdrawn":
    "Diese Anfrage wurde bereits zurückgezogen.",
  "trainerstunden.family.booking.withdraw.errors.notFound":
    "Termin nicht gefunden.",
  "trainerstunden.booking.ageMissing.title": "Geburtsdatum fehlt",
  "trainerstunden.booking.ageMissing.description":
    "Für Buchungen benötigen wir dein Geburtsdatum. Ergänze diese Angabe in deinen Kontaktdaten.",
  "trainerstunden.booking.ageMissing.descriptionParent":
    "Für Buchungen benötigen wir das Geburtsdatum von {name}. Ergänze die Angabe im Abschnitt „Daten für {name}“ unter Meine Daten.",
  "trainerstunden.booking.ageMissing.cta": "Kontaktdaten ergänzen",
  "trainerstunden.booking.ageMissing.ctaParent": "Kind-Daten öffnen",
  "trainerstunden.family.booking.adultConfirmationHint":
    "Ohne hinterlegtes Geburtsdatum oder Eltern-Kind-Beziehung bestätigst du hier, dass du volljährig bist. Der Verein kann die Angabe vor Ort prüfen.",
  "trainerstunden.family.booking.adultConfirmationLabel":
    "Ich bin volljährig (18 Jahre oder älter).",
  "trainerstunden.booking.guardianMissing.title":
    "Erziehungsberechtigter fehlt",
  "trainerstunden.booking.guardianMissing.description":
    "Für minderjährige Teilnehmer muss ein Erziehungsberechtigter hinterlegt sein, bevor eine Buchung angefragt werden kann.",
  "trainerstunden.booking.guardianMissing.cta":
    "Erziehungsberechtigten ergänzen",
  "trainerstunden.booking.guardianApprovalRequired.title":
    "Freigabe erforderlich",
  "trainerstunden.booking.guardianApprovalRequired.description":
    "Diese Trainingsanfrage wartet auf die Freigabe durch einen Erziehungsberechtigten.",
  "trainerstunden.booking.guardianApprovalRequired.cta": "Freigabe erteilen",
  "trainerstunden.booking.requestGuardianApproval": "Freigabe anfragen",
  "trainerstunden.booking.pendingGuardianApproval":
    "Wartet auf Freigabe durch Erziehungsberechtigten",
  "trainerstunden.booking.pendingGuardianApprovalBudget":
    "Anfrage gesendet – Freigabe durch Erziehungsberechtigten nötig (Freibetrag überschritten).",
  "trainerstunden.booking.pendingGuardianApprovalAgeAndBudget":
    "Anfrage gesendet – Freigabe durch Erziehungsberechtigten nötig (Alter und Freibetrag).",
  "trainerstunden.booking.guardianApprovalRequired.descriptionBudget":
    "Der Freibetrag für eigenständige Buchungen ist aufgebraucht oder 0 €. Bitte gib die Trainingsanfrage frei.",
  "trainerstunden.booking.guardianApprovalRequired.descriptionAgeAndBudget":
    "Minderjährigkeit und Freibetrag erfordern deine Freigabe, bevor der Trainer die Anfrage sieht.",
  "trainerstunden.booking.pendingTrainerApproval":
    "Wartet auf Bestätigung durch Trainer",
  "trainerstunden.booking.errors.ageUnknown":
    "Bitte ergänze dein Geburtsdatum in den Kontaktdaten, bevor eine Buchung möglich ist.",
  "trainerstunden.booking.errors.guardianMissing":
    "Für minderjährige Teilnehmer muss ein Erziehungsberechtigter hinterlegt sein.",
  "trainerstunden.booking.errors.offlineConsentRequired":
    "Bitte bestätige, dass die Zustimmung deiner Erziehungsberechtigten vorliegt.",
  "trainerstunden.booking.guardianApproval.errors.notAllowed":
    "Du bist nicht als Erziehungsberechtigter für diese Anfrage hinterlegt.",
  "trainerstunden.booking.guardianApproval.errors.notPending":
    "Diese Anfrage wartet nicht mehr auf eine Freigabe.",
  "trainerstunden.booking.guardianApproval.errors.failed":
    "Freigabe konnte nicht gespeichert werden.",
  "trainerstunden.family.sessions.status.pendingTrainer": "Wartet auf Trainer",
  "trainerstunden.family.sessionUntitled": "Tennis-Training",
  "trainerstunden.family.sessionDuration": "{min} Min.",
  "trainerstunden.family.tabs.aria": "Elternbereich",
  "trainerstunden.family.tabs.hub": "Übersicht",
  "trainerstunden.family.tabs.hubPlayer": "Übersicht über dein Tennis-Training",
  "trainerstunden.family.tabs.sessions": "Trainings",
  "trainerstunden.family.tabs.messages": "Nachrichten",
  "trainerstunden.family.tabs.more": "Mehr",
  "trainerstunden.family.tabs.profile": "Profil",
  "trainerstunden.family.tabs.invoices": "Rechnungen",
  "trainerstunden.family.tabs.payments": "Zahlungen",
  "trainerstunden.family.tabs.invoicesPayments": "Rechnungen & Zahlungen",
  "trainerstunden.family.profileCard.loggedInAs": "Angemeldet als",
  "trainerstunden.family.profileCard.parentAccount": "Elternkonto",
  "trainerstunden.family.profileCard.aria":
    "Angemeldet als {name}, Elternkonto",
  "trainerstunden.family.childFilter.myChildren": "Meine Kinder",
  "trainerstunden.family.childFilter.add": "Kind",
  "trainerstunden.family.childFilter.addAria": "Kind hinzufügen",
  "trainerstunden.family.messages.title": "Nachrichten",
  "trainerstunden.family.messages.empty": "Keine neuen Nachrichten",
  "trainerstunden.family.messages.hint":
    "Hinweise zu Trainings und Freigaben erscheinen hier.",
  "trainerstunden.family.hub.openTasks.title": "Offene Aufgaben",
  "trainerstunden.family.hub.openTasks.none": "Keine offenen Aufgaben",
  "trainerstunden.family.hub.openTasks.pendingBookings":
    "{count, plural, one {# Buchungsfreigabe wartet} other {# Buchungsfreigaben warten}}",
  "trainerstunden.family.hub.openTasks.guardianLinks":
    "{count, plural, one {# Verknüpfungsanfrage} other {# Verknüpfungsanfragen}}",
  "trainerstunden.family.hub.openTasks.awaitingRsvp":
    "Rückmeldung zum Training ausstehend",
  "trainerstunden.family.hub.openTasks.invoiceWaiting": "Rechnung wartet",
  "trainerstunden.family.hub.invoiceCard.title": "Rechnungen",
  "trainerstunden.family.hub.invoiceCard.empty": "Noch keine Rechnungen",
  "trainerstunden.family.hub.invoiceCard.due": "Fällig am {date}",
  "trainerstunden.family.hub.invoiceCard.link": "Rechnung ansehen",
  "trainerstunden.family.hub.invoiceCard.periodFallback": "Aktuelle Rechnung",
  "trainerstunden.family.profile.title": "Profil",
  "trainerstunden.family.profile.lead":
    "Verwalte deine Daten und die deines Kindes.",
  "trainerstunden.family.profile.emptyHint":
    "Trag hier deine Kontaktdaten ein und lege unten Kinder oder weitere Spieler selbst an.",
  "trainerstunden.family.profile.legalGuardian.sectionTitle":
    "Erziehungsberechtigter",
  "trainerstunden.family.profile.legalGuardian.sectionLead":
    "Dein hinterlegter Erziehungsberechtigter bzw. Rechnungsempfänger im Verein.",
  "trainerstunden.family.profile.legalGuardian.relation":
    "Erziehungsberechtigter / Rechnungsempfänger",
  "trainerstunden.family.profile.legalGuardian.empty":
    "Im Verein ist noch kein Erziehungsberechtigter hinterlegt.",
  "trainerstunden.family.profile.legalGuardian.unknownName":
    "Erziehungsberechtigter",
  "trainerstunden.family.profile.fieldPerson": "Person",
  "trainerstunden.family.profile.forPerson": "Daten für {name}",
  "trainerstunden.family.profile.fieldFirstName": "Vorname",
  "trainerstunden.family.profile.fieldLastName": "Nachname",
  "trainerstunden.family.profile.fieldEmail": "E-Mail",
  "trainerstunden.family.profile.emailLockedHint":
    "Deine E-Mail-Adresse wird vom Verein verwaltet.",
  "trainerstunden.family.profile.fieldPhone": "Telefon",
  "trainerstunden.family.profile.phonePlaceholder": "+49 …",
  "trainerstunden.family.profile.fieldBirthDate": "Geburtsdatum",
  "trainerstunden.family.profile.birthHint":
    "Das Geburtsdatum wird für Altersfreigaben bei Buchungen benötigt. Der Jahrgang wird automatisch abgeleitet.",
  "trainerstunden.family.profile.birthHintOptional":
    "Optional — nur für Altersfreigaben bei Buchungen nötig.",
  "trainerstunden.family.profile.birthHintChildRequired":
    "Das Geburtsdatum hilft dem Verein bei Trainings- und Altersfreigaben.",
  "trainerstunden.family.profile.birthHintGuardian":
    "Für Altersfreigaben bei deinen eigenen Buchungen von Trainingsstunden.",
  "trainerstunden.family.profile.fieldCountry": "Land",
  "trainerstunden.family.profile.useGuardianAddress":
    "Meine Adressedaten auf mein Kind übertragen",
  "trainerstunden.family.profile.useGuardianAddressHint":
    "Straße, Hausnummer, PLZ, Ort und Land werden von deinen Daten übernommen.",
  "trainerstunden.family.profile.useGuardianAddressDisabled":
    "Bitte zuerst deine Adresse oben speichern, damit sie übernommen werden kann.",
  "trainerstunden.family.profile.criticalApprovalHint":
    "Änderungen am Geburtsdatum werden bei hinterlegter Erziehungsbeziehung erst nach Freigabe durch einen Erziehungsberechtigten wirksam.",
  "trainerstunden.family.profile.savePendingCritical":
    "Andere Angaben wurden gespeichert. Das Geburtsdatum wartet auf Freigabe durch einen Erziehungsberechtigten.",
  "trainerstunden.family.profile.approval.pendingTitle": "Freigabe ausstehend",
  "trainerstunden.family.profile.approval.pendingDescription":
    "Die vorgeschlagene Änderung am Geburtsdatum ist noch nicht aktiv. Ein Erziehungsberechtigter muss sie bestätigen.",
  "trainerstunden.family.profile.approval.approveCta": "Freigabe erteilen",
  "trainerstunden.family.profile.approval.withdrawCta": "Anfrage zurückziehen",
  "trainerstunden.family.profile.approval.approvedSuccess":
    "Geburtsangaben wurden freigegeben und gespeichert.",
  "trainerstunden.family.profile.approval.errors.notAllowed":
    "Du bist nicht als Erziehungsberechtigter für diese Freigabe hinterlegt.",
  "trainerstunden.family.profile.approval.errors.notPending":
    "Diese Anfrage wartet nicht mehr auf Freigabe.",
  "trainerstunden.family.profile.approval.errors.notFound":
    "Anfrage nicht gefunden.",
  "trainerstunden.family.profile.approval.errors.withdrawNotAllowed":
    "Du darfst diese Anfrage nicht zurückziehen.",
  "trainerstunden.family.profile.approval.errors.failed":
    "Freigabe konnte nicht verarbeitet werden.",
  "trainerstunden.family.profile.billingSectionTitle": "Trainingsrechnungen",
  "trainerstunden.family.profile.billingSectionTitleForChild":
    "Trainingsrechnungen für {name}",
  "trainerstunden.family.profile.billingSectionLead":
    "Wer soll die Trainingsrechnungen erhalten?",
  "trainerstunden.family.profile.billingSectionLeadForChild":
    "Wer soll die Trainingsrechnungen für {name} erhalten?",
  "trainerstunden.family.profile.billingRecipient.summaryParents":
    "Die Trainingsrechnungen werden von deinen Eltern bzw. Erziehungsberechtigten bezahlt (laut Vereinsdaten).",
  "trainerstunden.family.profile.billingRecipient.summaryParentsGuardian":
    "Die Trainingsrechnungen von {name} gehen an dich als Erziehungsberechtigten (Rechnungsempfänger).",
  "trainerstunden.family.profile.billingRecipient.summarySelf":
    "Die Trainingsrechnungen werden von dir selbst bezahlt.",
  "trainerstunden.family.profile.billingRecipient.summarySelfGuardian":
    "Die Trainingsrechnungen von {name} werden von {name} selbst bezahlt.",
  "trainerstunden.family.profile.billingRecipient.change": "Zahlungsart ändern",
  "trainerstunden.family.profile.addressTitle": "Adresse",
  "trainerstunden.family.profile.fieldStreet": "Straße",
  "trainerstunden.family.profile.fieldHouseNumber": "Nr.",
  "trainerstunden.family.profile.fieldPostalCode": "PLZ",
  "trainerstunden.family.profile.fieldCity": "Ort",
  "trainerstunden.family.profile.save": "Speichern",
  "trainerstunden.family.profile.saveSuccess":
    "Kontaktdaten wurden gespeichert.",
  "trainerstunden.family.profile.auditHint":
    "Jede Änderung wird mit Zeitpunkt und Benutzer gespeichert.",
  "trainerstunden.family.profile.pageFooter":
    "Trainer und Trainingskoordinator erhalten eine Aufmerksamkeitsnotiz und geben die Angabe frei. Jede Änderung wird mit Zeitpunkt und Benutzer protokolliert.",
  "trainerstunden.family.profile.errors.notAllowed":
    "Du darfst diese Kontaktdaten nicht bearbeiten.",
  "trainerstunden.family.profile.errors.viewerNotFound":
    "Dein Profil konnte nicht geladen werden. Bitte erneut speichern oder den Verein kontaktieren.",
  "trainerstunden.family.profile.errors.notFound":
    "Kontaktdatensatz nicht gefunden.",
  "trainerstunden.family.profile.errors.emailLocked":
    "Die E-Mail-Adresse kann hier nicht geändert werden.",
  "trainerstunden.family.profile.errors.invalidBirthDate":
    "Bitte ein gültiges Geburtsdatum eingeben.",
  "trainerstunden.family.profile.errors.invalidBirthYear":
    "Bitte einen gültigen Jahrgang eingeben.",
  "trainerstunden.family.profile.errors.validation":
    "Bitte alle Pflichtfelder prüfen.",
  "trainerstunden.family.profile.errors.saveFailed":
    "Speichern fehlgeschlagen.",
  "trainerstunden.family.profile.errors.profileRpcUnavailable":
    "Einige Kontaktdaten konnten nicht vollständig geladen werden. Basisdaten wurden übernommen — bei fehlenden Feldern bitte den Verein kontaktieren.",
  "trainerstunden.family.profile.sectionParent": "Profil",
  "trainerstunden.family.profile.sectionSelf": "Meine Daten",
  "trainerstunden.family.profile.sectionChild": "Kindprofil",
  "trainerstunden.family.profile.roleParent": "Profil",
  "trainerstunden.family.members.sectionTitle": "Weitere Familienmitglieder",
  "trainerstunden.family.members.sectionLead":
    "Partner, Oma oder Opa — ohne eigenes Kindprofil im Trainingskonto.",
  "trainerstunden.family.profile.roleChild": "Kindprofil",
  "trainerstunden.family.profile.role.partner": "Partnerprofil",
  "trainerstunden.family.profile.role.grandmother": "Großmutter",
  "trainerstunden.family.profile.role.grandfather": "Großvater",
  "trainerstunden.family.profile.namedProfile": "{role} · {name}",
  "trainerstunden.family.profile.pageInfo":
    "Hier pflegst du die persönlichen Daten, die {clubName} für Trainings und Buchungen nutzt.",
  "trainerstunden.family.profile.clubFallback": "dein Verein",
  "trainerstunden.family.profile.badgeGuardian": "Elternteil",
  "trainerstunden.family.profile.badgeChild": "Kind",
  "trainerstunden.family.profile.guardianIntro":
    "Dein Elternprofil: {clubName} nutzt diese Angaben für Kommunikation und Rechnungen.",
  "trainerstunden.family.profile.childIntro":
    "Kindprofil von {name}: Diese Angaben werden für Trainings und Altersfreigaben genutzt.",
  "trainerstunden.family.profile.selfIntro":
    "Diese Angaben nutzt {clubName} für deine Trainings, Buchungen und Rechnungen.",
  "trainerstunden.family.profile.saveDone": "Gespeichert",
  "trainerstunden.family.profile.merge.title": "Unterschiedliche Einträge",
  "trainerstunden.family.profile.merge.lead":
    "Bei mehreren Trainern liegen teils abweichende Stammdaten vor. Wähle pro Feld die gültige Angabe für dein Portal.",
  "trainerstunden.family.profile.merge.optionGroup": "Quelle für {field}",
  "trainerstunden.family.profile.merge.syncLinked":
    "Gewählte Korrekturen auch auf alle verknüpften Trainer-Einträge übernehmen",
  "trainerstunden.family.profile.sharing.title": "Datenfreigabe im Verein",
  "trainerstunden.family.profile.sharing.lead":
    "Standardmäßig sind deine Kontaktdaten nur für den jeweiligen Trainer sichtbar. Du kannst sie tenant-weit für andere Trainer freigeben.",
  "trainerstunden.family.profile.sharing.optionGroup":
    "Sichtbarkeit für {label}",
  "trainerstunden.family.profile.sharing.private": "Nur Trainer",
  "trainerstunden.family.profile.sharing.tenant_public": "Im Verein",
  "trainerstunden.family.profile.audit.open": "Änderungen",
  "trainerstunden.family.profile.audit.title": "Änderungsprotokoll",
  "trainerstunden.family.profile.audit.subtitle":
    "Alle Änderungen an deinen Daten",
  "trainerstunden.family.profile.audit.filterAria": "Protokoll filtern",
  "trainerstunden.family.profile.audit.filterAll": "Alle",
  "trainerstunden.family.profile.audit.filterMine": "Meine",
  "trainerstunden.family.profile.audit.filterChild": "Kindprofil",
  "trainerstunden.family.profile.audit.empty":
    "Noch keine protokollierten Änderungen.",
  "trainerstunden.family.profile.audit.footer":
    "Du hast das Recht, alle Änderungen an deinen Daten einzusehen. Fragen? Kontaktiere deinen Verein.",
  "trainerstunden.family.profile.audit.entityParent": "Profil · {name}",
  "trainerstunden.family.profile.audit.entityChild": "Kindprofil · {name}",
  "trainerstunden.family.profile.audit.entityUnknown": "Unbekannte Person",
  "trainerstunden.family.profile.audit.errors.unavailable":
    "Das Änderungsprotokoll ist derzeit nicht verfügbar.",
  "trainerstunden.family.profile.audit.errors.loadFailed":
    "Das Änderungsprotokoll konnte nicht geladen werden.",
  "trainerstunden.family.profile.audit.field.first_name": "Vorname",
  "trainerstunden.family.profile.audit.field.last_name": "Nachname",
  "trainerstunden.family.profile.audit.field.email": "E-Mail",
  "trainerstunden.family.profile.audit.field.phone": "Telefon",
  "trainerstunden.family.profile.audit.field.birth_date": "Geburtsdatum",
  "trainerstunden.family.profile.audit.field.birth_year": "Jahrgang",
  "trainerstunden.family.profile.audit.field.street": "Straße",
  "trainerstunden.family.profile.audit.field.house_number": "Hausnummer",
  "trainerstunden.family.profile.audit.field.postal_code": "PLZ",
  "trainerstunden.family.profile.audit.field.city": "Ort",
  "trainerstunden.family.profile.audit.field.country": "Land",
  "trainerstunden.family.profile.audit.field.legal_guardian_person_id":
    "Erziehungsberechtigter",
  "trainerstunden.family.profile.audit.field.invoice_recipient_type":
    "Rechnungsempfänger",
  "trainerstunden.family.profile.audit.field.billing_contact_id":
    "Rechnungskontakt",
  "trainerstunden.family.childInvite.title": "Kind einladen",
  "trainerstunden.family.childInvite.titleForChild":
    "Spieler-Portal für {name}",
  "trainerstunden.family.childInvite.lead":
    "Gib die E-Mail-Adresse deines Kindes ein. Wenn es im Verein hinterlegt ist, wird es mit deinem Zugang verknüpft und erhält eine Einladung zum Spieler-Portal.",
  "trainerstunden.family.childInvite.readyLead":
    "Für {name} ist die E-Mail {email} hinterlegt. Mit „Einladung senden“ erhält dein Kind Zugang zum Spieler-Portal.",
  "trainerstunden.family.childInvite.pendingLead":
    "Die Einladung an {email} wurde versendet. Dein Kind muss sie noch annehmen.",
  "trainerstunden.family.childInvite.pendingStatus":
    "Die Einladung an {email} wurde noch nicht angenommen.",
  "trainerstunden.family.childInvite.awaitingLoginLead":
    "{name} hat Zugang zum Spieler-Portal, sich aber noch nicht angemeldet.",
  "trainerstunden.family.childInvite.awaitingLoginStatus":
    "{name} war noch nicht im Spieler-Portal eingeloggt. Du kannst eine Erinnerung mit neuem Einmal-Passwort senden.",
  "trainerstunden.family.childInvite.portalMetaActive":
    "Portal aktiv · letzter Login: {lastLogin}",
  "trainerstunden.family.childInvite.portalMetaAwaitingLogin":
    "Login-Konto angelegt · Einladung: {inviteDate} · noch kein Login",
  "trainerstunden.family.childInvite.portalMetaNever": "noch nie",
  "trainerstunden.family.childInvite.fieldEmail": "E-Mail des Kindes",
  "trainerstunden.family.childInvite.emailPlaceholder": "kind@email.de",
  "trainerstunden.family.childInvite.submit": "Einladung senden",
  "trainerstunden.family.childInvite.nudge": "Erinnerung senden",
  "trainerstunden.family.childInvite.success":
    "Die Einladung wurde an {email} gesendet. Dein Kind kann sich mit der E-Mail und dem Einmal-Passwort aus der Nachricht anmelden.",
  "trainerstunden.family.childInvite.nudgeSuccess":
    "Die Erinnerung wurde erneut an {email} gesendet.",
  "trainerstunden.family.childInvite.errors.invalidEmail":
    "Bitte eine gültige E-Mail-Adresse eingeben.",
  "trainerstunden.family.childInvite.errors.notAllowed":
    "Du bist nicht als Erziehungsberechtigter angemeldet.",
  "trainerstunden.family.childInvite.errors.billingMissing":
    "Dein Rechnungsempfänger-Profil fehlt. Bitte wende dich an deinen Verein.",
  "trainerstunden.family.childInvite.errors.notFound":
    "Unter dieser E-Mail ist kein Kind in deinem Verein hinterlegt. Bitte den Verein kontaktieren oder die E-Mail prüfen.",
  "trainerstunden.family.childInvite.errors.childEmailMissing":
    "Dem Kind ist im Verein noch keine E-Mail hinterlegt. Bitte den Verein kontaktieren.",
  "trainerstunden.family.childInvite.errors.alreadyLinked":
    "Dieses Kind ist bereits mit deinem Eltern-Zugang verknüpft.",
  "trainerstunden.family.childInvite.errors.alreadyLinkedOther":
    "Dieses Kind ist bereits einem anderen Rechnungsempfänger zugeordnet. Bitte den Verein kontaktieren.",
  "trainerstunden.family.childInvite.errors.alreadyRegistered":
    "Zu dieser E-Mail gibt es bereits einen Portal-Zugang.",
  "trainerstunden.family.childInvite.errors.unavailable":
    "Einladungen sind derzeit nicht verfügbar.",
  "trainerstunden.family.childInvite.errors.failed":
    "Die Einladung konnte nicht gesendet werden.",
  "trainerstunden.family.kpi.upcoming": "Anstehend",
  "trainerstunden.family.hub.attendanceStatTitle": "Deine Trainingsbilanz",
  "trainerstunden.family.hub.attendanceStatTitleChild":
    "Trainingsbilanz für {name}",
  "trainerstunden.family.hub.attendanceStatTitleAll":
    "Trainingsbilanz (alle Kinder)",
  "trainerstunden.family.hub.attendanceStatLabel":
    "{count} bestätigte Trainings",
  "trainerstunden.family.hub.attendanceStatLabelAll":
    "{count} bestätigte Trainings (alle Kinder)",
  "trainerstunden.family.hub.attendanceStatLabelChild":
    "{count} bestätigte Trainings für {name}",
  "trainerstunden.family.hub.attendanceStatUnit": "bestätigte Trainings",
  "trainerstunden.family.hub.attendanceStatHint":
    "Nur Termine, bei denen der Trainer deine Anwesenheit bestätigt hat. Weitere Auszeichnungen folgen.",
  "trainerstunden.family.hub.attendanceStatHintParent":
    "Nur Termine, bei denen der Trainer die Anwesenheit deines Kindes bestätigt hat. Weitere Auszeichnungen folgen.",
  "trainerstunden.family.hub.upcomingStatTitle": "Noch geplante Trainings",
  "trainerstunden.family.hub.upcomingStatTitleChild":
    "Noch geplante Trainings für {name}",
  "trainerstunden.family.hub.upcomingStatTitleAll":
    "Noch geplante Trainings (alle Kinder)",
  "trainerstunden.family.hub.upcomingStatMonth": "Dieser Monat",
  "trainerstunden.family.hub.upcomingStatSeasonSummer":
    "Diese Sommersaison (Mai–Sep)",
  "trainerstunden.family.hub.upcomingStatSeasonWinter":
    "Diese Wintersaison (Okt–Apr)",
  "trainerstunden.family.hub.upcomingStatHint":
    "Anstehende Termine aus deiner Trainingsplanung — ohne abgeschlossene Stunden.",
  "trainerstunden.family.hub.upcomingTitle": "Kommende Trainings",
  "trainerstunden.family.hub.upcomingTitleChild":
    "Kommende Trainings für {name}",
  "trainerstunden.family.hub.upcomingTitleAll":
    "Kommende Trainings (alle Kinder)",
  "trainerstunden.family.hub.upcomingListTitle": "Kommende Trainings",
  "trainerstunden.family.hub.sessionsView.switchAria":
    "Darstellung der Termine",
  "trainerstunden.family.hub.sessionsView.list": "Liste",
  "trainerstunden.family.hub.sessionsView.calendar": "Kalender",
  "trainerstunden.family.hub.sessionsView.prevMonth": "Vorheriger Monat",
  "trainerstunden.family.hub.sessionsView.nextMonth": "Nächster Monat",
  "trainerstunden.family.hub.sessionsView.calendarAria": "Kalender {month}",
  "trainerstunden.family.hub.sessionsView.dayWithSessionsAria":
    "{date}: {count} Trainings",
  "trainerstunden.family.hub.sessionsView.dayEmptyAria":
    "{date}: keine Trainings",
  "trainerstunden.family.hub.sessionsView.dayEmpty":
    "An diesem Tag kein geplantes Training.",
  "trainerstunden.family.hub.sessionsView.weekday.0": "Mo",
  "trainerstunden.family.hub.sessionsView.weekday.1": "Di",
  "trainerstunden.family.hub.sessionsView.weekday.2": "Mi",
  "trainerstunden.family.hub.sessionsView.weekday.3": "Do",
  "trainerstunden.family.hub.sessionsView.weekday.4": "Fr",
  "trainerstunden.family.hub.sessionsView.weekday.5": "Sa",
  "trainerstunden.family.hub.sessionsView.weekday.6": "So",
  "trainerstunden.family.hub.upcomingListTitleChild":
    "Kommende Trainings für {name}",
  "trainerstunden.family.hub.upcomingListTitleAll":
    "Kommende Trainings (alle Kinder)",
  "trainerstunden.family.hub.noUpcoming": "Keine anstehenden Trainings.",
  "trainerstunden.family.hub.viewAllSessions": "Alle Termine anzeigen",
  "trainerstunden.family.hub.loadMoreUpcoming": "{count} weitere Termine",
  "trainerstunden.family.hub.showAllUpcoming": "Alle Termine",
  "trainerstunden.family.hub.hero.title": "Nächstes Training",
  "trainerstunden.family.hub.hero.badgeToday": "Heute",
  "trainerstunden.family.hub.hero.time": "{time} Uhr",
  "trainerstunden.family.hub.hero.confirm": "Teilnahme bestätigen",
  "trainerstunden.family.hub.hero.confirmParent": "Teilnahme bestätigen",
  "trainerstunden.family.hub.hero.confirmAttending": "Du bist eingeplant",
  "trainerstunden.family.hub.hero.confirmAttendingParent":
    "{name} ist eingeplant",
  "trainerstunden.family.hub.hero.decline": "Teilnahme absagen",
  "trainerstunden.family.hub.hero.declineParent": "Teilnahme absagen",
  "trainerstunden.family.hub.hero.statusPlanned": "Du bist eingeplant",
  "trainerstunden.family.hub.hero.statusPlannedParent": "{name} ist eingeplant",
  "trainerstunden.family.hub.hero.statusAttending": "Du bist eingeplant",
  "trainerstunden.family.hub.hero.statusAttendingParent":
    "{name} ist eingeplant",
  "trainerstunden.family.hub.hero.statusNeedsResponse":
    "Deine Rückmeldung fehlt noch",
  "trainerstunden.family.hub.hero.statusNeedsResponseParent":
    "Rückmeldung für {name} fehlt noch",
  "trainerstunden.family.hub.hero.statusDeclined": "Du nimmst nicht teil",
  "trainerstunden.family.hub.hero.statusDeclinedParent":
    "{name} nimmt nicht teil",
  "trainerstunden.family.hub.hero.statusWaiting": "Rückmeldung beim Verein",
  "trainerstunden.family.hub.hero.statusPendingGuardian":
    "Freigabe durch Erziehungsberechtigten offen",
  "trainerstunden.family.hub.hero.statusPendingTrainer":
    "Freigabe durch Trainer offen",
  "trainerstunden.family.hub.hero.hintPendingGuardian":
    "Deine Trainingsanfrage wurde gesendet. Ein Erziehungsberechtigter muss sie noch freigeben, bevor der Trainer sie sieht.",
  "trainerstunden.family.hub.hero.hintPendingTrainer":
    "Deine Anfrage wartet auf die Bestätigung durch den Trainer. Du bist noch nicht fest eingeplant.",
  "trainerstunden.family.hub.hero.hintAllSet":
    "Du musst aktuell nichts weiter tun.",
  "trainerstunden.family.hub.hero.hintNeedsResponse":
    "Bitte kurz Teilnahme bestätigen oder absagen — damit der Trainer planen kann.",
  "trainerstunden.family.hub.hero.hintDeclined":
    "Das Training findet statt. Du kannst deine Teilnahme noch ändern, solange der Termin offen ist.",
  "trainerstunden.family.hub.hero.hintWaiting":
    "Der Verein meldet sich, sobald es Neuigkeiten gibt.",
  "trainerstunden.family.hub.hero.noUpcoming":
    "Aktuell steht kein Training an.",
  "trainerstunden.family.hub.hero.noUpcomingPlayer":
    "Und wann nimmst du dein nächstes Training? Frag deinen Trainer oder buche direkt die nächste Stunde.",
  "trainerstunden.family.hub.hero.noUpcomingChild":
    "Und wann geht {name} wieder auf den Platz? Die nächste Stunde ist nur einen Klick entfernt.",
  "trainerstunden.family.hub.hero.noUpcomingFamily":
    "Noch kein Training in der Familienansicht – wie wäre es mit der nächsten Stunde?",
  "trainerstunden.family.hub.summary.financeTitle": "Aktueller Stand",
  "trainerstunden.family.hub.summary.financeClear": "Keine offenen Rechnungen",
  "trainerstunden.family.hub.summary.financeClearHint":
    "Alles ist erledigt. Weiter so!",
  "trainerstunden.family.hub.summary.financeOpenCount":
    "{count} offene Rechnung(en)",
  "trainerstunden.family.hub.summary.financeOpenGeneric":
    "Offener Betrag fällig",
  "trainerstunden.family.hub.summary.financeLink": "Zahlungsstand anzeigen",
  "trainerstunden.family.hub.summary.monthTitle": "Diesen Monat",
  "trainerstunden.family.hub.summary.monthTrainings": "{count} Trainings",
  "trainerstunden.family.hub.summary.monthCost":
    "Prognose für offene Trainings: ca. {amount}",
  "trainerstunden.family.hub.summary.monthCostUnknown":
    "Kosten werden nach den Terminen berechnet",
  "trainerstunden.family.hub.summary.monthLink": "Alle Termine anzeigen",
  "trainerstunden.family.hub.badge.planned": "Eingeplant",
  "trainerstunden.family.hub.badge.confirmed": "Bestätigt",
  "trainerstunden.family.hub.badge.awaiting": "Wartet auf Rückmeldung",
  "trainerstunden.family.hub.badge.declined": "Nicht dabei",
  "trainerstunden.family.hub.badge.waiting": "In Klärung",
  "trainerstunden.family.hub.badge.pendingGuardian": "Freigabe offen",
  "trainerstunden.family.hub.quick.invoicesTitle": "Rechnungen",
  "trainerstunden.family.hub.quick.invoicesClear": "Keine offenen Rechnungen",
  "trainerstunden.family.hub.quick.invoicesLink": "Rechnungen anzeigen",
  "trainerstunden.family.hub.quick.historyTitle": "Trainingsverlauf",
  "trainerstunden.family.hub.quick.historyText":
    "{count} Trainings bereits absolviert",
  "trainerstunden.family.hub.quick.historyLink": "Zum Verlauf",
  "trainerstunden.family.hub.pastShowAll":
    "Alle {count} vergangenen Trainings anzeigen",
  "trainerstunden.family.hub.invoicesTitle": "Offene Rechnungen",
  "trainerstunden.family.hub.noOpenInvoices": "Keine offenen Rechnungen.",
  "trainerstunden.family.hub.viewInvoices": "Rechnungen anzeigen",
  "trainerstunden.family.hub.viewPayments": "Zahlungsstand anzeigen",
  "trainerstunden.family.hub.kpiOpen": "Offener Betrag",
  "trainerstunden.family.hub.kpiPaid": "Bereits gezahlt",
  "trainerstunden.family.hub.kpiAccrued": "Aufgelaufene Kosten",
  "trainerstunden.family.hub.kpiPrepared": "Noch nicht freigegeben",
  "trainerstunden.family.hub.kpiOpenInvoices": "Offene Rechnungen",
  "trainerstunden.family.hub.finance.title": "Kosten & Zahlungen",
  "trainerstunden.family.hub.finance.openInvoices": "Offene Rechnungen",
  "trainerstunden.family.hub.finance.openInvoicesCount":
    "{count} Rechnung(en) offen",
  "trainerstunden.family.hub.finance.openInvoicesAction": "Rechnungen anzeigen",
  "trainerstunden.family.hub.finance.noneOpen": "Keine offenen Rechnungen",
  "trainerstunden.family.hub.finance.openPayments": "Offene Zahlungen",
  "trainerstunden.family.hub.finance.openPaymentsHint":
    "Noch zu zahlender Betrag auf versendeten Rechnungen",
  "trainerstunden.family.hub.finance.paidHint":
    "Summe bereits beglichener Rechnungen",
  "trainerstunden.family.hub.finance.paidHintCalendarYear":
    "Beglichene Rechnungen im Kalenderjahr {year}",
  "trainerstunden.family.hub.finance.uninvoicedTraining":
    "Noch nicht in Rechnung",
  "trainerstunden.family.hub.finance.uninvoicedTrainingHint":
    "Bestätigte Trainingsstunden, die noch nicht auf einer Rechnung stehen",
  "trainerstunden.family.hub.finance.preparedDraft": "In Rechnungsentwürfen",
  "trainerstunden.family.hub.finance.preparedDraftHint":
    "Vom Verein vorbereitet, noch nicht versendet",
  "trainerstunden.family.hub.finance.forecastToggle":
    "Saison- und Jahresprognose anzeigen",
  "trainerstunden.family.hub.finance.forecastLead":
    "Durchgeführte Trainings (bestätigt) plus geplante Resttermine — Schätzung auf Basis der hinterlegten Stundensätze.",
  "trainerstunden.family.hub.finance.forecastUnavailable":
    "Für die Prognose fehlen noch Stundensätze bei einzelnen Terminen. Bitte wende dich an den Verein.",
  "trainerstunden.family.hub.finance.seasonTitle": "Aktuelle Saison",
  "trainerstunden.family.hub.finance.yearTitle": "Kalenderjahr {year}",
  "trainerstunden.family.hub.finance.confirmedCosts":
    "Durchgeführt (bestätigt)",
  "trainerstunden.family.hub.finance.invoicedCosts": "Bisher fakturiert",
  "trainerstunden.family.hub.finance.invoicedCostsHint":
    "Versendete Rechnungen im Zeitraum",
  "trainerstunden.family.hub.finance.invoiceCount": "{count} Rechnung(en)",
  "trainerstunden.family.hub.finance.plannedRemainingCosts":
    "Geplant (Rest der Saison/Jahr)",
  "trainerstunden.family.hub.finance.forecastTotal": "Erwartet gesamt",
  "trainerstunden.family.hub.finance.sessionCount": "{count} Termine",
  "trainerstunden.family.hub.latestInvoiceTitle": "Letzte Rechnung",
  "trainerstunden.family.hub.invoicePaid": "Ausgeglichen",
  "trainerstunden.family.hub.pastTitle": "Abgeschlossene Trainings",
  "trainerstunden.family.hub.pastHint":
    "{n} bestätigte Trainings in der Historie.",
  "trainerstunden.family.sessions.pageTitle": "Trainings",
  "trainerstunden.family.sessions.pageLead":
    "Deine kommenden und vergangenen Trainingstermine auf einen Blick.",
  "trainerstunden.family.sessions.upcomingTitle": "Kommende Trainings",
  "trainerstunden.family.sessions.upcomingTitleChild":
    "Kommende Trainings für {name}",
  "trainerstunden.family.sessions.upcomingTitleAll":
    "Kommende Trainings (alle Kinder)",
  "trainerstunden.family.sessions.upcomingHint":
    "Alle kommenden Trainingstermine.",
  "trainerstunden.family.sessions.upcomingHintChild":
    "Alle kommenden Trainingstermine für {name}.",
  "trainerstunden.family.sessions.upcomingHintAll":
    "Alle kommenden Trainingstermine eurer Kinder.",
  "trainerstunden.family.sessions.noUpcoming": "Keine anstehenden Trainings.",
  "trainerstunden.family.sessions.pastTitle": "Vergangene Trainings",
  "trainerstunden.family.sessions.pastShow": "Anzeigen ({count})",
  "trainerstunden.family.sessions.pastHide": "Ausblenden",
  "trainerstunden.family.sessions.pastCollapsedTeaser":
    "Vergangene Trainings sind eingeklappt — bei Bedarf anzeigen.",
  "trainerstunden.family.sessions.pastHint":
    "Abgelaufene Trainingstermine, neueste zuerst.",
  "trainerstunden.family.sessions.pastHintAll":
    "Abgelaufene Trainingstermine aller Kinder.",
  "trainerstunden.family.sessions.pastShowFirst":
    "Letzte {count} Trainings anzeigen",
  "trainerstunden.family.sessions.noPast":
    "Noch keine abgeschlossenen Trainings.",
  "trainerstunden.family.sessions.toolbarAria": "Terminliste filtern",
  "trainerstunden.family.sessions.cardAria": "Training {time}, {child}",
  "trainerstunden.family.sessions.showDetails": "Details anzeigen",
  "trainerstunden.family.sessions.trainerLine": "Trainer: {name}",
  "trainerstunden.family.sessions.estimatedCost": "Geschätzte Kosten: {amount}",
  "trainerstunden.family.sessions.estimatedCostUnknown":
    "Geschätzte Kosten werden nach den Terminen berechnet",
  "trainerstunden.family.sessions.status.takingPlace": "Findet statt",
  "trainerstunden.family.sessions.status.open": "Offen",
  "trainerstunden.family.sessions.status.cancelled": "Abgesagt",
  "trainerstunden.family.sessions.status.confirmed": "Bestätigt",
  "trainerstunden.family.sessions.status.holiday": "Ferien",
  "trainerstunden.family.sessions.selfDeclinedInline": "Du hast abgesagt",
  "trainerstunden.family.sessions.trainerConfirmedDespiteDecline":
    "Du hattest abgesagt – der Trainer hat deine Anwesenheit dennoch bestätigt.",
  "trainerstunden.family.sessions.rsvp.changeHint":
    "Das Training findet wie geplant statt. Du kannst deine Teilnahme ändern, solange der Trainer die Stunde noch nicht bestätigt hat.",
  "trainerstunden.family.dispute.aria": "Anwesenheit reklamieren",
  "trainerstunden.family.dispute.open": "Ich war nicht dabei – reklamieren",
  "trainerstunden.family.dispute.openOverride": "Anwesenheit reklamieren",
  "trainerstunden.family.dispute.lead":
    "Du wurdest als anwesend markiert, warst aber nicht beim Training. Der Trainer prüft deine Reklamation.",
  "trainerstunden.family.dispute.leadOverride":
    "Du hattest abgesagt, der Trainer hat deine Anwesenheit aber bestätigt. Wenn du nicht dabei warst, kannst du das reklamieren.",
  "trainerstunden.family.dispute.reasonLabel": "Grund",
  "trainerstunden.family.dispute.reasonPlaceholder": "Bitte wählen …",
  "trainerstunden.family.dispute.submit": "Reklamation senden",
  "trainerstunden.family.dispute.status.pending": "Reklamation wird geprüft",
  "trainerstunden.family.dispute.status.pendingOverride":
    "Reklamation wegen Trainer-Bestätigung wird geprüft",
  "trainerstunden.family.dispute.status.accepted": "Reklamation akzeptiert",
  "trainerstunden.family.dispute.status.rejected": "Reklamation abgelehnt",
  "trainerstunden.family.dispute.claimReason.illness": "Krankheit",
  "trainerstunden.family.dispute.claimReason.prior_commitment":
    "Terminkonflikt",
  "trainerstunden.family.dispute.claimReason.rsvp_declined": "Vorher abgesagt",
  "trainerstunden.family.dispute.claimReason.not_at_location": "Nicht am Platz",
  "trainerstunden.family.dispute.claimReason.other": "Sonstiges",
  "trainerstunden.family.dispute.errors.notConfirmed":
    "Die Stunde ist noch nicht bestätigt.",
  "trainerstunden.family.dispute.errors.notMarkedPresent":
    "Du wurdest für diese Stunde nicht als anwesend markiert.",
  "trainerstunden.family.dispute.errors.alreadyPending":
    "Es liegt bereits eine offene Reklamation vor.",
  "trainerstunden.family.dispute.errors.alreadyAccepted":
    "Diese Reklamation wurde bereits akzeptiert.",
  "trainerstunden.family.dispute.errors.validation":
    "Bitte alle Angaben prüfen.",
  "trainerstunden.family.dispute.errors.failed":
    "Reklamation konnte nicht gesendet werden.",
  "trainerstunden.family.dispute.errors.billingLocked":
    "Diese Stunde steht bereits auf einer Rechnung. Bitte reklamiere die Rechnung oder einzelne Positionen im Tab „Rechnungen“.",
  "trainerstunden.family.dispute.billingLockedHint":
    "Diese Stunde ist bereits fakturiert. Reklamationen sind nur noch über die Rechnung im Tab „Rechnungen“ möglich.",
  "trainerstunden.family.invoiceDispute.aria": "Rechnung reklamieren",
  "trainerstunden.family.invoiceDispute.title": "Reklamation",
  "trainerstunden.family.invoiceDispute.lead":
    "Stimmt Betrag, Position oder Inhalt der Rechnung nicht? Wähle einen Grund – der Trainer prüft deine Angabe.",
  "trainerstunden.family.invoiceDispute.reasonLabel": "Grund der Reklamation",
  "trainerstunden.family.invoiceDispute.reasonPlaceholder": "Bitte wählen …",
  "trainerstunden.family.invoiceDispute.notDisputablePaid":
    "Diese Rechnung ist bezahlt oder ausgeglichen. Eine Reklamation ist danach nicht mehr möglich.",
  "trainerstunden.family.invoiceDispute.claimReason.wrong_amount":
    "Falscher Betrag",
  "trainerstunden.family.invoiceDispute.claimReason.wrong_duration":
    "Falsche Dauer oder Termin",
  "trainerstunden.family.invoiceDispute.claimReason.duplicate_charge":
    "Doppelte Abrechnung",
  "trainerstunden.family.invoiceDispute.claimReason.service_not_rendered":
    "Leistung nicht erbracht",
  "trainerstunden.family.invoiceDispute.claimReason.wrong_assignment":
    "Falsche Zuordnung (Spieler/Position)",
  "trainerstunden.family.invoiceDispute.claimReason.other": "Sonstiges",
  "trainerstunden.family.invoiceDispute.wholeInvoice": "Gesamte Rechnung",
  "trainerstunden.family.invoiceDispute.singleLines": "Einzelne Positionen",
  "trainerstunden.family.invoiceDispute.openWhole":
    "Gesamte Rechnung reklamieren",
  "trainerstunden.family.invoiceDispute.openLine": "Diese Position reklamieren",
  "trainerstunden.family.invoiceDispute.submitWhole":
    "Reklamation zur Rechnung senden",
  "trainerstunden.family.invoiceDispute.submitLine":
    "Reklamation zur Position senden",
  "trainerstunden.family.invoiceDispute.status.pending":
    "Reklamation wird geprüft",
  "trainerstunden.family.invoiceDispute.status.accepted":
    "Reklamation akzeptiert",
  "trainerstunden.family.invoiceDispute.status.rejected":
    "Reklamation abgelehnt",
  "trainerstunden.family.invoiceDispute.errors.alreadyPending":
    "Es liegt bereits eine offene Reklamation vor.",
  "trainerstunden.family.invoiceDispute.errors.validation":
    "Bitte alle Angaben prüfen.",
  "trainerstunden.family.invoiceDispute.errors.failed":
    "Reklamation konnte nicht gesendet werden.",
  "trainerstunden.family.invoiceDispute.errors.notDisputablePaid":
    "Bezahlte Rechnungen können nicht mehr reklamiert werden.",
  "trainerstunden.family.dispute.notice.aria": "Hinweise zur Reklamation",
  "trainerstunden.family.dispute.notice.title":
    "Antwort des Trainers zu deiner Reklamation",
  "trainerstunden.family.dispute.notice.decisionLine": "Entscheidung: {reason}",
  "trainerstunden.family.dispute.notice.ack": "OK, gelesen",
  "trainerstunden.family.dispute.noticeAckFailed":
    "Bestätigung konnte nicht gespeichert werden.",
  "trainerstunden.attendanceDispute.review.aria":
    "Anwesenheits-Reklamationen prüfen",
  "trainerstunden.attendanceDispute.review.title": "Anwesenheit reklamiert",
  "trainerstunden.attendanceDispute.review.lead":
    "Ein Spieler bestreitet die Teilnahme. Bitte prüfen und mit Begründung entscheiden.",
  "trainerstunden.dispute.review.submittedAt": "Eingegangen am {date}",
  "trainerstunden.attendanceDispute.review.claimLine": "Angabe: {reason}",
  "trainerstunden.attendanceDispute.review.responseLabel": "Begründung",
  "trainerstunden.attendanceDispute.review.responsePlaceholder":
    "Bitte wählen …",
  "trainerstunden.attendanceDispute.review.acceptGroup": "Akzeptieren",
  "trainerstunden.attendanceDispute.review.rejectGroup": "Ablehnen",
  "trainerstunden.attendanceDispute.review.send": "Verschicken",
  "trainerstunden.attendanceDispute.review.cancel": "Abbrechen",
  "trainerstunden.attendanceDispute.review.noteLabel":
    "Nachricht an den Spieler (optional)",
  "trainerstunden.attendanceDispute.review.notePlaceholder":
    "Erklärung oder Hinweis, der auf der Startseite des Spielers erscheint …",
  "trainerstunden.attendanceDispute.acceptReason.verified_absence":
    "Abwesenheit bestätigt",
  "trainerstunden.attendanceDispute.acceptReason.billing_adjusted":
    "Abrechnung wird angepasst",
  "trainerstunden.attendanceDispute.acceptReason.accepted_other":
    "Sonstiger Grund (akzeptiert)",
  "trainerstunden.attendanceDispute.rejectReason.attended_confirmed":
    "Teilnahme bestätigt",
  "trainerstunden.attendanceDispute.rejectReason.insufficient_evidence":
    "Nachweis nicht ausreichend",
  "trainerstunden.attendanceDispute.rejectReason.billing_locked":
    "Abrechnung bereits gesperrt",
  "trainerstunden.attendanceDispute.rejectReason.rejected_other":
    "Sonstiger Grund (abgelehnt)",
  "trainerstunden.attendanceDispute.resolve.errors.billingLocked":
    "Abrechnung ist gesperrt – bitte zuerst über Korrektur-Workflow anpassen.",
  "trainerstunden.attendanceDispute.resolve.errors.notPending":
    "Diese Reklamation wurde bereits bearbeitet.",
  "trainerstunden.attendanceDispute.resolve.errors.validation":
    "Bitte eine gültige Begründung wählen.",
  "trainerstunden.attendanceDispute.resolve.errors.failed":
    "Reklamation konnte nicht gespeichert werden.",
  "trainerstunden.family.sessions.rsvp.aria": "Teilnahme für diesen Termin",
  "trainerstunden.family.sessions.rsvp.label": "Bist du dabei?",
  "trainerstunden.family.sessions.rsvp.attendPrompt": "Bin eingeplant",
  "trainerstunden.family.sessions.rsvp.attendPromptParent":
    "{name} ist eingeplant",
  "trainerstunden.family.sessions.rsvp.attending": "Bin beim Training dabei",
  "trainerstunden.family.sessions.rsvp.attendingParent": "{name} ist dabei",
  "trainerstunden.family.sessions.rsvp.declined": "Du nimmst nicht teil",
  "trainerstunden.family.sessions.rsvp.declinedParent":
    "{name} nimmt nicht teil",
  "trainerstunden.family.sessions.rsvp.attendingAria":
    "Bin beim Training dabei",
  "trainerstunden.family.sessions.rsvp.attendingAriaParent":
    "{name} ist beim Training dabei",
  "trainerstunden.family.sessions.rsvp.declinedAria":
    "Eigene Teilnahme absagen",
  "trainerstunden.family.sessions.rsvp.declinedAriaParent":
    "Teilnahme von {name} absagen",
  "trainerstunden.family.sessions.rsvp.error":
    "Teilnahme konnte nicht gespeichert werden.",
  "trainerstunden.family.sessions.holidayTakingPlace":
    "Achtung: Ferien – Training findet statt",
  "trainerstunden.family.sessions.holidayCancelled":
    "Achtung: Ferien – Training entfällt",
  "trainerstunden.family.sessions.participantsStandard": "Regelmäßig dabei",
  "trainerstunden.family.sessions.participantsExpected":
    "Voraussichtlich dabei",
  "trainerstunden.family.sessions.participantsAttended": "Teilgenommen",
  "trainerstunden.family.sessions.participantsDeclined":
    "Nimmt an diesem Termin nicht teil",
  "trainerstunden.family.sessions.participantsGroupInline": "Gruppe · {names}",
  "trainerstunden.family.sessions.participantsWithOthers": "Mit {names}",
  "trainerstunden.family.sessions.participantsAttendedInline":
    "Teilgenommen · {names}",
  "trainerstunden.family.sessions.participantsDeclinedInline":
    "Nicht dabei · {names}",
  "trainerstunden.family.sessions.participantsFullList": "Teilnehmer: {names}",
  "trainerstunden.family.invoices.title": "Rechnungen",
  "trainerstunden.family.invoices.hint":
    "Versendete Rechnungen — sichtbar erst nach Freigabe durch den Trainer.",
  "trainerstunden.family.invoices.hintAll":
    "Versendete Rechnungen aller verknüpften Kinder — sichtbar erst nach Freigabe.",
  "trainerstunden.family.invoices.empty":
    "Noch keine freigegebenen Rechnungen.",
  "trainerstunden.family.invoices.missingIdentifier":
    "Rechnungen können im Portal nur angezeigt werden, wenn eine E-Mail-Adresse oder Telefonnummer hinterlegt ist.",
  "trainerstunden.family.invoices.emptyChildUsesBillingRecipient":
    "Keine eigenen Rechnungen. Bitte schau bei {name} — dort laufen die Rechnungen.",
  "trainerstunden.family.invoices.openAmount": "Offen: {amount}",
  "trainerstunden.family.invoices.openSectionTitle": "Offene Rechnungen",
  "trainerstunden.family.invoices.closedSectionTitle":
    "Abgeschlossene Rechnungen",
  "trainerstunden.family.invoices.chartTitle":
    "Rechnungsbeträge {year} (Monatsübersicht)",
  "trainerstunden.family.invoices.chartAria":
    "Balkendiagramm Rechnungsbeträge und Prognose für {year}",
  "trainerstunden.family.invoices.chartLegendInvoiced": "Fakturiert",
  "trainerstunden.family.invoices.chartLegendForecast":
    "Prognose (geplante Termine)",
  "trainerstunden.family.invoices.chartHint":
    "Gestrichelte Balken: Mittelwert je Rechnungsposition (aus allen bisherigen Rechnungen) × geplante Teilnahmen pro Monat. Fakturierte Beträge nach Rechnungsmonat.",
  "trainerstunden.family.invoices.dueDate": "Zahlungsziel: {date}",
  "trainerstunden.family.invoices.dunningNotice":
    "{level}. Mahnung — bitte den offenen Betrag zeitnah begleichen.",
  "trainerstunden.family.invoices.dunningSentAt": "Mahnung versendet am {date}",
  "trainerstunden.family.invoices.partiallyPaid": "Teilweise bezahlt",
  "trainerstunden.family.invoices.linesAria": "Rechnungspositionen",
  "trainerstunden.family.invoices.pdfCta": "PDF herunterladen",
  "trainerstunden.family.invoices.pdfOpenCta": "PDF öffnen",
  "trainerstunden.family.invoices.pdfBusy": "PDF wird erstellt …",
  "trainerstunden.family.invoices.pdfFailed":
    "PDF konnte nicht geladen werden.",
  "trainerstunden.family.invoices.pdfPopupBlocked":
    "PDF konnte nicht geöffnet werden. Bitte Pop-ups für diese Seite erlauben.",
  "trainerstunden.family.invoices.payCta": "Jetzt per PayPal bezahlen",
  "trainerstunden.family.invoices.payUnavailable":
    "Online-Zahlung ist für diese Rechnung noch nicht verfügbar.",
  "trainerstunden.family.invoices.paypalUnavailable":
    "PayPal-Zahlung ist derzeit nicht eingerichtet (Server-Konfiguration).",
  "trainerstunden.family.invoices.detailLoadFailed":
    "Rechnungsdetails konnten nicht geladen werden.",
  "trainerstunden.family.invoices.detailNotAuthorized":
    "Du hast keinen Zugriff auf diese Rechnung.",
  "trainerstunden.family.invoices.detailAuthExpired":
    "Deine Anmeldung ist abgelaufen. Bitte Seite neu laden oder erneut anmelden.",
  "trainerstunden.family.invoices.detailNotFound":
    "Diese Rechnung wurde nicht gefunden.",
  "trainerstunden.family.invoices.detailServerConfig":
    "Rechnungsdetails sind vorübergehend nicht verfügbar (Server-Konfiguration). Bitte den Trainer informieren.",
  "trainerstunden.family.invoices.detailRetry": "Erneut laden",
  "trainerstunden.family.invoices.pdfRetry": "PDF erneut laden",
  "trainerstunden.family.payments.title": "Zahlungen",
  "trainerstunden.family.payments.historyTitle": "Zahlungshistorie",
  "trainerstunden.family.payments.hint":
    "Verbuchte Zahlungen und aktueller Zahlungsstand.",
  "trainerstunden.family.payments.hintAll":
    "Verbuchte Zahlungen und Zahlungsstand aller verknüpften Kinder.",
  "trainerstunden.family.payments.empty": "Noch keine Zahlungen erfasst.",
  "trainerstunden.family.payments.latestInvoiceTitle":
    "Letzte Rechnung & Zahlungsstand",
  "trainerstunden.family.payments.reference": "Verwendungszweck: {ref}",
  "trainerstunden.family.payments.paidAt": "Bezahlt am: {date}",
  "trainerstunden.subtitle":
    "Training planen, durchführen und abrechnen – ein Modul der TennisMatches-Plattform.",
  "trainerstunden.backToHome": "Zurück zur Startseite",
  "trainerstunden.backToHub": "Zurück zum TrainingsDesk-Hub",
  "trainerstunden.hub.backToHome": "Zurück zur Startseite",
  "trainerstunden.hub.subtitle":
    "Trainingsplanung, Abrechnung und Auswertung – gebündelt in TrainingsDesk.",
  "trainerstunden.hub.primaryAction.title": "Neue Trainingssession planen",
  "trainerstunden.hub.primaryAction.titleFirst":
    "Erste Trainingssession planen",
  "trainerstunden.hub.primaryAction.subtitle":
    "Training, Serie oder Einzelstunde anlegen",
  "trainerstunden.hub.primaryAction.aria":
    "Zur Trainingsplanung wechseln und neuen Termin anlegen",
  "trainerstunden.hub.mobile.adminSectionAria":
    "Abrechnung und offene Rechnungen",
  "trainerstunden.hub.mobile.statSectionAria": "Kurzüberblick Woche",
  "trainerstunden.hub.kpi.thisWeek": "Diese Woche",
  "trainerstunden.hub.kpi.hours": "Stunden",
  "trainerstunden.hub.kpi.trainingsPlanned": "{count} Trainings geplant",
  "trainerstunden.hub.kpi.thisWeekPlannedLine":
    "{hours} Stunden noch für diese Woche geplant",
  "trainerstunden.hub.kpi.thisWeekCompletedLine":
    "{hours} Stunden diese Woche bereits durchgeführt",
  "trainerstunden.hub.kpi.openPayments": "Offen seit Versand",
  "trainerstunden.hub.kpi.openCount": "offen",
  "trainerstunden.hub.kpi.pendingAmount": "{amount} ausstehend",
  "trainerstunden.hub.kpi.openPaymentsHint":
    "Eltern-/Spielerzahlungen · basiert auf protokollierten Zahlungsaufforderungen",
  "trainerstunden.hub.kpi.openParentStatements": "Offene Elternrechnungen",
  "trainerstunden.hub.kpi.openParentStatementsHint":
    "Rechnungen mit Status „Verschickt“/„Teilbezahlt“",
  "trainerstunden.hub.kpi.openParentStatementsEmpty":
    "Noch keine Rechnungen erstellt",
  "trainerstunden.hub.kpi.nextTraining": "Nächstes Training",
  "trainerstunden.hub.kpi.nextTrainingLabel": "{label}",
  "trainerstunden.hub.kpi.noNextTraining": "Kein nächstes Training",
  "trainerstunden.hub.kpi.sectionAria": "TrainingsDesk Kennzahlen",
  "trainerstunden.hub.backlog.title": "Zu bestätigende Trainings",
  "trainerstunden.hub.backlog.cta": "Jetzt bestätigen",
  "trainerstunden.hub.settlement.title": "Abrechenbare Trainings",
  "trainerstunden.hub.nextTraining.cta": "Trainingsplanung öffnen",
  "trainerstunden.hub.todos.title": "Offene To-dos",
  "trainerstunden.hub.todos.intro":
    "Konsolidierte Hinweise auf unvollständige Stammdaten. Details und Pflichtregeln legen Sie später fest; derzeit gilt eine einfache Erreichbarkeits- und Vollständigkeitsprüfung.",
  "trainerstunden.hub.todos.loading": "Wird geprüft…",
  "trainerstunden.hub.todos.allClear": "Keine offenen Stammdaten-Hinweise.",
  "trainerstunden.hub.todos.summary": "{count} offene Hinweise",
  "trainerstunden.hub.todos.linePeople":
    "Spieler: {count} (Abrechnungspartner ohne E-Mail und ohne Handynummer, oder Kontakt nicht gewählt)",
  "trainerstunden.hub.todos.lineTrainers":
    "Trainer: {count} (fehlender Name oder keine Standard-Stundensätze)",
  "trainerstunden.hub.todos.lineLocations": "Orte: {count} (ohne Namen)",
  "trainerstunden.hub.todos.ctaMasterdata": "Zu den Stammdaten",
  "trainerstunden.hub.todos.linkPeople": "Spieler öffnen",
  "trainerstunden.hub.todos.linkTrainers": "Trainer öffnen",
  "trainerstunden.hub.todos.linkLocations": "Orte öffnen",
  "trainerstunden.hub.actionsTitle": "Aktionen",
  "trainerstunden.hub.action.planning.title": "Trainings planen",
  "trainerstunden.hub.action.planning.desc":
    "Kalender: Woche und Monat, Trainer filtern",
  "trainerstunden.hub.action.agenda.title": "Tagesplan",
  "trainerstunden.hub.action.agenda.desc":
    "Heute und zurückliegende Tage: Anwesenheit bestätigen oder korrigieren",
  "trainerstunden.hub.action.masterdata.title": "Stammdaten",
  "trainerstunden.hub.action.masterdata.desc":
    "Trainer, Orte, Teilnehmer und Sessions verwalten",
  "trainerstunden.hub.action.payments.title": "Abrechnung",
  "trainerstunden.hub.action.payments.desc": "Zahlungen erfassen und prüfen",
  "trainerstunden.hub.action.settlementTrainer.title": "Trainerabrechnung",
  "trainerstunden.hub.action.settlementTrainer.desc":
    "Honorar aus bestätigten Stunden abrechnen",
  "trainerstunden.hub.action.report.title": "Spielerabrechnung",
  "trainerstunden.hub.action.report.desc":
    "Monatsübersicht, Zahlungsnachrichten und Versandprotokoll",
  "trainerstunden.hub.recent.title": "Zuletzt bearbeitet",
  "trainerstunden.hub.recent.status.active": "Aktiv",
  "trainerstunden.hub.recent.status.done": "Beendet",
  "trainerstunden.hub.recent.meta":
    "Trainer: {trainer} · {participants} Teilnehmer",
  "trainerstunden.hub.recent.empty": "Noch keine Trainings vorhanden.",
  "trainerstunden.hub.cockpit.greeting.morning": "Guten Morgen, {name}",
  "trainerstunden.hub.cockpit.greeting.day": "Guten Tag, {name}",
  "trainerstunden.hub.cockpit.greeting.evening": "Guten Abend, {name}",
  "trainerstunden.hub.cockpit.greeting.fallbackName": "Coach",
  "trainerstunden.hub.cockpit.subline": "Hier ist dein Überblick für heute.",
  "trainerstunden.hub.soloQuickStart.aria": "Einstieg für unabhängige Trainer",
  "trainerstunden.hub.soloQuickStart.title": "Loslegen",
  "trainerstunden.hub.soloQuickStart.lead":
    "Zuerst Profil, Kontakte und dein erstes Training – weitere Shortcuts darunter.",
  "trainerstunden.hub.soloQuickStart.moreShow": "Weitere Shortcuts",
  "trainerstunden.hub.soloQuickStart.moreHide": "Weniger anzeigen",
  "trainerstunden.hub.soloQuickStart.action.profile.title": "Profil & Honorar",
  "trainerstunden.hub.soloQuickStart.action.profile.hint":
    "Name, Adresse, Verfügbarkeit und Stundensätze",
  "trainerstunden.hub.soloQuickStart.action.contacts.title":
    "Spieler & Kontakte",
  "trainerstunden.hub.soloQuickStart.action.contacts.hint":
    "Teilnehmer und Abrechnungspartner anlegen",
  "trainerstunden.hub.soloQuickStart.action.locations.title": "Orte & Plätze",
  "trainerstunden.hub.soloQuickStart.action.locations.hint":
    "Trainingsorte für die Planung hinterlegen",
  "trainerstunden.hub.soloQuickStart.action.billing.title": "Abrechnung",
  "trainerstunden.hub.soloQuickStart.action.billing.hint":
    "Rechnungen erstellen und Zahlungen erfassen",
  "trainerstunden.hub.soloQuickStart.action.planning.title": "Erstes Training",
  "trainerstunden.hub.soloQuickStart.action.planning.hint":
    "Termin anlegen und Teilnehmer einladen",
  "trainerstunden.hub.soloQuickStart.action.expenses.title":
    "Ausgaben erfassen",
  "trainerstunden.hub.soloQuickStart.action.expenses.hint":
    "Trainingskosten und Vereinsbeiträge dokumentieren",
  "trainerstunden.hub.soloQuickStart.action.balance.title": "Bilanz",
  "trainerstunden.hub.soloQuickStart.action.balance.hint":
    "Einnahmen und Ausgaben im Überblick",
  "trainerstunden.hub.cockpit.kicker": "Operations Center",
  "trainerstunden.hub.cockpit.dateLabel": "Datum",
  "trainerstunden.hub.cockpit.hero.eyebrow": "Nächstes Training",
  "trainerstunden.hub.cockpit.hero.headlineToday": "Heute · {time}",
  "trainerstunden.hub.cockpit.hero.headlineUpcoming":
    "{weekday}, {date} · {time}",
  "trainerstunden.hub.cockpit.hero.today": "Heute",
  "trainerstunden.hub.cockpit.hero.confirmedChip": "{count} bestätigt",
  "trainerstunden.hub.cockpit.hero.attendingChip": "{count} dabei",
  "trainerstunden.hub.cockpit.hero.declinedChip": "{count} abgesagt",
  "trainerstunden.hub.cockpit.hero.pendingChip": "{count} offen",
  "trainerstunden.hub.cockpit.hero.rainChip": "{pct} % Regen",
  "trainerstunden.hub.cockpit.hero.action.openTraining": "Training öffnen",
  "trainerstunden.hub.cockpit.hero.action.checkParticipants":
    "Teilnehmer prüfen",
  "trainerstunden.hub.cockpit.hero.action.recordAttendance":
    "Anwesenheit erfassen",
  "trainerstunden.hub.cockpit.hero.action.confirmExecution":
    "Durchführung bestätigen",
  "trainerstunden.hub.cockpit.hero.action.viewStatus":
    "Trainingsstatus ansehen",
  "trainerstunden.hub.cockpit.hero.action.openTrainingstermine":
    "Trainingstermine öffnen",
  "trainerstunden.hub.cockpit.hero.action.participantsStatus":
    "Teilnehmerstatus prüfen",
  "trainerstunden.hub.cockpit.hero.action.coordinateTrainers":
    "Trainer koordinieren",
  "trainerstunden.hub.cockpit.hero.participants": "Teilnehmer",
  "trainerstunden.hub.cockpit.hero.message": "Nachricht senden",
  "trainerstunden.hub.cockpit.hero.messageSoon": "Demnächst verfügbar",
  "trainerstunden.hub.cockpit.hero.emptyHint":
    "Lege dein nächstes Training in der Planung an.",
  "trainerstunden.hub.cockpit.hero.weatherAria": "Wetter zum nächsten Training",
  "trainerstunden.hub.cockpit.hero.rainLine": "Regenwahrscheinlichkeit {pct} %",
  "trainerstunden.hub.cockpit.hero.watchTraining": "Training beobachten",
  "trainerstunden.hub.cockpit.hero.weatherRiskLine":
    "{temp}° · Regen {pct} % — {note}",
  "trainerstunden.hub.cockpit.hero.informParticipants":
    "Teilnehmer informieren",
  "trainerstunden.hub.cockpit.attention.title": "Benötigt Aufmerksamkeit",
  "trainerstunden.hub.cockpit.attention.backlog.one":
    "1 Training muss bestätigt werden",
  "trainerstunden.hub.cockpit.attention.backlog.other":
    "{count} Trainings müssen bestätigt werden",
  "trainerstunden.hub.cockpit.attention.makeupBacklog.one":
    "1 Nachholtermin muss geplant werden",
  "trainerstunden.hub.cockpit.attention.makeupBacklog.other":
    "{count} Nachholtermine müssen geplant werden",
  "trainerstunden.hub.cockpit.attention.allDeclined.one":
    "1 Spieler hat abgesagt",
  "trainerstunden.hub.cockpit.attention.allDeclined.other":
    "{count} Termine: alle Teilnehmer haben abgesagt",
  "trainerstunden.hub.cockpit.attention.parentBookingPending.one":
    "1 neue Buchungsanfrage",
  "trainerstunden.hub.cockpit.attention.parentBookingPending.other":
    "{count} neue Buchungsanfragen",
  "trainerstunden.hub.cockpit.attention.parentBookingMissed.one":
    "1 Buchungsanfrage läuft ab",
  "trainerstunden.hub.cockpit.attention.parentBookingMissed.other":
    "{count} Buchungsanfragen laufen ab",
  "trainerstunden.hub.cockpit.attention.parentBookingAwaitingPlayer.one":
    "1 Buchungsanfrage mit neuer Uhrzeit",
  "trainerstunden.hub.cockpit.attention.parentBookingAwaitingPlayer.other":
    "{count} Buchungsanfragen mit neuer Uhrzeit",
  "trainerstunden.hub.cockpit.attention.attendanceDisputes.one":
    "1 Anwesenheit wurde beanstandet",
  "trainerstunden.hub.cockpit.attention.attendanceDisputes.other":
    "{count} Anwesenheiten wurden beanstandet",
  "trainerstunden.hub.cockpit.attention.billingRecipientReview.one":
    "1 Rechnungsempfänger muss geprüft werden",
  "trainerstunden.hub.cockpit.attention.billingRecipientReview.other":
    "{count} Rechnungsempfänger müssen geprüft werden",
  "trainerstunden.hub.cockpit.attention.billingStatementDisputes.one":
    "1 Rechnung wurde beanstandet",
  "trainerstunden.hub.cockpit.attention.billingStatementDisputes.other":
    "{count} Rechnungen wurden beanstandet",
  "trainerstunden.hub.cockpit.attention.overdueBills":
    "{count} Rechnungen überfällig ({amount} €)",
  "trainerstunden.hub.cockpit.attention.billingPartner":
    "{count} Spieler ohne Abrechnungspartner",
  "trainerstunden.hub.cockpit.attention.billable":
    "{count} Trainings abrechenbar",
  "trainerstunden.hub.cockpit.attention.billableFamily":
    "{count} Trainings an Eltern abrechenbar",
  "trainerstunden.hub.cockpit.attention.draftInvoices":
    "{count} Elternrechnungs-Entwürfe ({amount} €)",
  "trainerstunden.hub.cockpit.openTasks.title": "Heute offen",
  "trainerstunden.hub.cockpit.openTasks.count": "{count} Aufgaben",
  "trainerstunden.hub.cockpit.openTasks.empty":
    "Keine dringenden Aufgaben — alles im grünen Bereich.",
  "trainerstunden.hub.cockpit.openTasks.open": "Öffnen",
  "trainerstunden.hub.cockpit.todo.title": "Zu erledigen",
  "trainerstunden.hub.cockpit.todo.count": "{count} offen",
  "trainerstunden.hub.cockpit.todo.empty":
    "Keine offenen Aufgaben — alles im grünen Bereich.",
  "trainerstunden.hub.cockpit.todo.showAll": "Alle anzeigen",
  "trainerstunden.hub.cockpit.todo.subtitle.makeupBacklog":
    "Abgesagte Trainings warten auf einen neuen Termin.",
  "trainerstunden.hub.cockpit.todo.subtitle.allDeclined":
    "Für das Training fehlt ein Ersatztermin.",
  "trainerstunden.hub.cockpit.money.title": "Dein Geld",
  "trainerstunden.hub.cockpit.money.loading": "Wird berechnet…",
  "trainerstunden.hub.cockpit.money.periodCalendarYear": "Kalenderjahr {year}",
  "trainerstunden.hub.cockpit.money.grandTotalHeadline":
    "Jahresumsatz (fakturiert)",
  "trainerstunden.hub.cockpit.money.waitingHeadline":
    "warten darauf, abgerechnet zu werden",
  "trainerstunden.hub.cockpit.money.stage1Label":
    "Offene Beträge, die du in Kürze abrechnen kannst",
  "trainerstunden.hub.cockpit.money.stage2Label":
    "Diese Leistungen kannst du bereits voll abrechnen",
  "trainerstunden.hub.cockpit.money.invoicedLabel":
    "Bereits fakturiert — noch nicht bezahlt",
  "trainerstunden.hub.cockpit.money.invoicedHint":
    "Offene Zahlungseingänge kannst du als Trainer erfassen",
  "trainerstunden.hub.cockpit.money.invoicedCta": "Zahlungen erfassen",
  "trainerstunden.hub.cockpit.money.invoicedAria":
    "{amount} fakturiert und noch offen — Zahlungen erfassen",
  "trainerstunden.hub.cockpit.money.ctaRecordPayments": "Zahlungen erfassen",
  "trainerstunden.hub.cockpit.money.ctaBilling": "Zur Abrechnung",
  "trainerstunden.hub.cockpit.money.inTransit": "{amount} unterwegs",
  "trainerstunden.hub.cockpit.money.overdueZero": "0 € überfällig",
  "trainerstunden.hub.cockpit.money.overdueAmount": "{amount} überfällig",
  "trainerstunden.hub.cockpit.stats.titleTrainings": "Deine Trainings",
  "trainerstunden.hub.cockpit.stats.titleHonorar": "Dein Honorar",
  "trainerstunden.hub.cockpit.stats.trainingCount": "{count} Trainings",
  "trainerstunden.hub.cockpit.stats.yearTotalLabel": "Gesamt im Kalenderjahr",
  "trainerstunden.hub.cockpit.stats.allConfirmed": "Alles bestätigt",
  "trainerstunden.hub.cockpit.stats.pendingConfirm.one": "1 noch bestätigen",
  "trainerstunden.hub.cockpit.stats.pendingConfirm.other":
    "{count} noch bestätigen",
  "trainerstunden.hub.cockpit.stats.confirmCta.one": "1 Training bestätigen",
  "trainerstunden.hub.cockpit.stats.confirmCta.other":
    "{count} Trainings bestätigen",
  "trainerstunden.hub.cockpit.badge.open": "Offen",
  "trainerstunden.hub.cockpit.badge.finance": "Finanzen",
  "trainerstunden.hub.cockpit.badge.masterdata": "Stammdaten",
  "trainerstunden.hub.cockpit.tasks.confirmBacklog":
    "{count} Trainings müssen bestätigt werden",
  "trainerstunden.hub.cockpit.tasks.confirmBacklogDetail":
    "Nächstes: {time} · {title}",
  "trainerstunden.hub.cockpit.tasks.confirmBacklogDetailGeneric":
    "Prüfe Anwesenheit und Durchführung.",
  "trainerstunden.hub.cockpit.tasks.openInvoices": "{count} offene Rechnungen",
  "trainerstunden.hub.cockpit.tasks.openInvoicesDetail":
    "{amount} € noch nicht bezahlt",
  "trainerstunden.hub.cockpit.tasks.peopleReachability":
    "{count} Spieler können nicht per WhatsApp erinnert werden",
  "trainerstunden.hub.cockpit.tasks.peopleReachabilityDetail":
    "Bei diesen Spielern fehlt die Telefonnummer.",
  "trainerstunden.hub.cockpit.tasks.peopleProfileCare":
    "{count} Spieler noch unvollständig",
  "trainerstunden.hub.cockpit.tasks.peopleProfileCareDetail":
    "Profil pflegen und klären, wer die Rechnung bezahlt.",
  "trainerstunden.hub.cockpit.tasks.overdueBills":
    "{count} Zahlungen sind überfällig",
  "trainerstunden.hub.cockpit.tasks.overdueBillsDetail":
    "Die Zahlungsfrist ist bereits abgelaufen.",
  "trainerstunden.hub.cockpit.tasks.billableSessions":
    "{count} Trainings sind abrechenbar",
  "trainerstunden.hub.cockpit.tasks.billableSessionsDetail":
    "{amount} € noch nicht fakturiert",
  "trainerstunden.hub.cockpit.tasks.billableFamilySessions":
    "{count} Trainings an Eltern abrechenbar",
  "trainerstunden.hub.cockpit.tasks.billableFamilySessionsDetail":
    "{amount} € offene Leistungen",
  "trainerstunden.hub.cockpit.tasks.draftFamilyInvoices":
    "{count} Rechnungen sind versandbereit",
  "trainerstunden.hub.cockpit.tasks.draftFamilyInvoicesDetail":
    "Diese Rechnungen können jetzt verschickt werden.",
  "trainerstunden.hub.cockpit.tasks.parentBookingPending.one":
    "1 neue Buchungsanfrage",
  "trainerstunden.hub.cockpit.tasks.parentBookingPending.other":
    "{count} neue Buchungsanfragen",
  "trainerstunden.hub.cockpit.tasks.parentBookingPendingDetail":
    "Nächste: {time} · {title}",
  "trainerstunden.hub.cockpit.tasks.parentBookingPendingDetailGeneric":
    "Neue Trainingswünsche warten auf deine Entscheidung.",
  "trainerstunden.hub.cockpit.tasks.parentBookingMissed.one":
    "1 Buchungsanfrage läuft ab",
  "trainerstunden.hub.cockpit.tasks.parentBookingMissed.other":
    "{count} Buchungsanfragen laufen ab",
  "trainerstunden.hub.cockpit.tasks.parentBookingMissedDetail":
    "Noch Zeit zur Bearbeitung",
  "trainerstunden.hub.cockpit.tasks.parentBookingMissedDetail.underOneHour":
    "Noch weniger als 1 Stunde zur Bearbeitung",
  "trainerstunden.hub.cockpit.tasks.parentBookingMissedDetail.one":
    "Noch 1 Stunde zur Bearbeitung",
  "trainerstunden.hub.cockpit.tasks.parentBookingMissedDetail.other":
    "Noch {hours} Stunden zur Bearbeitung",
  "trainerstunden.hub.cockpit.tasks.parentBookingAwaitingPlayerDetail":
    "Ein Spieler wartet auf deine Entscheidung.",
  "trainerstunden.hub.cockpit.tasks.attendanceDisputes.one":
    "1 Anwesenheit wurde beanstandet",
  "trainerstunden.hub.cockpit.tasks.attendanceDisputes.other":
    "{count} Anwesenheiten wurden beanstandet",
  "trainerstunden.hub.cockpit.tasks.attendanceDisputesDetail":
    "Nächste: {time} · {title}",
  "trainerstunden.hub.cockpit.tasks.attendanceDisputesDetailGeneric":
    "Prüfe den Hinweis des Empfängers.",
  "trainerstunden.hub.cockpit.tasks.billingRecipientReview.one":
    "1 Rechnungsempfänger muss geprüft werden",
  "trainerstunden.hub.cockpit.tasks.billingRecipientReview.other":
    "{count} Rechnungsempfänger müssen geprüft werden",
  "trainerstunden.hub.cockpit.tasks.billingRecipientReviewDetail":
    "Nächste: {name}",
  "trainerstunden.hub.cockpit.tasks.billingStatementDisputes.one":
    "1 Rechnung wurde beanstandet",
  "trainerstunden.hub.cockpit.tasks.billingStatementDisputes.other":
    "{count} Rechnungen wurden beanstandet",
  "trainerstunden.hub.cockpit.tasks.billingStatementDisputesDetail":
    "Prüfe den Hinweis des Empfängers.",

  "trainerstunden.hub.cockpit.activities.title": "Letzte Aktivitäten",
  "trainerstunden.hub.cockpit.activities.loading": "Wird geladen…",
  "trainerstunden.hub.cockpit.activities.empty": "Noch keine Aktivitäten.",
  "trainerstunden.hub.cockpit.activities.emptyFiltered":
    "Keine Aktivitäten für diesen Filter.",
  "trainerstunden.hub.cockpit.activities.showAll": "Alle Aktivitäten anzeigen",
  "trainerstunden.hub.publicBookingTelemetry.title":
    "Public Booking Telemetrie",
  "trainerstunden.hub.publicBookingTelemetry.period": "Letzte {days} Tage",
  "trainerstunden.hub.publicBookingTelemetry.periodToggleAria": "Zeitraum",
  "trainerstunden.hub.publicBookingTelemetry.periodDays": "{days} Tage",
  "trainerstunden.hub.publicBookingTelemetry.empty":
    "Noch keine Telemetrie-Ereignisse im gewählten Zeitraum.",
  "trainerstunden.hub.publicBookingTelemetry.created": "Links erstellt",
  "trainerstunden.hub.publicBookingTelemetry.copied": "Links kopiert",
  "trainerstunden.hub.publicBookingTelemetry.shared": "Links geteilt",
  "trainerstunden.hub.publicBookingTelemetry.submitSuccess":
    "Buchungen erfolgreich",
  "trainerstunden.hub.publicBookingTelemetry.conversionHint":
    "Conversion (Buchung/Link): {rate} %",
  "trainerstunden.hub.cockpit.activities.pageTitle": "Alle Aktivitäten",
  "trainerstunden.hub.cockpit.activities.backToHub": "Zurück zur Übersicht",
  "trainerstunden.hub.cockpit.activities.filterLabel": "Aktivitätstyp",
  "trainerstunden.hub.cockpit.activities.filterAll": "Alle",

  "trainerstunden.hub.cockpit.activities.type.session_created":
    "Training angelegt",
  "trainerstunden.hub.cockpit.activities.type.session_cancelled":
    "Training abgesagt",
  "trainerstunden.hub.cockpit.activities.type.session_moved":
    "Training verschoben",
  "trainerstunden.hub.cockpit.activities.type.invoice_sent":
    "Rechnung verschickt",
  "trainerstunden.hub.cockpit.activities.type.invoice_cancelled":
    "Rechnung storniert",
  "trainerstunden.hub.cockpit.activities.type.invoice_dunned":
    "Mahnung gesendet",
  "trainerstunden.hub.cockpit.activities.type.correction_booked":
    "Korrektur gebucht",
  "trainerstunden.hub.cockpit.activities.type.correction_reversed":
    "Korrektur storniert",
  "trainerstunden.hub.cockpit.activities.type.payment_received":
    "Zahlung eingegangen",
  "trainerstunden.hub.cockpit.activities.type.person_created":
    "Kontakt angelegt",

  "trainerstunden.hub.cockpit.activities.sessionCreated": "Training angelegt",
  "trainerstunden.hub.cockpit.activities.sessionCreatedDetail":
    "{date} · {time} Uhr{who}",
  "trainerstunden.hub.cockpit.activities.sessionCreatedSeries":
    "Trainingsserie angelegt ({count} Termine)",
  "trainerstunden.hub.cockpit.activities.sessionCreatedSeriesDetail":
    "Ab {date} · {time} Uhr{who}",
  "trainerstunden.hub.cockpit.activities.sessionCancelled": "Training abgesagt",
  "trainerstunden.hub.cockpit.activities.sessionCancelledDetail":
    "{date} · {time} Uhr · {reason}{who}",
  "trainerstunden.hub.cockpit.activities.sessionMoved": "Training verschoben",
  "trainerstunden.hub.cockpit.activities.sessionMovedDetail":
    "Neuer Termin: {date} · {time} Uhr{who}",
  "trainerstunden.hub.cockpit.activities.invoiceSent": "Rechnung verschickt",
  "trainerstunden.hub.cockpit.activities.invoiceSentDetail":
    "{recipient} · {amount} €",
  "trainerstunden.hub.cockpit.activities.invoiceCancelled":
    "Rechnung storniert",
  "trainerstunden.hub.cockpit.activities.invoiceCancelledDetail": "{recipient}",
  "trainerstunden.hub.cockpit.activities.invoiceDunned":
    "{level}. Mahnung gesendet",
  "trainerstunden.hub.cockpit.activities.invoiceDunnedDetail":
    "{recipient} · {amount} € offen",
  "trainerstunden.hub.cockpit.activities.correctionBooked": "Korrektur gebucht",
  "trainerstunden.hub.cockpit.activities.correctionBookedDetail":
    "{amount} € · {reason}",
  "trainerstunden.hub.cockpit.activities.correctionReversed":
    "Korrektur storniert",
  "trainerstunden.hub.cockpit.activities.correctionReversedDetail":
    "{amount} € · {reason}",
  "trainerstunden.hub.cockpit.activities.paymentReceived":
    "Zahlung eingegangen",
  "trainerstunden.hub.cockpit.activities.paymentReceivedDetail":
    "{amount} € · {person}",
  "trainerstunden.hub.cockpit.activities.personCreated": "Kontakt angelegt",
  "trainerstunden.hub.cockpit.activities.personCreatedDetail": "{name}",

  "trainerstunden.hub.cockpit.activities.correctionReason.participant":
    "Teilnehmer",
  "trainerstunden.hub.cockpit.activities.correctionReason.attendance":
    "Anwesenheit",
  "trainerstunden.hub.cockpit.activities.correctionReason.duration": "Dauer",
  "trainerstunden.hub.cockpit.activities.correctionReason.price": "Preis",
  "trainerstunden.hub.cockpit.activities.correctionReason.other": "Sonstiges",

  "trainerstunden.billingStatementDispute.review.aria":
    "Rechnungs-Reklamationen prüfen",
  "trainerstunden.billingStatementDispute.review.title": "Rechnung reklamiert",
  "trainerstunden.billingStatementDispute.review.backToArchive":
    "Zurück zu Rechnungen",
  "trainerstunden.billingStatementDispute.review.lead":
    "Ein Kunde bestreitet Positionen auf der Rechnung. Bitte prüfen und mit Begründung entscheiden.",
  "trainerstunden.billingStatementDispute.review.scopeWhole":
    "Gesamte Rechnung",
  "trainerstunden.billingStatementDispute.review.scopeLine":
    "Position: {date} · {description}",
  "trainerstunden.billingStatementDispute.resolve.errors.notPending":
    "Diese Reklamation wurde bereits bearbeitet.",
  "trainerstunden.billingStatementDispute.resolve.errors.validation":
    "Bitte eine gültige Begründung wählen.",
  "trainerstunden.billingStatementDispute.resolve.errors.failed":
    "Reklamation konnte nicht gespeichert werden.",
  "trainerstunden.hub.cockpit.priority.critical": "Kritisch",
  "trainerstunden.hub.cockpit.priority.dueSoon": "Bald fällig",
  "trainerstunden.hub.cockpit.priority.organizational": "Organisatorisch",
  "trainerstunden.hub.cockpit.priority.informational": "Informativ",
  "trainerstunden.hub.cockpit.ops.titleShort": "Trainings {scope}",
  "trainerstunden.hub.cockpit.ops.title": "Operations Board",
  "trainerstunden.hub.cockpit.ops.subtitle": "Aktive Trainings — {scope}",
  "trainerstunden.hub.cockpit.ops.attentionCount.one":
    "1 benötigt Aufmerksamkeit",
  "trainerstunden.hub.cockpit.ops.attentionCount.other":
    "{count} benötigen Aufmerksamkeit",
  "trainerstunden.hub.cockpit.ops.allClear": "Alles im grünen Bereich",
  "trainerstunden.hub.cockpit.ops.groupModeAria":
    "Gruppierung Operations Board",
  "trainerstunden.hub.cockpit.ops.groupByLocation": "Nach Standort",
  "trainerstunden.hub.cockpit.ops.groupByStatus": "Nach Status",
  "trainerstunden.hub.cockpit.ops.empty": "Keine Trainings in diesem Zeitraum.",
  "trainerstunden.hub.cockpit.ops.sessionCount.one": "1 Training",
  "trainerstunden.hub.cockpit.ops.sessionCount.other": "{count} Trainings",
  "trainerstunden.hub.cockpit.ops.playersAttending":
    "{attending} von {planned} Spielern dabei",
  "trainerstunden.hub.cockpit.hero.playersAttendingWithNames":
    "{attending} von {planned} Spielern dabei · {names}",
  "trainerstunden.hub.cockpit.ops.locationFallback": "Ohne Standort",
  "trainerstunden.hub.cockpit.ops.groupAttention": "Aufmerksamkeit nötig",
  "trainerstunden.hub.cockpit.ops.groupWeather": "Wetter kritisch",
  "trainerstunden.hub.cockpit.ops.groupOk": "Läuft problemlos",
  "trainerstunden.hub.cockpit.ops.stateNeedsConfirm": "Bestätigen",
  "trainerstunden.hub.cockpit.ops.stateAllDeclined": "Alle abgesagt",
  "trainerstunden.hub.cockpit.ops.stateRunning": "Läuft",
  "trainerstunden.hub.cockpit.ops.stateParticipantsOpen": "Absagen",
  "trainerstunden.hub.cockpit.ops.stateDone": "Bestätigt",
  "trainerstunden.hub.cockpit.ops.stateUpcoming": "Geplant",
  "trainerstunden.hub.cockpit.timeline.title": "Trainings heute & morgen",
  "trainerstunden.hub.cockpit.timeline.subtitle":
    "Dein Tagesfluss — nicht nur eine Liste.",
  "trainerstunden.hub.cockpit.timeline.weatherUncertain": "Wetter unsicher",
  "trainerstunden.hub.cockpit.timeline.scopeAria": "Zeitraum Trainingsliste",
  "trainerstunden.hub.cockpit.timeline.today": "Heute",
  "trainerstunden.hub.cockpit.timeline.tomorrow": "Morgen",
  "trainerstunden.hub.cockpit.timeline.nextUp": "Als nächstes",
  "trainerstunden.hub.cockpit.timeline.onDate": "am {weekday}, {date}",
  "trainerstunden.hub.cockpit.timeline.empty":
    "Keine Trainings in diesem Zeitraum.",
  "trainerstunden.hub.cockpit.timeline.confirmedMeta": "{count} bestätigt",
  "trainerstunden.hub.cockpit.timeline.attendingMeta":
    "{count} voraussichtlich dabei",
  "trainerstunden.hub.cockpit.timeline.declinedMeta": "{count} abgesagt",
  "trainerstunden.hub.cockpit.timeline.attendanceOpenMeta":
    "{count} Anwesenheit offen",
  "trainerstunden.hub.cockpit.timeline.plannedMeta":
    "{confirmed} bestätigt · {pending} offen",
  "trainerstunden.hub.cockpit.timeline.needsConfirm": "Bestätigen",
  "trainerstunden.hub.cockpit.timeline.done": "Bestätigt",
  "trainerstunden.hub.cockpit.finance.title": "Einnahmen & Abrechnung",
  "trainerstunden.hub.cockpit.finance.titleShort": "Finanzen",
  "trainerstunden.hub.cockpit.finance.familyScope":
    "Eltern- & Spielerrechnungen",
  "trainerstunden.hub.cockpit.finance.uninvoicedFamily":
    "Noch nicht fakturiert",
  "trainerstunden.hub.cockpit.finance.overdueFamily": "Überfällig",
  "trainerstunden.hub.cockpit.finance.billableFamily": "Abrechenbar",
  "trainerstunden.hub.cockpit.finance.recentPayments": "Letzte Zahlungen",
  "trainerstunden.hub.cockpit.finance.recentPaymentsEmpty":
    "Noch keine Zahlungen erfasst.",
  "trainerstunden.hub.cockpit.commBar.text":
    "Schnell informieren — Nachrichten an Gruppen oder einzelne Spieler senden.",
  "trainerstunden.hub.cockpit.commBar.action": "Nachricht erstellen",
  "trainerstunden.hub.cockpit.finance.uninvoiced": "Noch nicht fakturiert",
  "trainerstunden.hub.cockpit.finance.overdue": "Überfällig",
  "trainerstunden.hub.cockpit.finance.billable": "Abrechenbar",
  "trainerstunden.hub.cockpit.finance.billableCount": "{count} Trainings",
  "trainerstunden.hub.cockpit.finance.openPayments": "Offene Zahlungen",
  "trainerstunden.hub.cockpit.finance.openPaymentsCount": "{count} Rechnungen",
  "trainerstunden.hub.cockpit.finance.createInvoices": "Rechnungen erstellen",
  "trainerstunden.hub.cockpit.finance.checkPayments": "Zahlungen prüfen",
  "trainerstunden.hub.cockpit.week.aria": "Kurzüberblick Woche",
  "trainerstunden.hub.cockpit.week.sessions": "{count} Trainings diese Woche",
  "trainerstunden.hub.cockpit.week.hours":
    "{planned} h geplant · {done} h durchgeführt",
  "trainerstunden.hub.cockpit.week.participants": "{count} Teilnehmer geplant",
  "trainerstunden.hub.day.header.hello": "Hallo {name}!",
  "trainerstunden.hub.day.header.subtitle": "Hier ist dein Plan für heute.",
  "trainerstunden.hub.day.header.newSession": "Training anlegen",
  "trainerstunden.hub.day.today.title": "Heute",
  "trainerstunden.hub.day.today.emptyTitle":
    "Heute steht noch kein Training an.",
  "trainerstunden.hub.day.today.emptyText":
    "Plane dein nächstes Training in wenigen Sekunden.",
  "trainerstunden.hub.day.today.toCalendar": "Zum Kalender",
  "trainerstunden.hub.day.statusLabel": "Status:",
  "trainerstunden.hub.day.status.planned": "Geplant",
  "trainerstunden.hub.day.status.confirmed": "Bestätigt",
  "trainerstunden.hub.day.status.completed": "Abgeschlossen",
  "trainerstunden.hub.day.status.cancelled": "Abgesagt",
  "trainerstunden.hub.day.status.open": "Offen",
  "trainerstunden.hub.day.action.confirmAttendance": "Training bestätigen",
  "trainerstunden.hub.day.action.markCompleted": "Als durchgeführt markieren",
  "trainerstunden.hub.day.action.viewBilling": "Abrechnung ansehen",
  "trainerstunden.hub.day.action.replan": "Termin neu planen",
  "trainerstunden.hub.day.action.more": "Weitere Aktionen",
  "trainerstunden.hub.day.action.details": "Details öffnen",
  "trainerstunden.hub.day.action.edit": "Training bearbeiten",
  "trainerstunden.hub.day.action.cancel": "Training absagen",
  "trainerstunden.hub.day.sidebar.aria": "Kontext und nächste Schritte",
  "trainerstunden.hub.day.attention.title": "Auf einen Blick",
  "trainerstunden.hub.day.attention.allClear": "Alles im grünen Bereich",
  "trainerstunden.hub.day.attention.noOpenTasks": "Keine offenen Aufgaben.",
  "trainerstunden.hub.day.attention.needsAttention":
    "Das braucht deine Aufmerksamkeit.",
  "trainerstunden.hub.day.attention.count.one":
    "1 Ding braucht deine Aufmerksamkeit",
  "trainerstunden.hub.day.attention.count.other":
    "{count} Dinge brauchen deine Aufmerksamkeit",
  "trainerstunden.hub.day.upcoming.title": "Nächste Termine",
  "trainerstunden.hub.day.upcoming.empty":
    "Noch keine weiteren Termine geplant.",
  "trainerstunden.hub.day.upcoming.all": "Alle Termine anzeigen",
  "trainerstunden.hub.day.upcoming.today": "Heute",
  "trainerstunden.hub.day.upcoming.tomorrow": "Morgen",
  "trainerstunden.hub.day.upcoming.toCalendar": "Zum Kalender",
  "trainerstunden.hub.day.quick.title": "Schnellaktionen",
  "trainerstunden.hub.day.quick.newSession": "Training anlegen",
  "trainerstunden.hub.day.quick.addPlayer": "Spieler hinzufügen",
  "trainerstunden.hub.day.quick.createInvoice": "Rechnung erstellen",
  "trainerstunden.hub.day.quick.bookingRequests": "Buchungsanfragen öffnen",
  "trainerstunden.hub.day.quick.whatsapp": "WhatsApp-Erinnerungen",
  "trainerstunden.hub.day.whatsapp.title": "WhatsApp-Erinnerungen",
  "trainerstunden.hub.day.whatsapp.text":
    "Erinnere deine Spieler automatisch an ihre Trainings.",
  "trainerstunden.hub.day.whatsapp.connect": "Verbinden",
  "trainerstunden.hub.day.whatsapp.dismiss": "Nicht jetzt",
  "trainerstunden.hub.day.news.title": "Neu in TrainingsDesk",
  "trainerstunden.hub.day.news.dismiss": "Verstanden",
  "trainerstunden.hub.day.news.sessionEdit.title": "Termine direkt bearbeiten",
  "trainerstunden.hub.day.news.sessionEdit.text":
    "Tippe bei „Trainings heute“ auf einen Termin, um Teilnehmer, Datum und Uhrzeit sofort zu ändern.",
  "trainerstunden.hub.day.news.help.title": "Hilfe im TrainingsDesk",
  "trainerstunden.hub.day.news.help.text":
    "Unter Verwaltung → Hilfe findest du kurze Anleitungen zu den wichtigsten Funktionen.",
  "trainerstunden.hub.day.news.help.cta": "Hilfe öffnen",
  "trainerstunden.hub.day.metrics.aria": "Kompakte Übersicht",
  "trainerstunden.hub.day.metric.week.title": "Diese Woche",
  "trainerstunden.hub.day.metric.week.sessions.one": "1 Training diese Woche",
  "trainerstunden.hub.day.metric.week.sessions.other":
    "{count} Trainings diese Woche",
  "trainerstunden.hub.day.metric.week.sessionsShort.one": "1 Training",
  "trainerstunden.hub.day.metric.week.sessionsShort.other": "{count} Trainings",
  "trainerstunden.hub.day.metric.week.openConfirm.one":
    "1 muss noch bestätigt werden",
  "trainerstunden.hub.day.metric.week.openConfirm.other":
    "{count} müssen noch bestätigt werden",
  "trainerstunden.hub.day.metric.week.allConfirmed":
    "Alle Trainings sind bestätigt",
  "trainerstunden.hub.day.metric.week.cta": "Trainings prüfen",
  "trainerstunden.hub.day.metric.invoices.title": "Offene Rechnungen",
  "trainerstunden.hub.day.metric.invoices.count.one": "1 offene Rechnung",
  "trainerstunden.hub.day.metric.invoices.count.other":
    "{count} offene Rechnungen",
  "trainerstunden.hub.day.metric.invoices.amount": "{amount} € offen",
  "trainerstunden.hub.day.metric.invoices.cta": "Rechnungen prüfen",
  "trainerstunden.hub.day.metric.people.title": "Neue Spieler",
  "trainerstunden.hub.day.metric.people.count.one": "1 Spieler",
  "trainerstunden.hub.day.metric.people.count.other": "{count} Spieler",
  "trainerstunden.hub.day.metric.people.hint": "diese Woche",
  "trainerstunden.hub.day.metric.revenue.title": "Zahlungen diesen Monat",
  "trainerstunden.hub.day.metric.revenue.shortTitle": "Eingegangen",
  "trainerstunden.hub.day.metric.revenue.amount": "{amount} €",
  "trainerstunden.hub.day.metric.revenue.up": "mehr als im Vormonat",
  "trainerstunden.hub.day.metric.revenue.down": "weniger als im Vormonat",
  "trainerstunden.hub.day.metric.revenue.received": "Diesen Monat",
  "trainerstunden.hub.day.metric.revenue.cta": "Zahlungen ansehen",
  "trainerstunden.hub.day.first.title": "Willkommen bei TrainingsDesk",
  "trainerstunden.hub.day.first.subtitle": "Lege dein erstes Training an.",
  "trainerstunden.hub.day.first.cta": "Erstes Training anlegen",
  "trainerstunden.hub.day.first.benefit1": "Teilnehmer direkt hinzufügen",
  "trainerstunden.hub.day.first.benefit2": "Termin in Sekunden planen",
  "trainerstunden.hub.day.first.benefit3": "später automatisch abrechnen",
  "trainerstunden.hub.day.hint.label": "Tipp",
  "trainerstunden.hub.day.hint.text":
    "Bestätige Trainings direkt nach der Einheit.",
  "trainerstunden.hub.day.hint.dismiss": "Ausblenden",
  "trainerstunden.hub.day.hint.dismissAria": "Tipp ausblenden",
  "trainerstunden.hub.day.tip.tennify.title": "Tennify verbinden",
  "trainerstunden.hub.day.tip.tennify.text":
    "Hole Buchungen automatisch aus Tennify – weniger Tipparbeit, weniger Doppelbuchungen.",
  "trainerstunden.hub.day.tip.tennify.cta": "Tennify einrichten",
  "trainerstunden.hub.day.tip.checkcourt.title": "CheckCourt verbinden",
  "trainerstunden.hub.day.tip.checkcourt.text":
    "Platzbuchung über CheckCourt in der Planung nutzen.",
  "trainerstunden.hub.day.tip.checkcourt.cta": "CheckCourt einrichten",
  "trainerstunden.hub.day.tip.contacts.title": "Kontakte pflegen",
  "trainerstunden.hub.day.tip.contacts.text":
    "Spieler und Eltern anlegen, bevor du Termine planst.",
  "trainerstunden.hub.day.tip.contacts.cta": "Zu den Kunden",
  "trainerstunden.hub.day.tip.payment.title": "Zahlungsmethoden",
  "trainerstunden.hub.day.tip.payment.text":
    "IBAN oder PayPal hinterlegen für Rechnungen.",
  "trainerstunden.hub.day.tip.payment.cta": "Zahlung einrichten",
  "trainerstunden.hub.day.tip.holidays.title": "Ferienkalender aktivieren",
  "trainerstunden.hub.day.tip.holidays.text":
    "Mit Bundesland und Schulferien erkennt die Planung Ferientage und hilft bei Absagen.",
  "trainerstunden.hub.day.tip.holidays.cta": "Ferien einstellen",
  "trainerstunden.hub.day.tip.planningFields.title":
    "Formular „Neues Training“ vorbereiten",
  "trainerstunden.hub.day.tip.planningFields.text":
    "Lege fest, welche Felder beim Anlegen erscheinen und welche Werte vorausgefüllt sind — wirkt beim nächsten „+ Termin“.",
  "trainerstunden.hub.day.tip.planningFields.cta": "Formular anpassen",
  "trainerstunden.hub.day.tip.calendar.title": "Kalenderzeiten anpassen",
  "trainerstunden.hub.day.tip.calendar.text":
    "Öffnungszeiten und Zeitslots auf euren Trainingsalltag zuschneiden.",
  "trainerstunden.hub.day.tip.calendar.cta": "Kalender öffnen",
  "trainerstunden.hub.day.tip.whatsapp.title": "WhatsApp-Erinnerungen",
  "trainerstunden.hub.day.tip.whatsapp.text":
    "Erinnere Spieler automatisch an ihre Trainings – weniger No-Shows.",
  "trainerstunden.hub.day.tip.whatsapp.cta": "WhatsApp verbinden",
  "trainerstunden.hub.day.tip.attendance.title":
    "Anwesenheit automatisch bestätigen",
  "trainerstunden.hub.day.tip.attendance.text":
    "Nach dem Training können Stunden automatisch bestätigt werden – Grundlage für die Abrechnung.",
  "trainerstunden.hub.day.tip.attendance.cta": "Auto-Bestätigung einstellen",
  "trainerstunden.hub.inbox.title": "Neu & zu erledigen",
  "trainerstunden.hub.inbox.subtitle":
    "Das Wichtigste auf einen Blick — was neu ist und was du heute erledigen solltest.",
  "trainerstunden.hub.inbox.emptyTitle": "Alles erledigt",
  "trainerstunden.hub.inbox.emptyText":
    "Aktuell gibt es nichts, das deine Aufmerksamkeit braucht.",
  "trainerstunden.hub.inbox.sinceVisit.title": "Seit deinem letzten Besuch",
  "trainerstunden.hub.inbox.group.new": "Neu seit deinem letzten Besuch",
  "trainerstunden.hub.inbox.group.due": "Heute zu erledigen",
  "trainerstunden.hub.inbox.group.hint": "Hinweise",
  "trainerstunden.hub.inbox.provider.tennify": "Tennify",
  "trainerstunden.hub.inbox.provider.tennifyShort": "Tennify",
  "trainerstunden.hub.inbox.provider.checkcourt": "CheckCourt",
  "trainerstunden.hub.inbox.provider.checkcourtShort": "CheckCourt",
  "trainerstunden.hub.inbox.provider.courtplan": "CourtPlan",
  "trainerstunden.hub.inbox.provider.courtplanShort": "CourtPlan",
  "trainerstunden.hub.inbox.provider.internal": "Buchungsportal",
  "trainerstunden.hub.inbox.provider.internalShort": "Buchungsportal",
  "trainerstunden.hub.inbox.booking.title.one": "1 neue Buchungsanfrage",
  "trainerstunden.hub.inbox.booking.title.other":
    "{count} neue Buchungsanfragen",
  "trainerstunden.hub.inbox.booking.multiHint":
    "Neue Trainingswünsche warten auf deine Entscheidung.",
  "trainerstunden.hub.inbox.booking.providerCount.one": "1 neue Anfrage",
  "trainerstunden.hub.inbox.booking.providerCount.other":
    "{count} neue Anfragen",
  "trainerstunden.hub.inbox.booking.singleWants": "{name} möchte buchen",
  "trainerstunden.hub.inbox.payment.title": "1 Zahlung ist eingegangen",
  "trainerstunden.hub.inbox.payment.from": "von {name}",
  "trainerstunden.hub.inbox.payment.amount": "{amount} €",
  "trainerstunden.hub.inbox.action.review": "Anfrage prüfen",
  "trainerstunden.hub.inbox.action.reviewAllBookings": "Buchungen prüfen",
  "trainerstunden.hub.inbox.action.openRequests": "Anfragen öffnen",
  "trainerstunden.hub.inbox.action.view": "Ansehen",
  "trainerstunden.hub.inbox.action.open": "Öffnen",
  "trainerstunden.hub.inbox.action.confirmNow": "Trainings bestätigen",
  "trainerstunden.hub.inbox.action.openInvoices": "Rechnungen versenden",
  "trainerstunden.hub.inbox.action.openPayments": "Zahlungen prüfen",
  "trainerstunden.hub.inbox.action.accept": "Buchung annehmen",
  "trainerstunden.hub.inbox.action.counterTime": "Andere Zeit",
  "trainerstunden.hub.inbox.action.decline": "Ablehnen",
  "trainerstunden.hub.inbox.desc.confirmAttendance":
    "Prüfe Anwesenheit und Durchführung.",
  "trainerstunden.hub.inbox.desc.invoicesReady":
    "Diese Rechnungen können jetzt verschickt werden.",
  "trainerstunden.hub.inbox.desc.overdue":
    "Die Zahlungsfrist ist bereits abgelaufen.",
  "trainerstunden.hub.inbox.desc.payment": "Eine Zahlung ist eingegangen.",
  "trainerstunden.hub.inbox.desc.counterProposal":
    "Ein Spieler wartet auf deine Entscheidung.",
  "trainerstunden.hub.inbox.desc.genericCount": "{count} offen",
  "trainerstunden.hub.inbox.desc.generic": "Bitte prüfen",
  "trainerstunden.hub.inbox.task.fallback.action": "Prüfen",
  "trainerstunden.hub.inbox.task.bookingRequest.title.one":
    "1 neue Buchungsanfrage",
  "trainerstunden.hub.inbox.task.bookingRequest.title.other":
    "{count} neue Buchungsanfragen",
  "trainerstunden.hub.inbox.task.bookingRequest.description":
    "Neue Trainingswünsche warten auf deine Entscheidung.",
  "trainerstunden.hub.inbox.task.bookingRequest.singleDescription":
    "Über {provider} · {when}",
  "trainerstunden.hub.inbox.task.bookingRequest.action": "Anfrage prüfen",
  "trainerstunden.hub.inbox.task.bookingRequest.actionAll": "Buchungen prüfen",
  "trainerstunden.hub.inbox.task.bookingMissed.title.one":
    "1 Buchungsanfrage läuft ab",
  "trainerstunden.hub.inbox.task.bookingMissed.title.other":
    "{count} Buchungsanfragen laufen ab",
  "trainerstunden.hub.inbox.task.bookingMissed.description":
    "Bald verfällt die Anfrage — entscheide dich jetzt.",
  "trainerstunden.hub.inbox.task.bookingMissed.action": "Anfrage prüfen",
  "trainerstunden.hub.inbox.task.cancellation.title.one":
    "1 Spieler hat abgesagt",
  "trainerstunden.hub.inbox.task.cancellation.title.other":
    "{count} Termine: alle Teilnehmer haben abgesagt",
  "trainerstunden.hub.inbox.task.cancellation.description":
    "Für das Training fehlt ein Ersatztermin.",
  "trainerstunden.hub.inbox.task.cancellation.action": "Termin neu planen",
  "trainerstunden.hub.inbox.task.counterProposal.title.one":
    "1 Buchungsanfrage mit neuer Uhrzeit",
  "trainerstunden.hub.inbox.task.counterProposal.title.other":
    "{count} Buchungsanfragen mit neuer Uhrzeit",
  "trainerstunden.hub.inbox.task.counterProposal.description":
    "Ein Spieler wartet auf deine Entscheidung.",
  "trainerstunden.hub.inbox.task.counterProposal.action": "Anfrage prüfen",
  "trainerstunden.hub.inbox.task.invoiceComplaint.title.one":
    "1 Rechnung wurde beanstandet",
  "trainerstunden.hub.inbox.task.invoiceComplaint.title.other":
    "{count} Rechnungen wurden beanstandet",
  "trainerstunden.hub.inbox.task.invoiceComplaint.description":
    "Prüfe den Hinweis des Empfängers.",
  "trainerstunden.hub.inbox.task.invoiceComplaint.action": "Rechnung prüfen",
  "trainerstunden.hub.inbox.task.attendanceDispute.title.one":
    "1 Anwesenheit wurde beanstandet",
  "trainerstunden.hub.inbox.task.attendanceDispute.title.other":
    "{count} Anwesenheiten wurden beanstandet",
  "trainerstunden.hub.inbox.task.attendanceDispute.description":
    "Prüfe den Hinweis des Empfängers.",
  "trainerstunden.hub.inbox.task.attendanceDispute.action":
    "Anwesenheit prüfen",
  "trainerstunden.hub.inbox.task.attendanceConfirmation.title.one":
    "1 Training muss bestätigt werden",
  "trainerstunden.hub.inbox.task.attendanceConfirmation.title.other":
    "{count} Trainings müssen bestätigt werden",
  "trainerstunden.hub.inbox.task.attendanceConfirmation.description":
    "Prüfe Anwesenheit und Durchführung.",
  "trainerstunden.hub.inbox.task.attendanceConfirmation.action":
    "Trainings bestätigen",
  "trainerstunden.hub.inbox.task.makeupBacklog.title.one":
    "1 Nachholtermin muss geplant werden",
  "trainerstunden.hub.inbox.task.makeupBacklog.title.other":
    "{count} Nachholtermine müssen geplant werden",
  "trainerstunden.hub.inbox.task.makeupBacklog.description":
    "Abgesagte Trainings warten auf einen neuen Termin.",
  "trainerstunden.hub.inbox.task.makeupBacklog.action": "Nachholtermine planen",
  "trainerstunden.hub.inbox.task.invoiceDraftReady.title.one":
    "1 Rechnung ist versandbereit",
  "trainerstunden.hub.inbox.task.invoiceDraftReady.title.other":
    "{count} Rechnungen sind versandbereit",
  "trainerstunden.hub.inbox.task.invoiceDraftReady.description":
    "Diese Rechnungen können jetzt verschickt werden.",
  "trainerstunden.hub.inbox.task.invoiceDraftReady.action":
    "Rechnungen versenden",
  "trainerstunden.hub.inbox.task.overdueInvoice.title.one":
    "1 Zahlung ist überfällig",
  "trainerstunden.hub.inbox.task.overdueInvoice.title.other":
    "{count} Zahlungen sind überfällig",
  "trainerstunden.hub.inbox.task.overdueInvoice.description":
    "Die Zahlungsfrist ist bereits abgelaufen.",
  "trainerstunden.hub.inbox.task.overdueInvoice.action": "Zahlungen prüfen",
  "trainerstunden.hub.inbox.task.billableSessions.title.one":
    "1 Training ist abrechenbar",
  "trainerstunden.hub.inbox.task.billableSessions.title.other":
    "{count} Trainings sind abrechenbar",
  "trainerstunden.hub.inbox.task.billableSessions.description":
    "Diese Trainings können jetzt abgerechnet werden.",
  "trainerstunden.hub.inbox.task.billableSessions.action": "Rechnung erstellen",
  "trainerstunden.hub.inbox.task.paymentReceived.title.one":
    "1 Zahlung ist eingegangen",
  "trainerstunden.hub.inbox.task.paymentReceived.title.other":
    "{count} Zahlungen sind eingegangen",
  "trainerstunden.hub.inbox.task.paymentReceived.description":
    "Eine neue Zahlung kannst du jetzt verbuchen.",
  "trainerstunden.hub.inbox.task.paymentReceived.from": "von {name}",
  "trainerstunden.hub.inbox.task.paymentReceived.action": "Zahlung verbuchen",
  "trainerstunden.hub.inbox.task.whatsappPhoneGap.title.one":
    "1 Spieler kann nicht per WhatsApp erinnert werden",
  "trainerstunden.hub.inbox.task.whatsappPhoneGap.title.other":
    "{count} Spieler können nicht per WhatsApp erinnert werden",
  "trainerstunden.hub.inbox.task.whatsappPhoneGap.description":
    "Bei diesen Spielern fehlt die Telefonnummer.",
  "trainerstunden.hub.inbox.task.whatsappPhoneGap.action":
    "Kontaktdaten ergänzen",
  "trainerstunden.hub.inbox.task.playerCare.title.one":
    "1 Spieler noch unvollständig",
  "trainerstunden.hub.inbox.task.playerCare.title.other":
    "{count} Spieler noch unvollständig",
  "trainerstunden.hub.inbox.task.playerCare.description":
    "Profil pflegen und klären, wer die Rechnung bezahlt.",
  "trainerstunden.hub.inbox.task.playerCare.action": "Spieler pflegen",
  "trainerstunden.hub.cockpit.week.receivables":
    "{amount} € offene Forderungen",
  "trainerstunden.nav.here": "Du bist hier",
  "trainerstunden.nav.level.main": "Bereich",
  "trainerstunden.nav.level.sub": "Unterbereich",
  "trainerstunden.nav.closeSheet": "Schließen",
  "trainerstunden.tabs.masterdata": "Verwaltung",
  "trainerstunden.tabs.hub": "Übersicht",
  "trainerstunden.tabs.planning": "Trainingstermine",
  "trainerstunden.tabs.myTrainers": "Meine Trainer",
  "trainerstunden.tabs.planningParentBookingAttentionAria":
    "{count} offene Buchungsanfrage(n)",
  "trainerstunden.tabs.agenda": "Tagesplan",
  "trainerstunden.tabs.payments": "Zahlungsverbuchung",
  "trainerstunden.tabs.settlementTrainer": "Trainerabrechnung",
  "trainerstunden.tabs.report": "Abrechnungen",
  "trainerstunden.tabs.rechnungswesen": "Rechnungswesen",
  "trainerstunden.tabs.abrechnen": "Rechnungsentwürfe",
  "trainerstunden.tabs.abrechnung": "Abrechnung",
  "trainerstunden.tabs.finanzen": "Finanzen",
  "trainerstunden.myTrainers.title": "Meine Trainer",
  "trainerstunden.myTrainers.subtitle":
    "Trainer, die du koordinierst — Honorar und Koordination direkt steuern.",
  "trainerstunden.myTrainers.empty.title":
    "Noch keine Trainer in deiner Betreuung",
  "trainerstunden.myTrainers.empty.text":
    "Sobald du einen Trainer koordinierst, erscheint er hier.",
  "trainerstunden.myTrainers.status.active": "Aktiv",
  "trainerstunden.myTrainers.status.paused": "Pausiert",
  "trainerstunden.myTrainers.status.inactive": "Inaktiv",
  "trainerstunden.myTrainers.card.honorar": "Honorar",
  "trainerstunden.myTrainers.card.trainings": "Trainings",
  "trainerstunden.myTrainers.card.invoices": "Rechnungen",
  "trainerstunden.myTrainers.card.coordination": "Koordination",
  "trainerstunden.myTrainers.honorar.rate": "{amount} €/h",
  "trainerstunden.myTrainers.honorar.none": "Kein Honorar hinterlegt",
  "trainerstunden.myTrainers.honorar.modalTitle": "Honorar ändern",
  "trainerstunden.myTrainers.honorar.modalBody":
    "Neuer Stundensatz für {name}.",
  "trainerstunden.myTrainers.honorar.field": "Honorar in €/h",
  "trainerstunden.myTrainers.honorar.save": "Speichern",
  "trainerstunden.myTrainers.honorar.invalid":
    "Bitte einen gültigen Betrag eingeben.",
  "trainerstunden.myTrainers.honorar.saveFailed":
    "Honorar konnte nicht gespeichert werden.",
  "trainerstunden.myTrainers.stats.weekSessions.one": "1 Training diese Woche",
  "trainerstunden.myTrainers.stats.weekSessions.other":
    "{count} Trainings diese Woche",
  "trainerstunden.myTrainers.stats.openInvoices.one": "1 offene Rechnung",
  "trainerstunden.myTrainers.stats.openInvoices.other":
    "{count} offene Rechnungen",
  "trainerstunden.myTrainers.coordination.since": "Koordination seit {date}",
  "trainerstunden.myTrainers.coordination.sincePermanent": "Koordination aktiv",
  "trainerstunden.myTrainers.coordination.paused": "Koordination pausiert",
  "trainerstunden.myTrainers.action.changeHonorar": "Honorar ändern",
  "trainerstunden.myTrainers.action.editHonorar": "Bearbeiten",
  "trainerstunden.myTrainers.action.pause": "Koordination pausieren",
  "trainerstunden.myTrainers.action.end": "Koordination beenden",
  "trainerstunden.myTrainers.action.resume": "Koordination fortsetzen",
  "trainerstunden.myTrainers.link.trainings": "Trainings →",
  "trainerstunden.myTrainers.link.billing": "Abrechnung →",
  "trainerstunden.myTrainers.link.billingOpen": "Öffnen",
  "trainerstunden.myTrainers.link.profile": "Profil →",
  "trainerstunden.myTrainers.link.fullAdmin": "Zur vollständigen Verwaltung",
  "trainerstunden.myTrainers.pauseModal.title": "Koordination pausieren?",
  "trainerstunden.myTrainers.pauseModal.body":
    "Die Koordination von {name} endet ab heute. Du kannst sie später wieder starten.",
  "trainerstunden.myTrainers.pauseModal.confirm": "Pausieren",
  "trainerstunden.myTrainers.profile.back": "← Zurück zu Meine Trainer",
  "trainerstunden.myTrainers.profile.coordinationTitle": "Koordination",
  "trainerstunden.myTrainers.profile.honorarTitle": "Honorar",
  "trainerstunden.myTrainers.profile.trainingsTitle": "Trainings",
  "trainerstunden.myTrainers.profile.billingTitle": "Abrechnung",
  "trainerstunden.myTrainers.profile.contactTitle": "Kontakt",
  "trainerstunden.myTrainers.profile.phone": "Telefon",
  "trainerstunden.myTrainers.profile.email": "E-Mail",
  "trainerstunden.myTrainers.profile.missing": "Nicht hinterlegt",
  "trainerstunden.finanzen.pageTitle": "Finanzen",
  "trainerstunden.finanzen.pageSubtitle":
    "Zahlungen, Ausgaben und Bilanz verwalten.",
  "trainerstunden.finanzen.navAria": "Finanzbereiche",
  "trainerstunden.finanzen.empty":
    "Für Finanzen sind keine Bereiche freigeschaltet.",
  "trainerstunden.finanzen.landing.setCta": "Als Finanzen-Start festlegen",
  "trainerstunden.finanzen.landing.current": "Aktueller Finanzen-Start",
  "trainerstunden.finanzen.entry.zahlungen.title": "Einnahmen",
  "trainerstunden.finanzen.entry.zahlungen.description":
    "Zahlungseingänge verbuchen und einsehen.",
  "trainerstunden.finanzen.entry.ausgaben.title": "Ausgaben",
  "trainerstunden.finanzen.entry.ausgaben.description":
    "Ausgaben und Belege erfassen.",
  "trainerstunden.finanzen.entry.bilanz.title": "Bilanz",
  "trainerstunden.finanzen.entry.bilanz.description":
    "Einnahmen und Ausgaben im Überblick.",
  "trainerstunden.tabs.participants": "Kontakte",
  "trainerstunden.tabs.navDesktop.participants": "Kontakte",
  "trainerstunden.participants.pageTitle": "Kontakte",
  "trainerstunden.participants.pageSubtitle":
    "Schüler, Rechnungsempfänger und Geschäftspartner verwalten.",
  "trainerstunden.participants.addContact": "Kontakt hinzufügen",
  "trainerstunden.participants.listTitle": "Alle Kontakte",
  "trainerstunden.participants.listHint":
    "Kontakte suchen, nach Rolle filtern und Stammdaten öffnen.",
  "trainerstunden.contacts.kpi.aria": "Kontaktkennzahlen",
  "trainerstunden.contacts.kpi.players": "Schüler",
  "trainerstunden.contacts.kpi.billingRecipients": "Rechnungsempfänger",
  "trainerstunden.contacts.kpi.trainers": "Trainer",
  "trainerstunden.contacts.kpi.duplicates": "mögliche Dublette",
  "trainerstunden.contacts.kpi.addresses": "Adressen prüfen",
  "trainerstunden.contacts.kpi.invites": "Einladungen offen",
  "trainerstunden.contacts.relCard.ageYears": "Alter {age}",
  "trainerstunden.contacts.relCard.lastLogin": "Letzter Login",
  "trainerstunden.contacts.relCard.primarySection": "Schüler",
  "trainerstunden.contacts.relCard.importantRelations": "Wichtige Beziehungen",
  "trainerstunden.contacts.relCard.invoiceGoesTo": "Rechnung geht an",
  "trainerstunden.contacts.relCard.invoiceShort": "Rechnung",
  "trainerstunden.contacts.relCard.goesTo": "geht an",
  "trainerstunden.contacts.relCard.invoiceGoesToSummary":
    "Die Rechnung für {student} geht an {recipient} ({relation}).",
  "trainerstunden.contacts.relCard.invoiceGoesToShort":
    "Die Rechnung für {student} geht an {relation}.",
  "trainerstunden.contacts.relCard.changeBilling": "Rechnungsempfänger ändern",
  "trainerstunden.contacts.relCard.noBilling":
    "Kein Rechnungsempfänger hinterlegt",
  "trainerstunden.contacts.relCard.openContact": "Kontakt öffnen",
  "trainerstunden.contacts.relCard.moreDetails": "Weitere Angaben",
  "trainerstunden.contacts.relCard.nextTraining": "Nächstes Training",
  "trainerstunden.contacts.relCard.training": "Training",
  "trainerstunden.contacts.relCard.trainer": "Trainer",
  "trainerstunden.contacts.relCard.chipActive": "Aktiv",
  "trainerstunden.contacts.relCard.chipAppRegistered": "App registriert",
  "trainerstunden.contacts.relCard.chipAppNone": "App offen",
  "trainerstunden.contacts.relCard.chipInvoiceActive": "Rechnung aktiv",
  "trainerstunden.contacts.relCard.chipInvoiceNone": "Rechnung fehlt",
  "trainerstunden.contacts.relCard.chipTraining": "Training",
  "trainerstunden.contacts.relCard.chipTrainingDay": "Training {day}.",
  "trainerstunden.contacts.relCard.sharedAddress": "Gemeinsame Adresse",
  "trainerstunden.contacts.relCard.sharedClub": "Verein – gemeinsam",
  "trainerstunden.contacts.relCard.sharedTogether": "Gemeinsam",
  "trainerstunden.contacts.relCard.familyName": "Familie {name}",
  "trainerstunden.contacts.relCard.moreFamily": "Weitere Familienmitglieder",
  "trainerstunden.contacts.relCard.addFamilyMember":
    "Familienmitglied hinzufügen",
  "trainerstunden.contacts.relCard.addFamilyShort": "Familienmitglied",
  "trainerstunden.contacts.relCard.addChip": "hinzufügen",
  "trainerstunden.contacts.relCard.noRelations": "Keine Beziehungen hinterlegt",
  "trainerstunden.contacts.relCard.addRelation": "Beziehung hinzufügen",
  "trainerstunden.contacts.tasks.aria": "Kontaktaufgaben",
  "trainerstunden.contacts.tasks.showAll": "Alle anzeigen",
  "trainerstunden.contacts.tasks.duplicates.title": {
    one: "1 mögliche Dublette",
    other: "{count} mögliche Dubletten",
  },
  "trainerstunden.contacts.tasks.duplicates.empty": "Keine Dubletten gefunden.",
  "trainerstunden.contacts.tasks.duplicates.score":
    "{score} % Trefferwahrscheinlichkeit",
  "trainerstunden.contacts.tasks.duplicates.compare": "Vergleichen",
  "trainerstunden.contacts.tasks.duplicates.merge": "Zusammenführen",
  "trainerstunden.contacts.tasks.addresses.title": {
    one: "1 Adresse prüfen",
    other: "{count} Adressen prüfen",
  },
  "trainerstunden.contacts.tasks.addresses.empty": "Keine Adressprobleme.",
  "trainerstunden.contacts.tasks.addresses.missing": "Keine Adresse hinterlegt",
  "trainerstunden.contacts.tasks.addresses.incomplete": "Adresse unvollständig",
  "trainerstunden.contacts.tasks.addresses.add": "Hinzufügen",
  "trainerstunden.contacts.tasks.addresses.complete": "Vervollständigen",
  "trainerstunden.contacts.tasks.invites.title": {
    one: "1 Einladung offen",
    other: "{count} Einladungen offen",
  },
  "trainerstunden.contacts.tasks.invites.empty": "Keine offenen Einladungen.",
  "trainerstunden.contacts.tasks.invites.resend": "Erneut senden",
  "trainerstunden.verwaltung.pageTitle": "Verwaltung",
  "trainerstunden.verwaltung.accessDenied":
    "Für diesen Einstellungsbereich fehlt die Berechtigung.",
  "trainerstunden.verwaltung.pageSubtitle":
    "Trainer, Einstellungen und Stammdaten verwalten.",
  "trainerstunden.verwaltung.admin.dashboardSubtitle":
    "Wähle einen Bereich. Innerhalb einer Kategorie siehst du nur deren Funktionen.",
  "trainerstunden.verwaltung.admin.sidebarAria": "Navigation {category}",
  "trainerstunden.verwaltung.admin.breadcrumbAria": "Verwaltungspfad",
  "trainerstunden.verwaltung.admin.breadcrumbRoot": "← Verwaltung",
  "trainerstunden.verwaltung.admin.openItem": "Öffnen",
  "trainerstunden.verwaltung.admin.chooseItem": "Funktion wählen",
  "trainerstunden.verwaltung.admin.recentAria": "Zuletzt genutzte Bereiche",
  "trainerstunden.verwaltung.admin.recentTitle": "Zuletzt genutzt",
  "trainerstunden.verwaltung.admin.quickAria": "Schnellzugriff",
  "trainerstunden.verwaltung.admin.quickTitle": "Schnellzugriff",
  "trainerstunden.verwaltung.admin.metric.trainers": "Trainer",
  "trainerstunden.verwaltung.admin.metric.contacts": "Kontakte",
  "trainerstunden.verwaltung.admin.metric.lists": "Listen",
  "trainerstunden.verwaltung.admin.metric.functions": "Funktionen",
  "trainerstunden.verwaltung.admin.category.people.title": "Menschen",
  "trainerstunden.verwaltung.admin.category.people.description":
    "Trainer und Kontakte verwalten.",
  "trainerstunden.verwaltung.admin.category.training.title": "Trainingsbetrieb",
  "trainerstunden.verwaltung.admin.category.training.description":
    "Anlegen-Seite, Kalender, Ferien und Auswahllisten.",
  "trainerstunden.verwaltung.admin.category.finance.title": "Finanzen",
  "trainerstunden.verwaltung.admin.category.finance.description":
    "Rechnungslayout, Bankverbindungen, PayPal und Export.",
  "trainerstunden.verwaltung.admin.category.communication.title":
    "Kommunikation",
  "trainerstunden.verwaltung.admin.category.communication.description":
    "WhatsApp-Erinnerungen und Benachrichtigungen.",
  "trainerstunden.verwaltung.admin.category.general.title": "Allgemein",
  "trainerstunden.verwaltung.admin.category.general.description":
    "Grundeinstellungen, Anwesenheit und Hilfe.",
  "trainerstunden.verwaltung.admin.item.help.title": "Hilfe",
  "trainerstunden.verwaltung.admin.item.help.description":
    "Kurzanleitungen für den Alltag in TrainingsDesk.",
  "trainerstunden.help.title": "Hilfe & Anleitungen",
  "trainerstunden.help.eyebrow": "TrainingsDesk",
  "trainerstunden.help.intro":
    "Finde schnell, wie Hub, Planung, Abrechnung und Verwaltung funktionieren.",
  "trainerstunden.help.navLabel": "Hilfe-Themen",
  "trainerstunden.help.section.user": "Anwenderhilfe",
  "trainerstunden.help.empty.user": "Noch keine Anwenderhilfe hinterlegt.",
  "trainerstunden.help.empty.all": "Kein Dokument ausgewählt.",
  "trainerstunden.help.home.nav": "Themenübersicht",
  "trainerstunden.help.home.title": "Wobei brauchst du Hilfe?",
  "trainerstunden.help.home.intro":
    "Wähle ein Thema – oder nutze die Suche oben.",
  "trainerstunden.help.back": "Alle Themen",
  "trainerstunden.help.search.label": "Hilfe durchsuchen",
  "trainerstunden.help.search.placeholder": "Suchen… z. B. Rechnung, Kalender",
  "trainerstunden.help.search.results": "Suchergebnisse",
  "trainerstunden.help.search.empty":
    "Keine Treffer – anderen Begriff versuchen.",
  "trainerstunden.help.group.start": "Einstieg",
  "trainerstunden.help.group.start.blurb":
    "Erste Schritte und der tägliche Überblick im Hub.",
  "trainerstunden.help.group.daily": "Alltag",
  "trainerstunden.help.group.daily.blurb":
    "Termine planen, bestätigen, Kontakte und Trainer Studio.",
  "trainerstunden.help.group.money": "Abrechnung & Finanzen",
  "trainerstunden.help.group.money.blurb":
    "Rechnungen, Zahlungen und Einnahmen/Ausgaben.",
  "trainerstunden.help.group.admin": "Verwaltung",
  "trainerstunden.help.group.admin.blurb":
    "Einstellungen, Stammdaten und Vereinssetup.",
  "trainerstunden.help.group.roles": "Nach Rolle",
  "trainerstunden.help.group.roles.blurb":
    "Speziell für Trainer, Eltern und Vereinsverantwortliche.",
  "trainerstunden.help.group.more": "Weitere Themen",
  "trainerstunden.help.group.more.blurb": "Weitere Hilfeseiten.",
  "trainerstunden.verwaltung.admin.category.integrations.title":
    "Integrationen",
  "trainerstunden.verwaltung.admin.category.integrations.description":
    "Externe Dienste wie Tennify.",
  "trainerstunden.verwaltung.admin.category.subscription.title": "Vereinsabo",
  "trainerstunden.verwaltung.admin.category.subscription.description":
    "Plan, Trial und Abostatus für TrainingsDesk.",
  "trainerstunden.verwaltung.admin.item.contacts.title": "Kontakte",
  "trainerstunden.verwaltung.admin.item.contacts.description":
    "Eltern, Spieler und weitere Kontakte.",
  "trainerstunden.verwaltung.admin.item.billing.title":
    "Abrechnungs-Stammdaten",
  "trainerstunden.verwaltung.admin.item.billing.description":
    "Abrechnungsbezogene Stammdaten.",
  "trainerstunden.verwaltung.admin.item.billingMail.title": "Rechnungs-E-Mail",
  "trainerstunden.verwaltung.admin.item.billingMail.description":
    "E-Mail-Simulation und Rechnungsversand.",
  "trainerstunden.verwaltung.admin.item.calendar.title": "Kalender",
  "trainerstunden.verwaltung.admin.item.calendar.description":
    "Tageszeiten und Zeitslot der Planung.",
  "trainerstunden.verwaltung.admin.item.holidays.title": "Ferien",
  "trainerstunden.verwaltung.admin.item.holidays.description":
    "Schulferien und Bundesland.",
  "trainerstunden.verwaltung.admin.item.reminders.title":
    "WhatsApp & Erinnerungen",
  "trainerstunden.verwaltung.admin.item.reminders.description":
    "RSVP-Erinnerungen vor Terminen.",
  "trainerstunden.verwaltung.admin.item.attendance.title": "Anwesenheit",
  "trainerstunden.verwaltung.admin.item.attendance.description":
    "Auto-Bestätigung der Anwesenheit.",
  "trainerstunden.verwaltung.admin.item.tennify.title": "Tennify",
  "trainerstunden.verwaltung.admin.item.tennify.description":
    "Tennify-Anbindung und Plätze.",
  "trainerstunden.verwaltung.admin.item.checkcourt.title": "CheckCourt",
  "trainerstunden.verwaltung.admin.item.checkcourt.description":
    "CheckCourt-Anbindung und Plätze.",
  "trainerstunden.verwaltung.admin.quick.planNewSession.title":
    "Training erstellen",
  "trainerstunden.verwaltung.admin.quick.planNewSession.description":
    "Neuen Termin anlegen.",
  "trainerstunden.verwaltung.admin.quick.openAbrechnung.title":
    "Rechnung erstellen",
  "trainerstunden.verwaltung.admin.quick.openAbrechnung.description":
    "Zur Abrechnung wechseln.",
  "trainerstunden.verwaltung.admin.quick.openTrainerAbrechnung.title":
    "Auszahlung prüfen",
  "trainerstunden.verwaltung.admin.quick.openTrainerAbrechnung.description":
    "Trainer-Auszahlungen öffnen.",
  "trainerstunden.verwaltung.admin.quick.openExport.title": "Export starten",
  "trainerstunden.verwaltung.admin.quick.openExport.description":
    "Datenexport öffnen.",
  "trainerstunden.verwaltung.admin.overviewSubtitle":
    "Bereiche nach Themen geordnet — zuletzt Genutztes oben.",
  "trainerstunden.verwaltung.navAria": "Verwaltungsbereiche",
  "trainerstunden.verwaltung.segmentAria": "Verwaltungsbereiche",
  "trainerstunden.verwaltung.empty":
    "Für Verwaltung sind keine Bereiche freigeschaltet.",
  "trainerstunden.verwaltung.landing.setCta": "Als Verwaltungs-Start festlegen",
  "trainerstunden.verwaltung.landing.current": "Aktueller Verwaltungs-Start",
  "trainerstunden.verwaltung.entry.trainers.title": "Trainer",
  "trainerstunden.verwaltung.entry.trainers.description":
    "Trainer anlegen, bearbeiten und Berechtigungen verwalten.",
  "trainerstunden.verwaltung.entry.planningFields.title": "Neues Training",
  "trainerstunden.verwaltung.entry.planningFields.description":
    "Vorlage für das Formular „Neues Training“: Standardwerte und sichtbare Felder.",
  "trainerstunden.verwaltung.entry.invoiceLayout.title": "Rechnungslayout",
  "trainerstunden.verwaltung.entry.invoiceLayout.description":
    "Briefkopf, Texte und Layout der Rechnungen anpassen.",
  "trainerstunden.verwaltung.entry.dataExport.title": "Datenexport",
  "trainerstunden.verwaltung.entry.dataExport.description":
    "Trainings- und Abrechnungsdaten exportieren.",
  "trainerstunden.verwaltung.entry.settings.title": "Einstellungen",
  "trainerstunden.verwaltung.entry.settings.description":
    "Allgemeine Einstellungen für TrainingsDesk.",
  "trainerstunden.verwaltung.entry.vereinsabo.title": "Vereinsabo",
  "trainerstunden.verwaltung.entry.vereinsabo.description":
    "Plan wählen, Trial-Status und Freischaltung.",
  "trainerstunden.verwaltung.entry.lists.title": "Auswahllisten",
  "trainerstunden.verwaltung.entry.lists.description":
    "Referenzlisten für Planung und Abrechnung pflegen.",

  "trainerstunden.subscription.page.title": "Vereinsabo",
  "trainerstunden.subscription.page.subtitle":
    "Plan für den Verein. Eltern, Spieler und Kunden nutzen die App kostenlos.",
  "trainerstunden.subscription.currentPlan": "Aktueller Plan: {plan}",
  "trainerstunden.subscription.pilotNote":
    "Eltern und Spieler zahlen nichts für die Plattform. Pilot: Planfreischaltung ohne PayPal (Soft-Activate).",
  "trainerstunden.subscription.stripeNote":
    "Eltern und Spieler zahlen nichts für die Plattform. Zahlung und Kündigung laufen über Stripe.",
  "trainerstunden.subscription.paypalNote":
    "Eltern und Spieler zahlen nichts für die Plattform. Das Vereinsabo zahlst du per PayPal an Tennis-Matches (support@tennis-matches.de).",
  "trainerstunden.subscription.portal.cta": "Abo verwalten",
  "trainerstunden.subscription.portal.opening": "Wird geöffnet…",
  "trainerstunden.subscription.cancel.stripePolicy":
    "Kündigung und Zahlungsmethode im Stripe-Kundenportal. Wirksamkeit zum Periodenende.",
  "trainerstunden.subscription.cancel.paypalPolicy":
    "Kündigung beendet das PayPal-Abo. Zugang bleibt bis Periodenende, sofern PayPal das so liefert.",
  "trainerstunden.subscription.cancel.ctaStripe": "Lokal kündigen (Fallback)",
  "trainerstunden.subscription.cancel.ctaPaypal": "PayPal-Abo kündigen",
  "trainerstunden.subscription.freeForCustomers":
    "Für Kunden und Spieler ist TrainingsDesk kostenlos – Abrechnung betrifft nur den Verein.",
  "trainerstunden.subscription.status.trial": "Testphase",
  "trainerstunden.subscription.status.active": "Aktiv",
  "trainerstunden.subscription.status.expired": "Abgelaufen",
  "trainerstunden.subscription.status.canceled": "Gekündigt",
  "trainerstunden.subscription.meta.trialDays": "Testphase noch {days} Tage.",
  "trainerstunden.subscription.meta.periodEnd": "Laufzeit bis {date}.",
  "trainerstunden.subscription.meta.expired":
    "Schreibende Funktionen sind pausiert.",
  "trainerstunden.subscription.meta.cancelEffective":
    "Kündigung wirksam ab {date}.",
  "trainerstunden.subscription.meta.cancelPending":
    "Kündigung vorgemerkt — Wirksamkeitsdatum folgt von PayPal.",
  "trainerstunden.subscription.meta.accessUntil":
    "Zugang bleibt aktiv bis einschließlich {date}.",
  "trainerstunden.subscription.reactivate.aria": "Abo fortsetzen",
  "trainerstunden.subscription.reactivate.hint":
    "Du kannst das Abo jederzeit wieder aktivieren oder einen anderen Plan wählen — Zahlung läuft über PayPal.",
  "trainerstunden.subscription.bonus.intro":
    "{baseDays} Tage Testphase. Weitere Trainer verlängern bis max. {maxMonths} Monate (höchstens {maxTrainers} Trainer).",
  "trainerstunden.subscription.bonus.next":
    "Noch {trainers} Trainer bis +{days} Tage (max. {maxMonths} Monate kostenlos).",
  "trainerstunden.subscription.bonus.maxReached":
    "Maximale Testphase erreicht ({days} Tage / ca. 6 Monate).",
  "trainerstunden.subscription.bonus.trainerCount":
    "Trainer im Verein: {count} von {max} für Boni.",
  "trainerstunden.subscription.cancel.aria": "Kündigung",
  "trainerstunden.subscription.cancel.policy":
    "Kündigungsfrist: zum Ende der laufenden Woche. Bei aktivem Abo Rückerstattung für die restlichen Tage nach Wirksamkeitsdatum.",
  "trainerstunden.subscription.cancel.cta": "Abo kündigen",
  "trainerstunden.subscription.cancel.saving": "Wird gekündigt…",
  "trainerstunden.subscription.cancel.refundEstimate":
    "Geschätzte Rückerstattung: {amount} € ({days} Tage).",
  "trainerstunden.subscription.cancel.noRefund":
    "Keine Rückerstattung (Testphase oder keine Restlaufzeit).",
  "trainerstunden.subscription.plans.aria": "Verfügbare Pläne",
  "trainerstunden.subscription.plans.current": "Aktuell",
  "trainerstunden.subscription.plans.activate": "Plan wählen",
  "trainerstunden.subscription.plans.activatePaypal": "Mit PayPal bezahlen",
  "trainerstunden.subscription.plans.reactivate": "Abo reaktivieren",
  "trainerstunden.subscription.plans.reactivatePaypal":
    "Mit PayPal reaktivieren",
  "trainerstunden.subscription.plans.saving": "Wird gespeichert…",
  "trainerstunden.subscription.plans.redirectingPaypal":
    "Weiterleitung zu PayPal…",
  "trainerstunden.subscription.plans.price": "{price} € / Monat",
  "trainerstunden.subscription.checkoutError":
    "PayPal-Checkout fehlgeschlagen ({reason}). Bitte erneut versuchen.",
  "trainerstunden.subscription.checkoutHint":
    "Nach „Mit PayPal bezahlen“ wirst du zur PayPal-Sandbox weitergeleitet. Nach dem Approve kommst du zurück — das Abo wird dann aktiv.",
  "trainerstunden.subscription.plan.starter.name": "Starter",
  "trainerstunden.subscription.plan.starter.lead":
    "Planung und Anwesenheit für den Trainingsalltag.",
  "trainerstunden.subscription.plan.pro.name": "Pro",
  "trainerstunden.subscription.plan.pro.lead":
    "Eltern-Rechnungen, Finanzen und Auswertung inklusive.",
  "trainerstunden.subscription.plan.gold.name": "Gold",
  "trainerstunden.subscription.plan.gold.lead":
    "Alles aus Pro plus weitere Club-Apps.",
  "trainerstunden.subscription.feature.planning": "Planung & Anwesenheit",
  "trainerstunden.subscription.feature.billing": "Eltern-Rechnungen",
  "trainerstunden.subscription.feature.finance": "Finanzen & Auszahlungen",
  "trainerstunden.subscription.feature.analytics": "Auswertung",
  "trainerstunden.subscription.feature.clubApps": "Weitere Club-Apps",
  "trainerstunden.subscription.trial.banner":
    "Trial noch {days} Tage · TrainingsDesk Pro testen",
  "trainerstunden.subscription.trial.cta": "Plan wählen",
  "trainerstunden.subscription.gate.billing.title": "Rechnungen gehören zu Pro",
  "trainerstunden.subscription.gate.billing.lead":
    "Mit Pro schließt du den Monatsabschluss ohne Excel.",
  "trainerstunden.subscription.gate.analytics.title":
    "Auswertung gehört zu Pro",
  "trainerstunden.subscription.gate.analytics.lead":
    "Sieh Umsatz, Trainings und Absagen im Überblick.",
  "trainerstunden.subscription.gate.ctaManage": "Plan ansehen",
  "trainerstunden.subscription.gate.askAdmin":
    "Bitte den Vereinsadmin um ein Upgrade.",
  "trainerstunden.subscription.expired.title": "Abo abgelaufen",
  "trainerstunden.subscription.expired.lead":
    "Planung und Rechnungen sind pausiert. Deine Daten bleiben erhalten.",
  "trainerstunden.subscription.expired.cta": "Abo verlängern",

  "trainerstunden.tabs.offenePosten": "In Vorbereitung",
  "trainerstunden.tabs.rechnungen": "Rechnungen",
  "trainerstunden.tabs.zahlungen": "Einnahmen",
  "trainerstunden.tabs.ausgabenerfassung": "Ausgabenerfassung",
  "trainerstunden.tabs.bilanzierung": "Bilanzierung",
  "trainerstunden.tabs.analytics": "Auswertung",
  "trainerstunden.tabs.navDesktop.rechnungswesen": "Rechnungswesen",
  "trainerstunden.tabs.navDesktop.abrechnung": "Abrechnung",
  "trainerstunden.tabs.navDesktop.finanzen": "Finanzen",
  "trainerstunden.tabs.navDesktop.abrechnen": "Rechnungsentwürfe",
  "trainerstunden.tabs.navDesktop.offenePosten": "In Vorbereitung",
  "trainerstunden.tabs.navDesktop.rechnungen": "Rechnungen",
  "trainerstunden.tabs.navDesktop.zahlungen": "Einnahmen",
  "trainerstunden.tabs.navDesktop.ausgabenerfassung": "Ausgaben",
  "trainerstunden.tabs.navDesktop.bilanzierung": "Bilanz",
  "trainerstunden.tabs.navDesktop.analytics": "Auswertung",

  "trainerstunden.analytics.title": "Auswertung",
  "trainerstunden.analytics.subtitle":
    "Umsatz, Trainings und Absagen im Zeitraum.",
  "trainerstunden.analytics.period.label": "Zeitraum",
  "trainerstunden.analytics.period.month": "Monat",
  "trainerstunden.analytics.period.quarter": "Quartal",
  "trainerstunden.analytics.period.year": "Jahr",
  "trainerstunden.analytics.period.custom": "Frei",
  "trainerstunden.analytics.period.yearLabel": "Jahr",
  "trainerstunden.analytics.period.monthLabel": "Monat",
  "trainerstunden.analytics.period.quarterLabel": "Quartal",
  "trainerstunden.analytics.period.quarterOption": "Q{{quarter}}",
  "trainerstunden.analytics.period.from": "Von",
  "trainerstunden.analytics.period.until": "Bis",
  "trainerstunden.analytics.trainerFilter": "Trainer",
  "trainerstunden.analytics.trainerFilterAll": "Alle Trainer",
  "trainerstunden.analytics.rangeLabel": "{{from}} – {{until}}",
  "trainerstunden.analytics.expensesLoading": "Ausgaben werden geladen…",
  "trainerstunden.analytics.empty": "Keine Daten im Zeitraum.",
  "trainerstunden.analytics.kpi.revenue": "Umsatz",
  "trainerstunden.analytics.kpi.expenses": "Ausgaben",
  "trainerstunden.analytics.kpi.net": "Saldo",
  "trainerstunden.analytics.kpi.sessions": "Trainings",
  "trainerstunden.analytics.kpi.cancelled": "Absagen",
  "trainerstunden.analytics.kpi.confirmed": "Bestätigt",
  "trainerstunden.analytics.kpi.hours": "Stunden",
  "trainerstunden.analytics.kpi.noShows": "No-Shows",
  "trainerstunden.analytics.kpi.attendanceRate": "Anwesenheit",
  "trainerstunden.analytics.rankings.topTrainings":
    "Schüler mit meisten Trainings",
  "trainerstunden.analytics.rankings.topCancels":
    "Schüler mit meisten persönlichen Absagen",
  "trainerstunden.analytics.rankings.cancelReasons": "Absagegründe",
  "trainerstunden.analytics.rankings.revenueByTrainer": "Umsatz pro Trainer",
  "trainerstunden.analytics.charts.sessionsTitle": "Trainings & Absagen",
  "trainerstunden.analytics.charts.sessionsAria":
    "Balkendiagramm Trainings und Absagen im Zeitraum",
  "trainerstunden.analytics.charts.financeTitle": "Umsatz & Ausgaben",
  "trainerstunden.analytics.charts.financeAria":
    "Balkendiagramm Umsatz und Ausgaben im Zeitraum",
  "trainerstunden.analytics.charts.cancelPieTitle": "Absagegründe",
  "trainerstunden.analytics.charts.cancelPieAria":
    "Kreisdiagramm der Absagegründe",
  "trainerstunden.analytics.charts.heatmapTitle": "Wann wird trainiert?",
  "trainerstunden.analytics.charts.heatmapAria":
    "Heatmap Wochentag und Uhrzeit der Trainings",
  "trainerstunden.analytics.charts.legendHeld": "Trainings",
  "trainerstunden.analytics.charts.legendCancelled": "Absagen",
  "trainerstunden.analytics.charts.legendRevenue": "Umsatz",
  "trainerstunden.analytics.charts.legendExpenses": "Ausgaben",
  "trainerstunden.analytics.charts.legendForecast": "Geplant (Zukunft)",
  "trainerstunden.analytics.tooltip.forecastSuffix":
    "Zukunft — geplante Termine, noch keine Ist-Werte",
  "trainerstunden.analytics.charts.weekday.1": "Mo",
  "trainerstunden.analytics.charts.weekday.2": "Di",
  "trainerstunden.analytics.charts.weekday.3": "Mi",
  "trainerstunden.analytics.charts.weekday.4": "Do",
  "trainerstunden.analytics.charts.weekday.5": "Fr",
  "trainerstunden.analytics.charts.weekday.6": "Sa",
  "trainerstunden.analytics.charts.weekday.7": "So",
  "trainerstunden.analytics.chartExpand.expand": "Vergrößern",
  "trainerstunden.analytics.chartExpand.expandAria":
    "{title} vergrößern und analysieren",
  "trainerstunden.analytics.chartExpand.close": "Schließen",
  "trainerstunden.analytics.chartExpand.zoomAria": "Zoom",
  "trainerstunden.analytics.chartExpand.zoomIn": "Hineinzoomen",
  "trainerstunden.analytics.chartExpand.zoomOut": "Herauszoomen",
  "trainerstunden.analytics.chartExpand.periodAria": "Zeitraum im Diagramm",
  "trainerstunden.analytics.chartExpand.grainMonth": "Im Monat",
  "trainerstunden.analytics.chartExpand.grainYear": "Über Monate",
  "trainerstunden.analytics.chartExpand.prevMonth": "Vorheriger Monat",
  "trainerstunden.analytics.chartExpand.nextMonth": "Nächster Monat",
  "trainerstunden.analytics.chartExpand.prevYear": "Vorheriges Jahr",
  "trainerstunden.analytics.chartExpand.nextYear": "Nächstes Jahr",
  "trainerstunden.analytics.chartExpand.monthLabel": "{month} {year}",
  "trainerstunden.analytics.chartExpand.trendOff": "Trendlinie",
  "trainerstunden.analytics.chartExpand.trendOn": "Trendlinie an",
  "trainerstunden.analytics.chartExpand.trendLegend": "Trend (gleitend)",
  "trainerstunden.analytics.chartExpand.yAxisAria": "Y-Achse ({unit})",
  "trainerstunden.analytics.chartExpand.unitEur": "€",
  "trainerstunden.analytics.chartExpand.unitCount": "Stück",
  "trainerstunden.analytics.tooltip.barSessions":
    "{period}\n{heldLabel}: {held}\n{cancelledLabel}: {cancelled}",
  "trainerstunden.analytics.tooltip.barSessionsForecast":
    "{period}\n{heldLabel}: {held}",
  "trainerstunden.analytics.tooltip.barFinance":
    "{period}\n{revenueLabel}: {revenue} €\n{expensesLabel}: {expenses} €",
  "trainerstunden.analytics.tooltip.heatmap":
    "{day} {hour}:00 · {count} Trainings",
  "trainerstunden.analytics.tooltip.pie": "{reason}: {count} ({pct} %)",
  "trainerstunden.analytics.tooltip.hBar": "{name}: {count}",
  "trainerstunden.analytics.month.1": "Januar",
  "trainerstunden.analytics.month.2": "Februar",
  "trainerstunden.analytics.month.3": "März",
  "trainerstunden.analytics.month.4": "April",
  "trainerstunden.analytics.month.5": "Mai",
  "trainerstunden.analytics.month.6": "Juni",
  "trainerstunden.analytics.month.7": "Juli",
  "trainerstunden.analytics.month.8": "August",
  "trainerstunden.analytics.month.9": "September",
  "trainerstunden.analytics.month.10": "Oktober",
  "trainerstunden.analytics.month.11": "November",
  "trainerstunden.analytics.month.12": "Dezember",

  "trainerstunden.zahlungen.title": "Einnahmen",
  "trainerstunden.zahlungen.subtitle":
    "Verbuchte Zahlungseingänge und Einnahmen im Überblick.",
  "trainerstunden.zahlungen.linkRechnungswesen":
    "Offene Rechnungen in der Abrechnung",
  "trainerstunden.rechnungswesen.title": "Rechnungen & Honorare",
  "trainerstunden.rechnungswesen.subtitle":
    "Rechnungen und Abrechnungen für Eltern sowie Honorare für Trainer.",
  "trainerstunden.abrechnen.title": "Rechnungsentwürfe",
  "trainerstunden.abrechnen.subtitle":
    "Offene Leistungen in Rechnungen umwandeln und versenden.",
  "trainerstunden.offenePosten.title": "Nächste Abrechnung",
  "trainerstunden.offenePosten.subtitle":
    "Verdiente Leistungen, die sich gemäß Zahlungsrhythmus für die nächste Abrechnung ansammeln.",
  "trainerstunden.rechnungen.title": "Rechnungen",
  "trainerstunden.rechnungen.subtitle":
    "Archiv, Zahlungsstatus und Stornierungen einsehen.",
  "trainerstunden.rechnungswesen.linkZahlungen":
    "Zahlungseingänge unter Einnahmen",
  "trainerstunden.ausgaben.title": "Ausgabenerfassung",
  "trainerstunden.ausgaben.subtitle":
    "Betriebsausgaben erfassen, Belege ablegen und für die Bilanz vorbereiten.",
  "trainerstunden.ausgaben.categoryLabel": "Kategorie",
  "trainerstunden.expenses.standard.hint":
    "Datum, Betrag und optional Beleg erfassen — gilt für alle Standard-Kategorien gleich.",
  "trainerstunden.expenses.standard.dateLabel": "Datum",
  "trainerstunden.expenses.standard.dateEmptyHint":
    "Noch kein Datum gewählt — bei Belegauslesen oder manuell setzen.",
  "trainerstunden.expenses.standard.amountLabel": "Betrag",
  "trainerstunden.expenses.amountWithCurrency": "{amount} {currency}",
  "trainerstunden.expenses.currency.EUR": "€",
  "trainerstunden.expenses.currency.USD": "USD",
  "trainerstunden.expenses.currencyOption.EUR": "EUR (€)",
  "trainerstunden.expenses.currencyOption.USD": "USD ($)",
  "trainerstunden.expenses.standard.amountPlaceholder": "z. B. 89,50",
  "trainerstunden.expenses.standard.currencyLabel": "Währung",
  "trainerstunden.expenses.standard.fxLoading": "Wechselkurs wird geladen…",
  "trainerstunden.expenses.standard.fxError":
    "Wechselkurs konnte nicht geladen werden.",
  "trainerstunden.expenses.standard.fxPreview":
    "Für die Bilanz: {amountEur} € (Kurs {rate} am {rateDate})",
  "trainerstunden.expenses.standard.vendorLabel": "Anbieter / Empfänger",
  "trainerstunden.expenses.standard.vendorPlaceholder":
    "z. B. Tennisverein, Amazon, Hotel",
  "trainerstunden.expenses.standard.descriptionLabel": "Beschreibung",
  "trainerstunden.expenses.standard.descriptionPlaceholder":
    "Kurz notieren, wofür die Ausgabe war",
  "trainerstunden.expenses.standard.receiptLabel": "Beleg",
  "trainerstunden.expenses.standard.receiptHint":
    "PDF oder Foto — per KI auslesbar.",
  "trainerstunden.expenses.standard.receiptPasteHint":
    "Screenshot einfügen: Strg+V bzw. ⌘+V in diesen Bereich.",
  "trainerstunden.expenses.standard.receiptChooseFile": "Datei wählen",
  "trainerstunden.expenses.standard.receiptTakePhoto": "Foto aufnehmen",
  "trainerstunden.expenses.standard.receiptRemove": "Beleg entfernen",
  "trainerstunden.expenses.standard.receiptSelected": "Ausgewählt: {name}",
  "trainerstunden.expenses.standard.categoryHint.court_fees":
    "Platzmiete, Hallengebühr oder Court-Reservierung.",
  "trainerstunden.expenses.standard.categoryHint.equipment":
    "Schläger, Bälle, Besaitung, Kleidung und Trainingsmaterial.",
  "trainerstunden.expenses.standard.categoryHint.training_education":
    "Kurse, Seminare, Lizenzen und Trainer-Fortbildungen.",
  "trainerstunden.expenses.standard.categoryHint.travel":
    "Fahrtkosten, Übernachtung und Verpflegung auf Reisen.",
  "trainerstunden.expenses.standard.categoryHint.insurance":
    "Haftpflicht, Berufsunfähigkeit oder andere Versicherungsbeiträge.",
  "trainerstunden.expenses.standard.categoryHint.marketing":
    "Flyer, Anzeigen, Website oder sonstige Werbung.",
  "trainerstunden.expenses.standard.categoryHint.software":
    "Apps, Buchhaltung, Terminplanung und Online-Tools.",
  "trainerstunden.expenses.standard.categoryHint.office":
    "Porto, Telefon, Büromaterial und Verwaltungskosten.",
  "trainerstunden.expenses.standard.categoryHint.other":
    "Ausgaben, die in keine andere Kategorie passen.",
  "trainerstunden.expenses.category.court_fees": "Platzgebühren",
  "trainerstunden.expenses.category.equipment": "Equipment",
  "trainerstunden.expenses.category.training_education": "Fortbildung",
  "trainerstunden.expenses.category.travel": "Reisekosten",
  "trainerstunden.expenses.category.insurance": "Versicherung",
  "trainerstunden.expenses.category.club_membership": "Vereinsbeitrag",
  "trainerstunden.expenses.category.marketing": "Marketing & Werbung",
  "trainerstunden.expenses.category.software": "Software & Tools",
  "trainerstunden.expenses.category.office": "Büro & Verwaltung",
  "trainerstunden.expenses.category.other": "Sonstiges",
  "trainerstunden.expenses.proportional.annualAmountLabel": "Jahresbeitrag",
  "trainerstunden.expenses.proportional.annualAmountPlaceholder": "z. B. 240",
  "trainerstunden.expenses.proportional.professionalPercentLabel":
    "Anteil der beruflichen Nutzung (eigene Einschätzung)",
  "trainerstunden.expenses.proportional.professionalPercentPlaceholder":
    "z. B. 50",
  "trainerstunden.expenses.proportional.profitAmountLabel":
    "Betrag für die Gewinnermittlung",
  "trainerstunden.expenses.proportional.taxHint":
    "Die steuerliche Anerkennung hängt vom Einzelfall ab. Im Zweifel bitte steuerlichen Rat einholen.",
  "trainerstunden.ausgaben.extract.action": "Aus Beleg übernehmen",
  "trainerstunden.ausgaben.receiptStep.title": "Beleg hochladen",
  "trainerstunden.ausgaben.receiptStep.subtitle":
    "Zuerst Beleg anfügen, dann per KI auslesen lassen — danach Vorschläge prüfen und übernehmen.",
  "trainerstunden.ausgaben.receiptStep.extractAction": "Beleg auslesen",
  "trainerstunden.ausgaben.receiptStep.uploadFirst":
    "Noch kein Beleg — Datei wählen, Foto aufnehmen oder Screenshot einfügen (Strg+V / ⌘+V).",
  "trainerstunden.ausgaben.extractReview.title": "Vorschläge aus dem Beleg",
  "trainerstunden.ausgaben.extractReview.subtitle":
    "Bitte prüfen. Bei mehreren Positionen nur die für die Abrechnung relevanten auswählen.",
  "trainerstunden.ausgaben.extractReview.orderNumber": "Bestell- / Belegnummer",
  "trainerstunden.ausgaben.extractReview.orderNumberMissing": "nicht erkannt",
  "trainerstunden.ausgaben.extractReview.vendorHint": "Händler / Plattform",
  "trainerstunden.ausgaben.extractReview.suggestedCategory":
    "Vorgeschlagene Kategorie",
  "trainerstunden.ausgaben.extractReview.suggestedCategoryMissing":
    "nicht erkannt",
  "trainerstunden.ausgaben.extractReview.vendorAddressTitle": "Händler-Adresse",
  "trainerstunden.ausgaben.extractReview.fieldMissing": "nicht erkannt",
  "trainerstunden.ausgaben.extractReview.receiptPreviewTitle": "Beleg-Vorschau",
  "trainerstunden.ausgaben.extractReview.receiptPreviewAlt":
    "Hochgeladener Beleg",
  "trainerstunden.ausgaben.extractReview.receiptPreviewHint":
    "Maus oder Finger über den Beleg bewegen — die Lupe vergrößert zum Ablesen.",
  "trainerstunden.ausgaben.extractReview.receiptPreviewLoading":
    "Beleg wird geladen…",
  "trainerstunden.ausgaben.extractReview.receiptPreviewError":
    "Beleg-Vorschau konnte nicht geladen werden.",
  "trainerstunden.ausgaben.extractReview.receiptPreviewExpand": "Vergrößern",
  "trainerstunden.ausgaben.extractReview.receiptPreviewPdfNote":
    "PDF: erste Seite als Bild.",
  "trainerstunden.ausgaben.extractReview.receiptPreviewPdfMultiPage":
    "Mehrseitiges PDF — Seiten unten umschalten.",
  "trainerstunden.ausgaben.extractReview.receiptPreviewPagerLabel":
    "Belegseiten",
  "trainerstunden.ausgaben.extractReview.receiptPreviewPageOf":
    "Seite {page} von {total}",
  "trainerstunden.ausgaben.extractReview.receiptPreviewPrevPage": "Zurück",
  "trainerstunden.ausgaben.extractReview.receiptPreviewNextPage": "Weiter",
  "trainerstunden.ausgaben.extractReview.clickToEdit": "Zum Bearbeiten klicken",
  "trainerstunden.ausgaben.extractReview.lineItemDescription": "Position",
  "trainerstunden.ausgaben.extractReview.lineItemsIntro":
    "Positionen — nur markierte fließen in den Betrag ein:",
  "trainerstunden.ausgaben.extractReview.selectedSum":
    "Summe der Auswahl: {amountWithCurrency}",
  "trainerstunden.ausgaben.extractReview.applyAction": "Vorschläge übernehmen",
  "trainerstunden.ausgaben.extractReview.dismissAction": "Verwerfen",
  "trainerstunden.ausgaben.extractReview.feedbackAction": "Auslesen war falsch",
  "trainerstunden.ausgaben.extractReview.applied":
    "Vorschläge in die Maske übernommen — bitte prüfen und speichern.",
  "trainerstunden.ausgaben.extractFeedback.reportAction": "Auslesen war falsch",
  "trainerstunden.ausgaben.extractFeedback.title": "Belegauslesen korrigieren",
  "trainerstunden.ausgaben.extractFeedback.subtitle":
    "Korrigierte Werte werden übernommen und für die Qualitätsauswertung gespeichert.",
  "trainerstunden.ausgaben.extractFeedback.saveAction": "Korrektur übernehmen",
  "trainerstunden.ausgaben.extractFeedback.saved": "Korrektur übernommen.",
  "trainerstunden.ausgaben.extractQuality.title":
    "Auslese-Qualität nach Händler",
  "trainerstunden.ausgaben.extractQuality.subtitle":
    "Trefferquote pro Feld aus bestätigten und korrigierten Belegen.",
  "trainerstunden.ausgaben.extractQuality.vendor": "Händler",
  "trainerstunden.ausgaben.extractQuality.samples": "Belege",
  "trainerstunden.ausgaben.extractQuality.rate": "{value} %",
  "trainerstunden.ausgaben.extractQuality.field.expenseDate": "Datum",
  "trainerstunden.ausgaben.extractQuality.field.vendor": "Anbieter",
  "trainerstunden.ausgaben.extractQuality.field.orderNumber": "Belegnr.",
  "trainerstunden.ausgaben.extractQuality.field.amountEur": "Betrag",
  "trainerstunden.ausgaben.appliedLineItems.title": "Positionen aus dem Beleg",
  "trainerstunden.ausgaben.extract.busy": "Beleg wird gelesen…",
  "trainerstunden.ausgaben.extract.noFile":
    "Bitte zuerst einen Beleg hinzufügen.",
  "trainerstunden.ausgaben.extract.failed":
    "Beleg konnte nicht ausgelesen werden.",
  "trainerstunden.ausgaben.extract.error.backend":
    "Auslesen ist derzeit nicht erreichbar (API-Backend).",
  "trainerstunden.ausgaben.extract.error.notConfigured":
    "KI-Auslesen ist nicht konfiguriert. Lokal: CLOUDFLARE_ACCOUNT_ID und CLOUDFLARE_API_TOKEN in server/.env setzen, API neu starten.",
  "trainerstunden.ausgaben.extract.error.modelAgreement":
    "Meta-Llama-Lizenz noch nicht akzeptiert. Einmalig im Terminal ausführen: node scripts/accept-cloudflare-llama-agreement.mjs (server/.env muss CLOUDFLARE_* enthalten). Danach Beleg erneut auslesen.",
  "trainerstunden.ausgaben.extract.error.detail":
    "Auslesen fehlgeschlagen: {detail}",
  "trainerstunden.ausgaben.extract.error.empty":
    "Im Beleg wurden keine verwertbaren Felder erkannt — bitte manuell erfassen.",
  "trainerstunden.ausgaben.extract.success":
    "Beleg ausgelesen — Vorschläge unten prüfen.",
  "trainerstunden.ausgaben.extract.reviewHint":
    "Gelb markierte Felder stammen aus der KI — keine Steuerberatung, bitte prüfen.",
  "trainerstunden.ausgaben.extractFeedback.title": "Auslesen korrigieren",
  "trainerstunden.ausgaben.extractFeedback.subtitle":
    "Bitte die korrekten Werte eintragen — sie ersetzen die KI-Vorschläge in der Vorschau.",
  "trainerstunden.ausgaben.extractFeedback.applyAction": "Korrektur übernehmen",
  "trainerstunden.ausgaben.extractQuality.title":
    "Auslese-Qualität nach Händler",
  "trainerstunden.ausgaben.extractQuality.subtitle":
    "Aus gespeicherten Belegen: wie oft Vorschläge übernommen oder korrigiert wurden.",
  "trainerstunden.ausgaben.extractQuality.vendorCol": "Händler",
  "trainerstunden.ausgaben.extractQuality.eventsCol": "Belege",
  "trainerstunden.ausgaben.extractQuality.acceptedCol": "Übernommen",
  "trainerstunden.ausgaben.extractQuality.correctedCol": "Korrigiert",
  "trainerstunden.ausgaben.extractQuality.missesCol": "Fehlerfelder",
  "trainerstunden.ausgaben.extractQuality.noMisses": "—",
  "trainerstunden.ausgaben.extractQuality.field.expenseDate": "Datum",
  "trainerstunden.ausgaben.extractQuality.field.vendor": "Händler",
  "trainerstunden.ausgaben.extractQuality.field.orderNumber": "Bestellnr.",
  "trainerstunden.ausgaben.extractQuality.field.amountEur": "Betrag",
  "trainerstunden.ausgaben.vendorCreate.prompt":
    "Händler noch nicht in Kontakten? Belegdaten als Händler-Kontakt speichern.",
  "trainerstunden.ausgaben.vendorCreate.action": "Händler anlegen",
  "trainerstunden.ausgaben.vendorCreate.title": "Händler in Kontakten anlegen",
  "trainerstunden.ausgaben.vendorCreate.subtitle":
    "Name und Adresse stammen aus dem Beleg — bitte prüfen und ergänzen.",
  "trainerstunden.ausgaben.vendorCreate.save": "Händler speichern",
  "trainerstunden.ausgaben.vendorCreate.busy": "Speichern…",
  "trainerstunden.ausgaben.vendorCreate.success":
    "Händler in Kontakten angelegt.",
  "trainerstunden.ausgaben.vendorCreate.failed":
    "Händler konnte nicht angelegt werden.",
  "trainerstunden.ausgaben.vendorCreate.failedDuplicateName":
    "Händler konnte nicht angelegt werden: Ein Kontakt mit diesem Namen existiert bereits. Bitte in Kontakten prüfen oder die Rolle „Händler“ setzen.",
  "trainerstunden.ausgaben.vendorCreate.failedMissingVendor":
    "Händler konnte nicht angelegt werden: Kein gültiger Firmenname erkannt.",
  "trainerstunden.ausgaben.vendorCreate.failedContactSource":
    "Händler konnte nicht angelegt werden: Datenbank-Migration für Händler-Kontakte fehlt noch (contact_source vendor).",
  "trainerstunden.ausgaben.vendorCreate.failedPermission":
    "Händler konnte nicht angelegt werden: Keine Berechtigung zum Anlegen von Kontakten.",
  "trainerstunden.ausgaben.vendorAutoCreate.success":
    "Händler „{vendor}“ wurde in Kontakten angelegt.",
  "trainerstunden.ausgaben.vendorCreate.existingHint":
    "Dieser Händler ist bereits als Kontakt hinterlegt.",
  "trainerstunden.ausgaben.vendorCreate.openContact": "Kontakt öffnen",
  "trainerstunden.ausgaben.vendorSuggest.title": "Bekannter Kontakt erkannt",
  "trainerstunden.ausgaben.vendorSuggest.subtitle":
    "Name und Adresse aus dem Beleg passen zu einem bestehenden Kontakt — bitte prüfen und bestätigen.",
  "trainerstunden.ausgaben.vendorSuggest.confirmedTitle": "Kontakt übernommen",
  "trainerstunden.ausgaben.vendorSuggest.confirmedSubtitle":
    "Der Händlername in der Ausgabe wurde auf den bestehenden Kontakt gesetzt.",
  "trainerstunden.ausgaben.vendorSuggest.extractedLabel": "Aus dem Beleg",
  "trainerstunden.ausgaben.vendorSuggest.contactLabel": "Bestehender Kontakt",
  "trainerstunden.ausgaben.vendorSuggest.matchReason":
    "Übereinstimmung: {reasons}",
  "trainerstunden.ausgaben.vendorSuggest.confirmAction": "Kontakt übernehmen",
  "trainerstunden.ausgaben.vendorSuggest.dismissAction": "Nicht dieser Kontakt",
  "trainerstunden.ausgaben.vendorSuggest.confirmSuccess":
    "Kontakt für diese Ausgabe übernommen.",
  "trainerstunden.ausgaben.vendorSuggest.matchKey.name": "Name",
  "trainerstunden.ausgaben.vendorSuggest.matchKey.namePartial":
    "ähnlicher Name",
  "trainerstunden.ausgaben.vendorSuggest.matchKey.postalCode": "PLZ",
  "trainerstunden.ausgaben.vendorSuggest.matchKey.city": "Ort",
  "trainerstunden.ausgaben.vendorSuggest.matchKey.street": "Straße",
  "trainerstunden.ausgaben.vendorSuggest.matchKey.streetPartial":
    "ähnliche Straße",
  "trainerstunden.ausgaben.vendorSuggest.matchKey.houseNumber": "Hausnummer",
  "trainerstunden.ausgaben.vendorSuggest.matchKey.vendorRole": "Händler-Rolle",
  "trainerstunden.ausgaben.vendorSuggest.matchKey.addressBundle": "Adresse",
  "trainerstunden.ausgaben.vendorSuggest.matchKey.confirmed": "bestätigt",
  "trainerstunden.ausgaben.save.action": "Ausgabe speichern",
  "trainerstunden.ausgaben.save.busy": "Speichern…",
  "trainerstunden.ausgaben.save.success": "Ausgabe gespeichert.",
  "trainerstunden.ausgaben.save.successWithReceipt":
    "Ausgabe gespeichert — Beleg „{filename}“ wurde angehängt.",
  "trainerstunden.ausgaben.save.receiptAttachHint":
    "Beleg „{filename}“ wird mit der Ausgabe gespeichert und angehängt.",
  "trainerstunden.ausgaben.save.error.receiptUpload":
    "Beleg konnte nicht hochgeladen werden.",
  "trainerstunden.ausgaben.save.error.receiptType":
    "Belegformat nicht unterstützt (PDF, JPG, PNG oder WebP).",
  "trainerstunden.ausgaben.save.error.receiptTooLarge":
    "Beleg ist zu groß (max. 10 MB).",
  "trainerstunden.ausgaben.save.failed": "Speichern fehlgeschlagen.",
  "trainerstunden.ausgaben.save.failedWithReason":
    "Speichern fehlgeschlagen ({reason}).",
  "trainerstunden.ausgaben.save.error.detail":
    "Speichern fehlgeschlagen: {detail}",
  "trainerstunden.ausgaben.save.error.noSupabase":
    "Speichern fehlgeschlagen: Keine Datenbankverbindung.",
  "trainerstunden.ausgaben.save.missingContext":
    "Mandant oder Berechtigung fehlt.",
  "trainerstunden.ausgaben.save.error.missing-date": "Bitte ein Datum angeben.",
  "trainerstunden.ausgaben.save.error.missing-amount":
    "Bitte einen Betrag angeben.",
  "trainerstunden.ausgaben.save.error.invalid-amount":
    "Bitte einen gültigen Betrag angeben.",
  "trainerstunden.ausgaben.save.error.fx-failed":
    "Wechselkurs für USD konnte nicht ermittelt werden — Datum prüfen oder später erneut versuchen.",
  "trainerstunden.ausgaben.save.error.missing-annual-amount":
    "Bitte den Jahresbeitrag angeben.",
  "trainerstunden.ausgaben.save.error.invalid-annual-amount":
    "Bitte einen gültigen Jahresbeitrag angeben.",
  "trainerstunden.ausgaben.delete.failed": "Löschen fehlgeschlagen.",
  "trainerstunden.ausgaben.delete.error.detail":
    "Löschen fehlgeschlagen: {detail}",
  "trainerstunden.ausgaben.list.title": "Erfasste Ausgaben",
  "trainerstunden.ausgaben.list.loading": "Lade Ausgaben…",
  "trainerstunden.ausgaben.list.empty": "Noch keine Ausgaben erfasst.",
  "trainerstunden.ausgaben.list.date": "Datum",
  "trainerstunden.ausgaben.list.category": "Kategorie",
  "trainerstunden.ausgaben.list.vendor": "Anbieter",
  "trainerstunden.ausgaben.list.amount": "Betrag",
  "trainerstunden.ausgaben.list.receipt": "Beleg",
  "trainerstunden.ausgaben.list.openReceipt": "Beleg öffnen",
  "trainerstunden.ausgaben.list.receiptOpening": "Öffne…",
  "trainerstunden.ausgaben.list.noReceipt": "—",
  "trainerstunden.ausgaben.list.receiptOpenFailed":
    "Beleg konnte nicht geöffnet werden.",
  "trainerstunden.ausgaben.list.delete": "Löschen",
  "trainerstunden.ausgaben.list.reference": "Nr.",
  "trainerstunden.ausgaben.list.edit": "Bearbeiten",
  "trainerstunden.ausgaben.list.lineCountBadge": "{count} Positionen",
  "trainerstunden.ausgaben.list.expandLineItemsAria":
    "{count} Positionen einblenden",
  "trainerstunden.ausgaben.list.collapseLineItemsAria": "Positionen ausblenden",
  "trainerstunden.ausgaben.edit.title": "Ausgabe bearbeiten",
  "trainerstunden.ausgaben.edit.save": "Speichern",
  "trainerstunden.ausgaben.edit.saved": "Ausgabe gespeichert.",
  "trainerstunden.ausgaben.edit.savedWithReceipt":
    "Ausgabe gespeichert. Beleg „{filename}“ angehängt.",
  "trainerstunden.ausgaben.edit.receiptExisting": "Aktueller Beleg: {name}",
  "trainerstunden.ausgaben.edit.receiptOpen": "Beleg öffnen",
  "trainerstunden.ausgaben.edit.receiptReplaceHint":
    "Neuen Beleg hochladen, um den vorhandenen zu ersetzen.",
  "trainerstunden.ausgaben.edit.currencyToUsdHint":
    "Währung auf USD umgestellt — bitte den Rechnungsbetrag in USD eingeben. Der EUR-Wert wird beim Speichern per Tageskurs berechnet.",
  "trainerstunden.ausgaben.edit.currencyToEurHint":
    "Währung auf EUR umgestellt — Betrag entspricht dem EUR-Wert für die Bilanz.",
  "trainerstunden.ausgaben.edit.failed":
    "Ausgabe konnte nicht gespeichert werden.",
  "trainerstunden.ausgaben.edit.notSupported":
    "Diese Ausgabe kann hier nicht bearbeitet werden.",
  "trainerstunden.bilanzierung.title": "Bilanzierung",
  "trainerstunden.bilanzierung.subtitle":
    "Einnahmen und Ausgaben gegenüberstellen und den geschäftlichen Überblick behalten.",
  "trainerstunden.bilanzierung.incomeBasisHint":
    "Einnahmen zählen als Zahlungseingänge (Datum der Buchung). Rechnungen ohne separaten Zahlungseintrag zählen erst mit dem beglichenen Betrag — offene Rechnungen nicht. Ausgaben kommen aus der Ausgabenerfassung.",
  "trainerstunden.bilanzierung.yearLabel": "Jahr",
  "trainerstunden.bilanzierung.kpi.income": "Einnahmen",
  "trainerstunden.bilanzierung.kpi.incomeMeta": "{count} Buchungen",
  "trainerstunden.bilanzierung.kpi.expenses": "Ausgaben",
  "trainerstunden.bilanzierung.kpi.expensesMeta": "{count} Belege",
  "trainerstunden.bilanzierung.kpi.saldo": "Saldo",
  "trainerstunden.bilanzierung.kpi.saldoMeta": "Jahr {year}",
  "trainerstunden.bilanzierung.chart.title": "Monatsverlauf {year}",
  "trainerstunden.bilanzierung.chart.aria":
    "Säulendiagramm Einnahmen und Ausgaben nach Monat im Jahr {year}",
  "trainerstunden.bilanzierung.chart.legendIncome": "Einnahmen",
  "trainerstunden.bilanzierung.chart.legendExpenses": "Ausgaben",
  "trainerstunden.bilanzierung.incomeSectionTitle": "Einnahmen",
  "trainerstunden.bilanzierung.expenseSectionTitle": "Ausgaben",
  "trainerstunden.bilanzierung.incomeEmpty":
    "Keine Zahlungseingänge in diesem Jahr.",
  "trainerstunden.bilanzierung.expenseEmpty": "Keine Ausgaben in diesem Jahr.",
  "trainerstunden.bilanzierung.expensesLoading": "Ausgaben werden geladen…",
  "trainerstunden.bilanzierung.table.date": "Datum",
  "trainerstunden.bilanzierung.table.source": "Quelle",
  "trainerstunden.bilanzierung.table.expense": "Ausgabe",
  "trainerstunden.bilanzierung.table.amount": "Betrag",
  "trainerstunden.bilanzierung.table.noDate": "—",
  "trainerstunden.bilanzierung.source.payment": "Zahlungseingang",
  "trainerstunden.bilanzierung.source.statement": "Rechnung (beglichen)",
  "trainerstunden.bilanzierung.placeholder.body":
    "Die Bilanzierung wird Einnahmen aus dem Rechnungswesen mit erfassten Ausgaben zusammenführen.",
  "trainerstunden.bilanzierung.placeholder.feature.income":
    "Einnahmen aus Rechnungen und Zahlungseingängen",
  "trainerstunden.bilanzierung.placeholder.feature.expenses":
    "Ausgaben aus der Ausgabenerfassung",
  "trainerstunden.bilanzierung.placeholder.feature.period":
    "Auswertung nach Monat, Quartal und Jahr",
  "trainerstunden.rechnungswesen.nav.aria": "Kunden oder Trainer",
  "trainerstunden.rechnungswesen.pillars.families": "Kunden",
  "trainerstunden.rechnungswesen.pillars.trainers": "Trainer",
  "trainerstunden.rechnungswesen.pillars.familiesDesc":
    "Teilnehmer, Rechnungen und offene Posten.",
  "trainerstunden.rechnungswesen.pillars.trainersDesc":
    "Honorare und Trainerauszahlungen.",
  "trainerstunden.rechnungswesen.pillars.trainersPageTitle": "Trainer-Honorare",
  "trainerstunden.rechnungswesen.pillars.trainersPageSubtitle":
    "Auszahlungen und Abrechnungen für Trainer.",
  "trainerstunden.rechnungswesen.families.billing": "Abrechnungen",
  "trainerstunden.rechnungswesen.families.invoices": "Rechnungen",
  "trainerstunden.rechnungswesen.families.nav.aria": "Teilnehmer-Abrechnung",
  "trainerstunden.rechnungswesen.invoices.nav.aria": "Rechnungsstatus",
  "trainerstunden.rechnungswesen.invoices.status.draft": "Entwurf",
  "trainerstunden.rechnungswesen.invoices.status.sent": "Versandt",
  "trainerstunden.rechnungswesen.invoices.status.closed": "Abgeschlossen",
  "trainerstunden.coachBottomNav.zahlungen": "Einnahmen",
  "trainerstunden.coachBottomNav.abrechnen": "Abrechnen",
  "trainerstunden.coachBottomNav.rechnungen": "Rechnungen",
  "trainerstunden.coachBottomNav.rechnungswesen": "Rechnungswesen",
  "trainerstunden.coachBottomNav.moreMenu.sectionFinance": "Finanzen",
  "trainerstunden.tabs.navDesktop.agenda": "Tagesplan",
  "trainerstunden.tabs.navDesktop.settlementTrainer": "Auszahlungen",
  "trainerstunden.tabs.navDesktop.payments": "Einnahmen",
  "trainerstunden.tabs.navDesktop.masterdata": "Verwaltung",
  "trainerstunden.masterdata.tabs.aria": "Stammdaten Tabs",
  "trainerstunden.masterdata.tabs.sessions": "Trainingsstunden",
  "trainerstunden.masterdata.tabs.people": "Spieler",
  "trainerstunden.masterdata.tabs.contacts": "Kontakte",
  "trainerstunden.masterdata.tabs.billing": "Auswertung",
  "trainerstunden.masterdata.tabs.locations": "Orte",
  "trainerstunden.masterdata.tabs.trainers": "Trainer",
  "trainerstunden.masterdata.selfProfile.title": "Meine Daten",
  "trainerstunden.masterdata.tabs.planningFields": "Neues Training",
  "trainerstunden.masterdata.tabs.invoiceLayout": "Rechnungslayout",
  "trainerstunden.masterdata.tabs.dataExport": "Datenexport",
  "trainerstunden.masterdata.tabs.settings": "Einstellungen",
  "trainerstunden.masterdata.tabs.lists": "Auswahllisten",
  "trainerstunden.dataExport.title": "Datenexport",
  "trainerstunden.dataExport.lead":
    "Lade Trainingstermine, Rechnungen und Zahlungen als CSV herunter — Excel öffnet die Datei direkt (Semikolon, UTF-8).",
  "trainerstunden.dataExport.filters.aria": "Exportfilter",
  "trainerstunden.dataExport.filters.trainer": "Trainer",
  "trainerstunden.dataExport.filters.trainerAll": "Alle Trainer",
  "trainerstunden.dataExport.filters.from": "Von",
  "trainerstunden.dataExport.filters.to": "Bis",
  "trainerstunden.dataExport.filters.hint":
    "Rechnungen werden nach Abrechnungsmonat gefiltert, Zahlungen und Termine nach Datum im gewählten Zeitraum.",
  "trainerstunden.dataExport.sessions.title": "Trainingstermine",
  "trainerstunden.dataExport.sessions.hint":
    "Bestätigte und geplante Termine im Filter — ohne gelöschte Einträge.",
  "trainerstunden.dataExport.statements.title": "Rechnungen",
  "trainerstunden.dataExport.statements.hint":
    "Alle Rechnungsstatus inkl. Entwürfe, versendet, bezahlt und storniert.",
  "trainerstunden.dataExport.payments.title": "Zahlungen",
  "trainerstunden.dataExport.payments.hint":
    "Verbuchte Zahlungseingänge mit Zuordnung zur Rechnung.",
  "trainerstunden.dataExport.downloadCsv": "CSV herunterladen",
  "trainerstunden.dataExport.rowCount": "{count} Datensätze",
  "trainerstunden.dataExport.columns.sessionDate": "Datum",
  "trainerstunden.dataExport.columns.startTime": "Beginn",
  "trainerstunden.dataExport.columns.durationMin": "Dauer (Min.)",
  "trainerstunden.dataExport.columns.trainer": "Trainer",
  "trainerstunden.dataExport.columns.location": "Ort",
  "trainerstunden.dataExport.columns.status": "Status",
  "trainerstunden.dataExport.columns.participants": "Teilnehmer",
  "trainerstunden.dataExport.columns.targetGroup": "Zielgruppe",
  "trainerstunden.dataExport.columns.sessionFocus": "Schwerpunkt",
  "trainerstunden.dataExport.columns.pricingType": "Preisart",
  "trainerstunden.dataExport.columns.rateOrFixed": "Satz / Fixpreis (€)",
  "trainerstunden.dataExport.columns.seriesId": "Serien-ID",
  "trainerstunden.dataExport.columns.sessionId": "Termin-ID",
  "trainerstunden.dataExport.columns.invoiceNumber": "Rechnungsnummer",
  "trainerstunden.dataExport.columns.periodMonth": "Abrechnungsmonat",
  "trainerstunden.dataExport.columns.documentMonth": "Rechnungsmonat",
  "trainerstunden.dataExport.columns.sentDate": "Versanddatum",
  "trainerstunden.dataExport.columns.dueDate": "Fällig am",
  "trainerstunden.dataExport.columns.recipient": "Empfänger",
  "trainerstunden.dataExport.columns.invoiceStatus": "Status",
  "trainerstunden.dataExport.columns.originalAmount": "Original (€)",
  "trainerstunden.dataExport.columns.correctionAmount": "Korrekturen (€)",
  "trainerstunden.dataExport.columns.effectiveAmount": "Effektiv (€)",
  "trainerstunden.dataExport.columns.paidAmount": "Bezahlt (€)",
  "trainerstunden.dataExport.columns.openAmount": "Offen (€)",
  "trainerstunden.dataExport.columns.statementId": "Rechnungs-ID",
  "trainerstunden.dataExport.columns.paymentDate": "Zahlungsdatum",
  "trainerstunden.dataExport.columns.paymentAmount": "Betrag (€)",
  "trainerstunden.dataExport.columns.paymentMethod": "Zahlungsart",
  "trainerstunden.dataExport.columns.payer": "Zahler (Person)",
  "trainerstunden.dataExport.columns.invoiceRecipient": "Rechnungsempfänger",
  "trainerstunden.dataExport.columns.notes": "Notiz",
  "trainerstunden.dataExport.columns.paymentId": "Zahlungs-ID",
  "trainerstunden.referenceLists.title": "Auswahllisten",
  "trainerstunden.referenceLists.subtitle":
    "Gilt für den gesamten Verein — alle Trainer und Koordinatoren nutzen dieselben Auswahllisten. Bezeichnungen und Reihenfolge sind frei pflegbar; Systembedeutung hängt an den festen Einträgen.",
  "trainerstunden.referenceLists.audit.open": "Änderungsprotokoll",
  "trainerstunden.referenceLists.audit.title": "Änderungsprotokoll",
  "trainerstunden.referenceLists.audit.subtitle":
    "Wer hat wann Einträge in dieser Auswahlliste geändert?",
  "trainerstunden.referenceLists.audit.subtitleForList":
    "Änderungen an „{listTitle}“",
  "trainerstunden.referenceLists.audit.empty":
    "Noch keine protokollierten Änderungen.",
  "trainerstunden.referenceLists.audit.footer":
    "Es werden nur Änderungen ab der Einführung des Protokolls gespeichert.",
  "trainerstunden.referenceLists.audit.errors.unavailable":
    "Das Änderungsprotokoll ist in der Datenbank noch nicht verfügbar. Bitte Migration ausrollen.",
  "trainerstunden.referenceLists.audit.errors.loadFailed":
    "Änderungsprotokoll konnte nicht geladen werden.",
  "trainerstunden.referenceLists.audit.action.entry_added":
    "Eintrag hinzugefügt",
  "trainerstunden.referenceLists.audit.action.entry_removed":
    "Eintrag entfernt",
  "trainerstunden.referenceLists.audit.action.entry_enabled":
    "Eintrag aktiviert",
  "trainerstunden.referenceLists.audit.action.entry_disabled":
    "Eintrag deaktiviert",
  "trainerstunden.referenceLists.audit.action.entry_label_changed":
    "Bezeichnung geändert",
  "trainerstunden.referenceLists.audit.action.entry_default_changed":
    "Standard gesetzt",
  "trainerstunden.referenceLists.audit.action.entry_reordered":
    "Reihenfolge geändert",
  "trainerstunden.referenceLists.semantic.display.badge": "Stammdaten",
  "trainerstunden.referenceLists.semantic.display.hint":
    "Frei pflegbare Auswahl — Bezeichnungen, Reihenfolge und eigene Einträge haben keine feste Systemlogik.",
  "trainerstunden.referenceLists.semantic.system.badge": "Systembedeutung",
  "trainerstunden.referenceLists.semantic.system.hint":
    "Feste Einträge haben System-IDs. Eigene Werte werden ggf. intern zusammengeführt (z. B. als „Sonstiges“).",
  "trainerstunden.referenceLists.semantic.system.sessionCancelReasons.hint":
    "Einträge entsprechen Termin-Statuswerten im System. Eigene Absagegründe sind nicht vorgesehen.",
  "trainerstunden.referenceLists.semantic.system.paymentEntryMethods.hint":
    "Zahlungsarten werden bei der Erfassung gespeichert. Neue Arten erscheinen in Auswahlen, Auswertungen kennen ggf. nur Standardwerte.",
  "trainerstunden.referenceLists.semantic.rules.badge": "Regelwerk aktiv",
  "trainerstunden.referenceLists.semantic.rules.hint":
    "Diese Werte steuern die Abrechnungslogik (Rhythmus, Fälligkeit). Bezeichnungen und Reihenfolge sind anpassbar; deaktivierte Einträge sind in Stammdaten nicht wählbar.",
  "trainerstunden.referenceLists.semantic.rules.billingFrequency.hint":
    "Legt fest, wann offene Leistungen in die Abrechnungs-Inbox kommen: direkt nach dem Termin (eine Rechnung je Termin), monatlich oder quartalsweise am Monatsende des Quartals.",
  "trainerstunden.referenceLists.semantic.rules.billingPaymentTiming.hint":
    "Legt die Fälligkeit fest: Im Voraus 14 Tage vor dem ersten Termin, nachgelagert 14 Tage nach dem letzten Termin der Rechnung.",
  "trainerstunden.referenceLists.semantic.rulesPlanned.badge":
    "Regelwerk geplant",
  "trainerstunden.referenceLists.semantic.rulesPlanned.hint":
    "Feste Systemwerte — Bezeichnungen dürfen angepasst werden. Eigene Optionen sind derzeit nicht vorgesehen, bis Geschäftsregeln daran angebunden sind.",
  "trainerstunden.referenceLists.semantic.rulesPlanned.billingFrequency.hint":
    "Steuert künftig, wann abgerechnet wird (z. B. pro Termin, monatlich). Aktuell Stammdaten ohne automatische Folgelogik.",
  "trainerstunden.referenceLists.semantic.rulesPlanned.billingPaymentTiming.hint":
    "Steuert künftig Voraus- vs. Nachzahlung. Aktuell Stammdaten ohne automatische Folgelogik.",
  "trainerstunden.referenceLists.semantic.noCustomEntries":
    "Eigene Einträge sind für diese Liste nicht vorgesehen.",
  "trainerstunden.referenceLists.sessionCancelReasons.title":
    "Termin-Absagegründe",
  "trainerstunden.referenceLists.sessionCancelReasons.hint":
    "Steuert die Gründe beim Absagen in Planung und Bestätigungen. Deaktivierte Einträge erscheinen nicht in der Auswahl.",
  "trainerstunden.referenceLists.sessionCancelReasons.requiredLabel":
    "Ausfallgrund als Pflichtfeld",
  "trainerstunden.referenceLists.sessionCancelReasons.requiredHint":
    "Standard: optional. Wenn aktiv, muss beim Absagen ein Ausfallgrund gewählt werden.",
  "trainerstunden.referenceLists.enabled": "Aktiv",
  "trainerstunden.referenceLists.builtinLabel":
    "Anzeigename (Standard: {{label}})",
  "trainerstunden.referenceLists.customLabel": "Eigener Eintrag",
  "trainerstunden.referenceLists.customLabelPlaceholder":
    "Bezeichnung eingeben",
  "trainerstunden.referenceLists.addCustom": "Eigenen Eintrag hinzufügen",
  "trainerstunden.referenceLists.entryKinds.reason.addCustom":
    "Eigenen Grund hinzufügen",
  "trainerstunden.referenceLists.entryKinds.reason.customLabel":
    "Eigener Grund",
  "trainerstunden.referenceLists.entryKinds.reason.customLabelPlaceholder":
    "z. B. Hallensperrung",
  "trainerstunden.referenceLists.entryKinds.option.addCustom":
    "Eigene Option hinzufügen",
  "trainerstunden.referenceLists.entryKinds.option.customLabel":
    "Eigene Option",
  "trainerstunden.referenceLists.entryKinds.option.customLabelPlaceholder":
    "z. B. Quartalsweise",
  "trainerstunden.referenceLists.entryKinds.paymentMethod.addCustom":
    "Eigene Zahlungsart hinzufügen",
  "trainerstunden.referenceLists.entryKinds.paymentMethod.customLabel":
    "Eigene Zahlungsart",
  "trainerstunden.referenceLists.entryKinds.paymentMethod.customLabelPlaceholder":
    "z. B. PayPal",
  "trainerstunden.referenceLists.entryKinds.payoutMethod.addCustom":
    "Eigenen Auszahlungsweg hinzufügen",
  "trainerstunden.referenceLists.entryKinds.payoutMethod.customLabel":
    "Eigener Auszahlungsweg",
  "trainerstunden.referenceLists.entryKinds.payoutMethod.customLabelPlaceholder":
    "z. B. Überweisung",
  "trainerstunden.referenceLists.entryKinds.targetGroup.addCustom":
    "Eigene Zielgruppe hinzufügen",
  "trainerstunden.referenceLists.entryKinds.targetGroup.customLabel":
    "Eigene Zielgruppe",
  "trainerstunden.referenceLists.entryKinds.targetGroup.customLabelPlaceholder":
    "z. B. Anfänger U12",
  "trainerstunden.referenceLists.entryKinds.courtFormat.addCustom":
    "Eigenes Platzformat hinzufügen",
  "trainerstunden.referenceLists.entryKinds.courtFormat.customLabel":
    "Eigenes Platzformat",
  "trainerstunden.referenceLists.entryKinds.courtFormat.customLabelPlaceholder":
    "z. B. 3:3",
  "trainerstunden.referenceLists.removeCustom": "Entfernen",
  "trainerstunden.referenceLists.inUseLocked": "Bereits verwendet",
  "trainerstunden.referenceLists.inUseRemoveBlocked":
    "Dieser Eintrag wurde bereits genutzt und kann nicht entfernt werden. Deaktivieren ist weiterhin möglich.",
  "trainerstunden.referenceLists.moveUp": "Nach oben",
  "trainerstunden.referenceLists.moveDown": "Nach unten",
  "trainerstunden.referenceLists.defaultEntry": "Standard",
  "trainerstunden.referenceLists.defaultEntryHint":
    "Als Standard festlegen — rückt automatisch an die erste Position, kann danach manuell verschoben werden.",
  "trainerstunden.referenceLists.defaultEntryAria": "Standard: {{label}}",
  "trainerstunden.referenceLists.disabledEntriesToggle":
    "Nicht mehr wählbar ({count})",
  "trainerstunden.referenceLists.save": "Speichern",
  "trainerstunden.referenceLists.saving": "Speichern…",
  "trainerstunden.referenceLists.saved": "Gespeichert",
  "trainerstunden.referenceLists.saveFailed": "Speichern fehlgeschlagen.",
  "trainerstunden.referenceLists.saveMissingTenant":
    "Mandant konnte nicht ermittelt werden.",
  "trainerstunden.referenceLists.saveNoSupabase":
    "Keine Verbindung zur Datenbank.",
  "trainerstunden.referenceLists.saveSchemaMissing":
    "Die Datenbank-Tabelle für Auswahllisten fehlt noch. Bitte die neuesten Migrationen ausführen.",
  "trainerstunden.referenceLists.savePermissionDenied":
    "Keine Berechtigung zum Speichern. Vereinsadmin, Vorstand oder Koordinator-Rolle erforderlich.",
  "trainerstunden.referenceLists.saveInvalidTenant":
    "Mandant ist ungültig oder nicht in der Datenbank hinterlegt.",
  "trainerstunden.referenceLists.customLabelRequired":
    "Bitte für alle aktiven eigenen Einträge eine Bezeichnung eingeben.",
  "trainerstunden.referenceLists.minActiveRequiredMandatory":
    "Mindestens ein Eintrag muss aktiv bleiben — sonst ist die Auswahl in den betroffenen Pflichtfeldern nicht mehr möglich.",
  "trainerstunden.referenceLists.minActiveRequiredOptional":
    "Ohne aktive Einträge ist die Auswahl nicht nutzbar. Aktiviere mindestens einen Eintrag oder blende das Feld unter Verwaltung → Neues Training aus.",
  "trainerstunden.referenceLists.hidePlanningFieldConfirm":
    "In „{{listTitle}}“ ist kein aktiver Eintrag mehr übrig. Soll „{{fieldLabel}}“ in der Terminplanung künftig ausgeblendet werden?",
  "trainerstunden.referenceLists.hidePlanningFieldFailed":
    "Die Auswahlliste wurde gespeichert, das Ausblenden auf der Seite „Neues Training“ ist fehlgeschlagen. Bitte unter Verwaltung → Neues Training prüfen.",
  "trainerstunden.referenceLists.catalog.comingSoon":
    "Diese Liste ist derzeit noch fest im System hinterlegt und wird hier später pflegbar.",
  "trainerstunden.referenceLists.billingCorrectionReasons.hint":
    "Steuert die Gründe bei Rechnungskorrekturen. Eigene Gründe werden intern als „Sonstiges“ gespeichert.",
  "trainerstunden.referenceLists.paymentEntryMethods.hint":
    "Steuert die Auswahl bei der Zahlungserfassung in Zahlungen und am Rechnungskonto.",
  "trainerstunden.referenceLists.catalog.sessionCancelReasons":
    "Termin-Absagegründe",
  "trainerstunden.referenceLists.catalog.sessionCancelReasonsHint":
    "Wird in Planung und Bestätigungen beim Absagen verwendet.",
  "trainerstunden.referenceLists.catalog.billingCorrectionReasons":
    "Abrechnungs-Korrekturgründe",
  "trainerstunden.referenceLists.catalog.billingCorrectionReasonsHint":
    "Gründe bei Rechnungskorrekturen im Rechnungswesen.",
  "trainerstunden.referenceLists.catalog.paymentMethods": "Zahlungsarten",
  "trainerstunden.referenceLists.catalog.paymentMethodsHint":
    "Auswahl bei Zahlungserfassung.",
  "trainerstunden.referenceLists.sections.disputes": "Reklamationen",
  "trainerstunden.referenceLists.sections.planning": "Planung",
  "trainerstunden.referenceLists.sections.trainers": "Trainer & Termine",
  "trainerstunden.referenceLists.sections.finance": "Abrechnung & Zahlungen",
  "trainerstunden.referenceLists.groups.featured": "Häufig bearbeitet",
  "trainerstunden.referenceLists.groups.planning": "Planung & Termine",
  "trainerstunden.referenceLists.groups.trainers": "Trainer-Stammdaten",
  "trainerstunden.referenceLists.groups.disputes": "Reklamationen",
  "trainerstunden.referenceLists.groups.disputesParents": "Spieler melden",
  "trainerstunden.referenceLists.groups.disputesTrainer": "Trainer entscheidet",
  "trainerstunden.referenceLists.groups.finance": "Abrechnung & Zahlungen",
  "trainerstunden.referenceLists.catalogSearch": "Liste suchen…",
  "trainerstunden.referenceLists.catalogMeta":
    "{{enabled}} aktiv · {{custom}} eigene",
  "trainerstunden.referenceLists.customizeLabel": "Anzeigename anpassen",
  "trainerstunden.referenceLists.overrideLabel": "Anzeigename",
  "trainerstunden.referenceLists.customSonstigesNote":
    "Eigene Einträge werden intern als „Sonstiges“ gespeichert.",
  "trainerstunden.referenceLists.selectList":
    "Bitte links eine Liste auswählen.",
  "trainerstunden.referenceLists.listNavAria": "Auswahllisten-Katalog",
  "trainerstunden.referenceLists.noSearchResults": "Keine Liste gefunden.",
  "trainerstunden.referenceLists.attendanceDisputeClaimReasons.title":
    "Anwesenheits-Reklamation (Spieler)",
  "trainerstunden.referenceLists.attendanceDisputeClaimReasons.hint":
    "Gründe, die Spieler bei einer Anwesenheits-Reklamation wählen können. Eigene Gründe werden intern als „Sonstiges“ gespeichert.",
  "trainerstunden.referenceLists.billingStatementDisputeClaimReasons.title":
    "Rechnungs-Reklamation (Kunde)",
  "trainerstunden.referenceLists.billingStatementDisputeClaimReasons.hint":
    "Gründe bei Reklamationen zu Rechnungen oder Einzelpositionen. Eigene Gründe werden intern als „Sonstiges“ gespeichert.",
  "trainerstunden.referenceLists.disputeAcceptReasons.title":
    "Reklamation annehmen (Trainer)",
  "trainerstunden.referenceLists.disputeAcceptReasons.hint":
    "Begründungen, wenn eine Reklamation angenommen wird.",
  "trainerstunden.referenceLists.disputeRejectReasons.title":
    "Reklamation ablehnen (Trainer)",
  "trainerstunden.referenceLists.disputeRejectReasons.hint":
    "Begründungen, wenn eine Reklamation abgelehnt wird.",
  "trainerstunden.referenceLists.sessionTargetGroups.title": "Zielgruppen",
  "trainerstunden.referenceLists.sessionTargetGroups.hint":
    "Auswahl bei der Terminplanung (Zielgruppe).",
  "trainerstunden.referenceLists.sessionCourtFormats.title": "Platzformate",
  "trainerstunden.referenceLists.sessionCourtFormats.hint":
    "Auswahl beim Platzformat in der Planung.",
  "trainerstunden.referenceLists.trainerAbsenceReasons.title":
    "Trainer-Abwesenheitsgründe",
  "trainerstunden.referenceLists.trainerAbsenceReasons.hint":
    "Gründe in den Abwesenheitszeiträumen eines Trainers.",
  "trainerstunden.referenceLists.billingFrequencies.title":
    "Abrechnungsrhythmus",
  "trainerstunden.referenceLists.billingFrequencies.hint":
    "Wie oft abgerechnet wird (Trainer- und Spieler-Stammdaten).",
  "trainerstunden.referenceLists.billingPaymentTimings.title":
    "Zahlungszeitpunkt",
  "trainerstunden.referenceLists.billingPaymentTimings.hint":
    "Voraus oder nachgelagert (Trainer- und Spieler-Stammdaten).",
  "trainerstunden.referenceLists.trainerPayoutFrequencies.title":
    "Trainer-Auszahlungsfrequenz",
  "trainerstunden.referenceLists.trainerPayoutFrequencies.hint":
    "Wie oft der Trainer ausbezahlt wird (Legacy-Felder).",
  "trainerstunden.referenceLists.trainerPayoutMethods.title":
    "Trainer-Auszahlungsweg",
  "trainerstunden.referenceLists.trainerPayoutMethods.hint":
    "Zahlungsweg an den Trainer (Legacy-Felder).",
  "trainerstunden.contact.postalAddress.street": "Straße",
  "trainerstunden.contact.postalAddress.houseNumber": "Hausnummer",
  "trainerstunden.contact.postalAddress.postalCode": "PLZ",
  "trainerstunden.contact.postalAddress.city": "Stadt",
  "trainerstunden.contact.postalAddress.country": "Land",
  "postalAddress.suggestion.message": "Meintest du {address}?",
  "postalAddress.suggestion.accept": "Übernehmen",
  "postalAddress.suggestion.keep": "So belassen",
  "masterdata.postalAddress.validation.houseNumber":
    "Hausnummer: höchstens 4 Ziffern, optional bis zu 2 Buchstaben (z. B. 12, 12a, 12-14).",
  "masterdata.postalAddress.validation.cityNoDigits":
    "Im Ortsnamen sind keine Ziffern erlaubt. PLZ gehört in die Spalte PLZ.",
  "masterdata.postalAddress.validation.postalCodeDe":
    "PLZ: genau 5 Ziffern (Deutschland).",
  "masterdata.postalAddress.validation.postalCodeAtCh":
    "PLZ: genau 4 Ziffern (Österreich/Schweiz).",
  "trainerstunden.contact.postalAddress.trainerSectionTitle": "Trainer-Adresse",
  "trainerstunden.contact.postalAddress.trainerSectionHint":
    "Geschäftsadresse des Trainers für Abrechnung und Korrespondenz. Kann von der Spieler- oder Rechnungsadresse abweichen.",
  "trainerstunden.contact.postalAddress.playerSectionTitle": "Postadresse",
  "trainerstunden.contact.postalAddress.playerSectionHint":
    "Postadresse des Kontakts. Wird in der gemeinsamen Kontaktliste geführt und kann von der Trainer-Adresse abweichen.",
  "trainerstunden.contact.postalAddress.vendorSectionTitle": "Händler-Adresse",
  "trainerstunden.contact.postalAddress.vendorSectionHint":
    "Geschäftsadresse des Händlers — Straße, PLZ und Ort wie bei Rechnungsempfängern.",
  "trainerstunden.contact.postalAddress.copyToPlayer":
    "Geschäftsadresse in Spieleradresse übernehmen",
  "trainerstunden.contact.postalAddress.copyToTrainer":
    "Spieleradresse in Geschäftsadresse übernehmen",
  "trainerstunden.contact.postalAddress.linkedPlayerSectionHint":
    "Spielerprofil „{name}“ — Adresse wird beim Speichern des Trainers mit aktualisiert.",
  "trainerstunden.contact.contactDetails.title": "Kontaktdaten",
  "trainerstunden.contact.contactDetails.hint":
    "E-Mail, Telefon und Geburtstag wie im Kontaktstamm. Die E-Mail wird auch als TrainingsDesk-Login verwendet, sofern kein separates Spielerprofil verknüpft ist.",
  "trainerstunden.contact.contactDetails.linkedPlayerHint":
    "Spielerprofil „{name}“ — Kontaktdaten werden beim Speichern des Trainers mit aktualisiert.",
  "trainerstunden.contact.contactDetails.loginEmailHint":
    "Gilt auch als Login-E-Mail für den TrainingsDesk-Zugang (Tab „Zugang“).",
  "trainerstunden.contact.contactDetails.saveFailed":
    "Die Kontaktdaten konnten nicht gespeichert werden.",
  "trainerstunden.contact.postalAddress.playerSaveFailed":
    "Die Spieleradresse konnte nicht gespeichert werden.",
  "trainerstunden.contact.postalAddress.schemaPendingWarning":
    "Die Adresse wurde nur vorläufig gespeichert (Freitext). Strukturierte Adressfelder sind in der Datenbank noch nicht verfügbar — bitte die ausstehende Migration anwenden und die Adresse danach erneut speichern.",
  "trainerstunden.contact.linkedPlayerHint":
    "Verknüpft mit Spielerprofil „{name}“. Trainer- und Spieleradresse werden getrennt gepflegt.",
  "trainerstunden.masterdata.billing.hint":
    "Rechnungsempfänger, Kontaktdaten und Abrechnungslogik pflegen. Hier gibt es bewusst keine Versand-Aktionen – das passiert in „Rechnungsstellung“.",
  "trainerstunden.masterdata.billing.filter.label": "Anzeige",
  "trainerstunden.masterdata.billing.filter.all": "Alle",
  "trainerstunden.masterdata.billing.filter.incompleteWithCount":
    "Unvollständig ({count})",
  "trainerstunden.masterdata.billing.filter.emptyIncomplete":
    "Keine unvollständigen Rechnungsdaten gefunden.",
  "trainerstunden.masterdata.billing.filter.lockedHint":
    "Dieser Modus ist auf „Unvollständig“ fixiert.",
  "trainerstunden.masterdata.billing.search.label": "Suche",
  "trainerstunden.masterdata.billing.search.placeholder":
    "Name, E‑Mail oder Telefon",
  "trainerstunden.masterdata.billing.search.noResults":
    "Keine Treffer für diese Suche.",
  "trainerstunden.masterdata.billing.form.title": "Rechnungsdaten bearbeiten",
  "trainerstunden.masterdata.billing.form.hint":
    "Passe Empfänger und Kontaktdaten an, damit Rechnungen per E‑Mail/WhatsApp verschickt werden können.",
  "trainerstunden.masterdata.billing.missingContactHint":
    "E‑Mail und/oder Mobilnummer fehlen beim Rechnungsempfänger.",
  "trainerstunden.masterdata.billing.todos.notice":
    "Offene To‑dos: Bitte ergänze fehlende Kontaktdaten beim Rechnungsempfänger.",
  "trainerstunden.masterdata.billing.todos.backToBilling":
    "Zurück zur Abrechnungsübersicht",
  "trainerstunden.masterdata.loading": "Lade Daten …",
  "trainerstunden.masterdata.people.todos.notice":
    "Es werden nur Spieler angezeigt, bei denen Abrechnungsdaten fehlen (E‑Mail/Handynummer oder Kontakt nicht gewählt).",
  "trainerstunden.masterdata.people.todos.empty":
    "Keine offenen Hinweise bei Spielern.",
  "trainerstunden.masterdata.people.todos.backToBilling":
    "Zurück zur Spielerabrechnung",
  "trainerstunden.masterdata.people.filter.label": "Filter",
  "trainerstunden.masterdata.people.filter.all": "Alle",
  "trainerstunden.masterdata.people.filter.incompleteWithCount":
    "Unvollständig ({count})",
  "trainerstunden.masterdata.people.filter.emptyIncomplete":
    "Keine unvollständigen Stammdaten gefunden.",
  "trainerstunden.masterdata.people.filter.lockedHint":
    "Dieser Filter ist aktuell über den Link „Spieler öffnen“ fest aktiviert.",
  "trainerstunden.masterdata.sessions": "Stunden",
  "trainerstunden.masterdata.sessionsHint":
    "Hier legst du Termine (einmalig oder wöchentlich) an.",
  "trainerstunden.onboarding.eyebrow": "Erst-Setup",
  "trainerstunden.onboarding.title": "Dein Trainer-Profil einrichten",
  "trainerstunden.onboarding.existingTrainerHint":
    "Vom Koordinator hinterlegte Angaben sind bereits ausgefüllt. Bitte prüfe nur noch die offenen Punkte.",
  "trainerstunden.onboarding.progress": "Schritt {current} von {total}",
  "trainerstunden.onboarding.stepsLabel": "Fortschritt",
  "trainerstunden.onboarding.prefilled": "Vorbereitet – bitte prüfen",
  "trainerstunden.onboarding.continue": "Bestätigen & weiter",
  "trainerstunden.onboarding.finish": "Setup abschließen",
  "trainerstunden.onboarding.signOut": "Abmelden",
  "trainerstunden.onboarding.steps.club.title": "Deine Vereine",
  "trainerstunden.onboarding.steps.club.hint":
    "Wo trainierst du? Suche deine Vereine — bei mehreren wählst du den Hauptverein. Fehlt ein Verein, kannst du ihn anlegen.",
  "trainerstunden.onboarding.steps.profile.title": "Persönliches Profil",
  "trainerstunden.onboarding.steps.profile.hint":
    "Name, Erreichbarkeit und Adresse für Abrechnung und Kommunikation.",
  "trainerstunden.onboarding.steps.training.title": "Training",
  "trainerstunden.onboarding.steps.training.hint":
    "Wann und wo trainierst du – und zu welchem Satz?",
  "trainerstunden.onboarding.steps.bookings.title": "Buchungen & Anwesenheit",
  "trainerstunden.onboarding.steps.bookings.hint":
    "Spieler können bei dir buchen. Lege fest, wie Anfragen und Anwesenheit laufen.",
  "trainerstunden.onboarding.steps.billing.title": "Abrechnung an Spieler",
  "trainerstunden.onboarding.steps.billing.hint":
    "Standard für Rechnungen an Spieler bzw. Kunden. Bei Einzel- und Serienterminen kannst du bei Bedarf abweichende Abrechnungsoptionen wählen. Honorar-Auszahlung legt der Trainingskoordinator fest.",
  "trainerstunden.onboarding.steps.players.title": "Spieler anlegen",
  "trainerstunden.onboarding.steps.players.hint":
    "Optional: Lege Spieler an, die du direkt planen kannst.",
  "trainerstunden.onboarding.club.fallback": "Dein Verein",
  "trainerstunden.onboarding.club.confirmLabel":
    "Ja, ich trainiere für {club} in TrainingsDesk.",
  "trainerstunden.onboarding.profile.phone": "Handynummer",
  "trainerstunden.onboarding.profile.loginEmail": "Login-E-Mail",
  "trainerstunden.onboarding.training.availabilityTitle": "Trainingszeiten",
  "trainerstunden.onboarding.training.addAvailability":
    "Zeitfenster hinzufügen",
  "trainerstunden.onboarding.training.availabilityDay": "Wochentag",
  "trainerstunden.onboarding.training.availabilityFrom": "Von",
  "trainerstunden.onboarding.training.availabilityTo": "Bis",
  "trainerstunden.onboarding.training.locationFromClubsHint":
    "Dein Hauptverein ist der Standard-Trainingsort. Weitere Vereine hast du im Schritt „Deine Vereine“ angegeben.",
  "trainerstunden.onboarding.training.duration": "Standard-Dauer",
  "trainerstunden.onboarding.training.rate": "Standardpreis (€/h)",
  "trainerstunden.onboarding.training.day.mon": "Montag",
  "trainerstunden.onboarding.training.day.tue": "Dienstag",
  "trainerstunden.onboarding.training.day.wed": "Mittwoch",
  "trainerstunden.onboarding.training.day.thu": "Donnerstag",
  "trainerstunden.onboarding.training.day.fri": "Freitag",
  "trainerstunden.onboarding.training.day.sat": "Samstag",
  "trainerstunden.onboarding.training.day.sun": "Sonntag",
  "trainerstunden.onboarding.bookings.parentPortalActive":
    "Spieler-Buchungen sind für dein Profil aktiv.",
  "trainerstunden.onboarding.bookings.approvalLegend": "Buchungsfreigabe",
  "trainerstunden.onboarding.bookings.manualApproval":
    "Jede Anfrage manuell bestätigen (empfohlen)",
  "trainerstunden.onboarding.bookings.autoWithinAvailability":
    "Innerhalb meiner Zeiten automatisch bestätigen",
  "trainerstunden.onboarding.players.hint":
    "Du kannst Spieler auch später unter Kontakte anlegen.",
  "trainerstunden.onboarding.players.emailOptional": "E-Mail (optional)",
  "trainerstunden.onboarding.players.addRow": "Weiteren Spieler hinzufügen",
  "trainerstunden.onboarding.players.skip": "Später",
  "trainerstunden.onboarding.errors.tenantNotConfirmed":
    "Bitte bestätige die Vereinszuordnung.",
  "trainerstunden.onboarding.errors.missingFirstName":
    "Bitte Vornamen angeben.",
  "trainerstunden.onboarding.errors.missingLastName":
    "Bitte Nachnamen angeben.",
  "trainerstunden.onboarding.errors.missingPhone": "Bitte Handynummer angeben.",
  "trainerstunden.onboarding.errors.missingAddress":
    "Bitte Adresse vollständig angeben.",
  "trainerstunden.onboarding.errors.missingAvailability":
    "Bitte mindestens ein Trainingszeitfenster angeben.",
  "trainerstunden.onboarding.errors.missingLocation":
    "Bitte einen Trainingsort wählen oder anlegen.",
  "trainerstunden.onboarding.errors.missingDuration":
    "Bitte Standard-Dauer wählen.",
  "trainerstunden.onboarding.errors.missingRate":
    "Bitte einen Stundensatz größer als 0 angeben.",
  "trainerstunden.onboarding.errors.missingTrainingState":
    "Bitte Bundesland für Schulferien wählen.",
  "trainerstunden.onboarding.errors.missingBillingFrequency":
    "Bitte Abrechnungsrhythmus wählen.",
  "trainerstunden.onboarding.errors.missingBillingTiming":
    "Bitte Zahlungszeitpunkt wählen.",
  "trainerstunden.onboarding.errors.missingPayoutType":
    "Bitte Honorar-Art wählen.",
  "trainerstunden.onboarding.errors.missingPayoutRate":
    "Bitte Honorar-Betrag angeben.",
  "trainerstunden.onboarding.errors.missingPayoutFrequency":
    "Bitte Auszahlungsrhythmus wählen.",
  "trainerstunden.onboarding.errors.missingPayoutMethod":
    "Bitte Auszahlungsmethode wählen.",
  "trainerstunden.onboarding.errors.missingPaypal":
    "Bitte PayPal-Angabe ergänzen.",
  "trainerstunden.onboarding.errors.missingPlayerName":
    "Bitte Vor- und Nachname für jeden Spieler angeben.",
  "trainerstunden.onboarding.errors.saveFailed":
    "Speichern fehlgeschlagen. Bitte erneut versuchen.",
  "trainerstunden.onboarding.errors.newClubMissingFields":
    "Bitte Vereinsname und Ort angeben.",
  "trainerstunden.onboarding.errors.newClubFailed":
    "Verein konnte nicht angelegt werden.",
  "trainerstunden.onboarding.club.createSubmit": "Verein anlegen & übernehmen",
  "trainerstunden.settings.title": "Einstellungen",
  "trainerstunden.settings.subtitle":
    "Kalender, Region, Anwesenheit und Integrationen.",
  "trainerstunden.settings.apps.title": "Apps & Einstellungen",
  "trainerstunden.settings.apps.choose": "Funktion wählen",
  "trainerstunden.settings.apps.subtitle":
    "Arbeitsablauf und Integrationen auf einen Blick — Details per Klick.",
  "trainerstunden.settings.apps.sectionWorkflow": "Arbeitsablauf",
  "trainerstunden.settings.apps.sectionFinance": "Finanzen",
  "trainerstunden.settings.apps.sectionApps": "Apps",
  "trainerstunden.settings.apps.bank.subtitle":
    "Konto verbinden und Umsätze abgleichen",
  "trainerstunden.settings.apps.status.bankConfigure": "Nicht verbunden",
  "trainerstunden.settings.apps.paypal.subtitle":
    "PayPal-Zahlungen per Transaction Search abgleichen.",
  "trainerstunden.settings.apps.status.paypalConfigure": "Nicht verbunden",
  "trainerstunden.settings.apps.status.paypalConnected": "Verbunden",
  "trainerstunden.settings.group.bank": "Bankverbindungen",
  "trainerstunden.settings.group.paypal": "PayPal",
  "trainerstunden.verwaltung.admin.item.bank.title": "Bankverbindungen",
  "trainerstunden.verwaltung.admin.item.bank.description":
    "Bankkonto verbinden und Zahlungseingänge zuordnen.",
  "trainerstunden.verwaltung.admin.item.paypal.title": "PayPal",
  "trainerstunden.verwaltung.admin.item.paypal.description":
    "PayPal-Konto verbinden und Zahlungseingänge zuordnen.",
  "trainerstunden.bank.loading": "Bankdaten werden geladen…",
  "trainerstunden.bank.add": "+ Bankkonto verbinden",
  "trainerstunden.bank.addTitle": "Bankkonto verbinden",
  "trainerstunden.bank.addHint":
    "Die Bankauswahl und Anmeldung laufen beim Open-Banking-Anbieter. TrainingsDesk speichert keine Bank-PIN.",
  "trainerstunden.bank.addHintDirect":
    "PIN und photoTAN nur einmal beim Verbinden. Umsätze holt TrainingsDesk danach im Hintergrund — ohne erneute Anmeldung in der Bank-App. PIN und TAN werden nicht gespeichert.",
  "trainerstunden.bank.reconnectOnce": "Einmalig neu anmelden",
  "trainerstunden.bank.reconnectHint":
    "Die gespeicherte Sitzung ist abgelaufen. Einmal photoTAN bestätigen, danach wieder automatischer Abruf.",
  "trainerstunden.bank.connectComdirect": "comdirect verbinden",
  "trainerstunden.bank.autoSyncHint":
    "Abruf über den gespeicherten Zugang, ohne Login in der photoTAN-App.",
  "trainerstunden.bank.devProvider": "Provider: comdirect direct",
  "trainerstunden.bank.provider.comdirect": "comdirect",
  "trainerstunden.bank.provider.paypal": "PayPal",
  "trainerstunden.bank.institutionFallback": "Bankverbindung",
  "trainerstunden.bank.accountFallback": "Konto",
  "trainerstunden.bank.account": "Konto: {{iban}}",
  "trainerstunden.bank.useForReconciliation":
    "Dieses Konto für Zahlungsabgleich verwenden",
  "trainerstunden.bank.statusLabel": "Status",
  "trainerstunden.bank.status.connected": "Verbunden",
  "trainerstunden.bank.status.pending": "Ausstehend",
  "trainerstunden.bank.status.expired": "Abgelaufen",
  "trainerstunden.bank.status.error": "Fehler",
  "trainerstunden.bank.status.disconnected": "Getrennt",
  "trainerstunden.bank.lastSync": "Zuletzt synchronisiert: {{at}}",
  "trainerstunden.bank.neverSynced": "noch nie",
  "trainerstunden.bank.syncedJustNow": "gerade eben",
  "trainerstunden.bank.syncedAgoMinutes": "vor {{n}} Minuten",
  "trainerstunden.bank.syncedAgoHours": "vor {{n}} Stunden",
  "trainerstunden.bank.syncNow": "Jetzt synchronisieren",
  "trainerstunden.bank.actionBusy": "Bitte warten…",
  "trainerstunden.bank.syncOk":
    "Synchronisierung abgeschlossen. {{count}} neue Umsätze.",
  "trainerstunden.bank.syncOkNone":
    "Synchronisierung abgeschlossen. Keine neuen Umsätze.",
  "trainerstunden.bank.validateOk":
    "Verbindung geprüft — PayPal antwortet korrekt.",
  "trainerstunden.bank.renew": "Verbindung erneuern",
  "trainerstunden.bank.disconnect": "Trennen",
  "trainerstunden.bank.autoSync": "Automatische Synchronisierung aktiv",
  "trainerstunden.bank.importedNotice":
    "Wir haben {{count}} neue Umsätze gefunden.",
  "trainerstunden.bank.openReconciliation": "Zahlungsabgleich öffnen",
  "trainerstunden.bank.username": "Zugangsnummer",
  "trainerstunden.bank.pin": "PIN",
  "trainerstunden.bank.connect": "Bankkonto verbinden",
  "trainerstunden.bank.tan": "TAN",
  "trainerstunden.bank.tanPhoto":
    "Bitte PhotoTAN in der App scannen und TAN eingeben.",
  "trainerstunden.bank.tanPush":
    "Bitte die Anmeldung in der comdirect photoTAN-App bestätigen.",
  "trainerstunden.bank.tanImageAlt": "PhotoTAN-Grafik",
  "trainerstunden.bank.confirmTan": "Anmeldung bestätigen",
  "trainerstunden.bank.restartConnect": "Neu anmelden",
  "trainerstunden.bank.matchSettings.title": "Zahlungsabgleich",
  "trainerstunden.bank.matchSettings.autoSuggest": "Automatische Vorschläge",
  "trainerstunden.bank.matchSettings.autoMatch":
    "Automatisch als bezahlt markieren",
  "trainerstunden.bank.matchSettings.mode.never": "Nie",
  "trainerstunden.bank.matchSettings.mode.verySure":
    "Nur sehr sichere Treffer (>95 %)",
  "trainerstunden.bank.matchSettings.mode.verySureUnique":
    "Sehr sichere und eindeutige Treffer",
  "trainerstunden.bank.error.generic": "Bankvorgang fehlgeschlagen.",
  "trainerstunden.bank.error.clientMissing":
    "Open-Banking-Zugang fehlt serverseitig (FINAPI_CLIENT_ID / FINAPI_CLIENT_SECRET).",
  "trainerstunden.bank.error.comdirectNotConfigured":
    "comdirect ist nicht konfiguriert",
  "trainerstunden.bank.error.encryption":
    "Verschlüsselung nicht verfügbar. BANK_SETTINGS_ENCRYPTION_SECRET setzen.",
  "trainerstunden.bank.error.auth": "Anmeldung bei der Bank fehlgeschlagen.",
  "trainerstunden.bank.error.session":
    "Bank-Sitzung konnte nicht gestartet werden. Bitte erneut verbinden.",
  "trainerstunden.bank.error.tanStart":
    "TAN-Abfrage konnte nicht gestartet werden. Bitte erneut verbinden.",
  "trainerstunden.bank.error.tan": "TAN konnte nicht bestätigt werden.",
  "trainerstunden.bank.error.tanPending":
    "Noch keine Bestätigung in der photoTAN-App. Bitte dort freigeben, dann hier erneut bestätigen.",
  "trainerstunden.bank.error.secondary":
    "Die Bank-Sitzung konnte nach der TAN nicht abgeschlossen werden. Bitte erneut verbinden.",
  "trainerstunden.bank.error.accounts":
    "Konten konnten nicht geladen werden. Bitte erneut „Anmeldung bestätigen“ drücken.",
  "trainerstunden.bank.error.save":
    "Die Bankverbindung konnte nicht gespeichert werden.",
  "trainerstunden.bank.error.handler":
    "Interner Fehler beim Bankvorgang. Bitte erneut versuchen.",
  "trainerstunden.bank.error.connectExpired":
    "Die Anmeldung ist abgelaufen. Bitte neu verbinden.",
  "trainerstunden.bank.error.paypalMissing":
    "PayPal Client-ID und Secret fehlen.",
  "trainerstunden.bank.error.paypalAuth":
    "PayPal-Anmeldung fehlgeschlagen. Client-ID und Secret prüfen.",
  "trainerstunden.bank.error.paypalSearch":
    "Transaction Search ist in der PayPal-App nicht aktiv. Unter REST-API-Integrationen die Berechtigung „Transaction Search“ einschalten.",
  "trainerstunden.bank.error.paypalTx":
    "PayPal-Umsätze konnten nicht gelesen werden.",
  "trainerstunden.bank.connectPaypal": "PayPal verbinden",
  "trainerstunden.bank.addHintPaypal":
    "REST-API (nicht Braintree). Transaction Search in der PayPal-App aktivieren. Client-ID und Secret bleiben nur serverseitig gespeichert.",
  "trainerstunden.bank.paypalClientId": "PayPal Client-ID",
  "trainerstunden.bank.paypalSecret": "PayPal Secret",
  "trainerstunden.bank.paypalMode": "Umgebung",
  "trainerstunden.bank.paypalModeLive": "Live",
  "trainerstunden.bank.paypalModeSandbox": "Sandbox",
  "trainerstunden.bank.paypalUseEnv":
    "Mit hinterlegtem Server-Zugang verbinden",
  "trainerstunden.bank.paypalAccountEmail": "PayPal-Konto (E-Mail)",
  "trainerstunden.bank.paypalAccountEmailHint":
    "Damit erkennbar ist, welches PayPal-Konto verbunden ist.",
  "trainerstunden.bank.paypalAccountLabel": "Konto: {{email}}",
  "trainerstunden.bank.paypalAccountMissing":
    "Konto-E-Mail noch nicht hinterlegt",
  "trainerstunden.bank.paypalAccountSave": "Konto-E-Mail speichern",
  "trainerstunden.bank.error.paypalAccountEmail":
    "Bitte die PayPal-Konto-E-Mail angeben.",
  "trainerstunden.bank.error.paypalAccountEmailInvalid":
    "Bitte eine gültige E-Mail-Adresse angeben.",
  "trainerstunden.bank.environment": "Umgebung",
  "trainerstunden.bank.clientIdMasked": "Client-ID: {id}",
  "trainerstunden.bank.lastValidated": "Letzte Prüfung: {{at}}",
  "trainerstunden.bank.validateNow": "Verbindung prüfen",
  "trainerstunden.bank.replaceCredentials": "Credentials ersetzen",
  "trainerstunden.bank.replaceCredentialsCancel": "Abbrechen",
  "trainerstunden.bank.error.expired": "Verbindung abgelaufen. Bitte erneuern.",
  "trainerstunden.bank.reco.tab": "Zahlungsabgleich",
  "trainerstunden.bank.reco.tabReceipts": "Zahlungseingänge",
  "trainerstunden.bank.reco.tabsAria": "Einnahmen-Ansicht",
  "trainerstunden.bank.reco.providerFiltersAria": "Nach Zahlungsweg filtern",
  "trainerstunden.bank.reco.providerAll": "Alle",
  "trainerstunden.bank.reco.providerUnknown": "Unbekannt",
  "trainerstunden.bank.reco.todayTitle": "Heute eingegangen",
  "trainerstunden.bank.reco.todayMeta": "{{count}} Zahlungen · {{amount}}",
  "trainerstunden.bank.reco.unknown": "Unbekannte Zahlung",
  "trainerstunden.bank.reco.open": "Offene Zahlungen: {{count}}",
  "trainerstunden.bank.reco.new": "Neue Bankumsätze: {{count}}",
  "trainerstunden.bank.reco.auto": "Automatisch erkannt: {{count}}",
  "trainerstunden.bank.reco.review": "Zu prüfen: {{count}}",
  "trainerstunden.bank.reco.guess": "Vermutete Zuordnung",
  "trainerstunden.bank.reco.guessPossible": "Möglicher Treffer",
  "trainerstunden.bank.reco.invoiceRef": "Rechnung {{ref}}",
  "trainerstunden.bank.reco.score": "{{score}} % Übereinstimmung",
  "trainerstunden.bank.reco.assign": "Zuordnen",
  "trainerstunden.bank.reco.other": "Andere Zahlung auswählen",
  "trainerstunden.bank.reco.ignore": "Ignorieren",
  "trainerstunden.bank.reco.markPrivate": "Privat / nicht Tennis",
  "trainerstunden.bank.reco.privateTitle": "Privat / ausgeblendet ({count})",
  "trainerstunden.bank.reco.privateUndo": "Wieder Tennis",
  "trainerstunden.bank.reco.possible": "Mögliche Treffer",
  "trainerstunden.bank.reco.search":
    "Suche über Spieler, Eltern, Training, Saison",
  "trainerstunden.bank.reco.empty": "Keine neuen Umsätze zum Abgleich.",
  "trainerstunden.bank.reco.dash": "—",
  "trainerstunden.bank.reco.mark.settled": "✓",
  "trainerstunden.bank.reco.mark.unknown": "?",
  "trainerstunden.bank.reco.mark.open": "·",
  "trainerstunden.bank.reco.reasonMark": "✓ {text}",
  "trainerstunden.bank.reason.amount_exact": "Betrag identisch",
  "trainerstunden.bank.reason.name_player_full": "Spielername gefunden",
  "trainerstunden.bank.reason.name_lastname": "Nachname „{{name}}“ gefunden",
  "trainerstunden.bank.reason.name_contact": "Kontakt „{{name}}“ gefunden",
  "trainerstunden.bank.reason.name_firstname_purpose":
    "„{{name}}“ im Verwendungszweck",
  "trainerstunden.bank.reason.purpose_reference": "Zahlungsreferenz gefunden",
  "trainerstunden.bank.reason.purpose_training":
    "Trainingsname im Verwendungszweck",
  "trainerstunden.bank.reason.purpose_season":
    "Saison/Gruppe im Verwendungszweck",
  "trainerstunden.bank.reason.purpose_keyword":
    "Begriff „{{keyword}}“ im Verwendungszweck",
  "trainerstunden.bank.reason.time_proximity":
    "Zahlung {{days}} Tage nach Zahlungsaufforderung",
  "trainerstunden.bank.reason.signal_learned":
    "Bereits bestätigte Zahlerbeziehung",
  "trainerstunden.bank.reason.amount_unique":
    "Betrag eindeutig unter offenen Posten",
  "trainerstunden.settings.apps.edit": "Ändern",
  "trainerstunden.settings.apps.configure": "Konfigurieren",
  "trainerstunden.settings.apps.closePanel": "Schließen",
  "trainerstunden.settings.apps.status.hoursRange": "{{start}} – {{end}}",
  "trainerstunden.settings.apps.status.holidaysOn": "Schulferien aktiv",
  "trainerstunden.settings.apps.status.holidaysOff": "Schulferien deaktiviert",
  "trainerstunden.settings.apps.status.attendanceEnabled":
    "Auto-Bestätigung aktiv",
  "trainerstunden.settings.apps.status.attendanceDisabled":
    "Auto-Bestätigung deaktiviert",
  "trainerstunden.settings.apps.status.billingSimulationOn":
    "E-Mail-Simulation aktiv",
  "trainerstunden.settings.apps.status.billingSimulationOff":
    "E-Mail-Simulation deaktiviert",
  "trainerstunden.settings.apps.status.whatsappConnected": "Verbunden",
  "trainerstunden.settings.apps.status.whatsappNotConnected": "Nicht verbunden",
  "trainerstunden.settings.apps.status.tennifyConnected": "Aktiv",
  "trainerstunden.settings.apps.status.tennifyNotConnected":
    "Nicht konfiguriert",
  "trainerstunden.settings.apps.status.checkcourtConnected": "Aktiv",
  "trainerstunden.settings.apps.status.checkcourtNotConnected":
    "Nicht konfiguriert",
  "trainerstunden.settings.apps.status.courtsCount":
    "{{count}} Plätze hinterlegt",
  "trainerstunden.settings.apps.status.reminderLead":
    "Vorlauf: {{value}} {{unit}}",
  "trainerstunden.settings.apps.whatsapp.subtitle":
    "WhatsApp-Erinnerungen für Termin-Rückmeldungen.",
  "trainerstunden.settings.apps.tennify.subtitle":
    "Platzbelegung aus Tennify in der Planung prüfen.",
  "trainerstunden.settings.apps.checkcourt.subtitle":
    "Platzbelegung aus CheckCourt in der Planung prüfen.",
  "trainerstunden.settings.group.calendar": "Kalender",
  "trainerstunden.settings.group.region": "Region & Ferien",
  "trainerstunden.settings.group.attendance": "Anwesenheit",
  "trainerstunden.settings.group.reminders": "Erinnerungen",
  "trainerstunden.settings.group.billing": "Rechnungen",
  "trainerstunden.settings.group.integrations": "Integrationen",
  "trainerstunden.settings.group.checkcourt": "CheckCourt",
  "trainerstunden.settings.save": "Speichern",
  "trainerstunden.settings.saving": "Speichere …",
  "trainerstunden.settings.saved": "Gespeichert",
  "trainerstunden.settings.calendarHours.title": "Tageszeitraum",
  "trainerstunden.settings.calendarHours.hint":
    "Sichtbarer Bereich in der Planung.",
  "trainerstunden.settings.calendarHours.dayStart": "Beginn",
  "trainerstunden.settings.calendarHours.dayEnd": "Ende",
  "trainerstunden.settings.calendarHours.invalidRange":
    "Ende muss nach dem Beginn liegen.",
  "outlook.settings.title": "Outlook",
  "outlook.settings.intro":
    "Verbinde dein Microsoft-Konto, wähle einen Kalender und synchronisiere deine Tennis-Termine.",
  "outlook.settings.connect": "Outlook verbinden",
  "outlook.settings.loading": "Lade Outlook-Status …",
  "outlook.settings.notConfiguredHint":
    "Outlook ist serverseitig noch nicht eingerichtet. Bitte Entra-App und Secrets konfigurieren (siehe Setup-Anleitung).",
  "outlook.settings.connectedAs": "Verbunden als {email}",
  "outlook.settings.calendarLabel": "Zielkalender",
  "outlook.settings.calendarPlaceholder": "Kalender wählen …",
  "outlook.settings.createCalendar": "Kalender „Tennis“ erstellen",
  "outlook.settings.defaultCalendarName": "Tennis",
  "outlook.settings.syncScope": "Zu synchronisierende Terminarten",
  "outlook.settings.scope.trainingsdesk": "TrainingsDesk-Termine",
  "outlook.settings.scope.regeltermine": "Serientermine",
  "outlook.settings.lastSynced": "Letzter erfolgreicher Abgleich: {when}",
  "outlook.settings.neverSynced": "Noch nicht synchronisiert",
  "outlook.settings.syncNow": "Jetzt synchronisieren",
  "outlook.settings.disconnect": "Verbindung trennen",
  "outlook.settings.disconnectConfirm":
    "Outlook-Verbindung trennen? Vorhandene Outlook-Termine werden nicht gelöscht.",
  "outlook.settings.conflicts": "Konflikte",
  "outlook.settings.removedExternally": "In Outlook entfernt",
  "outlook.settings.restore": "In Outlook wiederherstellen",
  "outlook.settings.notice.connected": "Outlook erfolgreich verbunden.",
  "outlook.settings.notice.calendarCreated":
    "Kalender erstellt und ausgewählt.",
  "outlook.settings.notice.synced": "Synchronisation abgeschlossen.",
  "outlook.settings.notice.restored": "Wiederherstellung geplant.",
  "outlook.settings.notice.disconnected": "Verbindung getrennt.",
  "outlook.settings.error.notConfigured":
    "Outlook ist nicht konfiguriert. Administrator: Entra-App und MICROSOFT_CLIENT_* setzen.",
  "outlook.settings.error.encryption":
    "Token-Verschlüsselung fehlt. OUTLOOK_SETTINGS_ENCRYPTION_SECRET setzen.",
  "outlook.settings.error.missingBackendUrl":
    "Outlook-API nicht erreichbar (Pages-Function fehlt oder Catch-all-Proxy). Prüfe Deploy-Branch und Build-Befehl build:cloudflare:pages:test — nicht die Entra-Secrets.",
  "outlook.settings.error.backendUnreachable":
    "API-Backend nicht erreichbar. Administrator: Routing/Deploy prüfen.",
  "outlook.settings.error.requestFailed":
    "Outlook-Status konnte nicht geladen werden (Netzwerk, Auth oder Serverfehler). Bitte erneut versuchen.",
  "outlook.settings.error.gatewayTimeout":
    "Outlook-Sync ist abgebrochen (Zeitlimit/Upstream). Bitte erneut „Jetzt synchronisieren“ — ggf. mehrmals, bis alle Termine durch sind.",
  "outlook.settings.error.syncFailed":
    "Synchronisation mit Microsoft Graph fehlgeschlagen. Verbindung prüfen und erneut versuchen.",
  "outlook.settings.error.busy":
    "Synchronisation läuft bereits. Bitte kurz warten und erneut versuchen.",
  "outlook.settings.error.adminConsent":
    "Firmenkonto braucht Administratorfreigabe in Microsoft Entra.",
  "outlook.settings.error.invalidState":
    "Sicherheitsprüfung fehlgeschlagen. Bitte erneut verbinden.",
  "outlook.settings.error.sessionExpired":
    "Anmeldesitzung abgelaufen. Bitte erneut verbinden.",
  "outlook.settings.error.notConnected":
    "Nicht verbunden. Zuerst Outlook verbinden.",
  "outlook.settings.error.calendarRequired":
    "Bitte zuerst einen Zielkalender auswählen.",
  "outlook.settings.error.calendarNotWritable":
    "Dieser Kalender ist nicht beschreibbar. Bitte einen eigenen Kalender wählen.",
  "outlook.settings.error.revoked":
    "Microsoft-Verbindung abgelaufen oder widerrufen. Bitte erneut verbinden.",
  "outlook.settings.error.invalidClient":
    "Microsoft lehnt die App-Anmeldung ab (invalid_client). Administrator: In Cloudflare Pages (Prod) MICROSOFT_CLIENT_ID und MICROSOFT_CLIENT_SECRET prüfen — Secret oft abgelaufen. In Entra: neues Client Secret, Redirect-URI https://app.tennis-matches.de/api/outlook/callback, dann erneut verbinden.",
  "outlook.settings.error.generic":
    "Outlook-Aktion fehlgeschlagen. Bitte erneut versuchen oder Verbindung neu aufbauen.",
  "outlook.settings.conflict.generic": "Synchronisationskonflikt.",
  "outlook.settings.conflict.removedExternally":
    "Kopie in Outlook wurde gelöscht — Training bleibt bestehen.",
  "outlook.settings.conflict.concurrentEdit":
    "Termin wurde gleichzeitig im Tool und in Outlook geändert.",
  "outlook.settings.conflict.regeltermineInbound":
    "Verschiebung von Regelterminen aus Outlook wird in V1 nicht übernommen.",
  "outlook.settings.conflict.permissionDenied":
    "Keine Berechtigung, diesen Termin zu verschieben.",
  "outlook.settings.conflict.trainerConflict":
    "Trainer-Zeitkonflikt — Änderung aus Outlook abgelehnt.",
  "outlook.settings.conflict.applyFailed":
    "Änderung aus Outlook konnte nicht übernommen werden.",
  "outlook.settings.action.restoreOrKeep": "Wiederherstellen oder so belassen.",
  "outlook.settings.action.reviewInTool": "Im Tool prüfen und korrigieren.",
  "outlook.settings.action.editInTool": "Zeit im Tool anpassen.",
  "outlook.settings.action.askOwner": "Trainer/Owner um Verschiebung bitten.",
  "outlook.settings.action.fixConflict": "Konflikt im Tool lösen.",
  "trainerstunden.settings.timeSlot.label": "Uhrzeit-Raster",
  "trainerstunden.settings.timeSlot.hint": "Schrittweite für Startzeiten.",
  "trainerstunden.settings.timeSlot.minutesOption": "{{minutes}} Minuten",
  "trainerstunden.settings.trainingState.title": "Bundesland",
  "trainerstunden.settings.trainingState.label": "Trainingsregion",
  "trainerstunden.settings.trainingState.hint":
    "Für Schulferien und regionale Planung.",
  "trainerstunden.settings.trainingState.none": "Nicht festgelegt",
  "trainerstunden.settings.holidays.enableApi":
    "Schulferien im Kalender markieren",
  "trainerstunden.settings.holidays.syncHint":
    "Gleiche Region wie unter Standort & Wetter.",
  "trainerstunden.settings.holidays.calendarHint":
    "Ferientage werden nach dem Speichern hervorgehoben.",
  "trainerstunden.settings.holidays.validationState":
    "Bitte Bundesland wählen.",
  "trainerstunden.settings.billingEmail.title": "Rechnungsversand",
  "trainerstunden.settings.billingEmail.hint": "E-Mail-Versand von Rechnungen.",
  "trainerstunden.settings.billingEmail.simulationEnabled":
    "Nur simulieren (kein echter Versand)",
  "trainerstunden.settings.billingEmail.simulationHint":
    "Für Tests: kein Versand, Protokoll bleibt aktiv.",
  "trainerstunden.settings.attendanceAutoConfirm.title": "Auto-Bestätigung",
  "trainerstunden.settings.attendanceAutoConfirm.hint":
    "Vergangene Trainings automatisch als durchgeführt markieren.",
  "trainerstunden.settings.attendanceAutoConfirm.inheritFromCoordinator":
    "Aktuell: Vorgaben des Koordinators. Speichern legt eigene Werte fest.",
  "trainerstunden.settings.attendanceAutoConfirm.inheritFromCoordinatorNamed":
    "Aktuell: Vorgaben von {name}. Speichern legt eigene Werte fest.",
  "trainerstunden.settings.attendanceAutoConfirm.noTrainerProfile":
    "Trainer-Profil erforderlich.",
  "trainerstunden.settings.attendanceAutoConfirm.enabled":
    "Trainings automatisch bestätigen",
  "trainerstunden.settings.attendanceAutoConfirm.enabledHint":
    "Mindestens ein anwesender Spieler nötig.",
  "trainerstunden.settings.attendanceAutoConfirm.delayLabel":
    "Frist nach Trainingsende",
  "trainerstunden.settings.attendanceAutoConfirm.delayHint":
    "Bis dahin kannst du manuell bestätigen.",
  "trainerstunden.settings.attendanceAutoConfirm.delay.m0":
    "Direkt nach Trainingsende",
  "trainerstunden.settings.attendanceAutoConfirm.delay.m30": "30 Minuten",
  "trainerstunden.settings.attendanceAutoConfirm.delay.m60": "1 Stunde",
  "trainerstunden.settings.attendanceAutoConfirm.delay.m120": "2 Stunden",
  "trainerstunden.settings.attendanceAutoConfirm.delay.m240": "4 Stunden",
  "trainerstunden.settings.attendanceAutoConfirm.delay.m720": "12 Stunden",
  "trainerstunden.settings.attendanceAutoConfirm.delay.m1440": "24 Stunden",
  "trainerstunden.settings.attendanceAutoConfirm.delay.m2880": "48 Stunden",
  "trainerstunden.settings.sessionRsvpReminder.title": "WhatsApp-Erinnerung",
  "trainerstunden.settings.sessionRsvpReminder.hint":
    "Geplante Spieler bekommen vor dem Termin eine WhatsApp.",
  "trainerstunden.settings.sessionRsvpReminder.noTrainerProfile":
    "Trainer-Profil erforderlich.",
  "trainerstunden.settings.sessionRsvpReminder.enabled":
    "Erinnerung vor dem Training senden",
  "trainerstunden.settings.sessionRsvpReminder.enabledHint":
    "Versand im gewählten Abstand vor Start.",
  "trainerstunden.settings.sessionRsvpReminder.leadLabel": "Vorlauf",
  "trainerstunden.settings.sessionRsvpReminder.unitLabel": "Einheit",
  "trainerstunden.settings.sessionRsvpReminder.unit.minutes": "Minuten",
  "trainerstunden.settings.sessionRsvpReminder.unit.hours": "Stunden",
  "trainerstunden.settings.sessionRsvpReminder.leadHint": "5 Min. bis 7 Tage.",
  "trainerstunden.settings.whatsappBusiness.title": "WhatsApp Business",
  "trainerstunden.settings.whatsappBusiness.hint":
    "Erinnerungen gehen von deiner Nummer aus.",
  "trainerstunden.settings.whatsappBusiness.requiredForReminders":
    "Zuerst WhatsApp Business verbinden.",
  "trainerstunden.settings.whatsappBusiness.connect":
    "WhatsApp Business verbinden",
  "trainerstunden.settings.whatsappBusiness.connecting": "Verbinden…",
  "trainerstunden.settings.whatsappBusiness.disconnect": "Trennen",
  "trainerstunden.settings.whatsappBusiness.connectedAs":
    "Verbunden: {name} ({phone})",
  "trainerstunden.settings.whatsappBusiness.connectFailed":
    "Verbindung fehlgeschlagen.",
  "trainerstunden.settings.whatsappBusiness.disconnectFailed":
    "Trennen fehlgeschlagen.",
  "trainerstunden.settings.whatsappBusiness.cancelled":
    "Verbindung abgebrochen.",
  "trainerstunden.settings.whatsappBusiness.platformNotReady":
    "WhatsApp-Anmeldung ist noch nicht bereit.",
  "trainerstunden.settings.whatsappBusiness.devMockHint":
    "Dev: Meta nicht konfiguriert — Test-Verbindung wird gespeichert.",
  "trainerstunden.settings.tennify.title": "Tennify",
  "trainerstunden.settings.tennify.hint":
    "Platz-Verfügbarkeit beim Anlegen anzeigen.",
  "trainerstunden.settings.tennify.enabled": "Tennify-Check aktivieren",
  "trainerstunden.settings.tennify.apiKeyLabel": "API-Key",
  "trainerstunden.settings.tennify.apiKeyPlaceholder":
    "tbk_… (leer = vorhandenen behalten)",
  "trainerstunden.settings.tennify.notConfiguredHint":
    "Noch kein API-Key hinterlegt.",
  "trainerstunden.settings.tennify.configuredHint":
    "Key hinterlegt ({{keyHint}}).",
  "trainerstunden.settings.tennify.setupGuidePrefix": "Anleitung:",
  "trainerstunden.settings.tennify.setupGuideLink": "Tennify Booking API",
  "trainerstunden.settings.tennify.setupGuideSteps":
    "Tennify → Booking API → Key erzeugen und hier einfügen.",
  "trainerstunden.settings.tennify.knownCourtsLabel": "Plätze (manuell)",
  "trainerstunden.settings.tennify.knownCourtsPlaceholder": "Platz 1\nPlatz 2",
  "trainerstunden.settings.tennify.knownCourtsHint":
    "Ein Platz pro Zeile, exakt wie in Tennify.",
  "trainerstunden.settings.tennify.loadFailed":
    "Tennify-Konfiguration konnte nicht geladen werden.",
  "trainerstunden.settings.tennify.saveFailed":
    "Tennify-Konfiguration konnte nicht gespeichert werden.",
  "trainerstunden.settings.tennify.saveFailedKeyRequired":
    "API-Key erforderlich.",
  "trainerstunden.settings.tennify.saveFailedEncryption":
    "API-Key konnte nicht sicher gespeichert werden.",
  "trainerstunden.settings.tennify.saveFailedMissingContext":
    "Speichern aktuell nicht möglich — Seite neu laden.",
  "trainerstunden.settings.tennify.saveFailedTenantForbidden":
    "Keine Berechtigung für diesen Verein.",
  "trainerstunden.settings.checkcourt.title": "CheckCourt",
  "trainerstunden.settings.checkcourt.hint":
    "Verfügbarkeit prüfen, beim Termin anlegen automatisch buchen, beim Storno mitstornieren.",
  "trainerstunden.settings.checkcourt.enabled": "CheckCourt-Buchung aktivieren",
  "trainerstunden.settings.checkcourt.apiKeyLabel": "API-Key",
  "trainerstunden.settings.checkcourt.apiKeyPlaceholder":
    "ck_mgmt_… (leer = vorhandenen behalten)",
  "trainerstunden.settings.checkcourt.notConfiguredHint":
    "Noch kein API-Key hinterlegt. Management-Key (ck_mgmt_) empfohlen.",
  "trainerstunden.settings.checkcourt.configuredStatus": "API-Key aktiv",
  "trainerstunden.settings.checkcourt.configuredHint":
    "Gespeicherter Key: {{keyHint}}. Das Eingabefeld bleibt leer — Secret wird nicht erneut angezeigt. Neu eintragen nur zum Austauschen.",
  "trainerstunden.settings.checkcourt.setupGuidePrefix": "Anleitung:",
  "trainerstunden.settings.checkcourt.setupGuideLink":
    "CheckCourt Developer Docs",
  "trainerstunden.settings.checkcourt.setupGuideSteps":
    "CheckCourt → API Keys → Management-Key erzeugen und hier einfügen.",
  "trainerstunden.settings.checkcourt.scopesHint":
    "Benötigte Scopes: bookings:read, bookings:write, bookings:cancel, members:read_confidential (Trainer-Zuordnung per E-Mail/Name).",
  "trainerstunden.settings.checkcourt.knownCourtsLabel": "Plätze (manuell)",
  "trainerstunden.settings.checkcourt.knownCourtsPlaceholder":
    "Platz 1\nPlatz 2",
  "trainerstunden.settings.checkcourt.knownCourtsHint":
    "Ein Platz pro Zeile, exakt wie in CheckCourt.",
  "trainerstunden.settings.checkcourt.loadFailed":
    "CheckCourt-Konfiguration konnte nicht geladen werden.",
  "trainerstunden.settings.checkcourt.saveFailed":
    "CheckCourt-Konfiguration konnte nicht gespeichert werden.",
  "trainerstunden.settings.checkcourt.saveFailedWithReason":
    "CheckCourt-Konfiguration konnte nicht gespeichert werden ({{reason}}).",
  "trainerstunden.settings.checkcourt.saveFailedKeyRequired":
    "API-Key erforderlich.",
  "trainerstunden.settings.checkcourt.saveFailedEncryption":
    "API-Key konnte nicht sicher gespeichert werden.",
  "trainerstunden.settings.checkcourt.saveFailedMissingContext":
    "Speichern aktuell nicht möglich — Seite neu laden.",
  "trainerstunden.settings.checkcourt.saveFailedTenantForbidden":
    "Keine Berechtigung für diesen Verein.",
  "trainerstunden.settings.savePartialFailed":
    "Einstellungen gespeichert, Anwesenheits-Automatik nicht.",
  "trainerstunden.settings.trainingState.DE-BW": "Baden-Württemberg",
  "trainerstunden.settings.trainingState.DE-BY": "Bayern",
  "trainerstunden.settings.trainingState.DE-BE": "Berlin",
  "trainerstunden.settings.trainingState.DE-BB": "Brandenburg",
  "trainerstunden.settings.trainingState.DE-HB": "Bremen",
  "trainerstunden.settings.trainingState.DE-HH": "Hamburg",
  "trainerstunden.settings.trainingState.DE-HE": "Hessen",
  "trainerstunden.settings.trainingState.DE-MV": "Mecklenburg-Vorpommern",
  "trainerstunden.settings.trainingState.DE-NI": "Niedersachsen",
  "trainerstunden.settings.trainingState.DE-NW": "Nordrhein-Westfalen",
  "trainerstunden.settings.trainingState.DE-RP": "Rheinland-Pfalz",
  "trainerstunden.settings.trainingState.DE-SL": "Saarland",
  "trainerstunden.settings.trainingState.DE-SN": "Sachsen",
  "trainerstunden.settings.trainingState.DE-ST": "Sachsen-Anhalt",
  "trainerstunden.settings.trainingState.DE-SH": "Schleswig-Holstein",
  "trainerstunden.settings.trainingState.DE-TH": "Thüringen",
  "trainerstunden.planning.title": "Trainingstermine",
  "trainerstunden.planning.subtitle":
    "Was läuft heute – und was kommt als Nächstes?",
  "trainerstunden.planning.subtitleOrganize":
    "Trainings organisieren und nachbereiten.",
  "trainerstunden.planning.subtitleCalendar":
    "Kalenderansicht: Termine in Woche oder Monat, optional nach Trainer filtern.",
  "trainerstunden.planning.subtitleShort":
    "Listenansicht oder Kalender: kommende Termine filtern, für Outlook exportieren, bearbeiten und neue Trainings anlegen.",
  "trainerstunden.planning.openInCalendar": "Im Kalender anzeigen",
  "trainerstunden.planning.openInCalendarNotice":
    "Suche und Statusfilter gelten nur in der Trainingsliste; der Kalender öffnet den passenden Zeitraum mit Terminart Training.",
  "trainerstunden.planning.view.list": "Liste",
  "trainerstunden.planning.view.calendar": "Kalender",
  "trainerstunden.planning.showPast": "Vergangene anzeigen",
  "trainerstunden.planning.hidePast": "Vergangene ausblenden",
  "trainerstunden.planning.newSession": "Neues Training",
  "trainerstunden.planning.period.upcoming": "Anstehende",
  "trainerstunden.planning.period.week": "Diese Woche",
  "trainerstunden.planning.period.past": "Vergangene",
  "trainerstunden.planning.period.custom": "Zeitraum wählen",
  "trainerstunden.planning.statusFilter.label": "Status",
  "trainerstunden.planning.statusFilter.all": "Alle Status",
  "trainerstunden.planning.statusFilter.planned": "Geplant",
  "trainerstunden.planning.statusFilter.completed": "Durchgeführt",
  "trainerstunden.planning.statusFilter.cancelled": "Abgesagt",
  "trainerstunden.planning.listSearch.label": "Suche",
  "trainerstunden.planning.listSearch.placeholder":
    "Training oder Teilnehmer suchen …",
  "trainerstunden.planning.listSearch.aria": "Training oder Teilnehmer suchen",
  "trainerstunden.planning.moreActionsAria": "Weitere Aktionen",
  "trainerstunden.planning.resetFilters": "Filter zurücksetzen",
  "trainerstunden.planning.activeFilters": "Aktive Filter",
  "trainerstunden.planning.sessionCount": {
    one: "1 Training",
    other: "{count} Trainings",
  },
  "trainerstunden.planning.emptyNoSessions": "Noch keine Trainings vorhanden.",
  "trainerstunden.planning.emptyNoMatches":
    "Keine Treffer für die aktuellen Filter.",
  "trainerstunden.planning.loadFailed":
    "Trainings konnten nicht geladen werden.",
  "trainerstunden.planning.scrollRail.aria": "Zeitleiste und Schnellaktionen",
  "trainerstunden.planning.scrollRail.timelineAria": "Monate, Wochen und Tage",
  "trainerstunden.planning.scrollRail.weekLabel": "KW {kw} · {range}",
  "trainerstunden.planning.editSession": "Bearbeiten",
  "trainerstunden.planning.editSeriesSession": "Serientermin bearbeiten",
  "trainerstunden.planning.alreadyBilledReadonly":
    "Bereits abgerechnet – nicht mehr änderbar.",
  "trainerstunden.planning.pastSessions": "Vergangene Trainings",
  "trainerstunden.planning.block.timeRange": "{from} – {to}",
  "trainerstunden.planning.block.ariaLabel":
    "Trainingsblock {timeRange}, {venue}, {context}",
  "trainerstunden.planning.block.weatherAria":
    "Tageswetter für diesen Trainingsblock",
  "trainerstunden.planning.trainerBlock.ariaLabel": "Trainings von {name}",
  "trainerstunden.planning.trainerBlock.sessionCount": {
    one: "1 Training",
    other: "{count} Trainings",
  },
  "trainerstunden.planning.sessionsFilter.banner": {
    one: "Gefiltert · 1 Training aus einer Aktivität",
    other: "Gefiltert · {count} Trainings aus einer Aktivität",
  },
  "trainerstunden.planning.sessionsFilter.clear": "Alle Termine anzeigen",
  "trainerstunden.planning.upcomingSessions": "Kommende Trainings",
  "trainerstunden.planning.noUpcomingSessions":
    "Keine kommenden Trainings im gewählten Filter.",
  "trainerstunden.planning.noPastSessions":
    "Keine vergangenen Trainings im gewählten Filter.",
  "trainerstunden.planning.billingStatusSettlement": "Trainer-Abrechnung",
  "trainerstunden.planning.exportIcs": "Kalenderdatei (.ics)",
  "trainerstunden.planning.exportIcsShort": "Export (.ics)",
  "trainerstunden.planning.exportIcsConfirm":
    "{count} Trainings aus dem Zeitraum „{range}“ als .ics exportieren?",
  "trainerstunden.planning.periodLabel": "Zeitraum",
  "trainerstunden.planning.periodEmpty": "—",
  "trainerstunden.planning.periodRange": "{from} – {to}",
  "trainerstunden.planning.listFiltersAria": "Trainingstermine filtern",
  "trainerstunden.planning.playerSearchResultsAria":
    "Gefilterte Trainingstermine",
  "trainerstunden.planning.playerSearchEmpty":
    "Keine Trainingstermine für diese Spielersuche im gewählten Zeitraum.",
  "trainerstunden.planning.daySessionBadgeAria":
    "{count} Trainings an diesem Tag",
  "trainerstunden.planning.daySessionBadge": {
    one: "1 Training für heute",
    other: "{count} Trainings für heute",
  },
  "trainerstunden.planning.weather.daySummarySoon":
    "Tagesübersicht (Temperatur, Wind, Sonne) erscheint hier, sobald die Wetteranbindung aktiv ist.",
  "trainerstunden.planning.weather.daySummary":
    "{minTemp} / {maxTemp} · {precip} · Sonne {sunrise} – {sunset}",
  "trainerstunden.planning.weather.slotPlaceholder": "Zeitslot folgt",
  "trainerstunden.planning.weather.slotFormat": "{temp} · {wind} · {precip}",
  "trainerstunden.planning.weather.indoorTag": "Indoor",
  "trainerstunden.planning.weather.unavailable":
    "Wettervorhersage nicht verfügbar",
  "trainerstunden.planning.weather.loading": "Lädt Wetter …",
  "trainerstunden.planning.weather.risk.low": "Niedrig",
  "trainerstunden.planning.weather.risk.medium": "Mittel",
  "trainerstunden.planning.weather.risk.high": "Hoch",
  "trainerstunden.planning.weather.risk.reason.precip": "Regen {value} mm/h",
  "trainerstunden.planning.weather.risk.reason.wind": "Wind {value} km/h",
  "trainerstunden.planning.weather.risk.reason.cold": "Kühl {value}°",
  "trainerstunden.planning.weather.risk.reason.hot": "Heiß {value}°",
  "trainerstunden.planning.weather.risk.reason.storm": "Gewitter",
  "trainerstunden.planning.weather.attribution":
    "Wetterdaten: Deutscher Wetterdienst (DWD) via Bright Sky · CC BY 4.0",
  "trainerstunden.planning.weather.footerLead":
    "Stündliche Außenprognose und Trainingswahrscheinlichkeit werden angebunden (parallele Entwicklung). Hinweis: Unter „Standort & Wetter“ nutzen wir bereits serverseitig gecachte Prognosedaten.",
  "trainerstunden.planning.weather.footerMore": "Mehr zur Wetterprognose",
  "trainerstunden.planning.weather.slotPillSubline":
    "Wind {wind} · Niederschlag {precip} · Regen {rainProb} %",
  "trainerstunden.planning.weather.dayChipTempRange": "{min}–{max}",
  "trainerstunden.planning.weather.windBand.calm": "Wind ruhig ({kmh} km/h)",
  "trainerstunden.planning.weather.windBand.light": "Wind leicht ({kmh} km/h)",
  "trainerstunden.planning.weather.windBand.moderate":
    "Wind mäßig ({kmh} km/h)",
  "trainerstunden.planning.weather.windBand.fresh": "Wind frisch ({kmh} km/h)",
  "trainerstunden.planning.weather.windBand.unknown": "Wind —",
  "trainerstunden.planning.weather.sunHoursChip": "ca. {hours} h Licht",
  "trainerstunden.planning.weather.sunTimesShort": "{rise} → {set}",
  "trainerstunden.planning.weather.probability.percentLabel": "{pct} %",
  "trainerstunden.planning.weather.probability.headline.low":
    "Outdoor-Training findet voraussichtlich statt",
  "trainerstunden.planning.weather.probability.headline.medium":
    "Outdoor-Training: Stattfinden unsicher",
  "trainerstunden.planning.weather.probability.headline.high":
    "Outdoor-Training findet eher nicht statt",
  "trainerstunden.planning.weather.probability.subline.low":
    "Die Wetterprognose spricht dafür, dass das Outdoor-Training stattfinden kann.",
  "trainerstunden.planning.weather.probability.subline.medium":
    "Das Wetter kann das Training beeinträchtigen – bitte im Blick behalten.",
  "trainerstunden.planning.weather.probability.subline.high":
    "Die Prognose spricht eher gegen Outdoor-Training – Absage oder Verschiebung prüfen.",
  "trainerstunden.planning.weather.dayExecutionHint":
    "Pro Termin: Wetter und Einschätzung, ob das Outdoor-Training stattfindet.",
  "trainerstunden.planning.locationKind.indoor": "Indoor",
  "trainerstunden.planning.locationKind.outdoor": "Outdoor",
  "trainerstunden.planning.locationKind.other": "Anlage",
  "trainerstunden.planning.coachRow.aria": "Trainingstermin",
  "trainerstunden.planning.coachRow.participants": "Teilnehmer",
  "trainerstunden.planning.coachRow.weatherCol":
    "Wetter und Stattfinden-Einschätzung",
  "trainerstunden.planning.coachRow.menuAria": "Weitere Aktionen",
  "trainerstunden.planning.coachDesk.loadingMoreDays":
    "Weitere Tage werden geladen …",
  "trainerstunden.planning.coachRow.menuCancelSession": "Termin absagen",
  "trainerstunden.planning.coachRow.menuReactivateSession": "Reaktivieren",
  "trainerstunden.planning.coachRow.menuCopySession": "Termin kopieren",
  "trainerstunden.planning.coachRow.menuEditSeries": "Serie bearbeiten",
  "trainerstunden.planning.coachRow.menuRescheduleSession":
    "Termin verschieben",
  "trainerstunden.planning.coachRow.menuReviewDispute":
    "Reklamation bearbeiten",
  "trainerstunden.planning.coachRow.menuOpenConfirmations":
    "In Bestätigungen öffnen",
  "trainerstunden.planning.disputePendingFlag": "Reklamation offen",
  "trainerstunden.planning.disputePendingOpenAria":
    "Reklamation in Bestätigungen bearbeiten",
  "trainerstunden.planning.disputePendingHint":
    "Offene Anwesenheits-Reklamation — Nacharbeit in Bestätigungen nötig.",
  "trainerstunden.planning.schoolHoliday.badge": "Ferien",
  "trainerstunden.planning.schoolHoliday.badgeHint":
    "Termin liegt in den Schulferien des gewählten Bundeslands – Jugendliche und Kinder sind ggf. schwerer planbar.",
  "trainerstunden.planning.participantsTruncatedSuffix": " …",
  "trainerstunden.planning.sessionRowAtTrainer": "{players} beim {trainer}",
  "trainerstunden.planning.participantsDeclinedInline": "Abgesagt · {names}",
  "trainerstunden.planning.participantsAllDeclinedPreview": "Alle abgesagt",
  "trainerstunden.planning.participantDeclinedBadge": "Abgesagt",
  "trainerstunden.planning.exportIcsAria":
    "Kommende Termine als Kalenderdatei für Outlook und andere Kalender herunterladen",
  "trainerstunden.planning.exportIcsEmpty":
    "Keine kommenden Termine für den gewählten Trainer – nichts zu exportieren.",
  "trainerstunden.planning.exportIcsNotesPrefix": "Notiz",
  "trainerstunden.planning.listWeekHeading": "KW {kw} ({year}) · {range}",
  "trainerstunden.planning.listExpandAllWeeks": "Alle Zeiträume einblenden",
  "trainerstunden.planning.listResetFourWeeks": "Nur nächste 4 Wochen",
  "trainerstunden.planning.listExpandAllPast":
    "Alle vergangenen Zeiträume einblenden",
  "trainerstunden.planning.listQuickExpandAria": "Schnell ein- und ausblenden",
  "trainerstunden.planning.pastFilterAria":
    "Vergangene Trainings nach Datum filtern",
  "trainerstunden.planning.pastFilterFromLabel": "Von",
  "trainerstunden.planning.pastFilterToLabel": "Bis",
  "trainerstunden.planning.pastFilterReset": "Filter zurücksetzen",
  "trainerstunden.planning.pastFilterEmpty":
    "Keine vergangenen Trainings im gewählten Zeitraum.",
  "trainerstunden.planning.pastShowMore": "{count} weitere anzeigen",
  "trainerstunden.planning.pastShownCount": "{shown} von {total} angezeigt",
  "trainerstunden.planning.mobileOptionsSummary": "Optionen",
  "trainerstunden.planning.mobileOptionsDetailsAria":
    "Weitere Planungsoptionen ein- oder ausblenden",
  "trainerstunden.planning.mobileCalendarColumns.aria":
    "Trainer-Spalten wählen",
  "trainerstunden.planning.mobileCalendarColumns.hint":
    "Bis zu {max} Trainer-Spalten im Hochformat. Wähle die Trainer, die angezeigt werden.",
  "trainerstunden.planning.mobileCalendarColumns.slot": "Spalte {index}",
  "trainerstunden.planning.mobileCalendarColumns.none": "Ausblenden",
  "trainerstunden.planning.agenda.nextBadge": "Als nächstes",
  "trainerstunden.planning.agenda.sheetTitle": "Training absagen",
  "trainerstunden.planning.agenda.sheetIntro":
    "Umfang wählen, Ausfallgrund setzen und bestätigen. Der Termin bleibt in der Übersicht sichtbar, sofern er nicht gelöscht wird.",
  "trainerstunden.planning.agenda.cancelScopeLabel": "Umfang",
  "trainerstunden.planning.agenda.scopeSingle": "Nur diesen Termin absagen",
  "trainerstunden.planning.agenda.scopeSeriesFollowing":
    "Diesen und alle zukünftigen Termine der Serie absagen",
  "trainerstunden.planning.agenda.scopeSeriesDelete":
    "Alle zukünftigen Termine der Serie löschen",
  "trainerstunden.planning.agenda.seriesDeleteConfirm":
    "Alle ausgewählten zukünftigen Serientermine löschen? Sie bleiben zur Nachverfolgung gespeichert und können wiederhergestellt werden.",
  "trainerstunden.planning.agenda.saveCancelled": "Absage speichern",
  "trainerstunden.planning.agenda.cancelCreditInvoicedHint":
    "Für diese Stunde wurde bereits eine Rechnung versendet. Die Rechnung bleibt unverändert.",
  "trainerstunden.planning.agenda.cancelCreditCheckboxLabel":
    "Kosten der Stunde ({amount}) als Gutschrift notieren",
  "trainerstunden.planning.agenda.cancelCreditConfirm":
    "Für diese Stunde wurde bereits eine Rechnung versendet. Kosten der Stunde als Gutschrift notieren?",
  "trainerstunden.planning.agenda.submitBusy": "Wird verarbeitet …",
  "trainerstunden.planning.agenda.cancelledBadge": "Abgesagt",
  "trainerstunden.planning.agenda.cancelledLine": "{badge} · {reason}",
  "trainerstunden.planning.agenda.cancelledCollapsibleSummary":
    "Abgesagt ({count})",
  "trainerstunden.planning.agenda.rescheduledBadge": "(umgeplant)",
  "trainerstunden.planning.agenda.rescheduledLine":
    "Verschoben aufgrund {reason}",
  "trainerstunden.planning.agenda.playerOverlapGroupAria":
    "Zeitliche Überschneidung bei Teilnehmern",
  "trainerstunden.planning.agenda.playerDoubleBookingHint":
    "{name} wird zur gleichen Zeit doppelt trainiert.",
  "trainerstunden.planning.agenda.playerDoubleBookingHintWithTrainers":
    "{name} wird zur gleichen Zeit doppelt trainiert. Dieselbe Person ist parallel bei {trainers} eingetragen.",
  "trainerstunden.planning.moveReasonModal.title": "Termin verschieben",
  "trainerstunden.planning.moveReasonModal.body":
    "Optional kannst du einen kurzen Grund angeben (z. B. Wetter, Platzwechsel). Er wird in den Notizen ergänzt.",
  "trainerstunden.planning.moveReasonModal.label": "Grund (optional)",
  "trainerstunden.planning.moveReasonModal.cancel": "Abbrechen",
  "trainerstunden.planning.moveReasonModal.confirm": "Speichern",
  "trainerstunden.planning.moveReasonModal.saving": "Wird gespeichert …",
  "trainerstunden.planning.rescheduleModal.title": "Termin verschieben",
  "trainerstunden.planning.rescheduleModal.dateLabel": "Datum",
  "trainerstunden.planning.rescheduleModal.timeLabel": "Uhrzeit",
  "trainerstunden.planning.rescheduleModal.durationLabel": "Dauer (Min.)",
  "trainerstunden.planning.rescheduleModal.reasonLabel": "Grund (optional)",
  "trainerstunden.planning.rescheduleModal.cancel": "Abbrechen",
  "trainerstunden.planning.rescheduleModal.save": "Speichern",
  "trainerstunden.planning.rescheduleModal.saving": "Wird gespeichert …",
  "trainerstunden.planning.rescheduleModal.validation":
    "Bitte Datum und Uhrzeit angeben.",
  "trainerstunden.planning.coachRow.openConfirmHint":
    "Teilnehmer und Anwesenheit bearbeiten",
  "trainerstunden.planning.moveReasonNoteLine": "Verschoben: {reason}",
  "trainerstunden.planning.reactivate.confirm": "Termin wieder aktivieren?",
  "trainerstunden.planning.reactivate.failed":
    "Termin konnte nicht reaktiviert werden.",
  "trainerstunden.planning.deleteSessionModal.title": "Termin löschen",
  "trainerstunden.planning.deleteSessionModal.body":
    "Der Termin wird aus der Übersicht entfernt, bleibt aber zur Nachverfolgung gespeichert. Optional kannst du einen Grund angeben.",
  "trainerstunden.planning.deleteSessionModal.label": "Grund (optional)",
  "trainerstunden.planning.deleteSessionModal.cancel": "Abbrechen",
  "trainerstunden.planning.deleteSessionModal.confirm": "Löschen",
  "trainerstunden.planning.deleteSessionModal.saving": "Wird gelöscht …",
  "trainerstunden.planning.cancelSessionModal.title": "Termin absagen",
  "trainerstunden.planning.cancelSessionModal.body":
    "Der Termin bleibt in der Planung sichtbar und wird als ausgefallen markiert.",
  "trainerstunden.planning.cancelSessionModal.cancel": "Abbrechen",
  "trainerstunden.planning.cancelSessionModal.confirm": "Absagen",
  "trainerstunden.planning.cancelSessionModal.saving": "Wird abgesagt …",
  "trainerstunden.planning.listDeleteNotFuture":
    "Bestätigte Trainings können nicht gelöscht werden.",
  "trainerstunden.planning.deletedBinTitle": "Kürzlich gelöscht ({count})",
  "trainerstunden.planning.deletedBinHint":
    "Nur zukünftige Termine. Wiederherstellen bringt den Termin zurück in die Planung.",
  "trainerstunden.planning.restoreSession": "Wiederherstellen",
  "trainerstunden.planning.restoreFailed":
    "Wiederherstellen ist fehlgeschlagen.",
  "trainerstunden.planning.seriesDeepSectionTitle": "Serie",
  "trainerstunden.planning.seriesDeepEditRow": "Serie ab diesem Termin",
  "trainerstunden.planning.seriesDeepEditValue": "Expertenansicht öffnen …",
  "trainerstunden.planning.seriesDeepEditAria":
    "Serie ab diesem Termin in der Expertenansicht bearbeiten",
  "trainerstunden.planning.editorDiscardToOverview": "Zurück zur Übersicht",
  "trainerstunden.planning.editorDiscardHint":
    "Ohne Speichern schließen: alle Änderungen an diesem Termin gehen verloren.",
  "trainerstunden.planning.unsavedNavigateTitle": "Änderungen speichern?",
  "trainerstunden.planning.unsavedNavigateIntro":
    "Es gibt ungespeicherte Änderungen an diesem Termin:",
  "trainerstunden.planning.unsavedChange.date": "Datum",
  "trainerstunden.planning.unsavedChange.startTime": "Startzeit",
  "trainerstunden.planning.unsavedChange.duration": "Dauer",
  "trainerstunden.planning.unsavedChange.trainer": "Trainer",
  "trainerstunden.planning.unsavedChange.targetGroup": "Zielgruppe",
  "trainerstunden.planning.unsavedChange.participants": "Spieler",
  "trainerstunden.planning.unsavedChange.clientRate":
    "Stundensatz (Mitglieder)",
  "trainerstunden.planning.unsavedChange.court": "Spielfeld",
  "trainerstunden.planning.unsavedChange.location": "Ort",
  "trainerstunden.planning.unsavedChange.trainerHonorar": "Trainer-Honorar",
  "trainerstunden.planning.unsavedChange.notes": "Notizen",
  "trainerstunden.planning.unsavedChange.seriesScope": "Serien-Umfang",
  "trainerstunden.planning.unsavedNavigateSave": "Speichern",
  "trainerstunden.planning.unsavedNavigateDiscard": "Verwerfen",
  "trainerstunden.planning.unsavedNavigateKeepEditing": "Weiter bearbeiten",
  "trainerstunden.planning.pastConfirmedBillingBlockedLead":
    "Für dieses Training liegt bereits eine Abrechnung vor.",
  "trainerstunden.planning.billingBlockLinkDraft": "Zum Rechnungsentwurf",
  "trainerstunden.planning.billingBlockLinkInvoice": "Zur Rechnung",
  "trainerstunden.planning.billingBlockLinkStorno": "Rechnung stornieren",
  "trainerstunden.planning.billingBlockLinkInvoicing": "Zur Rechnungsstellung",
  "trainerstunden.planning.agenda.editIconAria": "Termin bearbeiten",
  "trainerstunden.planning.agenda.cancelIconAria": "Training absagen",
  "trainerstunden.planning.makeupBacklog.title": "Nachhol-Termine ausstehend",
  "trainerstunden.planning.makeupBacklog.subtitle":
    "Diese Trainings wurden abgesagt (z. B. Wetter), aber es wurde noch kein Ersatztermin geplant.",
  "trainerstunden.planning.makeupBacklog.count": "{count} Termin(e)",
  "trainerstunden.planning.makeupBacklog.empty":
    "Aktuell keine offenen Nachhol-Termine.",
  "trainerstunden.planning.makeupBacklog.trainerLine": "Trainer: {name}",
  "trainerstunden.planning.makeupBacklog.playersLine": "Geplant: {names}",
  "trainerstunden.planning.makeupBacklog.itemHint":
    "Wähle einen neuen Termin – Datum und Uhrzeit des abgesagten Trainings werden angepasst, Teilnehmer bleiben erhalten.",
  "trainerstunden.planning.makeupBacklog.rescheduleTitle":
    "Nachholtermin planen",
  "trainerstunden.planning.makeupBacklog.reschedulePastConfirm":
    "Der gewählte Termin liegt in der Vergangenheit. Trotzdem als Nachholtermin planen?",
  "trainerstunden.planning.makeupBacklog.openSession": "Termin ansehen",
  "trainerstunden.planning.makeupBacklog.planMakeup": "Nachholtermin planen",
  "trainerstunden.planning.makeupBacklog.waiveMakeup": "Kein Nachholtermin",
  "trainerstunden.planning.makeupBacklog.waiveConfirmTitle":
    "Kein Nachholtermin?",
  "trainerstunden.planning.makeupBacklog.waiveConfirm":
    "Diesen Termin aus der Nachhol-Liste entfernen? Es wird kein Ersatztermin geplant.",
  "trainerstunden.planning.makeupBacklog.waiveFailed":
    "Konnte nicht gespeichert werden. Bitte erneut versuchen.",
  "trainerstunden.planning.cancel.planMakeup": "Als Nachholtermin vormerken",
  "trainerstunden.planning.cancel.planMakeupHint":
    "Standard: Absage ohne Nachhol-Liste. Nur anhaken, wenn ein Ersatztermin geplant werden soll.",
  "trainerstunden.planning.makeupBacklog.allPlanning": "Gesamte Planung",
  "trainerstunden.planning.parentBookingRequests.title":
    "Offene Buchungsanfragen",
  "trainerstunden.planning.parentBookingRequests.navLink": "Buchungsanfragen",
  "trainerstunden.planning.parentBookingRequests.subtitle":
    "Anfragen vom Spieler prüfen oder offene Gegenvorschläge nachverfolgen.",
  "trainerstunden.planning.parentBookingRequests.count": "{count} Anfrage(n)",
  "trainerstunden.planning.parentBookingRequests.empty":
    "Aktuell keine offenen Buchungsanfragen.",
  "trainerstunden.planning.parentBookingRequests.pendingBadge": "Offen",
  "trainerstunden.planning.parentBookingRequests.calendarBlockLabel": "Anfrage",
  "trainerstunden.planning.calendarLegendAria": "Kalender-Legende",
  "trainerstunden.planning.calendarLegend.confirmed": "Bestätigt",
  "trainerstunden.planning.calendarLegend.open": "Offen",
  "trainerstunden.planning.calendarLegend.request": "Anfrage",
  "trainerstunden.planning.calendarLegend.cancelled": "Abgesagt",
  "trainerstunden.planning.parentBookingRequests.sectionReview": "Zu prüfen",
  "trainerstunden.planning.parentBookingRequests.sectionAwaitingPlayer":
    "Warte auf Antwort",
  "trainerstunden.planning.parentBookingRequests.awaitingBadge":
    "Gegenvorschlag offen",
  "trainerstunden.planning.parentBookingRequests.awaitingHint":
    "Dein Gegenvorschlag liegt beim Spieler. Sobald er annimmt oder ablehnt, aktualisiert sich der Status.",
  "trainerstunden.planning.parentBookingRequests.openSession": "Termin öffnen",
  "trainerstunden.planning.toolbarAria": "Trainingsplanung-Toolbar",
  "trainerstunden.planning.navGroupAria": "Kalendernavigation",
  "trainerstunden.planning.navToday": "Heute",
  "trainerstunden.planning.calendarMoreToggle": "Filter & Aktionen",
  "trainerstunden.planning.calendarFullDay": "Ganzer Tag",
  "trainerstunden.planning.calendarFocus.empty":
    "Keine Trainings in diesem Zeitraum",
  "trainerstunden.planning.calendarFocus.today": {
    one: "Heute: {count} Training · erstes Training {first} Uhr · letzter Termin {last} Uhr",
    other:
      "Heute: {count} Trainings · erstes Training {first} Uhr · letzter Termin {last} Uhr",
  },
  "trainerstunden.planning.calendarFocus.day": {
    one: "{count} Training · erstes Training {first} Uhr · letzter Termin {last} Uhr",
    other:
      "{count} Trainings · erstes Training {first} Uhr · letzter Termin {last} Uhr",
  },
  "trainerstunden.planning.calendarFocus.range": {
    one: "{days} Tage: {count} Training · erstes {first} Uhr · letztes {last} Uhr",
    other:
      "{days} Tage: {count} Trainings · erstes {first} Uhr · letztes {last} Uhr",
  },
  "trainerstunden.planning.navTomorrow": "Morgen",
  "trainerstunden.planning.filterGroup.view": "Ansicht",
  "trainerstunden.planning.filterGroup.quick": "Schnellfilter",
  "trainerstunden.planning.filterGroup.more": "Weitere Filter",
  "trainerstunden.planning.navPrevAria": "Vorherige Periode",
  "trainerstunden.planning.navNextAria": "Nächste Periode",
  "trainerstunden.planning.navPrevDayAria": "Vorheriger Tag",
  "trainerstunden.planning.navNextDayAria": "Nächster Tag",
  "trainerstunden.planning.mobileCalendarDayNavAria":
    "Tagesnavigation im Kalender",
  "trainerstunden.planning.mobileCalendarDatePickAria": "Datum auswählen",
  "trainerstunden.planning.createCta": "+ Termin",
  "trainerstunden.planning.createCtaFull": "+ Termin erstellen",
  "trainerstunden.planning.seasonPlanningCta": "Saison planen",
  "trainerstunden.planning.createDisabledHint": "Demnächst: Termin erstellen",
  "trainerstunden.seasonPlanning.title": "Saisonplanung",
  "trainerstunden.seasonPlanning.subtitle":
    "Eine Planung für den Saisonzeitraum — darunter mehrere Trainingsgruppen anlegen, Spieler zuordnen und Verfügbarkeit anfragen.",
  "trainerstunden.seasonPlanning.step.meta": "Saison",
  "trainerstunden.seasonPlanning.step.groups": "Gruppen & Spieler",
  "trainerstunden.seasonPlanning.step.assign": "Zuordnung",
  "trainerstunden.seasonPlanning.step.review": "Abschluss",
  "trainerstunden.seasonPlanning.field.title": "Name der Planung",
  "trainerstunden.seasonPlanning.field.titlePlaceholder": "z. B. Sommer 2026",
  "trainerstunden.seasonPlanning.field.kind": "Zeitraum-Vorlage",
  "trainerstunden.seasonPlanning.kind.summer": "Sommer",
  "trainerstunden.seasonPlanning.kind.winter": "Winter",
  "trainerstunden.seasonPlanning.kind.custom": "Eigener Zeitraum",
  "trainerstunden.seasonPlanning.field.startDate": "Beginn",
  "trainerstunden.seasonPlanning.field.endDate": "Ende",
  "trainerstunden.seasonPlanning.groups.heading":
    "Trainingsgruppen in dieser Saison",
  "trainerstunden.seasonPlanning.groups.hint":
    "Jede Karte ist eine Gruppe unter derselben Planung. Passe Größe, Wochentag und Uhrzeit an — die Spielerzuordnung folgt im nächsten Schritt.",
  "trainerstunden.seasonPlanning.groups.mini": "Mini (4–7)",
  "trainerstunden.seasonPlanning.groups.kids": "Kinder (8–10)",
  "trainerstunden.seasonPlanning.groups.u12": "U12",
  "trainerstunden.seasonPlanning.groups.u14": "U14",
  "trainerstunden.seasonPlanning.groups.u16": "U16",
  "trainerstunden.seasonPlanning.groups.u18": "U18",
  "trainerstunden.seasonPlanning.groups.adults": "Erwachsene",
  "trainerstunden.seasonPlanning.groups.custom": "Gruppe",
  "trainerstunden.seasonPlanning.field.maxSize": "Max. Spieler",
  "trainerstunden.seasonPlanning.field.weekday": "Wochentag",
  "trainerstunden.seasonPlanning.field.startTime": "Uhrzeit",
  "trainerstunden.seasonPlanning.weekday.none": "—",
  "trainerstunden.seasonPlanning.weekday.0": "So",
  "trainerstunden.seasonPlanning.weekday.1": "Mo",
  "trainerstunden.seasonPlanning.weekday.2": "Di",
  "trainerstunden.seasonPlanning.weekday.3": "Mi",
  "trainerstunden.seasonPlanning.weekday.4": "Do",
  "trainerstunden.seasonPlanning.weekday.5": "Fr",
  "trainerstunden.seasonPlanning.weekday.6": "Sa",
  "trainerstunden.seasonPlanning.players.heading": "Spieler auswählen",
  "trainerstunden.seasonPlanning.players.search": "Spieler suchen …",
  "trainerstunden.seasonPlanning.players.selectedCount": {
    one: "1 Spieler ausgewählt",
    other: "{count} Spieler ausgewählt",
  },
  "trainerstunden.seasonPlanning.players.empty": "Keine Spieler gefunden.",
  "trainerstunden.seasonPlanning.assign.heading": "Gruppenzuordnung",
  "trainerstunden.seasonPlanning.assign.hint":
    "Vorschläge kannst du pro Spieler überschreiben.",
  "trainerstunden.seasonPlanning.assign.unassigned": "Nicht zugeordnet",
  "trainerstunden.seasonPlanning.assign.ageUnknown": "Alter unbekannt",
  "trainerstunden.seasonPlanning.assign.ageLabel": "{age} Jahre",
  "trainerstunden.seasonPlanning.review.heading": "Prüfen & abschließen",
  "trainerstunden.seasonPlanning.review.checklistOk":
    "Alle Pflichtangaben sind vollständig.",
  "trainerstunden.seasonPlanning.review.checklistIssues":
    "Bitte behebe noch {count} Hinweise, bevor du fortfährst.",
  "trainerstunden.seasonPlanning.review.groupSummary":
    "{label} · {count} Spieler",
  "trainerstunden.seasonPlanning.review.emptyGroup": "Keine Spieler",
  "trainerstunden.seasonPlanning.action.back": "Zurück",
  "trainerstunden.seasonPlanning.action.next": "Weiter",
  "trainerstunden.seasonPlanning.action.saveDraft": "Entwurf speichern",
  "trainerstunden.seasonPlanning.action.sendAvailability":
    "Verfügbarkeit anfragen",
  "trainerstunden.seasonPlanning.action.close": "Schließen",
  "trainerstunden.seasonPlanning.draftSaved": "Entwurf gespeichert.",
  "trainerstunden.seasonPlanning.availabilitySent":
    "Verfügbarkeitsanfragen versendet.",
  "trainerstunden.seasonPlanning.availabilityPartial":
    "{sent} versendet, {skipped} übersprungen, {failed} fehlgeschlagen.",
  "trainerstunden.seasonPlanning.error.generic": "Aktion fehlgeschlagen.",
  "trainerstunden.seasonPlanning.validation.missing-title":
    "Bitte einen Namen für die Planung eingeben.",
  "trainerstunden.seasonPlanning.validation.missing-dates":
    "Bitte Start- und Enddatum setzen.",
  "trainerstunden.seasonPlanning.validation.invalid-date-range":
    "Das Enddatum muss nach dem Startdatum liegen.",
  "trainerstunden.seasonPlanning.validation.missing-players":
    "Bitte mindestens einen Spieler auswählen.",
  "trainerstunden.seasonPlanning.validation.unassigned-player":
    "Nicht alle Spieler sind einer Gruppe zugeordnet.",
  "trainerstunden.planning.eventClickHint":
    "Tipp: Auf einen Kalendereintrag tippen, um geplante Spieler zu bearbeiten oder zu ergänzen.",
  "trainerstunden.agenda.title": "Tagesplan",
  "trainerstunden.agenda.subtitle":
    "Offene und vergangene Termine: Anwesenheit bestätigen oder korrigieren. Such- und Datumsfilter bleiben verfügbar; kommende Termine planst du unter „Trainingstermine“.",
  "trainerstunden.agenda.toolbarAria": "Tagesplan-Werkzeugleiste",
  "trainerstunden.agenda.backlogToolbarCta": "Jetzt bestätigen",
  "trainerstunden.agenda.openAttendanceTitle": "Trainings bestätigen",
  "trainerstunden.agenda.openAttendanceHint":
    "Trainings prüfen und Teilnehmer bestätigen.",
  "trainerstunden.agenda.declinedOverrideHint":
    "Abgesagte Spieler kannst du hier aktivieren, wenn sie doch teilgenommen haben.",
  "trainerstunden.agenda.participantDeclinedOverrideBadge":
    "Anwesend (Absage überstimmt)",
  "trainerstunden.agenda.backlogAllCta": "Alle bestätigen",
  "trainerstunden.agenda.addPlayersCompact": "+ Spieler hinzufügen",
  "trainerstunden.agenda.filtersAria": "Filter",
  "trainerstunden.agenda.filters.reset": "Filter zurücksetzen",
  "trainerstunden.agenda.filters.active": "Aktiv",
  "trainerstunden.agenda.filters.show": "Filter anzeigen",
  "trainerstunden.agenda.filters.hide": "Filter ausblenden",
  "trainerstunden.agenda.agendaResetModal.title": "Agenda zurücksetzen?",
  "trainerstunden.agenda.agendaResetModal.body":
    "Spielersuche und Datumsfilter werden geleert; gefilterte Ansichten und Auswahlzustände dazu werden zurückgesetzt.",
  "trainerstunden.agenda.agendaResetModal.confirm": "Zurücksetzen",
  "trainerstunden.agenda.playerSearch.label": "Spieler",
  "trainerstunden.agenda.playerSearch.placeholder": "Name, E‑Mail oder Telefon",
  "trainerstunden.agenda.playerSearch.aria": "Spieler suchen",
  "trainerstunden.agenda.participantFilter.legend":
    "Teilnahme des gesuchten Spielers",
  "trainerstunden.agenda.participantFilter.participated":
    "Training durchgeführt",
  "trainerstunden.agenda.participantFilter.declined": "Teilnehmer abgesagt",
  "trainerstunden.agenda.participantFilter.absent": "Teilnehmer abwesend",
  "trainerstunden.agenda.participantFilter.planned_open": "Noch offen",
  "trainerstunden.agenda.participantStatus.participated":
    "Training durchgeführt",
  "trainerstunden.agenda.participantStatus.declined": "Teilnehmer abgesagt",
  "trainerstunden.agenda.participantStatus.absent": "Teilnehmer abwesend",
  "trainerstunden.agenda.participantStatus.plannedOpen": "Geplant",
  "trainerstunden.agenda.range.from": "Von",
  "trainerstunden.agenda.range.to": "Bis",
  "trainerstunden.agenda.history.title": "Übersicht (gefiltert)",
  "trainerstunden.agenda.history.count": "{count} Treffer",
  "trainerstunden.agenda.history.empty": "Keine Treffer.",
  "trainerstunden.agenda.compactRow.moreAria": "Aktionen für {label}",
  "trainerstunden.agenda.compactRow.sheetSubtitle":
    "Termin bearbeiten oder Abrechnung öffnen",
  "trainerstunden.agenda.compactRow.sheetActionsAria": "Termin-Aktionen",
  "trainerstunden.agenda.compactRow.openAttendance": "Anwesenheit bearbeiten",
  "trainerstunden.agenda.backlogSectionToolbarHint":
    "Öffnet die Bestätigungsansicht für alle offenen Termine – getrennt von den einzelnen Trainings unten.",
  "trainerstunden.agenda.backlogAllCtaLong":
    "Alle offenen bestätigen ({count})",
  "trainerstunden.agenda.returnToBilling": "Zurück zur Rechnungsstellung",
  "trainerstunden.agenda.returnToHub": "Zurück zur Übersicht",
  "trainerstunden.agenda.returnToPrevious": "Zurück",
  "trainerstunden.agenda.backlogTitle": "Zur Abnahme (noch offen)",
  "trainerstunden.agenda.backlogHint":
    "Trainings, die bereits vorbei sind, bei denen die Anwesenheit aber noch nicht bestätigt wurde.",
  "trainerstunden.agenda.confirmMode.title": "Zu bestätigende Trainings",
  "trainerstunden.agenda.confirmMode.subtitle":
    "Noch {count} Trainings zu bestätigen",
  "trainerstunden.agenda.confirmMode.empty": "Alles bestätigt",
  "trainerstunden.agenda.confirmMode.emptyAllDone": "Alles erledigt.",
  "trainerstunden.agenda.confirmMode.emptyNothingTodo": "Alles erledigt.",
  "trainerstunden.agenda.confirmSuccess.session":
    "Training bestätigt – als durchgeführt markiert.",
  "trainerstunden.agenda.backlogEmpty.allDoneToday": "Für heute erledigt.",
  "trainerstunden.agenda.backlogEmpty.nothingTodo": "Alles erledigt.",
  "trainerstunden.agenda.confirmMode.backToDashboard": "Zurück zum Dashboard",
  "trainerstunden.agenda.backlogBanner.title":
    "{count} Trainings müssen noch bestätigt werden",
  "trainerstunden.agenda.backlogBanner.cta": "Jetzt bestätigen",
  "trainerstunden.agenda.trainerFilterAria": "Trainer-Filter",
  "trainerstunden.agenda.backlogMode.progress":
    "Noch {count} Trainings zu bestätigen",
  "trainerstunden.agenda.backlogMode.allDone": "Alles bestätigt",
  "trainerstunden.agenda.backlogMode.backToDashboard": "Zurück zum Dashboard",
  "trainerstunden.agenda.editPlayers": "Spieler bearbeiten",
  "trainerstunden.agenda.collapsePlayers": "Einklappen",
  "trainerstunden.agenda.plannedPlayersHint":
    "Geplante Teilnehmer für dieses Training. Du kannst die Liste anpassen – Änderungen werden sofort gespeichert.",
  "trainerstunden.agenda.participantsSectionAria": "Teilnehmer am Training",
  "trainerstunden.agenda.participantsSectionTitle": "Spieler",
  "trainerstunden.agenda.participantsChipsGroupAria": "Ausgewählte Teilnehmer",
  "trainerstunden.agenda.attendanceSelectionMeta":
    "{present}/{planned} ausgewählt · {amount} €",
  "trainerstunden.agenda.addPlayerPlaceholder": "Spieler hinzufügen …",
  "trainerstunden.agenda.addPlayerCreatePlaceholder":
    "Neuen Spieler tippen (Vor- und Nachname) …",
  "trainerstunden.agenda.addPlayerScope.title": "Spieler hinzufügen",
  "trainerstunden.agenda.addPlayerScope.body":
    "Soll {name} nur für diesen Termin oder in die Serie ab hier aufgenommen werden?",
  "trainerstunden.agenda.addPlayerScope.single": "Einmalig – nur dieser Termin",
  "trainerstunden.agenda.addPlayerScope.series": "In die Serie ab hier",
  "trainerstunden.agenda.addPlayerComboboxAria":
    "Spieler suchen und hinzufügen",
  "trainerstunden.agenda.createNewPlayerOption":
    "Neuen Spieler „{name}“ anlegen",
  "trainerstunden.agenda.participantsSummaryFull":
    "{count} Teilnehmer · {amount} €",
  "trainerstunden.agenda.participantsSummaryCount": "{count} Teilnehmer",
  "trainerstunden.agenda.quickSuggestAdd": "+ {name}",
  "trainerstunden.agenda.quickSuggestionsAria":
    "Vorschläge: häufig mit diesem Trainer oder zu diesem Wochentag und dieser Uhrzeit geplant (nur Spieler)",
  "trainerstunden.agenda.playerAlreadyPlannedHint":
    "Diese Person ist bereits als Teilnehmer eingetragen.",
  "trainerstunden.agenda.addExistingPlayer": "Bestehenden Spieler hinzufügen",
  "trainerstunden.agenda.addPlayer": "Hinzufügen",
  "trainerstunden.agenda.quickCreatePlayer": "Neuen Spieler anlegen",
  "trainerstunden.agenda.createAndAddPlayer": "Anlegen & hinzufügen",
  "trainerstunden.agenda.quickCreateHint":
    "Der Spieler erscheint automatisch in den Stammdaten (Spieler).",
  "trainerstunden.agenda.quickPlayerNameRequired":
    "Bitte einen Namen eingeben.",
  "trainerstunden.agenda.quickPlayerCreateFailed":
    "Spieler konnte nicht angelegt werden.",
  "trainerstunden.agenda.plannedSaveFailed":
    "Geplante Spieler konnten nicht gespeichert werden.",
  "trainerstunden.agenda.removePlannedPlayer": "Aus Planung entfernen",
  "trainerstunden.agenda.playerUnknown": "Unbekannte Person",
  "trainerstunden.agenda.recentOpenOnlyHint":
    "Nur zurückliegende Termine mit offener Anwesenheit (innerhalb der letzten {days} Tage).",
  "trainerstunden.agenda.emptyRecentOpen":
    "Keine passenden offenen Bestätigungen (Filter oder Datumsbereich prüfen).",
  "trainerstunden.agenda.sheetAttendanceHint":
    "Die Abnahme der Anwesenheit erledigst du unter „Trainingsbestätigung“ beim jeweiligen Termin.",
  "trainerstunden.agenda.sessionFocusSubtitle":
    "Details, Teilnehmer und Abrechnung im Überblick.",
  "trainerstunden.agenda.focus.title": "Direktlink: Termin",
  "trainerstunden.agenda.focus.hint":
    "Du bist per Link aus einer Rechnung hierher gesprungen. Hier kannst du prüfen und ggf. korrigieren.",
  "trainerstunden.agenda.focus.hubTitle": "Trainingseinheit",
  "trainerstunden.agenda.focus.hubHint":
    "Details und Teilnehmerstatus für den ausgewählten Termin.",
  "trainerstunden.agenda.focus.parentBookingTitle": "Trainingsanfrage",
  "trainerstunden.agenda.focus.parentBookingHint":
    "Prüfe Termin und Verfügbarkeit. Anwesenheit bestätigst du erst nach der Durchführung der Stunde.",
  "trainerstunden.agenda.resetHint":
    "Dieser Termin ist bereits bestätigt. Wenn du Teilnehmer korrigieren musst, setze die Bestätigung zurück und bestätige danach erneut.",
  "trainerstunden.agenda.confirmedAddPlayerHint":
    "Termin ist bestätigt. Du kannst noch Spieler ergänzen; für Anwesenheitskorrekturen Bestätigung zurücksetzen.",
  "trainerstunden.agenda.resetCta": "Bestätigung zurücksetzen",
  "trainerstunden.agenda.disputePendingBanner":
    "Offene Anwesenheits-Reklamation — bitte unten prüfen und entscheiden.",
  "trainerstunden.agenda.resetModal.title": "Bestätigung zurücksetzen?",
  "trainerstunden.agenda.resetModal.body":
    "Wenn bereits Rechnungen erstellt wurden, müssen diese ggf. aktualisiert oder neu erstellt werden.",
  "trainerstunden.agenda.resetModal.confirm": "Zurücksetzen",
  "trainerstunden.agenda.resetFailed":
    "Bestätigung konnte nicht zurückgesetzt werden.",
  "trainerstunden.agenda.cancel.title": "Training als ausgefallen markieren",
  "trainerstunden.agenda.cancel.subtitle":
    "Das Training bleibt in der Historie sichtbar und wird nicht gelöscht.",
  "trainerstunden.agenda.cancel.reasonLabel": "Ausfallgrund",
  "trainerstunden.agenda.cancel.reasonLabelOptional": "Ausfallgrund (optional)",
  "trainerstunden.agenda.cancel.reasonPlaceholder":
    "Bitte Ausfallgrund auswählen",
  "trainerstunden.agenda.cancel.noteLabel": "Notiz (optional)",
  "trainerstunden.agenda.cancel.notePlaceholder":
    "z.B. kurzer Kontext zur Absage",
  "trainerstunden.agenda.cancel.save": "Ausfall speichern",
  "trainerstunden.agenda.cancel.saveFailed":
    "Ausfall konnte nicht gespeichert werden.",
  "trainerstunden.agenda.cancel.doneLabel": "Ausgefallen · {reason}",
  "trainerstunden.agenda.confirmCard.confirmSessionCta": "Stunde bestätigen",
  "trainerstunden.agenda.confirmCard.participantsHeading": "Wer war da?",
  "trainerstunden.agenda.confirmCard.presentSummary":
    "{present} von {planned} anwesend",
  "trainerstunden.agenda.confirmCard.totalEurSubtle": "{amount} € gesamt",
  "trainerstunden.agenda.confirmCard.more": "Mehr",
  "trainerstunden.agenda.confirmCard.moreAria":
    "Weitere Aktionen zu diesem Training",
  "trainerstunden.agenda.confirmCard.addPlayerLink": "Spieler hinzufügen",
  "trainerstunden.sessionDetail.clockRange": "{start} – {end} Uhr",
  "trainerstunden.sessionDetail.addPlayersCta": "Spieler hinzufügen",
  "trainerstunden.sessionDetail.confirmHint":
    "Alle ausgewählten Spieler werden als anwesend markiert und anteilig berechnet.",
  "trainerstunden.session.indicator.series": "Serientermin",
  "trainerstunden.session.courtFormat": "Spielfeld",
  "trainerstunden.session.courtFormat.unset": "Nicht festgelegt",
  "trainerstunden.courtFormat.kleinfeld": "Kleinfeld",
  "trainerstunden.courtFormat.midcourt": "Midcourt",
  "trainerstunden.courtFormat.grossfeld": "Großfeld",
  "trainerstunden.sessionDetail.costTotal": "{amount} €",
  "trainerstunden.sessionDetail.costCardTitle": "Kostenübersicht",
  "trainerstunden.sessionDetail.costPlayersSelected":
    "{count} Spieler ausgewählt",
  "trainerstunden.sessionDetail.costPerPlayer": "{amount} € pro Spieler",
  "trainerstunden.sessionDetail.costPerPlayerEmpty":
    "Wähle mindestens einen Spieler – der Betrag pro Person erscheint dann hier.",
  "trainerstunden.sessionDetail.playerOn": "Anwesend",
  "trainerstunden.sessionDetail.playerOff": "Nicht gewählt",
  "trainerstunden.sessionDetail.playerShare": "{amount} €",
  "trainerstunden.sessionDetail.executionDocTitle": "Termindetails",
  "trainerstunden.sessionDetail.executionDocAria":
    "Übersicht der durchgeführten Trainingseinheit",
  "trainerstunden.sessionDetail.metaDate": "Datum",
  "trainerstunden.sessionDetail.metaTime": "Uhrzeit",
  "trainerstunden.sessionDetail.metaStatus": "Status",
  "trainerstunden.sessionDetail.metaLocation": "Ort",
  "trainerstunden.sessionDetail.metaCourt": "Platz",
  "trainerstunden.sessionDetail.participantsHeading": "Teilnehmer",
  "trainerstunden.sessionDetail.participantName": "Spieler",
  "trainerstunden.sessionDetail.participantStatus": "Anwesenheit",
  "trainerstunden.sessionDetail.participantAmount": "Anteil",
  "trainerstunden.sessionDetail.participantStatusAbsent": "Abwesend",
  "trainerstunden.sessionDetail.participantStatusCancelled": "Storniert",
  "trainerstunden.sessionDetail.notesLabel": "Notizen",
  "trainerstunden.sessionDetail.contentHeading": "Trainingsinhalte",
  "trainerstunden.sessionDetail.contentEmpty":
    "Noch keine Trainingsinhalte notiert. Über Bearbeiten kannst du sie ergänzen.",
  "trainerstunden.sessionDetail.cancelledSectionTitle": "Absage",
  "trainerstunden.sessionDetail.costPerPlayerLabel": "Pro Spieler",
  "trainerstunden.sessionDetail.totalAmountLabel": "Gesamtbetrag",
  "trainerstunden.sessionDoc.title": "Training dokumentieren",
  "trainerstunden.sessionDoc.promptQuestion": "Magst du dokumentieren?",
  "trainerstunden.sessionDoc.promptHint":
    "Was wurde trainiert und wie war die Qualität? Später geht’s auch noch.",
  "trainerstunden.sessionDoc.promptYes": "Ja, dokumentieren",
  "trainerstunden.sessionDoc.promptLater": "Später",
  "trainerstunden.sessionDoc.openFromDetail": "Dokumentieren",
  "trainerstunden.sessionDoc.noPresent":
    "Keine anwesenden Spieler zum Dokumentieren.",
  "trainerstunden.sessionDoc.documentedBadge": "Doku",
  "trainerstunden.sessionDoc.trainingStartedOn": "Training begonnen am",
  "trainerstunden.sessionDoc.trainingStartedOnAsk":
    "Automatisch aus erster bekannter Stunde – bei Bedarf anpassen.",
  "trainerstunden.sessionDoc.trainingStartedOnHint":
    "Bereits hinterlegt – nicht erneut abfragen.",
  "trainerstunden.sessionDoc.skillsHeading": "Trainingsinhalte",
  "trainerstunden.sessionDoc.progressNote": "Fortschritte / Notiz",
  "trainerstunden.sessionDoc.progressNotePlaceholder":
    "Was hat sich verbessert? Woran noch arbeiten?",
  "trainerstunden.sessionDoc.save": "Speichern",
  "trainerstunden.sessionDoc.saveAndNext": "Speichern & nächster",
  "trainerstunden.sessionDoc.saveFailed":
    "Dokumentation konnte nicht gespeichert werden.",
  "trainerstunden.sessionDoc.qualityAria": "Qualität für {skill}",
  "trainerstunden.sessionDoc.qualityStarAria": "{count} von 5 Sternen",
  "trainerstunden.sessionDoc.skill.forehand": "Vorhand",
  "trainerstunden.sessionDoc.skill.backhand": "Rückhand",
  "trainerstunden.sessionDoc.skill.volley": "Volley",
  "trainerstunden.sessionDoc.skill.serve": "Aufschlag",
  "trainerstunden.sessionDoc.skill.cross": "Cross",
  "trainerstunden.sessionDoc.skill.longline": "Longline",
  "trainerstunden.sessionDoc.skill.smash": "Smash",
  "trainerstunden.sessionDoc.skill.footwork": "Beinarbeit",
  "trainerstunden.planning.today": "Heute",
  "trainerstunden.planning.emptyToday": "Heute keine Termine.",
  "trainerstunden.planning.upcoming": "Als Nächstes",
  "trainerstunden.planning.emptyUpcoming": "Noch nichts geplant.",
  "trainerstunden.planning.emptyUpcomingInDays":
    "In den gewählten {days} Tagen keine offenen zukünftigen Termine.",
  "trainerstunden.planning.recent": "Letzte 7 Tage",
  "trainerstunden.planning.recentPeriod": "Letzte {days} Tage",
  "trainerstunden.planning.horizonLabel": "Zeitraum",
  "trainerstunden.planning.horizonHint":
    "Die nächsten bzw. letzten Tage in der Übersicht. Die Auswahl wird auf diesem Gerät gespeichert.",
  "trainerstunden.planning.horizonOption": "{days} Tage",
  "trainerstunden.planning.rangeUpcoming":
    "Offene Termine bis einschließlich {date}",
  "trainerstunden.planning.rangeRecent":
    "Abgeschlossene Termine der letzten {days} Tage",
  "trainerstunden.planning.loading": "Lade Daten …",
  "trainerstunden.dataLoad.watchdogHint":
    "Die Daten haben ungewöhnlich lange gedauert. Einige Angaben können unvollständig sein – bitte erneut laden oder die Seite neu öffnen.",
  "trainerstunden.dataLoad.retryLoad": "Erneut laden",
  "trainerstunden.planning.sessionDefaultTitle": "Trainerstunde",
  "trainerstunden.planning.sessionAttendanceLine": "Anwesenheit: {status}",
  "trainerstunden.planning.emptyRecent": "Keine Termine in diesem Zeitraum.",
  "trainerstunden.planning.durationMinutes": "{minutes} Min",
  "trainerstunden.planning.fieldDash": "–",
  "trainerstunden.planning.togglePresent": "Anwesend umschalten ({name})",
  "trainerstunden.planning.participantMove": "Verschieben",
  "trainerstunden.planning.participantMoveAria":
    "Teilnehmer {name} auf eine andere Stunde verschieben",
  "trainerstunden.planning.participantMove.intro":
    "{source} · Teilnehmer verschieben: Zielstunde auswählen",
  "trainerstunden.planning.participantMove.targetSessionLabel": "Zielstunde",
  "trainerstunden.planning.participantMove.noTargets":
    "Keine passenden Zielstunden verfügbar.",
  "trainerstunden.planning.participantMove.saving": "Wird verschoben …",
  "trainerstunden.planning.participantMove.confirm": "Verschieben",
  "trainerstunden.planning.confirmFailed":
    "Trainingsbestätigung konnte nicht gespeichert werden.",
  "trainerstunden.planning.totalSessionCost": "Gesamtkosten der Stunde",
  "trainerstunden.planning.confirmedDone": "Durchgeführt und bestätigt",
  "trainerstunden.planning.doneAwaitingConfirm":
    "Durchgeführt, noch nicht bestätigt",
  "trainerstunden.planning.bookingApprovalExpired":
    "Buchungsanfrage nicht freigegeben (abgelaufen)",
  "trainerstunden.planning.bookingRejected": "Buchungsanfrage abgelehnt",
  "trainerstunden.planning.bookingPendingGuardianExpired":
    "Wartet auf Erziehungsberechtigten (nicht freigegeben)",
  "trainerstunden.planning.bookingPendingTrainerExpired":
    "Wartet auf Trainer-Freigabe (nicht bestätigt)",
  "trainerstunden.planning.bookingNotConfirmed": "Buchung nicht freigegeben",
  "trainerstunden.planning.calendarTitle": "Kalender",
  "trainerstunden.planning.calendarViewWeek": "Woche",
  "trainerstunden.planning.calendarViewMonth": "Monat",
  "trainerstunden.planning.calendarViewDay": "1 Tag",
  "trainerstunden.planning.calendarViewThreeDays": "3 Tage",
  "trainerstunden.planning.calendarViewGroupLabel": "Kalenderansicht",
  "trainerstunden.planning.calendarJumpDateLabel": "Datum",
  "trainerstunden.planning.calendarJumpDateAria":
    "Kalender auf das gewählte Datum springen",
  "trainerstunden.planning.calendarTrainerFilterAria": "Trainer filtern",
  "trainerstunden.planning.calendarTrainerFilterCount": "{count} Trainer",
  "trainerstunden.planning.calendarHint":
    "Alle Termine im gewählten Trainer-Filter. So ist die Trainingsplanung wieder direkt im Blick.",
  "trainerstunden.planning.calendarInteractionHint":
    "Termin ziehen zum Verschieben; im Wochen- oder Tagesraster die untere Kante ziehen, um die Dauer zu ändern; dort einen Zeitraum auswählen, um einen neuen Termin anzulegen (im Monatsraster ist die Auswahl deaktiviert).",
  "trainerstunden.planning.moveFailed":
    "Termin konnte nicht verschoben werden.",
  "trainerstunden.planning.resizeFailed":
    "Dauer konnte nicht angepasst werden.",
  "trainerstunden.planning.createSheetTitle": "Neuer Termin",
  "trainerstunden.planning.createDraftCalendarTitle": "Neuer Termin",
  "trainerstunden.planning.createSheetIntro":
    "Standarddauer 60 Minuten; Trainingsart und Zielgruppe wählen. Der Stundensatz wird aus den Trainer-Stammdaten vorgeschlagen und kann angepasst werden.",
  "trainerstunden.planning.createSubmit": "Termin anlegen",
  "trainerstunden.planning.createCancel": "Abbrechen",
  "trainerstunden.planning.createSaving": "Wird angelegt …",
  "trainerstunden.planning.createSaveFailed":
    "Termin konnte nicht angelegt werden.",
  "trainerstunden.planning.createSaveFailedWithDetail":
    "Termin konnte nicht angelegt werden.\n\nTechnische Hinweise:\n{detail}",
  "trainerstunden.planning.createSuccess": "Training wurde angelegt.",
  "trainerstunden.planning.createSuccessSeries":
    "{count} Trainings wurden angelegt.",
  "trainerstunden.planning.createPlanAnotherPrompt":
    "Möchtest du direkt einen weiteren Termin planen?",
  "trainerstunden.planning.createRepeatSamePrompt":
    "Gleichen Termin nochmals anlegen – für weitere {weekday}?",
  "trainerstunden.planning.createRepeatCount": "{count}× {weekday}",
  "trainerstunden.planning.createRepeatCustomDate": "Anderes Datum",
  "trainerstunden.planning.createRepeatCustomDateAria":
    "Anderes Datum für denselben Termin wählen",
  "trainerstunden.planning.createRepeatCustomDateApply":
    "Datum übernehmen und anpassen",
  "trainerstunden.planning.createPlanAnotherYes": "Weiteren Termin planen",
  "trainerstunden.planning.createPlanAnotherNo": "Zu Trainingsterminen",
  "trainerstunden.planning.coachDeskBrand": "TrainingsDesk",
  "trainerstunden.planning.editorFormContextSubtitle": "Trainerstunde",
  "trainerstunden.planning.coachMobile.productBrand": "Tennis-Matches.de",
  "trainerstunden.planning.coachMobile.segmentsAria":
    "Zeitraum für die Trainingsliste",
  "trainerstunden.planning.coachMobile.segmentToday": "Heute",
  "trainerstunden.planning.coachMobile.segmentWeek": "Woche",
  "trainerstunden.planning.coachMobile.segmentMonth": "Monat",
  "trainerstunden.planning.coachMobile.primaryCtaTitle":
    "Neue Trainingssession planen",
  "trainerstunden.planning.coachMobile.primaryCtaSubtitle":
    "Training, Serie oder Einzelstunde erstellen",
  "trainerstunden.planning.coachMobile.primaryCtaAria":
    "Neue Trainingssession planen",
  "trainerstunden.planning.coachMobile.groupToday": "Heute",
  "trainerstunden.planning.coachMobile.groupWeek": "Diese Woche",
  "trainerstunden.planning.coachMobile.groupMonth": "Diesen Monat",
  "trainerstunden.planning.coachMobile.groupLater": "Später",
  "trainerstunden.planning.coachMobile.trainingCount": {
    one: "{count} Training",
    other: "{count} Trainings",
  },
  "trainerstunden.planning.coachMobile.filterBtnAria": "Filter",
  "trainerstunden.planning.coachMobile.filterBtnLabel": "Filter",
  "trainerstunden.planning.coachMobile.periodFilterAria":
    "Terminfilter · {period}",
  "trainerstunden.planning.coachMobile.createSessionAria":
    "Neues Training anlegen",
  "trainerstunden.planning.coachMobile.filterSheetTitle": "Terminfilter",
  "trainerstunden.planning.coachMobile.filterSheetPeriodAria": "Zeitraum",
  "trainerstunden.planning.coachMobile.filterSheetCalendarHint":
    "Im Kalender filterst du über die Kalendernavigation. Wechsle zur Liste für Suche und Trainerfilter.",
  "trainerstunden.planning.coachMobile.nextHero.eyebrowUpcoming":
    "Nächstes Training · {relative}",
  "trainerstunden.planning.coachMobile.nextHero.eyebrowRunning": "Läuft gerade",
  "trainerstunden.planning.coachMobile.nextHero.actionEdit": "Bearbeiten",
  "trainerstunden.planning.coachMobile.nextHero.actionCancel": "Absagen",
  "trainerstunden.planning.coachMobile.nextHero.actionReschedule":
    "Verschieben",
  "trainerstunden.planning.coachMobile.nextHero.actionPlayers": "Spieler",
  "trainerstunden.planning.coachMobile.nextHero.actionPlayersAria":
    "Spieler für diesen Termin ergänzen oder entfernen",
  "trainerstunden.planning.coachMobile.nextHero.actionsAria": "Schnellaktionen",
  "trainerstunden.planning.coachMobile.playersSheetTitle": "Spieler",
  "trainerstunden.planning.coachMobile.lastPlayer.title": "Letzter Spieler",
  "trainerstunden.planning.coachMobile.lastPlayer.body":
    "Training absagen oder anderen Spieler wählen?",
  "trainerstunden.planning.coachMobile.lastPlayer.bodyLocked":
    "Ohne Spieler nicht möglich — bitte ergänzen.",
  "trainerstunden.planning.coachMobile.lastPlayer.addPlayer":
    "Spieler ergänzen",
  "trainerstunden.planning.coachMobile.lastPlayer.cancelSession":
    "Training absagen",
  "trainerstunden.planning.coachMobile.emptyPlayersDelete.title":
    "Termin ohne Spieler löschen?",
  "trainerstunden.planning.coachMobile.emptyPlayersDelete.body":
    "Ohne Spieler macht dieser Termin keinen Sinn. Nur diesen einen Termin löschen — die Serie bleibt unverändert.",
  "trainerstunden.planning.coachMobile.emptyPlayersDelete.cancel":
    "Spieler behalten",
  "trainerstunden.planning.coachMobile.emptyPlayersDelete.confirm":
    "Termin löschen",
  "trainerstunden.planning.coachMobile.laterTodayHeader":
    "Später heute · {count} weitere",
  "trainerstunden.planning.coachMobile.dayHeaderToday": "HEUTE · {date}",
  "trainerstunden.planning.coachMobile.dayHeaderYesterday": "Gestern · {date}",
  "trainerstunden.planning.coachMobile.dayHeaderTomorrow": "Morgen · {date}",
  "trainerstunden.planning.coachMobile.anchorNow": "Jetzt",
  "trainerstunden.planning.coachMobile.anchorEmpty":
    "Kein anstehendes Training in den nächsten Tagen.",
  "trainerstunden.planning.coachMobile.todayJump": "Heute",
  "trainerstunden.planning.coachMobile.scrollContextAria":
    "Aktueller Tag in der Liste: {day}",
  "trainerstunden.planning.coachMobile.searchBtnAria": "Suche",
  "trainerstunden.planning.coachMobile.searchSheetTitle": "Trainings suchen",
  "trainerstunden.planning.coachMobile.searchPlaceholder":
    "Spieler- oder Trainername",
  "trainerstunden.planning.coachMobile.searchPlaceholderShort":
    "Spieler suchen…",
  "trainerstunden.planning.coachMobile.filterChipsAria": "Aktive Filter",
  "trainerstunden.planning.coachMobile.filterReset": "Zurücksetzen",
  "trainerstunden.planning.coachMobile.filterChipSearch": "Suche: {query}",
  "trainerstunden.planning.coachMobile.filterChipTrainer": "Trainer: {name}",
  "trainerstunden.planning.coachMobile.filterChipTrainerCount":
    "Trainer: {count}",
  "trainerstunden.planning.coachMobile.filterChipRange": "Zeitraum: {period}",
  "trainerstunden.planning.coachMobile.chromeCollapseAria":
    "Filterleiste einklappen",
  "trainerstunden.planning.coachMobile.chromeExpandAria":
    "Filterleiste ausklappen",
  "trainerstunden.planning.coachMobile.trainerLensAll": "Alle Trainer",
  "trainerstunden.planning.coachMobile.trainerLensAria": "Trainer filtern",
  "trainerstunden.planning.coachMobile.dayJumpAria": "Zu Datum springen",
  "trainerstunden.planning.coachMobile.confirm.sectionTitle": "Zu bestätigen",
  "trainerstunden.planning.coachMobile.confirm.empty":
    "Keine Trainings zu bestätigen.",
  "trainerstunden.planning.coachMobile.makeup.sectionTitle":
    "Nachholtermine zu planen",
  "trainerstunden.planning.coachMobile.parentBooking.openCount": {
    one: "{count} offen",
    other: "{count} offen",
  },
  "trainerstunden.planning.coachMobile.makeup.openCount": {
    one: "{count} offen",
    other: "{count} offen",
  },
  "trainerstunden.planning.coachMobile.makeup.planMakeupAria":
    "Nachholtermin planen",
  "trainerstunden.planning.coachMobile.makeup.waiveMakeupAria":
    "Kein Nachholtermin",
  "trainerstunden.planning.coachMobile.makeup.expandSectionAria":
    "Nachholtermine anzeigen, {count} offen",
  "trainerstunden.planning.coachMobile.makeup.collapseSectionAria":
    "Nachholtermine ausblenden",
  "trainerstunden.planning.coachMobile.sectionTrainersAria": "Trainer",
  "trainerstunden.planning.coachMobile.confirm.openCount": {
    one: "{count} offen",
    other: "{count} offen",
  },
  "trainerstunden.planning.coachMobile.confirm.expandSectionAria":
    "Termine zur Bestätigung anzeigen, {count} offen",
  "trainerstunden.planning.coachMobile.confirm.collapseSectionAria":
    "Termine zur Bestätigung ausblenden",
  "trainerstunden.planning.coachMobile.confirm.enter": "Alle da?",
  "trainerstunden.planning.coachMobile.confirm.enterShort": "Alle da?",
  "trainerstunden.planning.coachMobile.confirm.enterAria":
    "Anwesenheit bestätigen: Spieler prüfen und bestätigen",
  "trainerstunden.planning.coachMobile.confirm.allPresentYes": "Ja, alle da",
  "trainerstunden.planning.coachMobile.confirm.adjustAbsent": "Nein, anpassen",
  "trainerstunden.planning.coachMobile.confirm.sheetTitle": "Anwesenheit",
  "trainerstunden.planning.coachMobile.confirm.promptQuestion":
    "Waren alle geplanten Spieler anwesend?",
  "trainerstunden.planning.coachMobile.confirm.absentHint":
    "Abwesende mit × entfernen (durchgestrichen). Danach bestätigen.",
  "trainerstunden.planning.coachMobile.confirm.markAbsentAria":
    "{name} als abwesend markieren",
  "trainerstunden.planning.coachMobile.confirm.markPresentAria":
    "{name} wieder als anwesend markieren",
  "trainerstunden.planning.coachMobile.confirm.addPlayerLink":
    "Spieler hinzufügen",
  "trainerstunden.planning.coachMobile.confirm.collapsePlayers": "Schließen",
  "trainerstunden.planning.coachMobile.confirm.presentLabel": "Anwesend",
  "trainerstunden.planning.coachMobile.confirm.absentLabel": "Abwesend",
  "trainerstunden.planning.coachMobile.confirm.confirmPartial": "Bestätigen",
  "trainerstunden.planning.coachMobile.confirm.confirmAllAbsentQuestion":
    "Wirklich niemand anwesend?",
  "trainerstunden.planning.coachMobile.confirm.confirmAllAbsentYes":
    "Ja, niemand da",
  "trainerstunden.planning.coachMobile.confirm.confirmAllAbsentNo":
    "Nein, zurück",
  "trainerstunden.planning.coachMobile.confirm.cancelAfterAllAbsentQuestion":
    "Training deshalb abgesagt?",
  "trainerstunden.planning.coachMobile.confirm.allAbsentDefaultNote":
    "Kein Spieler anwesend.",
  "trainerstunden.planning.coachMobile.confirm.confirmCancelTraining":
    "Training absagen",
  "trainerstunden.planning.coachMobile.confirm.backToAdjust": "Zurück",
  "trainerstunden.planning.coachMobile.confirm.confirmOne": "Bestätigen",
  "trainerstunden.planning.coachMobile.confirm.confirmOneAria":
    "Geplanten Teilnehmer als anwesend bestätigen",
  "trainerstunden.planning.coachMobile.confirm.cancelSessionAria":
    "Termin absagen",
  "trainerstunden.planning.coachMobile.confirm.rescheduleSessionAria":
    "Termin verschieben",
  "trainerstunden.planning.coachMobile.confirm.editSessionAria":
    "Termin bearbeiten",
  "trainerstunden.planning.coachMobile.confirm.changeTrainerAria":
    "Trainer ändern",
  "trainerstunden.planning.coachMobile.confirm.notHeldSectionLabel":
    "Training hat nicht stattgefunden?",
  "trainerstunden.planning.coachMobile.confirm.stackBtn":
    "Eindeutige bestätigen ({count})",
  "trainerstunden.planning.coachMobile.sessionRow.statusCancelled": "Abgesagt",
  "trainerstunden.planning.coachMobile.loadMore": "Mehr laden",
  "trainerstunden.planning.coachMobile.relativeMinutes": "in {count} Min.",
  "trainerstunden.planning.coachMobile.relativeHours": "in {count} Std.",
  "trainerstunden.planning.coachMobile.relativeHoursMinutes":
    "in {hours} Std. {minutes} Min.",
  "trainerstunden.planning.coachMobile.actionAdjustPlayers": "Spieler anpassen",
  "trainerstunden.planning.coachMobile.actionViewDetails": "Details ansehen",
  "trainerstunden.planning.coachMobile.sessionRow.moreAria":
    "Aktionen für {label}",
  "trainerstunden.coachBottomNav.aria": "TrainingsDesk Hauptnavigation",
  "trainerstunden.coachBottomNav.trainings": "Trainings",
  "trainerstunden.coachBottomNav.execution": "Tagesplan",
  "trainerstunden.coachBottomNav.participants": "Spieler",
  "trainerstunden.coachBottomNav.statistics": "Abrechnungen",
  "trainerstunden.coachBottomNav.billingOverview": "Rechnungsübersicht",
  "trainerstunden.coachBottomNav.billingDrafts": "Rechnungen",
  "trainerstunden.coachBottomNav.paymentReceipts": "Zahlungseingänge",
  "trainerstunden.coachBottomNav.invoiceHistory": "Rechnungen",
  "trainerstunden.coachBottomNav.more": "Mehr",
  "trainerstunden.coachBottomNav.moreMenu.aria": "Weitere Ziele",
  "trainerstunden.coachBottomNav.moreMenu.home": "TrainingsDesk-Start",
  "trainerstunden.coachBottomNav.moreMenu.sectionStart": "Start",
  "trainerstunden.coachBottomNav.moreMenu.sectionTraining": "Training",
  "trainerstunden.coachBottomNav.moreMenu.sectionParticipants": "Spieler",
  "trainerstunden.coachBottomNav.moreMenu.sectionBilling": "Abrechnung",
  "trainerstunden.coachBottomNav.moreMenu.sectionMore": "Weitere",
  "trainerstunden.coachBottomNav.moreMenu.paymentsTab": "Einnahmen",
  "trainerstunden.coachBottomNav.moreMenu.trainerSettlement":
    "Trainerabrechnung",
  "trainerstunden.coachBottomNav.moreMenu.masterdata": "Stammdaten",
  "trainerstunden.coachBottomNav.moreMenu.invoiceHistory": "Rechnungen",
  "trainerstunden.mobileBottomNav.aria": "TrainingsDesk Hauptnavigation",
  "trainerstunden.mobileBottomNav.uebersicht": "Übersicht",
  "trainerstunden.mobileBottomNav.trainingstermine": "Trainingstermine",
  "trainerstunden.mobileBottomNav.abrechnung": "Abrechnung",
  "trainerstunden.mobileBottomNav.finanzen": "Finanzen",
  "trainerstunden.mobileBottomNav.verwaltung": "Verwaltung",
  "trainerstunden.mobileBottomNav.moreSheet.aria": "Weitere Bereiche",
  "trainerstunden.mobileBottomNav.moreSheet.trainings": "Trainingstermine",
  "trainerstunden.mobileBottomNav.moreSheet.verwaltung": "Verwaltung",
  "trainerstunden.mobileBottomNav.moreSheet.profile": "Profil & Konto",
  "trainerstunden.mobileBottomNav.finanzen.segmentAria": "Finanzbereich wählen",
  "trainerstunden.mobileBottomNav.finanzen.abrechnen": "Abrechnen",
  "trainerstunden.mobileBottomNav.finanzen.abrechnung": "Abrechnung",
  "trainerstunden.mobileBottomNav.finanzen.offenePosten": "In Vorbereitung",
  "trainerstunden.mobileBottomNav.finanzen.rechnungen": "Rechnungen",
  "trainerstunden.mobileBottomNav.finanzen.zahlungen": "Einnahmen",
  "trainerstunden.mobileBottomNav.finanzen.ausgaben": "Ausgaben",
  "trainerstunden.mobileBottomNav.finanzen.bilanz": "Bilanz",
  "trainerstunden.embed.platformPeopleBadge": "Plattform",
  "trainerstunden.planning.planSessionTitle": "Training planen",
  "trainerstunden.planning.copySessionTitle": "Termin kopieren",
  "trainerstunden.planning.copySessionSubtitle":
    "1:1-Kopie als Einzeltermin. Passe Datum und Uhrzeit an – alle anderen Felder kannst du bei Bedarf ebenfalls ändern.",
  "trainerstunden.planning.editSessionTitle": "Termin bearbeiten",
  "trainerstunden.planning.sectionWhen": "Wann?",
  "trainerstunden.planning.sectionWhenWhere": "Wann & wo",
  "trainerstunden.planning.sectionLocation": "Ort",
  "trainerstunden.session.location": "Trainingsort",
  "trainerstunden.session.locationUnset": "Kein Ort gewählt",
  "trainerstunden.planning.rowLocationAria": "Trainingsort auswählen",
  "trainerstunden.planning.sheetPickLocationTitle": "Trainingsort wählen",
  "trainerstunden.planning.locationMasterdataHint":
    "Orte legst du unter Verwaltung → Orte an.",
  "trainerstunden.planning.locationAssignedClubsEmpty":
    "Keine Vereine zugeordnet. Bitte unter Stammdaten → Trainer deine Vereinszuordnung prüfen.",
  "trainerstunden.planning.locationCreateOption":
    "Neuen Trainingsort anlegen …",
  "trainerstunden.planning.locationCreateTitle": "Trainingsort anlegen",
  "trainerstunden.planning.locationCreateNameLabel": "Name des Ortes",
  "trainerstunden.planning.locationCreateNamePlaceholder":
    "z. B. Platz 3, Halle Nord",
  "trainerstunden.planning.locationCreateCourtFeeLabel":
    "Platzkosten (€, optional)",
  "trainerstunden.planning.locationCreateCourtFeePlaceholder": "z. B. 12",
  "trainerstunden.planning.locationCreateCourtFeeHint":
    "Wird am Ort gespeichert und beim Termin vorausgefüllt. Geht anteilig in die Eltern-Abrechnung ein.",
  "trainerstunden.planning.locationCreateCourtFeeInvalid":
    "Bitte einen gültigen Betrag für die Platzkosten eingeben (0 oder größer).",
  "trainerstunden.planning.sessionCourtFeeLabel": "Platzkosten (€)",
  "trainerstunden.planning.sessionCourtFeePlaceholder": "z. B. 20",
  "trainerstunden.planning.sessionCourtFeeHint":
    "Anteilig in der Eltern-Abrechnung. Leer = Vorgabe vom Trainingsort.",
  "trainerstunden.planning.unsavedChange.courtFee": "Platzkosten",
  "trainerstunden.planning.sessionGuestFeeLabel": "Gastspielergebühr (€)",
  "trainerstunden.planning.sessionGuestFeePlaceholder": "z. B. 8",
  "trainerstunden.planning.sessionGuestFeeHint":
    "Nur für Nicht-Mitglieder am Ort. Leer = Vorgabe vom Trainingsort.",
  "trainerstunden.planning.unsavedChange.guestFee": "Gastspielergebühr",
  "trainerstunden.planning.checkcourt.guestFeeNote":
    "Gastspielergebühr aktiv ({{amount}} €) — gilt für Nicht-Mitglieder am Ort.",
  "trainerstunden.planning.locationCreateGuestFeeLabel":
    "Gastspielergebühr (€, optional)",
  "trainerstunden.planning.locationCreateGuestFeePlaceholder": "z. B. 8",
  "trainerstunden.planning.locationCreateGuestFeeHint":
    "Wird am Ort gespeichert und beim Termin vorausgefüllt. Nur Nicht-Mitglieder zahlen diesen Betrag.",
  "trainerstunden.planning.locationCreateGuestFeeInvalid":
    "Bitte einen gültigen Betrag für die Gastspielergebühr eingeben (0 oder größer).",
  "trainerstunden.planning.locationCreateHint":
    "Dieser Ort ist nur in der Trainingsplanung deines Vereins sichtbar — nicht in der globalen Stammdaten-Verwaltung.",
  "trainerstunden.planning.locationCreateSubmit": "Ort speichern",
  "trainerstunden.planning.locationCreateNameRequired":
    "Bitte einen Namen für den Ort eingeben.",
  "trainerstunden.planning.locationCreateFailed":
    "Der Ort konnte nicht angelegt werden.",
  "trainerstunden.planning.locationCreateMatchTitle":
    "Bestehender Ort gefunden",
  "trainerstunden.planning.locationCreateMatchHint":
    "Dieser Name existiert bereits in den Stammdaten. Übernimm den vorhandenen Ort oder lege trotzdem einen neuen an.",
  "trainerstunden.planning.locationCreateMatchAdopt": "Übernehmen",
  "trainerstunden.planning.locationCreateMatchStandardBadge": "Standard",
  "trainerstunden.planning.locationCreateMatchDeskBadge": "Trainingsplanung",
  "trainerstunden.planning.locationCreateSubmitDespiteMatch":
    "Trotzdem als neuen Ort speichern",
  "trainerstunden.planning.locationCreateMatchConfirm":
    "Es gibt bereits passende Orte. Möchtest du wirklich einen weiteren anlegen?",
  "trainerstunden.planning.locationCreateMatchBack": "Zurück",
  "trainerstunden.planning.startTimeInPast":
    "Startzeit darf nicht in der Vergangenheit liegen. Bitte Datum oder Uhrzeit anpassen.",
  "trainerstunden.planning.sectionWho": "Wer?",
  "trainerstunden.planning.sectionParticipants": "Teilnehmer",
  "trainerstunden.planning.sectionTrainerAndPlayers": "Trainer & Spieler",
  "trainerstunden.planning.sectionPlayers": "Spieler",
  "trainerstunden.planning.sectionWhat": "Was?",
  "trainerstunden.planning.sectionRecurrence": "Terminfolge",
  "trainerstunden.planning.sectionRate": "Honorar & Abrechnung",
  "trainerstunden.planning.trialLessonLabel": "Probestunde",
  "trainerstunden.planning.trialLessonHint":
    "Eltern-Stundensatz kann 0 € sein. Trainer-Honorar bleibt separat im Honorar-Bereich.",
  "trainerstunden.planning.unsavedChange.trialLesson": "Probestunde",
  "trainerstunden.planning.createFields.title":
    "Formular „Neues Training“ einrichten",
  "trainerstunden.planning.createFields.subtitle":
    "Das ist die Vorlage fürs Formular, wenn du unter Planung „Neues Training“ oder „+ Termin“ öffnest — kein Termin selbst. Oben: vorausgefüllte Werte. Unten: welche Felder sichtbar sind („Einfach“ = schlanke Alltagansicht). Die Wirkung siehst du beim nächsten neuen Termin. Gilt für alle Nutzer dieses Vereins.",
  "trainerstunden.planning.createFields.defaults.sectionTitle":
    "Voreinstellungen für neue Termine",
  "trainerstunden.planning.createFields.defaults.sectionHint":
    "Diese Werte sind beim nächsten Anlegen schon ausgewählt. Datum und Uhrzeit kommen weiterhin aus dem Kalender.",
  "trainerstunden.planning.createFields.defaults.locationUnset":
    "Kein Standard-Ort",
  "trainerstunden.planning.createFields.defaults.trainerUnset":
    "Erster verfügbarer Trainer",
  "trainerstunden.planning.createFields.defaults.trainerLabel":
    "Standard-Trainer",
  "trainerstunden.planning.createFields.defaults.targetGroupEmpty":
    "Keine aktive Zielgruppe in den Auswahllisten — bitte unter Stammdaten → Auswahllisten pflegen.",
  "trainerstunden.planning.createFields.visibilitySectionTitle":
    "Felder & einfache Ansicht",
  "trainerstunden.planning.createFields.visibilitySectionHint":
    "„Anzeigen“: Feld erscheint überhaupt im Formular. „Einfach“: auch in der schlanken Alltagansicht. Im Expertenmodus siehst du alle angezeigten Felder.",
  "trainerstunden.planning.createFields.columnVisible": "Anzeigen",
  "trainerstunden.planning.createFields.columnStandard": "Einfach",
  "trainerstunden.planning.createFields.columnField": "Feld",
  "trainerstunden.planning.createFields.visibleHint":
    "Feld im Formular „Neues Training“ verfügbar machen",
  "trainerstunden.planning.createFields.standardHint":
    "Auch in der schlanken Alltagansicht von „Neues Training“ sichtbar",
  "trainerstunden.planning.createFields.standardBadge": "Einfach",
  "trainerstunden.planning.createFields.requiredBadge": "Pflichtfeld",
  "trainerstunden.planning.createFields.save": "Speichern",
  "trainerstunden.planning.createFields.saving": "Speichern…",
  "trainerstunden.planning.createFields.saved": "Gespeichert",
  "trainerstunden.planning.createFields.saveFailed":
    "Speichern fehlgeschlagen.",
  "trainerstunden.planning.createFields.saveMissingTenant":
    "Mandant konnte nicht ermittelt werden.",
  "trainerstunden.planning.createFields.sections.when": "Wann?",
  "trainerstunden.planning.createFields.sections.location": "Ort",
  "trainerstunden.planning.createFields.sections.who": "Wer?",
  "trainerstunden.planning.createFields.sections.meta": "Formular",
  "trainerstunden.planning.createFields.sections.recurrence": "Terminfolge",
  "trainerstunden.planning.createFields.sections.expert": "Expertenfelder",
  "trainerstunden.planning.createFields.sections.rate": "Honorar & Abrechnung",
  "trainerstunden.planning.createFields.sessionDate": "Datum",
  "trainerstunden.planning.createFields.startTime": "Startzeit",
  "trainerstunden.planning.createFields.duration": "Dauer",
  "trainerstunden.planning.createFields.location": "Trainingsort",
  "trainerstunden.planning.createFields.trainer": "Trainer",
  "trainerstunden.planning.createFields.targetGroup": "Zielgruppe",
  "trainerstunden.planning.createFields.sessionFocus":
    "Schwerpunkt (Freies Training)",
  "trainerstunden.planning.createFields.sessionFocusHint":
    "Nur bei Trainern mit freiem Training.",
  "trainerstunden.planning.createFields.participants": "Teilnehmer",
  "trainerstunden.planning.createFields.assistant":
    "Co-Trainer & Assistenz-Honorar",
  "trainerstunden.planning.createFields.formMode": "Standard / Individuell",
  "trainerstunden.planning.createFields.formModeHint":
    "Umschalter zwischen vereinfachtem und erweitertem Formular.",
  "trainerstunden.planning.createFields.formModeStandard": "Standard",
  "trainerstunden.planning.createFields.formModeIndividual": "Individuell",
  "trainerstunden.planning.createFields.formModeStandardHint":
    "Standard blendet nur die als „Einfach“ markierten Felder ein.",
  "trainerstunden.planning.createFields.formModeIndividualHint":
    "Individuell: Felder unten ein-/ausblenden. Die Auswahl wird als dein Standard gespeichert.",
  "trainerstunden.planning.createFields.formModeIndividualFields":
    "Felder im individuellen Modus",
  "trainerstunden.planning.createFields.recurrence": "Einzeltermin / Serie",
  "trainerstunden.planning.createFields.trainingType":
    "Trainingsart (abgeleitet)",
  "trainerstunden.planning.createFields.courtFormat": "Platzformat",
  "trainerstunden.planning.createFields.notes": "Notizen",
  "trainerstunden.planning.createFields.rate": "Honorar pro Stunde",
  "trainerstunden.planning.tennify.checking":
    "Tennify: Verfügbarkeit wird geprüft …",
  "trainerstunden.planning.tennify.ready":
    "Tennify ist aktiv. Für den Verfügbarkeitscheck bitte Ort auswählen.",
  "trainerstunden.planning.tennify.free":
    "Tennify: Platz ist im gewählten Zeitfenster frei.",
  "trainerstunden.planning.tennify.freeOnCourts":
    "Tennify: Frei auf {{courts}}.",
  "trainerstunden.planning.tennify.freeOnCourtsWithBusy":
    "Tennify: Frei auf {{courts}}. Belegt:",
  "trainerstunden.planning.tennify.ownReservedOnCourts":
    "Tennify: Für dich reserviert auf {{courts}}.",
  "trainerstunden.planning.tennify.ownReservedWithBusy":
    "Tennify: Für dich reserviert auf {{ownCourts}}. Belegt:",
  "trainerstunden.planning.tennify.ownAndFreeOnCourts":
    "Tennify: Für dich reserviert auf {{ownCourts}}. Frei auf {{freeCourts}}.",
  "trainerstunden.planning.tennify.freeOnCourtsWithOwnAndBusy":
    "Tennify: Für dich reserviert auf {{ownCourts}}. Frei auf {{freeCourts}}. Belegt:",
  "trainerstunden.planning.tennify.courtStatusLabel": "Tennify: Platzbelegung",
  "trainerstunden.planning.tennify.courtStatusAria": "Platzbelegung in Tennify",
  "trainerstunden.planning.tennify.courtStatusOwn": "Für dich reserviert",
  "trainerstunden.planning.tennify.courtStatusFree": "Frei",
  "trainerstunden.planning.tennify.courtStatusReadOnlyNote":
    "Nur Anzeige — Buchungen erfolgen in Tennify.",
  "trainerstunden.planning.tennify.otherBusyLabel": "Weitere Belegungen:",
  "trainerstunden.planning.tennify.unlistedCourtsHint":
    "Weitere Tennify-Plätze fehlen vermutlich in der API (noch ohne Buchung). In Einstellungen → Tennify Platz-Check unter „Tennify-Plätze“ eintragen.",
  "trainerstunden.planning.tennify.ownBooking":
    "Tennify: Platz ist bereits für dich gebucht{{courtSuffix}}.",
  "trainerstunden.planning.tennify.ownBookingCourtSuffix": " ({{courtName}})",
  "trainerstunden.planning.tennify.bookingLine":
    "{{courtName}} · {{timeRange}} Uhr · {{participants}}",
  "trainerstunden.planning.tennify.bookingCourtUnknown": "Platz unbekannt",
  "trainerstunden.planning.tennify.bookingParticipantsUnknown":
    "Keine Spielerangabe in Tennify",
  "trainerstunden.planning.tennify.openBooking": "Jetzt in Tennify buchen",
  "trainerstunden.planning.tennify.openBookingManage": "In Tennify verwalten",
  "trainerstunden.planning.tennify.occupied":
    "Tennify: Platz ist belegt ({{count}} überlappende Buchung(en)).",
  "trainerstunden.planning.tennify.nextFreeSlot":
    "Nächster freier Slot{{courtSuffix}}: ab {{time}} Uhr.",
  "trainerstunden.planning.tennify.nextFreeSlotCourtSuffix": " ({{courtName}})",
  "trainerstunden.planning.tennify.nextFreeSlotNone":
    "Im nächsten Zeitraum kein freier Slot in Tennify gefunden.",
  "trainerstunden.planning.tennify.notConfigured":
    "Tennify ist aktiv, aber kein API-Key hinterlegt (Einstellungen → Tennify Platz-Check).",
  "trainerstunden.planning.tennify.disabled":
    "Tennify Platz-Check ist deaktiviert (TrainingsDesk → Einstellungen → Tennify Platz-Check).",
  "trainerstunden.planning.tennify.loadFailed":
    "Tennify Platz-Check konnte nicht geladen werden. Bitte Einstellungen prüfen oder Seite neu laden.",
  "trainerstunden.planning.tennify.tenantForbidden":
    "Tennify-Konfiguration für diesen Verein ist nicht abrufbar (fehlende Berechtigung).",
  "trainerstunden.planning.tennify.authFailed":
    "Tennify hat den API-Key abgelehnt. Bitte Schlüssel in den Einstellungen prüfen.",
  "trainerstunden.planning.tennify.rateLimited":
    "Tennify-Anfragen sind kurzzeitig limitiert. Bitte in etwa einer Minute erneut prüfen.",
  "trainerstunden.planning.tennify.error":
    "Tennify-Verfügbarkeit aktuell nicht abrufbar.",
  "trainerstunden.planning.checkcourt.checking":
    "CheckCourt: Verfügbarkeit wird geprüft …",
  "trainerstunden.planning.checkcourt.ready":
    "CheckCourt ist aktiv. Für den Verfügbarkeitscheck bitte Ort auswählen.",
  "trainerstunden.planning.checkcourt.free":
    "CheckCourt: Platz ist im gewählten Zeitfenster frei.",
  "trainerstunden.planning.checkcourt.freeOnCourts":
    "CheckCourt: Frei auf {{courts}}.",
  "trainerstunden.planning.checkcourt.freeOnCourtsWithBusy":
    "CheckCourt: Frei auf {{courts}}. Belegt:",
  "trainerstunden.planning.checkcourt.ownReservedOnCourts":
    "CheckCourt: Für dich reserviert auf {{courts}}.",
  "trainerstunden.planning.checkcourt.ownReservedWithBusy":
    "CheckCourt: Für dich reserviert auf {{ownCourts}}. Belegt:",
  "trainerstunden.planning.checkcourt.ownAndFreeOnCourts":
    "CheckCourt: Für dich reserviert auf {{ownCourts}}. Frei auf {{freeCourts}}.",
  "trainerstunden.planning.checkcourt.freeOnCourtsWithOwnAndBusy":
    "CheckCourt: Für dich reserviert auf {{ownCourts}}. Frei auf {{freeCourts}}. Belegt:",
  "trainerstunden.planning.checkcourt.courtStatusLabel":
    "CheckCourt: Platzbelegung",
  "trainerstunden.planning.checkcourt.courtStatusAria":
    "Platzbelegung in CheckCourt",
  "trainerstunden.planning.checkcourt.courtStatusOwn": "Für dich reserviert",
  "trainerstunden.planning.checkcourt.courtStatusFree": "Frei",
  "trainerstunden.planning.checkcourt.courtStatusSelected": "Wird gebucht",
  "trainerstunden.planning.checkcourt.courtStatusReadOnlyNote":
    "Nur Anzeige — Buchungen erfolgen in CheckCourt.",
  "trainerstunden.planning.checkcourt.courtStatusAutoBookNote":
    "Gewählter Platz wird beim Speichern in CheckCourt gebucht.",
  "trainerstunden.planning.checkcourt.openBookingManage":
    "In CheckCourt verwalten",
  "trainerstunden.planning.checkcourt.bookTrainerNotFound":
    "Training gespeichert, aber CheckCourt nicht gebucht: Trainer wurde in CheckCourt nicht gefunden (E-Mail/Name).",
  "trainerstunden.planning.checkcourt.bookFailed":
    "Training gespeichert, aber CheckCourt-Buchung fehlgeschlagen ({{reason}}).",
  "trainerstunden.planning.checkcourt.otherBusyLabel": "Weitere Belegungen:",
  "trainerstunden.planning.checkcourt.unlistedCourtsHint":
    "Weitere CheckCourt-Plätze fehlen vermutlich in der API. In Einstellungen → CheckCourt unter „Plätze“ eintragen.",
  "trainerstunden.planning.checkcourt.ownBooking":
    "CheckCourt: Platz ist bereits für dich gebucht{{courtSuffix}}.",
  "trainerstunden.planning.checkcourt.ownBookingCourtSuffix":
    " ({{courtName}})",
  "trainerstunden.planning.checkcourt.bookingLine":
    "{{courtName}} · {{timeRange}} Uhr · {{participants}}",
  "trainerstunden.planning.checkcourt.bookingCourtUnknown": "Platz unbekannt",
  "trainerstunden.planning.checkcourt.bookingParticipantsUnknown":
    "Keine Spielerangabe in CheckCourt",
  "trainerstunden.planning.checkcourt.openBooking":
    "Jetzt in CheckCourt buchen",
  "trainerstunden.planning.checkcourt.occupied":
    "CheckCourt: Platz ist belegt ({{count}} überlappende Buchung(en)).",
  "trainerstunden.planning.checkcourt.nextFreeSlot":
    "Nächster freier Slot{{courtSuffix}}: ab {{time}} Uhr.",
  "trainerstunden.planning.checkcourt.nextFreeSlotCourtSuffix":
    " ({{courtName}})",
  "trainerstunden.planning.checkcourt.nextFreeSlotNone":
    "Im nächsten Zeitraum kein freier Slot in CheckCourt gefunden.",
  "trainerstunden.planning.checkcourt.notConfigured":
    "CheckCourt ist aktiv, aber kein API-Key hinterlegt (Einstellungen → CheckCourt).",
  "trainerstunden.planning.checkcourt.disabled":
    "CheckCourt Platz-Check ist deaktiviert.",
  "trainerstunden.planning.checkcourt.loadFailed":
    "CheckCourt Platz-Check konnte nicht geladen werden. Bitte Einstellungen prüfen oder Seite neu laden.",
  "trainerstunden.planning.checkcourt.loadFailedWithReason":
    "CheckCourt Platz-Check fehlgeschlagen ({{reason}}). Einstellungen/Scopes prüfen oder Seite neu laden.",
  "trainerstunden.planning.checkcourt.requestFailed":
    "CheckCourt antwortet nicht korrekt. API-Key-Scopes (bookings:read) und CheckCourt-Status prüfen.",
  "trainerstunden.planning.checkcourt.invalidWindow":
    "CheckCourt: Datum/Uhrzeit ungültig — bitte Wann & wo prüfen.",
  "trainerstunden.planning.checkcourt.sessionAuthFailed":
    "Sitzung abgelaufen — bitte neu anmelden und CheckCourt erneut prüfen.",
  "trainerstunden.planning.checkcourt.settingsLoadFailed":
    "CheckCourt-Einstellungen konnten serverseitig nicht geladen werden. API neu starten oder später erneut versuchen.",
  "trainerstunden.planning.checkcourt.tenantForbidden":
    "CheckCourt-Konfiguration für diesen Verein ist nicht abrufbar (fehlende Berechtigung).",
  "trainerstunden.planning.checkcourt.authFailed":
    "CheckCourt hat den API-Key abgelehnt. Bitte Schlüssel und Scopes in den Einstellungen prüfen.",
  "trainerstunden.planning.checkcourt.rateLimited":
    "CheckCourt-Anfragen sind kurzzeitig limitiert. Bitte in etwa einer Minute erneut prüfen.",
  "trainerstunden.planning.checkcourt.error":
    "CheckCourt-Verfügbarkeit aktuell nicht abrufbar.",
  "trainerstunden.planning.createFields.rateHint":
    "Ausgeblendet wird der berechnete Standardwert verwendet.",
  "trainerstunden.planning.createFields.coordinatorFee":
    "Koordinationspauschale",
  "trainerstunden.planning.sectionMeta": "Zeit & Trainer",
  "trainerstunden.planning.rowDateUnset": "Datum wählen",
  "trainerstunden.planning.rowDateAria": "Datum auswählen",
  "trainerstunden.planning.rowTimeAria": "Startzeit auswählen",
  "trainerstunden.planning.rowTrainerAria": "Trainer auswählen",
  "trainerstunden.planning.rowTargetAria": "Zielgruppe auswählen",
  "trainerstunden.planning.rowCourtAria": "Platzformat auswählen",
  "trainerstunden.planning.rowTrainingTypeAria":
    "Teilnehmer für Trainingsart öffnen",
  "trainerstunden.planning.rowRateAria": "Stundensatz bearbeiten",
  "trainerstunden.planning.rowHonorarAria": "Honorar bearbeiten",
  "trainerstunden.planning.rowScopeAria": "Bearbeitungsumfang wählen",
  "trainerstunden.planning.durationDisplay": "{minutes} Min",
  "trainerstunden.planning.durationStepperAria": "Dauer in Minuten anpassen",
  "trainerstunden.planning.durationPresetsRow": "Schnellwahl Dauer",
  "trainerstunden.planning.durationPresetsRowHint": "30 / 45 / 60 / 90 Min",
  "trainerstunden.planning.durationPresetsRowAria": "Dauer-Schnellwahl öffnen",
  "trainerstunden.planning.durationPreset30": "30 Minuten",
  "trainerstunden.planning.durationPreset45": "45 Minuten",
  "trainerstunden.planning.durationPreset60": "60 Minuten",
  "trainerstunden.planning.durationPreset90": "90 Minuten",
  "trainerstunden.planning.participantsRow": "Spieler",
  "trainerstunden.planning.participantsCountShort": "{count} Spieler",
  "trainerstunden.planning.participantsRowAria": "Spieler bearbeiten",
  "trainerstunden.planning.assistantRowLabel": "Trainerassistent",
  "trainerstunden.planning.assistantRowUnset": "Kein Assistent",
  "trainerstunden.planning.assistantAmountRowLabel": "Assistenten-Anteil",
  "trainerstunden.planning.assistantAmountUnset": "Nicht festgelegt",
  "trainerstunden.planning.rowAssistantAria": "Trainerassistent auswählen",
  "trainerstunden.planning.rowAssistantAmountAria":
    "Assistenten-Anteil bearbeiten",
  "trainerstunden.planning.sheetPickAssistantTitle": "Trainerassistent wählen",
  "trainerstunden.planning.sheetAssistantAmountTitle": "Assistenten-Anteil",
  "trainerstunden.planning.assistantSplitHint":
    "Honorar gesamt {gross} € · Assistent {assistant} € · Trainer {net} €",
  "trainerstunden.planning.mainTrainerAssistantOnlyError":
    "Dieser Trainer ist nur als Assistenztrainer hinterlegt und kann nicht als Haupttrainer geplant werden.",
  "trainerstunden.planning.unsavedChange.assistantTrainer": "Trainerassistent",
  "trainerstunden.planning.unsavedChange.assistantHonorar":
    "Assistenten-Anteil",
  "trainerstunden.planning.rowNotes": "Notiz",
  "trainerstunden.planning.rowNotesAria": "Notiz bearbeiten",
  "trainerstunden.planning.rowNotesPlaceholder": "Optional",
  "trainerstunden.planning.detailsRow": "Details",
  "trainerstunden.planning.detailsRowEmpty": "Optional",
  "trainerstunden.planning.detailsRowAria": "Spielfeld und Notiz bearbeiten",
  "trainerstunden.planning.sheetDetailsTitle": "Details",
  "trainerstunden.planning.ratePerHourShort": "Stundensatz",
  "trainerstunden.planning.rateRowUnset": "Eingeben",
  "trainerstunden.planning.rateRowValue": "{value} € / h",
  "trainerstunden.planning.sheetDone": "Fertig",
  "trainerstunden.planning.sheetPickDateTitle": "Datum wählen",
  "trainerstunden.planning.sheetPickTimeTitle": "Startzeit wählen",
  "trainerstunden.planning.sheetPickDurationTitle": "Dauer wählen",
  "trainerstunden.planning.sheetPickTrainerTitle": "Trainer wählen",
  "trainerstunden.planning.sheetPickTargetTitle": "Zielgruppe wählen",
  "trainerstunden.planning.sheetPickCourtTitle": "Platzformat",
  "trainerstunden.planning.sheetParticipantsTitle": "Teilnehmer",
  "trainerstunden.planning.sheetNotesTitle": "Notiz (optional)",
  "trainerstunden.planning.sheetPickRateTitle":
    "Stundensatz & Trainer-Vergütung",
  "trainerstunden.planning.sheetRateAndHonorarIntro":
    "Teilnehmer-Stundensatz (brutto) sowie Art und Satz der Trainervergütung für die Abrechnung. Das Honorar dieser Session wird automatisch aus Dauer und Vergütungsart berechnet.",
  "trainerstunden.planning.trainerHonorarComputedReadonlyLabel":
    "Trainerhonorar dieser Session (berechnet, nicht editierbar)",
  "trainerstunden.planning.dateMissing": "Bitte ein gültiges Datum eingeben.",
  "trainerstunden.planning.timeMissing": "Bitte eine Startzeit eingeben.",
  "trainerstunden.planning.participantsTooFew":
    "Bitte mindestens {min} Teilnehmer auswählen.",
  "trainerstunden.planning.plannedPlayerLimitReached":
    "Maximale Spieleranzahl erreicht. Bitte Trainingsart anpassen oder einen Spieler entfernen.",
  "trainerstunden.planning.sheetHonorarTitle": "Honorar & Abrechnung",
  "trainerstunden.planning.seriesIntervalAria": "Serien-Rhythmus wählen",
  "trainerstunden.planning.seriesEndAria": "Serien-Ende wählen",
  "trainerstunden.planning.targetGroupReadonly": "Zielgruppe",
  "trainerstunden.planningShare.title": "Planung teilen",
  "trainerstunden.planningShare.titleSession": "Termin teilen",
  "trainerstunden.planningShare.titleOwnerPool": "Meine gesamte Planung teilen",
  "trainerstunden.planningShare.titleSeries": "Serie teilen",
  "trainerstunden.planning.footerSecondaryAria": "Weitere Aktionen",
  "trainerstunden.planning.footerPrimaryAria": "Speichern und Abbrechen",
  "trainerstunden.planning.footerShareMenu": "Weitergeben",
  "trainerstunden.planning.footerShareMenuAria": "Termin weitergeben",
  "trainerstunden.planning.editorTab.content": "Termin",
  "trainerstunden.planning.editorTab.players": "Spieler",
  "trainerstunden.planning.editorTab.billing": "Honorar",
  "trainerstunden.planning.editorTabsAria": "Bereiche bearbeiten",
  "trainerstunden.planning.formErrorAria": "Hinweis zur Eingabe",
  "trainerstunden.planningShare.cta": "Mit Trainer teilen",
  "trainerstunden.billing.abrechnung.pipelineAria": "Abrechnungs-Pipeline",
  "trainerstunden.billing.abrechnung.pipeline.cta": "Nächster Schritt",
  "trainerstunden.billing.abrechnung.pipeline.step.preparation": "Vorbereiten",
  "trainerstunden.billing.abrechnung.pipeline.step.ready": "Bereit",
  "trainerstunden.billing.abrechnung.pipeline.step.drafts": "Entwürfe",
  "trainerstunden.billing.abrechnung.pipeline.step.sent": "Versendet",
  "trainerstunden.billing.abrechnung.pipeline.step.unpaid": "Offen",
  "trainerstunden.billing.abrechnung.pipeline.step.paid": "Bezahlt",
  "trainerstunden.planningShare.ctaOwnerPool": "Gesamte Planung teilen",
  "trainerstunden.planningShare.scopeSessionHint":
    "Dieser Termin und die zugehörigen Spielerdaten werden freigegeben.",
  "trainerstunden.planningShare.scopeOwnerPoolHint":
    "Alle deine TrainingsDesk-Termine in diesem Verein werden freigegeben.",
  "trainerstunden.planningShare.scopeSeriesHint":
    "Die Serie und verknüpfte TrainingsDesk-Termine werden freigegeben.",
  "trainerstunden.planningShare.granteeLabel": "Trainer im Verein",
  "trainerstunden.planningShare.granteePlaceholder": "Trainer suchen…",
  "trainerstunden.planningShare.granteeEmpty": "Kein Trainer gefunden",
  "trainerstunden.planningShare.granteeClear": "Auswahl löschen",
  "trainerstunden.planningShare.accessWrite": "Schreiben erlauben",
  "trainerstunden.planningShare.accessReadHint":
    "Standard: nur Lesen (Anwesenheit und Verschieben bleiben gesperrt).",
  "trainerstunden.planningShare.accessWriteHint":
    "Schreiben: Anwesenheit, Verschieben und Absagen im freigegebenen Umfang.",
  "trainerstunden.planningShare.consentDataShare":
    "Ich bestätige, dass die Planungs- und Spielerdaten mit diesem Trainer geteilt werden dürfen.",
  "trainerstunden.planningShare.consentPlayersInformed":
    "Ich bestätige, dass die Abstimmung mit den Datenownern (Spielern) erfolgt ist.",
  "trainerstunden.planningShare.submit": "Freigabe speichern",
  "trainerstunden.planningShare.existingTitle": "Aktive Freigaben",
  "trainerstunden.planningShare.revoke": "Widerrufen",
  "trainerstunden.planningShare.revokeConfirmTitle": "Freigabe widerrufen?",
  "trainerstunden.planningShare.revokeConfirmBody":
    "Der Trainer verliert danach den Zugriff auf diesen Umfang.",
  "trainerstunden.planningShare.levelRead": "Lesen",
  "trainerstunden.planningShare.levelWrite": "Schreiben",
  "trainerstunden.planningShare.unknownTrainer": "Trainer",
  "trainerstunden.planningShare.badgeFrom": "Geteilt von {name}",
  "trainerstunden.planningShare.badgeReadOnly": "Nur Lesen",
  "trainerstunden.planningShare.errors.missingSession": "Termin fehlt.",
  "trainerstunden.planningShare.errors.missingSeries": "Serie fehlt.",
  "trainerstunden.planningShare.errors.invalidScope": "Ungültiger Umfang.",
  "trainerstunden.planningShare.errors.consentDataShare":
    "Bitte die Freigabe der Daten bestätigen.",
  "trainerstunden.planningShare.errors.consentPlayersInformed":
    "Bitte die Abstimmung mit den Spielern bestätigen.",
  "trainerstunden.planningShare.errors.selfShare":
    "Du kannst die Planung nicht mit dir selbst teilen.",
  "trainerstunden.planningShare.errors.missingGrantee":
    "Bitte einen Trainer wählen.",
  "trainerstunden.planningShare.errors.missingGrantor":
    "Deine Trainer-Identität wurde nicht gefunden.",
  "trainerstunden.planningShare.errors.missingTenant": "Verein fehlt.",
  "trainerstunden.planningShare.errors.granteeNotFound":
    "Trainer nicht im gleichen Verein gefunden.",
  "trainerstunden.planningShare.errors.notAuthorized": "Keine Berechtigung.",
  "trainerstunden.planningShare.errors.duplicate":
    "Für diesen Trainer existiert bereits eine aktive Freigabe.",
  "trainerstunden.planningShare.errors.revokeFailed":
    "Widerruf fehlgeschlagen.",
  "trainerstunden.planningShare.errors.createFailed":
    "Freigabe konnte nicht gespeichert werden.",
  "trainerstunden.planningShare.errors.failed":
    "Teilen fehlgeschlagen. Bitte erneut versuchen.",
  "trainerstunden.planning.editStickyHint":
    "Speichern übernimmt die Änderungen für diesen Termin.",
  "trainerstunden.planning.honorarRowPerHour": "{rate} € / h",
  "trainerstunden.planning.honorarRowFlat": "{amount} € pauschal",
  "trainerstunden.planning.honorarDeskRateTimesDuration": "Stundensatz × Dauer",
  "trainerstunden.planning.honorarDeskRateTimesDurationValue":
    "{rate} € × {minutes} Min",
  "trainerstunden.planning.honorarDeskManualAdjustment": "Manuelle Anpassung",
  "trainerstunden.planning.honorarDeskTotalLabel": "Dein Honorar",
  "trainerstunden.planning.honorarDeskRatePending": "Trainer wählen",
  "trainerstunden.planning.honorarDeskRateUnset": "Kein Honorar-Stundensatz",
  "trainerstunden.planning.splitBaseLegend": "Schüler-Anteil",
  "trainerstunden.planning.splitBaseHintPlanned":
    "Jeder geplante Schüler zahlt denselben Stundenanteil – auch bei Absage oder No-Show.",
  "trainerstunden.planning.splitBaseHintPresent":
    "Nur anwesende Schüler teilen die Stunde. Absagen und No-Shows zahlen nicht.",
  "trainerstunden.planning.deskSessionMetaLine":
    "{date} · {time} · {duration} · {location}",
  "trainerstunden.planning.ratePerHour": "Stundensatz (€ pro Stunde, brutto)",
  "trainerstunden.planning.trainingSingleLabel": "Einzeltraining",
  "trainerstunden.planning.trainingGroupLabel": "Gruppentraining",
  "trainerstunden.planning.trainingTypeAutoHint":
    "Wird automatisch aus der Spieleranzahl abgeleitet.",
  "trainerstunden.planning.formModeSimple": "Einfach",
  "trainerstunden.planning.formModeExpert": "Experte",
  "trainerstunden.planning.formModeCoordinatorLocked":
    "Als Trainingskoordinator planst du immer in der Expertenansicht — inklusive Trainerwahl.",
  "trainerstunden.planning.trainerRequiredExpertHint":
    "Bitte in der Expertenansicht einen Trainer wählen, bevor du speicherst.",
  "trainerstunden.planning.formModeAria": "Ansicht: Einfach oder Experte",
  "trainerstunden.planning.expertSectionTitle": "Feinsteuerung",
  "trainerstunden.planning.durationRowLabel": "Dauer",
  "trainerstunden.planning.durationUnifiedRowAria":
    "Dauer auswählen oder fein anpassen",
  "trainerstunden.planning.durationFineTune": "Feinanpassung (±5 Min)",
  "trainerstunden.planning.trainingTypeExpertLabel": "Trainingsart",
  "trainerstunden.planning.trainingTypeDerivedHint":
    "Automatisch aus der Spieleranzahl abgeleitet.",
  "trainerstunden.planning.courtNotRelevant": "Nicht relevant",
  "trainerstunden.planning.createSheetIntroSimple":
    "Datum, Uhrzeit, Dauer, Teilnehmer und Terminfolge (einmalig oder Serie). Trainer, Zielgruppe, Satz und Honorar bleiben bis zum Expertenmodus aus den bestehenden Vorgaben erhalten.",
  "trainerstunden.planning.editStickyHintSimple":
    "Speichern übernimmt Datum, Zeit, Dauer und Teilnehmer. Weitere Felder bleiben unverändert, bis du sie im Expertenmodus anpasst.",
  "trainerstunden.planning.recurrenceLegend": "Terminfolge",
  "trainerstunden.planning.recurrenceOnceOption": "Einmalig",
  "trainerstunden.planning.recurrenceSeriesOption": "Serie (wiederkehrend)",
  "trainerstunden.planning.seriesIntervalLabel": "Rhythmus",
  "trainerstunden.planning.seriesOccurrencesTitle": "Termine der Serie",
  "trainerstunden.planning.seriesOccurrencesCount": "{count} Termine",
  "trainerstunden.planning.seriesOccurrencesPastTitle":
    "Vergangene Termine ({count})",
  "trainerstunden.planning.seriesOccurrencesCurrent": "Aktuell",
  "trainerstunden.planning.seriesOccurrencesSelectAria": "Termin {date} öffnen",
  "trainerstunden.planning.seriesOccurrencesHint":
    "Schalter pro zukünftigem Termin: Training findet statt oder entfällt. Ferien-Termine werden bei „Nur außerhalb der Ferien“ automatisch als entfallen markiert – manuell kannst du Ausnahmen setzen. Änderungen werden mit Speichern übernommen.",
  "trainerstunden.planning.seriesOccurrenceHeld": "Findet statt",
  "trainerstunden.planning.seriesOccurrenceNotHeld": "Entfällt",
  "trainerstunden.planning.seriesOccurrenceToggleAria":
    "Termin {date}: Training findet statt",
  "trainerstunden.planning.seriesOccurrenceSaveFailed":
    "Terminstatus der Serie konnte nicht gespeichert werden.",
  "trainerstunden.planning.seriesSessionCountHolidayAdjusted":
    "{count} Termine ({rhythm}, {from} – {to}) – {excluded} in den Schulferien als entfallen markiert",
  "trainerstunden.planning.seriesSessionCount":
    "{count} Termine ({rhythm}, {from} – {to})",
  "trainerstunden.planning.seriesSessionCountExcludeClear":
    "{count} Termine ({rhythm}, {from} – {to}) – keiner liegt in den Schulferien ({state})",
  "trainerstunden.planning.seriesHolidayScheduleLegend":
    "Training während der Schulferien",
  "trainerstunden.planning.seriesHolidayInclude": "Auch in den Ferien",
  "trainerstunden.planning.seriesHolidayExclude": "Nur außerhalb der Ferien",
  "trainerstunden.planning.seriesHolidayHint":
    "Schulferien für {state} (Einstellungen).",
  "trainerstunden.planning.seriesHolidayHintMissingState":
    "Kein Bundesland in den Einstellungen – Ferien können nicht berücksichtigt werden.",
  "trainerstunden.planning.seriesHolidayLoading":
    "Schulferien für {state} werden geladen …",
  "trainerstunden.planning.seriesNoSessionsAfterFilter":
    "Im gewählten Zeitraum fallen alle Termine in die Schulferien.",
  "trainerstunden.planning.seriesBillingSuggestedTotal":
    "Vorschlag: {total} € ({count} Termine × {duration} Min × {rate} €/h)",
  "trainerstunden.planning.seriesBillingSuggestedTotalUpdated":
    "Neuer Vorschlag: {total} € ({count} Termine × {duration} Min × {rate} €/h)",
  "trainerstunden.planning.seriesBillingApplySuggestion":
    "Vorschlag übernehmen",
  "trainerstunden.planning.seriesIntervalHint":
    "Wähle Intervall und Wochentage. Gleiche Startuhrzeit bei jedem Termin, von „Serie ab“ bis einschließlich „Serie bis“. Monatlich: gleicher Kalendertag.",
  "trainerstunden.planning.seriesRecurrenceUnset": "Bitte Rhythmus auswählen",
  "trainerstunden.planning.seriesRecurrenceIntro":
    "Lege Intervall und Tage fest — Vorschläge helfen, du kannst jede Kombination wählen.",
  "trainerstunden.planning.seriesRecurrenceUnitLabel": "Zeiteinheit",
  "trainerstunden.planning.seriesRecurrenceUnitWeeks": "Wochen",
  "trainerstunden.planning.seriesRecurrenceUnitMonths": "Monate",
  "trainerstunden.planning.seriesRecurrenceIntervalWeeks": "Alle … Wochen",
  "trainerstunden.planning.seriesRecurrenceIntervalMonths": "Alle … Monate",
  "trainerstunden.planning.seriesRecurrenceIntervalDecrease":
    "Intervall verringern",
  "trainerstunden.planning.seriesRecurrenceIntervalIncrease":
    "Intervall erhöhen",
  "trainerstunden.planning.seriesRecurrenceEveryNWeeks": "alle {count} Wochen",
  "trainerstunden.planning.seriesRecurrenceEveryNMonths": "alle {count} Monate",
  "trainerstunden.planning.seriesRecurrenceMonthlyModeLabel": "Monatlich nach",
  "trainerstunden.planning.seriesRecurrenceMonthlyByWeekday": "Wochentagen",
  "trainerstunden.planning.seriesRecurrenceMonthlyByDay": "Kalendertagen",
  "trainerstunden.planning.seriesRecurrenceMonthDaysLabel":
    "Kalendertage im Monat",
  "trainerstunden.planning.seriesRecurrenceMonthDayShort": "{day}.",
  "trainerstunden.planning.seriesRecurrenceStartDayOfMonth":
    "Starttag im Monat",
  "trainerstunden.planning.seriesRecurrencePresetFirstMid": "1. & 15.",
  "trainerstunden.planning.seriesRecurrenceFrequencyLabel": "Wiederholen alle",
  "trainerstunden.planning.seriesRecurrenceEveryWeek": "1 Woche",
  "trainerstunden.planning.seriesRecurrenceEveryTwoWeeks": "2 Wochen",
  "trainerstunden.planning.seriesRecurrenceEveryMonth": "1 Monat",
  "trainerstunden.planning.seriesRecurrenceWeekdaysLabel": "An diesen Tagen",
  "trainerstunden.planning.seriesRecurrencePresetStartDay": "Nur Starttag",
  "trainerstunden.planning.seriesRecurrencePresetMonFri": "Mo–Fr",
  "trainerstunden.planning.seriesRecurrenceMonthlyHint":
    "Monatlich am gleichen Kalendertag wie der Start (kurze Monate werden angepasst).",
  "trainerstunden.planning.seriesRecurrenceTimeHint":
    "Startuhrzeit für jeden Termin: {time} (oben unter „Wann & wo“).",
  "trainerstunden.planning.seriesRecurrenceApply": "Rhythmus übernehmen",
  "trainerstunden.planning.seriesRecurrenceSummaryDays": "{days} · {frequency}",
  "trainerstunden.planning.seriesRecurrenceSummaryDaysTime":
    "{days} · {frequency} · {time}",
  "trainerstunden.planning.seriesStartDate":
    "Serie ab (Datum, aus Kalenderauswahl)",
  "trainerstunden.planning.seriesEndDate": "Serie bis (Datum)",
  "trainerstunden.planning.seriesInvalidRange":
    "Das Serienende muss am oder nach dem Startdatum liegen.",
  "trainerstunden.planning.seriesRecurrenceSelectRequired":
    "Bitte zuerst einen Rhythmus für die Serie auswählen.",
  "trainerstunden.planning.sessionMetaTitle": "Zeit, Dauer und Trainer",
  "trainerstunden.planning.fieldSessionDate": "Datum",
  "trainerstunden.planning.saveMeta": "Änderungen speichern",
  "trainerstunden.planning.saveMetaSaving": "Wird gespeichert …",
  "trainerstunden.planning.saveMetaFailed":
    "Änderungen konnten nicht gespeichert werden.",
  "trainerstunden.planning.deleteSession": "Termin löschen",
  "trainerstunden.planning.deleteSaving": "Wird gelöscht …",
  "trainerstunden.planning.cancelSession": "Termin absagen",
  "trainerstunden.planning.cancelSaving": "Wird abgesagt …",
  "trainerstunden.planning.cancelFailed":
    "Termin konnte nicht abgesagt werden. Bitte erneut versuchen.",
  "trainerstunden.planning.deleteFailed":
    "Termin konnte nicht gelöscht werden.",
  "trainerstunden.planning.deleteFailedSoftDeleteMigration":
    "Termin konnte nicht gelöscht werden: Die Datenbank kennt Soft-Delete noch nicht. Bitte Migration 20260654000172_trainerstunden_sessions_soft_delete auf der Umgebung ausführen.",
  "trainerstunden.planning.deleteFailedPermission":
    "Termin konnte nicht gelöscht werden: Keine Berechtigung für diesen Termin (z. B. bereits bestätigtes Training oder anderer Trainer).",
  "trainerstunden.planning.deleteFailedNoSupabase":
    "Termin konnte nicht gelöscht werden: Keine Verbindung zur Datenbank. Bitte Seite neu laden und erneut einloggen.",
  "trainerstunden.planning.trainerPlaceholder": "Bitte wählen",
  "trainerstunden.planning.invalidDuration":
    "Bitte eine Dauer von mindestens 15 Minuten eingeben.",
  "trainerstunden.session.moveFailed": "Termin konnte nicht verschoben werden.",
  "trainerstunden.payments.hint":
    "Zahlungseingänge von Eltern/Spielern verbuchen. Getrennt von der Trainerabrechnung (Honorar an Trainer).",
  "trainerstunden.payments.dispatchBasedHint":
    "Hinweis: „Offen seit letztem Versand“ basiert auf protokollierten Zahlungsaufforderungen (Spielerabrechnung → Versand protokollieren).",
  "trainerstunden.payments.statementBasedHint":
    "Offene Beträge werden aus erstellten Rechnungen abgeleitet (Rechnungsstellung → Rechnungen).",
  "trainerstunden.payments.person": "Spieler",
  "trainerstunden.payments.date": "Datum",
  "trainerstunden.payments.amount": "Betrag (€)",
  "trainerstunden.payments.amountPlaceholder": "0,00",
  "trainerstunden.payments.statementLabel": "Rechnung (optional)",
  "trainerstunden.payments.statementNone": "Keine Rechnung auswählen",
  "trainerstunden.payments.statementOption": "{month} · offen {amount} €",
  "trainerstunden.payments.statementHint":
    "Wenn du eine Rechnung auswählst, kann der Zahlungsstatus automatisch aktualisiert werden.",
  "trainerstunden.payments.statementHintChoosePerson":
    "Zuerst Rechnungsempfänger wählen — dann erscheinen die offenen Rechnungen.",
  "trainerstunden.payments.statementHintFiltered":
    "Nur offene Rechnungen des gewählten Rechnungsempfängers.",
  "trainerstunden.payments.formRecipientEmpty":
    "Keine offenen Rechnungen mit Rechnungsempfängern",
  "trainerstunden.payments.method": "Zahlungsart",
  "trainerstunden.payments.method.cash": "Bar",
  "trainerstunden.payments.method.bank": "Überweisung",
  "trainerstunden.payments.method.creditBalance": "Guthaben",
  "trainerstunden.payments.method.card": "Karte",
  "trainerstunden.payments.method.other": "Sonstiges",
  "trainerstunden.payments.notes": "Notiz",
  "trainerstunden.payments.notesPlaceholder": "z.B. Überweisung, Bar, etc.",
  "trainerstunden.payments.createPayment": "Zahlung erfassen",
  "trainerstunden.payments.newPaymentTitle": "Neue Zahlung",
  "trainerstunden.payments.editPaymentTitle": "Zahlung bearbeiten",
  "trainerstunden.payments.bookedLabel": "verbucht",
  "trainerstunden.payments.bookedHistoryTitle": "Verbuchte Zahlungen ({count})",
  "trainerstunden.payments.bookedHistoryHint":
    "Bereits erfasste Zahlungseingänge — bearbeiten oder löschen.",
  "trainerstunden.payments.bookedColMethod": "Zahlungsart",
  "trainerstunden.payments.bookedColInvoice": "Rechnung",
  "trainerstunden.payments.receiptsSectionTitle": "Zahlungseingänge verbuchen",
  "trainerstunden.payments.receiptsSectionHint":
    "Wenn Geld auf dem Konto ist: hier eintragen. Offene Rechnungen findest du oben — dort kannst du auch direkt pro Rechnung verbuchen.",
  "trainerstunden.payments.openAmountsTitle": "Offen seit letztem Versand",
  "trainerstunden.payments.openAmountsText":
    "Aktuell sind {amount} € offen seit dem letzten protokollierten Versand – bei {people} Personen.",
  "trainerstunden.payments.openStatementsTitle": "Offen aus Rechnungen",
  "trainerstunden.payments.openStatementsEmpty":
    "Aktuell gibt es keine offenen Rechnungen.",
  "trainerstunden.payments.openStatementsText":
    "Aktuell sind {amount} € offen aus Rechnungen – bei {people} Empfängern.",
  "trainerstunden.payments.openStatementsListTitle":
    "Offene Rechnungen (Übersicht)",
  "trainerstunden.payments.openStatementsListHint":
    "Hier siehst du nur offene Beträge, für die bereits eine Rechnung erstellt wurde.",
  "trainerstunden.payments.openStatementsListEmpty":
    "Keine offenen Rechnungen gefunden.",
  "trainerstunden.payments.stmtColRecipient": "Empfänger",
  "trainerstunden.payments.stmtColMonth": "Monat",
  "trainerstunden.payments.stmtColStatus": "Status",
  "trainerstunden.payments.stmtColOpen": "Offen",
  "trainerstunden.payments.stmtColAction": "Aktion",
  "trainerstunden.payments.stmtBook": "Zahlung erfassen",
  "trainerstunden.payments.stmtOpen": "Zur Rechnung",
  "trainerstunden.payments.stmtPrefillMissingPerson":
    "Für diese Rechnung kann keine Person automatisch vorgeschlagen werden.",
  "trainerstunden.payments.legacyQueueTitle":
    "Legacy: Offen seit letztem Versand (Übersicht)",
  "trainerstunden.payments.statementPaymentNote":
    "Zahlung zu Rechnung {period}",
  "trainerstunden.payments.list": "Letzte Zahlungen",
  "trainerstunden.payments.empty": "Noch keine Zahlungen.",
  "trainerstunden.session.time": "Start",
  "trainerstunden.session.startTime": "Startzeit",
  "trainerstunden.session.duration": "Dauer (Min.)",
  "trainerstunden.session.locationHint": "Oder Ort frei eintragen:",
  "trainerstunden.locations.title": "Orte",
  "trainerstunden.locations.clubName": "Vereinsname (optional)",
  "trainerstunden.locations.environment": "Indoor/Outdoor (optional)",
  "trainerstunden.locations.environment.indoor": "Indoor",
  "trainerstunden.locations.environment.outdoor": "Outdoor",
  "trainerstunden.locations.accessCode": "Zugangscode (optional)",
  "trainerstunden.locations.accessCode.short": "Code",
  "trainerstunden.locations.name": "Name",
  "trainerstunden.locations.namePlaceholder": "z.B. Halle Süd",
  "trainerstunden.locations.street": "Straße",
  "trainerstunden.locations.postalCode": "PLZ",
  "trainerstunden.locations.city": "Ort",
  "trainerstunden.locations.locationType": "Typ",
  "trainerstunden.locations.locationType.outdoor": "Außenanlage",
  "trainerstunden.locations.locationType.indoor": "Halle",
  "trainerstunden.locations.locationType.clubhouse": "Vereinsheim",
  "trainerstunden.locations.locationType.training_site": "Trainingsgelände",
  "trainerstunden.locations.locationType.external": "Extern",
  "trainerstunden.locations.notes": "Notiz",
  "trainerstunden.locations.col.name": "Ort",
  "trainerstunden.locations.empty": "Noch keine Orte.",
  "trainerstunden.locations.hintTitle": "Hinweis",
  "trainerstunden.locations.hint":
    "Orte kannst du bei neuen Stunden auswählen.",
  "trainerstunden.confirm.deleteLocation": "Ort wirklich löschen?",
  "trainerstunden.confirm.deleteSession": "Trainerstunde wirklich löschen?",
  "trainerstunden.hint.enterToCreate": "Enter zum Anlegen.",
  "trainerstunden.hint.autoSave": "Änderungen werden automatisch gespeichert.",
  "trainerstunden.locations.details": "Ort",
  "trainerstunden.locations.noneSelected": "Wähle links einen Ort aus.",
  "trainerstunden.col.total": "Gesamt",
  "trainerstunden.col.status": "Status",
  "trainerstunden.status.confirmed": "bestätigt",
  "trainerstunden.status.open": "offen",
  "trainerstunden.status.planned": "Geplant",
  "trainerstunden.status.completed": "Durchgeführt",
  "trainerstunden.status.cancelled_weather": "Wetter / Regen",
  "trainerstunden.status.cancelled_trainer": "Trainer krank / verhindert",
  "trainerstunden.status.cancelled_court": "Platz nicht verfügbar",
  "trainerstunden.status.cancelled_participants": "Alle Teilnehmer abgesagt",
  "trainerstunden.status.cancelled_club":
    "Vereinsveranstaltung / organisatorischer Grund",
  "trainerstunden.status.cancelled_holiday": "Ferien",
  "trainerstunden.status.postponed": "Verschoben",
  "trainerstunden.status.cancelled_other": "Sonstiges",
  "trainerstunden.pricing.hourlySplit": "Stundensatz",
  "trainerstunden.pricing.fixedTotal": "Fixbetrag",
  "trainerstunden.splitBase.present": "auf Anwesende",
  "trainerstunden.splitBase.all": "auf alle geplant",
  "trainerstunden.session.recurrence": "Typ",
  "trainerstunden.recurrence.once": "einmalig",
  "trainerstunden.recurrence.daily": "wiederkehrend (täglich)",
  "trainerstunden.recurrence.weekly": "wiederkehrend (wöchentlich)",
  "trainerstunden.recurrence.biweekly": "wiederkehrend (2-wöchentlich)",
  "trainerstunden.recurrence.monthly": "wiederkehrend (monatlich)",
  "trainerstunden.session.dateFrom": "Datum (von)",
  "trainerstunden.session.dateUntil": "Datum (bis, optional)",
  "trainerstunden.session.dateUntilHint":
    "Nur bei wiederkehrenden Terminen: letztes Datum der Serie (einschließlich).",
  "trainerstunden.session.recurrenceLockedHint":
    "Frequenz ist gesperrt, sobald der Termin gestartet oder bereits verbucht wurde.",
  "trainerstunden.session.convertToSeriesHint":
    "Einzeltermin in eine Serie umwandeln: unter „Typ“ wöchentlich, 2-wöchentlich, monatlich oder täglich wählen, „Datum (bis)“ setzen und speichern.",
  "trainerstunden.session.convertSeriesTooFewDates":
    "Für eine Serie sind im gewählten Zeitraum mindestens zwei Termine nötig. Bitte „Datum (bis)“ weiter in die Zukunft legen.",
  "trainerstunden.session.saveFailedGeneric":
    "Der Termin konnte nicht gespeichert werden.",
  "trainerstunden.session.trainer": "Trainer",
  "trainerstunden.session.targetGroup": "Zielgruppe",
  "trainerstunden.session.trainingType": "Trainingsart",
  "trainerstunden.session.groupSize": "Gruppengröße",
  "trainerstunden.session.rateDerived": "Stundensatz (automatisch)",
  "trainerstunden.session.trainerMissing": "Bitte Trainer auswählen.",
  "trainerstunden.session.rateMissing":
    "Für diese Auswahl ist kein Stundensatz beim Trainer hinterlegt.",
  "trainerstunden.session.honorarSectionTitle": "Trainerhonorar dieser Session",
  "trainerstunden.session.honorarSectionHint":
    "Dieser Wert wird für die Trainerabrechnung verwendet.",
  "trainerstunden.session.honorarType": "Honorarart",
  "trainerstunden.session.honorarType.perHour": "Stundensatz (€/h)",
  "trainerstunden.session.honorarType.flatSession": "Pauschal pro Termin",
  "trainerstunden.session.honorarType.noPayout": "Keine Trainervergütung",
  "trainerstunden.session.honorarType.custom":
    "Benutzerdefiniert (Stundensatz)",
  "trainerstunden.session.honorarRateEur": "Honorar-Stundensatz (€/h)",
  "trainerstunden.session.honorarAmountEur": "Honorar-Betrag (€) pro Termin",
  "trainerstunden.session.honorarSource": "Quelle",
  "trainerstunden.session.honorarSource.trainerDefault": "Trainer-Standard",
  "trainerstunden.session.honorarSource.manual": "Manuell geändert",
  "trainerstunden.session.honorarNote": "Notiz (Honorar)",
  "trainerstunden.session.honorarRateMissing":
    "Bitte einen gültigen Honorar-Stundensatz eingeben.",
  "trainerstunden.session.honorarAmountMissing":
    "Bitte einen gültigen Honorar-Pauschalbetrag eingeben.",
  "trainerstunden.session.pricing": "Preis-Modell",
  "trainerstunden.session.splitBase": "Aufteilen",
  "trainerstunden.session.fixedTotal": "Fixbetrag (€)",
  "trainerstunden.group.children": "Kinder",
  "trainerstunden.group.youth": "Jugend",
  "trainerstunden.group.women": "Damen",
  "trainerstunden.group.men": "Herren",
  "trainerstunden.group.childrenYouth": "Kinder/Jugend",
  "trainerstunden.group.adults": "Erwachsene",
  "trainerstunden.training.single": "Einzeltraining",
  "trainerstunden.training.pair2": "Gruppentraining",
  "trainerstunden.training.group": "Gruppentraining",
  "trainerstunden.session.displayTitle.typeAndGroup": "{type} · {group}",
  "trainerstunden.session.displayTitle.youthTraining": "Jugendtraining",
  "trainerstunden.session.displayTitle.adultsTraining": "Erwachsenentraining",
  "trainerstunden.trainer.firstName": "Vorname",
  "trainerstunden.trainer.groupingPlaceholder.badge": "Platzhalter",
  "trainerstunden.trainer.groupingPlaceholder.label":
    "Nur Platzhalter zum Bündeln von Spielern (nicht abrechenbar)",
  "trainerstunden.trainer.groupingPlaceholder.hint":
    "Erscheint in der Planung, aber nicht in Rechnungs- und Zahlungsfiltern. Für echte Trainer deaktiviert lassen.",
  "trainerstunden.trainer.humanTrainer.label": "Menschlicher Trainer",
  "trainerstunden.trainer.humanTrainer.hint":
    "Wenn deaktiviert, gilt der Trainer als Platzhalter (z.B. „Freies Training“).",
  "trainerstunden.trainer.humanTrainer.freeTrainingHint":
    "„Freies Training“ ist ein Platzhalter und wird als nicht-menschlicher Trainer geführt.",
  "trainerstunden.trainer.lastName": "Nachname",
  "trainerstunden.trainer.errors.alreadyExistsForPerson":
    "Für diese Person existiert bereits ein Trainer-Datensatz. Bitte den bestehenden Trainer bearbeiten.",
  "trainerstunden.trainer.errors.saveFailed":
    "Trainer konnte nicht gespeichert werden.",
  "trainerstunden.trainer.clubs.title": "Vereinszuordnung",
  "trainerstunden.trainer.clubs.hint":
    "Ordne den Trainer einem oder mehreren Vereinen zu. Der Hauptverein ist der führende Verein für Abrechnung und Stammdaten.",
  "trainerstunden.trainer.clubs.cardLabel": "Vereine",
  "trainerstunden.trainer.clubs.primaryBadge": "Hauptverein",
  "trainerstunden.trainer.clubs.primaryShort": "Hauptverein",
  "trainerstunden.trainer.clubs.setPrimary": "Als Hauptverein",
  "trainerstunden.trainer.clubs.rowLabel": "Verein {{index}}",
  "trainerstunden.trainer.clubs.trainingClubLabel":
    "Er trainiert in Club / Verein",
  "trainerstunden.trainer.clubs.additionalClubLabel":
    "Weiterer Verein {{index}}",
  "trainerstunden.trainer.clubs.selectPlaceholder": "Verein auswählen…",
  "trainerstunden.trainer.clubs.addAnother": "Weiteren Verein hinzufügen",
  "trainerstunden.trainer.clubs.removeClub": "Entfernen",
  "trainerstunden.trainer.clubs.primaryRadio": "Hauptverein",
  "trainerstunden.trainer.clubs.unnamedClub": "Unbenannter Verein",
  "trainerstunden.trainer.clubs.unknownAssigned":
    "Zugeordneter Verein (Name unbekannt)",
  "trainerstunden.trainer.clubs.noneAssigned": "Kein Verein zugeordnet",
  "trainerstunden.trainer.clubs.assignCta": "Verein zuordnen",
  "trainerstunden.trainer.clubs.noOptions":
    "Keine Vereine zur Auswahl verfügbar.",
  "trainerstunden.trainer.clubs.error.loadFailed":
    "Vereine konnten nicht geladen werden.",
  "trainerstunden.trainer.clubs.error.membershipRequired":
    "Bitte mindestens einen Verein auswählen.",
  "trainerstunden.trainer.clubs.error.primaryRequired":
    "Bitte genau einen Hauptverein festlegen.",
  "trainerstunden.trainer.clubs.error.forbidden":
    "Keine Berechtigung für die Vereinszuordnung.",
  "trainerstunden.trainer.clubs.error.freeTraining":
    "Der System-Trainer für freies Training kann keinen Vereinen zugeordnet werden.",
  "trainerstunden.trainer.clubs.error.schemaPending":
    "Vereinszuordnung ist noch nicht in der Datenbank verfügbar (Migration ausstehend).",
  "trainerstunden.trainer.clubs.error.saveFailed":
    "Vereinszuordnung konnte nicht gespeichert werden.",
  "trainerstunden.trainer.address": "Adresse (optional)",
  "trainerstunden.trainer.licenseType": "Trainerschein (Art)",
  "trainerstunden.trainer.ratesTitle": "Stundensätze",
  "trainerstunden.trainer.standardRatesTitle": "Standard-Stundensätze",
  "trainerstunden.trainer.standardRatesHint":
    "Voller Teilnehmerpreis pro Stunde — Grundlage für Termine und Förderdifferenz.",
  "trainerstunden.trainer.standardRatePeriodsTitle":
    "Teilnehmerpreise (Zeiträume)",
  "trainerstunden.trainer.standardRatePeriodsIntro":
    "Trage zuerst deinen Standardpreis ein — er gilt für alle Zielgruppen. Abweichungen pro Zielgruppe sind optional.",
  "trainerstunden.trainer.ratePeriodFlatStandardTitle": "Standardpreis",
  "trainerstunden.trainer.ratePeriodFlatStandardIntro":
    "Gilt für alle Zielgruppen, sofern du unten keine abweichenden Preise einträgst.",
  "trainerstunden.trainer.ratePeriodDeviationsOptional":
    "Abweichende Preise je Zielgruppe (optional)",
  "trainerstunden.trainer.parentBillableRatePeriodsTitle":
    "Eltern-Rechnungssatz (Zeiträume)",
  "trainerstunden.trainer.parentBillableRatePeriodsIntro":
    "Optional: Was auf Eltern-Rechnungen erscheint (z. B. 30 €/h). Die Differenz zum Teilnehmerpreis wird pro Abrechnungsperiode als Förderanteil (Verein/Sponsor) aufsummiert — nicht an Eltern berechnet.",
  "trainerstunden.trainer.parentBillableRatePeriodsHint":
    "Nur ausfüllen, wenn ein Teil des Stundensatzes extern (Verein, Sponsor) getragen wird. Leer lassen = voller Teilnehmerpreis auf der Rechnung.",
  "trainerstunden.trainer.parentBillableRatePeriodValidFromRequired":
    "Bitte für jeden Eltern-Rechnungs-Zeitraum ein „Gültig ab“-Datum setzen.",
  "trainerstunden.trainer.parentBillableRatePeriodOverlapConfirm":
    "Es gibt überlappende Eltern-Rechnungs-Zeiträume. Trotzdem speichern?",
  "trainerstunden.trainer.honorarRatePeriodsTitle":
    "Auszahlung an Trainer (Koordinator-Einkauf)",
  "trainerstunden.trainer.honorarRatePeriodsIntro":
    "Was der Trainingskoordinator an diesen Trainer auszahlt — z. B. 25 €/h, während der Teilnehmerpreis 30 €/h beträgt. Wird beim Planen als Honorar-Snapshot übernommen und in Auszahlungen verwendet.",
  "trainerstunden.trainer.honorarRatePeriodsHint":
    "Nur für Koordinatoren sichtbar. Optionaler Koordinator-Anteil (Provision) wird darunter separat gepflegt.",
  "trainerstunden.trainer.honorarRatePeriodValidFromRequired":
    "Bitte für jeden Auszahlungs-Zeitraum ein „Gültig ab“-Datum setzen.",
  "trainerstunden.trainer.honorarRatePeriodOverlapConfirm":
    "Es gibt überlappende Auszahlungs-Zeiträume. Trotzdem speichern?",
  "trainerstunden.trainer.standardPeriodLabel": "Zeitraum {index}",
  "trainerstunden.trainer.standardPeriodAdd": "Zeitraum hinzufügen",
  "trainerstunden.trainer.standardPeriodRemove": "Zeitraum entfernen",
  "trainerstunden.trainer.standardPeriodValidFrom": "Gültig ab",
  "trainerstunden.trainer.standardPeriodValidTo": "Gültig bis",
  "trainerstunden.trainer.ratePeriodStandardGroup": "Standard-Zielgruppe",
  "trainerstunden.trainer.ratePeriodStandardBadge": "Standard",
  "trainerstunden.trainer.ratePeriodApplyStandard":
    "Standard-Sätze für Zielgruppen ohne eigenen Wert verwenden",
  "trainerstunden.trainer.ratePeriodDeviations":
    "Abweichende Zielgruppen (optional)",
  "trainerstunden.trainer.ratePeriodInheritsStandard": "über Standard",
  "trainerstunden.trainer.ratePeriodInheritPlaceholder": "Standard",
  "trainerstunden.trainer.ratePeriodStandardRatesAria":
    "Standard-Sätze je Trainingsart",
  "trainerstunden.trainer.ratePeriodDeviationRatesAria":
    "Abweichende Sätze je Zielgruppe",
  "trainerstunden.trainer.standardPeriodValidFromRequired":
    "Bitte für jeden Zeitraum ein „Gültig ab“-Datum setzen.",
  "trainerstunden.trainer.standardPeriodSparseConfirm":
    "Mindestens ein Zeitraum hat weder Einzel- noch Gruppentraining mit positivem Satz. Trotzdem speichern?",
  "trainerstunden.trainer.standardPeriodOverlapConfirm":
    "Es gibt überlappende Gültigkeitszeiträume. Trotzdem speichern?",
  "trainerstunden.trainer.rate.single": "Einzeltraining",
  "trainerstunden.trainer.rate.group": "Gruppentraining",
  "trainerstunden.trainer.ratePerHourPlaceholder": "€/h",
  "trainerstunden.trainer.coordination.title":
    "Koordination im Geld- & Rechnungsfluss",
  "trainerstunden.trainer.coordination.hint":
    "Lege fest, ob die Rechnungen dieses Trainers über den Trainingskoordinator laufen. Im koordinierten Zeitraum erhält der Trainer sein Geld über den Koordinator; außerhalb rechnet er selbst ab.",
  "trainerstunden.trainer.coordination.enableLabel":
    "Diesen Trainer im Geld- & Rechnungsfluss koordinieren",
  "trainerstunden.trainer.coordination.permanentHint":
    "Standard: dauerhafte Koordination (ohne Zeitlimit). Füge nur bei Bedarf einen Zeitraum hinzu, um die Koordination zeitlich einzuschränken.",
  "trainerstunden.trainer.coordination.periodsHint":
    "Koordination gilt nur in diesen Zeiträumen. Leeres „Von“/„Bis“ bedeutet unbefristet.",
  "trainerstunden.trainer.coordination.periodAdd": "Zeitraum einschränken",
  "trainerstunden.trainer.coordination.periodRemove": "Zeitraum entfernen",
  "trainerstunden.trainer.coordination.validFrom": "Koordiniert ab",
  "trainerstunden.trainer.coordination.validTo": "Koordiniert bis",
  "trainerstunden.trainer.coordination.cardLabel": "Koordination",
  "trainerstunden.trainer.coordination.statusPermanent":
    "Dauerhaft koordiniert",
  "trainerstunden.trainer.coordination.statusLimited":
    "Koordiniert ({count} Zeiträume)",
  "trainerstunden.trainer.coordination.statusActiveUntil":
    "Koordiniert bis {date}",
  "trainerstunden.trainer.coordination.statusEnded":
    "Koordination beendet am {date}",
  "trainerstunden.trainer.coordination.statusNone": "Nicht koordiniert",
  "trainerstunden.trainer.coordination.toggleOnCta": "Koordinieren",
  "trainerstunden.trainer.coordination.toggleOffCta": "Koordination beenden",
  "trainerstunden.trainer.coordination.toggleBusy": "Speichern…",
  "trainerstunden.trainer.coordination.toggleHint":
    "Koordination beenden setzt ein Enddatum (Historie bleibt). Neu koordinieren startet ab heute.",
  "trainerstunden.trainer.coordination.toggleFailed":
    "Koordination konnte nicht gespeichert werden.",
  "trainerstunden.trainer.coordination.endModal.title": "Koordination beenden",
  "trainerstunden.trainer.coordination.endModal.body":
    "Ab dem Folgetag läuft die Abrechnung nicht mehr über dich. Umsätze und Planungen bis einschließlich dieses Datums bleiben für dich sichtbar.",
  "trainerstunden.trainer.coordination.endModal.validTo":
    "Koordination endet am (einschließlich)",
  "trainerstunden.trainer.coordination.endModal.confirm": "Beenden",
  "trainerstunden.trainer.coordination.endModal.invalidDate":
    "Bitte ein gültiges Datum wählen.",
  "trainerstunden.trainer.coordination.endedFormHint":
    "Koordination ist beendet. Die Zeiträume bleiben für die Historie erhalten; zum erneuten Koordinieren den Haken wieder setzen.",
  "trainerstunden.trainer.uebungsleiterpauschale.title":
    "Übungsleiterpauschale (Verein)",
  "trainerstunden.trainer.uebungsleiterpauschale.hint":
    "Wenn der Verein die Übungsleiterpauschale zahlt, müssen Eltern-Rechnungen für diesen Trainer über den Verein laufen.",
  "trainerstunden.trainer.uebungsleiterpauschale.enableLabel":
    "Verein zahlt Übungsleiterpauschale für diesen Trainer",
  "trainerstunden.trainer.uebungsleiterpauschale.billingFlowHint":
    "Der Zahlungsfluss läuft über den Verein: Spieler zahlt an den Verein (Rechnungsadresse des Vereins), der Verein wickelt die Pauschale gegenüber dem Trainer ab. Direkte Trainer-Rechnungen an Spieler sind dann nicht zulässig.",
  "trainerstunden.trainer.uebungsleiterpauschale.afterSaveHint":
    "Vertrag und Bestätigung können nach dem ersten Speichern des Trainers hinterlegt werden.",
  "trainerstunden.trainer.uebungsleiterpauschale.contractUploadLabel":
    "Übungsleitervertrag (PDF oder Bild)",
  "trainerstunden.trainer.uebungsleiterpauschale.contractUploadHint":
    "Vertrag mit dem Verein als PDF oder Foto hochladen (max. 10 MB).",
  "trainerstunden.trainer.uebungsleiterpauschale.pendingFile":
    "Ausgewählt: {name}",
  "trainerstunden.trainer.uebungsleiterpauschale.contractConfirmLabel":
    "Ich bestätige, dass der schriftliche Übungsleitervertrag mit dem Verein vorliegt.",
  "trainerstunden.trainer.uebungsleiterpauschale.contractConfirmedStatus":
    "Vertrag bestätigt und hinterlegt.",
  "trainerstunden.trainer.uebungsleiterpauschale.viewContract":
    "Vertrag anzeigen",
  "trainerstunden.trainer.uebungsleiterpauschale.viewBusy": "Öffne …",
  "trainerstunden.trainer.uebungsleiterpauschale.viewFailed":
    "Vertrag konnte nicht geöffnet werden.",
  "trainerstunden.trainer.uebungsleiterpauschale.cardLabel":
    "Übungsleiterpauschale",
  "trainerstunden.trainer.uebungsleiterpauschale.statusActive":
    "Verein zahlt Pauschale",
  "trainerstunden.trainer.uebungsleiterpauschale.statusNone":
    "Keine Vereins-Pauschale",
  "trainerstunden.trainer.uebungsleiterpauschale.errors.missingContract":
    "Bitte laden Sie den Übungsleitervertrag hoch.",
  "trainerstunden.trainer.uebungsleiterpauschale.errors.missingContractConfirmation":
    "Bitte bestätigen Sie, dass der Vertrag vorliegt.",
  "trainerstunden.trainer.uebungsleiterpauschale.errors.invalidType":
    "Nur PDF oder Bilddateien (JPG, PNG, WebP) sind erlaubt.",
  "trainerstunden.trainer.uebungsleiterpauschale.errors.tooLarge":
    "Die Datei ist zu groß (max. 10 MB).",
  "trainerstunden.trainer.uebungsleiterpauschale.errors.uploadFailed":
    "Vertrag konnte nicht hochgeladen werden.",
  "trainerstunden.trainer.uebungsleiterpauschale.errors.saveFailed":
    "Übungsleiterpauschale konnte nicht gespeichert werden.",
  "trainerstunden.billing.draftIssuer.uebungsleiterpauschaleHint":
    "Mindestens ein Trainer erhält die Übungsleiterpauschale vom Verein – Rechnungen laufen nur über den Verein/Koordinator.",
  "trainerstunden.trainer.legacyPayoutSummary":
    "Auszahlungsdetails (optional, ältere Erfassung)",
  "trainerstunden.trainer.legacyPayoutHint":
    "Diese Felder bleiben technisch erhalten und sind nicht mehr der Hauptort für Honorar. Trainerabrechnung wird in einer späteren Phase an Session-Honorar gekoppelt.",
  "trainerstunden.trainer.group": "Gruppe",
  "trainerstunden.trainer.availabilityTitle": "Verfügbarkeit (Tag & Uhrzeit)",
  "trainerstunden.trainer.availabilityPublicBookingHint":
    "Diese Zeiten steuern die Online-Terminbuchung: Nur innerhalb dieser Fenster können Anfragen gestellt werden. Fixe Trainings erscheinen dort als belegt.",
  "trainerstunden.trainer.publicBookingListed":
    "In öffentlicher Online-Terminbuchung anbieten",
  "trainerstunden.trainer.publicBookingListedHint":
    "Nur aktivierte Trainer erscheinen im öffentlichen Vereinsverzeichnis und können Terminanfragen erhalten.",
  "trainerstunden.trainer.publicBookingLink.title": "Mein Buchungslink",
  "trainerstunden.trainer.publicBookingLink.hint":
    "Dauerhafter Link ohne Ablaufdatum. Empfänger wählen selbst einen freien Slot in deinen Verfügbarkeiten.",
  "trainerstunden.trainer.publicBookingLink.copy": "Link kopieren",
  "trainerstunden.trainer.publicBookingLink.copied":
    "Buchungslink wurde in die Zwischenablage kopiert.",
  "trainerstunden.trainer.publicBookingLink.copyPrompt":
    "Buchungslink kopieren",
  "trainerstunden.trainer.publicBookingLink.needSave":
    "Trainer zuerst speichern, danach steht der Buchungslink bereit.",
  "trainerstunden.trainer.absencesTitle": "Abwesenheiten",
  "trainerstunden.trainer.absence.vacation": "Urlaub",
  "trainerstunden.trainer.absence.sick": "Krankheit",
  "trainerstunden.trainer.absence.holiday": "Ferien",
  "trainerstunden.trainer.absence.note": "Notiz",
  "trainerstunden.trainer.notes": "Notizen",
  "trainerstunden.trainer.loginEmail.label": "Login-E-Mail",
  "trainerstunden.trainer.loginEmail.placeholder": "z.B. sebastian@example.com",
  "trainerstunden.trainer.loginEmail.hint":
    "Optional: Meldet sich der Trainer mit dieser E-Mail an, gelten die Zugriffe aus dem Rollen-/Zugriffskonzept.",
  "trainerstunden.trainer.permissions.title": "TrainingsDesk-Berechtigungen",
  "trainerstunden.trainer.permissions.hint":
    "Steuert, welche Bereiche der Trainer im Trainer-Login sehen darf. Ohne Auswahl gilt der Standard.",
  "trainerstunden.trainer.permissions.defaultHint":
    "Standard: Termine planen und Trainings bestätigen. Zusatzrechte nur bei Bedarf aktivieren.",
  "trainerstunden.trainer.permissions.administration": "Verwaltung",
  "trainerstunden.trainer.permissions.administrationHint":
    "Zugriff auf den Reiter Verwaltung inkl. Trainer, Kontakte und Einstellungen.",
  "trainerstunden.trainer.permissions.billing":
    "Rechnungen erstellen und versenden",
  "trainerstunden.trainer.permissions.billingHint":
    "Zugriff auf Rechnungswesen inkl. Entwürfe, Versand und offene Posten.",
  "trainerstunden.trainer.permissions.payments": "Zahlungen verbuchen",
  "trainerstunden.trainer.permissions.paymentsHint":
    "Zugriff auf Zahlungseingänge und Verbuchung gegen Rechnungen.",
  "trainerstunden.trainer.permissions.expenses": "Ausgaben erfassen",
  "trainerstunden.trainer.permissions.expensesHint":
    "Zugriff auf Ausgabenerfassung inkl. Kategorien und Beleg-Upload.",
  "trainerstunden.trainer.permissions.balance": "Bilanz einsehen",
  "trainerstunden.trainer.permissions.balanceHint":
    "Zugriff auf die Bilanzierung mit Einnahmen- und Ausgabenübersicht.",
  "trainerstunden.trainer.permissions.plannerHint":
    "Planer haben vollen Planungszugriff. Verwaltungs-, Rechnungs- und Zahlungsrechte gelten nur für die Rolle „Trainer“.",
  "trainerstunden.freeTraining.badge": "Freies Training",
  "trainerstunden.freeTraining.formHint":
    "System-Trainer für regelmäßiges Club-Training ohne Abrechnung. Ideal für Mittwochs-/Freitags-Runden mit freier Anmeldung.",
  "trainerstunden.freeTraining.focusLabel": "Schwerpunkt (optional)",
  "trainerstunden.freeTraining.focusPlaceholder":
    "z. B. Herrentraining H30, Damentraining, Jugend",
  "trainerstunden.freeTraining.focusHint":
    "Nur zur Orientierung — ersetzt nicht den Trainertyp und dient der Gruppierung.",
  "trainerstunden.freeTraining.sessionFocusLabel":
    "Schwerpunkt für diesen Termin",
  "trainerstunden.freeTraining.sessionFocusPlaceholder":
    "z. B. Herrentraining H30",
  "trainerstunden.freeTraining.regularAttendeesHint":
    "Kommt üblicherweise: {names}",
  "trainerstunden.freeTraining.planningHint":
    "Freies Training: keine Honorare oder Rechnungen. Spieler können wie gewohnt zu- oder absagen.",
  "trainerstunden.teamCaptain.squad.title": "Mannschaftskader",
  "trainerstunden.teamCaptain.squad.hint":
    "Wähle Mannschaftsspieler aus den ClubHub-Kontakten. Nur diese Personen kannst du in Freie-Training-Termine einplanen.",
  "trainerstunden.teamCaptain.squad.slotsHint":
    "Planbare Zeitfenster: Mittwoch und Freitag, 18:00–20:00 Uhr.",
  "trainerstunden.teamCaptain.squad.searchLabel": "Kontakte filtern",
  "trainerstunden.teamCaptain.squad.searchPlaceholder": "Name suchen…",
  "trainerstunden.teamCaptain.squad.listAria":
    "ClubHub-Kontakte für den Mannschaftskader",
  "trainerstunden.teamCaptain.squad.emptyPicker":
    "Keine passenden ClubHub-Kontakte gefunden.",
  "trainerstunden.teamCaptain.squad.save": "Kader speichern",
  "trainerstunden.teamCaptain.squad.selectedCount": "{n} ausgewählt",
  "trainerstunden.teamCaptain.squad.missingTenant":
    "Kein Verein zugeordnet — Kader kann nicht geladen werden.",
  "trainerstunden.teamCaptain.squad.loadFailed":
    "Mannschaftskader konnte nicht geladen werden.",
  "trainerstunden.teamCaptain.squad.pickerFailed":
    "ClubHub-Kontakte konnten nicht geladen werden.",
  "trainerstunden.teamCaptain.squad.saveFailed":
    "Mannschaftskader konnte nicht gespeichert werden.",
  "trainerstunden.teamCaptain.planning.slotsHint":
    "Freies Training: Mittwoch oder Freitag zwischen 18:00 und 20:00 Uhr. Keine Rechnungen oder Durchführungsbestätigung.",
  "trainerstunden.teamCaptain.planning.outsideSlot":
    "Dieser Termin liegt außerhalb der erlaubten Zeitfenster (Mi/Fr 18–20 Uhr).",
  "trainerstunden.teamCaptain.planning.seriesNotAllowed":
    "Serien-Termine sind für Mannschaftsführer nicht verfügbar.",
  "trainerstunden.teamCaptain.planning.trainerOnlyFree":
    "Als Mannschaftsführer darfst du nur „Freies Training“ planen.",
  "trainerstunden.teamCaptain.planning.playersRequired":
    "Bitte mindestens einen Mannschaftsspieler einplanen.",
  "medenspiele.title": "Mannschaften",
  "medenspiele.subtitle": "Mannschaften für Medenspiele verwalten.",
  "medenspiele.loading": "Lade Mannschaften…",
  "medenspiele.createTeam": "Mannschaft anlegen",
  "medenspiele.noTeams": "Noch keine Mannschaften angelegt.",
  "medenspiele.open": "Öffnen",
  "medenspiele.delete": "Löschen",
  "medenspiele.deleteConfirm":
    "Mannschaft „{name}“ wirklich löschen? Alle zugehörigen Spiele und Daten werden entfernt.",
  "medenspiele.deleting": "Wird gelöscht…",
  "medenspiele.teamName": "Mannschaftsname",
  "medenspiele.teamNamePlaceholder": "z. B. Herren 40 I",
  "medenspiele.teamCode": "Team-Code",
  "medenspiele.teamCodePlaceholder": "z. B. H40-1",
  "medenspiele.teamCodeHint": "4–12 Zeichen: Buchstaben, Zahlen, _ oder -.",
  "medenspiele.season": "Saison",
  "medenspiele.seasonPlaceholder": "z. B. Sommer 2026",
  "medenspiele.create": "Anlegen",
  "medenspiele.creating": "Wird angelegt…",
  "medenspiele.cancel": "Abbrechen",
  "medenspiele.error.missingFields": "Bitte Name und Team-Code ausfüllen.",
  "medenspiele.error.invalidCode":
    "Team-Code: 4–12 Zeichen, nur Buchstaben, Zahlen, _ oder -.",
  "medenspiele.error.createFailed": "Anlegen fehlgeschlagen. ",
  "medenspiele.error.deleteFailed": "Löschen fehlgeschlagen. ",
  "medenspiele.error.unknownError": "Unbekannter Fehler.",
  "teamdesk.nav.aria": "TeamDesk-Bereiche",
  "teamdesk.nav.teams": "Mannschaften",
  "teamdesk.nav.squad": "Kader",
  "teamdesk.nav.sessions": "Termine",
  "teamdesk.nav.planning": "Planen",
  "teamdesk.nav.training": "Freies Training",
  "teamdesk.page.teams.title": "Mannschaften",
  "teamdesk.page.squad.title": "Kader",
  "teamdesk.page.sessions.title": "Termine",
  "teamdesk.page.planning.title": "Planen",
  "teamdesk.training.title": "Freies Training planen",
  "teamdesk.training.comingSoon":
    "Die Terminplanung kommt als Nächstes in TeamDesk — hier kannst du bald Mi/Fr 18–20 Uhr planen.",
  "teamdesk.training.staffOnly":
    "Freies Training planen ist Mannschaftsführern vorbehalten. Sportwart und Vereinsadmins nutzen dafür TrainingsDesk.",
  "teamdesk.training.emptySquadHint":
    "Lege zuerst deinen Mannschaftskader an — ohne Kader kannst du niemanden einplanen.",
  "teamdesk.sessions.title": "Termine",
  "teamdesk.sessions.hint":
    "RSVP deines Kaders: Daumen hoch = dabei, Daumen runter = abgesagt.",
  "teamdesk.sessions.empty": "Noch keine Freie-Training-Termine geplant.",
  "teamdesk.sessions.upcoming": "Kommende Termine",
  "teamdesk.sessions.recent": "Vergangene Termine",
  "teamdesk.sessions.openPlanning": "Bearbeiten",
  "teamdesk.sessions.noPlayers": "Keine Kader-Spieler eingeplant.",
  "teamdesk.sessions.staffOnly":
    "Die Terminübersicht ist Mannschaftsführern vorbehalten.",
  "teamdesk.sessions.rsvp.listAria": "RSVP der Mannschaftsspieler",
  "teamdesk.sessions.rsvp.summary":
    "{attending} von {total} dabei · {declined} abgesagt",
  "teamdesk.sessions.rsvp.attending": "Zusage",
  "teamdesk.sessions.rsvp.declined": "Absage",
  "teamdesk.sessions.rsvp.attendingAria": "Spieler hat zugesagt",
  "teamdesk.sessions.rsvp.declinedAria": "Spieler hat abgesagt",
  "teamdesk.redirectFromCoachDesk": "Weiterleitung zu TeamDesk…",
  "trainerstunden.trainer.permissions.mainTabs": "Reiter",
  "trainerstunden.trainer.permissions.managementSubtabs":
    "Verwaltung – Unterreiter",
  "trainerstunden.trainer.permissions.readonlyHint":
    "Als Trainer kannst du diese Rechte nicht selbst ändern.",
  "trainerstunden.trainer.accessRole.label": "Berechtigung",
  "trainerstunden.trainer.accessRole.trainer": "Trainer (nur eigene)",
  "trainerstunden.trainer.accessRole.planner":
    "Planer (darf andere Trainer planen)",
  "trainerstunden.trainer.accessRole.hint":
    "Planer dürfen Termine für alle Trainer im Verein anlegen und bearbeiten. Verwaltung bleibt gesperrt.",
  "trainerstunden.trainer.appAccess.title": "App-Zugriff",
  "trainerstunden.trainer.appAccess.schleifchen.label":
    "MatchMixer freischalten",
  "trainerstunden.trainer.appAccess.schleifchen.hint":
    "Wenn aktiv, sieht der Trainer die App „MatchMixer“ im Hub.",
  "trainerstunden.trainer.appAccess.schleifchen.manage.label":
    "MatchMixer bearbeiten",
  "trainerstunden.trainer.appAccess.schleifchen.manage.hint":
    "Wenn aktiv, darf der Trainer Turniere im Verein anlegen und ändern. Sonst nur ansehen.",
  "trainerstunden.trainer.billingPeriodTitle": "Abrechnung & Zahlung",
  "trainerstunden.trainer.billingPeriodHint":
    "Standard für neue Rechnungsempfänger und Empfänger ohne eigene Abweichung. Änderungen können mit Stichtag auf Standard-Empfänger übertragen werden.",
  "trainerstunden.trainer.billingChangeDialog.title":
    "Abrechnungsintervall geändert",
  "trainerstunden.trainer.billingChangeDialog.lead":
    "Sollen die neuen Einstellungen auf Rechnungsempfänger ohne Abweichung übernommen werden? Empfänger mit eigenen Regeln werden zur Einzelprüfung vorgemerkt.",
  "trainerstunden.trainer.billingChangeDialog.effectiveFrom": "Stichtag",
  "trainerstunden.trainer.billingChangeDialog.applyToStandard":
    "Neues Intervall auf {count} Standard-Empfänger anwenden",
  "trainerstunden.trainer.billingChangeDialog.draftHandlingLegend":
    "Bestehende Entwürfe und Rechnungen",
  "trainerstunden.trainer.billingChangeDialog.draftHandlingKeep":
    "Unverändert lassen",
  "trainerstunden.trainer.billingChangeDialog.draftHandlingReview":
    "Zur manuellen Prüfung vormerken",
  "trainerstunden.trainer.billingChangeDialog.deviationLead":
    "{count} Empfänger mit Abweichung — Einzelprüfung nötig:",
  "trainerstunden.trainer.billingChangeDialog.deviationMore":
    "… und {count} weitere",
  "trainerstunden.trainer.billingChangeDialog.confirm": "Übernehmen",
  "trainerstunden.trainer.participantRateChangeDialog.title":
    "Teilnehmerpreise geändert",
  "trainerstunden.trainer.participantRateChangeDialog.lead":
    "Sollen die neuen Stundensätze auf Rechnungsempfänger ohne Abweichung übernommen werden? Empfänger mit eigenen Sätzen werden zur Einzelprüfung vorgemerkt.",
  "trainerstunden.trainer.participantRateChangeDialog.effectiveFrom":
    "Stichtag",
  "trainerstunden.trainer.participantRateChangeDialog.applyToStandard":
    "Neue Sätze auf {count} Standard-Empfänger anwenden",
  "trainerstunden.trainer.participantRateChangeDialog.draftHandlingLegend":
    "Bestehende Entwürfe und Rechnungen",
  "trainerstunden.trainer.participantRateChangeDialog.draftHandlingKeep":
    "Unverändert lassen",
  "trainerstunden.trainer.participantRateChangeDialog.draftHandlingReview":
    "Zur manuellen Prüfung vormerken",
  "trainerstunden.trainer.participantRateChangeDialog.deviationLead":
    "{count} Empfänger mit Abweichung — Einzelprüfung nötig:",
  "trainerstunden.trainer.participantRateChangeDialog.deviationMore":
    "… und {count} weitere",
  "trainerstunden.trainer.participantRateChangeDialog.confirm": "Übernehmen",
  "trainerstunden.billing.participantRateDeviation.queueTitle":
    "Teilnehmerpreis-Abweichungen prüfen",
  "trainerstunden.billing.participantRateDeviation.lead":
    "Diese Empfänger weichen vom Trainer-Standard ab. Neue Sätze nur nach Freigabe übernehmen.",
  "trainerstunden.billing.participantRateDeviation.proposedLine":
    "Vorschlag: Einzel {single} €/h · Gruppe {group} €/h ab {date}",
  "trainerstunden.billing.participantRateDeviation.accept":
    "Trainer-Standard übernehmen",
  "trainerstunden.billing.participantRateDeviation.dismiss":
    "Abweichung beibehalten",
  "trainerstunden.player.participantRateTitle": "Teilnehmerpreis",
  "trainerstunden.player.participantRateHint":
    "Vom Trainer übernommen, sofern nicht als Abweichung markiert. Individuelle Einzel- und Gruppensätze gelten für die Abrechnung.",
  "trainerstunden.billing.settingsDeviation.queueTitle":
    "Abrechnungs-Abweichungen prüfen",
  "trainerstunden.billing.settingsDeviation.lead":
    "Diese Empfänger weichen vom Trainer-Standard ab. Neue Intervalle nur nach Freigabe übernehmen.",
  "trainerstunden.billing.settingsDeviation.proposedLine":
    "Vorschlag: {frequency} · {timing} ab {date}",
  "trainerstunden.billing.settingsDeviation.accept":
    "Trainer-Standard übernehmen",
  "trainerstunden.billing.settingsDeviation.dismiss": "Abweichung beibehalten",
  "trainerstunden.player.billingPeriodHint":
    "Vom Trainer übernommen, sofern nicht als Abweichung markiert. Hier z. B. Vorauszahlung pro Kunde festlegen.",
  "trainerstunden.trainer.paymentDueDaysLabel": "Zahlungsziel (Tage)",
  "trainerstunden.trainer.paymentDueDaysHint":
    "Frist ab Rechnungsdatum auf allen Rechnungen dieses Trainers — unabhängig von der Zahlungsmethode (Standard: 7 Tage).",
  "trainerstunden.trainer.paymentDueDaysInvalid":
    "Zahlungsziel: bitte eine ganze Zahl zwischen 1 und 366 Tagen eintragen.",
  "trainerstunden.trainer.paymentDueDaysSchemaPending":
    "Gespeichert, aber das Zahlungsziel konnte nicht übernommen werden — bitte die ausstehende Migration anwenden und danach erneut speichern.",
  "trainerstunden.trainer.billingFrequencyLabel": "Abrechnungsrhythmus",
  "trainerstunden.trainer.billingAllocationModeLabel": "Kostenverteilung",
  "trainerstunden.trainer.billingAllocationMode.hourly":
    "Anteilig je Spieler je Stunde",
  "trainerstunden.trainer.billingAllocationMode.season":
    "Anteilig je Spieler je Saison/Serie",
  "trainerstunden.trainer.billingAllocationModeHint":
    "Unabhängig vom Abrechnungsrhythmus (monatlich, Voraus/Nach). Bei Saison wird der vereinbarte Gesamtbetrag gleichmäßig auf die geplanten Spieler verteilt – unabhängig von Anwesenheit.",
  "trainerstunden.trainer.billingRhythmSectionHint":
    "Abrechnungsrhythmus und Voraus/Nach gelten für beide Verteilungsarten.",
  "trainerstunden.planning.seriesBillingTitle": "Abrechnung der Serie",
  "trainerstunden.planning.seriesBillingModeLegend":
    "Abrechnungsmodell für diese Serie",
  "trainerstunden.planning.seriesBillingModeTrainerDefaults": "Mein Standard",
  "trainerstunden.planning.seriesBillingModeSeasonFlat": "Serienpauschale",
  "trainerstunden.planning.seriesBillingTrainerSummary":
    "{rhythm} · {allocation}",
  "trainerstunden.planning.seriesBillingFlatHint":
    "Fester Serienbetrag, gleichmäßig auf geplante Spieler – unabhängig von An- oder Abwesenheit.",
  "trainerstunden.planning.seriesBillingPaymentLegend": "Zahlungszeitpunkt",
  "trainerstunden.planning.seriesBillingPaymentAdvance": "Vorauszahlung",
  "trainerstunden.planning.seriesBillingPaymentArrears": "Nachgelagert",
  "trainerstunden.planning.seriesBillingUseTrainerDefaults":
    "Trainer-Standard übernehmen",
  "trainerstunden.planning.seriesBillingTotalLabel": "Serien-Gesamtbetrag (€)",
  "trainerstunden.planning.seriesBillingTotalHint":
    "Optional festlegen – sonst Stundensatz × Dauer × Anzahl Termine.",
  "trainerstunden.planning.seriesBillingPreview":
    "Bei {count} Spielern: {share} je Person (Serie gesamt {total}).",
  "trainerstunden.trainer.billingTimingLabel": "Zahlungszeitpunkt",
  "trainerstunden.trainer.billingFrequency.afterSession":
    "Direkt nach der Stunde",
  "trainerstunden.trainer.billingFrequency.monthly": "Pro Monat",
  "trainerstunden.trainer.billingFrequency.quarterly": "Pro Quartal",
  "trainerstunden.trainer.billingTiming.advance": "Im Voraus",
  "trainerstunden.trainer.billingTiming.arrears": "Nachgelagert",
  "trainerstunden.trainer.billingUnset": "nicht festgelegt",
  "trainerstunden.trainer.summary.billing": "Abrechnung & Zahlung",
  "trainerstunden.trainer.empty": "Noch keine Trainer angelegt.",
  "trainerstunden.trainer.summary.availability": "Verfügbarkeit",
  "trainerstunden.trainer.summary.absences": "Abwesenheiten",
  "trainerstunden.trainer.summary.organization": "Organisation",
  "trainerstunden.trainer.summary.rates": "Preise",
  "trainerstunden.trainer.summary.none": "Keine Angaben",
  "trainerstunden.people.firstName": "Vorname",
  "trainerstunden.people.lastName": "Nachname",
  "trainerstunden.people.birthDate": "Geburtstag (optional)",
  "trainerstunden.people.errors.invalidBirthDate":
    "Bitte ein gültiges Geburtsdatum eingeben.",
  "trainerstunden.people.errors.invalidBirthYear":
    "Bitte einen gültigen Jahrgang eingeben.",
  "trainerstunden.people.errors.birthDateInFuture":
    "Das Geburtsdatum darf nicht in der Zukunft liegen.",
  "trainerstunden.people.club.title": "Verein",
  "trainerstunden.people.club.hint":
    "Zuordnung zu deinem Tennisverein (Mandant). Kontakte gehören in der Regel zu genau einem Verein.",
  "trainerstunden.people.club.cardLabel": "Verein",
  "trainerstunden.people.club.noOptions": "Kein Verein zur Auswahl verfügbar.",
  "trainerstunden.people.club.unknownAssigned":
    "Zugeordneter Verein (Name unbekannt)",
  "trainerstunden.people.club.required": "Bitte einen Verein auswählen.",
  "trainerstunden.people.birthHint":
    "Exaktes Geburtsdatum für Altersfreigaben und Buchungen. Der Jahrgang wird automatisch abgeleitet.",
  "trainerstunden.people.birthYear": "Jahrgang (optional)",
  "trainerstunden.people.email": "E-Mail",
  "trainerstunden.people.phone": "Handynummer",
  "trainerstunden.people.phonePlaceholder": "+49 1xx ...",
  "trainerstunden.people.notes": "Notizen",
  "trainerstunden.people.autoCreateHint":
    "Wechsle danach einfach in einen anderen Tab – die Person wird automatisch angelegt.",
  "trainerstunden.player.empty": "Noch keine Spieler angelegt.",
  "trainerstunden.player.invoiceRecipientType": "Rechnungsempfänger",
  "trainerstunden.player.invoice.self": "Spieler selbst",
  "trainerstunden.player.invoice.contact": "Abweichende Kontaktperson",
  "trainerstunden.player.billingContact.existing": "Kontakt wählen",
  "trainerstunden.player.billingContact.hint":
    "Alle Vereinskontakte des aktuellen Clubs sind durchsuchbar. Beim Speichern wird bei Bedarf ein Rechnungsempfänger-Eintrag angelegt.",
  "trainerstunden.player.relationToContact": "Beziehung zum Spieler",
  "trainerstunden.player.relationToContact.placeholder":
    "z. B. Mutter / Vater / Onkel",
  "trainerstunden.player.billingContact.details": "Rechnungsempfänger-Details",
  "trainerstunden.player.billingContact.firstName": "Vorname (Kontakt)",
  "trainerstunden.player.billingContact.lastName": "Nachname (Kontakt)",
  "trainerstunden.player.billingContact.email": "E-Mail (Rechnung)",
  "trainerstunden.player.billingContact.phone": "Telefon (Kontakt)",
  "trainerstunden.player.billingPeriodTitle": "Abrechnung & Zahlung",
  "trainerstunden.player.unnamed": "Unbenannter Spieler",
  "trainerstunden.player.quickAdd.placeholder":
    "Neuen Spieler-Namen schnell ergänzen",
  "trainerstunden.player.quickAdd.add": "Name ergänzen",
  "trainerstunden.player.quickAdd.adding": "Wird angelegt...",
  "trainerstunden.player.quickAdd.hint":
    "Details kannst du später in den Stammdaten ergänzen.",
  "trainerstunden.player.quickAdd.failed":
    "Spieler konnte nicht angelegt werden.",
  "trainerstunden.billing.required":
    "Bitte Rechnungsempfänger auswählen oder erfassen.",
  "trainerstunden.billing.saveError":
    "Rechnungsempfänger konnte nicht gespeichert werden.",
  "trainerstunden.billing.statementCorrections.title": "Gebuchte Korrekturen",
  "trainerstunden.billing.statementCorrections.sectionAria":
    "Gebuchte Rechnungskorrekturen zu dieser Rechnung",
  "trainerstunden.billing.statementCorrections.empty":
    "Keine gebuchten Korrekturen.",
  "trainerstunden.billing.statementCorrections.amount": "Betrag",
  "trainerstunden.billing.statementCorrections.amountDisplay": "{amount} €",
  "trainerstunden.billing.statementCorrections.kind": "Art der Korrektur",
  "trainerstunden.billing.statementCorrections.reference": "Korrektur-Referenz",
  "trainerstunden.billing.statementCorrections.referenceItem":
    "Korrektur zu Leistung",
  "trainerstunden.billing.statementCorrections.createdAt": "Erfasst am",
  "trainerstunden.billing.statementCorrections.reason": "Grund",
  "trainerstunden.billing.statementCorrections.session": "Training",
  "trainerstunden.billing.statementCorrections.bookedAt":
    "Korrektur gebucht am",
  "trainerstunden.billing.statementCorrections.bookedBy":
    "Gebucht von (Nutzer-ID)",
  "trainerstunden.billing.statementCorrections.kindDeltaItem":
    "Ausgleich einer Leistung",
  "trainerstunden.billing.statementCorrections.kindAdjustmentItem": "Anpassung",
  "trainerstunden.billing.statementCorrections.kindReversalItem":
    "Storno / Rückbuchung",
  "trainerstunden.billing.statementCorrections.kindUnknown": "Art: {code}",
  "trainerstunden.billing.statementCorrections.reasonParticipant":
    "Teilnehmer falsch",
  "trainerstunden.billing.statementCorrections.reasonAttendance":
    "Anwesenheit falsch",
  "trainerstunden.billing.statementCorrections.reasonDuration": "Dauer falsch",
  "trainerstunden.billing.statementCorrections.reasonPrice": "Preis falsch",
  "trainerstunden.billing.statementCorrections.reasonOther": "Sonstiges",
  "trainerstunden.billing.statementCorrections.reasonUnknown": "Grund: {code}",
  "trainerstunden.billing.statementCorrections.summaryTitle":
    "Beträge inkl. Korrekturen",
  "trainerstunden.billing.statementCorrections.originalAmount":
    "Originalbetrag",
  "trainerstunden.billing.statementCorrections.correctionAmount":
    "Gebuchte Korrekturen",
  "trainerstunden.billing.statementCorrections.effectiveAmount":
    "Effektiver Rechnungsbetrag",
  "trainerstunden.billing.statementCorrections.postingCount":
    "{count} Korrektur-Einträge",
  "trainerstunden.billing.statementCorrections.summaryLoadError":
    "Korrektur-Summe konnte nicht geladen werden.",
  "trainerstunden.billing.statementCorrections.openAmountCorrected":
    "Offen (inkl. Korrekturen)",
  "trainerstunden.billing.statementCorrections.paidAmount": "Bereits bezahlt",
  "trainerstunden.billing.statementCorrections.totalsNote":
    "Offener Betrag bezieht den effektiven Rechnungsbetrag (Original plus gebuchte Korrekturen) ein.",
  "trainerstunden.attendees.planned": "Geplant (Zuordnung)",
  "trainerstunden.attendees.present": "Anwesend (nach Termin)",
  "trainerstunden.attendees.confirmHint":
    "Kosten werden erst nach Bestätigung berechnet.",
  "trainerstunden.attendees.confirm": "Anwesenheit bestätigen",
  "trainerstunden.attendees.reschedule": "Training verschieben",
  "trainerstunden.attendees.markCompleted": "Training durchgeführt",
  "trainerstunden.attendees.markCompletedFutureDisabled":
    "Für zukünftige Termine noch nicht möglich.",
  "trainerstunden.attendees.markCancelled": "Training absagen",
  "trainerstunden.attendees.copyPlanned": "Alle geplant = anwesend",
  "trainerstunden.attendees.copyPlannedShort": "Alle als anwesend",
  "trainerstunden.attendees.applySeries": "Auf alle Serientermine anwenden",
  "trainerstunden.attendees.nonePlanned": "Noch keine Teilnehmer eingetragen.",
  "trainerstunden.attendees.cost": "Aufteilung",
  "trainerstunden.attendees.max": "Max.",
  "trainerstunden.conflict.title":
    "Plausi-Check: mögliche Überschneidung gefunden.",
  "trainerstunden.conflict.continue": "Trotzdem speichern?",
  "trainerstunden.conflict.trainer": "Trainer ist bereits eingeplant",
  "trainerstunden.conflict.players": "Spieler bereits eingeplant",
  "trainerstunden.conflict.warnOverlap":
    "Am {date} (andere Stunde {time}): {detail}",
  "trainerstunden.planning.overlapChoice.title":
    "Überschneidung mit bestehenden Terminen",
  "trainerstunden.planning.overlapChoice.body":
    "Der neue Termin überschneidet sich zeitlich mit mindestens einem bestehenden Eintrag. Sollen die betroffenen Termine bestehen bleiben oder abgesagt werden?",
  "trainerstunden.planning.overlapChoice.sessionLine":
    "Am {date} · {time} Uhr · {detail}",
  "trainerstunden.planning.overlapChoice.keepExisting": "Bestehende behalten",
  "trainerstunden.planning.overlapChoice.cancelOverlapping":
    "Überschneidende absagen",
  "trainerstunden.planning.overlapChoice.back": "Zurück",
  "trainerstunden.planning.overlapChoice.cancelFailed":
    "Mindestens ein Termin konnte nicht abgesagt werden.",
  "trainerstunden.planning.tennify.ownBookingOverlapHint":
    "Hinweis: In Tennify ist der Platz in diesem Fenster bereits für dich gebucht. Ein weiterer Termin zur gleichen Zeit kann zu Doppelbelegungen führen — prüfe alternative Plätze oder Tennify.",
  "trainerstunden.session.editSeriesRest":
    "Ab diesem Termin (Serie): Dauer, Stundensatz und Spieler für alle folgenden, noch nicht beendeten Termine — vergangene Termine der Serie bleiben unverändert.",
  "trainerstunden.session.editSeriesRestShort": "Serie ab hier",
  "trainerstunden.planning.editScopeLabel": "Geltungsbereich",
  "trainerstunden.planning.seriesRestPastHint":
    "Bereits beendete Termine der Serie werden nicht mehr angepasst; nur dieser Termin und zukünftige, noch laufende oder anstehende Termine erhalten die Änderung.",
  "trainerstunden.planning.seriesRestPastHintShort":
    "Vergangene Termine der Serie bleiben unverändert.",
  "trainerstunden.session.seriesDurationTitle": "Seriendauer",
  "trainerstunden.session.seriesExtendHint":
    "„Serie bis“ nach hinten verschieben und speichern — es werden automatisch fehlende Termine im gewählten Rhythmus angelegt.",
  "trainerstunden.session.seriesExtendHintShort":
    "Enddatum nach hinten = neue Termine beim Speichern.",
  "trainerstunden.session.seriesExtendFailed":
    "Die Serie konnte nicht verlängert werden. Bitte erneut versuchen.",
  "trainerstunden.session.seriesExtendFailedWithDetail":
    "Die Serie konnte nicht verlängert werden: {detail}",
  "trainerstunden.planning.conflictWarningTitle": "Hinweis zu Überschneidungen",
  "trainerstunden.planning.playerPickFilterPlaceholder":
    "Suche nach Vor- oder Nachname …",
  "trainerstunden.planning.playerPickFilterAria": "Spielerliste eingrenzen",
  "trainerstunden.planning.playerPickSelectAria":
    "Spieler aus gefilterter Liste wählen",
  "trainerstunden.planning.playerPickSearchHint":
    "Tipp: Mit der Suche wird die Liste eingegrenzt – auch bei vielen Spielern schnell die richtige Person finden.",
  "trainerstunden.planning.playerPickNoMatches":
    "Keine Treffer für die Suche – Filter anpassen.",
  "trainerstunden.planning.playerPickAllAssigned":
    "Alle Spieler sind bereits für diesen Termin vorgesehen.",
  "trainerstunden.session.editScope": "Bearbeiten",
  "trainerstunden.session.editSingle": "Nur diesen Termin bearbeiten",
  "trainerstunden.session.editScopeSegmentSingle": "Nur dieser Termin",
  "trainerstunden.session.editScopeSegmentSeries": "Serie ab hier",
  "trainerstunden.session.editSeries": "Gesamte Serie bearbeiten",
  "trainerstunden.session.deleteSeries": "Gesamte Serie löschen",
  "trainerstunden.calendar.filterAll": "Alle Trainer",
  "trainerstunden.player.countLabel": "Spieler",
  "trainerstunden.confirm.deleteSeries": "Gesamte Serie wirklich löschen?",
  "trainerstunden.trainer.calendar.copy": "Kalender-Link kopieren",
  "trainerstunden.trainer.calendar.regenerate": "Token neu erstellen",
  "trainerstunden.trainer.calendar.copied": "Kalender-Link wurde kopiert.",
  "trainerstunden.trainer.calendar.regenerated":
    "Neuer Kalender-Link wurde erstellt und kopiert.",
  "trainerstunden.trainer.calendar.copyManual": "Kalender-Link kopieren:",
  "trainerstunden.location.createOption": "Ort nicht gefunden - neu anlegen",
  "trainerstunden.location.createPlaceholder": "Neuen Ort eingeben",
  "trainerstunden.location.createMissingName":
    "Bitte Namen fuer den neuen Ort eingeben.",
  "trainerstunden.location.createFailed": "Ort konnte nicht angelegt werden.",
  "trainerstunden.add": "Neu",
  "trainerstunden.save": "Speichern",
  "trainerstunden.delete": "Löschen",
  "trainerstunden.choose": "Bitte wählen",
  "trainerstunden.chooseOptional": "Optional auswählen",
  "trainerstunden.link.email": "Mail",
  "trainerstunden.link.whatsapp": "WhatsApp",
  "trainerstunden.link.call": "Anrufen",
  "trainerstunden.publicLink.create": "Zahlungslink",
  "trainerstunden.publicLink.copied":
    "Link kopiert. Du kannst ihn der Person schicken.",
  "trainerstunden.publicLink.copyPrompt": "Link zum Kopieren:",
  "trainerstunden.publicLink.error": "Link konnte nicht erstellt werden.",
  "trainerstunden.public.title": "Zahlungsübersicht",
  "trainerstunden.public.subtitle":
    "Persönliche Übersicht zu Trainingskosten und Zahlungen.",
  "trainerstunden.public.error": "Fehler",
  "trainerstunden.public.sessions": "Trainings (bestätigt)",
  "trainerstunden.public.sessionsHint":
    "Es werden nur bestätigte Termine berücksichtigt.",
  "trainerstunden.public.total": "Gesamt",
  "trainerstunden.public.emptySessions": "Noch keine bestätigten Trainings.",
  "trainerstunden.public.payments": "Zahlungen",
  "trainerstunden.public.emptyPayments": "Noch keine Zahlungen erfasst.",
  "trainerstunden.publicPayment.methodCardTitle": "Zahlungsmöglichkeit",
  "trainerstunden.publicPayment.methodCardHint":
    "Bitte nutze nur die hier angezeigten Angaben zur Zahlung.",
  "trainerstunden.publicPayment.paypalCta": "Mit PayPal bezahlen",
  "trainerstunden.publicPayment.bankCopyIbanHint":
    "IBAN-Endziffern und Kontoinhaber prüfen; vollständige IBAN ggf. per Verein/Trainer.",
  "trainerstunden.publicPayment.bankCopyBic": "BIC kopieren",
  "trainerstunden.publicPayment.cashAck": "Barzahlung vereinbart / bestätigt",
  "trainerstunden.col.name": "Spieler",
  "trainerstunden.kpi.hours": "Stunden",
  "trainerstunden.kpi.due": "Fällig",
  "trainerstunden.kpi.paid": "Bezahlt",
  "trainerstunden.kpi.open": "Offen",
  "trainerstunden.kpi.lastPayment": "Letzte Zahlung",
  "trainerstunden.kpi.credit": "Guthaben",
  "trainerstunden.report.hint":
    "Monatsübersicht für Eltern-/Spielerabrechnung: bestätigte Trainings, Kostenanteile und Zahlungen pro Person – gruppiert nach Trainer. Trainerabrechnung (Honorar an Trainer) ist ein eigener Tab.",
  "trainerstunden.report.empty":
    "Noch keine bestätigten Stunden mit Buchungsdaten.",
  "trainerstunden.report.loading": "Lade Daten…",
  "trainerstunden.report.billingRules": "Abrechnung (laut Stammdaten Trainer)",
  "trainerstunden.report.billingUnassignedNote":
    "Kein Trainer zugeordnet – hier keine Abrechnungsregeln.",
  "trainerstunden.report.trainerUnassigned": "Ohne zugewiesenen Trainer",
  "trainerstunden.report.trainerUnknown": "Trainer (nicht in Stammdaten): {id}",
  "trainerstunden.report.trainerHonorar":
    "Honorar (bestätigte Stunden, Zeitraum)",
  "trainerstunden.report.trainerHonorarHint":
    "Summe der Terminpreise (Fix oder Stundensatz × Dauer) aller in dieser Gruppe bestätigten Stunden. Auszahlungen an Trainer werden hier nicht abgezogen.",
  "trainerstunden.report.emptySection":
    "In diesem Zeitraum keine Einträge für diesen Trainer.",
  "trainerstunden.report.hoursUnit": "h",
  "trainerstunden.report.subtitleShort":
    "Offene Leistungen bündeln, Entwürfe prüfen, Rechnungen versenden und Zahlungseingänge nachverfolgen.",
  "trainerstunden.report.periodMonth": "Monat",
  "trainerstunden.report.filterToolbarAria":
    "Abrechnungszeitraum und Schnellzugriffe",
  "trainerstunden.report.monthPrevAria": "Vorheriger Abrechnungsmonat",
  "trainerstunden.report.monthNextAria": "Nächster Abrechnungsmonat",
  "trainerstunden.report.monthEndHint":
    "Ab dem 28. eines Monats kannst du die Kostenübersicht per Mail oder WhatsApp an den Rechnungsempfänger senden und den Versand hier protokollieren.",
  "trainerstunden.report.correctionColumn": "Korrektur (Min.)",
  "trainerstunden.report.correctionSave": "Übernehmen",
  "trainerstunden.report.correctionMinutesAria":
    "Stundenkorrektur in Minuten für diesen Monat",
  "trainerstunden.report.correctionFailed":
    "Korrektur konnte nicht gespeichert werden.",
  "trainerstunden.report.dispatchColumn": "Letzte Übersicht",
  "trainerstunden.report.actionsColumn": "Übersicht senden",
  "trainerstunden.report.dispatchNever": "Noch nicht protokolliert",
  "trainerstunden.report.openEmail": "E‑Mail öffnen",
  "trainerstunden.report.openWhatsapp": "WhatsApp‑Nachricht öffnen",
  "trainerstunden.report.logDispatchEmail": "Versand protokollieren (E‑Mail)",
  "trainerstunden.report.logDispatchWhatsapp":
    "Versand protokollieren (WhatsApp)",
  "trainerstunden.report.dispatchSplitHint":
    "1) Nachricht öffnen und im eigenen Programm versenden. 2) Danach hier den Versand protokollieren – dann erscheint die Übersicht im Tab „Zahlungsverbuchung“ und im Hub („Offen seit Versand“).",
  "trainerstunden.report.how.title": "Wie funktioniert das?",
  "trainerstunden.billingCorrection.lockedNotice":
    "Für dieses Training wurde bereits eine Rechnung verschickt oder beglichen. Änderungen in der Trainingsbestätigung sind deshalb nicht mehr möglich — bitte die Rechnung stornieren und neu abrechnen.",
  "trainerstunden.billingCorrection.reviewCorrection": "Zur Rechnung",
  "trainerstunden.billingCorrection.reviewCorrectionAria":
    "Zur Rechnungsübersicht wechseln, um die Rechnung zu stornieren",
  "trainerstunden.billingCorrection.blockedSave":
    "Diese Änderung können wir nicht speichern, weil es dazu schon eine verschickte oder beglichene Rechnung gibt. Bitte storniere die Rechnung zuerst unter Rechnungen.",
  "trainerstunden.billingCorrection.resetBlockedHint":
    "Die Bestätigung kann nicht zurückgenommen werden, solange eine verschickte oder beglichene Rechnung zu diesem Training existiert. Storniere die Rechnung zuerst unter Rechnungen.",
  "trainerstunden.billingCorrection.reviewPanelAria":
    "Korrektur prüfen: Übersicht ohne Änderung an Rechnungen",
  "trainerstunden.billingCorrection.reviewTitle": "Korrektur prüfen",
  "trainerstunden.billingCorrection.reviewLead":
    "Hier siehst du das Training und die zugehörigen Rechnungen. Es werden keine Rechnungsdaten geändert und es entstehen keine Korrekturbuchungen.",
  "trainerstunden.billingCorrection.sessionSectionTitle":
    "Betroffenes Training",
  "trainerstunden.billingCorrection.sessionDate": "Datum",
  "trainerstunden.billingCorrection.sessionTime": "Uhrzeit",
  "trainerstunden.billingCorrection.sessionType": "Trainingstyp",
  "trainerstunden.billingCorrection.sessionPlanned": "Geplant",
  "trainerstunden.billingCorrection.sessionPresent": "Anwesend",
  "trainerstunden.billingCorrection.sessionBillingBasis": "Abrechnungsbasis",
  "trainerstunden.billingCorrection.sessionBilledNotice":
    "Dieses Training wurde bereits abgerechnet.",
  "trainerstunden.billingCorrection.statementsSectionTitle":
    "Betroffene Rechnungen",
  "trainerstunden.billingCorrection.statementTotal":
    "Gesamtbetrag der Rechnung: {amount} €",
  "trainerstunden.billingCorrection.statementSent": "Versand: {date}",
  "trainerstunden.billingCorrection.statementNotSent": "Noch nicht versandt",
  "trainerstunden.billingCorrection.sessionLinesSum":
    "Summe der Leistungen aus diesem Training auf dieser Rechnung: {amount} €",
  "trainerstunden.billingCorrection.noSessionLines":
    "Keine zugehörigen Leistungen zu diesem Training in dieser Rechnung gefunden.",
  "trainerstunden.billingCorrection.noAutoChangeHint":
    "Bereits verschickte Rechnungen werden nicht automatisch geändert. Bitte prüfe die Auswirkungen, bevor eine Rechnungskorrektur erstellt wird.",
  "trainerstunden.billingCorrection.futureSectionTitle": "Geplante Korrektur",
  "trainerstunden.billingCorrection.futureSectionBody":
    "Im nächsten Schritt kannst du hier eine Änderung vormerken und die finanziellen Auswirkungen prüfen.",
  "trainerstunden.billingCorrection.actionsAria":
    "Aktionen zur Korrekturprüfung",
  "trainerstunden.billingCorrection.goToExecution": "Zur Trainingsbestätigung",
  "trainerstunden.billingCorrection.showInvoices": "Rechnungen anzeigen",
  "trainerstunden.billingCorrection.startCorrection":
    "Nächster Schritt: Korrektur buchen",
  "trainerstunden.billingCorrection.startCorrectionHint":
    "Noch nicht verfügbar. Hier passiert keine Buchung — eine echte Korrektur würde später separat erfolgen.",
  "trainerstunden.billingCorrection.sessionNotFound":
    "Das Training konnte nicht geladen werden oder existiert nicht mehr.",
  "trainerstunden.billingCorrection.sessionNotLockedHint":
    "Für dieses Training sind keine verschickten oder bezahlten Rechnungen betroffen. Du kannst Änderungen weiterhin direkt in der Trainingsbestätigung oder Planung vornehmen.",
  "trainerstunden.billingCorrection.simulationAria":
    "Korrektur prüfen: Auswirkung auf die Abrechnung",
  "trainerstunden.billingCorrection.simulationBadge": "Vorschau",
  "trainerstunden.billingCorrection.simulationStatusNotSaved":
    "Nur Vorschau – es wird noch nichts gespeichert.",
  "trainerstunden.billingCorrection.simulationStatusInvoiceUnchanged":
    "Die Originalrechnung bleibt unverändert.",
  "trainerstunden.billingCorrection.simulationTitle": "Änderung prüfen",
  "trainerstunden.billingCorrection.simulationHint":
    "Passe unten die Annahmen an (Teilnehmer, Dauer, Preis). Du siehst sofort die Auswirkung auf die Abrechnung.",
  "trainerstunden.billingCorrection.noMutationHint":
    "Es werden keine Rechnungen, Leistungszeilen oder Trainingsdaten geändert.",
  "trainerstunden.billingCorrection.simulationToggleShow":
    "Korrektur prüfen und Entwurf anlegen",
  "trainerstunden.billingCorrection.simulationToggleHide": "Bereich schließen",
  "trainerstunden.billingCorrection.simulationSplitAria": "Abrechnungsbasis",
  "trainerstunden.billingCorrection.simulationSplitPlanned": "Geplant",
  "trainerstunden.billingCorrection.simulationSplitPresent": "Anwesend",
  "trainerstunden.billingCorrection.simulationPricingAria": "Preismodell",
  "trainerstunden.billingCorrection.simulationPricingHourly": "Stundenweise",
  "trainerstunden.billingCorrection.simulationPricingFixed": "Festbetrag",
  "trainerstunden.billingCorrection.simulationDurationLabel": "Dauer (Min.)",
  "trainerstunden.billingCorrection.simulationRateLabel": "Stundensatz (€)",
  "trainerstunden.billingCorrection.simulationFixedLabel":
    "Festbetrag gesamt (€)",
  "trainerstunden.billingCorrection.simulationParticipantsAria":
    "Teilnehmer für die Vorschau",
  "trainerstunden.billingCorrection.simulationResultsTitle": "Ergebnis",
  "trainerstunden.billingCorrection.simulationDetailTitle":
    "Pro Rechnung im Detail",
  "trainerstunden.billingCorrection.simulationSummaryTitle": "Kurzüberblick",
  "trainerstunden.billingCorrection.simulationSummaryStatementCount":
    "{count} betroffene Rechnungen",
  "trainerstunden.billingCorrection.simulationSummarySumBilled":
    "Ursprünglich berechnet (nur diese Session)",
  "trainerstunden.billingCorrection.simulationSummarySumSimulated":
    "Neu berechnet (nur diese Session)",
  "trainerstunden.billingCorrection.simulationSummaryTotalDelta":
    "Differenz (nur diese Session)",
  "trainerstunden.billingCorrection.simulationGroupHint":
    "Bei Gruppentrainings kann eine Änderung auch andere Rechnungen beeinflussen — prüfe alle Zeilen unten.",
  "trainerstunden.billingCorrection.simulationDeltaSemantics":
    "Die Beträge sind eine Vorschau. Es entsteht keine automatische Gutschrift oder Nachforderung, bis du speicherst und buchst.",
  "trainerstunden.billingCorrection.simulationResultsEmpty":
    "Keine zugehörigen Leistungen für dieses Training gefunden.",
  "trainerstunden.billingCorrection.oldAmount":
    "Ursprünglich berechnet (Session)",
  "trainerstunden.billingCorrection.simulatedAmount": "Neu berechnet (Session)",
  "trainerstunden.billingCorrection.delta": "Differenz (Session)",
  "trainerstunden.billingCorrection.reducesBy": "Würde um {amount} € sinken",
  "trainerstunden.billingCorrection.increasesBy": "Würde um {amount} € steigen",
  "trainerstunden.billingCorrection.noChange": "Keine Änderung",
  "trainerstunden.billingCorrection.simulationWarning.noPayers":
    "Es sind keine Zahler:innen ausgewählt — in der Vorschau ergeben sich daher 0 €.",
  "trainerstunden.billingCorrection.simulationWarning.grossMismatch":
    "Hinweis: Summe der simulierten Anteile weicht vom Brutto ab (Rundung oder Eingaben prüfen).",
  "trainerstunden.billingCorrection.draftPrepareButton":
    "Korrekturentwurf vorbereiten",
  "trainerstunden.billingCorrection.draftSectionTitle": "Korrekturentwurf",
  "trainerstunden.billingCorrection.draftReasonLabel": "Grund der Korrektur",
  "trainerstunden.billingCorrection.draftReasonPlaceholder": "Bitte auswählen",
  "trainerstunden.billingCorrection.draftReasonParticipants":
    "Teilnehmer falsch",
  "trainerstunden.billingCorrection.draftReasonAttendance":
    "Anwesenheit falsch",
  "trainerstunden.billingCorrection.draftReasonDuration": "Dauer falsch",
  "trainerstunden.billingCorrection.draftReasonPrice": "Preis falsch",
  "trainerstunden.billingCorrection.draftReasonOther": "Sonstiges",
  "trainerstunden.billingCorrection.draftNoteLabel": "Notiz (optional)",
  "trainerstunden.billingCorrection.draftNotePlaceholder":
    "Kurz festhalten, was angepasst werden soll …",
  "trainerstunden.billingCorrection.draftSummaryIntro":
    "Überblick aus der Vorschau",
  "trainerstunden.billingCorrection.draftRecipientsTitle": "Pro Empfänger",
  "trainerstunden.billingCorrection.draftReviewButton": "Korrektur prüfen",
  "trainerstunden.billingCorrection.draftReviewReady":
    "Korrektur geprüft – du kannst den Korrekturentwurf speichern.",
  "trainerstunden.billingCorrection.draftBookDisabled":
    "Buchen folgt im nächsten Schritt",
  "trainerstunden.billingCorrection.draftBookDisabledHint":
    "Echte Buchung und Speicherung sind hier noch nicht möglich.",
  "trainerstunden.billingCorrection.draftSimulationChanged":
    "Die Vorschau hat sich geändert. Bitte den Korrekturentwurf erneut prüfen.",
  "trainerstunden.billingCorrection.draftWarningLocal":
    "Bis zum Speichern bleibt der Korrekturentwurf nur in diesem Formular. Mit „Korrekturentwurf speichern“ wird er abgelegt, ohne die Originalrechnung zu ändern und ohne Buchung.",
  "trainerstunden.billingCorrection.persistListTitle":
    "Korrekturen zu diesem Training",
  "trainerstunden.billingCorrection.persistListLoading": "Lade Entwürfe …",
  "trainerstunden.billingCorrection.persistListEmpty":
    "Noch kein gespeicherter Korrektur-Entwurf für diese Session.",
  "trainerstunden.billingCorrection.persistListAria":
    "Liste gespeicherter Korrektur-Entwürfe",
  "trainerstunden.billingCorrection.correctionStatus.draft": "Entwurf",
  "trainerstunden.billingCorrection.correctionStatus.confirmed": "Bestätigt",
  "trainerstunden.billingCorrection.correctionStatus.cancelled": "Storniert",
  "trainerstunden.billingCorrection.correctionStatus.booked": "Gebucht",
  "trainerstunden.billingCorrection.correctionStatus.reversed":
    "Storniert (Gegenbuchung)",
  "trainerstunden.billingCorrection.correctionStatus.reversedUi":
    "Korrektur storniert",
  "trainerstunden.billingCorrection.monthSectionAria": "Korrekturen im Monat",
  "trainerstunden.billingCorrection.monthSectionTitle": "Korrekturen",
  "trainerstunden.billingCorrection.monthSectionLead": "Monat: {period}",
  "trainerstunden.billingCorrection.monthLoading":
    "Korrekturen werden geladen …",
  "trainerstunden.billingCorrection.monthEmpty":
    "Keine Korrekturen. Wenn eine bereits versendete Rechnung geändert werden muss, erscheinen Korrekturen hier.",
  "trainerstunden.billingCorrection.monthGroup.draft": "Entwurf",
  "trainerstunden.billingCorrection.monthGroup.confirmed": "Bestätigt",
  "trainerstunden.billingCorrection.monthGroup.booked": "Gebucht",
  "trainerstunden.billingCorrection.monthGroup.cancelled": "Storniert",
  "trainerstunden.billingCorrection.monthCardSessionLine":
    "{date} · {training}",
  "trainerstunden.billingCorrection.monthOpenReview": "Korrektur prüfen",
  "trainerstunden.billingCorrection.monthShowLines": "Leistungen anzeigen",
  "trainerstunden.billingCorrection.monthHideLines": "Leistungen ausblenden",
  "trainerstunden.billingCorrection.monthLinesAria": "Korrekturpositionen",
  "trainerstunden.billingCorrection.immutabilityExplain":
    "Bereits versendete Rechnungen werden nicht verändert. Die Korrektur dokumentiert die Änderung nachvollziehbar.",
  "trainerstunden.billingCorrection.error.duplicateActiveDraft":
    "Für diese Änderung gibt es bereits einen offenen Korrekturentwurf.",
  "trainerstunden.billingCorrection.error.scopeMismatch":
    "Diese Korrektur betrifft mehrere Rechnungen. Bitte einzeln korrigieren.",
  "trainerstunden.billingCorrection.error.noRelevantChange":
    "Es gibt keine abrechnungsrelevante Änderung.",
  "trainerstunden.billingCorrection.error.draftWrongStatusOrMissing":
    "Diese Korrektur wurde nicht gefunden oder ist nicht mehr im passenden Status.",
  "trainerstunden.billingCorrection.error.bookWrongStatus":
    "Diese Korrektur kann in diesem Status nicht gebucht werden.",
  "trainerstunden.billingCorrection.error.missingTargetStatement":
    "Die Zielrechnung konnte nicht gefunden werden.",
  "trainerstunden.billingCorrection.error.forbidden":
    "Du hast keine Berechtigung für diese Korrektur.",
  "trainerstunden.billingCorrection.reasonChanged.participant":
    "Teilnehmer geändert",
  "trainerstunden.billingCorrection.reasonChanged.attendance":
    "Anwesenheit geändert",
  "trainerstunden.billingCorrection.reasonChanged.duration": "Dauer geändert",
  "trainerstunden.billingCorrection.reasonChanged.price": "Preis geändert",
  "trainerstunden.billingCorrection.reasonChanged.other": "Sonstiges",
  "trainerstunden.billingCorrection.diffKind.nachberechnung": "Nachberechnung",
  "trainerstunden.billingCorrection.diffKind.gutschrift": "Gutschrift / Abzug",
  "trainerstunden.billingCorrection.diffKind.none": "Keine Änderung",
  "trainerstunden.billingCorrection.amountOriginalShort":
    "Ursprünglich berechnet",
  "trainerstunden.billingCorrection.amountNewShort": "Neu berechnet",
  "trainerstunden.billingCorrection.amountDiffShort": "Differenz",
  "trainerstunden.billingCorrection.persistNewTotal": "Neu berechnet (Summe)",
  "trainerstunden.billingCorrection.nextStep.draft":
    "Nächster Schritt: Änderung bestätigen.",
  "trainerstunden.billingCorrection.nextStep.confirmed":
    "Nächster Schritt: Korrektur buchen.",
  "trainerstunden.billingCorrection.nextStep.booked": "Bereits gebucht.",
  "trainerstunden.billingCorrection.nextStep.cancelled": "Korrektur storniert.",
  "trainerstunden.billingCorrection.workflowStepsAria":
    "Ablauf Rechnungskorrektur",
  "trainerstunden.billingCorrection.workflowStep1": "Änderung prüfen",
  "trainerstunden.billingCorrection.workflowStep2":
    "Korrekturentwurf speichern",
  "trainerstunden.billingCorrection.workflowStep3": "Änderung bestätigen",
  "trainerstunden.billingCorrection.workflowStep4": "Korrektur buchen",
  "trainerstunden.billingCorrection.reviewWorkflowToggleShow":
    "Korrektur prüfen und Entwurf anlegen",
  "trainerstunden.billingCorrection.reviewWorkflowToggleHide":
    "Bereich schließen",
  "trainerstunden.billingCorrection.persistCreatedAt": "Erstellt: {date}",
  "trainerstunden.billingCorrection.persistLineCount": "{count} Leistungen",
  "trainerstunden.billingCorrection.persistOldTotal": "Ursprünglich berechnet",
  "trainerstunden.billingCorrection.persistDelta": "Differenz",
  "trainerstunden.billingCorrection.persistSaveDraft":
    "Korrekturentwurf speichern",
  "trainerstunden.billingCorrection.persistSaveBusy": "Speichern …",
  "trainerstunden.billingCorrection.persistConfirm": "Änderung bestätigen",
  "trainerstunden.billingCorrection.persistCancel": "Stornieren",
  "trainerstunden.billingCorrection.persistMutateBusy": "Bitte warten …",
  "trainerstunden.billingCorrection.draftPersistSuccess":
    "Korrekturentwurf wurde gespeichert.",
  "trainerstunden.billingCorrection.persistMutationSuccess":
    "Änderung übernommen.",
  "trainerstunden.billingCorrection.draftPersistErrorDuplicate":
    "Für dieses Training und dieselbe Änderungsvorschau gibt es bereits einen aktiven Korrekturentwurf oder eine bestätigte Korrektur. Bitte den bestehenden Eintrag stornieren oder die Vorschau anpassen.",
  "trainerstunden.billingCorrection.draftPersistErrorWrongStatus":
    "Die Aktion ist nicht mehr möglich (Entwurf nicht gefunden oder Status geändert). Bitte Liste aktualisieren.",
  "trainerstunden.billingCorrection.draftPersistErrorForbidden":
    "Keine Berechtigung für diese Aktion. Bitte erneut anmelden oder Zugriff prüfen.",
  "trainerstunden.billingCorrection.draftPersistErrorDb":
    "Serverfehler beim Speichern. Bitte später erneut versuchen.",
  "trainerstunden.billingCorrection.draftPersistErrorReferential":
    "Datenbankbezug ungültig (z. B. fehlende Rechnungsposition). Bitte Seite neu laden.",
  "trainerstunden.billingCorrection.draftPersistErrorValidation":
    "Eingaben unvollständig oder Daten passen nicht zur Session. Bitte prüfen.",
  "trainerstunden.billingCorrection.draftPersistErrorNoSupabase":
    "Speichern nicht möglich: keine Verbindung.",
  "trainerstunden.billingCorrection.draftPersistErrorGeneric":
    "Die Aktion ist fehlgeschlagen. Bitte erneut versuchen.",
  "trainerstunden.billingCorrection.persistFeedbackDismiss":
    "Hinweis ausblenden",
  "trainerstunden.billingCorrection.persistBookAction": "Korrektur buchen",
  "trainerstunden.billingCorrection.persistBookBusy": "Buchung läuft …",
  "trainerstunden.billingCorrection.persistBookSuccess":
    "Korrektur wurde gebucht.",
  "trainerstunden.billingCorrection.persistBookedAt": "Gebucht am: {date}",
  "trainerstunden.billingCorrection.persistBookedBy":
    "Gebucht von (Nutzer): {userRef}",
  "trainerstunden.billingCorrection.persistBookErrorUnauthenticated":
    "Bitte erneut anmelden.",
  "trainerstunden.billingCorrection.persistBookErrorForbidden":
    "Du darfst diese Korrektur nicht buchen.",
  "trainerstunden.billingCorrection.persistBookErrorWrongStatus":
    "Diese Korrektur kann in diesem Status nicht gebucht werden.",
  "trainerstunden.billingCorrection.persistBookErrorNoItems":
    "Diese Korrektur enthält keine Leistungen.",
  "trainerstunden.billingCorrection.persistBookErrorMissingTarget":
    "Die Zielrechnung konnte nicht gefunden werden.",
  "trainerstunden.billingCorrection.persistBookErrorMissingId":
    "Interner Fehler: Korrektur-ID fehlt.",
  "trainerstunden.billingCorrection.persistBookErrorNoSupabase":
    "Datenbankverbindung nicht verfügbar.",
  "trainerstunden.billingCorrection.persistBookErrorDb":
    "Die Buchung konnte technisch nicht abgeschlossen werden.",
  "trainerstunden.billingCorrection.persistBookErrorNotFound":
    "Korrektur wurde nicht gefunden.",
  "trainerstunden.billing.corrections.persistReverseAction":
    "Buchung stornieren",
  "trainerstunden.billing.corrections.persistReverseBusy": "Storno läuft …",
  "trainerstunden.billing.corrections.persistReverseSuccess":
    "Storno wurde gebucht ({count} Ausgleichsschritte).",
  "trainerstunden.billing.corrections.persistReversedAt":
    "Storniert am: {date}",
  "trainerstunden.billing.corrections.persistReversedBy":
    "Storniert von (Nutzer): {userRef}",
  "trainerstunden.billing.corrections.persistReverseErrorUnauthenticated":
    "Bitte erneut anmelden.",
  "trainerstunden.billing.corrections.persistReverseErrorNotFound":
    "Korrektur wurde nicht gefunden.",
  "trainerstunden.billing.corrections.persistReverseErrorForbidden":
    "Du darfst diese Korrektur nicht stornieren.",
  "trainerstunden.billing.corrections.persistReverseErrorWrongStatus":
    "Diese Korrektur kann in diesem Status nicht storniert werden.",
  "trainerstunden.billing.corrections.persistReverseErrorNoPostings":
    "Für diese Korrektur wurden keine buchbaren Ausgleichsschritte gefunden.",
  "trainerstunden.billing.corrections.persistReverseErrorMissingId":
    "Interner Fehler: Korrektur-ID fehlt.",
  "trainerstunden.billing.corrections.persistReverseErrorNoSupabase":
    "Datenbankverbindung nicht verfügbar.",
  "trainerstunden.billing.corrections.persistReverseErrorDb":
    "Das Storno konnte technisch nicht abgeschlossen werden.",
  "trainerstunden.billing.scope.filterLabel": "Zeitraum",
  "trainerstunden.billing.scope.filterAria":
    "Zeitraum für die Abrechnungsübersicht",
  "trainerstunden.billing.scope.effective": "Gesamt",
  "trainerstunden.billing.scope.month": "Monat",
  "trainerstunden.billing.scope.quarter": "Quartal",
  "trainerstunden.billing.scope.year": "Jahr",
  "trainerstunden.billing.scope.bandHintMonth":
    "Nur Abrechnungsmonat {period}.",
  "trainerstunden.billing.scope.bandHintEffective":
    "Gewählter Monat plus alle noch offenen Punkte aus früheren Monaten (ohne Zukunft).",
  "trainerstunden.billing.scope.bandHintQuarter":
    "Kalenderquartal {from} bis {to}.",
  "trainerstunden.billing.scope.bandHintYear": "Kalenderjahr {year}.",
  "trainerstunden.billing.invoicing.filter.toolbarAria": "Abrechnungsfilter",
  "trainerstunden.billing.invoicing.filter.recipientLabel":
    "Spieler / Rechnungsempfänger",
  "trainerstunden.billing.invoicing.filter.recipientClear":
    "Filter zurücksetzen",
  "trainerstunden.billing.invoicing.filter.recipientActive":
    "Gefiltert nach {name}",
  "trainerstunden.billing.carryover.sinceMonth": "Seit {period} offen",
  "trainerstunden.billing.carryover.includesBacklogShort":
    "inkl. frühere Monate",
  "trainerstunden.billing.overview.metrics.aria":
    "Monatskennzahlen zur Abrechnung",
  "trainerstunden.billing.overview.metrics.invoiced": "Versendet",
  "trainerstunden.billing.overview.metrics.drafts": "Entwürfe (gebündelt)",
  "trainerstunden.billing.overview.metrics.unbundled": "Noch nicht gebündelt",
  "trainerstunden.billing.overview.metrics.total": "Monat gesamt",
  "trainerstunden.billing.overview.metrics.scopeTotal": "Offen gesamt",
  "trainerstunden.billing.overview.metrics.anchorMonthOnly": "Nur Ankermonat",
  "trainerstunden.billing.overview.metrics.includeBacklogKicker":
    "inkl. Rückstände",
  "trainerstunden.billing.workQueue.aria": "Abrechnungs-Arbeitsstapel",
  "trainerstunden.billing.workQueue.title": "Arbeitsstapel",
  "trainerstunden.billing.workQueue.lead":
    "Bestätigte Trainingsanteile bündeln, Entwürfe prüfen und versenden. Versendete Rechnungen findest du in der Rechnungsübersicht.",
  "trainerstunden.billing.pipeline.lead":
    "Von der bestätigten Leistung bis zum Versand in einer Liste — Entwürfe prüfen, versenden und versendete Rechnungen nachverfolgen.",
  "trainerstunden.billing.pipeline.hint":
    "Der Monatsfilter oben gilt für die gesamte Pipeline. Versendete Rechnungen erscheinen am Ende der Empfängerliste.",
  "trainerstunden.billing.pipeline.unbundledAlongDraft": {
    one: "Zusätzlich {count} noch nicht gebündelte Leistung ({amount} €)",
    other: "Zusätzlich {count} noch nicht gebündelte Leistungen ({amount} €)",
  },
  "trainerstunden.billing.draftConsolidate.sectionAria":
    "Leistungen im Entwurf und noch offene Leistungen",
  "trainerstunden.billing.draftConsolidate.openTitle": "Noch nicht gebündelt",
  "trainerstunden.billing.draftConsolidate.openHint":
    "Diese bestätigten Trainings kannst du vor dem Versand noch in den Entwurf übernehmen.",
  "trainerstunden.billing.draftConsolidate.openHintWithEdit":
    "Wähle die offenen Leistungen aus, die in diesen Entwurf übernommen werden sollen.",
  "trainerstunden.billing.draftConsolidate.openLinesAria":
    "Noch nicht gebündelte Leistungen",
  "trainerstunden.billing.draftConsolidate.footerSummary": {
    one: "{count} Leistung · {amount} €",
    other: "{count} Leistungen · {amount} €",
  },
  "trainerstunden.billing.draftConsolidate.cta": "In Rechnung übernehmen",
  "trainerstunden.billing.draftConsolidate.busy": "Wird übernommen …",
  "trainerstunden.billing.draftConsolidate.errorNotDraft":
    "Der Entwurf kann nicht mehr ergänzt werden.",
  "trainerstunden.billing.draftRevert.lineAction": "Aus Entwurf entfernen",
  "trainerstunden.billing.draftRevert.lineActionAria":
    "Leistung vom {date} ({person}) aus dem Entwurf entfernen",
  "trainerstunden.billing.draftRevert.confirmTitle":
    "Leistung aus Entwurf entfernen?",
  "trainerstunden.billing.draftRevert.confirmText":
    "Die Position wird aus dem Entwurf entfernt und steht wieder als offene Leistung zur Verfügung. Wenn der Entwurf dadurch leer wird, wird er gelöscht.",
  "trainerstunden.billing.draftRevert.confirmCta": "Entfernen",
  "trainerstunden.billing.draftRevert.cancel": "Abbrechen",
  "trainerstunden.billing.draftRevert.busy": "Wird entfernt …",
  "trainerstunden.billing.draftRevert.successOne":
    "Leistung wurde aus dem Entwurf entfernt.",
  "trainerstunden.billing.draftRevert.successAndDeleted":
    "Letzte Leistung entfernt – leerer Entwurf wurde gelöscht.",
  "trainerstunden.billing.draftRevert.errorNotDraft":
    "Der Entwurf kann nicht mehr verändert werden.",
  "trainerstunden.billing.draftRevert.errorGeneric":
    "Die Leistung konnte nicht entfernt werden.",
  "trainerstunden.billing.archive.title": "Rechnungsarchiv",
  "trainerstunden.billing.archive.subtitle":
    "Versendete und abgeschlossene Rechnungen mit Rechnungsdatum im Monat {period}",
  "trainerstunden.billing.archive.subtitleAll":
    "Alle erstellten Rechnungen nach Rechnungsmonat – versendet, bezahlt, storniert und gespeicherte Entwürfe.",
  "trainerstunden.billing.archive.viewSwitchAria": "Rechnungsarchiv-Ansicht",
  "trainerstunden.billing.archive.all": "Alle",
  "trainerstunden.billing.archive.sent": "Versandt",
  "trainerstunden.billing.archive.closed": "Abgeschlossen",
  "trainerstunden.billing.archive.cancelled": "Storniert",
  "trainerstunden.billing.archive.drafts": "Entwürfe",
  "trainerstunden.billing.finance.kpi.aria": "Kennzahlen Abrechnungsmonat",
  "trainerstunden.billing.finance.kpi.monthTotal": "Monatsgesamt",
  "trainerstunden.billing.finance.kpi.monthTotalCaption":
    "Gesamtvolumen im {period}",
  "trainerstunden.billing.finance.kpi.sent": "Versendet",
  "trainerstunden.billing.finance.kpi.draftsBundled": "Entwürfe (gebündelt)",
  "trainerstunden.billing.finance.kpi.unbundled": "Noch nicht gebündelt",
  "trainerstunden.billing.finance.kpi.recipientsTotal": "Empfänger gesamt",
  "trainerstunden.billing.finance.kpi.invoiceCount": {
    one: "{count} Rechnung",
    other: "{count} Rechnungen",
  },
  "trainerstunden.billing.finance.kpi.lineCount": {
    one: "{count} Leistung",
    other: "{count} Leistungen",
  },
  "trainerstunden.billing.finance.kpi.recipientMeta": {
    one: "{count} Empfänger",
    other: "{count} Empfänger",
  },
  "trainerstunden.billing.finance.recipientTable.nameColumn": "Name",
  "trainerstunden.billing.finance.recipientTable.customerColumn": "Kunde",
  "trainerstunden.billing.finance.customerGroup.countAmount": {
    one: "{count} Rechnung · {amount} €",
    other: "{count} Rechnungen · {amount} €",
  },
  "trainerstunden.billing.finance.customerGroup.openPaid":
    "{open} offen · {paid} bezahlt",
  "trainerstunden.billing.finance.customerGroup.pagination.range":
    "{from}–{to} von {total} Kunden",
  "trainerstunden.billing.finance.recipientTable.invoiceColumn": "Rechnung",
  "trainerstunden.billing.finance.recipientTable.amountColumn": "Betrag",
  "trainerstunden.billing.finance.recipientTable.draftsColumn": "Entwürfe",
  "trainerstunden.billing.finance.recipientTable.linesColumn": "Leistungen",
  "trainerstunden.billing.finance.recipientTable.invoicesColumn": "Rechnungen",
  "trainerstunden.billing.finance.recipientTable.monthColumn": "Monat",
  "trainerstunden.billing.finance.recipientTable.dateColumn": "Datum",
  "trainerstunden.billing.finance.recipientTable.monthMultiple": {
    one: "{count} Monat",
    other: "{count} Monate",
  },
  "trainerstunden.billing.finance.recipientTable.statusColumn": "Status",
  "trainerstunden.billing.finance.recipientTable.statusPaid": "Bezahlt",
  "trainerstunden.billing.finance.recipientTable.statusUnpaid": "Unbezahlt",
  "trainerstunden.billing.finance.recipientTable.statusOpenFraction":
    "{open} von {total} offen",
  "trainerstunden.billing.finance.recipientTable.statusPartialUnpaid": {
    one: "{count} unbezahlt",
    other: "{count} unbezahlt",
  },
  "trainerstunden.billing.finance.recipientTable.amountOpen":
    "{amount} € offen",
  "trainerstunden.billing.finance.recipientTable.amountTotalHint":
    "gesamt {amount} €",
  "trainerstunden.billing.finance.recipientTable.amountOpenAria":
    "{open} € offen von insgesamt {total} €",
  "trainerstunden.billing.finance.recipientTable.sortByName":
    "Nach Name sortieren",
  "trainerstunden.billing.finance.recipientTable.sortNameAsc":
    "Nach Name sortiert (A–Z)",
  "trainerstunden.billing.finance.recipientTable.sortNameDesc":
    "Nach Name sortiert (Z–A)",
  "trainerstunden.billing.finance.recipientTable.sortByAmount":
    "Nach Betrag sortieren",
  "trainerstunden.billing.finance.recipientTable.sortAmountAsc":
    "Nach Betrag sortiert (aufsteigend)",
  "trainerstunden.billing.finance.recipientTable.sortAmountDesc":
    "Nach Betrag sortiert (absteigend)",
  "trainerstunden.billing.finance.recipientTable.sortByMonth":
    "Nach Monat sortieren",
  "trainerstunden.billing.finance.recipientTable.sortMonthAsc":
    "Nach Monat sortiert (älteste zuerst)",
  "trainerstunden.billing.finance.recipientTable.sortMonthDesc":
    "Nach Monat sortiert (neueste zuerst)",
  "trainerstunden.billing.finance.recipientTable.sortByDate":
    "Nach Rechnungsdatum sortieren",
  "trainerstunden.billing.finance.recipientTable.sortDateAsc":
    "Nach Datum sortiert (älteste zuerst)",
  "trainerstunden.billing.finance.recipientTable.sortDateDesc":
    "Nach Datum sortiert (neueste zuerst)",
  "trainerstunden.billing.finance.recipientTable.sortByStatus":
    "Nach Status sortieren",
  "trainerstunden.billing.finance.recipientTable.sortStatusAsc":
    "Nach Status sortiert (unbezahlt zuerst)",
  "trainerstunden.billing.finance.recipientTable.sortStatusDesc":
    "Nach Status sortiert (bezahlt zuerst)",
  "trainerstunden.billing.finance.recipientTable.actionsColumn": "Aktion",
  "trainerstunden.paymentReceipts.chainMenu.aria": "Rechnungsaktionen",
  "trainerstunden.paymentReceipts.chainMenu.chooseInvoice": "Rechnung wählen",
  "trainerstunden.paymentReceipts.chainMenu.invoicePick":
    "{period} · {amount} € offen",
  "trainerstunden.paymentReceipts.chainMenu.invoiceContext":
    "{period} · {amount} € offen",
  "trainerstunden.paymentReceipts.chainMenu.back": "Andere Rechnung",
  "trainerstunden.billing.finance.pipeline.aria": "Abrechnungs-Pipeline",
  "trainerstunden.billing.finance.pipeline.stage.draft": "Noch offen",
  "trainerstunden.billing.finance.pipeline.stage.openItems": "In Vorbereitung",
  "trainerstunden.billing.finance.pipeline.stage.sendReady": "Vorbereitet",
  "trainerstunden.billing.finance.pipeline.stage.sent": "Versendet",
  "trainerstunden.billing.finance.pipeline.stage.overdue": "Überfällig",
  "trainerstunden.billing.finance.pipeline.stage.paid": "Bezahlt",
  "trainerstunden.billing.finance.pipeline.overdueBadge": "Überfällig",
  "trainerstunden.billing.finance.pipeline.actionRequiredBadge":
    "Handlungsbedarf",
  "trainerstunden.billing.finance.pipeline.sendReadyBadge": "Versandbereit",
  "trainerstunden.billing.finance.pipeline.stageSelectAria":
    "Phase {stage} filtern",
  "trainerstunden.billing.finance.pipeline.filterEmpty.draft":
    "Keine offenen Leistungen ohne Rechnungsentwurf.",
  "trainerstunden.billing.finance.pipeline.filterEmpty.draftOpenDraftsCta":
    "Entwürfe anzeigen",
  "trainerstunden.billing.draftCards.kpi.aria": "Entwürfe nach Status",
  "trainerstunden.billing.draftCards.kpi.all.title": "Entwürfe",
  "trainerstunden.billing.draftCards.kpi.sendable.title": "Versandbereit",
  "trainerstunden.billing.draftCards.kpi.createdToday.title": "Erstellt heute",
  "trainerstunden.billing.draftCards.kpi.stale.title": "Seit mehr als 3 Tagen",
  "trainerstunden.billing.draftCards.kpi.cancelled.title": "Storniert",
  "trainerstunden.billing.draftCards.status.ready": "Versandbereit",
  "trainerstunden.billing.draftCards.status.incomplete": "Unvollständig",
  "trainerstunden.billing.draftCards.status.missingContact": "Kontakt fehlt",
  "trainerstunden.billing.draftCards.status.stale": "Seit 3 Tagen",
  "trainerstunden.billing.draftCards.status.cancelled": "Storniert",
  "trainerstunden.billing.draftCards.invoiceNumber": "Rechnungsnummer",
  "trainerstunden.billing.draftCards.created": "Erstellt",
  "trainerstunden.billing.draftCards.trainer": "Trainer",
  "trainerstunden.billing.draftCards.createdTodayAt": "Heute, {time} Uhr",
  "trainerstunden.billing.draftCards.lineCount": {
    one: "{count} Leistung",
    other: "{count} Leistungen",
  },
  "trainerstunden.billing.draftCards.action.send": "Rechnung versenden",
  "trainerstunden.billing.draftCards.action.preview": "Vorschau",
  "trainerstunden.billing.draftCards.action.edit": "Bearbeiten",
  "trainerstunden.billing.draftCards.action.addContact":
    "Kontaktdaten ergänzen",
  "trainerstunden.billing.draftCards.openContactProfile":
    "Kontaktprofil von {name} öffnen",
  "trainerstunden.billing.draftCards.moreAria": "Weitere Aktionen",
  "trainerstunden.billing.draftCards.showDetails": "Leistungen anzeigen",
  "trainerstunden.billing.draftCards.hideDetails": "Leistungen ausblenden",
  "trainerstunden.billing.draftCards.linesTitle": "Leistungen",
  "trainerstunden.billing.draftCards.linesEmpty":
    "Keine Leistungen hinterlegt.",
  "trainerstunden.billing.draftCards.bulkSend":
    "Alle versandbereiten Rechnungen senden",
  "trainerstunden.billing.draftCards.bulkMeta": "{count} Rechnungen · {amount}",
  "trainerstunden.billing.draftCards.bulkSendConfirm": {
    one: "1 versandbereite Rechnung jetzt per E-Mail senden?",
    other: "{count} versandbereite Rechnungen jetzt per E-Mail senden?",
  },
  "trainerstunden.billing.draftCards.emptyTitle": "Keine Entwürfe vorhanden",
  "trainerstunden.billing.draftCards.emptyBody":
    "Sobald abrechenbare Leistungen vorliegen, erscheinen die Rechnungsentwürfe hier.",
  "trainerstunden.billing.draftCards.filterEmpty":
    "Keine Entwürfe in diesem Filter.",
  "trainerstunden.billing.finance.pipeline.filterEmpty.openItems":
    "Keine offenen Leistungen für die nächste Abrechnung.",
  "trainerstunden.billing.finance.pipeline.filterEmpty.sendReady":
    "Keine vorbereiteten Rechnungen.",
  "trainerstunden.billing.finance.pipeline.filterEmpty.overdue":
    "Keine überfälligen offenen Rechnungen.",
  "trainerstunden.billing.finance.pipeline.filterSentLead":
    "Versendete Rechnungen findest du im Archiv unten.",
  "trainerstunden.billing.finance.section.sendReadyBadge": {
    one: "{count} Versandbereit",
    other: "{count} Versandbereit",
  },
  "trainerstunden.billing.finance.linkInvoiceOverview":
    "Rechnungsübersicht (versendet)",
  "trainerstunden.billing.finance.linkPayments": "Zahlungseingänge",
  "trainerstunden.billing.finance.linkAbrechnen": "Abrechnen",
  "trainerstunden.billing.archive.open": "Offen",
  "trainerstunden.billing.abrechnung.pageTitle": "Abrechnung",
  "trainerstunden.billing.abrechnung.pageSubtitle":
    "Deine Finanzen auf einen Blick.",
  "trainerstunden.billing.audience.tabsAria": "Abrechnungsansicht",
  "trainerstunden.billing.audience.viewLabel": "Ansicht",
  "trainerstunden.billing.audience.customers": "Kundenabrechnung",
  "trainerstunden.billing.audience.trainers": "Trainerabrechnung",
  "trainerstunden.billing.audience.customersShort": "Kunden",
  "trainerstunden.billing.audience.trainersShort": "Trainer",
  "trainerstunden.billing.trainer.pageTitle": "Trainerabrechnung",
  "trainerstunden.billing.trainer.pageSubtitle":
    "Honorare prüfen, Abrechnungen erstellen und Auszahlungen verwalten.",
  "trainerstunden.billing.trainer.sectionTitle": "Trainerabrechnung",
  "trainerstunden.billing.trainer.sectionSubtitle":
    "Honorare prüfen, Abrechnungen erstellen und Auszahlungen verwalten.",
  "trainerstunden.billing.trainer.filter.toolbarAria":
    "Filter Trainerabrechnung",
  "trainerstunden.billing.trainer.filter.searchLabel": "Suche",
  "trainerstunden.billing.trainer.filter.searchPlaceholder":
    "Name, E-Mail, Telefon oder Abrechnungsnummer",
  "trainerstunden.billing.trainer.filter.monthAll": "Ganzes Jahr",
  "trainerstunden.billing.trainer.kpi.aria": "Kennzahlen Trainerabrechnung",
  "trainerstunden.billing.trainer.kpi.open": "Offene Honorare",
  "trainerstunden.billing.trainer.kpi.openMeta":
    "{trainers} Trainer · {sessions} Trainings",
  "trainerstunden.billing.trainer.kpi.payout": "Zur Auszahlung",
  "trainerstunden.billing.trainer.kpi.payoutMeta": "{trainers} Trainer",
  "trainerstunden.billing.trainer.kpi.month": "Diesen Monat ausgezahlt",
  "trainerstunden.billing.trainer.kpi.monthMeta": "{sessions} Auszahlungen",
  "trainerstunden.billing.trainer.kpi.avg": "Durchschnittliche Auszahlung",
  "trainerstunden.billing.trainer.kpi.avgMeta": "pro Auszahlung",
  "trainerstunden.billing.trainer.col.trainer": "Trainer",
  "trainerstunden.billing.trainer.col.open": "Offene Honorare",
  "trainerstunden.billing.trainer.col.period": "Zeitraum",
  "trainerstunden.billing.trainer.col.month": "Diesen Monat abgerechnet",
  "trainerstunden.billing.trainer.col.last": "Letzte Abrechnung",
  "trainerstunden.billing.trainer.col.next": "Nächste Auszahlung",
  "trainerstunden.billing.trainer.col.status": "Status",
  "trainerstunden.billing.trainer.col.actions": "Aktionen",
  "trainerstunden.billing.trainer.sessionsCount": {
    one: "{count} Training",
    other: "{count} Trainings",
  },
  "trainerstunden.billing.trainer.listAria": "Trainerliste",
  "trainerstunden.billing.trainer.paneEmptyTitle":
    "Wähle links einen Trainer aus.",
  "trainerstunden.billing.trainer.paneEmptyBody":
    "Offene Trainings und die Auszahlung erscheinen hier.",
  "trainerstunden.billing.trainer.paneBack": "Zurück zur Trainerliste",
  "trainerstunden.billing.trainer.openSessionsHeading": "Offene Trainings",
  "trainerstunden.billing.trainer.noSessionsTitle":
    "Keine offenen Trainings vorhanden.",
  "trainerstunden.billing.trainer.noSessionsBody":
    "Für diesen Trainer gibt es aktuell nichts auszuzahlen.",
  "trainerstunden.billing.trainer.serviceCustomer": "Kunde: {name}",
  "trainerstunden.billing.trainer.detail.iban": "IBAN",
  "trainerstunden.billing.trainer.detail.paymentMethod": "Zahlungsart",
  "trainerstunden.billing.trainer.payment.paypal": "PayPal",
  "trainerstunden.billing.trainer.payment.bank": "Überweisung",
  "trainerstunden.billing.trainer.payment.missing": "Nicht hinterlegt",
  "trainerstunden.billing.trainer.summarySubtotal": "Zwischensumme",
  "trainerstunden.billing.trainer.summaryDeductions": "Abzüge",
  "trainerstunden.billing.trainer.summaryPayout": "Auszahlungsbetrag",
  "trainerstunden.billing.trainer.action.createPayout": "Auszahlung erstellen",
  "trainerstunden.billing.trainer.action.createBusy": "Wird erstellt…",
  "trainerstunden.billing.trainer.action.preview": "Vorschau",
  "trainerstunden.billing.trainer.previewAlert":
    "Vorschau für {name}: {count} Trainings · {amount}",
  "trainerstunden.billing.trainer.status.ready": "Bereit zur Abrechnung",
  "trainerstunden.billing.trainer.status.created": "Abrechnung erstellt",
  "trainerstunden.billing.trainer.status.payout": "Zur Auszahlung",
  "trainerstunden.billing.trainer.status.paid": "Ausgezahlt",
  "trainerstunden.billing.trainer.status.blocked": "Auszahlung blockiert",
  "trainerstunden.billing.trainer.status.noPayment": "Zahlungsart fehlt",
  "trainerstunden.billing.trainer.status.none": "Keine offenen Honorare",
  "trainerstunden.billing.trainer.action.create": "Abrechnung erstellen",
  "trainerstunden.billing.trainer.action.details": "Details anzeigen",
  "trainerstunden.billing.trainer.action.payment": "Zahlungsart hinterlegen",
  "trainerstunden.billing.trainer.action.payout": "Auszahlung erfassen",
  "trainerstunden.billing.trainer.action.view": "Abrechnung anzeigen",
  "trainerstunden.billing.trainer.empty.title": "Noch keine Trainer gefunden.",
  "trainerstunden.billing.trainer.empty.body":
    "Für die aktuelle Filterauswahl gibt es keine Treffer.",
  "trainerstunden.billing.trainer.pagination.range":
    "{from}–{to} von {total} Trainern",
  "trainerstunden.billing.abrechnung.backToDashboard": "Zur Übersicht",
  "trainerstunden.billing.abrechnung.actionPayments": "Zahlungseingänge",
  "trainerstunden.billing.abrechnung.actionExport": "Exportieren",
  "trainerstunden.billing.abrechnung.actionSettings": "Einstellungen",
  "trainerstunden.billing.abrechnung.overflowAria": "Weitere Aktionen",
  "trainerstunden.billing.abrechnung.cardsAria": "Abrechnungsbereiche",
  "trainerstunden.billing.abrechnung.cardViewCta": "Ansehen →",
  "trainerstunden.billing.abrechnung.view.preparation.title":
    "Offene Leistungen",
  "trainerstunden.billing.abrechnung.view.preparation.subtitle":
    "Bestätigte Leistungen, die noch in keine Rechnung übernommen wurden.",
  "trainerstunden.billing.abrechnung.view.preparation.description":
    "Noch nicht abgerechnete Leistungen",
  "trainerstunden.billing.abrechnung.view.ready.title":
    "Abrechnung vorbereiten",
  "trainerstunden.billing.abrechnung.view.ready.subtitle":
    "Prüfe offene Leistungen und erstelle daraus Rechnungen.",
  "trainerstunden.billing.abrechnung.view.ready.description":
    "Offene Leistungen prüfen und Rechnungen erzeugen",
  "trainerstunden.billing.abrechnung.view.drafts.title":
    "Abrechnung vorbereiten",
  "trainerstunden.billing.abrechnung.view.drafts.subtitle":
    "Prüfe offene Leistungen und erstelle daraus Rechnungen.",
  "trainerstunden.billing.abrechnung.view.drafts.description":
    "Offene Leistungen prüfen und Rechnungen erzeugen",
  "trainerstunden.billing.abrechnung.view.billNow.title":
    "Abrechnung vorbereiten",
  "trainerstunden.billing.abrechnung.view.billNow.subtitle":
    "Prüfe offene Leistungen und erstelle daraus Rechnungen.",
  "trainerstunden.billing.abrechnung.view.billNow.description":
    "Offene Leistungen prüfen und Rechnungen erzeugen",
  "trainerstunden.billing.abrechnung.view.yearInvoiced.title":
    "Erstellt {year}",
  "trainerstunden.billing.abrechnung.view.yearInvoiced.subtitle":
    "Im Kalenderjahr erstellte Rechnungen.",
  "trainerstunden.billing.abrechnung.view.yearInvoiced.description":
    "Rechnungen des laufenden Kalenderjahres",
  "trainerstunden.billing.abrechnung.view.sent.title": "Versendet",
  "trainerstunden.billing.abrechnung.view.sent.subtitle":
    "Versendete Rechnungen einsehen, filtern und verwalten.",
  "trainerstunden.billing.abrechnung.view.sent.description":
    "Gesendete Rechnungen einsehen und verwalten",
  "trainerstunden.billing.abrechnung.view.unpaid.title": "Unbezahlt",
  "trainerstunden.billing.abrechnung.view.unpaid.subtitle":
    "Versendete Rechnungen mit offenem Restbetrag.",
  "trainerstunden.billing.abrechnung.view.unpaid.description":
    "Offene Forderungen aus versendeten Rechnungen",
  "trainerstunden.billing.abrechnung.view.paid.title": "Bezahlt ({month})",
  "trainerstunden.billing.abrechnung.view.paid.subtitle":
    "Zahlungseingänge im gewählten Monat.",
  "trainerstunden.billing.abrechnung.view.paid.description":
    "Registrierte Zahlungen im gewählten Monat",
  "trainerstunden.billing.abrechnung.filter.toolbarAria":
    "Abrechnung nach Jahr, Monat, Trainer oder Person/Rechnung filtern",
  "trainerstunden.billing.abrechnung.filter.searchLabel": "Suche",
  "trainerstunden.billing.abrechnung.filter.searchPlaceholder":
    "Personen oder Rechnungen …",
  "trainerstunden.billing.abrechnung.dashboard.statusAria": "Statuskarten",
  "trainerstunden.billing.abrechnung.dashboard.billNowMeta":
    "{ready} bereit · {drafts} Entwürfe",
  "trainerstunden.billing.abrechnung.recipientFocus.back":
    "Alle offenen Rechnungen",
  "trainerstunden.billing.abrechnung.recipientFocus.lead":
    "Nur Rechnungen und offene Beträge dieses Empfängers.",
  "trainerstunden.billing.abrechnung.recipientFocus.yearInvoiced":
    "Erstellt {year}",
  "trainerstunden.billing.abrechnung.recipientFocus.invoiceCount": {
    one: "{count} Rechnung",
    other: "{count} Rechnungen",
  },
  "trainerstunden.billing.abrechnung.recipientFocus.openTitle": "Offen",
  "trainerstunden.billing.abrechnung.recipientFocus.openCount": {
    one: "{count} offene Rechnung",
    other: "{count} offene Rechnungen",
  },
  "trainerstunden.billing.abrechnung.recipientFocus.unknown": "Empfänger",
  "trainerstunden.billing.statementDetail.back":
    "Zurück zur Rechnungsübersicht",
  "trainerstunden.billing.statementDetail.status.paid": "Bezahlt",
  "trainerstunden.billing.statementDetail.status.open": "Offen",
  "trainerstunden.billing.statementDetail.status.overdue": "Überfällig",
  "trainerstunden.billing.statementDetail.status.cancelled": "Storniert",
  "trainerstunden.billing.statementDetail.kpi.invoiceDate": "Rechnungsdatum",
  "trainerstunden.billing.statementDetail.kpi.invoiceNumber": "Rechnungsnummer",
  "trainerstunden.billing.statementDetail.kpi.openAmount": "Offener Betrag",
  "trainerstunden.billing.statementDetail.hint.unpaidTitle":
    "Zahlung bisher nicht eingegangen.",
  "trainerstunden.billing.statementDetail.hint.dueSince": "Fällig seit {date}",
  "trainerstunden.billing.statementDetail.hint.overdueDays": {
    one: "Überfällig um {count} Tag.",
    other: "Überfällig um {count} Tage.",
  },
  "trainerstunden.billing.statementDetail.linesTitle":
    "Wofür ist diese Rechnung?",
  "trainerstunden.billing.statementDetail.linesEmpty":
    "Keine Leistungen hinterlegt.",
  "trainerstunden.billing.statementDetail.weekdayDate": "{weekday}, {date}",
  "trainerstunden.billing.statementDetail.nextStepsTitle": "Nächste Schritte",
  "trainerstunden.billing.statementDetail.action.remind": "Zahlung erinnern",
  "trainerstunden.billing.statementDetail.action.remindHint":
    "Erinnerung per E-Mail senden",
  "trainerstunden.billing.statementDetail.action.resend":
    "Rechnung erneut senden",
  "trainerstunden.billing.statementDetail.action.resendHint":
    "Rechnung noch einmal per E-Mail zustellen",
  "trainerstunden.billing.statementDetail.action.whatsapp":
    "Per WhatsApp erinnern",
  "trainerstunden.billing.statementDetail.action.whatsappHint":
    "Link kopieren und Nachricht senden",
  "trainerstunden.billing.statementDetail.action.recordPayment":
    "Zahlung verbuchen",
  "trainerstunden.billing.statementDetail.action.recordPaymentHint":
    "Zahlung manuell erfassen",
  "trainerstunden.billing.statementDetail.action.createCreditNote":
    "Gutschrift erstellen",
  "trainerstunden.billing.statementDetail.action.createCreditNoteHint":
    "Überzahlung oder Korrektur als Guthaben",
  "trainerstunden.billing.statementDetail.action.rebookItems":
    "Position umbuchen",
  "trainerstunden.billing.statementDetail.action.rebookItemsHint":
    "Falsche Person: Gutschrift + Nachbelastung",
  "trainerstunden.billing.statementDetail.action.view": "Rechnung anzeigen",
  "trainerstunden.billing.statementDetail.action.viewHint": "Vorschau öffnen",
  "trainerstunden.billing.statementDetail.action.pdf": "PDF herunterladen",
  "trainerstunden.billing.statementDetail.action.pdfHint": "PDF öffnen",
  "trainerstunden.billing.statementDetail.action.correct": "Rechnung anpassen",
  "trainerstunden.billing.statementDetail.action.correctHint":
    "Rechnung korrigieren",
  "trainerstunden.billing.statementDetail.action.cancel": "Rechnung stornieren",
  "trainerstunden.billing.statementDetail.action.cancelHint":
    "Stornorechnung erzeugen",
  "trainerstunden.billing.statementDetail.paymentsTitle": "Zahlungsverlauf",
  "trainerstunden.billing.statementDetail.paymentsEmpty":
    "Noch keine Zahlung eingegangen.",
  "trainerstunden.billing.statementDetail.summaryTitle": "Rechnungsübersicht",
  "trainerstunden.billing.statementDetail.summary.total": "Rechnungsbetrag",
  "trainerstunden.billing.statementDetail.summary.paid": "Bereits bezahlt",
  "trainerstunden.billing.statementDetail.summary.open": "Offener Betrag",
  "trainerstunden.billing.statementDetail.timelineTitle": "Zeitlicher Verlauf",
  "trainerstunden.billing.statementDetail.timelineEmpty":
    "Noch keine Ereignisse.",
  "trainerstunden.billing.statementDetail.timeline.created":
    "Rechnung erstellt · {date}",
  "trainerstunden.billing.statementDetail.timeline.sent":
    "Rechnung versendet · {date}",
  "trainerstunden.billing.statementDetail.timeline.due": "Fällig seit {date}",
  "trainerstunden.billing.statementDetail.timeline.paid":
    "Zahlung eingegangen · {date}",
  "trainerstunden.billing.statementDetail.timeline.cancelled":
    "Rechnung storniert · {date}",
  "trainerstunden.billing.abrechnung.dashboard.paymentsTitle":
    "Jetzt anstehend",
  "trainerstunden.billing.abrechnung.dashboard.kpiReceived": "Eingegangen",
  "trainerstunden.billing.abrechnung.dashboard.kpiOpen": "Offen",
  "trainerstunden.billing.abrechnung.dashboard.kpiYearInvoiced":
    "Erstellt {year}",
  "trainerstunden.billing.abrechnung.dashboard.kpiYearInvoicedCount":
    "{count} Rechnung(en)",
  "trainerstunden.billing.abrechnung.dashboard.kpiCount":
    "{count} Position(en)",
  "trainerstunden.billing.abrechnung.dashboard.allPayments":
    "Alle Einnahmen anzeigen",
  "trainerstunden.billing.abrechnung.dashboard.openQueue": "Zur Abrechnung →",
  "trainerstunden.billing.abrechnung.dashboard.paymentUnknown": "Unbekannt",
  "trainerstunden.billing.abrechnung.dashboard.payStatus.paid": "bezahlt",
  "trainerstunden.billing.abrechnung.dashboard.payStatus.open": "offen",
  "trainerstunden.billing.abrechnung.dashboard.payStatus.overdue": "überfällig",
  "trainerstunden.billing.abrechnung.dashboard.payStatus.draft": "Entwurf",
  "trainerstunden.billing.abrechnung.dashboard.payStatus.ready": "bereit",
  "trainerstunden.billing.abrechnung.dashboard.payStatus.todo": "offen",
  "trainerstunden.billing.abrechnung.dashboard.emptyAttention":
    "Nichts Offenes für diesen Monat – hier erscheinen Entwürfe, offene Leistungen und unbezahlte Rechnungen.",
  "trainerstunden.billing.abrechnung.dashboard.sectionPaymentsTitle":
    "Einnahmen",
  "trainerstunden.billing.abrechnung.dashboard.sectionRevenueTitle": "Umsatz",
  "trainerstunden.billing.abrechnung.dashboard.paymentsViewAria":
    "Darstellung Zahlungen",
  "trainerstunden.billing.abrechnung.dashboard.revenueViewAria":
    "Darstellung Umsatz",
  "trainerstunden.billing.abrechnung.dashboard.view.list": "Liste",
  "trainerstunden.billing.abrechnung.dashboard.view.cards": "Karten",
  "trainerstunden.billing.abrechnung.dashboard.view.flow": "Zahlungsfluss",
  "trainerstunden.billing.abrechnung.dashboard.view.bars": "Balken",
  "trainerstunden.billing.abrechnung.dashboard.view.line": "Linie",
  "trainerstunden.billing.abrechnung.dashboard.view.months": "Monatskarten",
  "trainerstunden.billing.abrechnung.dashboard.paymentsFlowAria":
    "Zahlungseingänge der letzten Monate",
  "trainerstunden.billing.abrechnung.dashboard.revenueBarsAria":
    "Umsatz der letzten Monate",
  "trainerstunden.billing.abrechnung.dashboard.revenueLineAria":
    "Umsatzverlauf der letzten Monate",
  "trainerstunden.billing.archive.subtitleRechnungenMonth":
    "Alle Rechnungen mit Rechnungsdatum im {period} — versendet und bezahlt.",
  "trainerstunden.billing.archive.subtitleRechnungenSearch":
    "Rechnungen gezielt suchen und filtern — ohne Vorgabe werden keine Ergebnisse angezeigt.",
  "trainerstunden.billing.archive.recipientInvoiceCount": "{count} Rechnungen",
  "trainerstunden.billing.archive.search.aria": "Rechnungsarchiv durchsuchen",
  "trainerstunden.billing.archive.search.lead":
    "Mindestens ein Kriterium wählen (Empfänger, Monat, Trainer, Rechnungsnummer oder Status).",
  "trainerstunden.billing.archive.search.title": "Rechnungen suchen",
  "trainerstunden.billing.archive.search.description":
    "Filtere Rechnungen nach Empfänger, Monat, Trainer oder Rechnungsnummer.",
  "trainerstunden.billing.archive.search.filterToggle": "Filter",
  "trainerstunden.billing.archive.search.filterToggleAria":
    "Erweiterte Filter ein- oder ausblenden",
  "trainerstunden.billing.archive.search.documentMonth": "Rechnungsmonat",
  "trainerstunden.billing.archive.search.documentMonthAny": "Alle Monate",
  "trainerstunden.billing.archive.search.trainer": "Trainer",
  "trainerstunden.billing.archive.search.trainerAny": "Alle Trainer",
  "trainerstunden.billing.archive.search.invoiceNumber": "Rechnungsnummer",
  "trainerstunden.billing.archive.search.unifiedLabel": "Suche",
  "trainerstunden.billing.archive.search.unifiedPlaceholder":
    "Name, E-Mail, Telefon oder Rechnungsnummer …",
  "trainerstunden.billing.archive.search.invoiceNumberPlaceholder":
    "z. B. RE-202606-001",
  "trainerstunden.billing.archive.search.clearAll": "Alle Filter zurücksetzen",
  "trainerstunden.billing.archive.sentShort": "Versendet",
  "trainerstunden.billing.archive.paid": "Bezahlt",
  "trainerstunden.billing.invoiceList.actionDetails": "Details",
  "trainerstunden.billing.invoiceList.actionPdf": "PDF",
  "trainerstunden.billing.invoiceList.actionRecordPayment": "Zahlung verbuchen",
  "trainerstunden.billing.invoiceList.actionResend": "Erneut senden",
  "trainerstunden.billing.invoiceList.actionStorno": "Stornieren",
  "trainerstunden.billing.invoiceUi.backToRecipients": "Alle Empfänger",
  "trainerstunden.billing.invoiceUi.kpi.open": "Offen",
  "trainerstunden.billing.invoiceUi.kpi.openCount": {
    one: "{count} Rechnung",
    other: "{count} Rechnungen",
  },
  "trainerstunden.billing.invoiceUi.kpi.overdue": "Überfällig",
  "trainerstunden.billing.invoiceUi.kpi.overdueCount": {
    one: "{count} Rechnung",
    other: "{count} Rechnungen",
  },
  "trainerstunden.billing.invoiceUi.kpi.oldestOverdue":
    "Älteste seit {days} Tagen",
  "trainerstunden.billing.invoiceUi.kpi.paidYear": "Bezahlt {year}",
  "trainerstunden.billing.invoiceUi.kpi.paidCount": {
    one: "{count} Rechnung",
    other: "{count} Rechnungen",
  },
  "trainerstunden.billing.invoiceUi.filter.aria": "Rechnungen filtern",
  "trainerstunden.billing.invoiceUi.filter.all": "Alle",
  "trainerstunden.billing.invoiceUi.filter.open": "Offen",
  "trainerstunden.billing.invoiceUi.filter.overdue": "Überfällig",
  "trainerstunden.billing.invoiceUi.filter.paid": "Bezahlt",
  "trainerstunden.billing.invoiceUi.filter.drafts": "Entwürfe",
  "trainerstunden.billing.invoiceUi.status.paid": "Bezahlt",
  "trainerstunden.billing.invoiceUi.status.overdue": "Überfällig",
  "trainerstunden.billing.invoiceUi.status.open": "Offen",
  "trainerstunden.billing.invoiceUi.status.draft": "Entwurf",
  "trainerstunden.billing.invoiceUi.status.cancelled": "Storniert",
  "trainerstunden.billing.invoiceUi.dueLabel": "Fällig {date}",
  "trainerstunden.billing.invoiceUi.listAria": "Rechnungsliste",
  "trainerstunden.billing.invoiceUi.listEmptyTitle": "Keine Rechnungen",
  "trainerstunden.billing.invoiceUi.listEmptyBody":
    "Für diesen Filter gibt es keine Rechnungen.",
  "trainerstunden.billing.invoiceUi.serviceSummaryMore":
    "{title} +{count} weitere",
  "trainerstunden.billing.invoiceUi.servicesFallback": "Leistung",
  "trainerstunden.billing.invoiceUi.servicesAria": "Leistungen",
  "trainerstunden.billing.invoiceUi.servicesTitle": "Leistungen",
  "trainerstunden.billing.invoiceUi.servicesEmpty": "Keine Positionen",
  "trainerstunden.billing.invoiceUi.servicesTotal": "Summe",
  "trainerstunden.billing.invoiceUi.drawer.aria": "Rechnungsdetails",
  "trainerstunden.billing.invoiceUi.drawer.closeAria": "Details schließen",
  "trainerstunden.billing.invoiceUi.drawer.expandAria": "Rechnung vergrößern",
  "trainerstunden.billing.invoiceUi.drawer.expandCta": "Rechnung öffnen",
  "trainerstunden.billing.positionCredit.title": "Position korrigieren",
  "trainerstunden.billing.positionCredit.lead":
    "Gutschrift zu Rechnung {invoice}. Die Originalrechnung bleibt unverändert.",
  "trainerstunden.billing.positionCredit.positionLabel": "Position",
  "trainerstunden.billing.positionCredit.remaining":
    "Noch gutschreibbar: {amount} €",
  "trainerstunden.billing.positionCredit.notes": "Grund der Korrektur",
  "trainerstunden.billing.positionCredit.notesPlaceholder":
    "z. B. Falsche Position / Verwechslung …",
  "trainerstunden.billing.positionCredit.amount": "Gutschriftbetrag (€)",
  "trainerstunden.billing.positionCredit.settlementLegend": "Verwendung",
  "trainerstunden.billing.positionCredit.settlement.refund":
    "Rückzahlung vormerken",
  "trainerstunden.billing.positionCredit.settlement.refundHint":
    "Es wird lediglich ein offener Rückzahlungsvorgang erzeugt. Es erfolgt keine automatische Auszahlung.",
  "trainerstunden.billing.positionCredit.settlement.balance":
    "Mit nächster Rechnung verrechnen",
  "trainerstunden.billing.positionCredit.settlement.balanceHint":
    "Das Guthaben wird automatisch auf die nächste Rechnung angerechnet.",
  "trainerstunden.billing.positionCredit.settlement.refundShort":
    "Rückzahlung vorgesehen",
  "trainerstunden.billing.positionCredit.settlement.balanceShort":
    "Mit nächster Rechnung verrechnet",
  "trainerstunden.billing.positionCredit.toSummary":
    "Weiter zur Zusammenfassung",
  "trainerstunden.billing.positionCredit.summaryLead":
    "Bitte Angaben prüfen, bevor die Gutschrift gebucht wird.",
  "trainerstunden.billing.positionCredit.summary.invoice":
    "Ursprüngliche Rechnung",
  "trainerstunden.billing.positionCredit.summary.position":
    "Ursprüngliche Position",
  "trainerstunden.billing.positionCredit.summary.amount": "Gutschriftbetrag",
  "trainerstunden.billing.positionCredit.summary.notes": "Grund",
  "trainerstunden.billing.positionCredit.summary.settlement": "Verwendung",
  "trainerstunden.billing.positionCredit.backToForm": "Zurück",
  "trainerstunden.billing.positionCredit.confirm": "Gutschrift buchen",
  "trainerstunden.billing.positionCredit.saveBusy": "Buchen …",
  "trainerstunden.billing.positionCredit.correctAction": "Position korrigieren",
  "trainerstunden.billing.positionCredit.lineMenuAria": "Positionsaktionen",
  "trainerstunden.billing.positionCredit.lineHint.title": "Gutschrift {number}",
  "trainerstunden.billing.positionCredit.lineHint.amount": "−{amount} €",
  "trainerstunden.billing.positionCredit.timeline.event":
    "Gutschrift {number} · {amount} € · {settlement}",
  "trainerstunden.billing.positionCredit.errorMissingContext":
    "Rechnung oder Position fehlt.",
  "trainerstunden.billing.positionCredit.errorAmountPositive":
    "Bitte einen Betrag größer als 0 eingeben.",
  "trainerstunden.billing.positionCredit.errorAmountExceeds":
    "Maximal {amount} € sind noch gutschreibbar.",
  "trainerstunden.billing.positionCredit.errorNotesRequired":
    "Bitte einen Grund angeben.",
  "trainerstunden.billing.positionCredit.errorSave":
    "Gutschrift konnte nicht gespeichert werden.",
  "trainerstunden.billing.positionCredit.error.amount-exceeds-remaining":
    "Der Betrag übersteigt den noch offenen Positionsanteil.",
  "trainerstunden.billing.positionCredit.error.statement-draft":
    "Für Entwürfe ist keine Positionsgutschrift möglich.",
  "trainerstunden.billing.positionCredit.error.statement-cancelled":
    "Stornierte Rechnungen können nicht korrigiert werden.",

  "trainerstunden.billing.positionCredit.bulk.selectPositionsCta":
    "+ Gutschrift erstellen",
  "trainerstunden.billing.positionCredit.bulk.selectBarAria":
    "Positionen für die Gutschrift auswählen",
  "trainerstunden.billing.positionCredit.bulk.selectBarSelectedCount":
    "{count} Positionen ausgewählt",
  "trainerstunden.billing.positionCredit.bulk.selectBarSelectedTotal":
    "Gesamtbetrag {amount} €",
  "trainerstunden.billing.positionCredit.bulk.selectBarContinueCta":
    "Gutschrift erstellen",
  "trainerstunden.billing.positionCredit.bulk.createCreditCta":
    "Gutschrift erstellen",
  "trainerstunden.billing.positionCredit.bulk.clearSelectionCta":
    "Auswahl aufheben",
  "trainerstunden.billing.positionCredit.bulk.closeAria": "Dialog schließen",

  "trainerstunden.billing.positionCredit.bulk.reason.trainingCancelled":
    "Training ausgefallen",
  "trainerstunden.billing.positionCredit.bulk.reason.wrongAmount":
    "Falscher Betrag",
  "trainerstunden.billing.positionCredit.bulk.reason.customerNotPresent":
    "Kunde nicht erschienen",
  "trainerstunden.billing.positionCredit.bulk.reason.goodwill": "Kulanz",
  "trainerstunden.billing.positionCredit.bulk.reason.other": "Sonstiges",

  "trainerstunden.billing.positionCredit.bulk.wizard.title":
    "Gutschrift erstellen",
  "trainerstunden.billing.positionCredit.bulk.summary.selectedCount": {
    one: "{count} Position ausgewählt",
    other: "{count} Positionen ausgewählt",
  },
  "trainerstunden.billing.positionCredit.bulk.summary.selectedTotal":
    "Gesamtbetrag {amount} €",
  "trainerstunden.billing.positionCredit.bulk.summary.showDetails":
    "Details anzeigen",
  "trainerstunden.billing.positionCredit.bulk.summary.hideDetails":
    "Details ausblenden",
  "trainerstunden.billing.positionCredit.bulk.partialTotalLabel":
    "Gesamtbetrag",
  "trainerstunden.billing.positionCredit.bulk.step1.title":
    "Ausgewählte Positionen",
  "trainerstunden.billing.positionCredit.bulk.step1.total": "Gesamtsumme",
  "trainerstunden.billing.positionCredit.bulk.step2.title":
    "Umfang der Gutschrift",
  "trainerstunden.billing.positionCredit.bulk.step2.amountLegend":
    "Umfang der Gutschrift",
  "trainerstunden.billing.positionCredit.bulk.step2.optionFull":
    "Vollständige Gutschrift",
  "trainerstunden.billing.positionCredit.bulk.step2.optionPartial":
    "Teilgutschrift",
  "trainerstunden.billing.positionCredit.bulk.step2.amountInputAria":
    "Betrag für {title}",
  "trainerstunden.billing.positionCredit.bulk.step2.remainingHint":
    "Noch gutschreibbar: {amount} €",
  "trainerstunden.billing.positionCredit.bulk.step2.preview":
    "Voraussichtlicher Betrag: {amount} €",
  "trainerstunden.billing.positionCredit.bulk.step3.title": "Grund",
  "trainerstunden.billing.positionCredit.bulk.step3.reasonLabel": "Grund",
  "trainerstunden.billing.positionCredit.bulk.step3.noteLabel":
    "Notiz (optional)",
  "trainerstunden.billing.positionCredit.bulk.step3.notePlaceholder":
    "Optional: kurze Beschreibung",
  "trainerstunden.billing.positionCredit.bulk.step3.otherLabel":
    "Freitext (optional)",
  "trainerstunden.billing.positionCredit.bulk.step3.otherPlaceholder":
    "Optional: kurze Beschreibung",
  "trainerstunden.billing.positionCredit.bulk.step4.title": "Verwendung",
  "trainerstunden.billing.positionCredit.bulk.step4.legend":
    "Wie soll die Gutschrift verwendet werden?",
  "trainerstunden.billing.positionCredit.bulk.step5.title": "Zusammenfassung",
  "trainerstunden.billing.positionCredit.bulk.step5.selectedCount":
    "Positionen",
  "trainerstunden.billing.positionCredit.bulk.step5.totalAmount":
    "Gesamtbetrag",
  "trainerstunden.billing.positionCredit.bulk.step5.reason": "Grund",
  "trainerstunden.billing.positionCredit.bulk.step5.usage": "Verwendung",
  "trainerstunden.billing.positionCredit.bulk.step5.immutableHint":
    "Die ursprüngliche Rechnung bleibt unverändert. Es wird eine neue Gutschrift erzeugt.",
  "trainerstunden.billing.positionCredit.bulk.mark.fully":
    "Vollständig gutgeschrieben",
  "trainerstunden.billing.positionCredit.bulk.mark.partial": "Teilgutschrift",
  "trainerstunden.billing.positionCredit.bulk.mark.remaining":
    "Restbetrag {amount} €",

  "trainerstunden.billing.positionCredit.bulk.errorNoPositions":
    "Keine Positionen ausgewählt.",
  "trainerstunden.billing.positionCredit.bulk.errorAmountPositive":
    "Bitte einen Betrag größer als 0 eingeben (max. {amount} €).",
  "trainerstunden.billing.positionCredit.bulk.errorAmountExceeds":
    "Maximal {amount} € sind noch gutschreibbar.",
  "trainerstunden.billing.positionCredit.bulk.errorReasonRequired":
    "Bitte einen Grund auswählen.",
  "trainerstunden.billing.positionCredit.bulk.errorReasonOtherRequired":
    "Bitte Freitext ausfüllen.",
  "trainerstunden.billing.positionCredit.bulk.errorSave":
    "Gutschrift konnte nicht erstellt werden. Bitte erneut versuchen.",

  "trainerstunden.billing.invoiceUi.drawer.invoiceTitle": "Rechnung {number}",
  "trainerstunden.billing.invoiceUi.drawer.draftInvoiceTitle":
    "Rechnungsentwurf",
  "trainerstunden.billing.invoiceUi.drawer.noNumberTitle":
    "Rechnung ohne Nummer",
  "trainerstunden.billing.invoiceUi.drawer.sentAt": "Gesendet {date}",
  "trainerstunden.billing.invoiceUi.drawer.openSuffix": "offen",
  "trainerstunden.billing.invoiceUi.drawer.paidFully": "Vollständig bezahlt",
  "trainerstunden.billing.invoiceUi.drawer.overdueDetail":
    "Fällig am {date} · {days} Tage überfällig",
  "trainerstunden.billing.invoiceUi.drawer.openDetail": "Fällig am {date}",
  "trainerstunden.billing.invoiceUi.drawer.draftDetail": "Noch nicht versendet",
  "trainerstunden.billing.invoiceUi.moreActionsAria": "Weitere Aktionen",
  "trainerstunden.billing.invoiceUi.timeline.aria": "Zahlungsverlauf",
  "trainerstunden.billing.invoiceUi.timeline.title": "Verlauf",
  "trainerstunden.billing.invoiceUi.timeline.created": "Erstellt",
  "trainerstunden.billing.invoiceUi.timeline.sent": "Versendet",
  "trainerstunden.billing.invoiceUi.timeline.payment": "Zahlung",
  "trainerstunden.billing.invoiceUi.timeline.open": "Offener Betrag",
  "trainerstunden.billing.invoiceUi.timeline.paid": "Bezahlt",
  "trainerstunden.billing.invoiceUi.timeline.overdueDays":
    "{days} Tage überfällig",
  "trainerstunden.billing.invoiceUi.timeline.noPaymentYet":
    "Noch keine Zahlung",
  "trainerstunden.billing.invoiceUi.hint.paidTitle": "Alles erledigt",
  "trainerstunden.billing.invoiceUi.hint.paidBody":
    "Diese Rechnung ist vollständig bezahlt.",
  "trainerstunden.billing.invoiceUi.hint.overdueTitle":
    "Überfällig seit {days} Tagen",
  "trainerstunden.billing.invoiceUi.hint.overdueBody":
    "Empfohlen: Mahnung senden oder Zahlung verbuchen.",
  "trainerstunden.billing.invoiceList.chainCount": {
    one: "{count} Rechnung",
    other: "{count} Rechnungen",
  },
  "trainerstunden.billing.invoiceList.chainTotalAria":
    "Gesamtbetrag {amount} €",
  "trainerstunden.billing.invoiceList.statusStorno": "Stornorechnung",
  "trainerstunden.billing.invoiceList.statusWithdrawnDraft":
    "Entwurf verworfen",
  "trainerstunden.billing.invoiceList.statusWithdrawnDraft":
    "Entwurf verworfen",
  "trainerstunden.billing.invoiceList.invoiceNumberFallback": "Ohne Nummer",
  "trainerstunden.billing.invoiceList.pagination.aria": "Seitennavigation",
  "trainerstunden.billing.invoiceList.pagination.range":
    "{from}–{to} von {total} Rechnungen",
  "trainerstunden.billing.prepare.pagination.range":
    "{from}–{to} von {total} Kunden",
  "trainerstunden.billing.prepare.customerColumn": "Kunde",
  "trainerstunden.billing.prepare.openServicesColumn": "Offene Leistungen",
  "trainerstunden.billing.prepare.periodColumn": "Zeitraum",
  "trainerstunden.billing.prepare.amountColumn": "Voraussichtlicher Betrag",
  "trainerstunden.billing.prepare.actionColumn": "Aktion",
  "trainerstunden.billing.prepare.openServicesMeta": {
    one: "{count} offene Leistung",
    other: "{count} offene Leistungen",
  },
  "trainerstunden.billing.prepare.viewServices": "Leistungen ansehen",
  "trainerstunden.billing.prepare.createInvoice": "Rechnung erstellen",
  "trainerstunden.billing.prepare.createInvoiceBusy": "Wird erstellt…",
  "trainerstunden.billing.prepare.emptyTitle": "Keine offenen Leistungen",
  "trainerstunden.billing.prepare.emptyBody":
    "Für die aktuelle Filterauswahl gibt es keine offenen Leistungen.",
  "trainerstunden.billing.prepare.openDraftsCta": "Erzeugte Entwürfe anzeigen",
  "trainerstunden.billing.prepare.drawerTitle": "Abrechnung vorbereiten",
  "trainerstunden.billing.prepare.drawerServicesHeading": "Offene Leistungen",
  "trainerstunden.billing.prepare.drawerSelectAll": "Alle auswählen",
  "trainerstunden.billing.prepare.drawerClearSelection": "Auswahl aufheben",
  "trainerstunden.billing.prepare.durationMinutes": "{minutes} Minuten",
  "trainerstunden.billing.prepare.creditTitle": "Kundenguthaben",
  "trainerstunden.billing.prepare.creditAutoHint":
    "Vorhandenes Guthaben wird beim Erstellen der Rechnung automatisch verrechnet.",
  "trainerstunden.billing.prepare.summarySubtotal": "Zwischensumme",
  "trainerstunden.billing.prepare.summaryCredit": "Kundenguthaben",
  "trainerstunden.billing.prepare.summaryDue": "Zu berechnen",
  "trainerstunden.billing.prepare.successTitle": "Rechnung erstellt",
  "trainerstunden.billing.prepare.successBody":
    "Die Rechnung wurde erfolgreich erstellt und kann nun versendet werden.",
  "trainerstunden.billing.prepare.successInvoiceNumber": "Rechnungsnummer",
  "trainerstunden.billing.prepare.successCustomer": "Kunde",
  "trainerstunden.billing.prepare.successAmount": "Betrag",
  "trainerstunden.billing.prepare.successViewInvoice": "Rechnung anzeigen",
  "trainerstunden.billing.prepare.successToList": "Zur Rechnungsliste",
  "trainerstunden.billing.prepare.successSendNow": "Jetzt versenden",
  "trainerstunden.billing.prepare.successClose": "Schließen",
  "trainerstunden.billing.prepare.listAria": "Kunden mit offenen Leistungen",
  "trainerstunden.billing.prepare.paneEmptyTitle":
    "Wähle links einen Kunden aus.",
  "trainerstunden.billing.prepare.paneEmptyBody":
    "Die offenen Leistungen und die Abrechnung erscheinen hier.",
  "trainerstunden.billing.prepare.paneBack": "Zurück zur Kundenliste",
  "trainerstunden.billing.prepare.noServicesTitle":
    "Keine offenen Leistungen vorhanden.",
  "trainerstunden.billing.prepare.noServicesBody":
    "Für diesen Kunden gibt es aktuell nichts abzurechnen.",
  "trainerstunden.billing.prepare.serviceTrainer": "Trainer {name}",
  "trainerstunden.billing.prepare.previewInvoice": "Vorschau",
  "trainerstunden.billing.invoiceList.pagination.prev": "Vorherige Seite",
  "trainerstunden.billing.invoiceList.pagination.next": "Nächste Seite",
  "trainerstunden.billing.invoiceList.pagination.pageSizeLabel":
    "Einträge pro Seite",
  "trainerstunden.billing.invoiceList.pagination.pageSizeOption":
    "{count} pro Seite",
  "trainerstunden.billing.invoiceList.statusOverdue": "Überfällig",
  "trainerstunden.billing.invoiceList.trainerMeta": "Trainer: {name}",
  "trainerstunden.billing.invoiceList.trainersMultiple": "{count} Trainer",
  "trainerstunden.billing.finance.archiveSectionTitle":
    "Versendete Rechnungen & Zahlungseingänge",
  "trainerstunden.billing.finance.rechnungenArchiveTitle": "Rechnungsarchiv",
  "trainerstunden.billing.finance.rechnungenTitle": "Rechnungen",
  "trainerstunden.billing.finance.rechnungenSubtitle":
    "Alle Rechnungen verwalten, filtern und versenden.",
  "trainerstunden.billing.finance.abrechnenTitle": "Rechnungsentwürfe",
  "trainerstunden.billing.finance.abrechnenSubtitle":
    "Rechnungsentwürfe prüfen, korrigieren und versenden.",
  "trainerstunden.billing.finance.openItemsTitle": "In Vorbereitung",
  "trainerstunden.billing.finance.openItemsSubtitle":
    "Offene Leistungen filtern und einzeln oder gebündelt abrechnen.",
  "trainerstunden.billing.finance.workbenchKpi.aria": "Kennzahlen Abrechnung",
  "trainerstunden.billing.finance.workbenchKpi.draftsOpen": "Aktueller Monat",
  "trainerstunden.billing.finance.draftsKpi.aria":
    "Kennzahlen Rechnungsentwürfe",
  "trainerstunden.billing.finance.draftsKpi.openDraftsLabel":
    "Offene Entwürfe zur Abrechnung",
  "trainerstunden.billing.finance.draftsKpi.draftCount": {
    one: "{count} Entwurf",
    other: "{count} Entwürfe",
  },
  "trainerstunden.billing.finance.draftsKpi.currentMonthLabel":
    "Aktueller Monat ({period})",
  "trainerstunden.billing.finance.draftsKpi.prevMonthInvoicedLabel":
    "Vormonat ({period})",
  "trainerstunden.billing.finance.draftsKpi.prevPrevMonthInvoicedLabel":
    "Vorvormonat ({period})",
  "trainerstunden.billing.finance.draftsKpi.trendUpVsPrevInvoiced":
    "Entwürfe gestiegen gegenüber fakturiertem Vormonat",
  "trainerstunden.billing.finance.draftsKpi.trendDownVsPrevInvoiced":
    "Entwürfe gesunken gegenüber fakturiertem Vormonat",
  "trainerstunden.billing.finance.draftsKpi.trendUpVsPrevPrevInvoiced":
    "Fakturierter Umsatz gestiegen gegenüber Vorvormonat",
  "trainerstunden.billing.finance.draftsKpi.trendDownVsPrevPrevInvoiced":
    "Fakturierter Umsatz gesunken gegenüber Vorvormonat",
  "trainerstunden.billing.finance.workbenchKpi.openItems": "In Vorbereitung",
  "trainerstunden.billing.finance.workbenchKpi.accumulated": "Offen",
  "trainerstunden.billing.finance.workbenchKpi.invoiceCount": {
    one: "{count} Rechnung",
    other: "{count} Rechnungen",
  },
  "trainerstunden.billing.finance.workbenchKpi.recipientCount": {
    one: "{count} Empfänger",
    other: "{count} Empfänger",
  },
  "trainerstunden.billing.finance.invoicedKpi.aria": "Fakturierter Umsatz",
  "trainerstunden.billing.finance.invoicedKpi.yearLabel":
    "Jahresumsatz {year} (fakturiert)",
  "trainerstunden.billing.finance.invoicedKpi.currentMonthLabel":
    "Aktueller Monat ({period})",
  "trainerstunden.billing.finance.invoicedKpi.prevMonthLabel":
    "Vormonat ({period})",
  "trainerstunden.billing.finance.invoicedKpi.countMeta": "{count} Rechnungen",
  "trainerstunden.billing.finance.invoicedKpi.trendUpVsPrevYear":
    "Umsatz gestiegen gegenüber {year}",
  "trainerstunden.billing.finance.invoicedKpi.trendDownVsPrevYear":
    "Umsatz gesunken gegenüber {year}",
  "trainerstunden.billing.finance.invoicedKpi.trendUpVsPrevMonth":
    "Umsatz gestiegen gegenüber Vormonat",
  "trainerstunden.billing.finance.invoicedKpi.trendDownVsPrevMonth":
    "Umsatz gesunken gegenüber Vormonat",
  "trainerstunden.billing.finance.paymentsKpi.aria":
    "Registrierte Zahlungseingänge",
  "trainerstunden.billing.finance.paymentsKpi.yearLabel":
    "Jahreseinnahmen {year} (registriert)",
  "trainerstunden.billing.finance.paymentsKpi.currentMonthLabel":
    "Aktueller Monat ({period})",
  "trainerstunden.billing.finance.paymentsKpi.prevMonthLabel":
    "Vormonat ({period})",
  "trainerstunden.billing.finance.paymentsKpi.countMeta": "{count} Einnahmen",
  "trainerstunden.billing.finance.paymentsKpi.trendUpVsPrevYear":
    "Einnahmen gestiegen gegenüber {year}",
  "trainerstunden.billing.finance.paymentsKpi.trendDownVsPrevYear":
    "Einnahmen gesunken gegenüber {year}",
  "trainerstunden.billing.finance.paymentsKpi.trendUpVsPrevMonth":
    "Einnahmen gestiegen gegenüber Vormonat",
  "trainerstunden.billing.finance.paymentsKpi.trendDownVsPrevMonth":
    "Einnahmen gesunken gegenüber Vormonat",
  "trainerstunden.billing.finance.archiveKpi.aria": "Kennzahlen Rechnungsmonat",
  "trainerstunden.billing.finance.archiveKpi.sent": "Versendet",
  "trainerstunden.billing.finance.archiveKpi.open": "Offen",
  "trainerstunden.billing.finance.archiveKpi.paid": "Bezahlt",
  "trainerstunden.billing.finance.archiveKpi.cancelled": "Storniert",
  "trainerstunden.billing.finance.archiveKpi.cancelledCount":
    "{count} Storniert",
  "trainerstunden.billing.invoicing.filter.searchToggleAria":
    "Empfänger suchen",
  "trainerstunden.billing.finance.archiveKpi.value": "{count} · {amount} €",
  "trainerstunden.billing.archive.predecessorCancelledLabel":
    "Ursprüngliche Rechnung storniert",
  "trainerstunden.billing.priorMonthDrafts.banner": {
    one: "{count} Entwurf aus {month} noch nicht versendet ({amount} €)",
    other: "{count} Entwürfe aus {month} noch nicht versendet ({amount} €)",
  },
  "trainerstunden.billing.priorMonthDrafts.linkRechnungen": "Zu Rechnungen",
  "trainerstunden.billing.prepareAllDialog.title":
    "Alle Rechnungen vorbereiten?",
  "trainerstunden.billing.prepareAllDialog.modeLead":
    "Wie möchtest du vorgehen?",
  "trainerstunden.billing.prepareAllDialog.modeChoicesAria":
    "Vorbereitungsmodus wählen",
  "trainerstunden.billing.prepareAllDialog.modeGuided": "Schritt für Schritt",
  "trainerstunden.billing.prepareAllDialog.modeGuidedHint":
    "Pro Empfänger Positionen prüfen, ggf. anpassen oder überspringen",
  "trainerstunden.billing.prepareAllDialog.modeBlind": "Alle auf einmal",
  "trainerstunden.billing.prepareAllDialog.modeBlindHint":
    "Entwürfe für alle Empfänger automatisch erstellen",
  "trainerstunden.billing.prepareAllDialog.guidedProgress":
    "Schritt-für-Schritt · Empfänger {current} von {total}",
  "trainerstunden.billing.prepareAllDialog.skipRecipient":
    "Überspringen und weiter",
  "trainerstunden.billing.prepareAllDialog.lead":
    "Für jeden Empfänger wird ein Rechnungsentwurf erstellt. Du kannst jeden Entwurf vor dem Versand noch prüfen und anpassen.",
  "trainerstunden.billing.prepareAllDialog.statsAria": "Zusammenfassung",
  "trainerstunden.billing.prepareAllDialog.recipients": "Empfänger",
  "trainerstunden.billing.prepareAllDialog.total": "Gesamtbetrag",
  "trainerstunden.billing.prepareAllDialog.hint":
    "Rechnungen werden nicht automatisch versendet. Versand erfolgt manuell pro Empfänger oder über „Alle versenden“.",
  "trainerstunden.billing.prepareAllDialog.confirm": "Ja, vorbereiten",
  "trainerstunden.billing.prepareCurrentMonthDialog.title":
    "Trainings aus {month} mitfakturieren?",
  "trainerstunden.billing.prepareCurrentMonthDialog.lead":
    "Standardmäßig werden nur bestätigte Trainings bis einschließlich {cutoffDate} ({previousMonth}) abgerechnet.",
  "trainerstunden.billing.prepareCurrentMonthDialog.stats":
    "{count} Leistungen · {amount} € aus dem laufenden Monat",
  "trainerstunden.billing.prepareCurrentMonthDialog.choicesAria":
    "Abrechnungszeitraum wählen",
  "trainerstunden.billing.prepareCurrentMonthDialog.excludeCurrentMonth":
    "Nur bis {cutoffDate}",
  "trainerstunden.billing.prepareCurrentMonthDialog.excludeCurrentMonthHint":
    "Empfohlen — Trainings aus dem laufenden Monat bleiben offen",
  "trainerstunden.billing.prepareCurrentMonthDialog.includeCurrentMonth":
    "{month} mitfakturieren",
  "trainerstunden.billing.prepareCurrentMonthDialog.includeCurrentMonthHint":
    "Alle ausgewählten Leistungen inklusive laufendem Monat übernehmen",
  "trainerstunden.billing.prepareCurrentMonthDialog.noLinesInRange":
    "Keine Leistungen bis zum Vormonatsende — aktuellen Monat mitfakturieren oder Abbrechen.",
  "trainerstunden.billing.finance.status.hintDraft": "Entwurf wird geprüft",
  "trainerstunden.billing.finance.status.hintSendReady":
    "Rechnung kann versendet werden",
  "trainerstunden.billing.finance.status.hintSent": "Rechnung wurde versendet",
  "trainerstunden.billing.finance.status.hintMixed": "Teilweise versendet",
  "trainerstunden.billing.finance.status.hintOpenLines":
    "Noch offene Leistungen vor Versand",
  "trainerstunden.billing.finance.status.hintRecover":
    "Wiederherstellung möglich",
  "trainerstunden.billing.finance.status.hintUnbundled":
    "Offene Leistungen zu einem Rechnungsentwurf bündeln",
  "trainerstunden.billing.finance.status.pill.draft": "Entwurf",
  "trainerstunden.billing.finance.status.pill.unbundled":
    "Noch nicht gebündelt",
  "trainerstunden.billing.finance.status.pill.sendReady": "Versandbereit",
  "trainerstunden.billing.finance.status.pill.prepared": "Rechnung vorbereitet",
  "trainerstunden.billing.finance.status.pill.sent": "Versendet",
  "trainerstunden.billing.finance.status.pill.mixed": "Teilweise versendet",
  "trainerstunden.billing.finance.status.pill.openLines": "Offen",
  "trainerstunden.billing.finance.status.pill.recover": "Storniert",
  "trainerstunden.billing.finance.sendInvoice": "Versenden",
  "trainerstunden.billing.finance.sendInvoiceFull": "Rechnung versenden",
  "trainerstunden.billing.finance.toggleLinesAria":
    "Leistungen anzeigen ({count})",
  "trainerstunden.billing.manualInvoice.cta": "Rechnung manuell erfassen",
  "trainerstunden.billing.manualInvoice.title": "Rechnung manuell erfassen",
  "trainerstunden.billing.manualInvoice.subtitle":
    "Leistungen direkt als Rechnungsentwurf buchen — ohne Training planen oder Anwesenheit bestätigen.",
  "trainerstunden.billing.manualInvoice.periodLabel": "Abrechnungsmonat",
  "trainerstunden.billing.manualInvoice.personLabel": "Spieler / Empfänger",
  "trainerstunden.billing.manualInvoice.personPlaceholder": "Person wählen …",
  "trainerstunden.billing.manualInvoice.personViaContact":
    "{name} · Rechnung an {contact}",
  "trainerstunden.billing.manualInvoice.recipientHint":
    "Rechnungsempfänger: {name}",
  "trainerstunden.billing.manualInvoice.linesLegend": "Leistungen",
  "trainerstunden.billing.manualInvoice.lineDescriptionLabel": "Beschreibung",
  "trainerstunden.billing.manualInvoice.lineDescriptionPlaceholder":
    "z. B. Tennistraining, Material, Platzbuchung",
  "trainerstunden.billing.manualInvoice.lineDateLabel": "Datum",
  "trainerstunden.billing.manualInvoice.lineAmountLabel": "Betrag (€)",
  "trainerstunden.billing.manualInvoice.addLine": "Weitere Leistung",
  "trainerstunden.billing.manualInvoice.removeLine": "Entfernen",
  "trainerstunden.billing.manualInvoice.removeLineAria":
    "Leistung {index} entfernen",
  "trainerstunden.billing.manualInvoice.notesLabel": "Notiz (optional)",
  "trainerstunden.billing.manualInvoice.notesPlaceholder":
    "Interne Notiz zur Rechnung",
  "trainerstunden.billing.manualInvoice.saveDraft": "Entwurf speichern",
  "trainerstunden.billing.manualInvoice.saving": "Speichern …",
  "trainerstunden.billing.manualInvoice.errorMissingPerson":
    "Bitte eine Person auswählen.",
  "trainerstunden.billing.manualInvoice.errorNoLines":
    "Bitte mindestens eine Leistung mit Beschreibung, Datum und Betrag erfassen.",
  "trainerstunden.billing.manualInvoice.errorActiveNotDraft":
    "Für diesen Empfänger existiert bereits eine versendete oder abgeschlossene Rechnung in diesem Monat.",
  "trainerstunden.billing.manualInvoice.errorUniqueConstraint":
    "Für diesen Empfänger existiert bereits eine Rechnung in diesem Monat.",
  "trainerstunden.billing.manualInvoice.errorSave":
    "Der Entwurf konnte nicht gespeichert werden.",
  "trainerstunden.billing.workQueue.phasePrepareTitle":
    "Rechnungen vorbereiten",
  "trainerstunden.billing.workQueue.phaseSendReadyTitle":
    "Rechnungen versenden",
  "trainerstunden.billing.workQueue.phaseOpenItemsTitle": "Nächste Abrechnung",
  "trainerstunden.billing.workQueue.phaseOpenItemsSubtitle": {
    one: "{count} Empfänger sammeln Leistungen für die nächste Abrechnung",
    other: "{count} Empfänger sammeln Leistungen für die nächste Abrechnung",
  },
  "trainerstunden.billing.workQueue.phaseOverdueTitle":
    "Überfällige Rechnungen",
  "trainerstunden.billing.workQueue.phaseOverdueSubtitle": {
    one: "{count} überfällige Rechnung — prüfen, mahnen oder Zahlung verbuchen",
    other:
      "{count} überfällige Rechnungen — prüfen, mahnen oder Zahlung verbuchen",
  },
  "trainerstunden.billing.overduePanel.lead":
    "Versendete Rechnungen mit überschrittener Fälligkeit. Mahnung per E-Mail oder Mahnstufe manuell setzen (z. B. Brief/WhatsApp).",
  "trainerstunden.billing.overduePanel.invoiceRef": "Rechnung {ref}",
  "trainerstunden.billing.overduePanel.dueDate": "Fällig seit {date}",
  "trainerstunden.billing.overdue.ageDays.one": "seit {count} Tag",
  "trainerstunden.billing.overdue.ageDays.other": "seit {count} Tagen",
  "trainerstunden.billing.overduePanel.openInvoice": "In Rechnungen öffnen",
  "trainerstunden.billing.dunning.level": "{level}. Mahnung",
  "trainerstunden.billing.dunning.sendEmail": "Mahnung per E-Mail",
  "trainerstunden.billing.dunning.menuItem": "Mahnung",
  "trainerstunden.billing.dunning.menuItemAll.one":
    "Alle überfälligen mahnen ({count})",
  "trainerstunden.billing.dunning.menuItemAll.other":
    "Alle überfälligen mahnen ({count})",
  "trainerstunden.billing.dunning.sendBusy": "Sende…",
  "trainerstunden.billing.dunning.markManual": "Mahnstufe +1 (manuell)",
  "trainerstunden.billing.dunning.resetManual": "Mahnstufe zurücksetzen",
  "trainerstunden.billing.dunning.resetFailed":
    "Mahnstufe konnte nicht zurückgesetzt werden.",
  "trainerstunden.billing.dunning.manualFailed":
    "Mahnstufe konnte nicht gespeichert werden.",
  "trainerstunden.billing.dunning.sendFailed.generic":
    "Mahnung konnte nicht gesendet werden.",
  "trainerstunden.billing.dunning.sendFailed.missing-email":
    "Keine E-Mail beim Rechnungsempfänger hinterlegt.",
  "trainerstunden.billing.dunning.sendFailed.not-overdue":
    "Rechnung ist noch nicht überfällig.",
  "trainerstunden.billing.dunning.sendFailed.not-open-invoice":
    "Nur versendete offene Rechnungen können gemahnt werden.",
  "trainerstunden.billing.dunning.sendFailed.db-schema-dunning":
    "Datenbank-Migration für Mahnstufen fehlt noch auf dieser Umgebung.",
  "trainerstunden.billing.workQueue.phaseSendReadySubtitle": {
    one: "{count} vorbereitete Rechnung im {period}.",
    other: "{count} vorbereitete Rechnungen im {period}.",
  },
  "trainerstunden.billing.workQueue.phasePrepareSubtitleOpen": {
    one: "{count} Empfänger mit offenen Leistungen.",
    other: "{count} Empfänger mit offenen Leistungen.",
  },
  "trainerstunden.billing.workQueue.phaseSendReadySubtitleOpen": {
    one: "{count} vorbereitete Rechnung.",
    other: "{count} vorbereitete Rechnungen.",
  },
  "trainerstunden.billing.workQueue.phasePrepareSubtitle": {
    one: "{count} Empfänger mit offenen Leistungen im {period}.",
    other: "{count} Empfänger mit offenen Leistungen im {period}.",
  },
  "trainerstunden.billing.workQueue.prepareAllBanner": {
    one: "{count} Empfänger hat offene Leistungen – jetzt alle Rechnungen vorbereiten?",
    other:
      "{count} Empfänger haben offene Leistungen – jetzt alle Rechnungen vorbereiten?",
  },
  "trainerstunden.billing.monthClose.reviewCta": "Alle Rechnungen erstellen",
  "trainerstunden.billing.monthClose.heroMeta": {
    one: "{count} Rechnung · {amount} Gesamtbetrag",
    other: "{count} Rechnungen · {amount} Gesamtbetrag",
  },
  "trainerstunden.billing.monthClose.empty":
    "Noch keine Rechnungsentwürfe für diesen Monat.",
  "trainerstunden.billing.monthClose.rowMenuAria": "Rechnungsaktionen",
  "trainerstunden.billing.monthClose.chainMenu.aria": "Entwurfsaktionen",
  "trainerstunden.billing.monthClose.chainMenu.chooseDraft": "Entwurf wählen",
  "trainerstunden.billing.monthClose.chainMenu.draftPick":
    "{number} · {amount}",
  "trainerstunden.billing.monthClose.chainMenu.back": "Anderer Entwurf",
  "trainerstunden.billing.monthClose.actionPreview": "Rechnungsvorschau",
  "trainerstunden.billing.monthClose.actionCorrect": "Korrigieren",
  "trainerstunden.billing.correction.editNotice":
    "Korrekturmodus — Änderungen werden automatisch gespeichert.",
  "trainerstunden.billing.correction.footerHint":
    "Positionen, Empfänger und Zahlungsziel direkt bearbeiten. Gesamtbetrag aktualisiert sich sofort.",
  "trainerstunden.billing.correction.done": "Fertig",
  "trainerstunden.billing.correction.removeLine": "Position entfernen",
  "trainerstunden.billing.correction.saveFailed":
    "Speichern fehlgeschlagen. Bitte erneut versuchen.",
  "trainerstunden.billing.correction.removeFailed":
    "Position konnte nicht entfernt werden.",
  "trainerstunden.billing.correction.removeDuplicateSession":
    "Diese Leistung ist bereits in einem anderen aktiven Entwurf enthalten. Bitte zuerst die doppelte Position dort entfernen oder dauerhaft löschen.",
  "trainerstunden.billing.correction.removeNotDraft":
    "Versendete Rechnungspositionen können hier nicht entfernt werden.",
  "trainerstunden.billing.correction.removeItemNotFound":
    "Position wurde nicht gefunden — bitte Seite neu laden.",
  "trainerstunden.billing.correction.removeMissingOwner":
    "Position konnte nicht ausgelagert werden (fehlende Zuordnung). Bitte erneut versuchen.",
  "trainerstunden.billing.correction.removeForbidden":
    "Keine Berechtigung zum Entfernen dieser Position.",
  "trainerstunden.billing.correction.recipientFirstName": "Vorname",
  "trainerstunden.billing.correction.recipientLastName": "Nachname",
  "trainerstunden.billing.correction.recipientHint":
    "Adresse wie auf der gedruckten Rechnung — Änderungen werden automatisch gespeichert.",
  "trainerstunden.billing.correction.recipientStreet": "Straße",
  "trainerstunden.billing.correction.recipientHouseNumber": "Hausnummer",
  "trainerstunden.billing.correction.recipientPostalCode": "PLZ",
  "trainerstunden.billing.correction.recipientCity": "Ort",
  "trainerstunden.billing.correction.positionsTitle": "Positionen",
  "trainerstunden.billing.correction.durationMin": "Dauer (Min.)",
  "trainerstunden.billing.correction.lineCount": "{count} Positionen",
  "trainerstunden.billing.correction.addLine": "Position hinzufügen",
  "trainerstunden.billing.correction.addLineConfirm": "Hinzufügen",
  "trainerstunden.billing.correction.addLinePlaceholder":
    "z. B. Barauslage Training September (Gabriel bei Sebastian)",
  "trainerstunden.billing.correction.addLineFailed":
    "Position konnte nicht hinzugefügt werden. Bitte Eingaben prüfen und erneut versuchen.",
  "trainerstunden.billing.correction.lineDescription": "Beschreibung",
  "trainerstunden.billing.correction.lineDescriptionPlaceholder":
    "Bezeichnung der Position",
  "trainerstunden.billing.correction.removeModalTitle": "Position entfernen",
  "trainerstunden.billing.correction.removeActionIntro":
    "Soll die Position in einen separaten Rechnungsentwurf ausgelagert oder dauerhaft gelöscht werden? Dauerhaft gelöschte Positionen werden nicht erneut automatisch in eine Rechnung übernommen.",
  "trainerstunden.billing.correction.removeActionSpinOff":
    "In separaten Entwurf auslagern",
  "trainerstunden.billing.correction.removeActionPermanent":
    "Dauerhaft löschen",
  "trainerstunden.billing.correction.removeTargetIntro":
    "Die Position wird aus dieser Rechnung entfernt und in einen separaten Entwurf verschoben. In der Entwurfsliste erscheint dieser unter demselben Empfängernamen mit eigenem Betrag — nicht als nummerierte „Entwurf 1/2“.",
  "trainerstunden.billing.correction.removeTargetLegend": "Ziel-Entwurf",
  "trainerstunden.billing.correction.removeTargetOption":
    "Auslagerungs-Entwurf · {amount} · {count} Positionen",
  "trainerstunden.billing.correction.removeTargetOptionAmount":
    "Auslagerungs-Entwurf · {amount}",
  "trainerstunden.billing.correction.removeTargetRecommended": "empfohlen",
  "trainerstunden.billing.correction.removeTargetNewDraft":
    "Neuen Auslagerungs-Entwurf anlegen",
  "trainerstunden.billing.correction.removeTargetConfirm": "Auslagern",
  "trainerstunden.billing.monthClose.splinterDraftLabel": "Ausgelagert",
  "trainerstunden.billing.monthClose.draftCountBadge": "{count} Entwürfe",
  "trainerstunden.billing.monthClose.expandDraftsAria":
    "{count} Rechnungsentwürfe anzeigen",
  "trainerstunden.billing.monthClose.collapseDraftsAria":
    "Rechnungsentwürfe einklappen",
  "trainerstunden.billing.monthClose.selectDraftAria":
    "Entwurf {number} zum Verbinden auswählen",
  "trainerstunden.billing.monthClose.mergeSelectedHint":
    "Mindestens zwei Entwürfe auswählen, um sie zu verbinden.",
  "trainerstunden.billing.monthClose.mergeSelectedHintReady": {
    one: "{count} Entwurf ausgewählt",
    other: "{count} Entwürfe ausgewählt",
  },
  "trainerstunden.billing.monthClose.mergeSelectedCta": "Entwürfe verbinden",
  "trainerstunden.billing.monthClose.mergeSelectedBusy": "Wird verbunden …",
  "trainerstunden.billing.monthClose.mergeSelectedSuccess":
    "Entwürfe wurden zu einer Rechnung verbunden.",
  "trainerstunden.billing.monthClose.mergeSelectedFailed":
    "Entwürfe konnten nicht verbunden werden.",
  "trainerstunden.billing.monthClose.mergeNeedMultiple":
    "Bitte mindestens zwei Entwürfe derselben Person auswählen.",
  "trainerstunden.billing.monthClose.mergeDuplicateSession":
    "Mindestens eine Leistung ist in beiden Entwürfen enthalten. Bitte doppelte Positionen zuerst entfernen oder auslagern.",
  "trainerstunden.billing.monthClose.mergeRecipientMismatch":
    "Diese Entwürfe gehören zu unterschiedlichen Empfängern und können nicht verbunden werden.",
  "trainerstunden.billing.monthClose.mergeNotDraft":
    "Nur offene Entwürfe können verbunden werden — mindestens eine Auswahl ist bereits versendet.",
  "trainerstunden.billing.monthClose.mergeSplitConflict":
    "Diese ausgelagerten Entwürfe lassen sich gerade nicht verbinden. Bitte Seite neu laden und erneut versuchen.",
  "trainerstunden.billing.monthClose.mergeStatementNotFound":
    "Entwürfe nicht gefunden — bitte Seite neu laden und erneut versuchen.",
  "trainerstunden.billing.monthClose.mergeMissingOwner":
    "Entwürfe konnten nicht verbunden werden (fehlende Zuordnung). Bitte erneut versuchen.",
  "trainerstunden.billing.monthClose.mergeForbidden":
    "Keine Berechtigung zum Verbinden dieser Entwürfe.",
  "trainerstunden.billing.monthClose.correctDraftHint":
    "Positionen im gespeicherten Rechnungsentwurf bearbeiten — nicht die offenen Leistungen des Monats.",
  "trainerstunden.billing.monthClose.correctDraftEmpty":
    "Keine Positionen mehr im Entwurf.",
  "trainerstunden.billing.monthClose.draftRecipient.label":
    "Rechnungsempfänger",
  "trainerstunden.billing.monthClose.draftRecipient.current":
    "Aktuell: {{name}}",
  "trainerstunden.billing.monthClose.draftRecipient.change": "Empfänger ändern",
  "trainerstunden.billing.monthClose.draftRecipient.sheetTitle":
    "Rechnungsempfänger wählen",
  "trainerstunden.billing.monthClose.draftRecipient.sheetHint":
    "Wähle, wer die Rechnung erhält — nur für diesen Entwurf oder dauerhaft für den Spieler.",
  "trainerstunden.billing.monthClose.draftRecipient.scopeLegend": "Gültigkeit",
  "trainerstunden.billing.monthClose.draftRecipient.scopeOnce":
    "Nur diese Rechnung",
  "trainerstunden.billing.monthClose.draftRecipient.scopeOnceHint":
    "Stammdaten des Spielers bleiben unverändert.",
  "trainerstunden.billing.monthClose.draftRecipient.scopePermanent":
    "Dauerhaft hinterlegen",
  "trainerstunden.billing.monthClose.draftRecipient.scopePermanentHint":
    "Zukünftige Rechnungen für diesen Spieler laufen ebenfalls an diesen Empfänger.",
  "trainerstunden.billing.monthClose.draftRecipient.searchPlaceholder":
    "Name oder E-Mail suchen …",
  "trainerstunden.billing.monthClose.draftRecipient.searchAria":
    "Rechnungsempfänger suchen",
  "trainerstunden.billing.monthClose.draftRecipient.noResults":
    "Kein Empfänger gefunden.",
  "trainerstunden.billing.monthClose.draftRecipient.clear": "Auswahl löschen",
  "trainerstunden.billing.monthClose.draftRecipient.optionSelf":
    "Spieler: {{name}}",
  "trainerstunden.billing.monthClose.draftRecipient.save":
    "Empfänger übernehmen",
  "trainerstunden.billing.monthClose.draftRecipient.success":
    "Rechnungsempfänger für diesen Entwurf wurde aktualisiert.",
  "trainerstunden.billing.monthClose.draftRecipient.successPermanent":
    "Rechnungsempfänger dauerhaft hinterlegt und Entwurf aktualisiert.",
  "trainerstunden.billing.monthClose.draftRecipient.error":
    "Empfänger konnte nicht gespeichert werden.",
  "trainerstunden.billing.monthClose.draftRecipient.errorNotDraft":
    "Nur Entwürfe können geändert werden.",
  "trainerstunden.billing.draftCards.changeRecipient":
    "Rechnungsempfänger ändern",
  "trainerstunden.billing.monthClose.actionSendSingle": "Rechnung verschicken",
  "trainerstunden.billing.monthClose.actionDeleteDraft": "Entwurf löschen",
  "trainerstunden.billing.monthClose.deleteDraft.title": "Entwurf löschen",
  "trainerstunden.billing.monthClose.deleteDraft.body":
    "Der Entwurf {number} wird vollständig gelöscht. Alle Leistungen stehen wieder als offene Posten zur Verfügung.",
  "trainerstunden.billing.monthClose.deleteDraft.confirm": "Entwurf löschen",
  "trainerstunden.billing.monthClose.deleteDraft.busy": "Wird gelöscht …",
  "trainerstunden.billing.monthClose.deleteDraft.success":
    "Entwurf wurde gelöscht.",
  "trainerstunden.billing.monthClose.deleteDraft.error":
    "Der Entwurf konnte nicht gelöscht werden.",
  "trainerstunden.billing.monthClose.deleteDraft.sessionStepTitle":
    "Was passiert mit der Trainerstunde?",
  "trainerstunden.billing.monthClose.deleteDraft.sessionStepBody":
    "Der Entwurf {number} wird dauerhaft gelöscht und erscheint nicht erneut aus denselben Stunden. Lege fest, was mit der Trainerstunde passiert.",
  "trainerstunden.billing.monthClose.deleteDraft.sessionActionCancel":
    "Trainerstunde absagen",
  "trainerstunden.billing.monthClose.deleteDraft.sessionActionCancelHint":
    "Der Termin wird als abgesagt markiert und zählt nicht mehr für Eltern- oder Trainerabrechnung.",
  "trainerstunden.billing.monthClose.deleteDraft.sessionActionZero":
    "Nicht berechnen (0 €)",
  "trainerstunden.billing.monthClose.deleteDraft.sessionActionZeroHint":
    "Die Trainerstunde bleibt bestätigt. Der Entwurf wird gelöscht und dieselbe Leistung erscheint nicht erneut in der Abrechnung.",
  "trainerstunden.billing.monthClose.deleteDraft.reasonRequired":
    "Bitte einen Absage-Grund auswählen.",
  "trainerstunden.billing.monthClose.deleteDraft.coordinatorPayoutTitle":
    "Soll {trainer} sein Honorar für diese Stunde trotzdem erhalten?",
  "trainerstunden.billing.monthClose.deleteDraft.coordinatorPayoutHint":
    "Diese Rechnung wird über den Trainingskoordinator gestellt. Da der Entwurf gelöscht wird, entsteht sonst keine Grundlage für die Trainerabrechnung dieser Stunde.",
  "trainerstunden.billing.monthClose.deleteDraft.coordinatorPayoutYes":
    "Ja, Trainer trotzdem auszahlen",
  "trainerstunden.billing.monthClose.deleteDraft.coordinatorPayoutNo":
    "Nein, kein Honorar für diese Stunde",
  "trainerstunden.billing.monthClose.deleteDraft.coordinatorPayoutRequired":
    "Bitte auswählen, ob der Trainer trotzdem bezahlt werden soll.",
  "trainerstunden.billing.monthClose.deleteDraft.sessionUpdateError":
    "Der Entwurf konnte nicht aktualisiert werden (Trainerstunde).",
  "trainerstunden.billing.monthClose.deleteDraft.sessionUpdateBeforeDeleteError":
    "Die Trainerstunde konnte nicht aktualisiert werden. Der Entwurf wurde nicht gelöscht.",
  "trainerstunden.billing.monthClose.deleteDraft.sessionUpdateAfterDeleteError":
    "Der Entwurf wurde gelöscht, die Trainer-Auszahlungsmarkierung konnte aber nicht gespeichert werden.",
  "trainerstunden.billing.monthClose.actionMergeOpenDrafts": {
    one: "Offene Rechnung zusammenführen",
    other: "Offene Rechnungen zusammenführen ({count})",
  },
  "trainerstunden.billing.monthClose.actionMergeOpenDraftsBusy":
    "Wird zusammengeführt …",
  "trainerstunden.billing.monthClose.autoMergeSuccess":
    "{count} Rechnungsentwürfe für {name} zusammengeführt.",
  "trainerstunden.billing.monthClose.actionSkip": "Überspringen",
  "trainerstunden.billing.monthClose.detailViewInvoice": "Rechnung ansehen",
  "trainerstunden.billing.monthClose.detailMore": "Mehr",
  "trainerstunden.billing.monthClose.detailHint":
    "Rechnung ansehen oder verschicken.",
  "trainerstunden.billing.monthClose.wizardStep":
    "Rechnung {current} von {total}",
  "trainerstunden.billing.monthClose.wizardReady": "Versandbereit",
  "trainerstunden.billing.monthClose.wizardSkip": "Überspringen",
  "trainerstunden.billing.monthClose.wizardNext": "Weiter",
  "trainerstunden.billing.monthClose.summaryTitle": "Versandübersicht",
  "trainerstunden.billing.monthClose.summarySkipped": "{name} übersprungen",
  "trainerstunden.billing.monthClose.summaryMeta": {
    one: "{count} Rechnung · {amount}",
    other: "{count} Rechnungen · {amount}",
  },
  "trainerstunden.billing.monthClose.summarySendCta": {
    one: "{count} Rechnung versenden",
    other: "{count} Rechnungen versenden",
  },
  "trainerstunden.billing.monthClose.summarySending": "Versende…",
  "trainerstunden.billing.monthClose.overdueLink": {
    one: "{count} überfällige Rechnung",
    other: "{count} überfällige Rechnungen",
  },
  "trainerstunden.billing.openItems.title": "Nächste Abrechnung",
  "trainerstunden.billing.openItems.collectedAmount": "{amount} offen",
  "trainerstunden.billing.openItems.recipientCount": {
    one: "{count} Empfänger",
    other: "{count} Empfänger",
  },
  "trainerstunden.billing.openItems.nextBillingDateLine":
    "Nächste Abrechnung: {date}",
  "trainerstunden.billing.openItems.rhythmLine": "Zahlungsrhythmus: {rhythm}",
  "trainerstunden.billing.openItems.rhythm.monthly": "Monatlich",
  "trainerstunden.billing.openItems.rhythm.quarterly": "Quartalsweise",
  "trainerstunden.billing.openItems.rhythm.afterSession": "Nach Termin",
  "trainerstunden.billing.openItems.heroMeta": {
    one: "{count} Empfänger · {amount}",
    other: "{count} Empfänger · {amount}",
  },
  "trainerstunden.billing.openItems.emptyForPeriod":
    "In {period} sind noch keine offenen Leistungen.",
  "trainerstunden.billing.openItems.hint":
    "Verdiente Leistungen, die noch nicht abgerechnet sind. Du kannst sie in die nächste Abrechnung übernehmen oder einzelne Empfänger über das Menü sofort abrechnen. Vorhandene Entwürfe unter Abrechnen werden dabei ergänzt.",
  "trainerstunden.billing.openItems.manualBillingCta":
    "Jetzt manuell abrechnen",
  "trainerstunden.billing.openItems.billNowCta": "Jetzt abrechnen",
  "trainerstunden.billing.openItems.billNowBusy": "Wird gebündelt …",
  "trainerstunden.billing.openItems.recipientMenuAria":
    "Aktionen für Empfänger",
  "trainerstunden.billing.openItems.lineCountBadge": {
    one: "{count} Leistung",
    other: "{count} Leistungen",
  },
  "trainerstunden.billing.openItems.expandSessionsAria": {
    one: "Training anzeigen",
    other: "{count} Trainings anzeigen",
  },
  "trainerstunden.billing.openItems.collapseSessionsAria":
    "Trainings ausblenden",
  "trainerstunden.billing.workQueue.prepareInvoiceCta": "Rechnung vorbereiten",
  "trainerstunden.billing.workQueue.phasePrepareMeta":
    "{recipients} Empfänger · {unbundledLines} noch nicht gebündelt ({unbundledAmount} €) · {draftCount} Entwürfe ({bundledAmount} €)",
  "trainerstunden.billing.workQueue.phasePrepareEmpty":
    "Keine offenen Abrechnungsaufgaben für diesen Zeitraum.",
  "trainerstunden.billing.workQueue.rowStatusUnbundled": "Noch nicht gebündelt",
  "trainerstunden.billing.workQueue.rowStatusBundled": "Entwurf",
  "trainerstunden.billing.workQueue.rowStatusSendReady": "Versandbereit",
  "trainerstunden.billing.workQueue.rowStatusOpenLines":
    "Noch offene Leistungen",
  "trainerstunden.billing.workQueue.phasePrepareSendReadyOnly": {
    one: " · {count} Empfänger versandbereit",
    other: " · {count} Empfänger versandbereit",
  },
  "trainerstunden.billing.workQueue.phasePrepareSendBlockedOnly": {
    one: " · {count} Empfänger mit offenen Leistungen",
    other: " · {count} Empfänger mit offenen Leistungen",
  },
  "trainerstunden.billing.workQueue.phasePrepareSendBoth":
    " · {sendReady} versandbereit, {sendBlocked} mit offenen Leistungen",
  "trainerstunden.billing.workQueue.rowMetaUnbundled": {
    one: "{count} Leistung · {amount} €",
    other: "{count} Leistungen · {amount} €",
  },
  "trainerstunden.billing.workQueue.rowMetaUnbundledCount": {
    one: "{count} Leistung",
    other: "{count} Leistungen",
  },
  "trainerstunden.billing.workQueue.changeInvoiceRecipient":
    "Rechnungsempfänger ändern",
  "trainerstunden.billing.workQueue.invoiceRecipient.title":
    "Rechnungsempfänger ändern",
  "trainerstunden.billing.workQueue.invoiceRecipient.subtitle":
    "Die Zuordnung gilt für alle offenen Leistungen dieses Spielers. Nach dem Speichern werden sie unter dem gewählten Empfänger gebündelt.",
  "trainerstunden.billing.workQueue.invoiceRecipient.playerLabel": "Spieler",
  "trainerstunden.billing.workQueue.invoiceRecipient.currentSelf":
    "Aktuell: Rechnung an {name} selbst",
  "trainerstunden.billing.workQueue.invoiceRecipient.currentContact":
    "Aktuell: Rechnungen für {player} gehen an {contact}",
  "trainerstunden.billing.workQueue.invoiceRecipient.suggestionsLabel":
    "Vorschläge aus Beziehungen",
  "trainerstunden.billing.workQueue.invoiceRecipient.loadingRelationships":
    "Beziehungen werden geladen …",
  "trainerstunden.billing.workQueue.invoiceRecipient.contactSearchPlaceholder":
    "Vereinskontakt suchen …",
  "trainerstunden.billing.workQueue.invoiceRecipient.contactSearchAria":
    "Rechnungsempfänger suchen",
  "trainerstunden.billing.workQueue.invoiceRecipient.contactSearchNoResults":
    "Kein passender Kontakt gefunden.",
  "trainerstunden.billing.workQueue.invoiceRecipient.contactSearchClear":
    "Auswahl löschen",
  "trainerstunden.billing.workQueue.invoiceRecipient.save": "Speichern",
  "trainerstunden.billing.workQueue.invoiceRecipient.saving": "Speichern …",
  "trainerstunden.billing.workQueue.invoiceRecipient.successContact":
    "Gespeichert. Offene Leistungen von {player} erscheinen jetzt unter {contact}.",
  "trainerstunden.billing.workQueue.invoiceRecipient.successSelf":
    "Gespeichert. Offene Leistungen von {player} erscheinen jetzt unter {player}.",
  "trainerstunden.billing.workQueue.invoiceRecipient.errorAlreadyAssigned":
    "Für diesen Spieler ist bereits ein anderer Rechnungsempfänger hinterlegt.",
  "trainerstunden.billing.workQueue.rowMetaBundled": {
    one: "{statements} Entwurf · {lines} Leistung · {amount} €",
    other: "{statements} Entwürfe · {lines} Leistungen · {amount} €",
  },
  "trainerstunden.billing.workQueue.rowMetaBoth":
    "Noch {unbundledLines} Leistungen ({unbundledAmount} €) · {draftStatements} Entwürfe mit {bundledLines} Leistungen ({bundledAmount} €)",
  "trainerstunden.billing.workQueue.phasePendingTitle": "1. Offene Leistungen",
  "trainerstunden.billing.workQueue.phasePendingMeta": {
    one: "{lines} Leistung · {recipients} Empfänger · {amount} €",
    other: "{lines} Leistungen · {recipients} Empfänger · {amount} €",
  },
  "trainerstunden.billing.workQueue.phasePendingEmpty":
    "Keine offenen Leistungen für diesen Zeitraum.",
  "trainerstunden.billing.workQueue.recipientLineMeta": {
    one: "{count} Leistung · {amount} €",
    other: "{count} Leistungen · {amount} €",
  },
  "trainerstunden.billing.workQueue.moreRecipients": {
    one: "… und {count} weiterer Empfänger",
    other: "… und {count} weitere Empfänger",
  },
  "trainerstunden.billing.workQueue.showAllRecipients":
    "Alle {count} Empfänger anzeigen",
  "trainerstunden.billing.workQueue.showFewerRecipients": "Weniger anzeigen",
  "trainerstunden.billing.workQueue.showLines":
    "{count} Trainingsstunden anzeigen",
  "trainerstunden.billing.workQueue.hideLines": "Leistungen ausblenden",
  "trainerstunden.billing.workQueue.linesSectionAria": "Leistungspositionen",
  "trainerstunden.billing.workQueue.lineStatusDraft": "Entwurf",
  "trainerstunden.billing.workQueue.lineStatusConfirmed": "Bestätigt",
  "trainerstunden.billing.workQueue.viewSwitchAria":
    "Darstellung des Arbeitsstapels",
  "trainerstunden.billing.workQueue.viewRecipients": "Nach Empfänger",
  "trainerstunden.billing.workQueue.viewSessions": "Nach Terminen",
  "trainerstunden.billing.workQueue.sessionViewAria":
    "Abrechnungs-Arbeitsstapel nach Terminen",
  "trainerstunden.billing.workQueue.sessionSectionCurrent":
    "Termine im Abrechnungsmonat",
  "trainerstunden.billing.workQueue.sessionSectionCarryover":
    "Offene Posten aus früheren Monaten",
  "trainerstunden.billing.workQueue.sessionDayBadge": {
    one: "{count} Termin",
    other: "{count} Termine",
  },
  "trainerstunden.billing.workQueue.sessionDayBadgeAria": {
    one: "{count} Termin an diesem Tag",
    other: "{count} Termine an diesem Tag",
  },
  "trainerstunden.billing.workQueue.sessionRowMeta":
    "{lines} Leistungen · {recipients} Empfänger · {amount} €",
  "trainerstunden.billing.workQueue.sessionShowLines":
    "{count} Leistungen anzeigen",
  "trainerstunden.billing.workQueue.sessionHideLines": "Leistungen ausblenden",
  "trainerstunden.billing.workQueue.sessionLineRecipient": "Rechnung an {name}",
  "trainerstunden.billing.workQueue.sessionPatternTitle": {
    one: "{count}× {weekday} · {timeRange}",
    other: "{count}× {weekday} · {timeRange}",
  },
  "trainerstunden.billing.workQueue.sessionPatternMeta":
    "{sessions} Termine · {lines} offene Leistungen · {amount} €",
  "trainerstunden.billing.workQueue.sessionPatternBundleCta": {
    one: "{count} offene Leistung bündeln",
    other: "{count} offene Leistungen bündeln",
  },
  "trainerstunden.billing.workQueue.sessionPatternShowInstances": {
    one: "{count} Termin anzeigen",
    other: "{count} Termine anzeigen",
  },
  "trainerstunden.billing.workQueue.sessionPatternHideInstances":
    "Termine ausblenden",
  "trainerstunden.billing.workQueue.sessionPatternInstancesAria":
    "Einzeltermine im Muster",
  "trainerstunden.billing.workQueue.sessionInstanceMeta":
    "{count} offene Leistungen · {amount} €",
  "trainerstunden.billing.workQueue.sessionPatternEmpty":
    "Keine offenen Termine mit noch nicht gebündelten Leistungen.",
  "trainerstunden.billing.workQueue.sessionBundleCta": {
    one: "{count} offene Leistung bündeln",
    other: "{count} offene Leistungen bündeln",
  },
  "trainerstunden.billing.workQueue.sessionBundleBusy": "Wird gebündelt …",
  "trainerstunden.billing.workQueue.sessionTrainerFilterLabel": "Trainer",
  "trainerstunden.billing.workQueue.sessionTrainerFilterAria":
    "Termine nach Trainer filtern",
  "trainerstunden.billing.workQueue.sessionTrainerFilterAll": "Alle Trainer",
  "trainerstunden.billing.workQueue.sessionFilterEmpty":
    "Keine offenen Termine für diesen Filter.",
  "trainerstunden.billing.workQueue.prepareAllCta":
    "Alle Rechnungen vorbereiten",
  "trainerstunden.billing.workQueue.prepareAllCtaShort": "Alle vorbereiten",
  "trainerstunden.billing.workQueue.bundleAllCta":
    "Noch offene Leistungen bündeln",
  "trainerstunden.billing.workQueue.bundleAllOpenCta": "Rechnung erstellen",
  "trainerstunden.billing.workQueue.bundleSelectedCta":
    "Ausgewählte Leistungen bündeln",
  "trainerstunden.billing.unbundledBundle.panelAria":
    "Offene Leistungen bündeln",
  "trainerstunden.billing.unbundledBundle.linesAria":
    "Offene Leistungen zur Auswahl",
  "trainerstunden.billing.unbundledBundle.selectHint":
    "Wähle die Leistungen aus, die in den Rechnungsentwurf übernommen werden sollen.",
  "trainerstunden.billing.unbundledBundle.lineTrainer": "Trainer: {name}",
  "trainerstunden.billing.unbundledBundle.multiTrainerHint":
    "Die Auswahl enthält Leistungen bei {count} Trainern – es werden getrennte Rechnungsentwürfe je Trainer erstellt (jeweils als eigene Karte, getrennt versendbar).",
  "trainerstunden.billing.unbundledBundle.multiTrainerCoordinatorHint":
    "Wähle den Rechnungssteller. Standard (vorausgewählt): Trainingskoordinator — eine gemeinsame Rechnung, Zahlungseingang beim Koordinator; Auszahlungen an die Trainer danach separat.",
  "trainerstunden.billing.draftIssuerMeta": "Rechnungssteller: {name}",
  "trainerstunden.billing.unbundledBundle.footerSummary":
    "{selected} von {total} Leistungen · {amount} €",
  "trainerstunden.billing.unbundledBundle.busy": "Wird gebündelt …",
  "trainerstunden.billing.bundleWorkspace.back": "Abbrechen und zurück",
  "trainerstunden.billing.bundleWorkspace.title": "Leistungen bündeln",
  "trainerstunden.billing.bundleWorkspace.lead":
    "Wähle die Leistungen und den Rechnungssteller. Danach wird ein Rechnungsentwurf erstellt.",
  "trainerstunden.billing.bundleWorkspace.openCta": "Leistungen bündeln",
  "trainerstunden.billing.bundleWorkspace.openLink":
    "Leistungen auswählen und bündeln",
  "trainerstunden.billing.bundleWorkspace.empty":
    "Für diesen Empfänger gibt es keine offenen Leistungen mehr.",
  "trainerstunden.billing.workQueue.selectLinesCta": "Einzeln auswählen",
  "trainerstunden.billing.workQueue.phaseDraftsTitle": "2. Rechnungsentwürfe",
  "trainerstunden.billing.workQueue.phaseDraftsMeta": {
    one: "{count} Entwurf · {recipients} Empfänger · {amount} €",
    other: "{count} Entwürfe · {recipients} Empfänger · {amount} €",
  },
  "trainerstunden.billing.workQueue.phaseDraftsEmpty":
    "Keine gespeicherten Entwürfe – zuerst Leistungen vorbereiten.",
  "trainerstunden.billing.workQueue.draftGroupMeta": {
    one: "{statements} Rechnung · {lines} Leistung · {amount} €",
    other: "{statements} Rechnungen · {lines} Leistungen · {amount} €",
  },
  "trainerstunden.billing.workQueue.reviewDraftsCta": {
    one: "{count} Entwurf prüfen",
    other: "{count} Entwürfe prüfen",
  },
  "trainerstunden.billing.workQueue.reviewDraftsCtaWithSendReady": {
    one: "{count} Entwurf prüfen ({ready} versandbereit)",
    other: "{count} Entwürfe prüfen ({ready} versandbereit)",
  },
  "trainerstunden.billing.workQueue.phaseDraftsHint":
    "Nach dem Prüfen Rechnungen versenden; Zahlungen werden im Tab „Zahlungen“ erfasst.",
  "trainerstunden.billing.workQueue.phasePrepareHint":
    "Zuerst bündeln, dann Entwürfe prüfen und als versendet markieren. Erst danach sind es echte Rechnungen in der Rechnungsübersicht.",
  "trainerstunden.billing.workQueue.draftLifecycleHint":
    "Entwürfe verschwinden im Arbeitsstapel erst nach „Als versendet markieren“ — das bloße Öffnen von WhatsApp oder E-Mail reicht nicht.",
  "trainerstunden.billing.workQueue.phaseCorrectionsTitle":
    "2. Korrekturen und Gutschriften",
  "trainerstunden.billing.workQueue.phaseCorrectionsSub":
    "Nur Entwürfe und zur Bestätigung – gebuchte Einträge im Rechnungsverlauf.",
  "trainerstunden.billing.workQueue.actionableCorrectionsEmpty":
    "Keine offenen Korrekturen in diesem Zeitraum.",
  "trainerstunden.billing.workQueue.pipelineClear":
    "Für {period}: Abrechnung ist gebündelt und versandbereit erledigt. Korrekturen siehe unten.",
  "trainerstunden.billing.workQueue.pipelineClearOpen":
    "Alle offenen Leistungen sind vorbereitet oder versendet. Korrekturen siehe unten.",
  "trainerstunden.billing.overview.metrics.carryFootnote":
    "Offene Leistungen und Entwürfe aus früheren Monaten fließen in die Kennzahlen ein (bis einschließlich {period}).",
  "trainerstunden.billing.carryover.summaryHintOpenLinesEarlier":
    "Offene Leistungen auch aus {periods}.",
  "trainerstunden.billing.carryover.summaryHintDraftsEarlier":
    "Offene Entwürfe aus {periods}.",
  "trainerstunden.billing.carryover.summaryHintPaymentsEarlier":
    "Noch offene Beträge aus früheren Monaten.",
  "trainerstunden.billing.carryover.summaryHintCorrectionsEarlier":
    "Korrekturen mit Bezug auf frühere Abrechnungsmonate.",
  "trainerstunden.billing.carryover.inboxCardFootnote":
    "Aus früherem Monat: {period}.",
  "trainerstunden.billing.openLineReset.cta": "Bestätigung zurücksetzen",
  "trainerstunden.billing.openLineReset.title":
    "Leistung aus Abrechnung nehmen",
  "trainerstunden.billing.openLineReset.lead":
    "Die Position verschwindet aus der offenen Abrechnung. Du kannst das Training absagen oder nur die Anwesenheitsbestätigung zurücknehmen.",
  "trainerstunden.billing.openLineReset.modeLegend": "Was ist passiert?",
  "trainerstunden.billing.openLineReset.modeCancelTitle":
    "Training hat nicht stattgefunden",
  "trainerstunden.billing.openLineReset.modeCancelHint":
    "Training als abgesagt markieren — erscheint nicht mehr in der Abrechnung.",
  "trainerstunden.billing.openLineReset.modeResetTitle":
    "Nur Bestätigung zurücksetzen",
  "trainerstunden.billing.openLineReset.modeResetHint":
    "Training bleibt geplant — Anwesenheit kann in Termine neu bestätigt werden.",
  "trainerstunden.billing.openLineReset.confirm": "Übernehmen",
  "trainerstunden.billing.openLineReset.busy": "Speichern…",
  "trainerstunden.billing.openLineReset.errorCancelReason":
    "Bitte einen Absagegrund wählen.",
  "trainerstunden.billing.openLineReset.errorGeneric":
    "Speichern fehlgeschlagen. Bitte erneut versuchen.",
  "trainerstunden.billingWorkspace.aria": "Abrechnung Überblick",
  "trainerstunden.billingWorkspace.title": "Übersicht",
  "trainerstunden.billingWorkspace.subtitle": "{period}",
  "trainerstunden.billingWorkspace.quickLinksAria":
    "Weitere Abrechnungsansichten",
  "trainerstunden.billingWorkspace.linkInvoiceHistory":
    "Rechnungsübersicht (versendet)",
  "trainerstunden.billingWorkspace.linkPaymentReceipts": "Zahlungseingänge",
  "trainerstunden.billingWorkspace.card.openServicesTitle": "Offene Leistungen",
  "trainerstunden.billingWorkspace.card.openServicesMeta": {
    one: "Eine bestätigte Leistung noch nicht in einer laufenden Abrechnung",
    other:
      "{count} bestätigte Leistungen noch nicht in einer laufenden Abrechnung",
  },
  "trainerstunden.billingWorkspace.card.openServicesMetaUnavailable":
    "Anzahl aktuell nicht verfügbar",
  "trainerstunden.billingWorkspace.card.draftsTitle": "Entwürfe",
  "trainerstunden.billingWorkspace.card.draftsMeta": {
    one: "Ein gespeicherter Entwurf in diesem Monat",
    other: "{count} gespeicherte Entwürfe in diesem Monat",
  },
  "trainerstunden.billingWorkspace.card.settledTitle": "Abgerechnet",
  "trainerstunden.billingWorkspace.card.settledMeta": {
    one: "Eine Rechnung bereits versendet oder mit Zahlung",
    other: "{count} Rechnungen bereits versendet oder mit Zahlung",
  },
  "trainerstunden.billingWorkspace.card.correctionsTitle": "Korrekturen",
  "trainerstunden.billingWorkspace.card.correctionsMeta": {
    one: "Ein Korrektur-Eintrag in diesem Monat",
    other: "{count} Korrektur-Einträge in diesem Monat",
  },
  "trainerstunden.billingWorkspace.value.emDash": "–",
  "trainerstunden.billingWorkspace.value.count": "{count}",
  "trainerstunden.billingWorkspace.chip.stillOpen": "Noch offen",
  "trainerstunden.billingWorkspace.chip.allCaptured": "Alles erfasst",
  "trainerstunden.billingWorkspace.chip.inDraft": "Im Entwurf",
  "trainerstunden.billingWorkspace.chip.noDrafts": "Keine Entwürfe",
  "trainerstunden.billingWorkspace.chip.settled": "Bereits abgerechnet",
  "trainerstunden.billingWorkspace.chip.notYetSettled": "Noch nicht versendet",
  "trainerstunden.billingWorkspace.chip.correctionsPresent": "Vorhanden",
  "trainerstunden.billingWorkspace.chip.noCorrections": "Keine Einträge",
  "trainerstunden.billingWorkspace.summary.actionOpenLines": {
    one: "1 Leistung abrechnen",
    other: "{count} Leistungen abrechnen",
  },
  "trainerstunden.billingWorkspace.summary.actionDrafts": {
    one: "1 Rechnungsentwurf prüfen",
    other: "{count} Rechnungsentwürfe prüfen",
  },
  "trainerstunden.billingWorkspace.summary.actionSettledInvoices": {
    one: "1 versendete Rechnung ansehen",
    other: "{count} versendete Rechnungen ansehen",
  },
  "trainerstunden.billingWorkspace.summary.actionOpenPayments": {
    one: "1 offenen Betrag verfolgen",
    other: "{count} offene Beträge verfolgen",
  },
  "trainerstunden.billingWorkspace.summary.metaOpenPayments": {
    one: "Eine Rechnung mit offenem oder teilweise beglichenem Betrag",
    other: "{count} Rechnungen mit offenen Beträgen",
  },
  "trainerstunden.billingWorkspace.summary.actionCorrections": {
    one: "1 Korrektur prüfen",
    other: "{count} Korrekturen prüfen",
  },
  "trainerstunden.billingWorkspace.summary.ctaShow": "Anzeigen",
  "trainerstunden.billingWorkspace.summary.attentionDrafts":
    "Vor Versand prüfen und abschließen.",
  "trainerstunden.billingWorkspace.summary.attentionOpenPayments":
    "Zahlungen offen oder Teilzahlung.",
  "trainerstunden.billingWorkspace.summary.attentionCorrections":
    "Buchungen und Auswirkungen prüfen.",
  "trainerstunden.billing.summary.previousOpen.title": {
    one: "1 unbezahlte Rechnung aus früheren Monaten",
    other: "{count} unbezahlte Rechnungen aus früheren Monaten",
  },
  "trainerstunden.billing.summary.previousOpen.meta": "Offen gesamt: {amount}",
  "trainerstunden.billing.summary.previousOpen.hint":
    "Bitte Zahlungseingänge prüfen oder Rechnungen nachverfolgen.",
  "trainerstunden.billing.summary.previousOpen.cta": "Anzeigen",
  "trainerstunden.billing.summary.previousOpen.sectionLead":
    "Zu einem Monat wechseln, um die offenen Rechnungen zu bearbeiten:",
  "trainerstunden.billing.summary.unconfirmedTraining.title": {
    one: "Eine unbestätigte Trainingsstunde",
    other: "{count} unbestätigte Trainingsstunden",
  },
  "trainerstunden.billing.summary.unconfirmedTraining.meta":
    "Noch nicht abrechnungsbereit",
  "trainerstunden.billing.summary.unconfirmedTraining.hint":
    "Bitte Stunden bestätigen, bevor sie abgerechnet werden können.",
  "trainerstunden.billing.summary.unconfirmedTraining.cta": "Stunden prüfen",
  "trainerstunden.billing.summary.recentSentOpen.title": {
    one: "Eine Rechnung neu versandt (bis 14 Tage)",
    other: "{count} Rechnungen neu versandt (bis 14 Tage)",
  },
  "trainerstunden.billing.summary.recentSentOpen.hint":
    "Versand liegt in den letzten 14 Tagen – Zahlungseingang prüfen und offene Beträge nachverfolgen.",
  "trainerstunden.billing.summary.recentSentOpen.sectionLead":
    "Versendet in den letzten 14 Tagen, mit noch offenem Betrag (alle Monate):",
  "trainerstunden.billing.summary.recentSentOpen.panelTitle":
    "Neu versandt (≤ 14 Tage)",
  "trainerstunden.billing.summary.recentSentOpen.panelAria":
    "Kürzlich versendete Rechnungen mit offenem Betrag",
  "trainerstunden.billing.summary.staleReceivable.title": {
    one: "Eine Rechnung mit offenem Betrag (älter als 14 Tage)",
    other: "{count} Rechnungen mit offenem Betrag (älter als 14 Tage)",
  },
  "trainerstunden.billing.summary.staleReceivable.hint":
    "Vor mehr als 14 Tagen erstellt – Zahlungseingang verbuchen oder Mahnung prüfen.",
  "trainerstunden.billing.summary.staleReceivable.sectionLead":
    "Erstellt vor über 14 Tagen, noch nicht beglichen (alle Monate, inkl. älterer Entwürfe mit offenem Anteil):",
  "trainerstunden.billing.summary.staleReceivable.panelTitle":
    "Offen seit über 14 Tagen",
  "trainerstunden.billing.summary.staleReceivable.panelAria":
    "Ältere offene Rechnungen und Entwürfe",
  "trainerstunden.billing.summary.receivableOpenTotalMeta":
    "Offen gesamt: {amount}",
  "trainerstunden.billing.paymentFollowUpCard.title": {
    one: "1 unbezahlte Rechnung",
    other: "{count} unbezahlte Rechnungen",
  },
  "trainerstunden.billing.paymentFollowUpCard.hint":
    "Bitte Zahlungseingänge prüfen oder Rechnungen nachverfolgen.",
  "trainerstunden.billing.paymentFollowUpCard.cta": "Zahlungen prüfen",
  "trainerstunden.paymentReceipts.pageTitle": "Einnahmen",
  "trainerstunden.paymentReceipts.pageSubtitle":
    "Zahlungseingänge verbuchen und Einnahmen nachverfolgen",
  "trainerstunden.paymentReceipts.globalOverviewAria":
    "Gesamtübersicht offener Zahlungen",
  "trainerstunden.paymentReceipts.globalOverviewTitle": "Gesamt offen",
  "trainerstunden.paymentReceipts.globalOverviewMeta":
    "{count} offene Rechnungen · {recipients} Empfänger",
  "trainerstunden.paymentReceipts.globalOverviewOverdue": "{count} überfällig",
  "trainerstunden.paymentReceipts.globalOverviewOverdueAria":
    "{count} überfällige Rechnungen anzeigen oder Filter zurücknehmen",
  "trainerstunden.paymentReceipts.overdueFilterActive":
    "Filter aktiv: nur überfällige Rechnungen.",
  "trainerstunden.paymentReceipts.overdueFilterSectionAria":
    "Überfällige Rechnungen",
  "trainerstunden.paymentReceipts.overdueFilterSectionTitle":
    "Überfällige Rechnungen",
  "trainerstunden.paymentReceipts.overdueFilterSectionLead":
    "Fälligkeit überschritten — Zahlungserinnerung oder Mahnung versenden.",
  "trainerstunden.paymentReceipts.overdueFilterEmptyTitle":
    "Keine überfälligen Rechnungen",
  "trainerstunden.paymentReceipts.overdueFilterEmptyBody":
    "Mit den aktuellen Filtern gibt es keine überfälligen offenen Rechnungen.",
  "trainerstunden.paymentReceipts.openSectionAria": "Offene Rechnungen",
  "trainerstunden.paymentReceipts.openSectionTitle": "Offen",
  "trainerstunden.paymentReceipts.openSectionLead":
    "Noch nicht vollständig bezahlt — Zahlung erfassen oder erinnern.",
  "trainerstunden.paymentReceipts.paidSectionTitle": "Bezahlt ({count})",
  "trainerstunden.paymentReceipts.cancelledSectionTitle": "Storniert ({count})",
  "trainerstunden.paymentReceipts.searchResultsAria": "Gefilterte Rechnungen",
  "trainerstunden.paymentReceipts.searchResultsTitle": "{count} Rechnungen",
  "trainerstunden.paymentReceipts.searchResultsLead":
    "Treffer zur Zahlungserfassung — offene Forderungen findest du unter Abrechnung.",
  "trainerstunden.paymentReceipts.searchEmptyTitle": "Keine Treffer",
  "trainerstunden.paymentReceipts.searchEmptyBody":
    "Passe Suche oder Filter an — oder setze alle Filter zurück.",
  "trainerstunden.paymentReceipts.emptyNoSearchTitle": "Keine Suche aktiv",
  "trainerstunden.paymentReceipts.emptyNoSearchBody":
    "Nutze die Suche, um eine Rechnung für die Zahlungserfassung zu finden. Offene Forderungen siehst du unter Abrechnung → Unbezahlt.",
  "trainerstunden.paymentReceipts.filterMonthLabel": "Monat (Filter)",
  "trainerstunden.paymentReceipts.filterMonthAria": "Rechnungsmonat filtern",
  "trainerstunden.paymentReceipts.summaryAria":
    "Zahlungsübersicht für den gewählten Monat",
  "trainerstunden.paymentReceipts.monthStatementsTitle": "Rechnungen im Monat",
  "trainerstunden.paymentReceipts.allClearTitle": "Keine offenen Zahlungsfälle",
  "trainerstunden.paymentReceipts.allClearBody":
    "Aktuell liegen keine offenen Rechnungen vor.",
  "trainerstunden.billingInvoiceHistory.pageTitle": "Rechnungsübersicht",
  "trainerstunden.billingInvoiceHistory.pageSubtitle":
    "Historie aller erstellten Rechnungen nach Rechnungsmonat: versendet, bezahlt, storniert und gespeicherte Entwürfe.",
  "trainerstunden.billingInvoiceHistory.emptyTitle":
    "Keine Rechnungen gefunden",
  "trainerstunden.billingInvoiceHistory.emptyBody":
    "Sobald Rechnungen erstellt, versendet oder storniert wurden, erscheinen sie hier.",
  "trainerstunden.billingInvoiceHistory.emptyBodySearch":
    "Für die gewählten Filter liegen aktuell keine Rechnungen vor.",
  "trainerstunden.billingInvoiceHistory.emptyBodyStatus":
    "Für „{status}“ liegen aktuell keine Rechnungen vor.",
  "trainerstunden.billingInvoiceHistory.searchPromptTitle":
    "Rechnungsarchiv durchsuchen",
  "trainerstunden.billingInvoiceHistory.searchPromptBody":
    "Wähle mindestens ein Suchkriterium — z. B. Empfänger, Rechnungsmonat, Trainer, Rechnungsnummer oder Status.",
  "trainerstunden.billingInvoiceHistory.emptyBodyFiltered":
    "Für den Filter „{filter}“ gibt es noch keine Einträge. Wechsle die Ansicht oder prüfe einen anderen Monat.",
  "trainerstunden.billingInvoiceHistory.monthSectionAria":
    "Rechnungen mit Rechnungsdatum im Monat {period}",
  "trainerstunden.billingPhase8.nextPaymentReceipts":
    "Es gibt Rechnungen mit offenem oder teilweise bezahltem Betrag.",
  "trainerstunden.billingPhase8.nextPaymentReceiptsCta": "Zahlungen prüfen",
  "trainerstunden.billing.detailPanel.backCta": "Zurück zur Übersicht",
  "trainerstunden.billingWorkspace.allClearBody":
    "Für {period} gibt es aktuell keine offenen Rechnungsaufgaben.",
  "trainerstunden.billingWorkspace.allClearHint":
    "Neue Leistungen entstehen nach bestätigten Trainings.",
  "trainerstunden.billingWorkspace.prepareInvoices": "Rechnung vorbereiten",
  "trainerstunden.billingWorkspace.workAreaTitle": "Rechnungen bearbeiten",
  "trainerstunden.billingWorkspace.workAreaHint":
    "Hier bearbeitest du Entwürfe und Rechnungen für den gewählten Monat: Versand prüfen und Zahlungen erfassen.",
  "trainerstunden.billing.openItem.performanceLockedExplanation":
    "Diese Leistung wurde bereits ganz oder teilweise abgerechnet oder in den Abrechnungslauf übernommen — auch wenn ein anderer Teilnehmer desselben Trainings schon erfasst wurde. Änderungen sind nur noch über eine Korrektur möglich.",
  "trainerstunden.billing.openItem.recordCorrectionCta": "Korrektur erfassen",
  "trainerstunden.billing.openItem.gotoSessionCta": "Zur Trainingsstunde",
  "trainerstunden.billing.openItem.gotoSessionHint":
    "Tippen, um die Trainingsstunde zu öffnen und die Teilnahme zu bestätigen.",
  "trainerstunden.billing.openItem.gotoSessionAria":
    "Trainingsstunde für {person} am {date} öffnen",
  "trainerstunden.billing.draftConsolidate.selectLineAria":
    "Leistung für {person} in den Entwurf übernehmen",
  "trainerstunden.billing.openItem.performanceBlockedMaterialized":
    "Mindestens eine Abrechnungszeile zu diesem Training existiert bereits (Entwurf oder weiter).",
  "trainerstunden.billing.openItem.performanceBlockedCorrectionBooked":
    "Zu diesem Training gibt es gebuchte Korrekturbuchungen.",
  "trainerstunden.billing.openItem.performanceBlockedCorrectionPipeline":
    "Zu diesem Training liegt eine Korrektur vor oder sie wird gerade bearbeitet.",
  "trainerstunden.billing.openItem.correctionBlockedOtherPlayerSent":
    "Für einen anderen Teilnehmer dieses Trainings wurde bereits eine Rechnung verschickt — bitte stornieren und neu abrechnen.",
  "trainerstunden.billing.openItem.correctionBlockedSentInvoice":
    "Für diese Leistung wurde bereits eine Rechnung verschickt — bitte stornieren und neu abrechnen.",
  "trainerstunden.billingInbox.sectionAria": "Offene Leistungen nach Empfänger",
  "trainerstunden.billingInbox.title": "Unbestätigte Trainingsstunden",
  "trainerstunden.billingInbox.lead":
    "Hier siehst du, für wen noch Trainingsanteile offen sind. Bei Gruppen sind das einzelne Teilnehmeranteile – nicht automatisch die ganze Gruppe.",
  "trainerstunden.billingInbox.targetedPrepareHint":
    "Du kannst mehrere Entwürfe im gleichen Zeitraum erstellen. Bereits übernommene Leistungen sind geschützt und werden nicht doppelt abgerechnet. Alle offenen Empfänger auf einmal weiterhin über die Monatsaktion „Rechnung vorbereiten“ unten.",
  "trainerstunden.billingInbox.emptyTitle": "Keine offenen Leistungen",
  "trainerstunden.billingInbox.emptyBody":
    "Bestätigte Stunden erscheinen hier, sobald sie noch nicht abgerechnet wurden.",
  "trainerstunden.billingInbox.goToMonthPrepare": "Zur Monatsvorbereitung",
  "trainerstunden.billingInbox.detailsLead":
    "Diese Trainingsanteile sind in diesem Monat noch nicht abgerechnet.",
  "trainerstunden.billingInbox.showItems": "Leistungen anzeigen",
  "trainerstunden.billingInbox.hideItems": "Leistungen ausblenden",
  "trainerstunden.billingInbox.openCountMeta": {
    one: "Eine offene Leistung",
    other: "{count} offene Leistungen",
  },
  "trainerstunden.billingInbox.periodLine": "{period}",
  "trainerstunden.billingInbox.playersLine": "Spieler: {names}",
  "trainerstunden.billingInbox.preparePanelAria": "Rechnung vorbereiten",
  "trainerstunden.billingInbox.prepareTitle": "Leistungen auswählen",
  "trainerstunden.billingInbox.prepareRecipient": "Empfänger: {name}",
  "trainerstunden.billingInbox.prepareSelectHint": "Ausgewählte Leistungen",
  "trainerstunden.billingInbox.preparePartialHint":
    "Nur ausgewählte Leistungen werden in den Entwurf übernommen. Diese Leistungen bleiben offen, die du abwählst.",
  "trainerstunden.billingInbox.prepareLinesAria":
    "Auswahl der offenen Leistungen",
  "trainerstunden.billingInbox.prepareClose": "Schließen",
  "trainerstunden.billingInbox.prepareCreateDraft": "Entwurf erstellen",
  "trainerstunden.billingInbox.prepareBusy": "Wird erstellt …",
  "trainerstunden.billingInbox.prepareStickySummary":
    "{count} Leistungen · {amount} €",
  "trainerstunden.billingInbox.prepareSuccess": "Entwurf wurde erstellt.",
  "trainerstunden.billingInbox.prepareSuccessPartial":
    "Entwurf wurde erstellt. {count} ausgewählte Leistungen waren inzwischen nicht mehr frei und wurden übersprungen.",
  "trainerstunden.billingInbox.prepareErrorDuplicateSessionPerson":
    "Mindestens eine ausgewählte Leistung ist bereits in einem anderen aktiven Entwurf oder einer Rechnung enthalten. Bitte Auswahl aktualisieren.",
  "trainerstunden.billingInbox.prepareErrorUniqueConstraint":
    "Die Datenbank hat die Aktion abgelehnt (Eindeutigkeit). Bitte Seite neu laden und erneut versuchen.",
  "trainerstunden.billingInbox.prepareErrorAlreadyBilled":
    "Bereits in Entwurf oder Rechnung enthalten. Bitte Auswahl aktualisieren.",
  "trainerstunden.billingInbox.prepareErrorNoSelection":
    "Bitte mindestens eine Leistung auswählen.",
  "trainerstunden.billingInbox.prepareErrorCreateFailed":
    "Der Entwurf konnte nicht erstellt werden.",
  "trainerstunden.billingInbox.prepareErrorGeneric":
    "Der Entwurf konnte nicht erstellt werden. Bitte erneut versuchen.",
  "trainerstunden.billingInbox.prepareErrorNoInboxRow":
    "Die Leistungen konnten keinem Abrechnungsmonat zugeordnet werden. Bitte Seite neu laden.",
  "trainerstunden.billingInbox.prepareErrorRecipientMismatch":
    "Empfänger der ausgewählten Leistungen passt nicht zusammen. Bitte getrennt bündeln.",
  "trainerstunden.billingInbox.prepareErrorMixedSessionTrainers":
    "Die ausgewählten Leistungen gehören zu unterschiedlichen Trainern. Bitte je Trainer getrennt bündeln.",
  "trainerstunden.billingInbox.prepareErrorInvalidSessionMonth":
    "Mindestens eine Leistung gehört nicht zum gewählten Abrechnungsmonat.",
  "trainerstunden.billingInbox.prepareErrorInvalidSession":
    "Mindestens eine Leistung ist noch nicht bestätigt und kann noch nicht abgerechnet werden.",
  "trainerstunden.billingInbox.prepareErrorAmountZero":
    "Mindestens eine Leistung hat keinen gültigen Betrag.",
  "trainerstunden.billingInbox.prepareErrorNoValidLines":
    "Es konnten keine abrechenbaren Leistungen gefunden werden.",
  "trainerstunden.billingInbox.prepareErrorNoTargetDraft":
    "Für mindestens eine Leistung fehlt ein Entwurf im passenden Abrechnungsmonat. Bitte die Leistungen nach Monat getrennt bündeln oder Seite neu laden.",
  "trainerstunden.billingInbox.prepareErrorAttendanceDispute":
    "Mindestens eine Leistung hat einen offenen Anwesenheits-Einwand und kann noch nicht abgerechnet werden.",
  "trainerstunden.billingInbox.prepareErrorMissingPerson":
    "Teilnehmerdaten fehlen für mindestens eine Leistung.",
  "trainerstunden.billing.draftIssuer.legend": "Rechnungssteller",
  "trainerstunden.billing.draftIssuer.hint":
    "Koordinator-Modus: eine Rechnung für alle Leistungen, Zahlungseingang beim Koordinator — danach Auszahlung an die Trainer laut Stammdaten. Trainer-Modus: nur die Stunden des gewählten Trainers.",
  "trainerstunden.billing.draftIssuer.optionCoordinator":
    "Trainingskoordinator ({name}) — gemeinsame Rechnung, Geldfluss über den Koordinator",
  "trainerstunden.billing.draftIssuer.optionCoordinatorCombined":
    "Trainingskoordinator — eine gemeinsame Rechnung für alle Trainer, Geldfluss über den Koordinator",
  "trainerstunden.billing.draftIssuer.coordinatorCombinedName": "alle Trainer",
  "trainerstunden.billing.draftIssuer.optionTrainer":
    "Trainer ({name}) — nur die Stunden dieses Trainers, direkter Rechnungsfluss",
  "trainerstunden.billing.draftIssuer.defaultBadge": "Standard",
  "trainerstunden.billing.draftIssuer.outcomeCoordinator":
    "Es entsteht ein Rechnungsentwurf mit allen {count} Leistungen. Zahlungseingang beim Trainingskoordinator ({name}); die Auszahlung an die beteiligten Trainer folgt im Bereich Auszahlungen.",
  "trainerstunden.billing.draftIssuer.outcomeCoordinatorCombined":
    "Es entsteht ein Rechnungsentwurf mit allen {count} Leistungen aller beteiligten Trainer. Zahlungseingang beim Trainingskoordinator; die Auszahlung an die Trainer folgt im Bereich Auszahlungen.",
  "trainerstunden.billing.draftIssuer.outcomeTrainerOnly":
    "Es werden nur die Leistungen von {name} gebündelt ({count} Positionen). Die Stunden der anderen Trainer bleiben offen.",
  "trainerstunden.billing.draftIssuer.outcomeTrainerSingle":
    "Es entsteht ein Rechnungsentwurf für {count} Leistungen. Absender: {name}.",
  "trainerstunden.billingInbox.itemTitleFallback": "Training",
  "trainerstunden.billingInbox.itemsSectionAria":
    "Unbestätigte Trainingsstunden",
  "trainerstunden.billingCards.batchPreviewLead":
    "So sehen die neuen Entwürfe aus, sobald du unten „Rechnung vorbereiten“ ausführst. Es werden noch keine Daten gespeichert.",
  "trainerstunden.billingCards.draftsSectionAria": "Gespeicherte Entwürfe",
  "trainerstunden.billingCards.draftsSectionTitle": "Entwürfe",
  "trainerstunden.billingCards.draftsSectionLead": "Zeitraum: {period}",
  "trainerstunden.billingCards.draftsNextHint":
    "Nächster Schritt: Versand prüfen und die Rechnung per E‑Mail oder WhatsApp verschicken, danach als versendet markieren.",
  "trainerstunden.billingCards.draftReservedInboxHint":
    "Diese Leistungen sind im Entwurf reserviert und erscheinen nicht mehr unter Offene Leistungen.",
  "trainerstunden.billingCards.prepareSend": "Versand vorbereiten",
  "trainerstunden.billingCards.discardDraft": "Entwurf zurücknehmen",
  "trainerstunden.billingCards.editContactData": "Kontaktdaten bearbeiten",
  "trainerstunden.billingCards.discardAllDraftsInGroup":
    "Alle Entwürfe zurücknehmen",
  "trainerstunden.billingCards.draftGroupMultiHint":
    "Für diesen Empfänger und Monat existieren mehrere gespeicherte Entwürfe. Unten wählst du, welchen du versenden möchtest.",
  "trainerstunden.billingCards.draftGroupAggregatedSendHint":
    "{count} Entwürfe — ein Versand mit allen Positionen.",
  "trainerstunden.billingCards.draftGroupSendHint":
    "Jeder Entwurf wird einzeln versendet (eigene Rechnung).",
  "trainerstunden.billingCards.draftGroupSendPickTitle":
    "Entwurf für Versand auswählen",
  "trainerstunden.billingCards.draftGroupSendPickMeta":
    "{date} · {lines} · {amount}",
  "trainerstunden.billingCards.showLines": "Leistungen anzeigen",
  "trainerstunden.billingCards.hideLines": "Leistungen ausblenden",
  "trainerstunden.billingCards.showDetails": "Details anzeigen",
  "trainerstunden.billingCards.hideDetails": "Details ausblenden",
  "trainerstunden.billingCards.downloadInvoicePdf": "PDF herunterladen",
  "trainerstunden.billingCards.downloadInvoicePdfBusy": "PDF wird erstellt …",
  "trainerstunden.billingCards.downloadInvoicePdfFailed":
    "PDF konnte nicht geladen werden.",
  "trainerstunden.billingCards.downloadInvoicePdfFailedNotFound":
    "Rechnung wurde nicht gefunden oder ist nicht mehr zugänglich.",
  "trainerstunden.billingCards.settledSectionAria": "Abgerechnete Rechnungen",
  "trainerstunden.billingCards.settledSectionTitle": "Abgerechnet",
  "trainerstunden.billingCards.settledSectionLead": "Zeitraum: {period}",
  "trainerstunden.billingCards.settledImmutableHint":
    "Nach dem Versand werden ursprüngliche Leistungen nicht verändert. Änderungen laufen über Korrekturen.",
  "trainerstunden.billingCards.cancelledSectionTitle": "Stornierte Rechnungen",
  "trainerstunden.billingCards.paymentsTitle": "Zahlungen",
  "trainerstunden.billingCards.linesAria": "Enthaltene Leistungen",
  "trainerstunden.billingCards.sentPending": "Noch nicht versendet",
  "trainerstunden.billingCards.createdAt": "Erstellt: {date}",
  "trainerstunden.billingCards.invoiceNumber": "Rechnungs-Nr.: {number}",
  "trainerstunden.billingCards.originalShort": "Original",
  "trainerstunden.billingCards.openShort": "Offen",
  "trainerstunden.billingCards.paidShort": "Bezahlt",
  "trainerstunden.billingCards.correctedDelta": "Korrigiert",
  "trainerstunden.billingCards.effectiveAmount": "Effektiver Betrag",
  "trainerstunden.billingCards.statementHasCorrectionsHint":
    "Diese Rechnung enthält Korrekturen.",
  "trainerstunden.billingCards.statementChipsAria":
    "Rechnungs- und Zahlungsstatus",
  "trainerstunden.billingCards.paymentBalance.open": "Offen",
  "trainerstunden.billingCards.paymentBalance.partial": "Teilweise bezahlt",
  "trainerstunden.billingCards.paymentBalance.paid": "Bezahlt",
  "trainerstunden.billingCards.paymentBalance.overpaid": "Überzahlt",
  "trainerstunden.billingCards.paymentSummaryAria": "Zahlungsüberblick",
  "trainerstunden.billingCards.paymentSummaryCorrectionsHint":
    "Korrekturen: {amount}",
  "trainerstunden.billingCards.recordPaymentFromStatement": "Zahlung erfassen",
  "trainerstunden.billingCards.confirmPayment": "Zahlungsbestätigung",
  "trainerstunden.billingCards.revertManualPayment": "Zahlung zurücknehmen",
  "trainerstunden.billingCards.revertManualPaymentBusy": "Wird zurückgenommen…",
  "trainerstunden.billingCards.revertManualPaymentFailed":
    "Zahlung konnte nicht zurückgenommen werden.",
  "trainerstunden.billingCards.revertManualPaymentModal.title":
    "Zahlung zurücknehmen?",
  "trainerstunden.billingCards.revertManualPaymentModal.body":
    "Die manuelle Zahlungsmarkierung wird rückgängig gemacht. Verbuchte Zahlungseingänge werden entfernt. Über PayPal bestätigte Zahlungen können nicht zurückgenommen werden.",
  "trainerstunden.billingCards.revertManualPaymentModal.confirm":
    "Zahlung zurücknehmen",
  "trainerstunden.billingCards.createCreditNote": "Gutschrift erstellen",
  "trainerstunden.billingCards.rebookItem": "Position umbuchen",
  "trainerstunden.billingCards.rebookModal.title": "Position umbuchen",
  "trainerstunden.billingCards.rebookModal.lead":
    "Aus {invoice}: isolierte Gutschrift (ohne Umverteilung anderer Kinder). Bei bezahlter Rechnung wird Guthaben notiert. Nachbelastung als Zusatzposition auf dem Ziel-Entwurf.",
  "trainerstunden.billingCards.rebookModal.itemsLegend":
    "Positionen gutschreiben",
  "trainerstunden.billingCards.rebookModal.noEligibleItems":
    "Keine Positionen mit positivem Restbetrag.",
  "trainerstunden.billingCards.rebookModal.targetPerson":
    "Nachbelastung an Person",
  "trainerstunden.billingCards.rebookModal.personPlaceholder": "Bitte wählen",
  "trainerstunden.billingCards.rebookModal.targetDraft":
    "Ziel-Rechnungsentwurf",
  "trainerstunden.billingCards.rebookModal.createNewDraft":
    "Neuen Entwurf anlegen",
  "trainerstunden.billingCards.rebookModal.createNewDraftHint":
    "Wenn kein Entwurf existiert (oder die bestehende Rechnung schon versendet ist), wird ein neuer Entwurf mit den Nachbelastungspositionen angelegt.",
  "trainerstunden.billingCards.rebookModal.period":
    "Abrechnungsmonat (neuer Entwurf)",
  "trainerstunden.billingCards.rebookModal.reason": "Grund / Notiz",
  "trainerstunden.billingCards.rebookModal.reasonDefault":
    "Verwechslung Teilnehmer — Umbuchung auf richtige Person",
  "trainerstunden.billingCards.rebookModal.save": "Umbuchen",
  "trainerstunden.billingCards.rebookModal.saveBusy": "Umbuchen …",
  "trainerstunden.billingCards.rebookModal.errorNoItems":
    "Bitte mindestens eine Position wählen.",
  "trainerstunden.billingCards.rebookModal.errorNoPerson":
    "Bitte die Zielperson wählen.",
  "trainerstunden.billingCards.rebookModal.errorTargetNotDraft":
    "Zielrechnung ist kein Entwurf. Bitte Entwurf wählen oder neu anlegen.",
  "trainerstunden.billingCards.rebookModal.errorActiveNotDraft":
    "Für diesen Monat gibt es schon eine versendete Rechnung. Anderen Monat wählen oder bestehenden Entwurf nutzen.",
  "trainerstunden.billingCards.rebookModal.errorAlreadyCredited":
    "Mindestens eine Position ist bereits gutgeschrieben.",
  "trainerstunden.billingCards.rebookModal.errorSave":
    "Umbuchung ist fehlgeschlagen. Bitte erneut versuchen.",
  "trainerstunden.billingCards.creditNoteModal.lead":
    "Betrag als Guthaben für den Rechnungsempfänger notieren. Optional sofort mit dem offenen Rechnungsbetrag verrechnen.",
  "trainerstunden.billingCards.creditNoteModal.leadNamed":
    "Gutschrift für {name}. Betrag als Guthaben notieren — optional sofort verrechnen.",
  "trainerstunden.billingCards.creditNoteModal.hintOpen":
    "Aktuell offen: {amount}.",
  "trainerstunden.billingCards.creditNoteModal.amount": "Betrag (€)",
  "trainerstunden.billingCards.creditNoteModal.notes": "Grund / Notiz",
  "trainerstunden.billingCards.creditNoteModal.notesPlaceholder":
    "z. B. Verrechnung Überzahlung Juni",
  "trainerstunden.billingCards.creditNoteModal.applyNow":
    "Sofort auf diese Rechnung verrechnen",
  "trainerstunden.billingCards.creditNoteModal.save": "Gutschrift speichern",
  "trainerstunden.billingCards.creditNoteModal.saveBusy": "Speichern …",
  "trainerstunden.billingCards.creditNoteModal.errorNoStatement":
    "Rechnung wurde nicht gefunden.",
  "trainerstunden.billingCards.creditNoteModal.errorCancelled":
    "Für stornierte Rechnungen können keine Gutschriften erfasst werden.",
  "trainerstunden.billingCards.creditNoteModal.errorAmountPositive":
    "Bitte einen gültigen Betrag größer 0 eingeben.",
  "trainerstunden.billingCards.creditNoteModal.errorSave":
    "Speichern ist fehlgeschlagen. Bitte erneut versuchen.",
  "trainerstunden.billingCards.paymentEdit": "Zahlung bearbeiten",
  "trainerstunden.billingCards.paymentModal.errorNoStatement":
    "Rechnung wurde nicht gefunden.",
  "trainerstunden.billingCards.paymentModal.errorCancelled":
    "Für stornierte Rechnungen können keine Zahlungen erfasst werden.",
  "trainerstunden.billingCards.paymentModal.errorNotPayable":
    "Für diese Rechnung ist keine Zahlungserfassung vorgesehen.",
  "trainerstunden.billingCards.paymentModal.errorPerson":
    "Bitte eine Person auswählen.",
  "trainerstunden.billingCards.paymentModal.errorDate":
    "Bitte ein Zahlungsdatum angeben.",
  "trainerstunden.billingCards.paymentModal.errorAmountPositive":
    "Bitte einen gültigen Betrag größer 0 eingeben.",
  "trainerstunden.billingCards.paymentModal.errorAmountMax":
    "Der Betrag darf den offenen Betrag ({max}) nicht übersteigen.",
  "trainerstunden.billingCards.paymentModal.errorSave":
    "Speichern ist fehlgeschlagen. Bitte erneut versuchen.",
  "trainerstunden.billingCards.paymentModal.errorNoPayment":
    "Zahlung wurde nicht gefunden.",
  "trainerstunden.billingCards.paymentModal.loadingStatement":
    "Rechnung wird geladen …",
  "trainerstunden.billingCards.paymentModal.hintMaxOpen": "Offen bis {amount}.",
  "trainerstunden.billingCards.paymentModal.sendReceiptMail":
    "Bestätigung per E-Mail an Rechnungsempfänger senden",
  "trainerstunden.billingCards.paymentModal.sendReceiptMailTo":
    "Versand an {email} (wie beim Rechnungsversand).",
  "trainerstunden.billingCards.paymentModal.sendReceiptMailNoEmail":
    "Keine E-Mail-Adresse für den Rechnungsempfänger hinterlegt.",
  "trainerstunden.billingCards.paymentModal.methodUnset": "Keine Angabe",
  "trainerstunden.billingCards.compactPartiallyPaidMeta":
    "{open} offen ({paid} bezahlt)",
  "trainerstunden.billingCards.paymentModal.hintPartiallyPaid":
    "Noch {open} offen — bereits {paid} bezahlt.",
  "trainerstunden.billingCards.paymentModal.overpayConfirmTitle":
    "Betrag höher als offen",
  "trainerstunden.billingCards.paymentModal.overpayConfirmLead":
    "Du erfasst {entered}, offen sind nur {open}. Ist das absichtlich?",
  "trainerstunden.billingCards.paymentModal.overpayConfirmSurplus":
    "Mehrbetrag: {amount}",
  "trainerstunden.billingCards.paymentModal.overpayClassifyTitle":
    "Wofür ist der Mehrbetrag?",
  "trainerstunden.billingCards.paymentModal.overpayClassifyLead":
    "Bitte kurz einordnen, damit du den Saldo später nachvollziehen kannst.",
  "trainerstunden.billingCards.paymentModal.overpayClassifyRequired":
    "Bitte eine Option wählen.",
  "trainerstunden.billingCards.paymentModal.overpayContinue": "Ja, weiter",
  "trainerstunden.billingCards.paymentModal.overpayBack": "Zurück",
  "trainerstunden.billingCards.paymentModal.surplusKind.credit_future":
    "Guthaben für künftige Abrechnungen",
  "trainerstunden.billingCards.paymentModal.surplusKind.equipment": "Equipment",
  "trainerstunden.billingCards.paymentModal.surplusKind.forgotten_booking":
    "Vergessene Trainingsbuchung",
  "trainerstunden.billingCards.paymentModal.surplusKind.mixed_other":
    "Sonstiges / mehrere Posten",
  "trainerstunden.billingCards.paymentModal.surplusNote":
    "Mehrbetrag {amount}: {kind}",
  "trainerstunden.billingCards.dueDateLabel": "Fällig: {date}",
  "trainerstunden.billingCards.paymentNoteLabel": "Notiz:",
  "trainerstunden.billingCards.saldoAria": "Saldo",
  "trainerstunden.billingCards.saldoTitle": "Saldo",
  "trainerstunden.billingCards.saldoOriginal": "Originalbetrag",
  "trainerstunden.billingCards.saldoCorrections": "Korrekturen",
  "trainerstunden.billingCards.settledMonthOverviewAria":
    "Zahlungsübersicht für diesen Monat",
  "trainerstunden.billingCards.settledMonthOpenTotalLabel": "Offen gesamt",
  "trainerstunden.billingCards.settledMonthPartialLabel": "Teilweise bezahlt",
  "trainerstunden.billingCards.settledMonthPaidLabel": "Bezahlt",
  "trainerstunden.billingCards.settledMonthOverdueLabel": "Offen (überfällig)",
  "trainerstunden.billingCards.paymentsDetailEmpty":
    "Noch keine Zahlung erfasst",
  "trainerstunden.billingPhase8.nextActionAria": "Nächste sinnvolle Aktion",
  "trainerstunden.billingPhase8.nextOpenServices":
    "Du hast offene Leistungen, aus denen du Rechnungen vorbereiten kannst.",
  "trainerstunden.billingPhase8.nextOpenServicesCta":
    "Offene Leistungen ansehen",
  "trainerstunden.billingPhase8.nextDrafts":
    "Es gibt vorbereitete Rechnungsentwürfe, die noch geprüft und versendet werden müssen.",
  "trainerstunden.billingPhase8.nextDraftsCta": "Entwürfe prüfen",
  "trainerstunden.billingDrafts.pageTitle": "Rechnungen",
  "trainerstunden.billingDrafts.pageSubtitle": "Zeitraum: {period}",
  "trainerstunden.billingDrafts.pageSubtitleOpen":
    "Alle offenen Entwürfe bis einschließlich {period}",
  "trainerstunden.billingDrafts.reviewSectionTitle": "Offene Rechnungen",
  "trainerstunden.billingDrafts.reviewSectionTitleOpen":
    "Offene Entwürfe bis {period}",
  "trainerstunden.billingDrafts.reviewPeriodThrough":
    "Zeitraum bis einschließlich {period}",
  "trainerstunden.billingDrafts.pageLead":
    "Prüfe die gebündelten Rechnungen, versende sie und markiere sie danach als versendet — erst dann erscheinen sie in der Rechnungsübersicht.",
  "trainerstunden.billingDrafts.reviewSummary":
    "{count} Entwürfe · {recipients} Empfänger · {amount} €",
  "trainerstunden.billingDrafts.reviewCreatedAt": "Erstellt {date}",
  "trainerstunden.billingDrafts.reviewStatusSendReady":
    "Rechnung versandbereit",
  "trainerstunden.billingDrafts.reviewStatusSent": "Rechnung versandt",
  "trainerstunden.billingDrafts.reviewStatusMixedSent": "Teilweise versandt",
  "trainerstunden.billingDrafts.reviewStatusRecoverCancelled":
    "Storniert — Entwurf wiederherstellen",
  "trainerstunden.billingDrafts.restoreInvoicedDraft":
    "Als Entwurf wiederherstellen (neue Rechnungsnummer)",
  "trainerstunden.billingSend.reissueHint":
    "Nach Storno wird automatisch eine neue Rechnungsnummer vergeben.",
  "trainerstunden.billingSend.resendBanner":
    "Nachversand — diese Rechnung wurde bereits versendet.",
  "trainerstunden.billingSend.resendBannerHint":
    "Erstversand: {firstSent}. Rechnungsnummer {invoiceNumber} bleibt unverändert; im E-Mail-Protokoll wird der Nachversand vermerkt.",
  "trainerstunden.billingSend.resendBannerHintNoDate":
    "Rechnungsnummer {invoiceNumber} bleibt unverändert; im E-Mail-Protokoll wird der Nachversand vermerkt.",
  "trainerstunden.billingSend.resendNote":
    "Erstversand: {firstSent}. Nachversand wird protokolliert.",
  "trainerstunden.billingSend.resendNoteNoDate":
    "Bereits versendet (Rechnungs-Nr. {invoiceNumber}). Nachversand wird protokolliert.",
  "trainerstunden.billingSend.resendCta": "Erneut per E-Mail senden",
  "trainerstunden.billingSend.resendPanelTitle": "Nachversand prüfen",
  "trainerstunden.billingSend.resendPanelAria": "Nachversand prüfen",
  "trainerstunden.billingSend.resendSending": "Sende erneut …",
  "trainerstunden.billingSend.sendSuccessResend":
    "Rechnung wurde erneut an {email} gesendet (Nachversand).",
  "trainerstunden.billingSend.sendSuccessResendSimulated":
    "Nachversand simuliert (Empfänger wäre: {email}). Keine E-Mail an Eltern gesendet.",
  "trainerstunden.billing.workQueue.sendReadyChipAria":
    "Rechnung versandbereit — Versand vorbereiten",
  "trainerstunden.billingDrafts.back": "Zurück",
  "trainerstunden.billingDrafts.backToBilling":
    "Zurück zur Abrechnungsübersicht",
  "trainerstunden.billingDrafts.doneTitle": "Keine offenen Rechnungen",
  "trainerstunden.billingDrafts.doneText":
    "Für diesen Monat gibt es aktuell keine gespeicherten Rechnungen im Status „Entwurf“.",
  "trainerstunden.billingDrafts.doneTextOpen":
    "Bis einschließlich {period} gibt es aktuell keine offenen Rechnungsentwürfe mehr.",
  "trainerstunden.billingDrafts.openDraftsCta": "Rechnungen prüfen",
  "trainerstunden.billingDraft.withdraw.title": "Entwurf zurücknehmen",
  "trainerstunden.billingDraft.withdraw.titleMany":
    "{count} Entwürfe zurücknehmen",
  "trainerstunden.billingDraft.withdraw.description":
    "Die Leistungen werden wieder als offen angezeigt und können erneut gebündelt werden.",
  "trainerstunden.billingDraft.withdraw.descriptionMany":
    "Die Leistungen aus {count} Entwürfen werden wieder als offen angezeigt und können erneut gebündelt werden.",
  "trainerstunden.billingDraft.withdraw.confirm": "Weiter",
  "trainerstunden.billingDraft.withdraw.cancel": "Abbrechen",
  "trainerstunden.billingDraft.correct.title": "Rechnungsentwurf korrigieren",
  "trainerstunden.billingDraft.correct.titleMany":
    "{count} Rechnungsentwürfe korrigieren",
  "trainerstunden.billingDraft.correct.description":
    "Soll die zugrunde liegende Trainingsbestätigung angepasst werden oder nur der Rechnungsentwurf?",
  "trainerstunden.billingDraft.correct.descriptionMany":
    "Für {count} Entwürfe: Trainingsdaten anpassen oder nur die Entwürfe in der Rechnungsstellung weiterbearbeiten?",
  "trainerstunden.billingDraft.correct.trainingData":
    "Trainingsbestätigung anpassen",
  "trainerstunden.billingDraft.correct.trainingDataBody":
    "Trainings- und Leistungsdaten werden in der Trainingsbestätigung wieder bearbeitbar. Der gespeicherte Entwurf wird fachlich zurückgenommen (ohne Datenlöschung).",
  "trainerstunden.billingDraft.correct.draftOnly":
    "Rechnungsentwurf bearbeiten",
  "trainerstunden.billingDraft.correct.draftOnlyBody":
    "Nur Texte und Abrechnungsdetails in der Rechnungsstellung anpassen. Die Trainingsbestätigung bleibt unverändert.",
  "trainerstunden.billingDraft.correct.cancel": "Abbrechen",
  "trainerstunden.billingPhase8.nextOpenSettled":
    "Es gibt versendete Rechnungen mit offenem Betrag.",
  "trainerstunden.billingPhase8.nextOpenSettledCta": "Offene Beträge prüfen",
  "trainerstunden.billingPhase8.nextAllDone": "Alles erledigt.",
  "trainerstunden.billingPhase8.allDoneTitle": "Alles erledigt",
  "trainerstunden.billingPhase8.allDoneBody":
    "Es gibt aktuell keine offenen Leistungen, Entwürfe oder offenen Rechnungen.",
  "trainerstunden.billingPhase8.allDoneHint":
    "Neue abrechenbare Leistungen entstehen, sobald du eine durchgeführte Stunde bestätigst.",
  "trainerstunden.billingPhase8.ctaAgenda": "Zu den Terminen",
  "trainerstunden.billingTimeline.aria": "Kurzhistorie",
  "trainerstunden.billingTimeline.draftCreated": "Entwurf erstellt am {date}",
  "trainerstunden.billingTimeline.invoiceCreated":
    "Rechnung angelegt am {date}",
  "trainerstunden.billingTimeline.sent": "Versendet am {date}",
  "trainerstunden.billingTimeline.paymentRecorded": "Zahlung erfasst am {date}",
  "trainerstunden.billingTimeline.correctionBooked":
    "Korrektur gebucht am {date}",
  "trainerstunden.payments.saveSuccess":
    "Zahlung wurde gespeichert und der Rechnungsstand aktualisiert.",
  "trainerstunden.payments.validation.personRequired":
    "Bitte eine Person auswählen.",
  "trainerstunden.payments.validation.dateRequired":
    "Bitte ein Datum auswählen.",
  "trainerstunden.payments.validation.amountRequired":
    "Bitte einen gültigen Betrag größer 0 € eingeben.",
  "trainerstunden.payments.validation.saveFailed":
    "Zahlung konnte nicht gespeichert werden. Bitte Angaben prüfen und erneut versuchen.",
  "trainerstunden.billingSend.panelAria": "Versand prüfen",
  "trainerstunden.billingSend.panelTitle": "Versand prüfen",
  "trainerstunden.billingSend.panelClose": "Schließen",
  "trainerstunden.billingSend.amountOriginal": "Originalbetrag",
  "trainerstunden.billingSend.amountCorrected": "Korrigiert",
  "trainerstunden.billingSend.amountEffective": "Effektiver Betrag",
  "trainerstunden.billingSend.amountOpen": "Offen",
  "trainerstunden.billingSend.channelEmail": "E‑Mail",
  "trainerstunden.billingSend.channelPhone": "Telefon / WhatsApp",
  "trainerstunden.billingSend.channelEmailMissing":
    "Keine E‑Mail im Entwurf hinterlegt.",
  "trainerstunden.billingSend.deliveryEmailLabel": "Empfänger-E-Mail",
  "trainerstunden.billingSend.deliveryEmailHint":
    "Standard ist die hinterlegte Adresse — bei Bedarf für diesen Versand ändern.",
  "trainerstunden.billingSend.draftIssuerLabel": "Rechnungssteller",
  "trainerstunden.billingSend.draftIssuerHint":
    "Standard ist der Trainingskoordinator (falls hinterlegt). Als Trainer kannst du dich selbst wählen — dann läuft die Zahlung nicht über den Koordinator.",
  "trainerstunden.billingSend.draftIssuerTrainerOverrideWarning":
    "Hinweis: Bei dieser Wahl geht die Zahlung direkt an den Trainer. Der Betrag fließt nicht über den Trainingskoordinator und wird dort nicht für die Auszahlung erfasst.",
  "trainerstunden.billingSend.draftIssuerSaving": "Speichere …",
  "trainerstunden.billingSend.draftIssuerSaved":
    "Rechnungssteller gespeichert.",
  "trainerstunden.billingSend.draftIssuerSaveFailed":
    "Rechnungssteller konnte nicht gespeichert werden.",
  "trainerstunden.billingSend.channelPhoneMissing":
    "Keine Telefonnummer im Entwurf hinterlegt.",
  "trainerstunden.billingSend.markSentHint":
    "Erst markieren, wenn du die Rechnung wirklich verschickt hast. Das Öffnen von E‑Mail oder WhatsApp markiert nicht automatisch den Versand.",
  "trainerstunden.billingSend.serverSendHint":
    "E-Mail-Versand erfolgt serverseitig. Bei aktivierter Simulation wird keine E-Mail an Eltern gesendet.",
  "trainerstunden.billingSend.sendEmail": "Rechnung per E-Mail senden",
  "trainerstunden.billingSend.sending": "Sende …",
  "trainerstunden.billingSend.sendFailed":
    "Rechnung konnte nicht versendet werden. Bitte erneut versuchen.",
  "trainerstunden.billingSend.sendSuccessSimulatedLogSkipped":
    "Rechnung im Simulationsmodus als versendet markiert (Versandprotokoll nicht verfügbar).",
  "trainerstunden.billingSend.markSentSimulationCta":
    "Im Simulationsmodus als versendet markieren",
  "trainerstunden.billingSend.markSentSimulationBusy": "Wird markiert …",
  "trainerstunden.billingSend.markSentSimulationSuccess":
    "Rechnung wurde im Simulationsmodus als per E-Mail versendet markiert.",
  "trainerstunden.billingSend.markSentSimulationFailed":
    "Status konnte nicht gespeichert werden. Bitte erneut versuchen.",
  "trainerstunden.billingSend.error.dbSchema":
    "Versandprotokoll fehlt in der Datenbank. Bitte Migration 20260654000209_billing_invoice_mail_log auf der Umgebung ausführen und erneut versuchen.",
  "trainerstunden.billingSend.error.serverException":
    "Serverfehler beim Versand. API-Logs prüfen (PDF, Datenbank oder Konfiguration).",
  "trainerstunden.billingSend.error.technicalHint": "(Code: {code})",
  "trainerstunden.billingSend.error.apiUnreachable":
    "Rechnungsversand ist derzeit nicht erreichbar. Bitte später erneut versuchen oder die Netzwerkverbindung prüfen.",
  "trainerstunden.billingSend.error.pagesMailNotConfigured":
    "Rechnungsversand ist in Cloudflare Pages noch nicht konfiguriert (SUPABASE_URL, SUPABASE_ANON_KEY, ggf. SMTP_FROM und MAIL_PROVIDER=resend).",
  "trainerstunden.billingSend.error.missingSupabaseUrl":
    "Cloudflare: Secret SUPABASE_URL fehlt.",
  "trainerstunden.billingSend.error.missingSupabaseAnonKey":
    "Cloudflare: Secret SUPABASE_ANON_KEY fehlt.",
  "trainerstunden.billingSend.error.missingSmtpFrom":
    "Cloudflare: Secret SMTP_FROM fehlt (Absender für Resend).",
  "trainerstunden.billingSend.error.auth":
    "Die Anmeldung für den PDF-Server ist abgelaufen oder ungültig. Bitte Seite neu laden, ggf. ab- und wieder anmelden, dann PDF erneut laden. Alternativ: „Rechnung anzeigen“ und im Browser drucken.",
  "trainerstunden.billingSend.error.apiKey":
    "Server-API nicht erreichbar (API-Schlüssel). Bitte Entwickler- oder Deploy-Konfiguration prüfen.",
  "trainerstunden.billingSend.error.missingEmail":
    "Keine E-Mail beim Rechnungsempfänger hinterlegt.",
  "trainerstunden.billingSend.error.notDraft":
    "Diese Rechnung kann in diesem Status nicht per E-Mail versendet werden.",
  "trainerstunden.billingSend.error.resendMixed":
    "Nachversand ist nur für bereits versendete Rechnungen möglich — nicht zusammen mit Entwürfen.",
  "trainerstunden.billingSend.error.recipientMismatch":
    "Die ausgewählten Entwürfe haben unterschiedliche Empfänger-E-Mails.",
  "trainerstunden.billingSend.error.needMergeFirst":
    "Mehrere Entwürfe müssen zuerst zu einer Gesamtrechnung zusammengeführt werden — sonst fehlen Positionen im PDF.",
  "trainerstunden.billingSend.needMergeFirstHint":
    "Bitte zuerst „Zu Gesamtrechnung zusammenführen“ — Versand ist erst danach möglich.",
  "trainerstunden.billingSend.error.mailDelivery":
    "E-Mail-Zustellung fehlgeschlagen. SMTP-Einstellungen prüfen oder Simulationsmodus nutzen.",
  "trainerstunden.billingSend.error.pdfFailed":
    "Rechnungs-PDF konnte nicht erzeugt werden. Bitte erneut versuchen.",
  "trainerstunden.billingSend.sendSuccess":
    "Rechnung wurde an {email} versendet.",
  "trainerstunden.billingSend.sendSuccessSimulated":
    "Rechnung simuliert (Empfänger wäre: {email}). Keine E-Mail an Eltern gesendet.",
  "trainerstunden.billingSend.simulationBanner": "Simulationsmodus aktiv",
  "trainerstunden.billingSend.simulationBannerHint":
    "Rechnungen werden protokolliert und als versendet markiert, aber nicht an Eltern-E-Mail-Adressen zugestellt.",
  "trainerstunden.billingSend.serverSimulationBanner":
    "Live-Versand noch nicht freigeschaltet",
  "trainerstunden.billingSend.serverSimulationBannerHint":
    "Der Live-Versand ist auf diesem Server noch nicht freigeschaltet. Rechnungs-E-Mails werden deshalb weiterhin nur simuliert – unabhängig von der Simulations-Option in den Einstellungen.",
  "trainerstunden.billingSend.openBillingEmailSettings":
    "E-Mail-Einstellungen öffnen",
  "trainerstunden.billingSend.openEmail": "E‑Mail öffnen",
  "trainerstunden.billingSend.openWhatsapp": "WhatsApp öffnen",
  "trainerstunden.billingSend.markSentEmail":
    "Als versendet markieren (E‑Mail)",
  "trainerstunden.billingSend.markSentWhatsapp":
    "Als versendet markieren (WhatsApp)",
  "trainerstunden.billingSend.openLinesWarning":
    "Für diesen Empfänger gibt es noch {count} offene Leistungen ({amount} €) im Abrechnungszeitraum — inklusive früherer Monate.",
  "trainerstunden.billingSend.openLinesManageHint":
    "Wähle die offenen Leistungen aus und nimm sie in den Entwurf auf, bevor du versendest.",
  "trainerstunden.billingSend.openLinesBundledSuccess":
    "Ausgewählte Leistungen wurden in den Rechnungsentwurf übernommen.",
  "trainerstunden.billingSend.openLinesConfirmProceed": "Trotzdem versenden",
  "trainerstunden.billingSend.openLinesConfirmed":
    "Versand trotz offener Leistungen bestätigt.",
  "trainerstunden.billingSend.aggregatedDraftHint":
    "{count} Entwürfe werden gemeinsam versendet — für nur eine PayPal-Gebühr zuerst „Gesamtrechnung“ nutzen.",
  "trainerstunden.billingSend.mergeDraftCta":
    "Zu Gesamtrechnung zusammenführen",
  "trainerstunden.billing.mergeSuggestion.aria":
    "Vorschlag: Rechnungen zusammenführen",
  "trainerstunden.billing.mergeSuggestion.title": "Gesamtrechnung möglich",
  "trainerstunden.billing.mergeSuggestion.lead":
    "Mehrere Entwürfe für denselben Empfänger bedeuten sonst mehrere Zahlungslinks (z. B. doppelte PayPal-Gebühren).",
  "trainerstunden.billing.mergeSuggestion.meta":
    "{count} Entwürfe · {amount} €",
  "trainerstunden.billing.mergeSuggestion.cta": "Gesamtrechnung erstellen",
  "trainerstunden.billing.mergeSuggestion.busy": "Wird zusammengeführt …",
  "trainerstunden.billing.mergeSuggestion.failed":
    "Zusammenführen fehlgeschlagen. Bitte erneut versuchen.",
  "trainerstunden.billing.mergeSuggestion.success":
    "Entwürfe wurden zu einer Gesamtrechnung zusammengeführt.",
  "trainerstunden.billing.mergeDraft.cardCta": "Gesamtrechnung erstellen",
  "trainerstunden.billing.draftCards.mergeSelectedHint":
    "Mehrere Entwürfe derselben Person: anhaken, dann unten verbinden.",
  "trainerstunden.billing.draftCards.mergeSelectedHintReady": {
    one: "{count} Entwurf gewählt — bei unterschiedlichen Trainern wählst du den Rechnungssteller.",
    other:
      "{count} Entwürfe gewählt — bei unterschiedlichen Trainern wählst du den Rechnungssteller.",
  },
  "trainerstunden.billing.draftCards.mergeSelectedHintSame": {
    one: "{count} Entwurf gewählt — bereit zur Gesamtrechnung.",
    other: "{count} Entwürfe gewählt — bereit zur Gesamtrechnung.",
  },
  "trainerstunden.billing.draftCards.mergeSelectedHintMixed": {
    one: "{count} Entwurf gewählt — als Nächstes den Rechnungssteller wählen.",
    other:
      "{count} Entwürfe gewählt — als Nächstes den Rechnungssteller wählen (Default: Koordinator).",
  },
  "trainerstunden.billing.draftCards.mergeSelectedHintPickMore":
    "Noch einen Entwurf derselben Person anhaken.",
  "trainerstunden.billing.draftCards.mergeCta": "Zusammenfassen",
  "trainerstunden.billing.draftCards.mergeBusy": "Wird zusammengefasst …",
  "trainerstunden.billing.draftCards.mergeIssuerTitle":
    "Rechnungssteller für Gesamtrechnung",
  "trainerstunden.billing.draftCards.selectAria":
    "Entwurf {number} für {name} auswählen",
  "trainerstunden.billing.draftCards.autoMergeSuccess": {
    one: "{count} Gesamtrechnung automatisch erstellt (gleicher Trainer).",
    other: "{count} Gesamtrechnungen automatisch erstellt (gleicher Trainer).",
  },
  "trainerstunden.billingMailOutbox.title": "E-Mail-Protokoll",
  "trainerstunden.billingMailOutbox.subtitle":
    "Welche Rechnung wann versendet wurde — inklusive Simulationen.",
  "trainerstunden.billingMailOutbox.refresh": "Aktualisieren",
  "trainerstunden.billingMailOutbox.loadFailed":
    "Versandprotokoll konnte nicht geladen werden.",
  "trainerstunden.billingMailOutbox.empty":
    "Noch keine Rechnungs-E-Mails in diesem Monat.",
  "trainerstunden.billingMailOutbox.colSentAt": "Versendet",
  "trainerstunden.billingMailOutbox.colRecipient": "Empfänger",
  "trainerstunden.billingMailOutbox.colSubject": "Betreff",
  "trainerstunden.billingMailOutbox.colAmount": "Betrag",
  "trainerstunden.billingMailOutbox.colStatus": "Status",
  "trainerstunden.billingMailOutbox.statusSent": "Versendet",
  "trainerstunden.billingMailOutbox.statusResent": "Nachversand",
  "trainerstunden.billingMailOutbox.statusSimulated": "Simuliert",
  "trainerstunden.billingMailOutbox.statusFailed": "Fehlgeschlagen",
  "trainerstunden.billingMailOutbox.deliveredTo": "Zugestellt an: {email}",
  "trainerstunden.billingInvoicePreview.menuItem": "Rechnungsvorschau",
  "trainerstunden.billingInvoicePreview.menuItemShowSent": "Rechnung anzeigen",
  "trainerstunden.billingInvoicePreview.title": "Rechnungsvorschau",
  "trainerstunden.billingInvoicePreview.close": "Schließen",
  "trainerstunden.billingInvoicePreview.print": "Drucken",
  "trainerstunden.billingInvoicePreview.printDraft": "Entwurf drucken",
  "trainerstunden.billingInvoicePreview.draftNotice":
    "Entwurf — Rechnungsnummer und Betrag können sich vor dem Versand noch ändern.",
  "trainerstunden.billingInvoicePreview.documentAria": "Rechnungsdokument",
  "trainerstunden.billingInvoicePreview.invoiceHeading": "Rechnung",
  "trainerstunden.billingInvoicePreview.issuerLabel": "Rechnungssteller",
  "trainerstunden.billingInvoicePreview.recipientLabel": "Rechnungsempfänger",
  "trainerstunden.billingInvoicePreview.invoiceNumberLabel": "Rechnungsnummer",
  "trainerstunden.billingInvoicePreview.invoiceDateLabel": "Rechnungsdatum",
  "trainerstunden.billingInvoicePreview.servicePeriodLabel":
    "Leistungszeitraum",
  "trainerstunden.billingInvoicePreview.serviceDatesLabel": "Leistungstage",
  "trainerstunden.billingInvoicePreview.dueDateLabel": "Zahlungsziel",
  "trainerstunden.billingInvoicePreview.paymentLabel": "Zahlungsinformationen",
  "trainerstunden.billingInvoicePreview.positionNumber": "Pos.",
  "trainerstunden.billingInvoicePreview.positionDate": "Datum",
  "trainerstunden.billingInvoicePreview.positionDescription": "Leistung",
  "trainerstunden.billingInvoicePreview.positionAmount": "Betrag",
  "trainerstunden.billingInvoicePreview.trainerSectionHeading":
    "Trainings bei {name}",
  "trainerstunden.billingInvoicePreview.totalLabel": "Gesamtbetrag",
  "trainerstunden.billingInvoicePreview.openAmountLabel": "Zu zahlen",
  "trainerstunden.billingInvoicePreview.issuerMissing":
    "Bitte Rechnungssteller im Trainer-Profil vervollständigen (Name und Adresse).",
  "trainerstunden.billingInvoicePreview.paymentMissing":
    "Noch keine Zahlungsmethode im Trainer-Profil hinterlegt.",
  "trainerstunden.billingInvoicePreview.paymentLoading":
    "Zahlungsinformationen werden geladen …",
  "trainerstunden.billingInvoicePreview.bankAccountHolder":
    "Kontoinhaber: {name}",
  "trainerstunden.billingInvoicePreview.bankIban": "IBAN: {iban}",
  "trainerstunden.billingInvoicePreview.bankIbanMasked": "IBAN ···· {last4}",
  "trainerstunden.billingInvoicePreview.bankBic": "BIC: {bic}",
  "trainerstunden.billingInvoicePreview.paypalEmail": "PayPal: {email}",
  "trainerstunden.billingInvoicePreview.paypalHandle": "PayPal: {handle}",
  "trainerstunden.billingInvoicePreview.layoutVersionLabel":
    "Layout-Version {version}",
  "trainerstunden.billingInvoicePreview.netTotalLabel": "Nettobetrag",
  "trainerstunden.billingInvoicePreview.vatLineLabel": "Umsatzsteuer",
  "trainerstunden.billingInvoicePreview.vatAmountLabel":
    "Umsatzsteuer ({rate} %): {amount}",
  "trainerstunden.billingInvoicePreview.vatExemptNotice":
    "Gemäß § 19 UStG wird keine Umsatzsteuer ausgewiesen.",
  "trainerstunden.invoiceLayout.title": "Rechnungslayout",
  "trainerstunden.invoiceLayout.subtitle":
    "Logo, Farben und Darstellung für Rechnungsentwürfe, Vorschau und PDF. Änderungen gelten nur für offene und künftige Rechnungen.",
  "trainerstunden.invoiceLayout.versionHint":
    "Beim Speichern wird nur bei echten Layout-Änderungen eine neue Version angelegt. Versendete Rechnungen behalten ihr eingefrorenes Layout.",
  "trainerstunden.invoiceLayout.versionsTitle": "Vorhandene Versionen",
  "trainerstunden.invoiceLayout.versionsCount": "({count})",
  "trainerstunden.invoiceLayout.activateCta": "Als Standard aktivieren",
  "trainerstunden.invoiceLayout.activateCtaShort": "Aktivieren",
  "trainerstunden.invoiceLayout.activateConfirm":
    "Version {number} wieder als aktiven Standard setzen? Es wird keine neue Version angelegt.",
  "trainerstunden.invoiceLayout.activateMissingVersion":
    "Die Layout-Version konnte nicht ermittelt werden.",
  "trainerstunden.invoiceLayout.activateVersionNotFound":
    "Die Layout-Version wurde nicht gefunden.",
  "trainerstunden.invoiceLayout.deleteCta": "Löschen",
  "trainerstunden.invoiceLayout.deleteConfirm":
    "Version {number} dauerhaft löschen? Nur möglich, wenn sie noch auf keiner versendeten Rechnung verwendet wurde.",
  "trainerstunden.invoiceLayout.deleteActiveVersion":
    "Die aktive Layout-Version kann nicht gelöscht werden.",
  "trainerstunden.invoiceLayout.deleteVersionInUse":
    "Diese Version wurde bereits auf einer versendeten Rechnung verwendet und kann nicht gelöscht werden.",
  "trainerstunden.invoiceLayout.deleteLastVersion":
    "Die letzte verbleibende Layout-Version kann nicht gelöscht werden.",
  "trainerstunden.invoiceLayout.versionBadge": "Version {number}",
  "trainerstunden.invoiceLayout.validFromLabel": "Gültig ab {date}",
  "trainerstunden.invoiceLayout.activeTag": "Aktiv",
  "trainerstunden.invoiceLayout.newVersionTitle": "Layout bearbeiten",
  "trainerstunden.invoiceLayout.labelField": "Bezeichnung",
  "trainerstunden.invoiceLayout.labelPlaceholder":
    "Optional — sonst Kurzbeschreibung der Änderungen",
  "trainerstunden.invoiceLayout.labelAutoHint": "Wird gespeichert als: {label}",
  "trainerstunden.invoiceLayout.defaultVersionLabel": "Neues Layout",
  "trainerstunden.invoiceLayout.change.generic": "Layout angepasst",
  "trainerstunden.invoiceLayout.change.more": "+{count} weitere",
  "trainerstunden.invoiceLayout.change.reactivated":
    "Version {number} reaktiviert",
  "trainerstunden.invoiceLayout.change.logo": "Logo geändert",
  "trainerstunden.invoiceLayout.change.primaryColor": "Primärfarbe geändert",
  "trainerstunden.invoiceLayout.change.accentColor": "Akzentfarbe geändert",
  "trainerstunden.invoiceLayout.change.footerNote": "Fußzeile geändert",
  "trainerstunden.invoiceLayout.change.showLogoOn": "Logo eingeblendet",
  "trainerstunden.invoiceLayout.change.showLogoOff": "Logo ausgeblendet",
  "trainerstunden.invoiceLayout.change.showServicePeriodOn":
    "Leistungszeitraum eingeblendet",
  "trainerstunden.invoiceLayout.change.showServicePeriodOff":
    "Leistungszeitraum ausgeblendet",
  "trainerstunden.invoiceLayout.change.showDueDateOn":
    "Zahlungsziel eingeblendet",
  "trainerstunden.invoiceLayout.change.showDueDateOff":
    "Zahlungsziel ausgeblendet",
  "trainerstunden.invoiceLayout.change.showFooterOn": "Fußzeile eingeblendet",
  "trainerstunden.invoiceLayout.change.showFooterOff": "Fußzeile ausgeblendet",
  "trainerstunden.invoiceLayout.change.positionSessionDateOn":
    "Spalte Datum eingeblendet",
  "trainerstunden.invoiceLayout.change.positionSessionDateOff":
    "Spalte Datum ausgeblendet",
  "trainerstunden.invoiceLayout.change.positionPlayerOn":
    "Spalte Spieler eingeblendet",
  "trainerstunden.invoiceLayout.change.positionPlayerOff":
    "Spalte Spieler ausgeblendet",
  "trainerstunden.invoiceLayout.change.positionTrainerOn":
    "Spalte Trainer eingeblendet",
  "trainerstunden.invoiceLayout.change.positionTrainerOff":
    "Spalte Trainer ausgeblendet",
  "trainerstunden.invoiceLayout.change.tailSectionOrder":
    "Reihenfolge Zahlung/Fußzeile geändert",
  "trainerstunden.invoiceLayout.validFromField": "Gültig ab",
  "trainerstunden.invoiceLayout.validFromHint":
    "Ab diesem Zeitpunkt wird das Layout für neue und noch offene Rechnungen verwendet.",
  "trainerstunden.invoiceLayout.logoField": "Logo",
  "trainerstunden.invoiceLayout.logoUploadCta": "Logo hochladen",
  "trainerstunden.invoiceLayout.logoUploading": "Wird hochgeladen …",
  "trainerstunden.invoiceLayout.logoUploadAria":
    "Rechnungslogo aus Datei wählen",
  "trainerstunden.invoiceLayout.logoUploadInvalidType":
    "Nur PNG, JPEG oder WebP sind erlaubt.",
  "trainerstunden.invoiceLayout.logoUploadTooLarge":
    "Das Logo ist zu groß (max. 2 MB).",
  "trainerstunden.invoiceLayout.logoUploadFailed":
    "Logo konnte nicht hochgeladen werden.",
  "trainerstunden.invoiceLayout.logoUrlField": "oder Logo-URL (HTTPS)",
  "trainerstunden.invoiceLayout.logoUrlHint":
    "Datei hochladen oder öffentlich erreichbare Bild-URL (PNG, JPEG oder WebP).",
  "trainerstunden.invoiceLayout.logoUrlInvalid":
    "Die Logo-URL muss mit https:// beginnen.",
  "trainerstunden.invoiceLayout.displayOptionsTitle": "Darstellung",
  "trainerstunden.invoiceLayout.optionShowLogo": "Logo anzeigen",
  "trainerstunden.invoiceLayout.optionShowServicePeriod":
    "Leistungszeitraum anzeigen",
  "trainerstunden.invoiceLayout.optionShowDueDate": "Zahlungsziel anzeigen",
  "trainerstunden.invoiceLayout.optionShowPlayerInPositions":
    "Spieler in Positionen anzeigen",
  "trainerstunden.invoiceLayout.primaryColorField": "Primärfarbe",
  "trainerstunden.invoiceLayout.accentColorField": "Akzentfarbe",
  "trainerstunden.invoiceLayout.footerNoteField": "Fußzeile",
  "trainerstunden.invoiceLayout.footerNotePlaceholder":
    "z. B. Vielen Dank für Ihr Vertrauen",
  "trainerstunden.invoiceLayout.footerNoteHint":
    "Der Hinweis zur Kleinunternehmerregelung und die Bankverbindung kommen aus dem Trainer-Profil und erscheinen im Bereich „Zahlung“. Hier nur optionaler Zusatztext für die Fußzeile.",
  "trainerstunden.invoiceLayout.regionMapAria":
    "Schematische Übersicht der Rechnungsbereiche",
  "trainerstunden.invoiceLayout.regionMapLead":
    "So sind die Bereiche auf der Rechnung angeordnet:",
  "trainerstunden.invoiceLayout.regionMapHint":
    "Klicke auf graue Bereiche oder Chips, um optionale Angaben ein- oder auszublenden. Pflichtangaben sind gesperrt. Mit ↑/↓ verschiebst du Zahlung und Fußzeile.",
  "trainerstunden.invoiceLayout.regionRequiredBadge": "Pflicht",
  "trainerstunden.invoiceLayout.regionLogoDisabledHint":
    "Zuerst Logo hochladen",
  "trainerstunden.invoiceLayout.regionFooterEmptyHint":
    "Optionaler Zusatztext — Kleinunternehmer-Hinweis und Bankverbindung kommen aus dem Profil (Bereich „Zahlung“).",
  "trainerstunden.invoiceLayout.regionPositionColumnsLead":
    "Spalten in der Positionstabelle:",
  "trainerstunden.invoiceLayout.regionMoveUpAria": "{region} nach oben",
  "trainerstunden.invoiceLayout.regionMoveDownAria": "{region} nach unten",
  "trainerstunden.invoiceLayout.positionColumn.positionNumber": "Pos.",
  "trainerstunden.invoiceLayout.positionColumn.sessionDate": "Datum",
  "trainerstunden.invoiceLayout.positionColumn.description": "Leistung",
  "trainerstunden.invoiceLayout.positionColumn.playerName": "Spieler",
  "trainerstunden.invoiceLayout.positionColumn.trainerName": "Trainer",
  "trainerstunden.invoiceLayout.positionColumn.amount": "Betrag",
  "trainerstunden.invoiceLayout.regionLogo": "Logo",
  "trainerstunden.invoiceLayout.regionHeading": "Überschrift",
  "trainerstunden.invoiceLayout.regionMeta": "Rechnungsdaten",
  "trainerstunden.invoiceLayout.regionServicePeriod": "Leistungszeitraum",
  "trainerstunden.invoiceLayout.regionIssuer": "Rechnungssteller",
  "trainerstunden.invoiceLayout.regionRecipient": "Empfänger",
  "trainerstunden.invoiceLayout.regionPositions": "Positionen",
  "trainerstunden.invoiceLayout.regionPlayers": "Spielernamen",
  "trainerstunden.invoiceLayout.regionTotals": "Summen",
  "trainerstunden.invoiceLayout.regionPayment": "Zahlung",
  "trainerstunden.invoiceLayout.regionDueDate": "Zahlungsziel",
  "trainerstunden.invoiceLayout.regionFooter": "Fußzeile",
  "trainerstunden.invoiceLayout.previewTitle": "Live-Vorschau",
  "trainerstunden.invoiceLayout.previewLead":
    "Beispielrechnung mit deinen aktuellen Einstellungen (Musterdaten).",
  "trainerstunden.invoiceLayout.previewMobileHint":
    "Die Live-Vorschau ist auf größeren Bildschirmen rechts neben dem Formular verfügbar.",
  "trainerstunden.invoiceLayout.previewSampleIssuer": "Max Mustermann",
  "trainerstunden.invoiceLayout.previewSampleIssuerAddress": "Musterstraße 1",
  "trainerstunden.invoiceLayout.previewSampleIssuerEmail": "trainer@verein.de",
  "trainerstunden.invoiceLayout.previewSampleRecipient": "Familie Beispiel",
  "trainerstunden.invoiceLayout.previewSampleRecipientStreet": "Beispielweg 12",
  "trainerstunden.invoiceLayout.previewSampleRecipientCity": "80331 München",
  "trainerstunden.invoiceLayout.previewSampleRecipientAddress":
    "Beispielweg 12 · 80331 München",
  "trainerstunden.invoiceLayout.previewSampleRecipientEmail":
    "eltern@beispiel.de",
  "trainerstunden.invoiceLayout.previewSampleInvoiceNumber": "RE-202606-MUSTER",
  "trainerstunden.invoiceLayout.previewSamplePeriod": "Juni 2026",
  "trainerstunden.invoiceLayout.previewSampleServiceDates":
    "10.06.2026 – 17.06.2026",
  "trainerstunden.invoiceLayout.previewSampleLineTitle":
    "Gruppentraining · 60 Min",
  "trainerstunden.invoiceLayout.previewSampleLineTitle2":
    "Einzeltraining · 60 Min",
  "trainerstunden.invoiceLayout.previewSamplePlayer": "Lara Beispiel",
  "trainerstunden.invoiceLayout.previewSamplePlayer2": "Tim Beispiel",
  "trainerstunden.invoiceLayout.previewSamplePaymentHolder":
    "Kontoinhaber: Tennisverein Musterstadt e. V.",
  "trainerstunden.invoiceLayout.previewSamplePaymentIban":
    "IBAN: DE12 3456 7890 1234 5678 90",
  "trainerstunden.invoiceLayout.saveNewVersion": "Layout speichern",
  "trainerstunden.invoiceLayout.saveNoChanges":
    "Keine Änderungen am Layout – es wurde keine neue Version angelegt.",
  "trainerstunden.invoiceLayout.saveNoChangesHint":
    "Keine Änderungen gegenüber der aktiven Version.",
  "trainerstunden.invoiceLayout.saving": "Speichern …",
  "trainerstunden.invoiceLayout.saved": "Gespeichert",
  "trainerstunden.invoiceLayout.saveFailed":
    "Layout konnte nicht gespeichert werden.",
  "trainerstunden.invoiceLayout.saveMissingTenant":
    "Mandant konnte nicht ermittelt werden.",
  "trainerstunden.invoiceLayout.saveNoSupabase":
    "Verbindung zur Datenbank fehlt.",
  "trainerstunden.invoiceLayout.saveSchemaMissing":
    "Die Datenbank ist noch nicht aktualisiert (Rechnungslayout-Tabelle fehlt). Bitte Migration ausrollen.",
  "trainerstunden.invoiceLayout.savePermissionDenied":
    "Keine Berechtigung zum Speichern des Rechnungslayouts. Nur Trainer-Koordination oder Verwaltungsrollen dürfen Layouts anlegen.",
  "trainerstunden.invoiceLayout.saveInvalidTenant":
    "Der Mandant ist ungültig oder nicht mehr vorhanden.",
  "trainerstunden.trainer.invoiceVatModeLabel":
    "Umsatzsteuer auf Elternrechnungen",
  "trainerstunden.trainer.invoiceVatModeExempt":
    "Umsatzsteuerbefreit (Kleinunternehmer)",
  "trainerstunden.trainer.invoiceVatModeStandard": "Mit Umsatzsteuer ausweisen",
  "trainerstunden.trainer.invoiceVatModeHint":
    "Steuert die Ausweisung auf Rechnungen dieses Trainers. In Deutschland üblicherweise 19 %.",
  "trainerstunden.trainer.invoiceVatRateLabel": "Umsatzsteuersatz (%)",
  "trainerstunden.trainer.invoiceVatRateHint": "Standard in Deutschland: 19 %.",
  "trainerstunden.trainer.invoiceVatActiveSummary":
    "Aktiv: Umsatzsteuer wird mit {rate} % auf offenen Rechnungen ausgewiesen.",
  "trainerstunden.trainer.invoiceVatExemptSummary":
    "Aktiv: Umsatzsteuerbefreit – keine USt-Ausweisung auf Rechnungen.",
  "trainerstunden.trainer.invoiceVatSchemaPending":
    "Die Umsatzsteuer-Einstellung konnte nicht gespeichert werden (Datenbank-Migration fehlt noch). Bitte Administrator informieren.",
  "trainerstunden.billingStatements.sectionTitle":
    "Elternabrechnung (Rechnungen)",
  "trainerstunden.billingStatements.sectionHint":
    "Rechnungen gelten pro Monat und Empfänger. Mehrere Entwürfe oder Rechnungen pro Empfänger und Monat sind möglich; dieselbe Trainingsteilnahme wird nicht doppelt abgerechnet.",
  "trainerstunden.billingStatements.actionsTitle": "Rechnungen erstellen",
  "trainerstunden.billingStatements.actionsHintShort":
    "Erstellt neue Entwürfe aus bestätigten Trainings in diesem Monat.",
  "trainerstunden.billingStatements.createDrafts": "Rechnungen erstellen",
  "trainerstunden.billingStatements.createFailed":
    "Rechnungen konnten nicht erstellt werden.",
  "trainerstunden.billingStatements.previewEmpty":
    "Für diesen Monat gibt es keine neuen abrechenbaren Leistungen, oder sie sind bereits in einem Entwurf oder einer Rechnung enthalten.",
  "trainerstunden.billingStatements.previewTitle": "Vorschau ({count})",
  "trainerstunden.billingStatements.previewAria": "Entwurfs-Vorschau",
  "trainerstunden.billingStatements.draftHint":
    "{count} neuer Entwurf möglich.",
  "trainerstunden.billingStatements.previewShow": "Vorschau anzeigen",
  "trainerstunden.billingStatements.previewMore":
    "… und {count} weitere Empfänger",
  "trainerstunden.billingStatements.previewItemsAria":
    "Vorschau der Leistungen",
  "trainerstunden.billingStatements.previewMoreItemsInline":
    "+{count} weitere Leistungen",
  "trainerstunden.billingStatements.listTitle": "Rechnungen (Monat)",
  "trainerstunden.billingStatements.listTitleWithMonth":
    "Rechnungen – {period}",
  "trainerstunden.billingStatements.itemsCount": {
    one: "Eine Leistung",
    other: "{count} Leistungen",
  },
  "trainerstunden.billingStatements.openLabel": "Offen: {amount} €",
  "trainerstunden.billingStatements.sentAt": "Versandt: {date} ({channel})",
  "trainerstunden.billingStatements.itemsEmpty":
    "Keine Leistungen auf dieser Rechnung.",
  "trainerstunden.billingStatements.itemFallback": "Leistung",
  "trainerstunden.billingStatements.missingReachabilityInline":
    "Keine E‑Mail/Handy",
  "trainerstunden.billingStatements.missingEmail":
    "Keine E‑Mail beim Rechnungsempfänger hinterlegt.",
  "trainerstunden.billingStatements.missingPhone":
    "Keine gültige Mobilnummer beim Rechnungsempfänger hinterlegt.",
  "trainerstunden.billingStatements.reachability.missingEmailConfirm":
    "Keine E‑Mail beim Rechnungsempfänger hinterlegt.\n\nMöchtest du jetzt die Stammdaten öffnen und die Kontaktdaten ergänzen?",
  "trainerstunden.billingStatements.reachability.missingPhoneConfirm":
    "Keine gültige Mobilnummer beim Rechnungsempfänger hinterlegt.\n\nMöchtest du jetzt die Stammdaten öffnen und die Kontaktdaten ergänzen?",
  "trainerstunden.billingStatements.cancelModal.title": "Rechnung stornieren?",
  "trainerstunden.billingStatements.cancelModal.body":
    "Es wird eine Stornorechnung (Ausgleich der Forderung) erstellt und die ursprüngliche Rechnung im Archiv als storniert markiert. Anschließend liegt ein neuer Rechnungsentwurf mit denselben Positionen bereit — beim Versand erhält er eine neue Rechnungsnummer. Erfasste Zahlungen zu dieser Rechnung werden entfernt.",
  "trainerstunden.billingStatements.cancelModal.confirm": "Stornieren",
  "trainerstunden.billingStatements.cancelModal.titleMany":
    "{count} Rechnungen stornieren?",
  "trainerstunden.billingStatements.cancelModal.bodyMany":
    "Für jede Rechnung wird eine Stornorechnung erstellt, die Ursprungsrechnung bleibt storniert im Archiv, und ein neuer Entwurf mit denselben Positionen wird angelegt. Erfasste Zahlungen werden entfernt.",
  "trainerstunden.billingStatements.cancelModal.confirmMany": "Alle stornieren",
  "trainerstunden.billingStatements.markSentFailed":
    "Versandstatus konnte nicht gespeichert werden.",
  "trainerstunden.billingStatements.markSentReactivateConflict":
    "Diese Rechnung kollidiert mit einem anderen aktiven Entwurf oder einer offenen Abrechnung derselben Trainingsstunden. Bitte den anderen Entwurf versenden oder verwerfen – oder die stornierte Rechnung über „Zurück in Entwurf“ erneut öffnen.",
  "trainerstunden.billingStatements.markSentFreezeFailed":
    "Rechnungsdaten konnten vor dem Versand nicht eingefroren werden. Bitte Datenbank-Migrationen prüfen oder den Support kontaktieren.",
  "trainerstunden.billingStatements.markPaidFailed":
    "Rechnung konnte nicht als bezahlt markiert werden.",
  "trainerstunden.billingStatements.cancelFailed":
    "Rechnung konnte nicht storniert werden.",
  "trainerstunden.billingStatements.revertDraftFailed":
    "Der Entwurf konnte nicht zurückgeführt werden. Bitte erneut versuchen.",
  "trainerstunden.billingStatements.updatePaymentStatusFailed":
    "Zahlungsstatus konnte nicht aktualisiert werden.",
  "trainerstunden.billingStatements.status.draft": "Im Entwurf",
  "trainerstunden.billingStatements.status.sent": "Versendet",
  "trainerstunden.billingStatements.status.partially_paid": "Teilweise bezahlt",
  "trainerstunden.billingStatements.status.paid": "Bezahlt",
  "trainerstunden.billingStatements.status.cancelled": "Storniert",
  "trainerstunden.billingStatements.action.openEmail": "E‑Mail öffnen",
  "trainerstunden.billingStatements.action.openWhatsapp": "WhatsApp öffnen",
  "trainerstunden.billingStatements.action.sendConfirmation":
    "Bestätigungslink senden",
  "trainerstunden.billingStatements.action.copyLink": "Link kopieren",
  "trainerstunden.billingStatements.action.markSentEmail":
    "Als versandt (E‑Mail)",
  "trainerstunden.billingStatements.action.markSentWhatsapp":
    "Als versandt (WhatsApp)",
  "trainerstunden.billingStatements.action.refreshPayments":
    "Zahlungen aktualisieren",
  "trainerstunden.billingStatements.action.markPaid": "Als bezahlt markieren",
  "trainerstunden.billingStatements.action.cancel": "Rechnung stornieren",
  "trainerstunden.billingStatements.action.revertDraft": "Entwurf zurücknehmen",
  "trainerstunden.billingStatements.action.openSession": "Termin öffnen",
  "trainerstunden.billingStatements.action.correct": "Korrektur",
  "trainerstunden.billingStatements.action.primaryActionsAria":
    "Primäre Aktionen",
  "trainerstunden.billingStatements.action.send": "Senden",
  "trainerstunden.billingStatements.action.sendMenuAria": "Senden-Menü",
  "trainerstunden.billingStatements.action.more": "Mehr",
  "trainerstunden.billingStatements.action.moreMenuAria": "Weitere Aktionen",
  "trainerstunden.billingStatements.action.showDetails": "Details anzeigen",
  "trainerstunden.billingStatements.action.hideDetails": "Details ausblenden",
  "trainerstunden.billingStatements.confirmationMail.noAuth":
    "Du bist nicht angemeldet. Bitte Seite neu laden und erneut versuchen.",
  "trainerstunden.billingStatements.confirmationMail.failed":
    "Bestätigungslink konnte nicht versendet werden.",
  "trainerstunden.billingStatements.confirmationMail.mockHint":
    "Testmodus: Es wurde keine echte E-Mail versendet.",
  "trainerstunden.billingStatements.confirmationMail.sentHint":
    "Bestätigungslink wurde gesendet.",
  "trainerstunden.billingStatements.confirmationMail.copyMissingToken":
    "Noch kein Link vorhanden. Bitte zuerst den Bestätigungslink senden.",
  "trainerstunden.billingStatements.confirmationMail.copied":
    "Link wurde kopiert.",
  "trainerstunden.billingStatements.confirmationMail.copyPrompt":
    "Link kopieren:",
  "trainerstunden.invoice.parentStatusLabel": "Eltern",
  "trainerstunden.invoice.paymentStatusLabel": "Zahlung",
  "trainerstunden.invoice.parentStatus.pending_confirmation": "offen",
  "trainerstunden.invoice.parentStatus.confirmed": "bestätigt",
  "trainerstunden.invoice.parentStatus.question": "Rückfrage",
  "trainerstunden.invoice.paymentStatus.confirmed_unpaid": "offen",
  "trainerstunden.invoice.paymentStatus.awaiting_bank_transfer":
    "Überweisung offen",
  "trainerstunden.invoice.paymentStatus.paypal_started": "PayPal gestartet",
  "trainerstunden.invoice.paymentStatus.paid": "bezahlt",
  "trainerstunden.invoice.paymentStatus.failed": "fehlgeschlagen",
  "trainerstunden.billingStatements.openPrevious.aria":
    "Offene Rechnungen aus Vormonaten",
  "trainerstunden.billingStatements.openPrevious.title": "Offen aus Vormonaten",
  "trainerstunden.billingStatements.openPrevious.summary":
    "{count} offene Rechnungen · offen gesamt: {amount} €",
  "trainerstunden.billingStatements.openPrevious.showCta": "anzeigen",
  "trainerstunden.billingStatements.openPrevious.monthChip":
    "{period}: {count} · {amount} €",
  "trainerstunden.billingStatements.message.subject":
    "Rechnung Tennistraining – {period}",
  "trainerstunden.billingStatements.message.greetingNamed": "Liebe(r) {name},",
  "trainerstunden.billingStatements.message.greetingGeneric":
    "Liebe(r) Sportfreund/in,",
  "trainerstunden.billingStatements.message.thankYou":
    "vielen Dank für dein Vertrauen in uns.",
  "trainerstunden.billingStatements.message.invoiceTitle":
    "Rechnung Tennistraining – {period}",
  "trainerstunden.billingStatements.message.title":
    "Rechnung / Zahlungsaufforderung – {period}",
  "trainerstunden.billingStatements.message.total": "Gesamtsumme: {amount} €",
  "trainerstunden.billingStatements.message.itemsHeader": "Leistungen:",
  "trainerstunden.billingStatements.message.itemsEmpty": "Keine Leistungen",
  "trainerstunden.billingStatements.message.itemLine":
    "{date} · {detail} · {trainer} — {amount} €",
  "trainerstunden.billingStatements.message.itemLineFallback":
    "{description} — {amount} €",
  "trainerstunden.billingStatements.message.footer": "Mit sportlichen Grüßen",
  "trainerstunden.billingStatements.message.signatureTrainer":
    "Dein Trainer\n{name}",
  "trainerstunden.billingStatements.message.signatureCoordinator":
    "Dein Trainingskoordinator\n{name}",
  "trainerstunden.billingStatements.message.paymentPaypalLink":
    "Bezahlung bitte per PayPal: {url}",
  "trainerstunden.billingStatements.message.paymentPaypalHint":
    "Bezahlung bitte per PayPal: {hint}",
  "trainerstunden.billingStatements.message.paymentPaypalEmail":
    "Bezahlung bitte per PayPal an: {email}",
  "trainerstunden.billingStatements.message.paymentPaypalHandle":
    "Bezahlung bitte per PayPal an: {handle}",
  "trainerstunden.billingStatements.message.paymentBankIntro":
    "Bezahlung bitte per Überweisung:",
  "trainerstunden.billingStatements.message.paymentCash":
    "Bezahlung bitte in bar beim nächsten Training.",
  "trainerstunden.billingStatements.item.sessionFixed":
    "{date} · Fix gesamt {total} € · {n} zahlende Personen · Anteil {share} €",
  "trainerstunden.billingStatements.item.sessionHourly":
    "{date} · {durationMin} Min. · {rate} €/h · Anteil {share} €",
  "trainerstunden.billingStatements.item.sessionHourlySubsidized":
    "{date} · {durationMin} Min. · {grossRate} €/h (Eltern {billableRate} €/h) · Anteil {share} €",
  "trainerstunden.billing.externalSubsidy.title":
    "Förderanteil (Verein / Sponsor)",
  "trainerstunden.billing.externalSubsidy.intro":
    "Differenz zwischen vollem Teilnehmerpreis und Eltern-Rechnungssatz — aufsummiert für die gewählte Periode, ohne Eltern-Rechnung.",
  "trainerstunden.billing.externalSubsidy.totalLabel": "Summe Förderanteil",
  "trainerstunden.billing.externalSubsidy.rowMeta": "{count} Termine",
  "trainerstunden.trainer.clubMediationFeeTitle": "Vermittlungsgebühr Verein",
  "trainerstunden.trainer.clubMediationFeeHint":
    "Differenz zwischen Teilnehmerpreis und Eltern-Rechnungssatz wird als eigene Rechnung an den Verein (Rechnungsempfänger) ausgewiesen — z. B. Nachweis Stunden & Zahlungen. Nur für Trainer mit dieser Einstellung.",
  "trainerstunden.trainer.clubMediationFeeEnable":
    "Vermittlungsgebühr an den Verein abrechnen",
  "trainerstunden.trainer.clubMediationFeeContactLabel":
    "Rechnungsempfänger Verein",
  "trainerstunden.trainer.clubMediationFeeContactPlaceholder":
    "Rechnungsempfänger wählen…",
  "trainerstunden.trainer.clubMediationFeeContactRequired":
    "Bitte einen Rechnungsempfänger für die Vermittlungsgebühr wählen.",
  "trainerstunden.billing.clubMediationFee.itemDescription":
    "Vermittlungsgebühr · {trainer} · {person} · {date}",
  "trainerstunden.billing.clubMediationFee.statementNotes":
    "Vermittlungsgebühr (Differenz Teilnehmerpreis / Eltern-Rechnungssatz)",
  "trainerstunden.billingStatements.item.displaySession": "{time} · {training}",
  "trainerstunden.billingStatements.item.sessionLine":
    "{training} von {timeRange} Uhr",
  "trainerstunden.billingStatements.item.trainingHoursLine":
    "{hours}h Training",
  "trainerstunden.billingStatements.item.courtBookingLine":
    "{hours}h Platzbuchung",
  "trainerstunden.billingStatements.item.guestFeeLine": "Gastspielergebühr",
  "trainerstunden.billingStatements.item.positionLabel": "Pos {number}",
  "trainerstunden.report.mailSubject":
    "Kostenübersicht TrainingsDesk – {period}",
  "trainerstunden.report.overviewLineTitle":
    "Kostenübersicht – {period} · Trainer: {trainer}",
  "trainerstunden.report.overviewLinePlayer": "Spieler: {name}",
  "trainerstunden.report.overviewLineHours":
    "Stunden (inkl. Korrektur): {hours}",
  "trainerstunden.report.overviewLineDue": "Fällig: {amount} €",
  "trainerstunden.report.overviewLinePaid": "Bezahlt: {amount} €",
  "trainerstunden.report.overviewLineOpen": "Offen: {amount} €",
  "trainerstunden.report.overviewFooter": "Mit freundlichen Grüßen",
  "trainerstunden.report.missingEmail":
    "Keine E-Mail beim Rechnungsempfänger hinterlegt.",
  "trainerstunden.report.missingPhone":
    "Keine gültige Mobilnummer beim Rechnungsempfänger hinterlegt.",
  "trainerstunden.report.dispatchLogFailed":
    "Protokolleintrag konnte nicht gespeichert werden.",
  "trainerstunden.report.monthTotalsTitle":
    "Summen · {period} (alle Spieler dieser Gruppe)",
  "trainerstunden.report.monthTotalsDueLabel": "Fällig gesamt",
  "trainerstunden.report.monthTotalsPaidLabel": "Bezahlt gesamt",
  "trainerstunden.report.monthTotalsOpenLabel": "Offen gesamt",
  "trainerstunden.report.paymentMonthAttributionHint":
    "Hinweis: „Bezahlt“ pro Spieler bezieht sich auf Zahlungen, deren Buchungsdatum in den gewählten Kalendermonat fällt. Liegt die Buchung z. B. im Mai, erscheint sie nicht unter April.",
  "trainerstunden.report.yearTotalsTitle": "Kalenderjahr {year}",
  "trainerstunden.report.yearTotalsDueLabel": "Trainingskosten (Jahr)",
  "trainerstunden.report.yearTotalsPaidLabel": "Zahlungseingänge (Jahr)",
  "trainerstunden.report.yearTotalsBalanceLabel": "Saldo",
  "trainerstunden.report.yearTotalsHint":
    "Trainingskosten: Summe der fälligen Beträge aller Monate des Jahres für diese Trainer-Gruppe. Zahlungseingänge: Summe aller verbuchten Zahlungen im Jahr für Spieler, die mindestens ein bestätigtes Training bei diesem Trainer im Jahr hatten. Der Saldo ist die Differenz (vereinfachte Jahresübersicht ohne Perioden-Vortrag wie bei Einzelzeilen).",
  "trainerstunden.report.invoiceSessionsHeader":
    "Trainings (bestätigt) im Monat:",
  "trainerstunden.report.invoiceNoSessionsInPeriod":
    "Keine bestätigten Trainings in diesem Monat (nur Salden / Korrektur).",
  "trainerstunden.report.invoiceLineHourly":
    "{date} · {durationMin} Min. · {rate} €/h · Anteil {share} €",
  "trainerstunden.report.invoiceLineFixed":
    "{date} · Fix gesamt {total} € · {n} zahlende Personen · Anteil {share} €",
  "trainerstunden.report.invoiceCorrectionLine":
    "Korrektur (Minuten): {minutes}",
  "trainerstunden.report.invoiceTotalsHeader": "— Summen —",
  "trainerstunden.report.invoiceCarryLine":
    "Vortrag (ältere offene Posten): {amount} €",
  "trainerstunden.report.invoiceMonthDueLine": "Fällig im Monat: {amount} €",
  "trainerstunden.report.invoiceMonthPaidLine":
    "Bereits gezahlt (im Monat): {amount} €",
  "trainerstunden.report.invoiceDisplayOpenLine": "Gesamt offen: {amount} €",
  "trainerstunden.payments.queueTitle":
    "Offen seit letztem Versand (Übersicht)",
  "trainerstunden.payments.queueHint":
    "Hier erscheinen nur Personen/Zahler, für die eine Zahlungsaufforderung protokolliert wurde. Du siehst den damals mitgeteilten Betrag („Mitgeteilt“) und den aktuellen Saldo („Saldo jetzt“) und kannst den Zahlungseingang schnell verbuchen.",
  "trainerstunden.payments.queueEmpty":
    "Noch kein protokollierter Versand einer Zahlungsaufforderung (siehe Spielerabrechnung).",
  "trainerstunden.payments.queueColPerson": "Spieler",
  "trainerstunden.payments.queueColTrainer": "Trainer",
  "trainerstunden.payments.queueColSent": "Letzter Versand",
  "trainerstunden.payments.queueColChannel": "Kanal",
  "trainerstunden.payments.queueColDeclared": "Mitgeteilt (Offen)",
  "trainerstunden.payments.queueColBalance": "Saldo jetzt",
  "trainerstunden.payments.queueColAction": "Aktion",
  "trainerstunden.payments.queueBook": "Zahlung verbuchen",
  "trainerstunden.payments.queueBookDisabled": "Kein offener Betrag",
  "trainerstunden.payments.quickNote":
    "Verbuchung nach Kostenübersicht vom {date}",
  "trainerstunden.payments.quickBookFailed":
    "Zahlung konnte nicht gespeichert werden.",
  "trainerstunden.payments.sectionForm": "Zahlung erfassen",
  "trainerstunden.payments.loading": "Lade Daten…",
  "trainerstunden.trainer.payoutTitle": "Trainerhonorar (Auszahlung)",
  "trainerstunden.trainer.payoutHint":
    "Getrennt von Elternzahlungen und von den Teilnehmer-Stundensätzen unten.",
  "trainerstunden.trainer.payoutVsParticipantRatesExplain":
    "Dieser Betrag wird für die Trainerabrechnung genutzt. Die Stundensätze unten sind Preise für Trainingsgruppen und Teilnehmer.",
  "trainerstunden.trainer.payoutRateLabelSettlement":
    "Betrag (€) — für Trainerabrechnung erforderlich",
  "trainerstunden.trainer.payoutRateSettlementHint":
    "Ohne diesen Betrag kann keine Trainerabrechnung erstellt werden (unabhängig von den Teilnehmer-Stundensätzen).",
  "trainerstunden.trainer.payoutTypeLabel": "Honorar-Typ",
  "trainerstunden.trainer.payoutType.perHour": "Pro bestätigte Stunde",
  "trainerstunden.trainer.payoutType.flatPeriod":
    "Pauschale pro Abrechnungszeitraum",
  "trainerstunden.trainer.payoutRateLabel": "Betrag (€)",
  "trainerstunden.trainer.payoutFrequencyLabel": "Auszahlungsrhythmus",
  "trainerstunden.trainer.payoutFrequency.weekly": "Wöchentlich",
  "trainerstunden.trainer.payoutFrequency.monthly": "Monatlich",
  "trainerstunden.trainer.payoutFrequency.quarterly": "Quartalsweise",
  "trainerstunden.trainer.payoutFrequency.seasonal": "Saisonweise",
  "trainerstunden.trainer.payoutFrequency.adHoc": "Nach Absprache",
  "trainerstunden.trainer.payoutMethodLabel": "Auszahlungsweg",
  "trainerstunden.trainer.payoutMethod.clubTransfer": "Verein zahlt an Trainer",
  "trainerstunden.trainer.payoutMethod.trainerDirect":
    "Direktzahlung an Trainer",
  "trainerstunden.trainer.payoutMethod.cash": "Bar",
  "trainerstunden.trainer.payoutMethod.other": "Sonstiges",
  "trainerstunden.trainer.payoutNotesLabel": "Notiz zur Auszahlung",
  "trainerstunden.trainer.card.openSessions": "Offene Sessions",
  "trainerstunden.trainer.card.openHours": "Offene Stunden",
  "trainerstunden.trainer.card.openAmount": "Offenes Honorar",
  "trainerstunden.trainer.card.lastSettlement": "Letzte Abrechnung",
  "trainerstunden.trainer.card.noSettlement": "Keine",
  "trainerstunden.trainer.card.noOpenSessions":
    "Keine offenen bestätigten Sessions",
  "trainerstunden.trainer.card.createSettlement": "Abrechnung erstellen",
  "trainerstunden.trainer.card.details": "Details",
  "trainerstunden.trainer.card.menuAria": "Weitere Trainer-Aktionen",
  "trainerstunden.trainer.card.edit": "Bearbeiten",
  "trainerstunden.trainer.deleteModal.title": "Trainer löschen?",
  "trainerstunden.trainer.deleteModal.body":
    "Der Trainer wird aus den Stammdaten entfernt. Verknüpfte Termine und Abrechnungen können betroffen sein.",
  "trainerstunden.trainer.deactivate": "Deaktivieren",
  "trainerstunden.trainer.reactivate": "Reaktivieren",
  "trainerstunden.trainer.deactivateModal.title": "Trainer deaktivieren?",
  "trainerstunden.trainer.deactivateModal.body":
    "Der Trainer wird nicht gelöscht. Er erscheint nicht mehr in der Terminplanung. Personenbezogene Daten werden frühestens 6 Monate nach der Deaktivierung anonymisiert. Abrechnungen und Historie bleiben erhalten.",
  "trainerstunden.trainer.deactivateConfirm": "Trainer wirklich deaktivieren?",
  "trainerstunden.trainer.deactivateBlocked":
    "Deaktivierung nicht möglich: {count} zukünftige Termine (nächster: {date}). Bitte zuerst Trainer oder Assistent in der Planung ändern.",
  "trainerstunden.trainer.deactivateFailed":
    "Trainer konnte nicht deaktiviert werden.",
  "trainerstunden.trainer.reactivateConfirm": "Trainer wieder aktivieren?",
  "trainerstunden.trainer.reactivateFailed":
    "Trainer konnte nicht reaktiviert werden.",
  "trainerstunden.trainer.reactivateAnonymizedBlocked":
    "Anonymisierte Trainer können nicht reaktiviert werden. Historische Abrechnungen bleiben unter der anonymisierten Bezeichnung sichtbar.",
  "trainerstunden.trainer.inactiveBadge": "Deaktiviert",
  "trainerstunden.trainer.anonymizedBadge": "Anonymisiert",
  "trainerstunden.trainer.anonymizedDisplayName":
    "Trainer (anonymisiert, {id})",
  "trainerstunden.trainer.inactiveSectionTitle":
    "Deaktivierte Trainer ({count})",
  "trainerstunden.trainer.inactiveSectionHint":
    "Deaktivierte Trainer sind für neue Termine nicht wählbar. Nach mindestens 6 Monaten werden personenbezogene Stammdaten automatisch anonymisiert.",
  "trainerstunden.trainer.form.createHeading": "Neuen Trainer anlegen",
  "trainerstunden.trainer.createOrigin.title": "Person im Verein finden",
  "trainerstunden.trainer.createOrigin.hint":
    "Ist die Person schon als Kontakt im Verein angelegt? Zuerst suchen — sonst neue Trainer-Stammdaten anlegen.",
  "trainerstunden.trainer.createOrigin.searchLabel": "Kontakt im Verein suchen",
  "trainerstunden.trainer.createOrigin.continueWithContact":
    "Aus Kontakt übernehmen",
  "trainerstunden.trainer.createOrigin.createFresh":
    "Neu anlegen (ohne Kontakt)",
  "trainerstunden.trainer.form.editHeading": "Trainer bearbeiten: {name}",
  "trainerstunden.trainer.form.sections.navAria":
    "Bereiche der Trainer-Stammdaten",
  "trainerstunden.trainer.form.sections.scrollHint":
    "Wischen für weitere Bereiche",
  "trainerstunden.trainer.form.sections.basics.title": "Stammdaten",
  "trainerstunden.trainer.form.sections.basics.hint":
    "Name, Vereine, Adresse, Darstellung",
  "trainerstunden.trainer.form.sections.billing.title": "Abrechnung",
  "trainerstunden.trainer.form.sections.billing.hint":
    "Rhythmus, USt., Zahlungswege",
  "trainerstunden.trainer.form.sections.rates.title": "Honorare & Sätze",
  "trainerstunden.trainer.form.sections.rates.hint":
    "Teilnehmerpreise, Auszahlung, Assistent",
  "trainerstunden.trainer.form.sections.assistantRates.title":
    "Honorare & Sätze",
  "trainerstunden.trainer.form.sections.assistantRates.hint":
    "Standard-Anteil pro Termin",
  "trainerstunden.trainer.form.sections.coordination.title": "Koordination",
  "trainerstunden.trainer.form.sections.coordination.hint":
    "Koordinator-Zeiträume",
  "trainerstunden.trainer.form.sections.schedule.title": "Planung",
  "trainerstunden.trainer.form.sections.schedule.hint":
    "Rolle, Verfügbarkeit, Abwesenheit",
  "trainerstunden.trainer.form.sections.access.title": "Zugang",
  "trainerstunden.trainer.form.sections.access.hint":
    "Login und Berechtigungen",
  "trainerstunden.trainer.form.sections.advanced.title": "Erweitert",
  "trainerstunden.trainer.form.sections.advanced.hint":
    "Legacy-Auszahlungsfelder",
  "trainerstunden.trainer.form.navigateGuard.leaveTitle":
    "Bearbeitung abbrechen?",
  "trainerstunden.trainer.form.navigateGuard.leaveIntro":
    "Du verlässt die Trainer-Bearbeitung.",
  "trainerstunden.trainer.form.navigateGuard.dirtyTitle":
    "Änderungen speichern?",
  "trainerstunden.trainer.form.navigateGuard.dirtyIntro":
    "Es gibt ungespeicherte Änderungen an diesem Trainer:",
  "trainerstunden.trainer.form.navigateGuard.keepEditing": "Weiter bearbeiten",
  "trainerstunden.trainer.form.navigateGuard.discard": "Verwerfen",
  "trainerstunden.trainer.form.navigateGuard.save": "Speichern",
  "trainerstunden.trainer.form.unsavedChange.firstName": "Vorname",
  "trainerstunden.trainer.form.unsavedChange.lastName": "Nachname",
  "trainerstunden.trainer.form.unsavedChange.address": "Adresse",
  "trainerstunden.trainer.form.unsavedChange.licenseType": "Lizenz",
  "trainerstunden.trainer.form.unsavedChange.notes": "Notizen",
  "trainerstunden.trainer.form.unsavedChange.availability": "Verfügbarkeit",
  "trainerstunden.trainer.form.unsavedChange.absences": "Abwesenheiten",
  "trainerstunden.trainer.form.unsavedChange.standardRates":
    "Standard-Honorare",
  "trainerstunden.trainer.form.unsavedChange.honorarRates": "Honorar-Sätze",
  "trainerstunden.trainer.form.unsavedChange.parentBillableRates":
    "Eltern-Sätze",
  "trainerstunden.trainer.form.unsavedChange.loginEmail": "Login-E-Mail",
  "trainerstunden.trainer.form.unsavedChange.loginRole": "Login-Rolle",
  "trainerstunden.trainer.form.unsavedChange.uiPermissions": "Berechtigungen",
  "trainerstunden.trainer.form.unsavedChange.schleifchenAccess":
    "Schleifchen-Zugang",
  "trainerstunden.trainer.form.unsavedChange.schleifchenManage":
    "Schleifchen-Verwaltung",
  "trainerstunden.trainer.form.unsavedChange.billingFrequency":
    "Abrechnungsrhythmus",
  "trainerstunden.trainer.form.unsavedChange.billingPaymentTiming":
    "Zahlungszeitpunkt",
  "trainerstunden.trainer.form.unsavedChange.billingAllocationMode":
    "Kostenverteilung",
  "trainerstunden.trainer.form.unsavedChange.paymentDueDays": "Zahlungsziel",
  "trainerstunden.trainer.form.unsavedChange.invoiceVatMode":
    "Umsatzsteuer auf Elternrechnungen",
  "trainerstunden.trainer.form.unsavedChange.invoiceVatRate":
    "Umsatzsteuersatz",
  "trainerstunden.trainer.form.unsavedChange.trainerPayoutType":
    "Auszahlungsart",
  "trainerstunden.trainer.form.unsavedChange.trainerPayoutRate":
    "Auszahlungsbetrag",
  "trainerstunden.trainer.form.unsavedChange.trainerPayoutFrequency":
    "Auszahlungsrhythmus",
  "trainerstunden.trainer.form.unsavedChange.trainerPayoutMethod":
    "Auszahlungsmethode",
  "trainerstunden.trainer.form.unsavedChange.trainerPayoutNotes":
    "Auszahlungsnotizen",
  "trainerstunden.trainer.form.unsavedChange.paypalHandle": "PayPal",
  "trainerstunden.trainer.form.unsavedChange.avatar": "Profilbild",
  "trainerstunden.trainer.form.unsavedChange.avatarColor": "Profilfarbe",
  "trainerstunden.trainer.form.unsavedChange.defaultAssistant":
    "Standard-Assistent",
  "trainerstunden.trainer.form.unsavedChange.defaultAssistantHonorar":
    "Assistenten-Honorar",
  "trainerstunden.trainer.form.unsavedChange.assistantDefaultRate":
    "Assistenten-Standardrate",
  "trainerstunden.trainer.form.unsavedChange.coordinatorFeeType":
    "Koordinator-Anteil (Art)",
  "trainerstunden.trainer.form.unsavedChange.coordinatorFeeValue":
    "Koordinator-Anteil (Wert)",
  "trainerstunden.trainer.form.unsavedChange.coordination": "Koordination",
  "trainerstunden.trainer.form.unsavedChange.uebungsleiterpauschale":
    "Übungsleiterpauschale",
  "trainerstunden.trainer.form.unsavedChange.uebungsleiterContract":
    "Übungsleiter-Vertrag",
  "trainerstunden.trainer.form.unsavedChange.assistantOnly": "Nur Assistent",
  "trainerstunden.trainer.form.unsavedChange.groupingPlaceholder":
    "Gruppierungs-Platzhalter",
  "trainerstunden.trainer.form.unsavedChange.freeTraining": "Freies Training",
  "trainerstunden.trainer.form.unsavedChange.freeTrainingFocus":
    "Freies Training (Schwerpunkt)",
  "trainerstunden.trainer.form.unsavedChange.clubs": "Vereine",
  "trainerstunden.trainer.form.unsavedChange.playerAddress": "Spieler-Adresse",
  "trainerstunden.trainer.form.unsavedChange.playerContact": "Spieler-Kontakt",
  "trainerstunden.trainer.form.unsavedChange.form": "Formular",
  "trainerstunden.settlement.loading": "Lade Daten…",
  "trainerstunden.settlement.intro":
    "Hier erstellst du Trainerabrechnungen für bestätigte Trainings. Elternzahlungen werden weiterhin separat verbucht.",
  "trainerstunden.settlement.pageSubtitle":
    "Pro Trainer: Was du auszahlst — Details nur bei Bedarf aufklappen.",
  "trainerstunden.settlement.trainerOwedLine": "Du schuldest {name} {amount}",
  "trainerstunden.settlement.trainerIncomeLine": "Einnahmen (Eltern): {amount}",
  "trainerstunden.settlement.trainerMarginLine": "Dein Anteil: {amount}",
  "trainerstunden.settlement.trainerDetailsShow": "Einzeltrainings anzeigen",
  "trainerstunden.settlement.trainerDetailsHide": "Einzeltrainings ausblenden",
  "trainerstunden.settlement.unconfirmedPastCompact":
    "{count} Trainings noch nicht bestätigt — Details aufklappen",
  "trainerstunden.settlement.honorarSnapshotMissingCompact":
    "{count} Trainings ohne Honorar — Details aufklappen",
  "trainerstunden.settlement.helpTitle": "Info",
  "trainerstunden.settlement.rateMissing":
    "Trainerhonorar (Betrag €) fehlt oder ist ungültig.",
  "trainerstunden.settlement.rateMissingHint":
    "Bitte unter Stammdaten → Trainer im Abschnitt „Trainerhonorar (Auszahlung)“ den Betrag (€) eintragen.",
  "trainerstunden.settlement.rateMissingExplain":
    "Für {name} ist noch kein Trainerhonorar hinterlegt. Die gepflegten Stundensätze sind Teilnehmerpreise und werden nicht automatisch als Trainerhonorar verwendet.",
  "trainerstunden.settlement.rateMissingAlert":
    "Für {name}: Trainerhonorar (Betrag €) fehlt. Bitte unter Stammdaten → Trainer im Abschnitt „Trainerhonorar (Auszahlung)“ eintragen.",
  "trainerstunden.settlement.honorarSnapshotMissingAlert":
    "Für {name}: Für mindestens eine bestätigte Session fehlt ein gültiger Honorar-Snapshot ({count} betroffen). Bitte die Termine bearbeiten.",
  "trainerstunden.settlement.honorarSnapshotMissingExplain":
    "Für {name} fehlt bei {count} bestätigter Session ein gültiger Honorar-Snapshot. Die Trainerabrechnung nutzt nur die in der Session gespeicherten Honorarfelder.",
  "trainerstunden.settlement.openTrainerMasterdataPayout":
    "Honorarsatz in Stammdaten pflegen",
  "trainerstunden.settlement.flow3.overviewTitle": "Überblick",
  "trainerstunden.settlement.flow3.overviewHint":
    "Offene, bestätigte Trainings pro Trainer – als nächstes prüfen und abrechnen.",
  "trainerstunden.settlement.flow3.overviewCta": "Review öffnen",
  "trainerstunden.settlement.flow3.summaryMain":
    "{trainerCount} Trainer · {sessionCount} Trainings · {amount}",
  "trainerstunden.settlement.flow3.summaryBlocked":
    "{count} Trainer können aktuell nicht abgerechnet werden (fehlende Honorardaten).",
  "trainerstunden.settlement.flow3.createNow": "Abrechnung erstellen",
  "trainerstunden.settlement.flow3.reviewTitle": "Review",
  "trainerstunden.settlement.flow3.reviewHint":
    "Prüfe kurz die offenen Trainings – danach erstellst du die Abrechnungen in einem Schritt.",
  "trainerstunden.settlement.flow3.reviewSummary":
    "{trainerCount} Trainer · Gesamtsumme: {amount}",
  "trainerstunden.settlement.flow3.sessionsShow": "Trainings anzeigen",
  "trainerstunden.settlement.flow3.sessionsHide": "Weniger anzeigen",
  "trainerstunden.settlement.flow3.successTitle": "Abrechnung erstellt",
  "trainerstunden.settlement.flow3.successDetail":
    "{trainerCount} Abrechnungen erstellt · {amount}",
  "trainerstunden.settlement.flow3.backToOverview": "Zurück zum Überblick",
  "trainerstunden.settlement.flow3.markPaid": "Als bezahlt markieren",
  "trainerstunden.settlement.flow3.historyTitle": "Letzte Abrechnungen",
  "trainerstunden.settlement.flow3.historyHint":
    "Zur Orientierung – ohne technische Status-Anzeige.",
  "trainerstunden.settlement.flow3.historyHintShort":
    "Bereits erstellte Trainerabrechnungen.",
  "trainerstunden.settlement.flow3.historyPeriod": "{start} – {end}",
  "trainerstunden.settlement.flow3.historyPaidAt": "Bezahlt am {date}",
  "trainerstunden.settlement.previewTitle": "Vorschau Trainerabrechnung",
  "trainerstunden.settlement.previewHint":
    "Prüfen Sie die Positionen. Erst nach „Abrechnung finalisieren“ wird die Abrechnung festgeschrieben.",
  "trainerstunden.settlement.previewTrainer": "Trainer",
  "trainerstunden.settlement.previewPeriod": "Zeitraum",
  "trainerstunden.settlement.previewSessionsIncludedLabel":
    "Bestätigte Trainings (Anzahl)",
  "trainerstunden.settlement.previewSessionsIncluded": "{count} Trainings",
  "trainerstunden.settlement.previewColDate": "Datum",
  "trainerstunden.settlement.previewColDuration": "Dauer",
  "trainerstunden.settlement.previewColDescription": "Beschreibung",
  "trainerstunden.settlement.previewColAmount": "Betrag",
  "trainerstunden.settlement.previewDurationMin": "{minutes} Min.",
  "trainerstunden.settlement.previewTotal": "Gesamtsumme",
  "trainerstunden.settlement.previewDiscard": "Vorschau schließen",
  "trainerstunden.settlement.actionFinalizeConfirm": "Abrechnung finalisieren",
  "trainerstunden.settlement.flow.back": "Zurück",
  "trainerstunden.settlement.flow.openTitle": "Offen",
  "trainerstunden.settlement.flow.openHint":
    "Trainer mit offenen bestätigten Sessions. Abrechnung erstellen → prüfen → finalisieren.",
  "trainerstunden.settlement.flow.openEmpty":
    "Keine offenen bestätigten Sessions.",
  "trainerstunden.settlement.flow.successTitle": "Abrechnung erstellt",
  "trainerstunden.settlement.flow.successDetail": "Trainer: {name}",
  "trainerstunden.settlement.sessionUntitled": "(ohne Titel)",
  "trainerstunden.settlement.sessionTitleWithPlayers": "{kind} · {players}",
  "trainerstunden.settlement.sessionTitleCustomWithPlayers":
    "{title} · {players}",
  "trainerstunden.settlement.honorarPendingLabel": "Honorar fehlt",
  "trainerstunden.settlement.honorarPendingHint":
    "Training ist noch nicht vollständig bestätigt oder das Honorar wurde noch nicht gespeichert. Im Coach-Desk bestätigen — dann erscheint der Betrag.",
  "trainerstunden.settlement.sessionRowLabel": "{date} · {title}",
  "trainerstunden.settlement.previewFlatLine": "Pauschale (Zeitraum)",
  "trainerstunden.settlement.error.createZeroTotal":
    "Die Abrechnungssumme muss größer als 0 € sein.",
  "trainerstunden.settlement.error.finalizeZeroTotal":
    "Diese Abrechnung hat keine positive Summe und kann nicht finalisiert werden.",
  "trainerstunden.settlement.error.sessionLinkFailed":
    "Die Trainings konnten nicht mit der Abrechnung verknüpft werden.",
  "trainerstunden.settlement.error.readbackSessionLink":
    "Nach dem Verknüpfen stimmen die Session-Zuordnungen nicht (wurden zurückgesetzt).",
  "trainerstunden.settlement.error.readbackFlat":
    "Bei der Pauschalen-Abrechnung wurden keine Trainings verknüpft (wurde zurückgesetzt).",
  "trainerstunden.settlement.error.finalizeHeaderFailed":
    "Der Abrechnungsstatus konnte nicht auf „erstellt“ gesetzt werden (Sessions wurden zurückgesetzt).",
  "trainerstunden.settlement.error.verifyFinalStatus":
    "Unerwarteter Status nach Finalisierung (Änderungen wurden zurückgenommen).",
  "trainerstunden.settlement.error.verifyPostFinalize":
    "Die Session-Verknüpfung nach Finalisierung ist fehlerhaft (Abrechnung wurde zurückgesetzt).",
  "trainerstunden.settlement.kpiAria": "Kennzahlen Trainerabrechnung",
  "trainerstunden.settlement.kpiOpenTrainers": "Offene Trainer",
  "trainerstunden.settlement.kpiOpenSessionsShort": "Offene Trainings",
  "trainerstunden.settlement.kpiOpenHonorarShort": "Geschätztes Honorar",
  "trainerstunden.settlement.openListTitle": "Offene Abrechnungen",
  "trainerstunden.settlement.cardMeta":
    "{sessionCount} Termine · {hours} Stunden offen",
  "trainerstunden.settlement.kpiOpenDrafts": "Offene Entwürfe (Abrechnungen)",
  "trainerstunden.settlement.kpiOpenSessions": "Offene bestätigte Sessions",
  "trainerstunden.settlement.kpiOpenHonorarTotal":
    "Offenes Honorar (geschätzt, Summe)",
  "trainerstunden.settlement.kpiFinalizedPaidLabel": "Erstellt / Bezahlt",
  "trainerstunden.settlement.kpiFinalizedPaidHint":
    "Anzahl finalisierter · bezahlter Abrechnungen",
  "trainerstunden.settlement.separateFromParentsReminder":
    "Hinweis: Trainerabrechnung ist getrennt von Elternzahlungen.",
  "trainerstunden.settlement.previewSummaryAmount": "Summe (Entwurf)",
  "trainerstunden.settlement.previewSummarySessions": "Enthaltene Sessions",
  "trainerstunden.settlement.previewPayoutBlockTitle": "Auszahlung an Trainer",
  "trainerstunden.settlement.previewSessionsListTitle": "Enthaltene Trainings",
  "trainerstunden.settlement.previewColTimeDuration": "Zeit / Dauer",
  "trainerstunden.settlement.previewTimeAndDuration": "{time} · {minutes} Min.",
  "trainerstunden.settlement.previewFlatAmountIncluded":
    "In Pauschale enthalten",
  "trainerstunden.settlement.previewShowMore": "Weitere anzeigen ({count})",
  "trainerstunden.settlement.previewShowLess": "Weniger anzeigen",
  "trainerstunden.settlement.trainingTypeOther": "Trainingsart: {value}",
  "trainerstunden.settlement.rateMissingBadge": "— (fehlt)",
  "trainerstunden.settlement.cardOpenSessions": "Offene Sessions",
  "trainerstunden.settlement.cardOpenHours": "Offene Stunden (Summe)",
  "trainerstunden.settlement.colPaidAt": "Bezahlt am",
  "trainerstunden.settlement.colPaymentRef": "Zahlungsreferenz",
  "trainerstunden.settlement.trainerListTitle": "Trainer",
  "trainerstunden.settlement.trainerListHint":
    "Offene Stunden und voraussichtliches Honorar nach Stammdaten. „Abrechnung erstellen“ legt einen Entwurf an; in der Vorschau prüfen und anschließend finalisieren.",
  "trainerstunden.settlement.openHours": "Offene Stunden",
  "trainerstunden.settlement.openHonorar": "Honorar (geschätzt)",
  "trainerstunden.settlement.openSessionsCount": "{count} offene Termine",
  "trainerstunden.settlement.createButton": "Abrechnung erstellen",
  "trainerstunden.settlement.creating": "Wird erstellt…",
  "trainerstunden.settlement.noneOpen":
    "Keine offenen bestätigten Stunden für diesen Trainer.",
  "trainerstunden.settlement.missingPeriod":
    "Zeitraum konnte nicht ermittelt werden.",
  "trainerstunden.settlement.createFailed":
    "Trainerabrechnung konnte nicht angelegt werden.",
  "trainerstunden.settlement.finalizeFailed":
    "Trainerabrechnung konnte nicht finalisiert werden (Entwurf ggf. in der Historie).",
  "trainerstunden.settlement.markPaidFailed":
    "Status „bezahlt“ konnte nicht gesetzt werden.",
  "trainerstunden.settlement.cancelFailed": "Stornierung ist fehlgeschlagen.",
  "trainerstunden.settlement.confirmCancel":
    "Diese Trainerabrechnung wirklich stornieren? Bei finalisierten Abrechnungen werden die Zuordnungen der Trainingsstunden aufgehoben.",
  "trainerstunden.settlement.historyTitle": "Historie Trainerabrechnungen",
  "trainerstunden.settlement.historyHint":
    "Entwürfe können finalisiert, finalisierte Abrechnungen als bezahlt markiert oder storniert werden.",
  "trainerstunden.settlement.historyEmpty": "Noch keine Trainerabrechnungen.",
  "trainerstunden.settlement.colPeriod": "Zeitraum",
  "trainerstunden.settlement.colTrainer": "Trainer",
  "trainerstunden.settlement.colStatus": "Status",
  "trainerstunden.settlement.colTotal": "Summe",
  "trainerstunden.settlement.colActions": "Aktionen",
  "trainerstunden.settlement.status.draft": "Entwurf",
  "trainerstunden.settlement.status.finalized": "Erstellt",
  "trainerstunden.settlement.status.paid": "Bezahlt",
  "trainerstunden.settlement.status.cancelled": "Storniert",
  "trainerstunden.settlement.actionFinalize": "Finalisieren",
  "trainerstunden.settlement.actionMarkPaid": "Als bezahlt markieren",
  "trainerstunden.settlement.actionCancel": "Stornieren",
  "trainerstunden.settlement.working": "Bitte warten…",
  "trainerstunden.settlement.lineCount": "{count} Positionen",
  "trainerstunden.settlement.detail.title": "Trainerabrechnung – Details",
  "trainerstunden.settlement.detail.notFound":
    "Diese Abrechnung wurde nicht gefunden (vielleicht zwischenzeitlich gelöscht).",
  "trainerstunden.settlement.detail.notesLabel": "Notiz",
  "trainerstunden.settlement.detail.itemsEmpty": "Keine Positionen vorhanden.",
  "trainerstunden.settlement.detail.colHours": "Stunden",
  "trainerstunden.settlement.detail.colRate": "Satz",
  "trainerstunden.settlement.detail.payTitle": "Zahlung",
  "trainerstunden.settlement.detail.paypalHint":
    "Bitte als „An Freunde/Familie senden“ bezahlen. Die PayPal-App nimmt diese Auswahl pro Zahlung auf – sie kann nicht im URL erzwungen werden.",
  "trainerstunden.settlement.detail.paypalOpen":
    "PayPal-Zahlung öffnen ({amount})",
  "trainerstunden.settlement.detail.paypalUrlLabel": "PayPal.me-Link",
  "trainerstunden.settlement.detail.paypalMissing":
    "Kein PayPal-Handle in den Stammdaten dieses Trainers hinterlegt.",
  "trainerstunden.settlement.detail.paypalGoToMasterdata": "Stammdaten öffnen",
  "trainerstunden.settlement.detail.paymentMethods.snapshotNotice":
    "Die angezeigten Zahlungsdaten entsprechen dem Stand zum Zeitpunkt der Finalisierung und ändern sich nicht nachträglich.",
  "trainerstunden.settlement.detail.markPaidTitle": "Als bezahlt markieren",
  "trainerstunden.settlement.detail.markPaidDateLabel": "Zahlungsdatum",
  "trainerstunden.settlement.detail.markPaidReferenceLabel":
    "Zahlungsreferenz (optional)",
  "trainerstunden.settlement.detail.markPaidReferencePlaceholder":
    "z. B. PayPal-Transaktions-ID",
  "trainerstunden.settlement.detail.markPaidNotesLabel": "Notiz (optional)",
  "trainerstunden.settlement.detail.markPaidNotesPlaceholder":
    "Interner Vermerk zur Zahlung",
  "trainerstunden.settlement.detail.markPaidConfirm": "Speichern",
  "trainerstunden.settlement.detail.errorInvalidDate":
    "Ungültiges Zahlungsdatum.",
  "trainerstunden.settlement.detail.paidTitle": "Bezahlt",
  "trainerstunden.settlement.detail.paidNote":
    "Diese Abrechnung wurde bereits als bezahlt verbucht.",
  "trainerstunden.settlement.detail.cancelledTitle": "Storniert",
  "trainerstunden.settlement.detail.cancelledNote":
    "Diese Abrechnung wurde storniert. Die zugehörigen Trainings sind wieder offen.",
  "trainerstunden.settlement.detail.openLink": "{name} ({amount}) öffnen",
  "trainerstunden.settlement.detail.selectionEmpty":
    "Keine Trainings ausgewählt.",
  "trainerstunden.settlement.detail.selectionEmptyBatch":
    "Keine Trainer mit gültiger Auswahl zur Abrechnung.",
  "trainerstunden.settlement.detail.selectionSummary":
    "{selected} von {total} Trainings · {hours} Stunden",
  "trainerstunden.settlement.detail.selectVisible":
    "Sichtbare auswählen ({selected}/{total})",
  "trainerstunden.settlement.detail.createForSelection":
    "Abrechnung erstellen ({count})",
  "trainerstunden.settlement.detail.batchCta":
    "Alle ausgewählten abrechnen ({count})",
  "trainerstunden.settlement.detail.kpiSelectedSessions":
    "Ausgewählte Trainings",
  "trainerstunden.settlement.detail.kpiSelectedAmount": "Honorar (Auswahl)",
  "trainerstunden.settlement.detail.kpiNoSelection":
    "Bitte mindestens einen Trainer mit Auswahl haben.",
  "trainerstunden.settlement.detail.filterBarAria":
    "Trainings-Zeitraum filtern",
  "trainerstunden.settlement.detail.filterAll": "Alle",
  "trainerstunden.settlement.detail.filterCurrentMonth": "Aktueller Monat",
  "trainerstunden.settlement.detail.filterPrevMonth": "Vormonat",
  "trainerstunden.settlement.detail.filterRange": "Eigener Zeitraum",
  "trainerstunden.settlement.detail.filterEmpty":
    "Im gewählten Zeitraum sind keine offenen Trainings.",
  "trainerstunden.settlement.detail.rangeFromLabel": "Von",
  "trainerstunden.settlement.detail.rangeToLabel": "Bis",
  "trainerstunden.settlement.detail.rangeApply":
    "Auswahl im Zeitraum übernehmen",
  "trainerstunden.settlement.detail.groupCount":
    "{selected}/{total} ausgewählt",
  "trainerstunden.settlement.detail.toggleSessionAria":
    "Training {date} – {title} auswählen",
  "trainerstunden.settlement.detail.colDate": "Datum",
  "trainerstunden.settlement.detail.colTime": "Zeit · Dauer",
  "trainerstunden.settlement.detail.colTitle": "Titel",
  "trainerstunden.settlement.detail.colAmount": "Honorar",
  "trainerstunden.settlement.detail.kpiTrainerInline": "Trainer offen",
  "trainerstunden.settlement.detail.kpiSessionsInline": "Sessions ausgewählt",
  "trainerstunden.settlement.detail.kpiAmountInline": "Honorar (Auswahl)",
  "trainerstunden.settlement.historyDrawerLabel":
    "Letzte Abrechnungen anzeigen ({count})",
  "trainerstunden.settlement.unconfirmedPastTitle":
    "{count} vergangene Trainings warten auf Bestätigung",
  "trainerstunden.settlement.unconfirmedPastHint":
    "Solange diese Trainings nicht als „durchgeführt“ bestätigt sind, können sie weder hier in die Trainerabrechnung noch bei den Eltern/Spielern abgerechnet werden.",
  "trainerstunden.settlement.unconfirmedPastSince":
    "Ältestes offenes Training: {date}",
  "trainerstunden.settlement.unconfirmedPastCta":
    "{count} Trainings im Coach-Desk bestätigen",
  "trainerstunden.settlement.unconfirmedPastCtaSingle":
    "Training im Coach-Desk bestätigen",
  "trainerstunden.settlement.unconfirmedOnlyMeta":
    "{count} unbestätigte Trainings · keine offene Trainerabrechnung",
  "trainerstunden.payouts.sectionTitle": "Trainer-Auszahlungen",
  "trainerstunden.payouts.sectionHint":
    "Offene Honorare prüfen und Auszahlungen anstoßen — wie in einem Banking-Dashboard.",
  "trainerstunden.payouts.parentsSectionTitle": "Elternzahlungen",
  "trainerstunden.payouts.parentsSectionHint":
    "Eingänge zu offenen Eltern-/Spieler-Rechnungen erfassen. Getrennt von Trainer-Auszahlungen.",
  "trainerstunden.payouts.kpiOpenAmount": "Offene Auszahlungen",
  "trainerstunden.payouts.kpiOpenCount": "{count} offene Abrechnung(en)",
  "trainerstunden.payouts.kpiPaidAmount": "Bereits ausgezahlt",
  "trainerstunden.payouts.kpiPaidCount": "{count} bezahlte Abrechnung(en)",
  "trainerstunden.payouts.dash.kpiAria": "Kennzahlen Trainer-Auszahlungen",
  "trainerstunden.payouts.dash.kpiOpen": "Offen",
  "trainerstunden.payouts.dash.kpiOpenMeta": "{count} Auszahlungen",
  "trainerstunden.payouts.dash.kpiPaid": "Bereits ausgezahlt",
  "trainerstunden.payouts.dash.kpiPaidMeta": "{count} Auszahlungen",
  "trainerstunden.payouts.dash.kpiMonth": "Diesen Monat",
  "trainerstunden.payouts.dash.kpiAvg": "Durchschnittliche Auszahlung",
  "trainerstunden.payouts.dash.badgePaypal": "PayPal verbunden",
  "trainerstunden.payouts.dash.badgeNoMethod": "Noch keine Zahlungsart",
  "trainerstunden.payouts.dash.badgeBankMissing": "Bankverbindung fehlt",
  "trainerstunden.payouts.dash.badgeBlocked": "Auszahlung blockiert",
  "trainerstunden.payouts.dash.amountLabel": "Auszahlung",
  "trainerstunden.payouts.dash.statusLabel": "Status",
  "trainerstunden.payouts.dash.statusOpen": "Offen",
  "trainerstunden.payouts.dash.sessionsCount": "{count} Sessions",
  "trainerstunden.payouts.dash.lastSession": "Letzte Session: {date}",
  "trainerstunden.payouts.dash.createCta": "Auszahlung erstellen",
  "trainerstunden.payouts.dash.bulkTitle": "{count} Sessions ausgewählt",
  "trainerstunden.payouts.dash.bulkCta": "Alle ausgewählten auszahlen",
  "trainerstunden.payouts.dash.showDetails": "Details anzeigen",
  "trainerstunden.payouts.dash.hideDetails": "Details ausblenden",
  "trainerstunden.payouts.dash.blockSessions": "Sessions",
  "trainerstunden.payouts.dash.blockHonor": "Honorar",
  "trainerstunden.payouts.dash.blockHistory": "Historie",
  "trainerstunden.payouts.dash.blockPeriod": "Zeitraum",
  "trainerstunden.payouts.dash.periodFrom": "Von",
  "trainerstunden.payouts.dash.periodTo": "Bis",
  "trainerstunden.payouts.dash.honorSum": "Summe",
  "trainerstunden.payouts.dash.honorCorrections": "Korrekturen",
  "trainerstunden.payouts.dash.honorTotal": "Endbetrag",
  "trainerstunden.payouts.dash.lastPaid": "Letzte Auszahlung",
  "trainerstunden.payouts.dash.reference": "Referenz",
  "trainerstunden.payouts.dash.payMethod": "Zahlungsart",
  "trainerstunden.payouts.dash.emptyTitle": "Alle Trainer sind ausgezahlt",
  "trainerstunden.payouts.dash.emptyBody":
    "Momentan gibt es keine offenen Honorare.",
  "trainerstunden.payouts.dash.openEmptyTitle": "Alle Trainer sind ausgezahlt",
  "trainerstunden.payouts.dash.openEmptyBody":
    "Momentan gibt es keine offenen Honorare.",
  "trainerstunden.payouts.dash.kpiOpenTrainersMeta": "{count} Trainer",
  "trainerstunden.payouts.filterAria": "Trainer-Auszahlungen filtern",
  "trainerstunden.payouts.filterStatus.open": "Offen",
  "trainerstunden.payouts.filterStatus.paid": "Bezahlt",
  "trainerstunden.payouts.filterStatus.cancelled": "Storniert",
  "trainerstunden.payouts.filterStatus.all": "Alle",
  "trainerstunden.payouts.filterTrainerLabel": "Trainer",
  "trainerstunden.payouts.filterTrainerAll": "Alle Trainer",
  "trainerstunden.payouts.filterMonthLabel": "Monat",
  "trainerstunden.payouts.filterSearchLabel": "Suche",
  "trainerstunden.payouts.filterSearchPlaceholder":
    "Name oder Zahlungsreferenz",
  "trainerstunden.payouts.empty": "Keine Auszahlungen im aktuellen Filter.",
  "trainerstunden.payouts.colTrainer": "Trainer",
  "trainerstunden.payouts.colPeriod": "Zeitraum",
  "trainerstunden.payouts.colStatus": "Status",
  "trainerstunden.payouts.colAmount": "Betrag",
  "trainerstunden.payouts.colPaid": "Bezahlt",
  "trainerstunden.payouts.colActions": "Aktionen",
  "trainerstunden.payouts.openDetail": "Details",
  "trainerstunden.payouts.filteredTotal": "Summe (gefiltert)",
  "trainerstunden.trainer.paypalBlockTitle": "Zahlung an Trainer (PayPal)",
  "trainerstunden.trainer.paypalBlockHint":
    "Trag den PayPal-Handle des Trainers ein. In der Trainerabrechnung wird daraus automatisch ein PayPal.me-Link für Friends/Family-Auszahlungen generiert.",
  "trainerstunden.trainer.paypalHandleLabel":
    "PayPal-Handle (für Friends/Family-Auszahlung)",
  "trainerstunden.trainer.paypalHandlePlaceholder": "z. B. mbreitenfellner",
  "trainerstunden.trainer.paypalHandleHelp":
    "Wird zu paypal.me/{handle}/{betrag}EUR erweitert. Nur der Handle, keine vollständige URL.",
  "trainerstunden.trainer.avatarBlockTitle": "Trainerfoto (optional)",
  "trainerstunden.trainer.avatarBlockHint":
    "Öffentliche Bild-URL (HTTPS), z. B. von eurer Website oder einem Bildhoster. Wird in der Coach-Desktop-Liste angezeigt; ohne URL erscheinen Initialen.",
  "trainerstunden.trainer.avatarUrlLabel": "Bild-URL (HTTPS)",
  "trainerstunden.trainer.avatarUrlPlaceholder": "https://…",
  "trainerstunden.trainer.avatarUrlHelp":
    "Nur https://-Links werden gespeichert. Bei Fehler oder Blockierung durch den Host werden Initialen gezeigt.",
  "trainerstunden.trainer.avatarColor.legend":
    "Farbe der Initialen (ohne Foto)",
  "trainerstunden.trainer.avatarColor.auto": "Automatisch",
  "trainerstunden.trainer.avatarColor.autoHint":
    "Die Farbe wird automatisch aus dem Trainer zugeordnet.",
  "trainerstunden.trainer.avatarColor.manualHint":
    "Manuell gewählte Farbe {index} von 7.",
  "trainerstunden.trainer.avatarColor.swatchAria": "Farbe {index}",
  "trainerstunden.trainer.planningRoleTitle": "Rolle in der Terminplanung",
  "trainerstunden.trainer.planningRoleHint":
    "Assistenztrainer können nur als Assistent an Terminen mit einem anderen Haupttrainer eingesetzt werden. Normale Trainer können Haupt- und Assistenzrolle haben – pro Termin aber nur einmal.",
  "trainerstunden.trainer.isAssistantOnlyLabel":
    "Nur Assistenztrainer (nicht als Haupttrainer planbar)",
  "trainerstunden.trainer.isAssistantOnlyActiveNote":
    "Standard-Assistent und Honorar-Aufteilung entfallen, weil dieser Trainer nicht als Haupttrainer geplant wird.",
  "trainerstunden.trainer.assistantOnlyBadge": "Assistenztrainer",
  "trainerstunden.trainer.assistantBlockTitle": "Trainerassistent (optional)",
  "trainerstunden.trainer.assistantBlockHint":
    "Der Teilnehmerpreis bleibt unverändert. Hier legst du fest, welcher Anteil des Trainerhonorars an einen Assistenten geht – der Rest bleibt beim Haupttrainer.",
  "trainerstunden.trainer.assistantTrainerLabel": "Trainerassistent",
  "trainerstunden.trainer.assistantNone": "Kein Assistent",
  "trainerstunden.trainer.assistantHonorarLabel":
    "Assistenten-Anteil pro Termin (€)",
  "trainerstunden.trainer.assistantHonorarPlaceholder": "z. B. 10",
  "trainerstunden.trainer.assistantSameTrainerError":
    "Der Assistent darf nicht derselbe Trainer sein.",
  "trainerstunden.trainer.assistantShareExceedsHonorar":
    "Der Assistenten-Anteil darf das Trainerhonorar dieser Session nicht übersteigen.",
  "trainerstunden.trainer.assistantSplitPreview":
    "Aufteilung (Trainerhonorar): gesamt {gross} € · Assistent {assistant} € · Trainer {net} €",
  "trainerstunden.trainer.assistantOwnRateTitle": "Assistenten-Satz",
  "trainerstunden.trainer.assistantOwnRateHint":
    "Dein Standard-Anteil pro Termin, wenn du als Trainerassistent eingesetzt wirst. Ist beim Haupttrainer ein abweichender Betrag hinterlegt, gilt dieser stattdessen.",
  "trainerstunden.trainer.assistantOwnRateLabel":
    "Standard-Anteil pro Termin (€)",
  "trainerstunden.trainer.coordinatorFeeBlockTitle":
    "Koordinator-Anteil (intern)",
  "trainerstunden.trainer.coordinatorFeeBlockHint":
    "Optional: zusätzlicher Koordinator-Anteil vom Trainer-Honorar (Provision). Ohne Eintrag erhält der Trainer den vollen Auszahlungssatz aus dem Block „Auszahlung an Trainer“.",
  "trainerstunden.trainer.coordinatorFeeTypeLabel": "Art des Anteils",
  "trainerstunden.trainer.coordinatorFeeType.none": "Kein Anteil",
  "trainerstunden.trainer.coordinatorFeeType.percent": "Prozent vom Honorar",
  "trainerstunden.trainer.coordinatorFeeType.perHour":
    "Betrag je Trainingsstunde (€/h)",
  "trainerstunden.trainer.coordinatorFeeType.flatSession":
    "Pauschale je Termin (€)",
  "trainerstunden.trainer.coordinatorFeeValueLabel": "Anteil",
  "trainerstunden.trainer.coordinatorFeeValuePercentLabel": "Anteil in Prozent",
  "trainerstunden.trainer.coordinatorFeeValuePerHourLabel":
    "Anteil je Stunde (€/h)",
  "trainerstunden.trainer.coordinatorFeeValueFlatLabel":
    "Pauschale je Termin (€)",
  "trainerstunden.trainer.coordinatorFeeValuePlaceholder": "z. B. 10",
  "trainerstunden.trainer.coordinatorFeeSplitPreview":
    "Aufteilung (Trainerhonorar): gesamt {gross} € · Koordinator {coordinator} € · Trainer {net} €",
  "trainerstunden.trainer.coordinatorShareExceedsHonorar":
    "Assistenten- und Koordinator-Anteil dürfen zusammen das Trainerhonorar nicht übersteigen.",
  "trainerstunden.trainer.coordinatorRecipientMissing":
    "Für den Koordinator-Anteil konnte kein Trainer-Datensatz mit deiner Login-E-Mail angelegt werden. Bitte in der Trainer-Verwaltung prüfen oder Support kontaktieren.",
  "trainerstunden.planning.unsavedChange.coordinatorFeeType":
    "Koordinator-Anteil (Art)",
  "trainerstunden.planning.unsavedChange.coordinatorFeeValue":
    "Koordinator-Anteil (Wert)",
  "trainerstunden.settlement.sessionRowLabelAssistant":
    "{date} · {title} (Assistenten-Anteil)",
  "trainerstunden.settlement.sessionRowLabelCoordinator":
    "{date} · {title} (Koordinator-Anteil)",
  "trainerstunden.settlement.sessionRowLabelNet":
    "{date} · {title} (netto, Assistent {assistantAmount})",
  "trainerstunden.trainer.paymentMethods.title": "Zahlungsmethoden (Empfang)",
  "trainerstunden.trainer.paymentMethods.intro":
    "Lege fest, wie Zahlungen eingehen (PayPal, Überweisung, Bar). Das Zahlungsziel legst du im Abrechnungsblock des Trainers fest.",
  "trainerstunden.trainer.paymentMethods.addCta": "Zahlungsmethode hinzufügen",
  "trainerstunden.trainer.paymentMethods.empty":
    "Noch keine Zahlungsmethode hinterlegt.",
  "trainerstunden.trainer.paymentMethods.defaultBadge": "Standard",
  "trainerstunden.trainer.paymentMethods.activeToggle": "Aktiv",
  "trainerstunden.trainer.paymentMethods.type.paypal": "PayPal",
  "trainerstunden.trainer.paymentMethods.type.bank_transfer": "Banküberweisung",
  "trainerstunden.trainer.paymentMethods.type.cash": "Bar",
  "trainerstunden.trainer.paymentMethods.form.paypalEmail": "PayPal-E-Mail",
  "trainerstunden.trainer.paymentMethods.form.paypalHandle": "PayPal-Handle",
  "trainerstunden.trainer.paymentMethods.form.paypalMeUrl": "PayPal.me-Link",
  "trainerstunden.trainer.paymentMethods.form.paypalMode": "PayPal-Zahlungsart",
  "trainerstunden.trainer.paymentMethods.form.paypalModeFriends":
    "Freunde & Familie (paypal.me)",
  "trainerstunden.trainer.paymentMethods.form.paypalModeCheckout":
    "PayPal Business (automatische Zahlungsbestätigung)",
  "trainerstunden.trainer.paymentMethods.form.paypalModeCheckoutHint":
    "Eltern erhalten einen sicheren PayPal-Checkout-Link in der Rechnungs-Mail. Nach Zahlung wird die Rechnung automatisch als bezahlt markiert.",
  "trainerstunden.trainer.paymentMethods.form.paypalModeCheckoutPlatformWarn":
    "Voraussetzung: PayPal Business API muss für die Plattform hinterlegt sein (PAYPAL_CLIENT_ID / PAYPAL_SECRET). Ohne diese Konfiguration kann keine Rechnung mit dieser Zahlungsart versendet werden — es gibt keinen stillen Fallback auf Freunde & Familie.",
  "trainerstunden.trainer.paymentMethods.form.paypalModeFriendsHint":
    "Klassischer paypal.me-Link oder E-Mail-Hinweis — Zahlungseingang musst du manuell bestätigen.",
  "trainerstunden.billingInvoicePreview.paypalCheckoutPending":
    "PayPal Business: Zahlungslink wird mit der Rechnungs-Mail versendet (nur wenn die Plattform-PayPal-API konfiguriert ist).",
  "trainerstunden.billingSend.error.paypalCheckoutNotConfigured":
    "PayPal Business ist als Zahlungsart gewählt, aber die PayPal-API der Plattform ist nicht konfiguriert. Bitte Admin: PAYPAL_CLIENT_ID und PAYPAL_SECRET setzen — oder vorübergehend „Freunde & Familie“ wählen.",
  "trainerstunden.trainer.paymentMethods.form.displayName":
    "Anzeigename (optional)",
  "trainerstunden.trainer.paymentMethods.form.displayNameHint":
    "Kurzbezeichnung auf der Rechnung, z. B. „Girokonto TC“. Leer lassen = Zahlungsart wird angezeigt.",
  "trainerstunden.trainer.paymentMethods.form.instructions":
    "Zahlungshinweis auf der Rechnung (optional)",
  "trainerstunden.trainer.paymentMethods.form.instructionsHint":
    "Freitext für Empfänger, z. B. Verwendungszweck oder „Bitte bar beim nächsten Training begleichen“.",
  "trainerstunden.trainer.paymentMethods.form.dueDays": "Zahlungsziel (Tage)",
  "trainerstunden.trainer.paymentMethods.form.dueDaysHint":
    "Frist ab Rechnungsdatum — erscheint als Zahlungsziel auf der Rechnung (z. B. 7 = 7 Tage netto).",
  "trainerstunden.trainer.paymentMethods.form.accountHolder": "Kontoinhaber",
  "trainerstunden.trainer.paymentMethods.form.iban": "IBAN",
  "trainerstunden.trainer.paymentMethods.form.ibanHint":
    "Vollständige IBAN mit Prüfziffer (ISO 13616). Für DE: 22 Zeichen, z. B. DE89 3704 0044 0532 0130 00.",
  "trainerstunden.trainer.paymentMethods.form.bicOptional": "BIC (optional)",
  "trainerstunden.trainer.paymentMethods.form.bicHint":
    "Nur bei ausländischen IBAN erforderlich. Bei DE-IBAN innerhalb des SEPA-Raums nicht nötig.",
  "trainerstunden.trainer.paymentMethods.form.bicDeNotRequired":
    "Bei deutscher IBAN ist keine BIC-Angabe erforderlich (SEPA-Überweisung).",
  "trainerstunden.trainer.paymentMethods.form.ibanLast4":
    "IBAN endet auf (4 Ziffern)",
  "trainerstunden.trainer.paymentMethods.form.bic": "BIC",
  "trainerstunden.trainer.paymentMethods.confirmDelete":
    "Diese Zahlungsmethode wirklich entfernen?",
  "trainerstunden.trainer.paymentMethods.deleteModalTitle":
    "Zahlungsmethode löschen",
  "trainerstunden.trainer.paymentMethods.afterSaveHint":
    "Zahlungsmethoden kannst du anlegen, sobald der Trainer gespeichert ist (danach hier bearbeiten).",
  "trainerstunden.trainer.paymentMethods.loadError":
    "Zahlungsmethoden konnten nicht geladen werden.",
  "trainerstunden.trainer.paymentMethods.mirrorPersistFailed":
    "PayPal-Handle in den Stammdaten konnte nicht automatisch mit den Zahlungsmethoden abgeglichen werden.",
  "trainerstunden.trainer.paymentMethods.setDefaultFailed":
    "Standard-Zahlungsmethode konnte nicht gesetzt werden.",
  "trainerstunden.trainer.paymentMethods.setDefaultCta": "Als Standard",
  "trainerstunden.trainer.paymentMethods.inactiveBadge": "Inaktiv",
  "trainerstunden.trainer.paymentMethods.formTitleAdd":
    "Zahlungsmethode hinzufügen",
  "trainerstunden.trainer.paymentMethods.formTitleEdit":
    "Zahlungsmethode bearbeiten",
  "trainerstunden.trainer.paymentMethods.formPaymentType": "Zahlungsart",
  "trainerstunden.trainer.paymentMethods.formTypeLocked": "Zahlungsart",
  "trainerstunden.trainer.paymentMethods.setAsDefault":
    "Direkt als Standard für diesen Trainer setzen",
  "trainerstunden.trainer.paymentMethods.errors.missingTrainer":
    "Trainer fehlt – bitte zuerst speichern.",
  "trainerstunden.trainer.paymentMethods.errors.bankIbanLast4":
    "Bitte genau vier Ziffern für „IBAN endet auf“ eintragen.",
  "trainerstunden.trainer.paymentMethods.errors.bankIbanRequired":
    "Bitte die vollständige IBAN eintragen.",
  "trainerstunden.trainer.paymentMethods.errors.bankAccountHolderRequired":
    "Bitte den Kontoinhaber eintragen.",
  "trainerstunden.trainer.paymentMethods.errors.ibanInvalidFormat":
    "IBAN ungültig: Zwei Buchstaben (Land), zwei Prüfziffern, danach nur Buchstaben und Ziffern.",
  "trainerstunden.trainer.paymentMethods.errors.ibanInvalidLength":
    "IBAN hat für dieses Land die falsche Länge.",
  "trainerstunden.trainer.paymentMethods.errors.ibanInvalidChecksum":
    "IBAN-Prüfziffer ist falsch — bitte Eingabe kontrollieren.",
  "trainerstunden.trainer.paymentMethods.errors.bicInvalidFormat":
    "BIC ungültig (8 oder 11 Zeichen, z. B. COBADEFFXXX).",
  "trainerstunden.trainer.paymentMethods.errors.dueDaysInvalid":
    "Zahlungsziel: bitte eine ganze Zahl zwischen 1 und 366 Tagen eintragen.",
  "trainerstunden.trainer.paymentMethods.errors.validation":
    "Bitte Eingaben prüfen.",
  "trainerstunden.trainer.paymentMethods.errors.saveFailed":
    "Speichern ist fehlgeschlagen.",
  "trainerstunden.trainer.paymentMethods.errors.schemaPending":
    "Gespeichert, aber das Zahlungsziel (Tage) konnte nicht übernommen werden — bitte die ausstehende Migration anwenden und danach erneut speichern.",
  "trainerstunden.trainer.paymentMethods.errors.missingTable":
    "Zahlungsmethoden sind in der Datenbank noch nicht eingerichtet. Bitte die ausstehende Migration anwenden (trainerstunden_payment_methods).",
  "trainerstunden.trainer.paymentMethods.errors.forbidden":
    "Keine Berechtigung zum Speichern der Zahlungsmethode. Bitte erneut anmelden oder den Vereins-Administrator kontaktieren.",
  "trainerstunden.trainer.paymentMethods.errors.missingTenant":
    "Kein Mandant (Tenant) zugeordnet — Zahlungsmethode kann nicht gespeichert werden.",
  "trainerstunden.trainer.paymentMethods.errors.noSupabase":
    "Datenbankverbindung nicht verfügbar.",
  "trainerstunden.trainer.paymentMethods.errors.requireOneContact":
    "Bitte mindestens PayPal-Handle, PayPal-E-Mail oder PayPal.me-Link angeben.",
  "trainerstunden.trainer.paymentMethods.errors.paypalCheckoutRequiresEmail":
    "Für PayPal Business ist eine PayPal-E-Mail erforderlich.",
  "trainerstunden.trainer.payoutMethod.paypal": "PayPal Friends/Family",
  "trainerstunden.confirm.deletePayment": "Zahlung wirklich löschen?",
  "trainerstunden.action.edit": "Bearbeiten",
  "trainerstunden.action.cancel": "Abbrechen",
  "trainerstunden.action.prev": "Zurück",
  "trainerstunden.action.next": "Weiter",
  "trainerstunden.sheet.close": "Schließen",
  "home.cards.trainerstunden.title": "TrainingsDesk",
  "home.cards.trainerstunden.text":
    "Trainings planen, Teilnehmer führen und Abrechnung – als Modul im TennisMatches-Ökosystem.",
  "nav.bpmn": "BPMN",
  "superadmin.nav.bpmn": "BPMN",
  "superadmin.nav.dashboard": "Dashboard",
  "superadmin.nav.featureFlags": "Feature Flags",
  "superadmin.nav.reports": "Reports",
  "superadmin.nav.appearance": "Appearance",
  "superadmin.nav.clubs": "Vereine",
  "superadmin.nav.governance": "Governance",
  "superadmin.nav.aria": "Superadmin-Navigation",
  "superadmin.bpmn.title": "Superadmin – BPMN",
  "superadmin.bpmn.hint":
    "BPMN-Visualisierung aus BPMN 2.0 XML (Repo-Artefakt).",
  "superadmin.tiles.bpmn.title": "BPMN",
  "superadmin.tiles.bpmn.desc":
    "BPMN 2.0 Prozessvisualisierung (XML als Repo-Artefakt).",
  "superadmin.tiles.bpmn.open": "BPMN öffnen",

  "superadmin.nav.exerciseMetadata": "Übungs-Metadaten",
  "superadmin.tiles.exerciseMetadata.title": "Übungs-Metadaten",
  "superadmin.tiles.exerciseMetadata.desc":
    "Globale Kategorien, Level, Schwierigkeit und Tags für Übungen.",
  "superadmin.tiles.exerciseMetadata.open": "Metadaten verwalten",
  "superadmin.exerciseMetadata.title": "Übungs-Metadaten",
  "superadmin.exerciseMetadata.subtitle":
    "Globale Metadaten für Übungen (Kategorie, Level, Schwierigkeit, Tags). Nur Superadmin kann bearbeiten.",
  "superadmin.exerciseMetadata.add.title": "Neues Metadatum (Tag)",
  "superadmin.exerciseMetadata.field.key": "Key",
  "superadmin.exerciseMetadata.field.label": "Name",
  "superadmin.exerciseMetadata.field.sort": "Sortierung",
  "superadmin.exerciseMetadata.field.description": "Beschreibung",
  "superadmin.exerciseMetadata.col.key": "Key",
  "superadmin.exerciseMetadata.col.label": "Name",
  "superadmin.exerciseMetadata.col.sort": "Sort.",
  "superadmin.exerciseMetadata.col.active": "Aktiv",
  "superadmin.exerciseMetadata.col.description": "Beschreibung",
  "superadmin.exerciseMetadata.empty": "Keine Einträge",
  "superadmin.exerciseMetadata.error.load":
    "Metadaten konnten nicht geladen werden.",
  "superadmin.exerciseMetadata.error.save": "Speichern fehlgeschlagen.",
  "superadmin.exerciseMetadata.success.add": "Metadatum angelegt.",
  "superadmin.exerciseMetadata.success.save": "Gespeichert.",

  "superadmin.nav.repositoryCoverage": "Repository-Abdeckung",
  "superadmin.tiles.repositoryCoverage.title": "Repository-Abdeckung",
  "superadmin.tiles.repositoryCoverage.desc":
    "Ziel-KPIs für Schläge, Schlagart und Schwerpunkte im globalen Übungs-Repository.",
  "superadmin.tiles.repositoryCoverage.open": "KPIs anzeigen",
  "superadmin.repositoryKpis.title": "Repository-Abdeckung",
  "superadmin.repositoryKpis.subtitle":
    "Globale Ziel-KPIs für das Übungs-Repository. Ziele werden zentral in der Datenbank gepflegt.",
  "superadmin.repositoryKpis.tab.coverage": "Abdeckung",
  "superadmin.repositoryKpis.tab.targets": "Zielwerte",
  "superadmin.repositoryKpis.filter.dimension": "Dimension",
  "superadmin.repositoryKpis.dimension.stroke": "Schläge",
  "superadmin.repositoryKpis.dimension.strokeType": "Schlagart",
  "superadmin.repositoryKpis.dimension.focusArea": "Schwerpunkte",
  "superadmin.repositoryKpis.dimension.level": "Level",
  "superadmin.repositoryKpis.dimension.ageGroup": "Altersgruppe",
  "superadmin.repositoryKpis.col.label": "Aspekt",
  "superadmin.repositoryKpis.col.counts": "Ist / Bronze / Silber / Gold",
  "superadmin.repositoryKpis.col.avgFill": "Ø Füllgrad",
  "superadmin.repositoryKpis.col.coverage": "Abdeckung",
  "superadmin.repositoryKpis.col.status": "Status",
  "superadmin.repositoryKpis.col.gaps": "Lücken B/S/G",
  "superadmin.repositoryKpis.level.below_target": "Unter Ziel",
  "superadmin.repositoryKpis.level.bronze": "Bronze",
  "superadmin.repositoryKpis.level.silver": "Silber",
  "superadmin.repositoryKpis.level.gold": "Gold",
  "superadmin.repositoryKpis.empty": "Keine KPI-Daten",
  "superadmin.repositoryKpis.emptyTargets": "Keine Zielwerte",
  "superadmin.repositoryKpis.add.title": "Neuer Zielwert",
  "superadmin.repositoryKpis.field.key": "Key",
  "superadmin.repositoryKpis.field.label": "Label",
  "superadmin.repositoryKpis.field.metadataItemKey":
    "Metadaten-Key (Übungs-Tags)",
  "superadmin.repositoryKpis.field.sort": "Sortierung",
  "superadmin.repositoryKpis.field.active": "Aktiv",
  "superadmin.repositoryKpis.field.bronzeFill": "Bronze Füllgrad %",
  "superadmin.repositoryKpis.field.silverFill": "Silber Füllgrad %",
  "superadmin.repositoryKpis.field.goldFill": "Gold Füllgrad %",
  "superadmin.repositoryKpis.col.tierShort.bronze": "B",
  "superadmin.repositoryKpis.col.tierShort.silver": "S",
  "superadmin.repositoryKpis.col.tierShort.gold": "G",
  "superadmin.repositoryKpis.col.fillShort.bronze": "B-Füll",
  "superadmin.repositoryKpis.col.fillShort.silver": "S-Füll",
  "superadmin.repositoryKpis.col.fillShort.gold": "G-Füll",
  "superadmin.repositoryKpis.error.load": "KPIs konnten nicht geladen werden.",
  "superadmin.repositoryKpis.error.save": "Speichern fehlgeschlagen.",
  "superadmin.repositoryKpis.success.add": "Zielwert angelegt.",
  "superadmin.repositoryKpis.success.save": "Gespeichert.",

  "superadmin.tiles.trainingMetadata.title": "Trainings-Metadaten",
  "superadmin.tiles.trainingMetadata.desc":
    "Generisches Metadatenmodell mit Dimensionen, Items und i18n (Tennis).",
  "superadmin.tiles.trainingMetadata.open": "Modell anzeigen",
  "superadmin.nav.trainingMetadata": "Trainings-Metadaten",
  "superadmin.trainingMetadata.title": "Trainings-Metadaten",
  "superadmin.trainingMetadata.subtitle":
    "Generisches Metadatenmodell (sport=tennis). Dimensionen und Items aus der Datenbank.",
  "superadmin.trainingMetadata.dimensions.title": "Dimensionen",
  "superadmin.trainingMetadata.col.key": "Key",
  "superadmin.trainingMetadata.col.label": "Label",
  "superadmin.trainingMetadata.col.labelDe": "Label (de-DE)",
  "superadmin.trainingMetadata.col.cardinality": "Kardinalität",
  "superadmin.trainingMetadata.col.sort": "Sort.",
  "superadmin.trainingMetadata.col.active": "Aktiv",
  "superadmin.trainingMetadata.col.items": "Items",
  "superadmin.trainingMetadata.empty.dimensions": "Keine Dimensionen",
  "superadmin.trainingMetadata.empty.items": "Keine Items",
  "superadmin.trainingMetadata.error.load":
    "Metadaten konnten nicht geladen werden.",
  "superadmin.trainingMetadata.error.save": "Speichern fehlgeschlagen.",
  "superadmin.trainingMetadata.success.save": "Gespeichert.",

  "superadmin.tiles.governance.title": "Governance / Roles",
  "superadmin.tiles.governance.desc":
    "Superadmin/Admin-Bindings (global/tenant) verwalten.",
  "superadmin.tiles.governance.open": "Rollen verwalten",

  "superadmin.tiles.clubs.title": "Vereine",
  "superadmin.tiles.clubs.desc":
    "Neue Tennisvereine mit Name, Ort und Website anlegen.",
  "superadmin.tiles.clubs.open": "Vereine verwalten",

  "superadmin.clubs.title": "Vereine verwalten",
  "superadmin.clubs.subtitle":
    "Neue Vereine für die Plattform anlegen und bestehende einsehen.",
  "superadmin.clubs.mode.aria": "Vereinsverwaltung",
  "superadmin.clubs.mode.list": "Übersicht",
  "superadmin.clubs.mode.map": "Landkarte",
  "superadmin.clubs.mode.discover": "Landkreise",
  "superadmin.clubs.mode.duplicates": "Duplikate",
  "superadmin.clubs.mode.dq": "Datenqualität",
  "superadmin.clubs.dq.pageTitle": "Datenqualität",
  "superadmin.clubs.dq.pageSubtitle":
    "Vollständigkeit der Pflichtfelder in der Vereinsliste.",
  "superadmin.clubs.dq.cardHint":
    "Auswertung über alle sichtbaren Vereine (ohne als Duplikat markierte). Pflichtfelder: Ort, PLZ, Land, Straße, Hausnummer, Website, E-Mail. Zusätzlich: passt die Website-Domain zum Vereinsnamen?",
  "superadmin.clubs.dq.overall": "Gesamt-DQ",
  "superadmin.clubs.dq.overallFormula":
    "{filled} von {cells} Pflichtfeld-Werten vollständig",
  "superadmin.clubs.dq.rowCount": "Zeilen",
  "superadmin.clubs.dq.fieldCount": "Pflichtfelder",
  "superadmin.clubs.dq.empty": "Keine Vereine für die Auswertung vorhanden.",
  "superadmin.clubs.dq.backToList": "Zur Übersicht",
  "superadmin.clubs.dq.refresh": "Neu laden",
  "superadmin.clubs.dq.table.aria": "Datenqualität je Pflichtfeld",
  "superadmin.clubs.dq.col.field": "Pflichtfeld",
  "superadmin.clubs.dq.col.rows": "Zeilen",
  "superadmin.clubs.dq.col.filled": "Summe vollständig",
  "superadmin.clubs.dq.col.empty": "Summe leer",
  "superadmin.clubs.dq.col.dq": "DQ",
  "superadmin.clubs.dq.totalRow": "Gesamt",
  "superadmin.clubs.dq.fields.sectionTitle": "Stammdaten-Vollständigkeit",
  "superadmin.clubs.dq.fields.sectionHint":
    "Zeile anklicken, um Vereine mit fehlendem oder ungültigem Feld in der Übersicht zu filtern.",
  "superadmin.clubs.dq.fields.rowAria":
    "{field}: {count} unvollständig — zur gefilterten Vereinsliste",
  "superadmin.clubs.dq.citySuggest.action":
    "Ort aus Namen vorschlagen ({count})",
  "superadmin.clubs.dq.citySuggest.hint":
    "Leitet Orte aus Vereinsnamen ab und validiert sie über OpenPLZ. Mehrdeutige Treffer (z. B. Hof) werden übersprungen.",
  "superadmin.clubs.dq.citySuggest.progress":
    "OpenPLZ-Prüfung {index}/{total} …",
  "superadmin.clubs.dq.citySuggest.none":
    "Keine Vereine ohne Ort zum Vorschlagen.",
  "superadmin.clubs.dq.citySuggest.previewNone":
    "Für {total} Vereine ohne Ort konnte kein sicherer Ort ermittelt werden ({ambiguous} mehrdeutig).",
  "superadmin.clubs.dq.citySuggest.confirm":
    "{total} Vereine ohne Ort analysiert.\n\n{applicable} sichere Vorschläge übernehmen?\n• {high} eindeutig\n• {medium} mehrere PLZ, gleicher Ort\n• {ambiguous} mehrdeutig — werden übersprungen",
  "superadmin.clubs.dq.citySuggest.success":
    "{applied} Orte übernommen. {skipped} ohne sicheren Treffer.",
  "superadmin.clubs.dq.citySuggest.failed":
    "Ort-Vorschläge konnten nicht ermittelt oder gespeichert werden.",
  "superadmin.clubs.dq.website.sectionTitle": "Website vs. Vereinsname",
  "superadmin.clubs.dq.website.sectionHint":
    "Verdächtig, wenn Domain weder zum Namen noch zum Ort passt — z. B. Zeitungs- oder Branchenbuch-Treffer aus der automatischen Suche.",
  "superadmin.clubs.dq.website.plausible": "Website plausibel",
  "superadmin.clubs.dq.website.plausibleFormula":
    "{plausible} von {total} Websites passen zum Verein",
  "superadmin.clubs.dq.website.reviewCount": "Zu prüfen",
  "superadmin.clubs.dq.website.blocklistCount": "Sperrliste",
  "superadmin.clubs.dq.website.blocklistTitle": "Gesperrte Domains",
  "superadmin.clubs.dq.website.blocklistHint":
    "Gesperrte Domains erscheinen nicht mehr in der Prüfwarteschlange. „Ja“ = Verein bleibt ohne Website; „Nein“ = kein echter Verein.",
  "superadmin.clubs.dq.website.mismatchCount": "Verdächtige Websites",
  "superadmin.clubs.dq.website.noWebsites":
    "Keine Websites zum Prüfen vorhanden.",
  "superadmin.clubs.dq.website.allPlausible":
    "Alle hinterlegten Websites passen plausibel zum Vereinsnamen.",
  "superadmin.clubs.dq.website.table.aria": "Verdächtige Website-Zuordnungen",
  "superadmin.clubs.dq.website.col.club": "Verein",
  "superadmin.clubs.dq.website.col.website": "Website",
  "superadmin.clubs.dq.website.col.email": "E-Mail",
  "superadmin.clubs.dq.website.col.reason": "Grund",
  "superadmin.clubs.dq.website.col.retention": "Verein behalten?",
  "superadmin.clubs.dq.website.retention.keep": "Ja, Verein behalten",
  "superadmin.clubs.dq.website.retention.drop": "Nein, kein Verein",
  "superadmin.clubs.dq.website.retention.review": "Prüfen",
  "superadmin.clubs.dq.website.retention.keepShort": "Ja",
  "superadmin.clubs.dq.website.retention.dropShort": "Nein",
  "superadmin.clubs.dq.website.reason.untrustedHost":
    "Verzeichnis/Medium statt Vereinsseite",
  "superadmin.clubs.dq.website.reason.nonClubName":
    "Kein Vereinsname (Portal/Listicle/Verzeichnis)",
  "superadmin.clubs.dq.website.reason.manualSuspicious":
    "Manuell als verdächtig markiert",
  "superadmin.clubs.dq.website.reason.emailMismatch":
    "E-Mail-Domain passt nicht zum Verein",
  "superadmin.clubs.dq.website.reason.nameMismatch":
    "Domain passt nicht zum Vereinsnamen",
  "superadmin.clubs.dq.website.manualOkCount": "Manuell OK",
  "superadmin.clubs.dq.website.applyAuto": "Auto-Erkennung anwenden",
  "superadmin.clubs.dq.website.applyAutoConfirm":
    "{count} Vereine werden als verdächtig markiert (bereits als OK markierte werden übersprungen). Fortfahren?",
  "superadmin.clubs.dq.website.applyAutoNone":
    "Keine neuen verdächtigen Websites gefunden.",
  "superadmin.clubs.dq.website.applyAutoSuccess":
    "{count} Vereine als verdächtig markiert.",
  "superadmin.clubs.dq.website.applyAutoFailed":
    "Auto-Erkennung konnte nicht gespeichert werden.",
  "superadmin.clubs.dq.website.markBlocklist": "Kein Verein (Sperrliste)",
  "superadmin.clubs.dq.website.markKeepClub": "Verein behalten",
  "superadmin.clubs.dq.website.markKeepClubHint":
    "E-Mail und Webseite löschen, Domain sperren — Verein bleibt erhalten",
  "superadmin.clubs.dq.website.clearEmail": "E-Mail entfernen",
  "superadmin.clubs.dq.website.keepClearEmail":
    "Bei „Verein behalten“ E-Mail ebenfalls löschen",
  "superadmin.clubs.dq.website.keepClearEmailShort": "E-Mail mit löschen",
  "superadmin.clubs.dq.website.toolbarGroupReview": "Manuelle Prüfung",
  "superadmin.clubs.dq.website.keepClubConfirmWithEmail":
    "{count} Verein(e): E-Mail und Webseite werden gelöscht, Domain gesperrt — der Verein bleibt erhalten. Fortfahren?",
  "superadmin.clubs.dq.website.clearEmailConfirm":
    "E-Mail bei {count} Verein(en) entfernen? Website bleibt unverändert.",
  "superadmin.clubs.dq.website.clearEmailSuccess":
    "E-Mail bei {count} Verein(en) entfernt.",
  "superadmin.clubs.dq.website.keepClubConfirm":
    "{count} Verein(e): E-Mail und Webseite werden gelöscht, Domain gesperrt — der Verein bleibt erhalten. Fortfahren?",
  "superadmin.clubs.dq.website.keepClubSuccess":
    "{count} Verein(e): E-Mail und Webseite gelöscht, Verein behalten.",
  "superadmin.clubs.dq.website.blocklistConfirm":
    "{count} Eintrag/Einträge als kein Verein gesperrt — verschwinden aus der Prüfliste. Fortfahren?",
  "superadmin.clubs.dq.website.blocklistSuccess": "{count} Domain(s) gesperrt.",
  "superadmin.clubs.dq.website.col.actions": "Aktion",
  "superadmin.clubs.dq.website.unblockAction": "Sperrung aufheben",
  "superadmin.clubs.dq.website.unblockConfirm":
    "Sperrung für „{name}“ aufheben? Der Verein erscheint wieder in der Prüfliste (Website wird wiederhergestellt, falls gespeichert).",
  "superadmin.clubs.dq.website.unblockSuccess":
    "Sperrung für „{name}“ aufgehoben.",
  "superadmin.clubs.dq.website.unblockFailed":
    "Sperrung konnte nicht aufgehoben werden.",
  "superadmin.clubs.dq.website.unblockRestoreHint":
    "Hebt die Sperrung auf und stellt Website/E-Mail wieder her (falls gespeichert).",
  "superadmin.clubs.dq.website.unblockNoSnapshotHint":
    "Hebt die Sperrung auf — Website muss ggf. manuell ergänzt werden.",
  "superadmin.clubs.dq.website.markSuspicious": "Auswahl als verdächtig",
  "superadmin.clubs.dq.website.markOk": "Auswahl als OK",
  "superadmin.clubs.dq.website.markSuspiciousSuccess":
    "{count} Vereine als verdächtig markiert.",
  "superadmin.clubs.dq.website.markOkSuccess":
    "{count} Vereine als OK markiert.",
  "superadmin.clubs.dq.website.bulkFailed":
    "Website-Bewertung konnte nicht gespeichert werden.",
  "superadmin.clubs.dq.website.selectAll": "Alle auswählen",
  "superadmin.clubs.dq.website.col.select": "Auswahl",
  "superadmin.clubs.dq.website.toolbarReviewLabel": "Auswahl bearbeiten",
  "superadmin.clubs.dq.website.toolbarHintKeep":
    "Verein behalten — E-Mail und Webseite löschen, Domain sperren; der Verein bleibt in der Liste.",
  "superadmin.clubs.dq.website.toolbarHintClearEmail":
    "E-Mail entfernen — nur die E-Mail-Adresse löschen.",
  "superadmin.clubs.dq.website.toolbarHintBlock":
    "Kein Verein (Sperrliste) — Eintrag sperren.",
  "superadmin.clubs.dq.website.toolbarHintEdit":
    "Verein, Webseite und E-Mail per Klick bearbeiten (Enter speichern, Esc abbrechen).",
  "superadmin.clubs.dq.website.field.clubName": "Vereinsname",
  "superadmin.clubs.dq.website.field.websiteUrl": "Website",
  "superadmin.clubs.dq.website.field.email": "E-Mail",
  "superadmin.clubs.dq.website.editFieldHint":
    "Klicken zum Bearbeiten — Enter speichert, Esc bricht ab",
  "superadmin.clubs.dq.website.editFieldAria": "{field} bearbeiten: {value}",
  "superadmin.clubs.dq.website.editFieldSuccess": "{field} gespeichert.",
  "superadmin.clubs.dq.website.editFieldFailed":
    "Änderung konnte nicht gespeichert werden.",
  "superadmin.clubs.dq.website.editNameHint":
    "Klicken zum Bearbeiten — Enter speichert, Esc bricht ab",
  "superadmin.clubs.dq.website.editNameAria": "Vereinsname bearbeiten: {name}",
  "superadmin.clubs.dq.website.editNameSuccess":
    "Vereinsname gespeichert: {name}",
  "superadmin.clubs.dq.website.editNameFailed":
    "Vereinsname konnte nicht gespeichert werden.",
  "superadmin.clubs.dq.website.trust.suspicious": "Markiert",
  "superadmin.clubs.mode.add": "Verein anlegen",
  "superadmin.clubs.mode.import": "Excel-Import",
  "superadmin.clubs.list.pageTitle": "Vereine",
  "superadmin.clubs.list.pageSubtitle":
    "Tennisvereine der Plattform verwalten.",
  "superadmin.clubs.list.websiteWarn.badge": "Website?",
  "superadmin.clubs.list.websiteWarn.hint": "Details unter Datenqualität",
  "superadmin.clubs.list.websiteWarn.title.untrustedHost":
    "Verzeichnis/Medium statt Vereinsseite — {hostname}",
  "superadmin.clubs.list.websiteWarn.title.nonClubName":
    "Kein Vereinsname (Portal/Listicle) — {hostname}",
  "superadmin.clubs.list.websiteWarn.title.manualSuspicious":
    "Manuell als verdächtig markiert — {hostname}",
  "superadmin.clubs.list.websiteWarn.title.emailMismatch":
    "E-Mail-Domain passt nicht zum Verein — {hostname}",
  "superadmin.clubs.list.websiteWarn.title.nameMismatch":
    "Domain passt nicht zum Vereinsnamen — {hostname}",
  "superadmin.clubs.backToApp": "Zurück zur App",
  "superadmin.clubs.errorLog.link": "Fehler-Log",
  "superadmin.clubs.errorLog.badge": "{count} Fehler",
  "superadmin.clubs.errorLog.pageTitle": "Fehler-Log",
  "superadmin.clubs.errorLog.pageSubtitle":
    "Fehlgeschlagene Impressum- und Website-Scans im Überblick.",
  "superadmin.clubs.errorLog.title": "Protokoll",
  "superadmin.clubs.errorLog.hint":
    "Einträge aus Stapel- und Einzelscans. Beim Öffnen werden bestehende fehlgeschlagene Scans aus der Historie übernommen.",
  "superadmin.clubs.errorLog.empty": "Keine Fehler protokolliert.",
  "superadmin.clubs.errorLog.aria": "Fehlerprotokoll Impressum-Scans",
  "superadmin.clubs.errorLog.filterReason": "Grund",
  "superadmin.clubs.errorLog.filterAll": "Alle Gründe",
  "superadmin.clubs.errorLog.clear": "Log leeren",
  "superadmin.clubs.errorLog.clearConfirm":
    "Fehler-Log wirklich leeren? Die Scan-Historie in der Übersicht bleibt erhalten.",
  "superadmin.clubs.errorLog.col.time": "Zeit",
  "superadmin.clubs.errorLog.col.club": "Verein",
  "superadmin.clubs.errorLog.col.source": "Quelle",
  "superadmin.clubs.errorLog.col.reason": "Grund",
  "superadmin.clubs.errorLog.source.batch": "Stapel",
  "superadmin.clubs.errorLog.source.manual": "Manuell",
  "superadmin.clubs.add.pageTitle": "Verein anlegen",
  "superadmin.clubs.add.pageSubtitle":
    "Einen neuen Verein manuell für die Plattform erstellen.",
  "superadmin.clubs.add.cardHint":
    "Impressum-Stammdaten: Name, Anschrift, Kontakt, Register.",
  "superadmin.clubs.import.pageTitle": "Excel-Import",
  "superadmin.clubs.import.pageSubtitle":
    "Mehrere Vereine auf einmal aus einer Excel- oder CSV-Datei importieren.",
  "superadmin.clubs.map.pageTitle": "Vereins-Landkarte",
  "superadmin.clubs.map.pageSubtitle":
    "Alle Tennisvereine auf der Karte — Landkreis nur als optionaler Filter.",
  "superadmin.clubs.map.cardHint":
    "OpenStreetMap-Karte mit allen Vereinen, die Koordinaten haben. Landkreis-Filter nutzt den Import-Landkreis (discover_source_ags). Vereine ohne Koordinaten erscheinen rechts in der Liste.",
  "superadmin.clubs.map.aria": "Interaktive Vereinskarte",
  "superadmin.clubs.map.filter.kreis": "Landkreis (optional)",
  "superadmin.clubs.map.filter.allKreise": "Alle Vereine",
  "superadmin.clubs.map.filter.search": "Suche",
  "superadmin.clubs.map.filter.searchPlaceholder": "Verein, Ort oder PLZ …",
  "superadmin.clubs.map.stats":
    "{total} Vereine · {onMap} auf der Karte · {missing} ohne Koordinaten",
  "superadmin.clubs.map.missing.title": "Ohne Koordinaten",
  "superadmin.clubs.map.missing.hint":
    "Diese Vereine sind im Register, haben aber noch keinen Standort in club_locations.",
  "superadmin.clubs.map.missing.empty":
    "Alle gefilterten Vereine haben Koordinaten.",
  "superadmin.clubs.map.geocode.action": "Koordinaten ermitteln ({count})",
  "superadmin.clubs.map.geocode.hint":
    "{count} von {total} Vereinen ohne Koordinaten können per Adresse geocodiert werden (OpenStreetMap/Photon).",
  "superadmin.clubs.map.geocode.confirm":
    "Koordinaten für {count} Vereine ermitteln? Das kann einige Minuten dauern (ca. 1 Request pro Sekunde).",
  "superadmin.clubs.map.geocode.running": "Geocoding läuft …",
  "superadmin.clubs.map.geocode.progressStart":
    "Starte Geocoding für {total} Vereine …",
  "superadmin.clubs.map.geocode.progress":
    "{index}/{total} · {success} OK · {failed} fehlgeschlagen · {skipped} übersprungen — {name} ({status})",
  "superadmin.clubs.map.geocode.done":
    "Fertig: {success} mit Koordinaten, {failed} fehlgeschlagen, {skipped} übersprungen.",
  "superadmin.clubs.map.popup.kreis": "Landkreis AGS {ags}",
  "superadmin.clubs.map.errors.rpcMissing":
    "Landkarte: Datenbank-Funktion fehlt noch (Migration deployen).",
  "superadmin.clubs.discover.pageTitle": "Landkreis-Recherche",
  "superadmin.clubs.discover.pageSubtitle":
    "Tennisvereine pro Landkreis per Websuche finden und in die Datenbank übernehmen.",
  "superadmin.clubs.discover.cardHint":
    "Landkreis wählen, suchen, gefundene Vereine prüfen und blind importieren. Große Städte: mehrere Google-Queries mit bis zu 20 Treffern pro Seite (Städte 2 Seiten). Nicht jeder Verein ist online auffindbar — danach Impressum-Stapel in der Übersicht.",
  "superadmin.clubs.discover.nextHint": "Nach dem Import:",
  "superadmin.clubs.discover.linkList":
    "Zur Vereinsübersicht (Impressum-Stapel)",
  "superadmin.clubs.discover.filter.state": "Bundesland",
  "superadmin.clubs.discover.filter.allStates": "Alle Bundesländer",
  "superadmin.clubs.discover.filter.search": "Kreis suchen",
  "superadmin.clubs.discover.filter.searchPlaceholder": "Name, AGS oder Typ…",
  "superadmin.clubs.discover.list.aria": "Landkreise und kreisfreie Städte",
  "superadmin.clubs.discover.list.empty": "Kein Kreis entspricht dem Filter.",
  "superadmin.clubs.discover.status.imported": "Importiert",
  "superadmin.clubs.discover.status.searched": "Gesucht",
  "superadmin.clubs.discover.search": "Vereine suchen",
  "superadmin.clubs.discover.searching": "Suche läuft…",
  "superadmin.clubs.discover.importAll": "Auswahl übernehmen",
  "superadmin.clubs.discover.importing": "Import läuft…",
  "superadmin.clubs.discover.selectAll": "Alle auswählen",
  "superadmin.clubs.discover.selectLikely": "Nur wahrscheinliche",
  "superadmin.clubs.discover.pickKreis":
    "Bitte einen Landkreis aus der Liste wählen.",
  "superadmin.clubs.discover.results.hint":
    "Noch keine Treffer — „Vereine suchen“ starten.",
  "superadmin.clubs.discover.stats.title": "Stand für diesen Kreis",
  "superadmin.clubs.discover.stats.storedLabel": "In DB hinterlegt",
  "superadmin.clubs.discover.stats.lastFoundLabel": "Zuletzt gefunden",
  "superadmin.clubs.discover.stats.lastImportedLabel": "Zuletzt importiert",
  "superadmin.clubs.discover.stats.lastSkippedLabel": "Zuletzt übersprungen",
  "superadmin.clubs.discover.stats.lastSearch": "Letzte Suche: {date}",
  "superadmin.clubs.discover.stats.hintReSearch":
    "Erneut „Vereine suchen“, um aktuelle Treffer in der Tabelle zu sehen.",
  "superadmin.clubs.discover.results.empty":
    "Keine passenden Vereinswebsites erkannt.",
  "superadmin.clubs.discover.results.none":
    "Für diesen Kreis wurden keine Tennisvereine gefunden.",
  "superadmin.clubs.discover.results.rawFiltered":
    "Google lieferte {raw} Roh-Treffer, aber keiner passte zum Tennis-Filter (.de-Vereinsseite).",
  "superadmin.clubs.discover.results.found":
    "{count} Vereinskandidaten gefunden.",
  "superadmin.clubs.discover.results.count": "{count} Treffer",
  "superadmin.clubs.discover.results.likelyCount": "{count} wahrscheinlich",
  "superadmin.clubs.discover.results.storedCount": "{count} bereits in DB",
  "superadmin.clubs.discover.results.unlikelyCount": "{count} unwahrscheinlich",
  "superadmin.clubs.discover.results.alreadyStored": "Bereits in DB",
  "superadmin.clubs.discover.results.alreadyStoredHint":
    "Diese Website ist bereits als Verein hinterlegt — kein erneuter Import nötig.",
  "superadmin.clubs.discover.results.col.likelihood": "Einschätzung",
  "superadmin.clubs.discover.results.likely": "Verein wahrscheinlich",
  "superadmin.clubs.discover.results.likelyHint":
    "Domain und Name passen zu einem Tennisverein (gleiche Heuristik wie Datenqualität).",
  "superadmin.clubs.discover.results.unlikely": "Unwahrscheinlich",
  "superadmin.clubs.discover.results.unlikelyHint":
    "Medien, Verzeichnis, kein Vereinsname oder anderer Ort.",
  "superadmin.clubs.discover.results.geoMismatch":
    "Gehört nicht zum gewählten Kreis bzw. zur gewählten Stadt",
  "superadmin.clubs.discover.results.review": "Prüfen",
  "superadmin.clubs.discover.results.reviewHint": "Bitte manuell prüfen.",
  "superadmin.clubs.discover.results.selectRow": "{name} auswählen",
  "superadmin.clubs.discover.results.col.name": "Verein",
  "superadmin.clubs.discover.results.col.website": "Website",
  "superadmin.clubs.discover.results.selectAll": "Auswahl",
  "superadmin.clubs.discover.success.imported":
    "{created} Vereine angelegt, {skipped} übersprungen (Duplikat).",
  "superadmin.clubs.discover.errors.rateLimited":
    "Such-Limit erreicht — bitte später erneut versuchen.",
  "superadmin.clubs.discover.errors.serperMissing":
    "Serper API ist auf dem Server nicht konfiguriert (SERPER_API_KEY).",
  "superadmin.clubs.discover.errors.edgeMissing":
    "Edge Function club-discover-kreis ist noch nicht deployed.",
  "superadmin.clubs.discover.errors.searchFailed": "Suche fehlgeschlagen.",
  "superadmin.clubs.discover.errors.noSelection":
    "Bitte mindestens einen Verein auswählen.",
  "superadmin.clubs.discover.errors.importFailed": "Import fehlgeschlagen.",
  "superadmin.clubs.duplicates.pageTitle": "Duplikat-Prüfung",
  "superadmin.clubs.duplicates.pageSubtitle":
    "Ähnliche Vereine finden, besten Datensatz behalten — übrige weich als Duplikat markieren.",
  "superadmin.clubs.duplicates.cardHint":
    "Vergleich nach Name, E-Mail, Ort, Straße, Hausnummer und PLZ. Markierte Duplikate bleiben in der Datenbank, erscheinen aber nicht mehr in der Vereinsliste.",
  "superadmin.clubs.duplicates.analyze": "Duplikate suchen",
  "superadmin.clubs.duplicates.analyzing": "Analyse läuft…",
  "superadmin.clubs.duplicates.apply": "Auswahl übernehmen",
  "superadmin.clubs.duplicates.applying": "Speichern…",
  "superadmin.clubs.duplicates.backToList": "Zur Vereinsübersicht",
  "superadmin.clubs.duplicates.meta":
    "{count} Vereine geprüft · {groups} Duplikat-Gruppen",
  "superadmin.clubs.duplicates.results.none":
    "Keine Duplikat-Gruppen gefunden.",
  "superadmin.clubs.duplicates.results.found":
    "{groups} Duplikat-Gruppen gefunden.",
  "superadmin.clubs.duplicates.group.apply": "Gruppe übernehmen",
  "superadmin.clubs.duplicates.group.count": "{count} Einträge",
  "superadmin.clubs.duplicates.unique.action": "Alle sind Unikate — behalten",
  "superadmin.clubs.duplicates.unique.confirm":
    "Diese {count} Vereine sind keine Duplikate und bleiben getrennt. Die Entscheidung wird gespeichert und künftige Vorschläge angepasst. Fortfahren?",
  "superadmin.clubs.duplicates.unique.note":
    "Manuell als Unikate bestätigt (Superadmin Duplikat-Prüfung)",
  "superadmin.clubs.duplicates.unique.success":
    "Als Unikate gespeichert ({pairs} Paar-Ausschlüsse).",
  "superadmin.clubs.duplicates.unique.errors.failed":
    "Unikate konnten nicht gespeichert werden.",
  "superadmin.clubs.duplicates.unique.errors.failedDetail":
    "Unikate konnten nicht gespeichert werden: {detail}",
  "superadmin.clubs.duplicates.release.action": "Kein Duplikat — freigeben",
  "superadmin.clubs.duplicates.release.hint":
    "Gehört ein Verein nicht zur Gruppe? Unter der Karte „Kein Duplikat — freigeben“ — die Gruppe wird danach neu aufgeteilt.",
  "superadmin.clubs.duplicates.release.actionHint":
    "Diesen Verein aus der Gruppe lösen; er wird nicht mit den anderen zusammengeführt",
  "superadmin.clubs.duplicates.release.confirm":
    "„{name}“ ist kein Duplikat zu den {count} anderen Einträgen in dieser Gruppe und soll getrennt bleiben. Die Entscheidung wird gespeichert. Fortfahren?",
  "superadmin.clubs.duplicates.release.ok": "Freigeben",
  "superadmin.clubs.duplicates.release.note":
    "Manuell aus Duplikat-Gruppe freigegeben (Superadmin)",
  "superadmin.clubs.duplicates.release.success":
    "„{name}“ freigegeben ({pairs} Paar-Ausschlüsse gespeichert).",
  "superadmin.clubs.duplicates.release.errors.failed":
    "Freigabe konnte nicht gespeichert werden.",
  "superadmin.clubs.duplicates.release.errors.failedDetail":
    "Freigabe konnte nicht gespeichert werden: {detail}",
  "superadmin.clubs.duplicates.group.match": "Übereinstimmung: {reasons}",
  "superadmin.clubs.duplicates.col.keep": "Behalten",
  "superadmin.clubs.duplicates.col.keepFor": "{name} behalten",
  "superadmin.clubs.duplicates.keeper.title": "1. Eintrag behalten",
  "superadmin.clubs.duplicates.keeper.hint":
    "Dieser Datensatz bleibt in der Vereinsliste sichtbar und erhält die zusammengeführten Stammdaten. Vereine mit Usern werden bevorzugt empfohlen.",
  "superadmin.clubs.duplicates.keeper.entry": "Eintrag {n}",
  "superadmin.clubs.duplicates.members.none": "Keine User",
  "superadmin.clubs.duplicates.members.one": "1 User",
  "superadmin.clubs.duplicates.members.many": "{count} User",
  "superadmin.clubs.duplicates.migration.title": "User-Migration",
  "superadmin.clubs.duplicates.migration.usersOnDuplicate":
    "Beim Übernehmen werden {migrateCount} User vom markierten Duplikat auf den behaltenen Verein umgehängt ({details}). Stammdaten landen auf dem Keeper.",
  "superadmin.clubs.duplicates.migration.bothHaveUsers":
    "Sowohl Keeper ({keeperCount} User) als auch Duplikat ({migrateCount} User) haben Accounts ({details}). Beim Übernehmen werden User zusammengeführt; doppelte Zuordnungen werden bereinigt.",
  "superadmin.clubs.duplicates.migration.line": "{name}: {count} User",
  "superadmin.clubs.duplicates.merge.title": "2. Felder zusammenführen",
  "superadmin.clubs.duplicates.merge.hint":
    "Nur Felder mit unterschiedlichen Werten — Quelle wählen, deren Wert übernommen wird.",
  "superadmin.clubs.duplicates.merge.noChoices":
    "Keine Felder mit unterschiedlichen Werten — nichts auszuwählen.",
  "superadmin.clubs.duplicates.merge.pickFieldValue": "{field}: {value}",
  "superadmin.clubs.duplicates.merge.preview":
    "Ergebnis für den behaltenen Verein",
  "superadmin.clubs.duplicates.merge.pickValue": "{entry}: {value}",
  "superadmin.clubs.duplicates.merge.pickValueOnly": "{value}",
  "superadmin.clubs.duplicates.suggested": "Empfohlen",
  "superadmin.clubs.duplicates.confirm":
    "{count} Vereine als Duplikat markieren, Stammdaten speichern und User auf den Keeper umhängen — nicht löschen. Fortfahren?",
  "superadmin.clubs.duplicates.confirm.migration":
    "Dabei werden {count} User-Mitgliedschaft(en) auf den behaltenen Verein migriert.",
  "superadmin.clubs.duplicates.success":
    "{keepers} behalten, {marked} als Duplikat markiert, {migrated} User-Mitgliedschaft(en) migriert.",
  "superadmin.clubs.duplicates.errors.noSelection":
    "Bitte mindestens eine Gruppe mit Behalten-Auswahl aktivieren.",
  "superadmin.clubs.duplicates.errors.applyFailed":
    "Duplikat-Markierung konnte nicht gespeichert werden.",
  "superadmin.clubs.duplicates.errors.applyFailedDetail":
    "Duplikat-Markierung fehlgeschlagen: {detail}",
  "superadmin.clubs.duplicates.reason.email": "E-Mail",
  "superadmin.clubs.duplicates.reason.address": "Adresse",
  "superadmin.clubs.duplicates.reason.name": "Name",
  "superadmin.clubs.duplicates.reason.city": "Ort",
  "superadmin.clubs.duplicates.reason.postal_code": "PLZ",
  "superadmin.clubs.duplicates.reason.street": "Straße",
  "superadmin.clubs.import.cardHint":
    "Spalten zuordnen, Vorschau prüfen und alle Zeilen importieren.",
  "superadmin.clubs.add.title": "Verein hinzufügen",
  "superadmin.clubs.add.hint":
    "Öffentliche Vereins-Stammdaten wie im Impressum erfassen — für Suche und Plattform-Grunddaten.",
  "superadmin.clubs.add.privacyNote":
    "Bitte keine personenbezogenen Daten (z. B. Vor- und Nachnamen von Vorstandsmitgliedern). Diese gehören nicht ins Vereinsprofil.",
  "superadmin.clubs.add.section.club": "Verein",
  "superadmin.clubs.add.section.address": "Anschrift",
  "superadmin.clubs.add.section.contact": "Kontakt",
  "superadmin.clubs.add.section.register": "Vereinsregister",
  "superadmin.clubs.add.section.registerHint":
    "Optional — typische Angaben aus dem Impressum eingetragener Vereine (e.V.).",
  "superadmin.clubs.add.cta": "Verein anlegen",
  "superadmin.clubs.list.title": "Angelegte Vereine",
  "superadmin.clubs.list.searchPlaceholder":
    "Suchen (Name, Ort, E-Mail, Website)…",
  "superadmin.clubs.list.aria": "Liste der Vereine",
  "superadmin.clubs.list.empty": "Noch keine Vereine vorhanden.",
  "superadmin.clubs.list.dqFilterBanner":
    "{count} Vereine mit unvollständigem Feld „{field}“",
  "superadmin.clubs.list.dqFilterClear": "Filter entfernen",
  "superadmin.clubs.list.dqFilterEmpty":
    "Keine Vereine für diesen Datenqualitäts-Filter.",
  "superadmin.clubs.list.citySuggest.action": "Ort aus Namen ({count})",
  "superadmin.clubs.list.citySuggest.none":
    "Keine Vereine ohne Ort zum Vorschlagen.",
  "superadmin.clubs.list.citySuggest.previewNone":
    "Für {total} Vereine ohne Ort konnte kein sicherer Ort ermittelt werden ({ambiguous} mehrdeutig).",
  "superadmin.clubs.list.citySuggest.confirm":
    "{total} Vereine ohne Ort analysiert.\n\n{applicable} sichere Vorschläge übernehmen?\n• {high} eindeutig\n• {medium} mehrere PLZ, gleicher Ort\n• {ambiguous} mehrdeutig — werden übersprungen",
  "superadmin.clubs.list.citySuggest.success":
    "{applied} Orte übernommen. {skipped} ohne sicheren Treffer.",
  "superadmin.clubs.list.citySuggest.failed":
    "Ort-Vorschläge konnten nicht ermittelt oder gespeichert werden.",
  "superadmin.clubs.list.col.website": "Website",
  "superadmin.clubs.list.col.location": "Ort / PLZ",
  "superadmin.clubs.list.col.status": "Status",
  "superadmin.clubs.list.col.created": "Angelegt",
  "superadmin.clubs.list.col.tenantId": "Tenant-ID",
  "superadmin.clubs.success.created": "Verein „{name}“ wurde angelegt.",
  "superadmin.clubs.errors.missingName": "Bitte einen Vereinsnamen eingeben.",
  "superadmin.clubs.errors.notAuthorized":
    "Keine Berechtigung — nur für globale Superadmins.",
  "superadmin.clubs.errors.createFailed":
    "Verein konnte nicht angelegt werden.",
  "superadmin.clubs.errors.loadFailed":
    "Vereinsliste konnte nicht geladen werden.",
  "superadmin.clubs.errors.rpcMissing":
    "Die Datenbank-Funktion für die Vereinsliste fehlt noch. Bitte Supabase-Migrationen ausführen (supabase db push).",
  "superadmin.clubs.info.listDegraded":
    "Vereine aus den bestehenden Stammdaten (club_profiles) geladen. Für Tenant-Status und vollständige Liste bitte die Supabase-Migrationen anwenden.",
  "superadmin.clubs.list.col.actions": "Aktionen",
  "superadmin.clubs.list.sort.clickToSort": "Spalte sortieren",
  "superadmin.clubs.list.sort.sortedAsc": "Sortiert aufsteigend",
  "superadmin.clubs.list.sort.sortedDesc": "Sortiert absteigend",
  "superadmin.clubs.delete.action": "Löschen",
  "superadmin.clubs.delete.deleting": "Wird gelöscht…",
  "superadmin.clubs.delete.confirm": "Verein „{name}“ unwiderruflich löschen?",
  "superadmin.clubs.delete.success": "Verein wurde gelöscht.",
  "superadmin.clubs.delete.errors.protected":
    "Dieser Verein ist geschützt und kann nicht gelöscht werden.",
  "superadmin.clubs.delete.errors.hasData":
    "Der Verein hat noch Mitglieder oder Daten und kann hier nicht gelöscht werden.",
  "superadmin.clubs.delete.errors.notFound": "Verein wurde nicht gefunden.",
  "superadmin.clubs.delete.errors.rpcMissing":
    "Löschen ist auf dem Server noch nicht verfügbar (Migration fehlt).",
  "superadmin.clubs.delete.errors.notAuthorized":
    "Keine Berechtigung zum Löschen.",
  "superadmin.clubs.delete.errors.failed": "Löschen fehlgeschlagen.",
  "superadmin.clubs.impressum.scan": "Impressum laden",
  "superadmin.clubs.impressum.scanning": "Impressum wird gesucht…",
  "superadmin.clubs.impressum.title": "Impressum-Daten",
  "superadmin.clubs.impressum.subtitle":
    "Erkannte Angaben von der Vereinswebsite — mit „Übernehmen“ in die Vereins-Stammdaten schreiben.",
  "superadmin.clubs.impressum.source": "Quelle",
  "superadmin.clubs.impressum.apply": "Übernehmen",
  "superadmin.clubs.impressum.applying": "Speichern…",
  "superadmin.clubs.impressum.close": "Schließen",
  "superadmin.clubs.impressum.field.street": "Straße",
  "superadmin.clubs.impressum.field.clubName": "Vereinsname",
  "superadmin.clubs.impressum.field.foundedYear": "Gründungsjahr",
  "superadmin.clubs.impressum.field.houseNumber": "Hausnummer",
  "superadmin.clubs.impressum.field.postalCode": "PLZ",
  "superadmin.clubs.impressum.field.city": "Ort",
  "superadmin.clubs.impressum.field.email": "E-Mail",
  "superadmin.clubs.impressum.status.willApply": "wird übernommen",
  "superadmin.clubs.impressum.status.willCorrect": "wird korrigiert",
  "superadmin.clubs.impressum.status.alreadySet": "bereits gepflegt",
  "superadmin.clubs.impressum.status.missing": "nicht erkannt",
  "superadmin.clubs.impressum.hint.nameFromWebsite":
    "Abweichung zur Website erkannt",
  "superadmin.clubs.impressum.hint.nameFromImpressum":
    "Laut Impressum auf der Website",
  "superadmin.clubs.impressum.hint.foundedYearFromName":
    "Aus Vereinsnamen erkannt",
  "superadmin.clubs.impressum.confirmAbort.message":
    "Die Analyse läuft noch. Möchten Sie wirklich abbrechen?",
  "superadmin.clubs.impressum.confirmAbort.yes": "Ja, abbrechen",
  "superadmin.clubs.impressum.confirmAbort.no": "Weiter suchen",
  "superadmin.clubs.impressum.errors.notFound":
    "Kein Impressum unter den üblichen Pfaden gefunden.",
  "superadmin.clubs.impressum.errors.noFields":
    "Impressum gefunden, aber Straße, PLZ oder E-Mail konnten nicht erkannt werden.",
  "superadmin.clubs.impressum.errors.edgeUnavailable":
    "Der Impressum-Abruf ist noch nicht verfügbar (Edge Function „club-impressum-fetch“ deployen).",
  "superadmin.clubs.impressum.errors.fetchFailed":
    "Impressum konnte nicht geladen werden.",
  "superadmin.clubs.impressum.errors.applyFailed":
    "Daten konnten nicht übernommen werden.",
  "superadmin.clubs.impressum.success.applied":
    "Impressum-Daten wurden in die Vereins-Stammdaten übernommen.",
  "superadmin.clubs.impressum.batch.title": "Impressum-Stapel",
  "superadmin.clubs.impressum.batch.hint":
    "Mehrere Vereine nacheinander scannen und erkannte Daten automatisch übernehmen — ohne Einzelbestätigung. Mit Serper-Option nur Vereine ohne hinterlegte Website; zuerst unversuchte, fehlgeschlagene Suche („Website nicht gefunden“) frühestens nach 30 Tagen erneut.",
  "superadmin.clubs.impressum.batch.size": "Anzahl",
  "superadmin.clubs.impressum.batch.onlyMissingEmail": "Nur ohne E-Mail",
  "superadmin.clubs.impressum.batch.skipPreviouslyScanned":
    "Nur ungescannte und fehlgeschlagene",
  "superadmin.clubs.impressum.batch.start": "Stapel starten",
  "superadmin.clubs.impressum.batch.running":
    "Stapel {current}/{total}: {clubName}",
  "superadmin.clubs.impressum.batch.cancel": "Stapel abbrechen",
  "superadmin.clubs.impressum.batch.confirm":
    "{count} Vereine werden nacheinander gescannt; erkannte Felder werden automatisch übernommen. Fortfahren?",
  "superadmin.clubs.impressum.batch.empty":
    "Keine passenden Vereine mit Website in der aktuellen Ansicht.",
  "superadmin.clubs.impressum.batch.nothingTodo":
    "Nichts weiter zu tun — alle passenden Vereine wurden bereits bearbeitet.",
  "superadmin.clubs.impressum.batch.noWebsite":
    "Keine Vereine mit Website — optional „Fehlende Website per Serper suchen“ aktivieren.",
  "superadmin.clubs.impressum.batch.noMissingWebsite":
    "Keine Vereine ohne Website in der aktuellen Ansicht — Serper-Suche betrifft nur Einträge ohne hinterlegte URL.",
  "superadmin.clubs.impressum.batch.discoverMissingWebsites":
    "Fehlende Website per Serper suchen (nur Vereine ohne Website)",
  "superadmin.clubs.impressum.batch.runningWebsite":
    "Website suchen ({current}/{total}): {clubName}",
  "superadmin.clubs.impressum.batch.summaryWebsites":
    "{count} Websites gefunden.",
  "superadmin.clubs.impressum.batch.summaryRateLimited":
    "{count} wegen Such-Limit übersprungen — Stapel pausiert automatisch, danach erneut starten.",
  "superadmin.clubs.impressum.batch.runningRateLimit":
    "Such-Limit — warte, dann weiter ({current}/{total}): {clubName}",
  "superadmin.clubs.impressum.batch.summaryCancelled": "Abgebrochen.",
  "superadmin.clubs.impressum.batch.dismiss": "OK",
  "superadmin.clubs.impressum.batch.summary":
    "Stapel abgeschlossen: {applied} übernommen, {skipped} ohne Änderung, {failed} Fehler.",
  "superadmin.clubs.impressum.batch.errors.title": "Fehlerursachen",
  "superadmin.clubs.impressum.batch.errors.line": "{count}× {reason}",
  "superadmin.clubs.impressum.batch.errors.samples": "Beispiele:",
  "superadmin.clubs.impressum.batch.errors.edge-unavailable":
    "Edge Function club-discover-website nicht deployt",
  "superadmin.clubs.impressum.batch.errors.edge-error":
    "Edge Function antwortet mit Fehler",
  "superadmin.clubs.impressum.batch.errors.serper-not-configured":
    "Serper API (SERPER_API_KEY) fehlt auf dem Server",
  "superadmin.clubs.impressum.batch.errors.website-not-found":
    "Keine passende Website per Serper gefunden",
  "superadmin.clubs.impressum.batch.errors.rate-limited":
    "Stündliches Such-Limit erreicht (Serper/Edge) — Stapel pausiert automatisch",
  "superadmin.clubs.impressum.batch.errors.impressum-not-found":
    "Kein Impressum auf der Website gefunden",
  "superadmin.clubs.impressum.batch.errors.fetch-failed":
    "Impressum-Abruf fehlgeschlagen",
  "superadmin.clubs.impressum.batch.errors.missing-website-url":
    "Keine Website hinterlegt",
  "superadmin.clubs.impressum.batch.errors.request-failed":
    "Netzwerkfehler bei der Suche",
  "superadmin.clubs.impressum.batch.errors.no-supabase":
    "Keine Datenbankverbindung",
  "superadmin.clubs.impressum.batch.errors.unknown": "Unbekannter Fehler",
  "superadmin.clubs.impressum.batch.status.applied": "übernommen",
  "superadmin.clubs.impressum.batch.status.skipped": "keine Änderung",
  "superadmin.clubs.impressum.batch.status.failed": "Fehler",
  "superadmin.clubs.list.col.impressumScan": "Impressum-Scan",
  "superadmin.clubs.impressum.scanHistory.status.applied": "Übernommen",
  "superadmin.clubs.impressum.scanHistory.status.appliedEmpty":
    "Übernommen (ohne Felder)",
  "superadmin.clubs.impressum.scanHistory.status.skippedWithResults":
    "Gefunden, nichts Neues",
  "superadmin.clubs.impressum.scanHistory.status.skippedNoResults":
    "Keine neuen Daten",
  "superadmin.clubs.impressum.scanHistory.status.failed": "Fehlgeschlagen",
  "superadmin.clubs.impressum.scanHistory.status.failedWithResults":
    "Fehler (Felder erkannt)",
  "superadmin.clubs.impressum.scanHistory.source.batch": "Stapel",
  "superadmin.clubs.impressum.scanHistory.source.manual": "Einzelscan",
  "superadmin.clubs.impressum.scanHistory.websiteRetryAt":
    "Erneute Suche ab {date}",

  "superadmin.clubs.fields.clubName": "Vereinsname",
  "superadmin.clubs.fields.city": "Ort",
  "superadmin.clubs.fields.postalCode": "Postleitzahl",
  "superadmin.clubs.fields.street": "Straße",
  "superadmin.clubs.fields.houseNumber": "Hausnummer",
  "superadmin.clubs.fields.country": "Land",
  "superadmin.clubs.fields.website": "Website",
  "superadmin.clubs.fields.email": "E-Mail (öffentlich)",
  "superadmin.clubs.fields.phone": "Telefon (öffentlich)",
  "superadmin.clubs.fields.shortName": "Kurzname",
  "superadmin.clubs.fields.legalName": "Rechtlicher Name",
  "superadmin.clubs.fields.registerCourt": "Registergericht",
  "superadmin.clubs.fields.registerNumber": "Registernummer",
  "superadmin.clubs.fields.dtbClubId": "DTB-Vereinsnummer",
  "superadmin.clubs.fields.btvClubId": "BTV-Vereinsnummer",
  "superadmin.clubs.fields.foundedYear": "Gründungsjahr",

  "superadmin.clubs.import.title": "Excel-Import",
  "superadmin.clubs.import.hint":
    "Lade eine Excel- oder CSV-Datei hoch. Ordne Impressum-Felder (Anschrift, Kontakt, Register) zu — keine personenbezogenen Daten.",
  "superadmin.clubs.import.fileLabel": "Datei auswählen",
  "superadmin.clubs.import.formats": "Unterstützt: .xlsx, .xls, .csv",
  "superadmin.clubs.import.fileLoaded":
    "Datei gelesen. Bitte Spaltenzuordnung prüfen.",
  "superadmin.clubs.import.meta":
    "Blatt „{sheet}“ · {columns} Spalten · {rows} Datenzeilen",
  "superadmin.clubs.import.mapping.title": "Spalten zuordnen",
  "superadmin.clubs.import.mapping.hint":
    "Wähle für jedes Zielfeld die passende Excel-Spalte. Nicht zugeordnete Felder bleiben leer. Weitere Felder kannst du jederzeit über die Liste unten nutzen.",
  "superadmin.clubs.import.mapping.aria": "Spaltenzuordnung",
  "superadmin.clubs.import.mapping.target": "Zielfeld",
  "superadmin.clubs.import.mapping.source": "Excel-Spalte",
  "superadmin.clubs.import.mapping.sample": "Beispielwert",
  "superadmin.clubs.import.mapping.none": "— nicht zuordnen —",
  "superadmin.clubs.import.preview.title": "Vorschau",
  "superadmin.clubs.import.preview.hint":
    "So werden die ersten Zeilen importiert (nur zugeordnete Felder).",
  "superadmin.clubs.import.preview.count":
    "{shown} von {total} Zeilen in der Vorschau",
  "superadmin.clubs.import.preview.empty": "Noch keine Felder zugeordnet.",
  "superadmin.clubs.import.preview.noRows":
    "Keine importierbaren Zeilen (Vereinsname fehlt?).",
  "superadmin.clubs.import.skipDuplicates":
    "Bereits vorhandene Vereine überspringen (gleicher Name + Ort)",
  "superadmin.clubs.import.duplicates.title": "Duplikatprüfung",
  "superadmin.clubs.import.duplicates.intro":
    "Vor dem Import werden bestehende Vereine (gleicher Name + Ort) geprüft. Identische Einträge werden automatisch übersprungen, bei Anreicherungen kannst du Felder ergänzen lassen.",
  "superadmin.clubs.import.duplicates.empty":
    "Noch keine importierbaren Zeilen.",
  "superadmin.clubs.import.duplicates.noDuplicates":
    "Keine Duplikate gefunden — alle Zeilen werden neu angelegt.",
  "superadmin.clubs.import.duplicates.hint":
    "Passe die Aktion pro Duplikat an. „Anreichern“ füllt nur leere Felder beim bestehenden Verein.",
  "superadmin.clubs.import.duplicates.aria": "Duplikatübersicht",
  "superadmin.clubs.import.duplicates.col.status": "Befund",
  "superadmin.clubs.import.duplicates.col.details": "Unterschiede",
  "superadmin.clubs.import.duplicates.col.action": "Aktion",
  "superadmin.clubs.import.duplicates.status.new": "Neu",
  "superadmin.clubs.import.duplicates.status.enrichable": "Anreicherbar",
  "superadmin.clubs.import.duplicates.status.redundant": "Identisch",
  "superadmin.clubs.import.duplicates.status.conflict": "Abweichung",
  "superadmin.clubs.import.duplicates.action.create": "Neu anlegen",
  "superadmin.clubs.import.duplicates.action.enrich": "Bestehenden anreichern",
  "superadmin.clubs.import.duplicates.action.skip": "Überspringen",
  "superadmin.clubs.import.duplicates.action.forceCreate":
    "Trotzdem neu anlegen",
  "superadmin.clubs.import.duplicates.detail.add": "+ {field}: {value}",
  "superadmin.clubs.import.duplicates.detail.conflict":
    "≠ {field}: Import „{importValue}“ · Bestand „{existingValue}“",
  "superadmin.clubs.import.duplicates.detail.redundant":
    "Alle importierten Felder sind bereits vorhanden.",
  "superadmin.clubs.import.duplicates.summary.new": "{count} neu",
  "superadmin.clubs.import.duplicates.summary.enrichable":
    "{count} anreicherbar",
  "superadmin.clubs.import.duplicates.summary.redundant": "{count} identisch",
  "superadmin.clubs.import.duplicates.summary.conflict":
    "{count} mit Abweichung",
  "superadmin.clubs.import.duplicates.reason.redundant":
    "Keine neuen Informationen — automatisch übersprungen.",
  "superadmin.clubs.import.duplicates.reason.conflict":
    "Abweichende Werte — nicht automatisch überschrieben.",
  "superadmin.clubs.import.duplicates.reason.duplicate":
    "Duplikat (Name + Ort).",
  "superadmin.clubs.import.duplicates.reason.manual": "Manuell übersprungen.",
  "superadmin.clubs.import.duplicates.forceCreateOne": "Trotzdem anlegen",
  "superadmin.clubs.import.duplicates.forceCreateSuccess":
    "Verein „{name}“ wurde zusätzlich angelegt.",
  "superadmin.clubs.import.result.title": "Importergebnis",
  "superadmin.clubs.import.result.summary":
    "{created} angelegt, {enriched} angereichert, {skipped} übersprungen, {failed} fehlgeschlagen.",
  "superadmin.clubs.import.result.skippedTitle": "Nicht übernommene Duplikate",
  "superadmin.clubs.import.result.backToList": "Zur Vereinsübersicht",
  "superadmin.clubs.import.result.partial":
    "Import abgeschlossen. Prüfe die nicht übernommenen Duplikate unten.",
  "superadmin.clubs.import.cta": "Vereine importieren",
  "superadmin.clubs.import.reset": "Import zurücksetzen",
  "superadmin.clubs.import.success":
    "Import abgeschlossen: {created} angelegt, {enriched} angereichert, {skipped} übersprungen, {failed} fehlgeschlagen.",
  "superadmin.clubs.import.errors.emptyFile":
    "Die Datei enthält keine verwertbaren Daten.",
  "superadmin.clubs.import.errors.parseFailed":
    "Datei konnte nicht gelesen werden: {message}",
  "superadmin.clubs.import.errors.noRows": "Keine Zeilen zum Importieren.",
  "superadmin.clubs.import.errors.missingNameMapping":
    "Bitte mindestens die Spalte für den Vereinsnamen zuordnen.",
  "superadmin.clubs.import.errors.importFailed":
    "Der Massenimport ist fehlgeschlagen.",
  "superadmin.clubs.import.errors.rpcMissing":
    "Die Import-Funktion ist in der Datenbank noch nicht verfügbar. Bitte Migrationen 20260655000362 bis 20260655000366 ausrollen (supabase db push).",
  "superadmin.clubs.import.errors.detail": "Import-Fehler: {message}",
  "superadmin.clubs.import.successSequential":
    "(Einzelimport-Fallback, da Bulk-RPC fehlt.)",

  "superadmin.governance.title": "Governance",
  "superadmin.governance.subtitle":
    "Role-Bindings (global/tenant) und Access-Requests debuggen.",
  "superadmin.governance.me.title": "Ich",
  "superadmin.governance.me.hint":
    "Hilfsfunktionen für Debugging (z. B. User-ID kopieren).",
  "superadmin.governance.me.notLoggedIn": "Nicht eingeloggt",
  "superadmin.governance.me.use": "Übernehmen",
  "superadmin.governance.add.title": "Role Binding hinzufügen",
  "superadmin.governance.add.hint":
    "Nur global Superadmins können Role-Bindings schreiben (via RPC).",
  "superadmin.governance.form.scope": "Scope",
  "superadmin.governance.form.scopeId": "Scope-ID",
  "superadmin.governance.form.scopeId.placeholder":
    "z. B. global oder vereinsweit",
  "superadmin.governance.form.userId": "User-ID",
  "superadmin.governance.form.userId.placeholder": "UUID",
  "superadmin.governance.form.role": "Rolle",
  "superadmin.governance.scope.global": "global",
  "superadmin.governance.scope.tenant": "tenant",
  "superadmin.governance.role.superadmin": "superadmin",
  "superadmin.governance.role.admin": "admin",
  "superadmin.governance.add.cta": "Hinzufügen",
  "superadmin.governance.list.title": "Role Bindings",
  "superadmin.governance.list.aria": "Role Bindings Tabelle",
  "superadmin.governance.list.col.scope": "Scope",
  "superadmin.governance.list.col.scopeId": "Scope-ID",
  "superadmin.governance.list.col.role": "Rolle",
  "superadmin.governance.list.col.userId": "User-ID",
  "superadmin.governance.list.col.updated": "Aktualisiert",
  "superadmin.governance.list.empty": "Keine Role-Bindings gefunden.",

  "superadmin.governance.confirm.delete": "Role Binding wirklich löschen?",
  "superadmin.governance.status.fillAllFields": "Bitte alle Felder ausfüllen.",
  "superadmin.governance.status.scopeGlobalNeedsGlobalId":
    "Scope 'global' benötigt scope_id = 'global'.",
  "superadmin.governance.status.scopeGlobalRoleSuperadminOnly":
    "Scope 'global' erlaubt nur Rolle 'superadmin'.",
  "superadmin.governance.status.scopeTenantRoleAdmin":
    "Scope 'tenant' erlaubt in diesem Tool nur Rolle 'admin'.",
  "superadmin.governance.status.addFailed":
    "Hinzufügen fehlgeschlagen ({reason}).",
  "superadmin.governance.status.added": "Role Binding hinzugefügt.",
  "superadmin.governance.status.deleteFailed":
    "Löschen fehlgeschlagen ({reason}).",
  "superadmin.governance.status.deleted": "Role Binding gelöscht.",
  "superadmin.governance.status.reloaded": "Neu geladen ({n}).",
  "superadmin.governance.status.reloadFailed":
    "Neu laden fehlgeschlagen ({reason}).",
  "superadmin.governance.status.noUserId": "Keine User-ID verfügbar.",
  "superadmin.governance.status.userIdCopied": "User-ID kopiert.",
  "superadmin.governance.status.copyBlocked":
    "Kopieren blockiert – bitte manuell markieren.",
  "superadmin.governance.status.userIdCopiedIntoForm":
    "User-ID ins Formular übernommen.",

  "superadmin.governance.requests.title": "Access Requests (Debug)",
  "superadmin.governance.requests.hint":
    "Minimaler End-to-End Test: Request → Approval → role_bindings.",
  "superadmin.governance.requests.createSelf":
    "Create self request (tenant test)",
  "superadmin.governance.requests.reload": "Reload requests",
  "superadmin.governance.requests.scopeId": "Scope-ID (tenant)",
  "superadmin.governance.requests.my.title": "My Requests",
  "superadmin.governance.requests.pending.title": "Pending Requests im Scope",
  "superadmin.governance.requests.loading": "Lade…",
  "superadmin.governance.requests.empty": "Keine Requests.",
  "superadmin.governance.requests.approve": "Approve",
  "superadmin.governance.requests.reject": "Reject",
  "superadmin.governance.requests.status.notLoggedIn": "Nicht eingeloggt.",
  "superadmin.governance.requests.status.loadFailed":
    "Requests laden fehlgeschlagen ({reason}).",
  "superadmin.governance.requests.status.createFailed":
    "Request erstellen fehlgeschlagen ({reason}).",
  "superadmin.governance.requests.status.created": "Request erstellt.",
  "superadmin.governance.requests.status.approveFailed":
    "Approve fehlgeschlagen ({reason}).",
  "superadmin.governance.requests.status.approved": "Approved.",
  "superadmin.governance.requests.status.rejectFailed":
    "Reject fehlgeschlagen ({reason}).",
  "superadmin.governance.requests.status.rejected": "Rejected.",
  "superadmin.bpmn.select.label": "Diagramm",
  "superadmin.bpmn.select.schleifchen": "MatchMixer – Flow",
  "superadmin.bpmn.select.example": "Beispiel – Start → Task → End",
  "superadmin.bpmn.edit": "Bearbeiten (Drag & Drop)",
  "superadmin.bpmn.db.load": "Aus DB laden",
  "superadmin.bpmn.db.save": "In DB speichern",
  "superadmin.bpmn.db.status.ready": "",
  "superadmin.bpmn.db.status.loading": "Lade…",
  "superadmin.bpmn.db.status.saving": "Speichere…",
  "superadmin.bpmn.db.status.loaded": "Aus DB geladen.",
  "superadmin.bpmn.db.status.saved": "In DB gespeichert.",
  "superadmin.bpmn.db.status.notFound": "Kein Eintrag in der DB gefunden.",
  "superadmin.bpmn.db.status.tableMissing":
    "DB-Tabelle fehlt (Migration ausrollen).",
  "superadmin.bpmn.db.status.enableEdit":
    "Zum Speichern bitte Bearbeiten aktivieren.",

  // BPMN Viewer (Fallback)
  "bpmn.title": "BPMN Prozess",
  "bpmn.subtitle": "Visualisierung aus BPMN 2.0 XML (Repo-Artefakt)",
  "bpmn.actions.fit": "Einpassen",
  "bpmn.actions.reload": "Neu laden",
  "bpmn.actions.autoLayout": "Auto-Layout",
  "bpmn.actions.import": "Datei laden",
  "bpmn.actions.exportXml": "Export .bpmn",
  "bpmn.actions.exportSvg": "Export SVG",
  "bpmn.actions.resetLocal": "Reset",
  "bpmn.actions.resetLocal.hint": "Lokale Änderungen löschen",
  "bpmn.aria.canvas": "BPMN Diagramm",
  "bpmn.status.loading": "Diagramm wird geladen …",
  "bpmn.status.ready": "Diagramm bereit.",
  "bpmn.status.savedLocal": "Änderungen lokal gespeichert.",
  "bpmn.status.autolayoutRunning": "Auto-Layout läuft …",
  "bpmn.status.autolayoutDone": "Auto-Layout fertig.",
  "bpmn.status.autolayoutError": "Auto-Layout fehlgeschlagen.",
  "bpmn.status.error": "Fehler beim Laden des Diagramms.",
  "bpmn.hint.localDraft": "Änderungen werden lokal im Browser gespeichert.",
  "bpmn.hint.editing":
    "Bearbeiten: Palette links nutzen (Drag & Drop). Über das Schraubenschlüssel-Menü kannst du Element-Typen wechseln.",

  "settings.theme.title": "Darstellung",
  "settings.theme.light": "Hell",
  "settings.theme.dark": "Dunkel",
  "settings.theme.system": "Automatisch",
  "settings.theme.autoHint": "Übernimmt die Darstellung deines Geräts.",

  "settings.tabs.aria": "Einstellungen",
  "settings.tabs.appearance": "Darstellung",
  "settings.tabs.location": "Standort & Wetter",
  "settings.tabs.apps": "Apps",
  "settings.tabs.account": "Konto",

  "settings.location.title": "Standort & Wetter",
  "settings.location.description":
    "Standort und Zeitzone für Sonnenzeiten und Wetter – externe APIs nur serverseitig.",
  "settings.location.loadError": "Standort konnte nicht geladen werden.",
  "settings.location.saveError": "Standort konnte nicht gespeichert werden.",
  "settings.location.saved": "Standort gespeichert.",
  "settings.location.savedLocalOnly":
    "Standort nur lokal gespeichert. Datenbank-Schema prüfen / Migrationen ausführen, damit der Standort dauerhaft erhalten bleibt.",
  "settings.location.section.timezone": "Zeitzone",
  "settings.location.section.place": "Ort",
  "settings.location.section.sun": "Sonne",
  "settings.location.section.weather": "Wetter",
  "settings.location.section.weatherOutdoor": "Wetter (Outdoor)",
  "settings.location.schoolHolidays.sectionTitle": "Schulferien",
  "settings.location.schoolHolidays.intro":
    "Optional Schulferien für dein Bundesland laden – synchron mit TrainingsDesk.",
  "settings.location.schoolHolidays.enableApi":
    "Schulferien automatisch laden und im TrainingsDesk-Kalender markieren",
  "settings.location.schoolHolidays.stateLabel": "Bundesland (Trainingsregion)",
  "settings.location.schoolHolidays.stateHint":
    "Pflicht, wenn der automatische Abruf aktiv ist.",
  "settings.location.schoolHolidays.syncHint":
    "Gleiche Einstellung wie in TrainingsDesk unter Verwaltung → Einstellungen.",
  "settings.location.schoolHolidays.attribution": "Quelle: OpenHolidays API",
  "settings.location.schoolHolidays.save":
    "Schulferien-Einstellungen speichern",
  "settings.location.schoolHolidays.saveChanges": "Änderungen speichern",
  "settings.location.schoolHolidays.saving": "Speichere …",
  "settings.location.schoolHolidays.saved": "Gespeichert",
  "settings.location.schoolHolidays.savedStatus":
    "Schulferien-Einstellungen gespeichert ({state}).",
  "settings.location.schoolHolidays.savedDisabled":
    "Schulferien-Abruf ist deaktiviert (gespeichert).",
  "settings.location.schoolHolidays.validationState":
    "Bitte ein Bundesland wählen, wenn Schulferien geladen werden sollen.",
  "settings.location.schoolHolidays.previewTitle": "Kommende Ferien",
  "settings.location.schoolHolidays.previewEmpty":
    "Keine kommenden Schulferien im gewählten Zeitraum.",
  "settings.location.schoolHolidays.previewSelectState":
    "Wähle ein Bundesland, um die Ferien anzuzeigen.",
  "settings.location.schoolHolidays.previewLoadError":
    "Schulferien konnten nicht geladen werden.",
  "settings.location.schoolHolidays.previewYearHint":
    "Angezeigt: {yearFrom}–{yearTo}",
  "settings.location.timezoneLabel": "IANA-Zeitzone",
  "settings.location.timezoneHint":
    "Steuert Anzeige von Uhrzeiten, „heute“ und Sonnenzeiten.",
  "settings.location.searchLabel": "Ort suchen (Name, PLZ, Adresse)",
  "settings.location.searchPlaceholder":
    "z. B. „TC Musterstadt“ oder „Musterhausen 12345“",
  "settings.location.searching": "Suche…",
  "settings.location.noLocation": "Kein Standort gewählt",
  "settings.location.useClubDefault": "Vereinsstandard übernehmen",
  "settings.location.noClubDefault": "Noch kein Vereinsstandort hinterlegt.",
  "settings.location.sourceClub": "aus Vereinsdaten",
  "settings.location.sourceUser": "selbst gewählt",
  "settings.location.clubs.title": "Meine Vereine",
  "settings.location.clubs.hint":
    "Übernehme Standort und Adresse von einem deiner Vereine. Fehlt ein Verein oder die Adresse, kannst du den Standort weiter unten auch manuell suchen.",
  "settings.location.clubs.loadError": "Vereine konnten nicht geladen werden.",
  "settings.location.clubs.primary": "Hauptverein",
  "settings.location.clubs.apply": "Übernehmen",
  "settings.location.clubs.applied": "Übernommen",
  "settings.location.clubs.geocode": "Adresse geocodieren",
  "settings.location.clubs.geocoding": "Suche Adresse…",
  "settings.location.clubs.geocodeFailed":
    "Adresse konnte nicht gefunden werden.",
  "settings.location.clubs.geocodeSavedShared":
    "Adresse geocodiert und im Verein hinterlegt.",
  "settings.location.clubs.geocodeSavedUserOnly":
    "Adresse geocodiert und in deinen Einstellungen gespeichert. Für alle Vereinsmitglieder muss ein Vereinsadmin die Koordinaten in den Stammdaten pflegen.",
  "settings.location.clubs.noAddress": "Keine Adresse hinterlegt",
  "settings.location.clubs.noCoordinates": "Keine Koordinaten gepflegt",
  "settings.location.clubs.missingData": "Adresse im Vereinsprofil pflegen",
  "settings.location.clubs.sourceLocation": "aus Anlage",
  "settings.location.needCoordinates":
    "Wähle zuerst einen Ort, um Sonnenzeiten und Wetter zu sehen.",
  "settings.location.geocodingAttribution":
    "Geocoding: © Google · Fallback: OpenStreetMap-Mitwirkende via Photon (komoot)",
  "settings.location.sun.sunrise": "Sonnenaufgang",
  "settings.location.sun.solarNoon": "Sonnenhöchststand",
  "settings.location.sun.sunset": "Sonnenuntergang",
  "settings.location.sun.dayLength": "Tageslänge",
  "settings.location.sun.tomorrowSunrise": "Morgen · Sonnenaufgang",
  "settings.location.sun.tomorrowSunset": "Morgen · Sonnenuntergang",
  "settings.location.sun.localCalc":
    "Sonnenzeiten lokal berechnet (NOAA-Algorithmus).",
  "settings.location.weather.indoorHint":
    "Du hast aktuell Indoor (blau) eingestellt. Die Wettervorschau ist vor allem für Outdoor relevant.",
  "settings.location.weather.loading": "Lade Wetter…",
  "settings.location.weather.error":
    "Wetterdaten konnten nicht geladen werden.",
  "settings.location.weather.empty": "Keine Daten verfügbar.",
  "settings.location.weather.attribution":
    "Wetterdaten: Deutscher Wetterdienst (DWD) via Bright Sky · CC BY 4.0",

  "settings.title": "Einstellungen",
  "settings.subtitle":
    "Verwalte hier deine plattformweiten Einstellungen für Darstellung, Apps und Konto.",
  "settings.home.title": "Einstieg / Startseite",
  "settings.home.hint":
    "Wähle, welche App nach dem Login standardmäßig geöffnet werden soll.",
  "settings.home.saveCta": "Startseite speichern",
  "settings.home.saved": "Startseite gespeichert.",
  "settings.home.saveError": "Startseite konnte nicht gespeichert werden.",
  "settings.home.options.hub": "Hub",
  "settings.home.options.trainerstunden": "TrainingsDesk",
  "settings.home.options.schleifchen": "MatchMixer",
  "homePreference.set.cta": "Als Startseite festlegen",
  "homePreference.set.current": "Aktuelle Startseite",
  "homePreference.set.success":
    "{appName} ist jetzt deine Startseite – du landest dort direkt nach dem Login.",
  "homePreference.cleared.success":
    "{appName} ist nicht mehr deine Startseite – du landest wieder im Hub.",
  "settings.playerCount": "ANZAHL SPIELER",

  // Schleifchen Setup Wizard (Fallback)
  "settings.wizard.subtitle": "Geführt durch die wichtigsten Einstellungen.",
  "settings.wizard.mode.label": "Modus",
  "settings.wizard.mode.simple": "Einfach",
  "settings.wizard.mode.expert": "Expert",
  "settings.wizard.back": "Zurück",
  "settings.wizard.next": "Weiter",
  "settings.wizard.cancel": "Abbrechen",
  "settings.wizard.mobileNavAria": "Schritt für Schritt",
  "settings.wizard.stepProgressAria": "Fortschritt der Wizard-Schritte",
  "settings.wizard.stepOf": "Schritt {current} von {total}",
  "settings.wizard.workflow.setup": "Turnier vorbereiten",
  "settings.wizard.workflow.schedule": "Spielplan",
  "settings.wizard.workflow.execution": "Durchführung",
  "settings.wizard.workflow.finished": "Abgeschlossen",
  "breadcrumb.label": "Turnierablauf",

  "settings.wizard.step.meta.title": "Grundlagen",
  "settings.wizard.step.meta.hint": "Format, Datum und Zeit festlegen.",
  "settings.wizard.step.players.title": "Spieler",
  "settings.wizard.step.players.hint": "Spieleranzahl und Namen eintragen.",
  "settings.wizard.step.time.title": "Modus",
  "settings.wizard.step.time.hint": "Spielmodus und Spielplan-Template wählen.",
  "settings.wizard.step.timeAdvanced.title": "Zeitblöcke",
  "settings.wizard.step.timeAdvanced.hint":
    "Warmup, Wechsel und Pausen feinjustieren.",
  "settings.wizard.step.rules.title": "Feintuning",
  "settings.wizard.step.rules.hint": "Zeit, Plätze und Zusammenfassung.",
  "settings.format": "Format",
  "settings.format.singles": "Einzel",
  "settings.format.singles.desc": "",
  "settings.format.singles.players": "bis 16 Spieler",
  "settings.format.doubles": "Doppel",
  "settings.format.doubles.desc": "Partner wechseln",
  "settings.format.doubles.players": "bis 24 Spieler",
  "settings.format.fixedDoubles": "Feste Teams",
  "settings.format.fixedDoubles.desc": "Teams bleiben zusammen",
  "settings.format.fixedDoubles.players": "bis 24 Spieler",
  "settings.badge.new": "Neu",
  "settings.badge.comingSoon": "demnächst",
  "settings.dateTime": "Datum & Zeit",
  "settings.startDate": "Spieldatum",
  "settings.startDate.placeholder": "Datum wählen",
  "settings.tournamentName": "Turniername (optional)",
  "settings.tournamentNamePlaceholder": "z.B. Vereinsmeisterschaft",
  "settings.timeInfo.title": "Turnier-Informationen",
  "settings.errors.title": "Fehler",
  "settings.players.needed": "Noch {count} benötigt",
  "settings.wizard.teamAllocation": "Team-Zulosung",
  "settings.wizard.teamAllocation.question":
    "Wie sollen die festen Doppel-Teams gebildet werden?",
  "settings.wizard.teamAllocation.manual": "Manuell",
  "settings.wizard.teamAllocation.manual.desc": "Teams selbst festlegen",
  "settings.wizard.teamAllocation.random": "Zufällig",
  "settings.wizard.teamAllocation.random.desc": "Zufallspaarungen",
  "settings.wizard.teamAllocation.lkBased": "LK-basiert",
  "settings.wizard.teamAllocation.lkBased.desc": "Stark + Schwach",
  "settings.wizard.teamAllocation.lkBased.missingLkWarning":
    "Nicht alle Spieler haben eine LK. Team-Bildung läuft mit dem Möglichen weiter.",
  "settings.wizard.manualTeams.title": "Teams bilden",
  "settings.wizard.manualTeams.hint":
    "Klicke zwei Spieler an, um ein Team zu bilden",
  "settings.wizard.manualTeams.formed": "Teams gebildet",
  "settings.wizard.manualTeams.formedList": "Gebildete Teams:",
  "settings.wizard.manualTeams.available": "Verfügbare Spieler:",
  "settings.wizard.manualTeams.selectPartner": "Wähle Partner für {name}:",
  "settings.wizard.manualTeams.allDone": "Alle Teams gebildet!",
  "settings.wizard.manualTeams.oddPlayers":
    "Ungerade Spielerzahl – ein Spieler wird pausieren",
  "settings.wizard.manualTeams.removeTeam": "Team entfernen",
  "settings.wizard.manualTeams.cannotPair":
    "Diese Spieler dürfen nicht als Team spielen (Ausschluss).",
  "settings.wizard.manualTeams.incompleteTitle": "Team-Zuordnung unvollständig",
  "settings.wizard.manualTeams.incompleteMessage":
    "Es sind erst {formed} von {required} Teams gebildet. Ist das so beabsichtigt?",
  "settings.wizard.manualTeams.incompleteContinue": "Trotzdem weiter",
  "settings.wizard.recommended": "Empfohlen",
  "settings.wizard.addPlayer": "Weiteren Spieler hinzufügen",
  "settings.wizard.autocompleteTip": "Tipp: Namen eintippen für Autocomplete.",
  "settings.wizard.autocomplete": "Autocomplete",
  "settings.wizard.tip": "Tipp",
  "settings.wizard.workflow.participants": "Teilnehmer",
  "settings.wizard.minPlayers": "Min. {count} Spieler",
  "settings.wizard.ready": "Bereit",
  "settings.wizard.estimatedEnd": "Geschätztes Ende",
  "settings.wizard.places": "Plätze",
  "settings.wizard.summary": "Zusammenfassung",
  "settings.wizard.advancedSettings": "Erweiterte Einstellungen",
  "settings.wizard.timeSettings": "Zeiteinstellungen",
  "settings.wizard.roundsCount": "Anzahl Runden",
  "settings.wizard.roundsFromModeStep":
    "Wurde im Schritt „Modus“ durch die Auswahl Playoffs gewählt.",
  "settings.wizard.availableCourts": "Anzahl verfügbare Plätze",
  "settings.wizard.maxPlayersSimultaneously":
    "max. {count} Spieler gleichzeitig",
  "settings.wizard.summary.format": "Format",
  "settings.wizard.summary.players": "Spieler",
  "settings.wizard.summary.teamAllocation": "Team-Zulosung",
  "settings.wizard.summary.mode": "Modus",
  "settings.wizard.summary.duration": "Dauer",
  "settings.wizard.summary.courts": "Plätze",
  "settings.wizard.summary.withExclusions": "(mit Ausschlüssen)",
  "settings.wizard.summary.participants": "{count} Teilnehmer",
  "settings.wizard.endTimeAt": "{time} Uhr",
  "settings.unit.min": "Min",
  "settings.wizard.lkShort": "LK",
  "settings.wizard.lkForPlayer": "Leistungsklasse Spieler {n}",
  "settings.wizard.lkPerPlayer": "LK pro Spieler",
  "settings.wizard.lkPerPlayer.hint":
    "Leistungsklasse pro Spieler für Team-Zulosung und Auswertung (Expert).",
  "settings.wizard.lkRange": "1,0 – 25,0",
  "settings.wizard.exclusion": "Ausschluss",
  "settings.wizard.exclusion.hint":
    "Spieler X nicht mit Spieler Y paaren (Expert).",
  "settings.wizard.exclusion.buttonTitle": "Ausschlüsse festlegen",
  "settings.wizard.exclusion.prompt": "Mit wem soll {name} NICHT spielen?",
  "settings.createSchedule": "Spielplan erstellen",
  "settings.updateSchedule": "Spielplan erstellen",
  "settings.updateTournament": "Turnier aktualisieren",
  "settings.endTime": "Geschätztes Ende",
  "settings.derivedRounds": "Runden",
  "settings.minutesPerRound": "Min. pro Runde",
  "settings.totalMinutes": "Gesamtdauer",
  "settings.courtsCount": "Anzahl Plätze",
  "settings.courtsNumbers": "Platznummern",
  "settings.courtsNumbers.placeholder":
    "z.B. 1, 2, 3 oder leer für automatische Nummerierung",
  "settings.pauseBetweenRounds": "Pause zw. Runden",
  "settings.halftimeBreak": "Halbzeitpause",
  "settings.warmupMinutes": "Einspielzeit",
  "settings.hints.title": "Hinweise & Tipps",
  "settings.rr.mode": "Modus",
  "settings.rr.mode.oneSetOpen": "Klassisch",
  "settings.rr.mode.oneSetTb": "Wettkampf",
  "settings.rr.mode.twoSetsMtb": "Mit Playoffs",

  "settings.wizard.modePreset.classic": "Klassisch",
  "settings.wizard.modePreset.competitive": "Wettkampf",
  "settings.wizard.modePreset.timebox": "Zeitspiel",
  "settings.wizard.modePreset.playoffs": "Playoffs",
  "settings.wizard.modePreset.classic.desc":
    "1 Satz auf Zeit, einfache Wertung",
  "settings.wizard.modePreset.classic.bullet1": "15 Min pro Runde",
  "settings.wizard.modePreset.classic.bullet2": "2 Punkte für Sieg",
  "settings.wizard.modePreset.classic.bullet3": "1 Punkt für Unentschieden",
  "matchmixer.setup.mode.classic.bullet.minutesPerRound":
    "{minutes} Min pro Runde",
  "matchmixer.setup.mode.classic.bullet.winPoints": "2 Punkte für Sieg",
  "matchmixer.setup.mode.classic.bullet.drawPoints":
    "1 Punkt für Unentschieden",
  "settings.wizard.modePreset.competitive.desc":
    "2 Sätze, detaillierte Wertung",
  "settings.wizard.modePreset.competitive.bullet1": "20 Min pro Runde",
  "settings.wizard.modePreset.competitive.bullet2":
    "Satzdifferenz bei Gleichstand",
  "settings.wizard.modePreset.competitive.bullet3": "Tie-Break nach Rating",
  "settings.wizard.modePreset.timebox.desc":
    "Feste Gesamtdauer statt Rundenanzahl",
  "settings.wizard.modePreset.timebox.bullet1": "z.B. 3 Stunden gesamt",
  "settings.wizard.modePreset.timebox.bullet2": "Beliebig viele Runden",
  "settings.wizard.modePreset.timebox.bullet3": "Endet automatisch",
  "settings.wizard.modePreset.playoffs.desc": "Vorrunden + Halbfinale & Finale",
  "settings.wizard.modePreset.playoffs.bullet1": "MatchMixer-Vorrunden",
  "settings.wizard.modePreset.playoffs.bullet2": "Top 4 im K.O.-Modus",
  "settings.wizard.modePreset.playoffs.bullet3": "Spannendes Finale",
  "settings.points.win": "Punkte Sieg",
  "settings.points.draw": "Punkte Unentschieden",
  "settings.scoring.title": "Scoring & Regeln",
  "settings.scoring.subtitle": "Wie wird ein Match gewertet?",
  "settings.scoring.gameMode": "Spielmodus",
  "settings.scoring.oneSet": "1 Satz",
  "settings.scoring.oneSet.desc": "Schnell & einfach",
  "settings.scoring.bestOf3": "Best of 3",
  "settings.scoring.bestOf3.desc": "2 Gewinnsätze",
  "settings.scoring.bestOf5": "Best of 5",
  "settings.scoring.bestOf5.desc": "3 Gewinnsätze",
  "settings.scoring.setEnd": "Satz-Ende",
  "settings.scoring.setEnd.open": "Offen",
  "settings.scoring.setEnd.open.desc": "2 Spiele Vorsprung",
  "settings.scoring.setEnd.tiebreak": "7:6",
  "settings.scoring.setEnd.tiebreak.desc": "Tiebreak bei 6:6",
  "settings.scoring.setEnd.max75": "7:5",
  "settings.scoring.setEnd.max75.desc": "Max. 7:5",
  "settings.scoring.setEnd.short": "6:4",
  "settings.scoring.setEnd.short.desc": "Kurzsätze",
  "settings.scoring.noAd": "No-Ad Regel",
  "settings.scoring.noAd.desc": "Bei Einstand entscheidet 1 Punkt",
  "settings.template.title": "Template-Auswahl",
  "settings.template.hint": "Vorgefertigte Einstellungen laden (Expert).",
  "settings.playerNamePlaceholder": "Name eingeben...",
  "settings.playerNameOptional": "Optional",
  "settings.playerNamesHint": "Spielernamen eintragen (Autocomplete möglich).",
  "settings.courtsCount.reducedHint":
    "Weniger Plätze als empfohlen. Das Turnier kann länger dauern.",
  "settings.courtsCount.autoHint":
    "Basierend auf {playerCount} {format} Spielern berechnet.",
  "settings.courtsCount.suggested": "Vorschlag",
  "settings.halftimeBreak.shortTournamentWarning":
    "Bei Turnieren unter 90 Minuten ist eine Halbzeitpause möglicherweise nicht sinnvoll.",
  "settings.wizard.step.diagnostics.title": "Diagnose",
  "settings.wizard.step.diagnostics.hint":
    "Plausibilitäts-Checks und Hinweise.",
  "settings.wizard.step.review.title": "Überblick",
  "settings.wizard.step.review.hint": "Zusammenfassung prüfen und erstellen.",

  "settings.wizard.simple.metaHint":
    "Weitere Optionen findest du im Expert-Modus.",
  "settings.wizard.simple.totalMinutesHint":
    "Gesamtdauer ist im Einfach-Modus fix (im Expert-Modus anpassbar).",
  "settings.wizard.simple.reviewNote":
    "Weitere Einstellungen (z.B. Punkte, Regeln, Pausen) kannst du im Expert-Modus anpassen.",

  "settings.wizard.diagnostics.capacityTitle": "Kapazität",
  "settings.wizard.diagnostics.capacityBody":
    "Kapazität: {cap} (Spieler: {players}, sitze aus: {rest})",

  "settings.wizard.review.name": "Turnier",
  "settings.wizard.review.unnamed": "Ohne Namen",
  "settings.wizard.review.date": "Datum",
  "settings.wizard.review.players": "Spieler",
  "settings.wizard.review.startTime": "Startzeit (hh:mm)",
  "settings.wizard.review.minutesPerRound": "Minuten/Runde",
  "settings.wizard.review.rounds": "Runden",

  "settings.wizard.validation.timeInvalid":
    "Bitte eine gültige Startzeit eingeben.",
  "settings.wizard.validation.minutesPerRoundInvalid":
    "Bitte gültige Minuten pro Runde eingeben.",
  "settings.validation.fixToContinue":
    "Bitte korrigieren Sie die Eingabefehler.",
  "settings.validation.warningsContinue": "Warnungen:\n\n",

  "error.saveFailed": "Speichern fehlgeschlagen",
  "trainerstunden.db.schemaOutOfDate":
    "Speichern nicht möglich: Deine Datenbank ist nicht auf dem aktuellen Stand (Migrationen fehlen). Bitte die Supabase-Migrationen ausführen und erneut versuchen.",
  "trainerstunden.db.permissionDenied":
    "Speichern nicht möglich: Keine Berechtigung (RLS). Bitte erneut einloggen oder Rechte prüfen.",

  "trainerstunden.masterdata.people.menuAria": "Aktionen für Kontakt",
  "trainerstunden.masterdata.people.deactivate": "Deaktivieren",
  "trainerstunden.masterdata.people.reactivate": "Reaktivieren",
  "trainerstunden.masterdata.people.deactivateModal.title":
    "Spieler deaktivieren?",
  "trainerstunden.masterdata.people.deactivateModal.body":
    "Zugang zur App bleibt bestehen. Der Spieler wird nicht gelöscht und kann später reaktiviert werden.",
  "trainerstunden.masterdata.people.reactivateModal.title":
    "Spieler reaktivieren?",
  "trainerstunden.masterdata.people.reactivateModal.body":
    "Der Spieler erscheint wieder in der aktiven Kontaktliste.",
  "trainerstunden.masterdata.people.deactivateConfirm":
    "Soll dieser Spieler deaktiviert werden? Der Zugang zur App bleibt bestehen. Er wird nicht gelöscht und kann später reaktiviert werden.",
  "trainerstunden.masterdata.people.reactivateConfirm":
    "Soll dieser Spieler reaktiviert werden?",
  "trainerstunden.masterdata.people.deactivateDisabledHint":
    "Deaktivieren ist nicht möglich, solange der Spieler noch in geplanten Trainings (heute oder Zukunft) ist.",
  "trainerstunden.masterdata.people.deactivateBlocked":
    "Deaktivieren ist nicht möglich: Der Spieler ist noch in {count} geplanten Trainings (nächstes Training: {date}).",
  "trainerstunden.masterdata.people.deactivateBlockedModal.title":
    "Deaktivieren nicht möglich",
  "trainerstunden.masterdata.people.inactive.sectionTitle":
    "Inaktive Spieler ({count})",
  "trainerstunden.masterdata.people.inactive.empty": "Keine inaktiven Spieler.",
  "trainerstunden.masterdata.people.inactive.label": "Inaktiv",
  "trainerstunden.masterdata.people.search.label": "Suche",
  "trainerstunden.masterdata.people.search.placeholder":
    "Name, E-Mail oder Telefon…",
  "trainerstunden.masterdata.people.search.noResults":
    "Keine Spieler gefunden.",
  "trainerstunden.masterdata.people.alphabet.label": "Alphabet",
  "trainerstunden.masterdata.people.form.mode": "Bearbeiten",
  "trainerstunden.masterdata.people.form.createTitle": "Kontakt hinzufügen",
  "trainerstunden.masterdata.people.form.editTitle": "Kontakt bearbeiten",
  "trainerstunden.masterdata.people.form.hint":
    "Änderungen oben erfassen und unten speichern oder abbrechen.",
  "trainerstunden.masterdata.people.roles.groupAria": "Training und Abrechnung",
  "trainerstunden.masterdata.people.roles.legend": "Geschäftspartnertyp",
  "trainerstunden.masterdata.people.roles.trainSelf":
    "Ich spiele/trainiere selbst",
  "trainerstunden.masterdata.people.roles.hint":
    "Ein Kontakt kann Spieler, Rechnungsempfänger und/oder Händler sein — ein Datensatz pro Eintrag. Händler: Firmenname im ersten Feld, Adresse darunter. Nur Rechnungsempfänger: Geburtsdatum weglassen.",
  "trainerstunden.masterdata.people.roles.reveal":
    "Für andere Personen bezahlen?",
  "trainerstunden.masterdata.people.roles.required":
    "Bitte mindestens eine Rolle wählen: Spieler, Rechnungsempfänger oder Händler.",
  "trainerstunden.masterdata.people.roles.vendorCompanyRequired":
    "Für Händler ist ein Firmenname erforderlich.",
  "trainerstunden.masterdata.people.vendorCompanyLabel": "Firma / Händler",
  "trainerstunden.masterdata.people.vendorCompanyPlaceholder":
    "z. B. Tennis-Point Europe GmbH",
  "trainerstunden.masterdata.people.vendorCompanySuffixLabel":
    "Zusatz (optional)",
  "trainerstunden.masterdata.people.vendorCompanySuffixPlaceholder":
    "z. B. Filiale, Abteilung",
  "trainerstunden.masterdata.people.roles.birthRequiredForPlayer":
    "Geburtsdatum ist optional — für Altersfreigaben und Buchungen hilfreich.",
  "trainerstunden.masterdata.people.roles.vendorBlockedDueToSessions":
    "Wechsel zu Händler / Lieferant ist nicht möglich: Der Kontakt ist noch in {count} geplanten Trainings (nächstes Training: {date}).",
  "trainerstunden.masterdata.people.roles.invalidTransition":
    "Dieser Rollenwechsel ist so nicht möglich. Bitte zuerst offene Trainings entfernen oder den Support kontaktieren.",
  "trainerstunden.masterdata.people.duplicates.bannerTitle":
    "Mögliche Duplikate ({count})",
  "trainerstunden.masterdata.people.duplicates.bannerExpandAria":
    "Duplikat-Hinweise ausklappen",
  "trainerstunden.masterdata.people.duplicates.bannerCollapseAria":
    "Duplikat-Hinweise einklappen",
  "trainerstunden.masterdata.people.duplicates.bannerHint":
    "Gleicher Name, mehrere Kontakte im Verein. Bitte prüfen und ggf. zusammenführen.",
  "trainerstunden.masterdata.people.duplicates.groupLabel":
    "{name} ({count} Einträge)",
  "trainerstunden.masterdata.people.duplicates.review": "Prüfen",
  "trainerstunden.masterdata.people.duplicates.modalTitle":
    "Duplikat prüfen: {name}",
  "trainerstunden.masterdata.people.duplicates.modalLead":
    "Sind das dieselbe Person? Wählen Sie den Ziel-Datensatz. Termine, Rechnungen und Zahlungen der anderen Spalte werden dorthin umgehängt — der zweite Eintrag wird nur inaktiv, nichts wird gelöscht.",
  "trainerstunden.masterdata.people.duplicates.keepRecord": "Behalten",
  "trainerstunden.masterdata.people.duplicates.noContactData":
    "Keine Kontaktdaten hinterlegt",
  "trainerstunden.masterdata.people.duplicates.impactTitle":
    "Gegenüberstellung:",
  "trainerstunden.masterdata.people.duplicates.compareTransferHint":
    "Die Zahlen zeigen, wo die Daten heute liegen. Nach der Zusammenführung liegt alles beim Datensatz „Behalten“.",
  "trainerstunden.masterdata.people.duplicates.compareMetricCol": "Verknüpfung",
  "trainerstunden.masterdata.people.duplicates.compareKeeperCol":
    "Behalten (Ziel)",
  "trainerstunden.masterdata.people.duplicates.compareMergeCol": "Wird inaktiv",
  "trainerstunden.masterdata.people.duplicates.compareSessions":
    "Trainingstermine",
  "trainerstunden.masterdata.people.duplicates.compareOpenStatements":
    "Offene Rechnungen",
  "trainerstunden.masterdata.people.duplicates.compareHistoricalStatements":
    "Rechnungen (historisch)",
  "trainerstunden.masterdata.people.duplicates.comparePayments": "Zahlungen",
  "trainerstunden.masterdata.people.duplicates.compareBillingChildren":
    "Spieler mit Abrechnung an diesen Kontakt",
  "trainerstunden.masterdata.people.duplicates.compareBillingChildrenDetailIntro":
    "Diese Spieler haben den Kontakt als Rechnungsempfänger in den Stammdaten hinterlegt.",
  "trainerstunden.masterdata.people.duplicates.compareBillingChildrenDetailAtPerson":
    "{personName} ({role}): {names}",
  "trainerstunden.masterdata.people.duplicates.compareBillingChildrenDetailNone":
    "keine",
  "trainerstunden.masterdata.people.duplicates.compareBillingChildrenDetailCountOnly":
    "{count} Spieler",
  "trainerstunden.masterdata.people.duplicates.compareBillingChildrenDetailAfterMerge":
    "Nach der Zusammenführung: {count} Spieler an {keeperName} — {names}. Die Zuordnung vom inaktiven Datensatz wird umgehängt, kein Spieler wird gelöscht.",
  "trainerstunden.masterdata.people.duplicates.compareBillingChildrenDetailAfterMergeNoNames":
    "Nach der Zusammenführung werden {count} Spieler-Zuordnungen an {keeperName} umgehängt — kein Spieler wird gelöscht.",
  "trainerstunden.masterdata.people.duplicates.compareAppAccess": "App-Zugang",
  "trainerstunden.masterdata.people.duplicates.compareAppAccessDetailIntro":
    "Einladungen und Login-Verknüpfungen werden beim Zusammenführen an den Ziel-Datensatz umgehängt — der App-Zugang bleibt bestehen.",
  "trainerstunden.masterdata.people.duplicates.compareAppAccessDetailAtPerson":
    "{personName} ({role}): {status}",
  "trainerstunden.masterdata.people.duplicates.compareAppAccessDetailNone":
    "kein App-Zugang",
  "trainerstunden.masterdata.people.duplicates.compareAppAccessStatusAcceptedLinked":
    "App aktiv (Login verknüpft)",
  "trainerstunden.masterdata.people.duplicates.compareAppAccessStatusAccepted":
    "Einladung angenommen",
  "trainerstunden.masterdata.people.duplicates.compareAppAccessStatusPending":
    "Einladung offen",
  "trainerstunden.masterdata.people.duplicates.compareAppAccessStatusOther":
    "Status: {status}",
  "trainerstunden.masterdata.people.duplicates.compareAppAccessDetailAfterMerge":
    "Nach der Zusammenführung läuft der App-Zugang über {keeperName} — Login und Rolle bleiben erhalten.",
  "trainerstunden.masterdata.people.duplicates.compareContactTransferTitle":
    "Kontaktdaten vom inaktiven Datensatz",
  "trainerstunden.masterdata.people.duplicates.compareContactTransferIntro":
    "Fehlende Felder am Ziel-Datensatz werden aus dem inaktiven Datensatz übernommen:",
  "trainerstunden.masterdata.people.duplicates.compareContactTransferItem":
    "{label}: {value}",
  "trainerstunden.masterdata.people.duplicates.contactFieldStreet": "Straße",
  "trainerstunden.masterdata.people.duplicates.contactFieldPostalCode": "PLZ",
  "trainerstunden.masterdata.people.duplicates.contactFieldCity": "Ort",
  "trainerstunden.masterdata.people.duplicates.compareSessionsOverlap":
    "Überschneidung: {count} Termine — beide Datensätze sind auf demselben Training eingetragen.",
  "trainerstunden.masterdata.people.duplicates.compareSessionsAfterMerge":
    "Termine nach Zusammenführung",
  "trainerstunden.masterdata.people.duplicates.compareSessionsAfterMergeValue":
    "{total} Termine gesamt ({keeperOnly} bereits am Ziel · {mergeOnly} werden umgehängt · {overlap} Überschneidung)",
  "trainerstunden.masterdata.people.duplicates.compareSessionsOverlapHint":
    "Bei überschneidenden Terminen wird die Person nur einmal am Training geführt — es gehen keine Termine verloren.",
  "trainerstunden.masterdata.people.duplicates.impactOpenStatements":
    "Offene Rechnungen: {count}",
  "trainerstunden.masterdata.people.duplicates.impactHistoricalStatements":
    "Rechnungen (historisch): {count}",
  "trainerstunden.masterdata.people.duplicates.impactPayments":
    "Zahlungen: {count}",
  "trainerstunden.masterdata.people.duplicates.impactSessions":
    "Trainingstermine: {count}",
  "trainerstunden.masterdata.people.duplicates.impactBillingChildren":
    "Abrechnung an diesen Empfänger: {count} Spieler",
  "trainerstunden.masterdata.people.duplicates.impactLinkedHint":
    "Alle Verknüpfungen der inaktiven Spalte wandern zum Ziel-Datensatz — Termine und Rechnungen bleiben erhalten.",
  "trainerstunden.masterdata.people.duplicates.impactEmptyHint":
    "Keine Abrechnungs- oder Terminverknüpfungen — der leere Datensatz kann ohne Datenverlust entfernt werden.",
  "trainerstunden.masterdata.people.duplicates.notDuplicates":
    "Keine Duplikate",
  "trainerstunden.masterdata.people.duplicates.mergeConfirm": "Zusammenführen",
  "trainerstunden.masterdata.people.duplicates.mergeSuccess":
    "Kontakte zusammengeführt.",
  "trainerstunden.masterdata.people.duplicates.errors.billingCollision":
    "Für denselben Monat gibt es bereits aktive Rechnungen auf beiden Datensätzen. Bitte zuerst in Finanz bereinigen.",
  "trainerstunden.masterdata.people.duplicates.errors.trainerMirror":
    "Trainer-Spiegelkontakte können nicht zusammengeführt werden.",
  "trainerstunden.masterdata.people.duplicates.errors.tenantMismatch":
    "Die Kontakte gehören nicht zum selben Verein.",
  "trainerstunden.masterdata.people.duplicates.errors.invalidPair":
    "Ungültige Auswahl.",
  "trainerstunden.masterdata.people.duplicates.errors.linkCollision":
    "Zusammenführen fehlgeschlagen: Beide Datensätze haben dieselbe Verknüpfung (z. B. Gruppe oder App-Zugang). Seite neu laden und erneut versuchen.",
  "trainerstunden.masterdata.people.duplicates.errors.billingRecipientAssigned":
    "Zusammenführen fehlgeschlagen: Der Rechnungsempfänger konnte nicht umgehängt werden. Bitte Seite neu laden und erneut versuchen.",
  "trainerstunden.masterdata.people.duplicates.errors.managedChildBillingLocked":
    "Zusammenführen fehlgeschlagen: Ein verknüpftes Kind hat einen gesperrten Rechnungsempfänger.",
  "trainerstunden.masterdata.people.duplicates.errors.guardianAssigned":
    "Zusammenführen fehlgeschlagen: Ein Erziehungsberechtigter ist bereits gesetzt und kann nicht umgehängt werden.",
  "trainerstunden.masterdata.people.duplicates.errors.mergeFailed":
    "Zusammenführen fehlgeschlagen.",
  "trainerstunden.masterdata.people.addressSync.bannerTitle":
    "Adressen abgleichen ({count})",
  "trainerstunden.masterdata.people.addressSync.bannerExpandAria":
    "Adress-Abgleich ausklappen",
  "trainerstunden.masterdata.people.addressSync.bannerCollapseAria":
    "Adress-Abgleich einklappen",
  "trainerstunden.masterdata.people.addressSync.bannerHint":
    "Bei verknüpften Kontakten (Kind, Eltern, Rechnungsempfänger) ist die Adresse nur auf einer Seite gepflegt. Leere Felder können übernommen werden.",
  "trainerstunden.masterdata.people.addressSync.groupLabel":
    "{sourceName} → {targetName}",
  "trainerstunden.masterdata.people.addressSync.review": "Prüfen",
  "trainerstunden.masterdata.people.addressSync.modalTitle":
    "Adresse übernehmen",
  "trainerstunden.masterdata.people.addressSync.modalLead":
    "Es werden nur leere Felder beim Ziel-Kontakt ergänzt — bestehende Werte bleiben unverändert.",
  "trainerstunden.masterdata.people.addressSync.sourceLabel": "Quelle: {name}",
  "trainerstunden.masterdata.people.addressSync.targetLabel": "Ziel: {name}",
  "trainerstunden.masterdata.people.addressSync.noAddress": "Keine Adresse",
  "trainerstunden.masterdata.people.addressSync.fieldsTitle":
    "Diese Felder werden übernommen",
  "trainerstunden.masterdata.people.addressSync.field.street": "Straße",
  "trainerstunden.masterdata.people.addressSync.field.houseNumber":
    "Hausnummer",
  "trainerstunden.masterdata.people.addressSync.field.postalCode": "PLZ",
  "trainerstunden.masterdata.people.addressSync.field.city": "Ort",
  "trainerstunden.masterdata.people.addressSync.relation.parentChild":
    "Familienbezug (Kind / Eltern)",
  "trainerstunden.masterdata.people.addressSync.relation.billingRecipient":
    "Spieler und Rechnungsempfänger",
  "trainerstunden.masterdata.people.addressSync.relation.legalGuardian":
    "Spieler und Erziehungsberechtigte/r",
  "trainerstunden.masterdata.people.addressSync.apply": "Übernehmen",
  "trainerstunden.masterdata.people.addressSync.dismiss": "Nicht jetzt",
  "trainerstunden.masterdata.people.addressSync.success": "Adresse übernommen.",
  "trainerstunden.masterdata.people.addressSync.error":
    "Adresse konnte nicht übernommen werden.",
  "trainerstunden.masterdata.people.staffRoles.legend": "Trainer-Rollen",
  "trainerstunden.masterdata.people.staffRoles.enableLabel":
    "Auch als Trainer, Assistent oder Koordinator im TrainingsDesk",
  "trainerstunden.masterdata.people.staffRoles.typeLegend": "Art",
  "trainerstunden.masterdata.people.staffRoles.hint":
    "Zusätzlich zur Spieler- oder Kontaktrolle im TrainingsDesk als Trainer, Assistent oder Koordinator tätig.",
  "trainerstunden.masterdata.people.staffRoles.none": "Keine Trainer-Rolle",
  "trainerstunden.masterdata.people.staffRoles.trainer": "Trainer",
  "trainerstunden.masterdata.people.staffRoles.assistant": "Assistent",
  "trainerstunden.masterdata.people.staffRoles.coordinator": "Koordinator",
  "trainerstunden.masterdata.people.errors.duplicateName":
    "In diesem Verein gibt es bereits einen Kontakt mit diesem Vor- und Nachnamen. Bitte den bestehenden Datensatz bearbeiten oder eine andere Rolle dort ergänzen.",
  "trainerstunden.masterdata.people.addAsAssistant": "Trainerassistent",
  "trainerstunden.masterdata.people.form.pageHint":
    "Kontaktdaten erfassen und speichern oder zur Liste zurück.",
  "trainerstunden.masterdata.people.form.backToList": "Zurück zur Kontaktliste",
  "trainerstunden.masterdata.people.form.backToProfile": "Zurück zum Profil",
  "trainerstunden.masterdata.people.form.notFound": "Kontakt nicht gefunden.",
  "trainerstunden.masterdata.people.profile.title": "Kontakt",
  "trainerstunden.masterdata.people.profile.unnamed": "Unbenannter Kontakt",
  "trainerstunden.masterdata.people.profile.email": "E-Mail",
  "trainerstunden.masterdata.people.profile.phone": "Telefon",
  "trainerstunden.masterdata.people.profile.address": "Adresse",
  "trainerstunden.masterdata.people.profile.birth": "Geburtsdatum",
  "trainerstunden.masterdata.people.profile.appAccess": "App-Zugang",
  "trainerstunden.masterdata.people.profile.trainingActions.title":
    "Training anlegen",
  "trainerstunden.masterdata.people.profile.trainingActions.single":
    "Einzeltraining",
  "trainerstunden.masterdata.people.profile.trainingActions.series":
    "Serientraining",
  "trainerstunden.masterdata.people.profile.trainingActions.singleAria":
    "Einzeltraining mit {name} anlegen",
  "trainerstunden.masterdata.people.profile.trainingActions.seriesAria":
    "Serientraining mit {name} anlegen",
  "trainerstunden.masterdata.people.profile.serviceRecipients.title":
    "Leistungsempfänger",
  "trainerstunden.masterdata.people.profile.serviceRecipients.role":
    "Leistungsempfänger",
  "trainerstunden.masterdata.people.profile.serviceRecipients.openAria":
    "Profil von {name} öffnen",
  "trainerstunden.masterdata.people.profile.invoices.title": "Rechnungen",
  "trainerstunden.masterdata.people.profile.costs.title": "Trainingskosten",
  "trainerstunden.masterdata.people.profile.costs.billedVia":
    "Rechnungen laufen über {name}.",
  "trainerstunden.masterdata.people.profile.costs.openInvoices":
    "Zu {name} wechseln",
  "trainerstunden.masterdata.people.profile.costs.kpiYear":
    "Abgerechnet {year}",
  "trainerstunden.masterdata.people.profile.costs.kpiTotal":
    "Gesamt abgerechnet",
  "trainerstunden.masterdata.people.profile.costs.kpiOpen": "Noch offen",
  "trainerstunden.masterdata.people.profile.costs.openCount":
    "{count} offene Leistungen",
  "trainerstunden.masterdata.people.profile.costs.empty":
    "Noch keine Trainingskosten für diese Person.",
  "trainerstunden.masterdata.people.profile.costs.lineFallback": "Training",
  "trainerstunden.masterdata.people.profile.costs.statusOpen": "Offen",
  "trainerstunden.masterdata.people.profile.costs.statusBilled": "Abgerechnet",
  "trainerstunden.masterdata.people.profile.trainingDocs.title":
    "Trainingsbewertung",
  "trainerstunden.masterdata.people.profile.trainingDocs.loading":
    "Bewertungen werden geladen…",
  "trainerstunden.masterdata.people.profile.trainingDocs.empty":
    "Noch keine Trainingsdokumentation vorhanden.",
  "trainerstunden.masterdata.people.profile.trainingDocs.averageHeading":
    "Durchschnitt aus {count} dokumentierten Stunden",
  "trainerstunden.masterdata.people.profile.trainingDocs.averageAria":
    "{skill}: Durchschnitt {average} von 5",
  "trainerstunden.masterdata.people.profile.trainingDocs.startedOn":
    "Training begonnen am {date}",
  "trainerstunden.masterdata.people.profile.trainingDocs.showDetails":
    "Details",
  "trainerstunden.masterdata.people.profile.trainingDocs.hideDetails":
    "Details ausblenden",
  "trainerstunden.masterdata.people.profile.invoices.filterLabel": "Status",
  "trainerstunden.masterdata.people.profile.invoices.filterAria":
    "Rechnungen filtern",
  "trainerstunden.masterdata.people.profile.invoices.filterAll": "Alle",
  "trainerstunden.masterdata.people.profile.invoices.filterOpen": "Offen",
  "trainerstunden.masterdata.people.profile.invoices.filterPaid": "Bezahlt",
  "trainerstunden.masterdata.people.profile.invoices.filterCancelled":
    "Storniert",

  // Form-Admin (Fallback)
  "formAdmin.title": "Formulare & Regeln",
  "formAdmin.schema.title": "Schema",
  "formAdmin.schema.select": "Formular",
  "formAdmin.schema.none": "Kein Schema geladen.",
  "formAdmin.schema.key": "Key",
  "formAdmin.schema.version": "Version",
  "formAdmin.schema.active": "Aktiv",
  "formAdmin.schema.layout": "Layout (JSON)",
  "formAdmin.schema.noTranslation": "(keine Übersetzung gefunden)",
  "formAdmin.fields.title": "Felder",
  "formAdmin.fields.hint": "Field-Definitionen inkl. constraints/ui JSON.",
  "formAdmin.fields.col.fieldKey": "field_key",
  "formAdmin.fields.col.type": "type",
  "formAdmin.fields.col.labelKey": "label_key",
  "formAdmin.fields.col.labelText": "Label (Übersetzung)",
  "formAdmin.fields.col.helpKey": "help_key",
  "formAdmin.fields.col.helpText": "Hilfe (Übersetzung)",
  "formAdmin.fields.suggestedLabelKey": "Vorschlag",
  "formAdmin.fields.suggestedHelpKey": "Vorschlag",
  "formAdmin.fields.col.default": "default_value",
  "formAdmin.fields.col.constraints": "constraints (JSON)",
  "formAdmin.fields.col.ui": "ui (JSON)",
  "formAdmin.fields.col.action": "Aktion",
  "formAdmin.mode.title": "Ansicht",
  "formAdmin.mode.hint": "Einfach blendet technische Details aus.",
  "formAdmin.mode.simple": "Einfach",
  "formAdmin.mode.expert": "Expert",
  "formAdmin.rules.title": "Regeln",
  "formAdmin.rules.hint": "IF/THEN Regeln (JSON).",
  "formAdmin.rules.priority": "Priorität",
  "formAdmin.rules.notes": "Notizen",
  "formAdmin.rules.when": "Wenn (JSON)",
  "formAdmin.rules.then": "Dann (JSON)",
  "formAdmin.rules.builder.title": "Regel-Builder",
  "formAdmin.rules.builder.hint":
    "Erstelle Regeln ohne JSON. (Expert: JSON bleibt verfügbar)",
  "formAdmin.rules.builder.priority": "Priorität",
  "formAdmin.rules.builder.notes": "Notizen",
  "formAdmin.rules.builder.notesPlaceholder": "z.B. ONE_SET_OPEN versteckt MTB",
  "formAdmin.rules.builder.whenTitle": "Wenn",
  "formAdmin.rules.builder.thenTitle": "Dann",
  "formAdmin.rules.builder.field": "Feld",
  "formAdmin.rules.builder.op": "Operator",
  "formAdmin.rules.builder.value": "Wert",
  "formAdmin.rules.builder.valuePlaceholder":
    "z.B. ONE_SET_OPEN oder 10 oder true",
  "formAdmin.rules.builder.valueHint": "Für in/notIn: Werte komma-getrennt.",
  "formAdmin.rules.builder.action": "Aktion",
  "formAdmin.rules.builder.thenValuePlaceholder": "true/false oder Wert",
  "formAdmin.rules.builder.thenValueHint":
    "Bei clearValue wird der Wert ignoriert.",
  "formAdmin.rules.builder.add": "Regel hinzufügen",
  "formAdmin.rules.builder.noFields": "(keine Felder)",
  "formAdmin.rules.builder.addAction": "Aktion hinzufügen",
  "formAdmin.rules.builder.actionsTitle": "Aktionen",
  "formAdmin.rules.builder.actionsEmpty": "Noch keine Aktionen hinzugefügt.",
  "formAdmin.rules.builder.reset": "Zurücksetzen",

  // Form-Admin: Operatoren & Aktionen (Fallback)
  "formAdmin.ops.equals": "ist gleich",
  "formAdmin.ops.notEquals": "ist nicht gleich",
  "formAdmin.ops.in": "ist in Liste",
  "formAdmin.ops.notIn": "ist nicht in Liste",
  "formAdmin.ops.isEmpty": "ist leer",
  "formAdmin.ops.gt": "größer als",
  "formAdmin.ops.gte": "größer/gleich",
  "formAdmin.ops.lt": "kleiner als",
  "formAdmin.ops.lte": "kleiner/gleich",
  "formAdmin.actions.setVisible": "Sichtbar/Unsichtbar",
  "formAdmin.actions.setEnabled": "Aktiv/Deaktiv",
  "formAdmin.actions.setRequired": "Pflichtfeld",
  "formAdmin.actions.setValue": "Wert setzen",
  "formAdmin.actions.clearValue": "Wert leeren",

  "formAdmin.workflow.title": "Workflow (Schritte & Felder)",
  "formAdmin.workflow.hint":
    "Hier definierst du, welche Felder in welchem Schritt erscheinen (ohne JSON).",
  "formAdmin.workflow.steps": "Schritte",
  "formAdmin.workflow.addStep": "Schritt hinzufügen",
  "formAdmin.workflow.stepHint":
    "ID ist technisch (stabil). title_key/hint_key sind Übersetzungen.",
  "formAdmin.workflow.modes": "Modi (Schritt-Reihenfolge)",
  "formAdmin.workflow.modesHint":
    "Definiert die Wizard-Reihenfolge je Modus (simple/expert).",
  "formAdmin.workflow.modesEmpty":
    "(keine Schritte – wird automatisch aus Feldern abgeleitet)",
  "formAdmin.workflow.addModeStep": "Schritt hinzufügen",
  "formAdmin.workflow.mode.simple": "Einfach",
  "formAdmin.workflow.mode.expert": "Expert",
  "formAdmin.workflow.fields": "Felder zuordnen",
  "formAdmin.workflow.fieldsHint":
    "Wähle Schritt + Reihenfolge (kleiner = weiter oben).",
  "formAdmin.workflow.noSteps": "(keine Schritte)",
  "formAdmin.workflow.col.field": "Feld",
  "formAdmin.workflow.col.drag": "Sortieren",
  "formAdmin.workflow.col.step": "Schritt",
  "formAdmin.workflow.col.order": "Reihenfolge",
  "formAdmin.workflow.dragHint": "Ziehen zum Sortieren (Drag & Drop)",
  "formAdmin.workflow.warningsTitle": "Hinweise",
  "formAdmin.workflow.unassigned": "Unzugeordnet",
  "formAdmin.workflow.advancedTable": "Erweiterte Ansicht (Tabelle)",
  "formAdmin.preview.title": "Vorschau (Wizard)",
  "formAdmin.preview.mode": "Modus",
  "formAdmin.preview.hint":
    "Zeigt live, welche Schritte/Felder der Anwender sieht.",
  "formAdmin.preview.steps": "Schritte",
  "formAdmin.preview.fields": "Felder im Schritt",
  "formAdmin.preview.liveTitle": "Echte Darstellung (Live)",
  "formAdmin.preview.liveHint":
    "Layout-Änderungen werden live als Draft übertragen (ohne Speichern).",
  "formAdmin.preview.noLive":
    "Live‑Vorschau ist aktuell nur für MatchMixer‑Setup verfügbar.",

  /* Hub (Global + App Hub) */
  "home.welcomeBack": "Willkommen zurück",
  "home.chooseApp": "Wähle eine App",
  "hub.mainApp.spielerFinden.title": "CourtLink",
  "hub.mainApp.spielerFinden.subtitle":
    "Spieler finden, Matches abstimmen und dein Netzwerk nutzen.",
  "hub.mainApp.matchVerabreden.title": "Match verabreden",
  "hub.mainApp.matchVerabreden.subtitle": "Termine abstimmen – demnächst.",
  "hub.mainApp.halleBuchen.title": "Platz buchen",
  "hub.mainApp.halleBuchen.subtitle": "Court-Buchung – demnächst.",
  "home.openHub": "Neuen Hub öffnen",
  "home.openHubHint":
    "Neue Startseite (Beta) mit App-Hubs & Zuletzt verwendet.",
  "home.yourApps": "Deine Apps",
  "hub.marketplace.category.turniere": "Turniere",
  "hub.marketplace.category.training": "Training",
  "hub.marketplace.category.organisation": "Organisation",
  "hub.marketplace.category.tools": "Tools",
  "hub.marketplace.status.beta": "Beta",
  "hub.marketplace.status.comingSoonAria": "Demnächst verfügbar",
  "hub.marketplace.usage.active": "Aktiv",
  "hub.marketplace.usage.comingSoon": "Demnächst",
  "hub.marketplace.usage.noAccess": "Kein Zugriff",
  "hub.marketplace.detailsLink": "Details",
  "hub.marketplace.detail.backToHub": "Zurück zum Hub",
  "hub.marketplace.detail.openApp": "App öffnen",
  "hub.marketplace.detail.categoryLabel": "Kategorie",
  "hub.marketplace.detail.featureFlagLabel": "Feature-Flag",
  "hub.marketplace.detail.entryRouteLabel": "Einstieg",
  "home.recent": "Zuletzt verwendet",
  "home.recent.empty": "Noch keine zuletzt verwendeten Einträge.",
  "hub.schleifchen.title": "MatchMixer",
  "hub.matchmixer.title": "MatchMixer",
  "hub.schleifchen.subtitle": "Doppelrunden organisieren und Turniere steuern.",
  "hub.matchmixer.subtitle": "Doppelrunden organisieren und Turniere steuern.",
  "hub.matchmixer.tip.title": "Tipp des Tages",
  "hub.matchmixer.tip.1":
    "Beim Schleifchen rotieren alle paar Runden die Partner – ideal für Vereinsabende, wenn viele unterschiedliche Doppel spielen sollen.",
  "hub.matchmixer.tip.2":
    "Starte mit der geplanten Rundenanzahl – du kannst während des Turniers jederzeit Runden ergänzen oder abschließen.",
  "hub.matchmixer.tip.3":
    "Teile den Turnier-Code mit den Spielerinnen und Spielern: Sie sehen Spielplan und Ergebnisse live, ohne App-Installation.",
  "hub.matchmixer.quickStart.word1": "Planen",
  "hub.matchmixer.quickStart.word2": "Mischen",
  "hub.matchmixer.quickStart.word3": "Spielen",
  "hub.matchmixer.quickStart.tagline": "Planen · Mischen · Spielen",
  "hub.matchmixer.quickStart.aria":
    "MatchMixer: Turnier planen, Paarungen mischen, live durchführen",
  "hub.matchmixer.stats.aria": "Turnier-Übersicht",
  "hub.matchmixer.stat.total": "Turniere gesamt",
  "hub.matchmixer.stat.totalDetail": "Alle deine MatchMixer-Turniere",
  "hub.matchmixer.stat.running": "Laufen gerade",
  "hub.matchmixer.stat.runningDetail": "Aktuell im Spielbetrieb",
  "hub.matchmixer.stat.planned": "Geplant",
  "hub.matchmixer.stat.plannedDetail": "Bereit zum Start",
  "hub.matchmixer.active.title": "Deine aktiven Turniere",
  "hub.matchmixer.active.empty": "Noch keine eigenen Turniere. Leg oben los.",
  "hub.matchmixer.active.status.planned": "Geplant",
  "hub.matchmixer.active.status.registration": "Anmeldung läuft",
  "hub.matchmixer.active.status.running": "Läuft gerade",
  "hub.matchmixer.active.status.active": "Aktiv",
  "hub.matchmixer.active.status.finished": "Abgeschlossen",
  "hub.matchmixer.active.status.cancelled": "Abgesagt",
  "hub.matchmixer.active.status.aborted": "Abgebrochen",
  "hub.matchmixer.hero.aria": "MatchMixer starten",
  "hub.matchmixer.hero.title":
    "Neue Partner. Spannende Matches. Dein Tag auf dem Platz.",
  "hub.matchmixer.hero.subtitle":
    "Bring Menschen zusammen. MatchMixer organisiert die Runden.",
  "hub.matchmixer.hero.cta": "Heute spielen",
  "hub.matchmixer.hero.ctaPlay": "Heute spielen",
  "hub.matchmixer.hero.ctaRegister": "Mit Anmeldung planen",
  "hub.matchmixer.secondary.aria": "Weitere Aktionen",
  "hub.matchmixer.secondary.openRegistration": "Mit Anmeldung planen",
  "hub.matchmixer.secondary.templates": "Vorlagen nutzen",
  "hub.matchmixer.secondary.registrationsList": "Offene Anmeldungen",
  "hub.matchmixer.tournaments.title": "Deine Turniere",
  "hub.matchmixer.tournaments.filter.aria": "Turniere nach Status filtern",
  "hub.matchmixer.tournaments.filter.all": "Alle",
  "hub.matchmixer.tournaments.filter.active": "Aktiv",
  "hub.matchmixer.tournaments.filter.planned": "Geplant",
  "hub.matchmixer.tournaments.filter.finished": "Abgeschlossen",
  "hub.matchmixer.tournaments.filter.cancelled_aborted":
    "Abgesagt / Abgebrochen",
  "hub.matchmixer.tournaments.filter.running": "Laufend",
  "hub.matchmixer.tournaments.filter.past": "Vergangen",
  "hub.matchmixer.tournaments.search.aria": "Turnier suchen",
  "hub.matchmixer.tournaments.search.placeholder": "Name oder Code suchen…",
  "hub.matchmixer.tournaments.archiveToggle": "Archiv anzeigen",
  "hub.matchmixer.tournaments.overdue.banner":
    "{count} vergangene Termine brauchen Klärung",
  "hub.matchmixer.tournaments.overdue.cta": "Status klären",
  "hub.matchmixer.tournaments.overdue.cardHint":
    "Termin liegt in der Vergangenheit",
  "hub.matchmixer.tournaments.focus.active":
    "Weiter am aktiven Turnier „{name}“",
  "hub.matchmixer.tournaments.focus.activeCta": "Weiter spielen",
  "hub.matchmixer.tournaments.focus.new":
    "Kein aktives Turnier — starte eine neue Session.",
  "hub.matchmixer.tournaments.focus.newCta": "Neues Turnier starten",
  "hub.matchmixer.tournaments.stale.hint":
    "{count} abgelaufene Entwürfe sind ausgeblendet",
  "hub.matchmixer.tournaments.stale.cta": "Aufräumen ({count})",
  "hub.matchmixer.tournaments.nameFallback.dated": "MatchMixer · {date}",
  "hub.matchmixer.tournaments.nameFallback.generic": "MatchMixer",
  "hub.matchmixer.tournaments.empty.all":
    "Noch keine Turniere. Starte oben ein neues.",
  "hub.matchmixer.tournaments.empty.active":
    "Gerade läuft kein Turnier. Starte oben ein neues oder wechsle den Filter.",
  "hub.matchmixer.tournaments.empty.planned":
    "Keine geplanten Turniere. Lege oben ein neues an.",
  "hub.matchmixer.tournaments.empty.finished":
    "Noch keine abgeschlossenen Turniere.",
  "hub.matchmixer.tournaments.empty.cancelled_aborted":
    "Keine abgesagten oder abgebrochenen Turniere.",
  "hub.matchmixer.tournaments.empty.archived": "Im Archiv sind keine Turniere.",
  "hub.matchmixer.tournaments.empty.running":
    "Gerade läuft kein Turnier. Starte oben ein neues oder wechsle den Filter.",
  "hub.matchmixer.tournaments.empty.past": "Noch keine vergangenen Turniere.",
  "hub.matchmixer.tournaments.players": "{count} Spieler",
  "hub.matchmixer.tournaments.courts": "{count} Plätze",
  "hub.matchmixer.tournaments.roundProgress": "Runde {current} von {rounds}",
  "hub.matchmixer.tournaments.cta.continue": "Weiter zum Turnier",
  "hub.matchmixer.tournaments.cta.open": "Turnier öffnen",
  "hub.matchmixer.tournaments.cta.prepare": "Turnier vorbereiten",
  "hub.matchmixer.tournaments.cta.results": "Ergebnisse ansehen",
  "hub.matchmixer.tournaments.cta.replan": "Neu planen",
  "hub.matchmixer.tournaments.cta.details": "Details und Ergebnisse",
  "hub.matchmixer.bulk.aria": "Mehrfachauswahl",
  "hub.matchmixer.bulk.selectAll": "Alle sichtbaren auswählen",
  "hub.matchmixer.bulk.selected": "{count} ausgewählt",
  "hub.matchmixer.bulk.selectOne": "{name} auswählen",
  "hub.matchmixer.bulk.clear": "Auswahl aufheben",
  "hub.matchmixer.bulk.working": "Wird ausgeführt…",
  "hub.matchmixer.bulk.noneEligible":
    "Für die Auswahl ist diese Aktion nicht möglich.",
  "hub.matchmixer.bulk.partialError":
    "{ok} erfolgreich, {fail} fehlgeschlagen.",
  "hub.matchmixer.bulk.cancel": "Absagen ({count})",
  "hub.matchmixer.bulk.abort": "Abbrechen ({count})",
  "hub.matchmixer.bulk.archive": "Archivieren ({count})",
  "hub.matchmixer.bulk.deleteEmpty": "Löschen ({count})",
  "hub.matchmixer.bulk.cancel.confirmTitle": "{count} Turniere absagen?",
  "hub.matchmixer.bulk.cancel.confirmBody":
    "Geplante Turniere werden abgesagt. Anmeldungen bleiben erhalten, Start und neue Anmeldungen sind gesperrt.",
  "hub.matchmixer.bulk.cancel.confirmCta": "Absagen",
  "hub.matchmixer.bulk.cancel.success": "{count} Turniere abgesagt.",
  "hub.matchmixer.bulk.abort.confirmTitle": "{count} Turniere abbrechen?",
  "hub.matchmixer.bulk.abort.confirmBody":
    "Laufende Turniere werden als abgebrochen markiert. Bisherige Ergebnisse bleiben erhalten.",
  "hub.matchmixer.bulk.abort.confirmCta": "Abbrechen",
  "hub.matchmixer.bulk.abort.success": "{count} Turniere abgebrochen.",
  "hub.matchmixer.bulk.archive.confirmTitle": "{count} Turniere archivieren?",
  "hub.matchmixer.bulk.archive.confirmBody":
    "Die ausgewählten Turniere werden im Archiv abgelegt und aus der Standardliste ausgeblendet.",
  "hub.matchmixer.bulk.archive.confirmCta": "Archivieren",
  "hub.matchmixer.bulk.archive.success": "{count} Turniere archiviert.",
  "hub.matchmixer.bulk.deleteEmpty.confirmTitle": "{count} Entwürfe löschen?",
  "hub.matchmixer.bulk.deleteEmpty.confirmBody":
    "Nur leere Entwürfe ohne Anmeldungen und Ergebnisse werden endgültig gelöscht.",
  "hub.matchmixer.bulk.deleteEmpty.confirmCta": "Endgültig löschen",
  "hub.matchmixer.bulk.deleteEmpty.success": "{count} Entwürfe gelöscht.",
  "hub.matchmixer.bulk.cleanupStale.confirmTitle":
    "{count} abgelaufene Entwürfe entfernen?",
  "hub.matchmixer.bulk.cleanupStale.confirmBody":
    "Vergangene Geplant-Turniere werden abgesagt und aus der Liste entfernt.",
  "hub.matchmixer.bulk.cleanupStale.confirmCta": "Aufräumen",
  "hub.matchmixer.bulk.cleanupStale.success":
    "{count} abgelaufene Entwürfe entfernt.",
  "hub.matchmixer.footer.tagline":
    "Gemeinsam spielen. Neue Leute kennenlernen.",
  "hub.matchmixer.active.entrants.zero": "Noch keine Anmeldungen",
  "hub.matchmixer.active.entrants.count": "{count} Anmeldungen",
  "hub.matchmixer.active.deadline": "bis {date}",
  "hub.matchmixer.active.menu.toggle": "Aktionen für {name}",
  "hub.matchmixer.active.menu.open": "Turnier öffnen",
  "hub.matchmixer.active.menu.start": "Turnier starten",
  "hub.matchmixer.active.menu.edit": "Bearbeiten",
  "hub.matchmixer.active.menu.delete": "Turnier löschen",
  "hub.matchmixer.active.menu.cancel": "Turnier absagen",
  "hub.matchmixer.active.menu.abort": "Turnier abbrechen",
  "hub.matchmixer.active.menu.archive": "Archivieren",
  "hub.matchmixer.active.menu.unarchive": "Aus Archiv holen",
  "hub.matchmixer.active.menu.deleteEmpty": "Endgültig löschen…",
  "hub.matchmixer.active.menu.deleteEmptyDisabled":
    "Nur leere Entwürfe ohne Anmeldungen oder Ergebnisse können gelöscht werden. Bitte absagen.",
  "hub.matchmixer.active.menu.reschedule": "Termin verschieben",
  "hub.matchmixer.active.menu.replan": "Neu planen",
  "hub.matchmixer.active.menu.motif": "Motiv wählen",
  "hub.matchmixer.active.menu.excludeStats": "Aus Statistik ausschließen",
  "hub.matchmixer.active.menu.includeStats": "Wieder in Statistik aufnehmen",
  "hub.matchmixer.active.menu.excludeStats.suggest":
    "Name enthält „test“ – Ausschluss prüfen?",
  "hub.matchmixer.active.menu.notify": "Teilnehmer informieren",
  "hub.matchmixer.active.menu.startDisabled":
    "Start ist erst nach Turnierbeginn oder bei laufendem Turnier nicht möglich.",
  "hub.matchmixer.active.menu.startDisabledFuture":
    "Start ist erst ab dem geplanten Termin möglich.",
  "hub.matchmixer.active.menu.editDisabled":
    "Einstellungen können nach Start oder Abschluss nicht mehr geändert werden.",
  "hub.matchmixer.active.menu.deleteDisabled":
    "Abgeschlossene Turniere können nicht gelöscht werden.",
  "hub.matchmixer.active.delete.success": "„{name}“ wurde gelöscht.",
  "hub.matchmixer.lifecycle.reason.label": "Grund (optional)",
  "hub.matchmixer.lifecycle.reason.placeholder":
    "z. B. Regen, zu wenige Teilnehmer…",
  "hub.matchmixer.lifecycle.date.label": "Datum",
  "hub.matchmixer.lifecycle.time.label": "Uhrzeit",
  "hub.matchmixer.lifecycle.cancel.title": "Turnier absagen?",
  "hub.matchmixer.lifecycle.cancel.body":
    "„{name}“ wird als abgesagt markiert. Planung und Anmeldungen bleiben erhalten.",
  "hub.matchmixer.lifecycle.cancel.cta": "Absagen",
  "hub.matchmixer.lifecycle.cancel.success": "„{name}“ wurde abgesagt.",
  "hub.matchmixer.lifecycle.cancel.error":
    "Absage fehlgeschlagen. Bitte erneut versuchen.",
  "hub.matchmixer.lifecycle.abort.title": "Turnier abbrechen?",
  "hub.matchmixer.lifecycle.abort.body":
    "„{name}“ wird abgebrochen. Bisherige Spiele und Ergebnisse bleiben erhalten.",
  "hub.matchmixer.lifecycle.abort.cta": "Abbrechen",
  "hub.matchmixer.lifecycle.abort.success": "„{name}“ wurde abgebrochen.",
  "hub.matchmixer.lifecycle.abort.error":
    "Abbruch fehlgeschlagen. Bitte erneut versuchen.",
  "hub.matchmixer.lifecycle.archive.title": "Turnier archivieren?",
  "hub.matchmixer.lifecycle.archive.body":
    "„{name}“ wird im Archiv abgelegt und aus der Standardliste ausgeblendet.",
  "hub.matchmixer.lifecycle.archive.cta": "Archivieren",
  "hub.matchmixer.lifecycle.archive.success": "„{name}“ wurde archiviert.",
  "hub.matchmixer.lifecycle.unarchive.title": "Aus Archiv holen?",
  "hub.matchmixer.lifecycle.unarchive.body":
    "„{name}“ erscheint wieder in der normalen Übersicht.",
  "hub.matchmixer.lifecycle.unarchive.cta": "Wiederherstellen",
  "hub.matchmixer.lifecycle.unarchive.success":
    "„{name}“ wurde wiederhergestellt.",
  "hub.matchmixer.lifecycle.unarchive.error":
    "Wiederherstellen fehlgeschlagen. Bitte erneut versuchen.",
  "hub.matchmixer.lifecycle.deleteEmpty.title": "Leeren Entwurf löschen?",
  "hub.matchmixer.lifecycle.deleteEmpty.body":
    "„{name}“ wird endgültig gelöscht. Das geht nur ohne Anmeldungen und Spiele.",
  "hub.matchmixer.lifecycle.deleteEmpty.cta": "Endgültig löschen",
  "hub.matchmixer.lifecycle.deleteEmpty.success": "„{name}“ wurde gelöscht.",
  "hub.matchmixer.lifecycle.deleteEmpty.error":
    "Löschen fehlgeschlagen. Bitte erneut versuchen.",
  "hub.matchmixer.lifecycle.deleteEmpty.notEmpty":
    "Dieses Turnier ist nicht leer und kann so nicht gelöscht werden.",
  "hub.matchmixer.lifecycle.reschedule.title": "Termin verschieben",
  "hub.matchmixer.lifecycle.reschedule.body":
    "Neuer Termin für „{name}“. Planung und Anmeldungen bleiben erhalten.",
  "hub.matchmixer.lifecycle.reschedule.cta": "Termin speichern",
  "hub.matchmixer.lifecycle.reschedule.success":
    "Termin für „{name}“ wurde aktualisiert.",
  "hub.matchmixer.lifecycle.reschedule.error":
    "Termin konnte nicht gespeichert werden.",
  "hub.matchmixer.lifecycle.reschedule.missingDate": "Bitte ein Datum wählen.",
  "hub.matchmixer.lifecycle.replan.title": "Neu planen",
  "hub.matchmixer.lifecycle.replan.body":
    "Erstellt einen neuen geplanten Entwurf aus „{name}“ mit neuem Code. Das Original bleibt unverändert.",
  "hub.matchmixer.lifecycle.replan.cta": "Entwurf anlegen",
  "hub.matchmixer.lifecycle.replan.success":
    "Neuer Entwurf aus „{name}“ wurde angelegt.",
  "hub.matchmixer.lifecycle.replan.error":
    "Neuer Entwurf konnte nicht angelegt werden.",
  "hub.matchmixer.lifecycle.replan.missingDate":
    "Bitte ein Datum für den neuen Entwurf wählen.",
  "hub.matchmixer.lifecycle.motif.title": "Motiv wählen",
  "hub.matchmixer.lifecycle.motif.aria": "Turniermotiv auswählen",
  "hub.matchmixer.lifecycle.motif.cta": "Motiv speichern",
  "hub.matchmixer.lifecycle.motif.success": "Motiv für „{name}“ gespeichert.",
  "hub.matchmixer.lifecycle.motif.error":
    "Motiv konnte nicht gespeichert werden.",
  "hub.matchmixer.lifecycle.motif.modes.aria": "Motiv-Art wählen",
  "hub.matchmixer.lifecycle.motif.mode.catalog": "Vorlagen",
  "hub.matchmixer.lifecycle.motif.mode.custom": "Eigenes Bild",
  "hub.matchmixer.lifecycle.motif.mode.status": "Text-Status",
  "hub.matchmixer.lifecycle.motif.custom.upload": "Bild hochladen",
  "hub.matchmixer.lifecycle.motif.custom.camera": "Foto aufnehmen",
  "hub.matchmixer.lifecycle.motif.custom.hint":
    "Wähle ein Bild von deinem Gerät oder nimm ein Foto auf.",
  "hub.matchmixer.lifecycle.motif.custom.required":
    "Bitte zuerst ein Bild hochladen oder ein Foto aufnehmen.",
  "hub.matchmixer.lifecycle.motif.custom.tooLarge":
    "Das Bild ist zu groß (max. 2 MB nach Komprimierung).",
  "hub.matchmixer.lifecycle.motif.custom.invalidType":
    "Nur JPEG, PNG oder WebP sind erlaubt.",
  "hub.matchmixer.lifecycle.motif.custom.uploadError":
    "Bild konnte nicht hochgeladen werden.",
  "hub.matchmixer.lifecycle.motif.status.label": "Status-Text",
  "hub.matchmixer.lifecycle.motif.status.placeholder":
    "z. B. Freitagabend-Doppel",
  "hub.matchmixer.lifecycle.motif.status.required":
    "Bitte einen kurzen Status-Text eingeben.",
  "hub.matchmixer.lifecycle.motif.status.colors": "Hintergrundfarbe",
  "hub.matchmixer.lifecycle.motif.status.previewEmpty": "Dein Status…",
  "hub.matchmixer.lifecycle.motif.status.color.green": "Grün",
  "hub.matchmixer.lifecycle.motif.status.color.blue": "Blau",
  "hub.matchmixer.lifecycle.motif.status.color.teal": "Petrol",
  "hub.matchmixer.lifecycle.motif.status.color.slate": "Schiefer",
  "hub.matchmixer.lifecycle.motif.status.color.rose": "Rose",
  "hub.matchmixer.lifecycle.motif.status.color.amber": "Bernstein",
  "hub.matchmixer.lifecycle.motif.status.color.violet": "Violett",
  "hub.matchmixer.lifecycle.excludeStats.enabled":
    "„{name}“ wird aus der Statistik ausgeschlossen.",
  "hub.matchmixer.lifecycle.excludeStats.disabled":
    "„{name}“ fließt wieder in die Statistik ein.",
  "hub.matchmixer.lifecycle.excludeStats.error":
    "Statistik-Kennzeichnung konnte nicht gespeichert werden.",
  "hub.matchmixer.statistik.title.year": "Dein Tennisjahr {year}",
  "hub.matchmixer.statistik.title.generic": "Deine MatchMixer-Statistik",
  "hub.matchmixer.statistik.toInsights": "Zum Club-Überblick",
  "hub.matchmixer.statistik.subtitle":
    "Auswertung deiner gespielten Matches und organisierten Turniere.",
  "hub.matchmixer.statistik.back": "Zurück zu MatchMixer",
  "hub.matchmixer.statistik.tab.play": "Mein Spiel",
  "hub.matchmixer.statistik.tab.events": "Meine Veranstaltungen",
  "hub.matchmixer.statistik.filters.aria": "Statistik filtern",
  "hub.matchmixer.statistik.filter.period": "Zeitraum",
  "hub.matchmixer.statistik.filter.from": "Von",
  "hub.matchmixer.statistik.filter.to": "Bis",
  "hub.matchmixer.statistik.filter.format": "Format",
  "hub.matchmixer.statistik.filter.includeActive":
    "Laufende Turniere als vorläufige Daten einbeziehen",
  "hub.matchmixer.statistik.period.thisYear": "Dieses Jahr",
  "hub.matchmixer.statistik.period.lastYear": "Letztes Jahr",
  "hub.matchmixer.statistik.period.all": "Gesamter Zeitraum",
  "hub.matchmixer.statistik.period.custom": "Eigener Zeitraum",
  "hub.matchmixer.statistik.format.all": "Alle Formate",
  "hub.matchmixer.statistik.format.singles": "Einzel",
  "hub.matchmixer.statistik.format.doubles": "Doppel",
  "hub.matchmixer.statistik.format.fixedDoubles": "Festes Doppel",
  "hub.matchmixer.statistik.format.mixed": "Mixed-Publikum",
  "hub.matchmixer.statistik.error":
    "Statistik konnte nicht geladen werden ({reason}).",
  "hub.matchmixer.statistik.play.identityGap":
    "Für dich sind noch keine gespielten Matches zugeordnet.",
  "hub.matchmixer.statistik.play.identityGap.tech":
    "Technische Lücke: Persönliche Statistik braucht eine Anmeldung mit user_id und player_pid ({gap}). Organisator ohne Teilnahme erhält bewusst keine fremde Bilanz.",
  "hub.matchmixer.statistik.play.kpi.tournaments": "Gespielte Turniere",
  "hub.matchmixer.statistik.play.kpi.matches": "Gespielte Matches",
  "hub.matchmixer.statistik.play.kpi.wins": "Siege",
  "hub.matchmixer.statistik.play.kpi.losses": "Niederlagen",
  "hub.matchmixer.statistik.play.kpi.draws": "Unentschieden",
  "hub.matchmixer.statistik.play.kpi.partners": "Doppelpartner",
  "hub.matchmixer.statistik.play.balance.title": "Meine Matchbilanz",
  "hub.matchmixer.statistik.play.balance.summary":
    "{wins} Siege · {draws} Unentschieden · {losses} Niederlagen",
  "hub.matchmixer.statistik.play.balance.winRate":
    "Siegquote: {rate} (von {decided} Begegnungen mit Ergebnis)",
  "hub.matchmixer.statistik.play.balance.winRate.help":
    "Siegquote = Siege ÷ Begegnungen mit gültigem Ergebnis (Sieg, Niederlage oder Unentschieden). Begegnungen ohne verwertbares Ergebnis zählen nicht mit.",
  "hub.matchmixer.statistik.play.balance.withoutOutcome":
    "{count} Begegnungen ohne verwertbares Ergebnis (separat ausgewiesen).",
  "hub.matchmixer.statistik.play.partners.title": "Mit wem ich gespielt habe",
  "hub.matchmixer.statistik.play.partners.empty":
    "Noch keine Doppel-/Mixed-Partner in diesem Zeitraum.",
  "hub.matchmixer.statistik.play.partners.col.name": "Partner",
  "hub.matchmixer.statistik.play.partners.col.matches": "Matches",
  "hub.matchmixer.statistik.play.partners.col.wld": "S/U/N",
  "hub.matchmixer.statistik.play.recent.title": "Meine letzten Turniere",
  "hub.matchmixer.statistik.play.recent.empty":
    "Keine Turniere mit gespielten Matches in diesem Filter.",
  "hub.matchmixer.statistik.play.recent.meta":
    "{matches} Matches · Bilanz {wins}/{draws}/{losses}",
  "hub.matchmixer.statistik.play.recent.place": "Platz {place}",
  "hub.matchmixer.statistik.play.highlights.title": "Persönliche Highlights",
  "hub.matchmixer.statistik.play.highlight.partners":
    "Du hast mit {count} verschiedenen Doppelpartnern gespielt.",
  "hub.matchmixer.statistik.play.highlight.streak":
    "Dein längster Siegesserie: {count} Matches.",
  "hub.matchmixer.statistik.play.highlight.mostFrequent":
    "Am häufigsten zusammengespielt: {name} ({matches} Matches).",
  "hub.matchmixer.statistik.events.kpi.tournaments": "Durchgeführte Turniere",
  "hub.matchmixer.statistik.events.kpi.matches": "Gespielte Matches",
  "hub.matchmixer.statistik.events.kpi.participations": "Teilnahmen",
  "hub.matchmixer.statistik.events.kpi.participations.hint":
    "Summe der Teilnehmerplätze über alle Turniere",
  "hub.matchmixer.statistik.events.kpi.people": "Unterschiedliche Personen",
  "hub.matchmixer.statistik.events.kpi.people.hint":
    "Über Anmeldungen mit Benutzerkonto gezählt",
  "hub.matchmixer.statistik.events.kpi.people.unreliable":
    "Nicht zuverlässig: fehlende Benutzerverknüpfung bei Anmeldungen",
  "hub.matchmixer.statistik.events.activity.title": "Aktivität im Zeitraum",
  "hub.matchmixer.statistik.events.activity.empty":
    "Keine Aktivität im gewählten Zeitraum.",
  "hub.matchmixer.statistik.events.activity.focus":
    "Anzeige gefiltert auf {month}.",
  "hub.matchmixer.statistik.events.activity.clearFocus": "Filter aufheben",
  "hub.matchmixer.statistik.events.compare.title": "Turniervergleich",
  "hub.matchmixer.statistik.events.compare.empty":
    "Keine Turniere für diesen Filter.",
  "hub.matchmixer.statistik.events.compare.col.name": "Turnier",
  "hub.matchmixer.statistik.events.compare.col.date": "Datum",
  "hub.matchmixer.statistik.events.compare.col.status": "Status",
  "hub.matchmixer.statistik.events.compare.col.players": "Teilnehmer",
  "hub.matchmixer.statistik.events.compare.col.matches": "Matches",
  "hub.matchmixer.statistik.events.compare.col.rounds": "Runden",
  "hub.matchmixer.statistik.events.mix.title": "Qualität der Durchmischung",
  "hub.matchmixer.statistik.events.mix.empty":
    "Noch nicht genug Doppel-Daten für eine Durchmischungsauswertung.",
  "hub.matchmixer.statistik.events.mix.summary":
    "Einsätze {min}–{max} · Ø {partners} Partner · {repeats} wiederholte Partnerpaare",
  "hub.matchmixer.statistik.events.mix.noEntryExit":
    "Ein-/Ausstiege sind nicht erfasst – Aussagekraft eingeschränkt.",
  "hub.matchmixer.statistik.cta.results": "Ergebnisse ansehen",
  "hub.matchmixer.statistik.cta.evaluation": "Auswertung ansehen",
  "hub.matchmixer.statistik.badge.aborted": "Abgebrochen",
  "hub.matchmixer.statistik.excluded.hint":
    "{count} Turnier(e) sind als Test markiert und fließen nicht in die Auswertung ein.",
  "hub.matchmixer.motif.highfive": "High-Five",
  "hub.matchmixer.motif.abendplatz": "Abendplatz",
  "hub.matchmixer.motif.herbstplatz": "Herbstplatz",
  "hub.matchmixer.motif.winterhall": "Winterhalle",
  "hub.matchmixer.motif.nikolaus": "Nikolaus",
  "hub.matchmixer.motif.weihnachten": "Weihnachten",
  "hub.matchmixer.motif.halloween": "Halloween",
  "hub.matchmixer.motif.default": "Standard",
  "hub.matchmixer.notify.title": "Teilnehmer informieren",
  "hub.matchmixer.notify.hint":
    "Kein Versandkanal hinterlegt – Text kopieren und selbst versenden.",
  "hub.matchmixer.notify.copy": "Text kopieren",
  "hub.matchmixer.notify.copied": "Text in die Zwischenablage kopiert.",
  "hub.matchmixer.notify.copyError": "Kopieren fehlgeschlagen.",
  "hub.matchmixer.notify.linkLine": "\n\nAnmeldung: {link}",
  "hub.matchmixer.notify.text.cancelled":
    "Hallo,\n\ndas Turnier „{name}“ ({when}) wurde abgesagt.{linkLine}\n\nViele Grüße",
  "hub.matchmixer.notify.text.reschedule":
    "Hallo,\n\ndas Turnier „{name}“ findet neu am {when} statt.{linkLine}\n\nViele Grüße",
  "hub.matchmixer.primaryCta": "Neues MatchMixer-Turnier starten",
  "hub.matchmixer.primaryCtaHint":
    "Einzel, Doppel oder Mixed – in wenigen Minuten spielbereit",
  "hub.matchmixer.player.primaryCta": "Offene Turnier-Anmeldungen",
  "hub.matchmixer.player.primaryCtaHint":
    "Für laufende Anmeldungen als Spieler registrieren",
  "hub.matchmixer.actionOpenDesc":
    "Aus deiner Liste unten wählen oder per Turnier-Code öffnen",
  "hub.matchmixer.actionStatsDesc":
    "Vergangene Turniere und Ergebnisse einsehen",
  "hub.matchmixer.actionSettingsDesc": "Standardwerte und Vorlagen – demnächst",
  "hub.matchmixer.registration.promo.title": "Offene Turnier-Anmeldungen",
  "hub.matchmixer.registration.promo.multiple":
    "{count} Schleifchen-Turniere nehmen gerade Anmeldungen entgegen.",
  "hub.matchmixer.registration.promo.count": "{count} angemeldet",
  "hub.matchmixer.registration.promo.organizer": "Turnierveranstalter: {name}",
  "hub.matchmixer.registration.promo.ctaRegister": "Jetzt anmelden",
  "hub.matchmixer.registration.promo.ctaSetup": "Zum Setup",
  "hub.matchmixer.registration.promo.ctaAll": "Alle anzeigen",
  "hub.matchmixer.registration.list.title": "Offene Anmeldungen",
  "hub.matchmixer.registration.list.subtitle":
    "Vom Verein geplante Schleifchen-Turniere mit offener Registrierungsphase.",
  "hub.matchmixer.registration.list.back": "Zurück zum MatchMixer-Hub",
  "hub.matchmixer.registration.list.organizer": "Turnierveranstalter: {name}",
  "hub.matchmixer.registration.list.empty":
    "Aktuell gibt es keine offenen Anmeldungen in deinem Verein.",
  "hub.matchmixer.registration.list.error":
    "Die Liste konnte nicht geladen werden. Bitte später erneut versuchen.",
  "hub.matchmixer.registration.page.title": "Turnier-Anmeldung",
  "hub.matchmixer.registration.page.displayName": "Dein Name auf dem Spielplan",
  "hub.matchmixer.registration.page.organizer": "Turnierveranstalter: {name}",
  "hub.matchmixer.registration.page.participantNotice":
    "Als Teilnehmer kannst du dich nur im Anmeldezeitraum an- und abmelden. Einstellungen und Spielplan bearbeitet ausschließlich der Turnierveranstalter.",
  "hub.matchmixer.registration.page.registeredAs":
    "Du bist angemeldet als „{name}“.",
  "hub.matchmixer.registration.page.submit": "Anmelden",
  "hub.matchmixer.registration.page.unregister": "Abmelden",
  "hub.matchmixer.registration.page.organizerHint":
    "Du bist der Turnierveranstalter dieses Turniers. Hier melden sich andere Spieler an – du verwaltest Einstellungen und Spielplan im Setup.",
  "hub.matchmixer.registration.page.organizerCta": "Zum Turnier-Setup",
  "hub.matchmixer.registration.success.registered":
    "Anmeldung gespeichert. Der Veranstalter erstellt den Spielplan.",
  "hub.matchmixer.registration.success.unregistered": "Du wurdest abgemeldet.",
  "hub.matchmixer.registration.errors.notAuthenticated":
    "Bitte melde dich an, um dich für ein Turnier anzumelden.",
  "hub.matchmixer.registration.errors.clubOnly":
    "Diese Anmeldung ist nur für Mitglieder deines Vereins.",
  "hub.matchmixer.registration.errors.closed":
    "Die Anmeldung ist geschlossen oder die Frist ist abgelaufen.",
  "hub.matchmixer.registration.errors.notFound": "Turnier nicht gefunden.",
  "hub.matchmixer.registration.errors.organizerCannotUnregister":
    "Als Turnierveranstalter kannst du dich hier nicht abmelden.",
  "hub.matchmixer.registration.errors.missingCode":
    "Kein Turnier-Code angegeben.",
  "hub.matchmixer.registration.errors.setupState":
    "Anmeldung gespeichert, aber der Setup-Assistent konnte nicht vorbereitet werden.",
  "hub.matchmixer.registration.errors.generic":
    "Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
  "hub.matchmixer.registration.page.openCare": "Zum persönlichen Bereich",
  "hub.matchmixer.registration.errors.missingName":
    "Bitte deinen Namen eintragen.",
  "hub.matchmixer.care.title": "Dein MatchMixer",
  "hub.matchmixer.care.brand": "MatchMixer · Persönlicher Link",
  "hub.matchmixer.care.hello": "Hallo {name}",
  "hub.matchmixer.care.linkTitle": "Dein persönlicher Link",
  "hub.matchmixer.care.linkHint":
    "Diesen Link merken oder teilen – damit pflegst du deine Ergebnisse, ohne dich anzumelden.",
  "hub.matchmixer.care.waitingSchedule":
    "Du bist angemeldet. Sobald der Veranstalter den Spielplan erstellt, siehst du hier deine Spiele.",
  "hub.matchmixer.care.noMatches":
    "Für dich stehen aktuell keine Spiele im Plan.",
  "hub.matchmixer.care.matchesTitle": "Deine Spiele",
  "hub.matchmixer.care.scoreA": "Dein Team",
  "hub.matchmixer.care.scoreB": "Gegner",
  "hub.matchmixer.care.saved": "Ergebnis gespeichert.",
  "hub.matchmixer.care.resultSaved": "Eingetragen",
  "hub.matchmixer.care.errors.invalid":
    "Dieser persönliche Link ist ungültig oder abgelaufen.",
  "hub.matchmixer.care.errors.notInMatch":
    "Dieses Spiel gehört nicht zu deinem persönlichen Link.",
  "hub.matchmixer.care.errors.generic":
    "Speichern fehlgeschlagen. Bitte später erneut versuchen.",
  "matchmixer.registration.share.playersTitle": "Persönliche Links der Spieler",
  "matchmixer.registration.share.playersHint":
    "Jeden Link einzeln teilen – damit trägt die Person ihre Ergebnisse ein.",
  "matchmixer.registration.share.copyPlayer": "Link kopieren",
  "matchmixer.registration.share.emptyPlayers":
    "Noch keine Anmeldungen. Der Link oben ist für die Anmeldung.",
  "hub.schleifchen.actionsTitle": "Aktionen",
  "hub.schleifchen.actionNewDesc":
    "Neues Turnier starten – Einzel, Doppel oder Mixed (MatchMixer)",
  "hub.schleifchen.actionOpenDesc":
    "Turnier über Code oder aus der Liste öffnen",
  "hub.schleifchen.actionStatsDesc":
    "Vergangene Turniere analysieren und Spielerstatistiken einsehen",
  "hub.schleifchen.actionSettingsDesc":
    "Standardwerte und Turniervorlagen verwalten",
  "hub.trainerstunden.title": "TrainingsDesk",
  "hub.trainerstunden.subtitle":
    "Trainings buchen oder geben – je nach Rolle. Ein Modul, beide Perspektiven.",
  "hub.trainerstunden.locked.connectClub":
    "Verein verbinden, um Trainings zu buchen",
  "hub.trainerstunden.locked.activatePlayer":
    "Tippen, um als Spieler:in zu starten",
  "hub.trainer.title": "Trainer Studio",
  "hub.trainer.subtitle": "Übungen finden und Trainingseinheiten planen.",
  "hub.clubmeisterschaft.title": "ClubChamp",
  "hub.clubmeisterschaft.subtitle":
    "Turniere, Clubmeisterschaften, Cups und Wettbewerbe.",
  "hub.clubmeisterschaft.quickStart.tagline": "Planen · Spielen · Meistern",
  "hub.clubmeisterschaft.hero.aria": "ClubChamp starten",
  "hub.clubmeisterschaft.hero.title":
    "Clubmeisterschaften klar organisieren – von der Anmeldung bis zum Finale.",
  "hub.clubmeisterschaft.hero.subtitle":
    "Gruppen, K.O. und Zeiträume in einem Flow. Dein Verein behält den Überblick.",
  "hub.clubmeisterschaft.hero.cta": "Neue Clubmeisterschaft",
  "hub.clubmeisterschaft.secondary.aria": "Weitere Aktionen",
  "hub.clubmeisterschaft.secondary.stats": "Statistik",
  "hub.clubmeisterschaft.secondary.settings": "Einstellungen",
  "hub.clubmeisterschaft.footer.tagline":
    "ClubChamp – Clubmeisterschaften für Tennisvereine.",
  "hub.clubmeisterschaft.tournaments.title": "Deine Clubmeisterschaften",
  "hub.clubmeisterschaft.tournaments.filter.aria":
    "Turniere nach Status filtern",
  "hub.clubmeisterschaft.tournaments.filter.all": "Alle",
  "hub.clubmeisterschaft.tournaments.filter.active": "Aktiv",
  "hub.clubmeisterschaft.tournaments.filter.planned": "Geplant",
  "hub.clubmeisterschaft.tournaments.filter.finished": "Abgeschlossen",
  "hub.clubmeisterschaft.tournaments.filter.cancelled_aborted":
    "Abgesagt / Abgebrochen",
  "hub.clubmeisterschaft.tournaments.search.aria": "Turnier suchen",
  "hub.clubmeisterschaft.tournaments.search.placeholder":
    "Name oder Code suchen…",
  "hub.clubmeisterschaft.tournaments.archiveToggle": "Archiv anzeigen",
  "hub.clubmeisterschaft.tournaments.nameFallback.generic": "Clubmeisterschaft",
  "hub.clubmeisterschaft.tournaments.empty.all":
    "Noch keine Clubmeisterschaft. Starte oben eine neue.",
  "hub.clubmeisterschaft.tournaments.empty.active":
    "Gerade läuft keine Clubmeisterschaft.",
  "hub.clubmeisterschaft.tournaments.empty.planned":
    "Keine geplanten Clubmeisterschaften.",
  "hub.clubmeisterschaft.tournaments.empty.finished":
    "Keine abgeschlossenen Clubmeisterschaften.",
  "hub.clubmeisterschaft.tournaments.empty.cancelled_aborted":
    "Keine abgesagten Clubmeisterschaften.",
  "hub.clubmeisterschaft.tournaments.empty.archived": "Kein Archiv-Eintrag.",
  "hub.clubmeisterschaft.tournaments.cta.continue": "Weiter spielen",
  "hub.clubmeisterschaft.tournaments.cta.results": "Ergebnisse",
  "hub.clubmeisterschaft.tournaments.cta.open": "Öffnen",
  "hub.clubmeisterschaft.tournaments.cta.prepare": "Vorbereiten",
  "hub.clubmeisterschaft.active.status.planned": "Geplant",
  "hub.clubmeisterschaft.active.status.active": "Aktiv",
  "hub.clubmeisterschaft.active.status.finished": "Abgeschlossen",
  "hub.clubmeisterschaft.active.status.cancelled": "Abgesagt",
  "hub.clubmeisterschaft.active.status.aborted": "Abgebrochen",
  "hub.clubmeisterschaft.tournaments.players": "{count} Spieler",
  "club.simple.untitled": "Neue Clubmeisterschaft",
  "club.simple.backToOverview": "Zur Übersicht",
  "club.simple.next": "Weiter",
  "club.simple.steps.aria": "Vorbereitungsschritte",
  "club.simple.steps.day": "Turnier",
  "club.simple.steps.players": "Spieler",
  "club.simple.steps.flow": "Ablauf",
  "club.simple.day.title": "Was möchtest du ausrichten?",
  "club.simple.day.name": "Name",
  "club.simple.day.format": "Format",
  "club.simple.day.mode": "Turniermodus",
  "club.simple.day.formatAria": "Spielformat wählen",
  "club.simple.day.modeAria": "Turniermodus wählen",
  "club.simple.summary.aria": "Zusammenfassung",
  "club.simple.summary.title": "Deine Clubmeisterschaft",
  "club.simple.summary.players": "Teilnehmer",
  "club.simple.summary.mode": "Modus",
  "club.simple.finish.prepare": "Turnier vorbereiten",
  "club.simple.done": "Fertig",
  "club.simple.flow.title": "Ablauf festlegen",
  "club.simple.flow.hint":
    "Gruppen/K.O., Zeiträume und Regeln – danach kannst du den Spielplan erzeugen.",
  "hub.clubmeisterschaft.statistik.back": "Zur Clubmeisterschaft",
  "hub.clubmeisterschaft.statistik.title": "Clubmeisterschaft-Statistik",
  "hub.clubmeisterschaft.statistik.subtitle":
    "Laufende und beendete Turniere auf einen Blick.",
  "hub.clubmeisterschaft.statistik.toInsights": "Zum Club-Überblick",
  "hub.clubmeisterschaft.statistik.kpis.aria": "Kennzahlen",
  "hub.clubmeisterschaft.statistik.error":
    "Statistik konnte nicht geladen werden ({reason}).",
  "hub.clubmeisterschaft.statistik.empty":
    "Noch keine Clubmeisterschaft-Turniere vorhanden.",
  "hub.clubmeisterschaft.statistik.recent.title": "Zuletzt",
  "hub.clubmeisterschaft.statistik.status.running": "Laufend",
  "hub.clubmeisterschaft.statistik.status.finished": "Beendet",
  "hub.clubmeisterschaft.statistik.status.other": "Geplant",
  "hub.clubmeisterschaft.statistik.players": "{count} Spieler",
  "hub.medenspiele.title": "TeamDesk",
  "hub.medenspiele.subtitle":
    "Medenspiele und Mannschaftswettbewerbe organisieren.",
  "hub.belegung.title": "Belegung",
  "hub.belegung.subtitle":
    "Plätze buchen, Belegungsplan und Trainer-Blöcke verwalten.",
  "hub.kalender.title": "Kalender",
  "hub.kalender.subtitle":
    "Wer ist wann eingeplant – Serientermine, TrainingsDesk und später Turniere.",
  "hub.schedule.title": "Deine nächsten Termine",
  "hub.trainerConfirm.title": "Trainings bestätigen",
  "hub.trainerConfirm.kicker": "Noch unbestätigt",
  "hub.trainerConfirm.moreTitle": "Weitere unbestätigte",
  "hub.trainerConfirm.count": "{count} offen",
  "hub.trainerConfirm.countOne": "{count} offen",
  "hub.trainerConfirm.question": "Training hat stattgefunden?",
  "hub.trainerConfirm.questionDesk": "Anwesenheit im TrainingsDesk bestätigen.",
  "hub.trainerConfirm.attendanceQuestion": "Wer war anwesend?",
  "hub.trainerConfirm.attendanceHint":
    "Tippe auf Namen, die nicht da waren — dann bestätigen.",
  "hub.trainerConfirm.needSomeonePresent":
    "Mindestens eine Person muss anwesend sein.",
  "hub.trainerConfirm.confirmAttendance": "Bestätigen",
  "hub.trainerConfirm.openInDesk": "Im TrainingsDesk",
  "hub.trainerConfirm.yes": "Ja, bestätigen",
  "hub.trainerConfirm.yesShort": "Ja",
  "hub.trainerConfirm.openDesk": "Bestätigen",
  "hub.trainerConfirm.openShort": "Öffnen",
  "hub.trainerConfirm.no": "Nein…",
  "hub.trainerConfirm.reschedule": "Verschieben",
  "hub.trainerConfirm.rebook": "Neu terminieren",
  "hub.trainerConfirm.cancel": "Absagen",
  "hub.trainerConfirm.more": "Weitere {count} im TrainingsDesk",
  "hub.bookingRequestsPeek.title": "Buchungsanfragen",
  "hub.bookingRequestsPeek.summary": "{count} offen",
  "hub.bookingRequestsPeek.summaryOne": "{count} offen",
  "hub.bookingRequestsPeek.unnamed": "Anfrage",
  "hub.bookingRequestsPeek.kind.pending": "Neu",
  "hub.bookingRequestsPeek.kind.missed": "Läuft ab",
  "hub.bookingRequestsPeek.more": "Weitere {count} Anfragen öffnen",
  "hub.bookingRequestsPeek.openAll": "Alle Anfragen öffnen",
  "hub.schedule.open": "Kalender öffnen",
  "hub.schedule.all": "Alle Termine ansehen",
  "hub.schedule.empty": "Gerade steht nichts an.",
  "hub.schedule.emptyHint":
    "Sobald Trainings oder Serientermine feststehen, erscheinen sie hier.",
  "hub.schedule.today": "Heute",
  "hub.schedule.todayIndex": "Heute · {n}. Termin",
  "hub.schedule.tomorrow": "Morgen",
  "hub.schedule.untitled": "Termin",
  "hub.schedule.trainingFallback": "Training",
  "hub.schedule.durationMin": "{count} Min.",
  "hub.schedule.with": "mit {names}",
  "hub.schedule.companionsMore": "{names} + {count}\u00a0weitere",
  "hub.schedule.timeEmpty": "—",
  "hub.schedule.action.training": "Training öffnen",
  "hub.schedule.action.series": "Serie öffnen",
  "hub.schedule.action.open": "Termin öffnen",
  "hub.schedule.action.details": "Details ansehen",
  "hub.schedule.action.prepare": "Training vorbereiten",
  "hub.schedule.action.decline": "Abmelden",
  "hub.schedule.action.declineNamed": "{name} abmelden",
  "hub.schedule.action.declineConfirm": "Wirklich von diesem Termin abmelden?",
  "hub.schedule.action.declineConfirmNamed":
    "{name} wirklich von diesem Termin abmelden?",
  "hub.schedule.action.menu": "Weitere Aktionen",
  "hub.schedule.action.ics": "Kalenderdatei (.ics)",
  "hub.schedule.action.edit": "Einzeltermin bearbeiten",
  "hub.schedule.role.trainer": "Trainer",
  "hub.schedule.role.waitlist": "Auf der Warteliste",
  "hub.schedule.role.player": "Spieler",
  "hub.schedule.rsvp.planned": "Eingeplant",
  "hub.schedule.rsvp.yes": "Zugesagt",
  "hub.schedule.rsvp.no": "Abgesagt",
  "hub.schedule.declinedOne": "{name} abgesagt",
  "hub.schedule.declined": "{names} abgesagt",
  "hub.schedule.court": "Platz {n}",
  "hub.schedule.placeWithBookedCourt": "{place} · gebucht",
  "hub.schedule.range.aria": "Wie viele Termine zeigen",
  "hub.schedule.range.value": "{n} Termine",
  "hub.schedule.range.valueOne": "{n} Termin",
  "hub.schedule.range.countAria": "Die nächsten {n} Termine",
  "hub.schedule.status.live": "Läuft gerade",
  "hub.schedule.status.done": "Abgeschlossen",
  "hub.desk.yourTennis": "Dein Tennis",
  "hub.club.title": "Vereinsaktivitäten",
  "hub.insights.promo.title": "Club Insights",
  "hub.insights.promo.lead": "Kennzahlen über deine Apps im Überblick.",
  "hub.insights.subtitle":
    "KPIs über TrainingsDesk, MatchMixer und Clubmeisterschaft – aufrufbar und auswertbar.",
  "hub.apps.tagline.insights": "Zahlen sehen.\nBesser entscheiden.",
  "hub.insights.back": "Zur Startseite",
  "hub.insights.title": "Club Insights",
  "hub.insights.lead":
    "Querschnitt über TrainingsDesk, MatchMixer und Clubmeisterschaft.",
  "hub.insights.gate.title": "Club Insights freischalten",
  "hub.insights.gate.lead":
    "Club Insights ist ab dem Pro-Plan verfügbar – zusammen mit der Auswertung.",
  "hub.insights.error": "Insights konnten nicht geladen werden ({reason}).",
  "hub.insights.totals.aria": "Gesamtüberblick",
  "hub.insights.totals.sessionsToday": "Trainings heute",
  "hub.insights.totals.runningTournaments": "Laufende Turniere",
  "hub.insights.totals.openMatches": "Offene Matches",
  "hub.insights.totals.activePeople": "Aktive Personen",
  "hub.insights.section.open": "Details öffnen",
  "hub.insights.section.locked": "Pro erforderlich",
  "hub.insights.empty": "Keine Apps mit Auswertung freigeschaltet.",
  "hub.insights.detail.back": "Zu Club Insights",
  "hub.insights.detail.trainingsdesk.lead":
    "Vollständige TrainingsDesk-Auswertung in Club Insights.",
  "analytics.catalog.trainerstunden.title": "TrainingsDesk",
  "analytics.catalog.trainerstunden.kpi.sessions": "Trainings heute",
  "analytics.catalog.trainerstunden.kpi.openBilling": "Offene Abrechnungen",
  "analytics.catalog.trainerstunden.kpi.activePeople": "Aktive Personen",
  "analytics.catalog.matchmixer.title": "MatchMixer",
  "analytics.catalog.matchmixer.kpi.running": "Laufende Turniere",
  "analytics.catalog.matchmixer.kpi.activePlayers": "Aktive Spieler",
  "analytics.catalog.matchmixer.kpi.openMatches": "Offene Matches",
  "analytics.catalog.clubmeisterschaft.title": "Clubmeisterschaft",
  "analytics.catalog.clubmeisterschaft.kpi.running": "Laufende Turniere",
  "analytics.catalog.clubmeisterschaft.kpi.finished": "Beendete Turniere",
  "analytics.catalog.clubmeisterschaft.kpi.players": "Spieler in aktiven",
  "hub.impulse.title": "Übung der Woche",
  "hub.impulse.open": "Übung öffnen",
  "hub.tour.title": "Auf der Tour",
  "hub.tour.asOf": "Spielstand von {time} Uhr",
  "hub.tour.updatedAt": "Letzter bekannter Spielstand {time} Uhr",
  "hub.tour.standToday": "Stand heute, {time} Uhr",
  "hub.tour.standDate": "Stand {date}, {time} Uhr",
  "hub.tour.staleNotice": "Aktuell sind keine frischen Spielstände verfügbar.",
  "hub.tour.filterAria": "Tour filtern",
  "hub.tour.viewAria": "Touransicht",
  "hub.tour.view.matches": "Matches",
  "hub.tour.view.tournaments": "Turniere",
  "hub.tour.filter.all": "Alle",
  "hub.tour.filter.atp": "ATP",
  "hub.tour.filter.wta": "WTA",
  "hub.tour.filter.favorites": "Favoriten",
  "hub.tour.search": "Spieler suchen",
  "hub.tour.editFavorites": "Favoriten bearbeiten",
  "hub.tour.favoritesTitle": "Favoriten",
  "hub.tour.favoritesPrompt": "Wessen Matches möchtest du verfolgen?",
  "hub.tour.pickPlayers": "Spieler auswählen",
  "hub.tour.favoritesNoMatches":
    "Für deine Favoriten sind aktuell keine Matches angesetzt.",
  "hub.tour.showAllMatches": "Alle Matches ansehen",
  "hub.tour.favoritesEmpty":
    "Markiere Spieler, um ihre nächsten Partien hier zu sehen.",
  "hub.tour.empty": "Gerade keine laufenden oder kommenden Partien.",
  "hub.tour.tournamentsEmpty": "Keine aktuellen Turniere in den Matchdaten.",
  "hub.tour.staleEmpty":
    "Aktuell keine neuen Daten. Es bleibt der letzte bekannte Stand.",
  "hub.tour.configMissing":
    "Tourdaten sind vorbereitet, der API-Schlüssel fehlt noch auf dem Server.",
  "hub.tour.unavailable":
    "Tourdaten sind gerade nicht erreichbar. Deine Termine bleiben verfügbar.",
  "hub.tour.cachedNote": "Anzeige aus dem gemeinsamen Cache, kein Live-Ticker.",
  "hub.tour.untitled": "Turnier",
  "hub.tour.vs": "gegen",
  "hub.tour.timeOpen": "Zeit noch offen",
  "hub.tour.status.live": "Laufend",
  "hub.tour.status.stale": "Stand veraltet",
  "hub.tour.scoreHint": "Stand der letzten Aktualisierung",
  "hub.tour.details": "Details",
  "hub.tour.round": "Runde {round}",
  "hub.tour.indoor": "Halle",
  "hub.tour.starPlayer": "{name} merken",
  "hub.tour.unstarPlayer": "{name} nicht mehr merken",
  "hub.tour.starEvent": "Turnier merken",
  "hub.tour.unstarEvent": "Turnier nicht mehr merken",
  "hub.tour.surface.clay": "Sand",
  "hub.tour.surface.grass": "Rasen",
  "hub.tour.surface.hard": "Hartplatz",
  "hub.tour.more": "Mehr anzeigen",
  "hub.tour.back": "Zur Startseite",
  "hub.tour.calendar.tab": "Turnierkalender",
  "hub.tour.calendar.title": "Turnierkalender",
  "hub.tour.calendar.open": "Turnierkalender öffnen",
  "hub.tour.calendar.hint":
    "Unabhängiger Kalenderausblick von tennis-calendar.com, nicht gefiltert nach ATP oder WTA.",
  "hub.tour.calendar.filterNote":
    "Dieser Kalender kommt von tennis-calendar.com und folgt nicht dem ATP-/WTA-Filter.",
  "hub.tour.calendar.iframeTitle": "Turnierkalender (tennis-calendar.com)",
  "hub.tour.calendar.source": "Quelle: tennis-calendar.com",
  "hub.tour.nextEvent.title": "Turnierkalender",
  "hub.tour.nextEvent.hint":
    "Unabhängiger Kalenderausblick von tennis-calendar.com.",
  "hub.tour.nextEvent.iframeTitle": "Turnierkalender (tennis-calendar.com)",
  "hub.tour.nextEvent.source": "Quelle: tennis-calendar.com",
  "hub.overdueBills.title": "Überfällige Rechnungen",
  "hub.overdueBills.summary": "{count} offen · {amount}",
  "hub.overdueBills.recipients": "{count} Schuldner",
  "hub.overdueBills.unnamed": "Unbekannt",
  "hub.overdueBills.age.one": "seit {count} Tag",
  "hub.overdueBills.age.other": "seit {count} Tagen",
  "hub.overdueBills.invoices": "{count} Rechnungen",
  "hub.overdueBills.more": "Weitere {count} Schuldner ansehen",
  "hub.overdueBills.openAll": "Alle überfälligen öffnen",
  "hub.overdueBills.openRow": "Öffnen",
  "hub.overdueBills.ctaAbrechnung": "Zur Abrechnung",
  "hub.attention.title": "Handlungsbedarf",
  "hub.attention.view": "Ansehen",
  "hub.attention.rsvp.title": "Fehlende Rückmeldungen",
  "hub.attention.rsvp.body":
    "{count} kommender Termin wartet auf deine Zusage.",
  "hub.attention.rsvp.body_plural":
    "{count} kommende Termine warten auf deine Zusage.",
  "hub.attention.rsvp.action": "Rückmeldung geben",
  "hub.attention.rsvp.compact": "{count} Rückmeldung offen",
  "hub.attention.rsvp.compact_plural": "{count} Rückmeldungen offen",
  "hub.attention.booking.title": "Nachrücker-Anfragen",
  "hub.attention.booking.body": "{count} Anfrage wartet auf dich.",
  "hub.attention.booking.body_plural": "{count} Anfragen warten auf dich.",
  "hub.attention.booking.action": "Anfragen prüfen",
  "hub.attention.booking.compact": "{count} Nachrücker-Anfrage",
  "hub.attention.booking.compact_plural": "{count} Nachrücker-Anfragen",
  "hub.attention.overdue.title": "Überfällige Rechnungen",
  "hub.attention.overdue.body": "{count} Rechnung ist überfällig.",
  "hub.attention.overdue.body_plural": "{count} Rechnungen sind überfällig.",
  "hub.attention.overdue.action": "Überfällige ansehen",
  "hub.attention.overdue.compact": "{count} Rechnung überfällig",
  "hub.attention.overdue.compact_plural": "{count} Rechnungen überfällig",
  "hub.attention.openBills.title": "Offene Rechnungen",
  "hub.attention.openBills.body": "{count} Rechnung wartet auf Zahlung.",
  "hub.attention.openBills.body_plural":
    "{count} Rechnungen warten auf Zahlung.",
  "hub.attention.openBills.action": "Zahlungen öffnen",
  "hub.attention.openBills.compact": "{count} Rechnung offen",
  "hub.attention.openBills.compact_plural": "{count} Rechnungen offen",
  "hub.attention.parentOverdue.title": "Überfällige Rechnungen",
  "hub.attention.parentOverdue.body": "{count} Rechnung ist überfällig.",
  "hub.attention.parentOverdue.body_plural":
    "{count} Rechnungen sind überfällig.",
  "hub.attention.parentOverdue.action": "Rechnungen öffnen",
  "hub.attention.parentOverdue.compact": "{count} Rechnung überfällig",
  "hub.attention.parentOverdue.compact_plural": "{count} Rechnungen überfällig",
  "hub.attention.parentOpen.title": "Offene Rechnungen",
  "hub.attention.parentOpen.body": "{count} Rechnung ist noch offen.",
  "hub.attention.parentOpen.body_plural": "{count} Rechnungen sind noch offen.",
  "hub.attention.parentOpen.action": "Rechnungen öffnen",
  "hub.attention.parentOpen.compact": "{count} Rechnung offen",
  "hub.attention.parentOpen.compact_plural": "{count} Rechnungen offen",
  "hub.attention.tennisBank.compact": "{count} neuer tennisrelevanter Umsatz",
  "hub.attention.tennisBank.compact_plural":
    "{count} neue tennisrelevante Umsätze",
  "hub.attention.tennisBank.inOne": "1 Eingang · {amount}",
  "hub.attention.tennisBank.inMany": "{count} Eingänge · {amount}",
  "hub.attention.tennisBank.outOne": "1 Ausgabe · {amount}",
  "hub.attention.tennisBank.outMany": "{count} Ausgaben · {amount}",
  "hub.attention.tennisBank.action": "Umsätze prüfen",
  "hub.attention.tennisBank.refresh": "Jetzt prüfen",
  "hub.attention.tennisBank.checkedAt": "Zuletzt geprüft {time}",
  "hub.attention.tennisBank.checkError": "Umsätze konnten nicht geprüft werden",
  "trainerstunden.bank.relevance.filterHint":
    "Nur neue tennisrelevante Treffer. Gesehen heißt nicht bestätigt.",
  "trainerstunden.bank.relevance.statusAssigned": "Zugeordnet",
  "trainerstunden.bank.relevance.statusReview":
    "Tennisbezug erkannt · Bitte prüfen",
  "trainerstunden.bank.relevance.dismiss": "Nicht tennisrelevant",
  "trainerstunden.bank.relevance.alwaysParty":
    "Diesen Zahlungsempfänger immer als tennisrelevant erkennen",
  "trainerstunden.bank.relevance.reason.invoice_reference":
    "Rechnungsreferenz erkannt",
  "trainerstunden.bank.relevance.reason.invoice_assigned":
    "Rechnung zugeordnet",
  "trainerstunden.bank.relevance.reason.merchant_tennis_point":
    "Tennis-Point als Händler erkannt",
  "trainerstunden.bank.relevance.reason.purpose_hall":
    "Tennishalle im Verwendungszweck",
  "trainerstunden.bank.relevance.reason.purpose_training":
    "Tennistraining im Verwendungszweck",
  "trainerstunden.bank.relevance.reason.purpose_tennis":
    "Tennis im Verwendungszweck",
  "trainerstunden.bank.relevance.reason.purpose_court_fee":
    "Platzgebühr im Verwendungszweck",
  "trainerstunden.bank.relevance.reason.club_counterparty":
    "Tennisverein als Gegenpartei erkannt",
  "trainerstunden.bank.relevance.reason.party_rule":
    "Von dir als tennisrelevant gespeichert",
  "trainerstunden.bank.relevance.reason.learned_expense":
    "Ähnlich zu deinen bisher erfassten Tennisausgaben",
  "hub.winterdoppel.title": "Serientermine",
  "hub.winterdoppel.subtitle":
    "Wiederkehrende Termine planen, Verfügbarkeit und Wochen-Check-in.",
  "winterdoppel.title": "Serientermine",
  "winterdoppel.tenant": "Verein",
  "kalender.title": "Kalender",
  "kalender.tenant": "Verein",
  "kalender.view.aria": "Kalenderansicht",
  "kalender.view.day": "Tag",
  "kalender.view.threeDay": "3 Tage",
  "kalender.view.week": "Woche",
  "kalender.view.month": "Monat",
  "kalender.view.year": "Jahr",
  "kalender.view.today": "Heute",
  "kalender.view.more": "Mehr",
  "kalender.nav.prev": "Vorheriger Zeitraum",
  "kalender.nav.next": "Nächster Zeitraum",
  "kalender.layout.aria": "Darstellung",
  "kalender.layout.overlay": "Überlagert",
  "kalender.layout.side": "Nebeneinander",
  "kalender.layout.sideDisabled":
    "Nebeneinander ist in Monat und Jahr nicht verfügbar.",
  "kalender.panel.toggle": "Personenpanel ein- oder ausklappen",
  "kalender.people.aria": "Personenkalender",
  "kalender.people.searchPlaceholder": "Person hinzufügen …",
  "kalender.people.me": "Ich",
  "kalender.people.onlyMe": "Nur ich",
  "kalender.people.player": "Spieler",
  "kalender.people.needMatch":
    "Keine automatische Personenzuordnung. Bitte dich über die Suche hinzufügen.",
  "kalender.people.mobile": "Personen ({{count}})",
  "kalender.create.short": "+ Termin",
  "kalender.create.aria": "Neuen Trainingstermin anlegen",
  "kalender.miniMonth.prev": "Vorheriger Monat",
  "kalender.miniMonth.next": "Nächster Monat",
  "kalender.miniMonth.dayWithEvents": "{day}, mit Terminen",
  "kalender.event.shared": "Gemeinsamer Termin",
  "kalender.hint.conflict": "{{name}}: Überschneidung {{range}}",
  "kalender.hint.adjacency": "{{name}}: direkter Anschluss um {{time}}",
  "kalender.hint.conflictAria": "Überschneidung",
  "kalender.hint.conflictsSummary": {
    one: "1 Überschneidung",
    other: "{count} Überschneidungen",
  },
  "kalender.hint.adjacenciesSummary": {
    one: "1 direkter Anschluss",
    other: "{count} direkte Anschlüsse",
  },
  "kalender.types.label": "Terminarten",
  "kalender.types.all": "Alle Terminarten",
  "kalender.types.training": "Training",
  "kalender.types.regeltermine": "Serientermine",
  "kalender.types.einzeltermine": "Einzeltermine",
  "kalender.types.reset": "Alle Terminarten anzeigen",
  "kalender.tone.training": "Training",
  "kalender.tone.free": "Freies Training",
  "kalender.tone.einzel": "Einzeltermin",
  "kalender.tone.waitlist": "Warteliste",
  "kalender.tone.trainingMark": "Tr",
  "kalender.tone.freeMark": "Frei",
  "kalender.tone.einzelMark": "E",
  "kalender.tone.waitlistMark": "W",
  "kalender.tone.legend":
    "Farbe = Person · Tr = Training · Frei (gestreift) = Freies Training · E = Einzeltermin",
  "winterdoppel.results.title": "Ergebnisse",
  "winterdoppel.results.lead":
    "Sätze eintragen – auch wenn ein Satz nicht zu Ende gespielt wurde. Bei Bedarf die tatsächliche Paarung anpassen.",
  "winterdoppel.results.court": "Platz {{n}}",
  "winterdoppel.results.sideA": "Seite A",
  "winterdoppel.results.sideB": "Seite B",
  "winterdoppel.results.playerN": "Spieler {{n}}",
  "winterdoppel.results.vs": "gegen",
  "winterdoppel.results.set": "Satz {{n}}",
  "winterdoppel.results.setComplete": "Satz beendet",
  "winterdoppel.results.setIncomplete": "Abgebrochen (Stand speichern)",
  "winterdoppel.results.addSet": "Satz hinzufügen",
  "winterdoppel.results.removeSet": "Satz entfernen",
  "winterdoppel.results.save": "Ergebnis speichern",
  "winterdoppel.results.saved": "Ergebnis gespeichert",
  "winterdoppel.results.emptySession":
    "Für diesen Termin gibt es noch keine Platzeinteilung.",
  "winterdoppel.results.noSessions":
    "Noch keine vergangenen Termine zum Eintragen.",
  "winterdoppel.results.playerPlaceholder": "Spieler wählen",
  "winterdoppel.results.winnerA": "Gewinner: Seite A",
  "winterdoppel.results.winnerB": "Gewinner: Seite B",
  "winterdoppel.results.winnerOpen":
    "Kein Match-Gewinner (offen / abgebrochen)",
  "winterdoppel.results.error.token":
    "Link ungültig – bitte Self-Care-Link erneut öffnen.",
  "winterdoppel.results.error.forbidden":
    "Keine Berechtigung für dieses Ergebnis.",
  "winterdoppel.results.error.notOnCourt":
    "Nur Spieler dieses Platzes oder Planer können das Ergebnis speichern.",
  "winterdoppel.results.error.future":
    "Ergebnisse erst ab dem Terminabend möglich.",
  "winterdoppel.results.error.sides":
    "Paarung ungültig – bitte Spieler der Session wählen.",
  "winterdoppel.results.error.notFound": "Termin nicht gefunden.",
  "winterdoppel.results.error.generic":
    "Ergebnis konnte nicht gespeichert werden.",
  "kalender.bridge.planningFiltersPartial":
    "Suche und Status aus der Trainingsliste werden im Kalender nicht übernommen.",
  "kalender.detail.when": "Zeit",
  "kalender.detail.place": "Ort",
  "kalender.detail.source": "Quelle",
  "kalender.detail.person": "Person",
  "kalender.detail.participants": "Teilnehmer",
  "kalender.detail.status": "Status",
  "kalender.detail.conflict": "Überschneidung mit anderem Termin",
  "kalender.detail.open": "Termin öffnen",
  "winterdoppel.seriesSelect": "Serie",
  "winterdoppel.seriesSelectPlaceholder": "Serie wählen …",
  "winterdoppel.nav.aria": "Serientermine Navigation",
  "winterdoppel.nav.level.main": "Bereich",
  "winterdoppel.nav.closeSheet": "Schließen",
  "winterdoppel.nav.overview": "Übersicht",
  "winterdoppel.nav.occupancy": "Personenplan",
  "winterdoppel.occupancy.title": "Wer ist wann eingeplant?",
  "winterdoppel.occupancy.hint":
    "Namen eintippen und Personen auswählen – du siehst ihre Serientermine über alle Serien (auch als Trainer), wer sonst dabei ist, und zusätzlich Einzeltermine aus dem TrainingsDesk.",
  "winterdoppel.occupancy.search": "Person suchen",
  "winterdoppel.occupancy.searchPlaceholder": "Vor- und Nachname eingeben…",
  "winterdoppel.occupancy.searchMore": "Weitere Person…",
  "winterdoppel.occupancy.includePast": "Vergangene Termine anzeigen",
  "winterdoppel.occupancy.people": "Personen",
  "winterdoppel.occupancy.peopleEmpty": "Keine Person passt zur Suche.",
  "winterdoppel.occupancy.needPeople":
    "Namen eintippen und eine Person auswählen – oder „Nur ich“ für deinen Kalender.",
  "winterdoppel.occupancy.kind.trainer": "Trainer",
  "winterdoppel.occupancy.removePerson": "{{name}} entfernen",
  "winterdoppel.occupancy.asTrainer": "Als Trainer",
  "winterdoppel.occupancy.role.starter": "Dabei",
  "winterdoppel.occupancy.role.reserve": "Ersatz / Warteliste",
  "winterdoppel.occupancy.role.reserveRank":
    "Ersatz / Warteliste · Pos. {{rank}}",
  "winterdoppel.occupancy.nickname.add": "Spitzname merken",
  "winterdoppel.occupancy.nickname.placeholder": "Spitzname…",
  "winterdoppel.occupancy.nickname.remove": "Spitzname {{name}} entfernen",
  "winterdoppel.occupancy.nickname.belongsTo":
    "{{alias}} gehört zu {{canonical}}",
  "winterdoppel.occupancy.nickname.link": "Als Spitzname merken",
  "winterdoppel.occupancy.nickname.swap": "Zuordnung tauschen",
  "winterdoppel.occupancy.nickname.saved": "Spitzname",
  "winterdoppel.occupancy.empty": "Keine Termine für die Auswahl.",
  "winterdoppel.occupancy.together": "Gemeinsamer Tag",
  "winterdoppel.occupancy.source.regel": "Regeltermin",
  "winterdoppel.occupancy.source.einzel": "Einzeltermin",
  "winterdoppel.occupancy.mode.free": "Freies Training",
  "winterdoppel.occupancy.mode.training": "Training mit Trainer",
  "winterdoppel.occupancy.mode.einzel": "Einzel / TrainingsDesk",
  "winterdoppel.occupancy.companions": "Mit dabei: {{names}}",
  "winterdoppel.occupancy.companionsNone":
    "Keine weiteren Mitspieler hinterlegt.",
  "winterdoppel.occupancy.openSeries": "Serie öffnen",
  "winterdoppel.occupancy.week": "KW {{week}}",
  "winterdoppel.occupancy.create.open": "Einzeltermin hinzufügen",
  "winterdoppel.occupancy.create.title": "Neuer Einzeltermin",
  "winterdoppel.occupancy.create.date": "Datum",
  "winterdoppel.occupancy.create.time": "Uhrzeit",
  "winterdoppel.occupancy.create.duration": "Dauer (Min.)",
  "winterdoppel.occupancy.create.trainer": "Trainer",
  "winterdoppel.occupancy.create.trainerNone": "Ohne Trainer",
  "winterdoppel.occupancy.create.name": "Bezeichnung",
  "winterdoppel.occupancy.create.defaultTitle": "Einzeltermin",
  "winterdoppel.occupancy.create.save": "Termin anlegen",
  "winterdoppel.occupancy.create.cancel": "Abbrechen",
  "winterdoppel.nav.settings": "Einstellungen",
  "winterdoppel.nav.editSeries": "Serie bearbeiten",
  "winterdoppel.nav.participants": "Teilnehmer",
  "winterdoppel.nav.seasonPlanning": "Saisonplanung",
  "winterdoppel.nav.rahmenplan": "Rahmenplan",
  "winterdoppel.nav.sessions": "Termine",
  "winterdoppel.nav.evaluation": "Auswertung",
  "winterdoppel.nav.series": "Serie",
  "winterdoppel.nav.players": "Teilnehmer",
  "winterdoppel.nav.lineup": "Planungsregeln",
  "winterdoppel.series.mode": "Spielmodus",
  "winterdoppel.series.mode.free": "Freies Spiel",
  "winterdoppel.series.mode.training": "Training",
  "winterdoppel.series.modeHint.free":
    "Aufstellung: Doppel-Partnerwünsche (2er-Paare).",
  "winterdoppel.series.modeHint.training":
    "Aufstellung: flexible Trainingsgruppen (2er, 3er, 4er, …) und Kostenprognose je Rechnungsempfänger.",
  "winterdoppel.series.fairnessMode": "Fairness (Grobplanung & Warteliste)",
  "winterdoppel.series.fairnessMode.proportional": "Prozentual",
  "winterdoppel.series.fairnessMode.equal_load": "Gleiche Belastung",
  "winterdoppel.series.fairnessModeHint.proportional":
    "Wer relativ zu seiner Verfügbarkeit seltener eingeplant ist, kommt zuerst – auch bei der Warteliste nach Absagen.",
  "winterdoppel.series.fairnessModeHint.equal_load":
    "Wer bisher am wenigsten gespielt hat, kommt zuerst – an jedem Termin, an dem er kann. Weniger verfügbare Spieler spielen damit nicht „künstlich“ gleich oft, holen aber nach, sobald sie da sind.",
  "winterdoppel.series.notifyCancelTitle": "Absage-Benachrichtigung",
  "winterdoppel.series.notifyCancelHint":
    "Optional: Bei Absage über den persönlichen Link werden gewählte Adressen informiert.",
  "winterdoppel.series.notifyCancelEnabled": "Absage-Benachrichtigung nutzen",
  "winterdoppel.series.notifyCancelEmails": "E-Mail-Empfänger",
  "winterdoppel.series.notifyCancelEmailsPlaceholder":
    "eine Adresse pro Zeile oder kommagetrennt",
  "winterdoppel.series.notifyCancelCount":
    "{{count}} Empfänger werden benachrichtigt.",
  "winterdoppel.lineup.hintFree":
    "Partnerwünsche für Doppel – optional, bevor der Plan erzeugt wird.",
  "winterdoppel.lineup.hintTraining":
    "Feste Spielgruppen (beliebige Größe ab 2) – möglichst gemeinsam einplanen, bevor der Plan erzeugt wird.",
  "winterdoppel.lineup.hintTrainingPublished":
    "Nach Veröffentlichung: Spieler in der Gruppe tauschen oder die Wochen einmalig/ab jetzt tauschen. Einzelne Termine änderst du im Saisonplan.",
  "winterdoppel.lineup.hint":
    "Partnerwünsche und feste Trainingsgruppen – optional, bevor der Plan erzeugt wird.",
  "winterdoppel.costs.forecastTitle": "Prognose je Rechnungsempfänger",
  "winterdoppel.costs.forecastHint":
    "Auf Basis der aktuellen Planung und Stammdaten (Rechnungsempfänger).",
  "winterdoppel.costs.forecastHintEstimated":
    "Noch ohne fertige Kostenanteile: grobe Aufteilung des Zeitraum-Gesamtbetrags auf die Spieler, gruppiert nach Rechnungsempfänger.",
  "winterdoppel.costs.forecastSummary":
    "Zeitraum {{period}} · Termin {{evening}} · {{count}} Termine",
  "winterdoppel.costs.forecastEmpty":
    "Keine Prognose möglich – bitte Spieler hinzufügen.",
  "winterdoppel.costs.trainerTitle": "Trainingskosten (Trainer)",
  "winterdoppel.costs.trainerHint":
    "Honorar je Gruppe aus Stundensatz × Dauer × Gruppentermine, gleichmäßig auf Mitglieder.",
  "winterdoppel.costs.trainerSummary":
    "Training {{trainer}} · Halle {{hall}} · gesamt {{grand}}",
  "winterdoppel.costs.colGroup": "Gruppe",
  "winterdoppel.costs.colTrainer": "Trainer",
  "winterdoppel.costs.colSessions": "Termine",
  "winterdoppel.costs.colHallShare": "Halle",
  "winterdoppel.costs.colTrainerShare": "Trainer",
  "winterdoppel.costs.colRecipient": "Rechnungsempfänger",
  "winterdoppel.costs.colPlayers": "Spieler",
  "winterdoppel.nav.plan": "Saisonplan",
  "winterdoppel.nav.week": "Termine",
  "winterdoppel.nav.fairness": "Fairness",
  "winterdoppel.nav.costs": "Kosten & Abrechnung",
  "winterdoppel.seasonStatus.preparing": "In Vorbereitung",
  "winterdoppel.seasonStatus.published": "Veröffentlicht",
  "winterdoppel.seasonStatus.archived": "Archiviert",
  "winterdoppel.sessionStatus.notPublished": "Noch nicht veröffentlicht",
  "winterdoppel.sessionStatus.rsvpRunning": "Rückmeldung läuft",
  "winterdoppel.sessionStatus.confirmed": "Bestätigt",
  "winterdoppel.sessionStatus.cancelled": "Abgesagt",
  "winterdoppel.sessionStatus.completed": "Abgeschlossen",
  "winterdoppel.seasonPlanning.tabsAria": "Saisonplanung Bereiche",
  "winterdoppel.seasonPlanning.tabGroups": "Gruppen",
  "winterdoppel.seasonPlanning.tabPlan": "Saisonplan",
  "winterdoppel.rahmenplan.needSeries": "Bitte zuerst eine Serie wählen.",
  "winterdoppel.rahmenplan.hint":
    "Pädagogischer Winter-Rahmenplan: Schwerpunkte je Termin und Spielerbeurteilung. Unterrichtspläne aus dem TrainerStudio kannst du unten je Termin verknüpfen.",
  "winterdoppel.rahmenplan.templateLabel": "Rahmenplan-Vorlage",
  "winterdoppel.rahmenplan.applyTemplate": "Vorlage in Matrix übernehmen",
  "winterdoppel.rahmenplan.overwriteConfirm":
    "{{count}} angepasste Zellen würden überschrieben. Der aktuelle Stand wird im Audit-Trail gespeichert und kann wiederhergestellt werden. Trotzdem Vorlage übernehmen?",
  "winterdoppel.rahmenplan.fillEmptyConfirm":
    "Überschreiben abgebrochen. {{count}} leere Zellen trotzdem aus der Vorlage füllen?",
  "winterdoppel.rahmenplan.restoreConfirm":
    "Diesen Stand wiederherstellen? Der aktuelle Stand wird vorher im Audit-Trail gesichert.",
  "winterdoppel.rahmenplan.auditTitle": "Audit-Trail",
  "winterdoppel.rahmenplan.auditHint":
    "Gesicherte Stände vor dem Überschreiben durch Vorlagen oder vor einer Wiederherstellung.",
  "winterdoppel.rahmenplan.auditEmpty":
    "Noch keine Snapshots – erscheinen beim Überschreiben einer Vorlage.",
  "winterdoppel.rahmenplan.restore": "Wiederherstellen",
  "winterdoppel.rahmenplan.studioHint":
    "Vorlagen anlegen und bearbeiten im TrainerStudio (Menü „Rahmenplan“). Unterrichtspläne je Termin verknüpfst du in der Matrix-Zeile darunter.",
  "winterdoppel.rahmenplan.openTrainerStudio": "Vorlagen im TrainerStudio",
  "winterdoppel.rahmenplan.template.u12_medenspiel": "U12 Medenspiel (Winter)",
  "winterdoppel.rahmenplan.template.u12_medenspielDesc":
    "20 Termine bis zum Medenspiel-Check Ende Januar inkl. Meldeschluss.",
  "winterdoppel.rahmenplan.applyU12Template": "U12-Medenspiel-Vorlage laden",
  "winterdoppel.rahmenplan.publishOnSchedule":
    "Auf der öffentlichen Terminübersicht veröffentlichen",
  "winterdoppel.rahmenplan.publishOnScheduleHint":
    "Nur die Matrix (Schwerpunkte) – ohne Spielerbeurteilung.",
  "winterdoppel.rahmenplan.openSchedule": "Öffentliche Seite öffnen",
  "winterdoppel.rahmenplan.loading": "Rahmenplan wird geladen …",
  "winterdoppel.rahmenplan.colFocus": "Fokus",
  "winterdoppel.rahmenplan.colLessonPlan": "TrainerStudio",
  "winterdoppel.rahmenplan.lessonPlanNone": "Kein Unterrichtsplan",
  "winterdoppel.rahmenplan.lessonPlanAria": "Unterrichtsplan für {{date}}",
  "winterdoppel.rahmenplan.openLessonPlan": "Im TrainerStudio öffnen",
  "winterdoppel.rahmenplan.emptyCell": "—",
  "winterdoppel.rahmenplan.save": "Speichern",
  "winterdoppel.rahmenplan.cancel": "Abbrechen",
  "winterdoppel.rahmenplan.assessmentTitle": "Spielerbeurteilung",
  "winterdoppel.rahmenplan.assessmentHint":
    "Gesamtstand (sicher / teilweise / noch nicht) – Baseline, Zwischenstand und Medenspiel-Check.",
  "winterdoppel.rahmenplan.noPlayers": "Noch keine Spieler in der Serie.",
  "winterdoppel.rahmenplan.colCriterion": "Kriterium",
  "winterdoppel.rahmenplan.assessmentAria":
    "Beurteilung {{player}} – {{criterion}}",
  "winterdoppel.rahmenplan.levelUnset": "—",
  "winterdoppel.rahmenplan.level.sicher": "sicher",
  "winterdoppel.rahmenplan.level.teilweise": "teilweise",
  "winterdoppel.rahmenplan.level.noch_nicht": "noch nicht",
  "winterdoppel.trainingBriefing.title": "Trainingsdetails",
  "winterdoppel.trainingBriefing.eyebrow": "Trainingsdetails",
  "winterdoppel.trainingBriefing.untitled": "Training",
  "winterdoppel.trainingBriefing.loading": "Trainingsdetails werden geladen …",
  "winterdoppel.trainingBriefing.needSession":
    "Kein Termin in der Adresse. Bitte vom Hub erneut öffnen.",
  "winterdoppel.trainingBriefing.notFound":
    "Dieser Termin wurde nicht gefunden.",
  "winterdoppel.trainingBriefing.editSection":
    "Termin bearbeiten (Teilnehmer, Zeit, Kosten)",
  "winterdoppel.trainingBriefing.whoPlays": "Wer spielt",
  "winterdoppel.trainingBriefing.noPlayers": "Noch keine Spieler eingeteilt.",
  "winterdoppel.trainingBriefing.reserves": "Reserve: {names}",
  "winterdoppel.trainingBriefing.todayContent": "Heute vermitteln",
  "winterdoppel.trainingBriefing.focusLabel": "Schwerpunkt",
  "winterdoppel.trainingBriefing.focusEmpty":
    "Noch kein Schwerpunkt hinterlegt",
  "winterdoppel.trainingBriefing.rahmenEdit": "Anpassen",
  "winterdoppel.trainingBriefing.rahmenDone": "Fertig",
  "winterdoppel.trainingBriefing.noContent":
    "Noch kein Schwerpunkt / Inhalt im Rahmenplan hinterlegt.",
  "winterdoppel.trainingBriefing.playerStand": "Stand der Spieler",
  "winterdoppel.trainingBriefing.moreSection": "Weitere Infos",
  "winterdoppel.trainingBriefing.noAssessments":
    "Noch keine Bewertung für diesen Termin.",
  "winterdoppel.trainingBriefing.noLessonPlan":
    "Kein Unterrichtsplan verknüpft — im Rahmenplan zuordenbar.",
  "winterdoppel.trainingBriefing.linkLessonPlan": "Plan verknüpfen",
  "winterdoppel.trainingBriefing.openLineup": "Lineup öffnen",
  "winterdoppel.trainingBriefing.openRahmenplan": "Rahmenplan öffnen",
  "winterdoppel.trainingBriefing.openLessonPlan": "Unterrichtsplan öffnen",
  "winterdoppel.trainingBriefing.dash": "—",
  "winterdoppel.trainingBriefing.openTrainingView": "Trainingsansicht",
  "winterdoppel.trainingBriefing.backToPlan": "Zur Planung",
  "winterdoppel.trainingBriefing.trainingViewTitle": "Training",
  "winterdoppel.trainingBriefing.reschedule.cta": "Termin verschieben",
  "winterdoppel.trainingBriefing.reschedule.title": "Termin verschieben",
  "winterdoppel.trainingBriefing.reschedule.dateLabel": "Neues Datum",
  "winterdoppel.trainingBriefing.reschedule.timeHint":
    "Uhrzeit bleibt wie in der Serie ({timeRange}).",
  "winterdoppel.trainingBriefing.reschedule.save": "Speichern",
  "winterdoppel.trainingBriefing.reschedule.cancel": "Abbrechen",
  "winterdoppel.trainingBriefing.reschedule.saving": "Wird gespeichert …",
  "winterdoppel.trainingBriefing.reschedule.invalidDate":
    "Bitte ein gültiges Datum wählen.",
  "winterdoppel.trainingBriefing.reschedule.dateConflict":
    "An diesem Tag gibt es in der Serie schon einen Termin.",
  "winterdoppel.trainingBriefing.reschedule.error":
    "Termin konnte nicht verschoben werden.",
  "winterdoppel.trainingBriefing.participantCount": "{n} Teilnehmer",
  "winterdoppel.trainingBriefing.rosterAria": "Teilnehmer Zu- und Absage",
  "winterdoppel.trainingBriefing.rosterMarkIn": "{name} zusagen",
  "winterdoppel.trainingBriefing.rosterMarkOut": "{name} absagen",
  "winterdoppel.trainingBriefing.durationComplete":
    "{planned} / {available} Min.",
  "winterdoppel.trainingBriefing.durationPartial":
    "{planned} / {available} Min. (Dauer unvollständig)",
  "winterdoppel.trainingBriefing.content.loading":
    "Trainingsinhalte werden geladen …",
  "winterdoppel.trainingBriefing.content.empty":
    "Noch keine detaillierten Inhalte für diesen Termin. Füge einen Block hinzu.",
  "winterdoppel.trainingBriefing.content.addBlock": "Übung hinzufügen",
  "winterdoppel.trainingBriefing.content.deleteBlock": "Übung löschen",
  "winterdoppel.trainingBriefing.content.deleteConfirm":
    "Diese Übung wirklich löschen?",
  "winterdoppel.trainingBriefing.content.duplicate": "Duplizieren",
  "winterdoppel.trainingBriefing.content.edit": "Bearbeiten",
  "winterdoppel.trainingBriefing.content.doneEdit": "Fertig",
  "winterdoppel.trainingBriefing.content.exerciseN": "Übung {n}",
  "winterdoppel.trainingBriefing.content.exerciseOf":
    "Übung {current} von {total}",
  "winterdoppel.trainingBriefing.content.openExerciseList": "Übungen",
  "winterdoppel.trainingBriefing.content.stripAria": "Stundenablauf",
  "winterdoppel.trainingBriefing.content.moveUp": "Übung nach vorne",
  "winterdoppel.trainingBriefing.content.moveDown": "Übung nach hinten",
  "winterdoppel.trainingBriefing.content.durationMin": "{n} Min.",
  "winterdoppel.trainingBriefing.content.durationUnset": "ohne Dauer",
  "winterdoppel.trainingBriefing.content.durationIncomplete":
    "Geplant {planned} von {available} Min. — bei {missing} Übung(en) fehlt die Dauer.",
  "winterdoppel.trainingBriefing.content.titlePlaceholder":
    "Name der Übung (z. B. Aufwärmen)",
  "winterdoppel.trainingBriefing.content.pointsTarget": "Punkteziel",
  "winterdoppel.trainingBriefing.content.pointsTargetPlaceholder": "z. B. 11",
  "winterdoppel.trainingBriefing.content.pointsTargetValue": "bis {n}",
  "winterdoppel.trainingBriefing.content.pointsUnit": "Punkte",
  "winterdoppel.trainingBriefing.content.flowTitle": "Ablauf",
  "winterdoppel.trainingBriefing.content.observeTitle": "Darauf achte ich",
  "winterdoppel.trainingBriefing.content.orgShortTitle": "Organisation",
  "winterdoppel.trainingBriefing.content.methodikTitle":
    "Methodik & Organisation",
  "winterdoppel.trainingBriefing.content.variantsAria": "Varianten",
  "winterdoppel.trainingBriefing.content.variantLabelPlaceholder":
    "Variantenname",
  "winterdoppel.trainingBriefing.content.emptyField": "Noch nicht hinterlegt",
  "winterdoppel.trainingBriefing.content.saveStatusSaving": "Speichern …",
  "winterdoppel.trainingBriefing.content.saveStatusSaved": "Gespeichert",
  "winterdoppel.trainingBriefing.content.saveStatusError":
    "Speichern fehlgeschlagen",
  "winterdoppel.trainingBriefing.content.navAria": "Übung navigieren",
  "winterdoppel.trainingBriefing.content.navBack": "Zurück",
  "winterdoppel.trainingBriefing.content.navNext": "Weiter",
  "winterdoppel.trainingBriefing.content.navStart": "Anfang",
  "winterdoppel.trainingBriefing.content.navEnd": "Ende",
  "winterdoppel.trainingBriefing.content.colGoal": "Trainingsziel",
  "winterdoppel.trainingBriefing.content.colMethod": "Methodik",
  "winterdoppel.trainingBriefing.content.colDuration": "Zeit / Dauer",
  "winterdoppel.trainingBriefing.content.colOrganization":
    "Organisation / Durchführung",
  "winterdoppel.trainingBriefing.content.teachingMethod": "Lehrmethode",
  "winterdoppel.trainingBriefing.content.teachingMethod.teilmethode":
    "Teilmethode",
  "winterdoppel.trainingBriefing.content.teachingMethod.ganzheitsmethode":
    "Ganzheitsmethode",
  "winterdoppel.trainingBriefing.content.teachingMethod.teilorientierte_methode":
    "Teilorientierte Methode",
  "winterdoppel.trainingBriefing.content.procedure": "Verfahren",
  "winterdoppel.trainingBriefing.content.procedure.induktiv": "induktiv",
  "winterdoppel.trainingBriefing.content.procedure.deduktiv": "deduktiv",
  "winterdoppel.trainingBriefing.content.trainerActions": "Trainermaßnahme",
  "winterdoppel.trainingBriefing.content.trainerAction.organisieren":
    "Organisieren",
  "winterdoppel.trainingBriefing.content.trainerAction.aufgabe_erklaeren":
    "Aufgabe kurz erklären",
  "winterdoppel.trainingBriefing.content.trainerAction.beobachten":
    "Beobachten",
  "winterdoppel.trainingBriefing.content.trainerAction.korrigieren":
    "Korrigieren",
  "winterdoppel.trainingBriefing.content.trainerAction.einspielen":
    "Einspielen",
  "winterdoppel.trainingBriefing.content.trainerAction.zuspielen": "Zuspielen",
  "winterdoppel.trainingBriefing.content.trainerAction.mitspielen":
    "Mitspielen",
  "winterdoppel.trainingBriefing.content.aids": "Hilfsmittel",
  "winterdoppel.trainingBriefing.content.techniqueTags": "Technik / Taktik",
  "winterdoppel.trainingBriefing.content.techniqueTag.vh": "VH",
  "winterdoppel.trainingBriefing.content.techniqueTag.rh": "RH",
  "winterdoppel.trainingBriefing.content.techniqueTag.aufschlag": "Aufschlag",
  "winterdoppel.trainingBriefing.content.techniqueTag.return": "Return",
  "winterdoppel.trainingBriefing.content.techniqueTag.bewegung": "Bewegung",
  "winterdoppel.trainingBriefing.content.techniqueTag.cross": "Cross",
  "winterdoppel.trainingBriefing.content.techniqueTag.longline": "Longline",
  "winterdoppel.trainingBriefing.content.techniqueTag.volley": "Volley / Netz",
  "winterdoppel.trainingBriefing.content.techniqueTag.matchtaktik":
    "Matchtaktik",
  "winterdoppel.trainingBriefing.content.gameForm":
    "Trainingsspiel / Spielform",
  "winterdoppel.trainingBriefing.content.gameFormPlaceholder":
    "z. B. Crossduelle, anschließend Punkt frei",
  "winterdoppel.trainingBriefing.rahmenContextAria":
    "Rahmenplan für diesen Termin",
  "winterdoppel.trainingBriefing.rahmenContextHint":
    "Aus dem Rahmenplan — hier verfeinerbar, darunter detaillierte Übungsblöcke.",
  "winterdoppel.trainingBriefing.content.sketch.title": "Platz-Skizze",
  "winterdoppel.trainingBriefing.content.sketch.aria":
    "Tennisplatz-Skizze zum Setzen von Spielern, Pfeilen und Zonen",
  "winterdoppel.trainingBriefing.content.sketch.previewEmpty":
    "Noch keine Platzskizze.",
  "winterdoppel.trainingBriefing.content.sketch.dropHint":
    "Screenshot einfügen (⌘V) oder Bild hierher ziehen",
  "winterdoppel.trainingBriefing.content.photo.dropHint":
    "Bild hierher ziehen oder einfügen (⌘V)",
  "winterdoppel.trainingBriefing.content.photo.dropActive":
    "Bild jetzt loslassen",
  "winterdoppel.trainingBriefing.content.sketch.editCta": "Skizze bearbeiten",
  "winterdoppel.trainingBriefing.content.sketch.editTitle": "Skizze bearbeiten",
  "winterdoppel.trainingBriefing.content.sketch.pickTemplate": "Vorlage wählen",
  "winterdoppel.trainingBriefing.content.sketch.removeFromBlock":
    "Skizze entfernen",
  "winterdoppel.trainingBriefing.content.sketch.removeFromBlockConfirm":
    "Skizze aus dieser Übung entfernen?",
  "winterdoppel.trainingBriefing.content.sketch.cancelEdit": "Abbrechen",
  "winterdoppel.trainingBriefing.content.sketch.applyEdit": "Übernehmen",
  "winterdoppel.trainingBriefing.content.sketch.expand": "Vergrößern",
  "winterdoppel.trainingBriefing.content.sketch.closeExpand": "Schließen",
  "winterdoppel.trainingBriefing.content.sketch.legendAria": "Legende",
  "winterdoppel.trainingBriefing.content.sketch.legendPlayer": "Spieler",
  "winterdoppel.trainingBriefing.content.sketch.legendTrainer": "Trainer",
  "winterdoppel.trainingBriefing.content.sketch.legendBall": "Ballpfeil",
  "winterdoppel.trainingBriefing.content.sketch.legendMove": "Laufweg",
  "winterdoppel.trainingBriefing.content.sketch.legendDouble":
    "Laufendes Zuspiel",
  "winterdoppel.trainingBriefing.content.sketch.hint":
    "Mit „Auswählen“ Elemente tippen und ziehen: Pfeil-Enden verlängern, Linie verschieben; Zone an den Eckpunkten skalieren. Auswahl mit Entf löschen.",
  "winterdoppel.trainingBriefing.content.sketch.clearNum": "Nr. entfernen",
  "winterdoppel.trainingBriefing.content.sketch.markerT": "T",
  "winterdoppel.trainingBriefing.content.sketch.toolBall": "Ballpfeil",
  "winterdoppel.trainingBriefing.content.sketch.toolMove": "Laufweg",
  "winterdoppel.trainingBriefing.content.sketch.toolDouble": "Doppelpfeil",
  "winterdoppel.trainingBriefing.content.sketch.toolZone": "Zone",
  "winterdoppel.trainingBriefing.content.sketch.toolCone": "Hütchen",
  "winterdoppel.trainingBriefing.content.sketch.toolSelect": "Auswählen",
  "winterdoppel.trainingBriefing.content.sketch.toolErase": "Radierer",
  "winterdoppel.trainingBriefing.content.sketch.nextNum": "Nr.",
  "winterdoppel.trainingBriefing.content.sketch.selectedNum": "Auswahl-Nr.",
  "winterdoppel.trainingBriefing.content.sketch.removeSelected":
    "Auswahl löschen",
  "winterdoppel.trainingBriefing.content.sketch.clear": "Skizze leeren",
  "winterdoppel.trainingBriefing.content.sketch.library":
    "Gespeicherte Skizzen",
  "winterdoppel.trainingBriefing.content.sketch.namePlaceholder":
    "Name der Skizze",
  "winterdoppel.trainingBriefing.content.sketch.save": "Skizze speichern",
  "winterdoppel.trainingBriefing.content.sketch.saved": "Skizze gespeichert.",
  "winterdoppel.trainingBriefing.content.sketch.overwritten":
    "Skizze global überschrieben.",
  "winterdoppel.trainingBriefing.content.sketch.saveFailed":
    "Skizze konnte nicht gespeichert werden.",
  "winterdoppel.trainingBriefing.content.sketch.loaded": "Skizze geladen.",
  "winterdoppel.trainingBriefing.content.sketch.editingClean":
    "Geladen: „{name}“",
  "winterdoppel.trainingBriefing.content.sketch.editingDirty":
    "„{name}“ bearbeitet – als neue Vorlage speichern oder Original überschreiben.",
  "winterdoppel.trainingBriefing.content.sketch.saveDialogTitle":
    "Skizze speichern",
  "winterdoppel.trainingBriefing.content.sketch.saveDialogBody":
    "Du hast „{name}“ geändert. Standard: als neue Vorlage speichern. „Original überschreiben“ ändert die Vorlage und alle verknüpften Übungen.",
  "winterdoppel.trainingBriefing.content.sketch.saveDialogCancel": "Abbrechen",
  "winterdoppel.trainingBriefing.content.sketch.saveAsNew": "Als neue Skizze",
  "winterdoppel.trainingBriefing.content.sketch.saveAsNewName":
    "{name} – Variante",
  "winterdoppel.trainingBriefing.content.sketch.saveAsNewHint":
    "Neuen Namen für die Variante wählen.",
  "winterdoppel.trainingBriefing.content.sketch.saveAsNewConfirm": "Speichern",
  "winterdoppel.trainingBriefing.content.sketch.overwriteGlobal":
    "Original überschreiben",
  "winterdoppel.trainingBriefing.content.sketch.overwriteConfirm":
    "Vorlage „{name}“ wirklich global überschreiben?",
  "winterdoppel.trainingBriefing.content.sketch.libraryEmpty":
    "Noch keine gespeicherten Skizzen.",
  "winterdoppel.trainingBriefing.content.sketch.needTenant":
    "Speichern erst nach geladenem Vereinskontext möglich.",
  "winterdoppel.trainingBriefing.content.sketch.delete": "Löschen",
  "winterdoppel.trainingBriefing.content.sketch.deleteConfirm":
    "Diese gespeicherte Skizze wirklich löschen?",
  "winterdoppel.trainingBriefing.content.sketch.deleteTemplateAria":
    "Skizze „{name}“ löschen",
  "winterdoppel.trainingBriefing.content.minutes": "Min",
  "winterdoppel.trainingBriefing.content.variantN": "Variante {n}",
  "winterdoppel.trainingBriefing.content.addVariant": "Variante hinzufügen",
  "winterdoppel.trainingBriefing.content.removeVariant": "Entfernen",
  "winterdoppel.trainingBriefing.content.uploadPhoto": "Foto hochladen",
  "winterdoppel.trainingBriefing.content.removePhoto": "Foto entfernen",
  "winterdoppel.trainingBriefing.content.photoAlt": "Organisationsfoto",
  "winterdoppel.trainingBriefing.content.uploadFailed":
    "Foto konnte nicht hochgeladen werden.",
  "winterdoppel.trainingBriefing.content.needTenant":
    "Foto-Upload erst nach geladenem Vereinskontext möglich.",
  "winterdoppel.participants.tabsAria": "Teilnehmer Bereiche",
  "winterdoppel.participants.tabRoster": "Teilnehmer",
  "winterdoppel.participants.tabRules": "Planungsregeln",
  "winterdoppel.evaluation.tabsAria": "Auswertung Bereiche",
  "winterdoppel.evaluation.tabFairness": "Fairness",
  "winterdoppel.evaluation.tabCosts": "Kosten & Abrechnung",
  "winterdoppel.evaluation.tabConflicts": "Konflikte",
  "winterdoppel.conflicts.needSeries": "Bitte zuerst eine Serie wählen.",
  "winterdoppel.conflicts.title": "Planungskonflikte",
  "winterdoppel.conflicts.hint":
    "Prüfung der aktuellen Serie – inklusive Überschneidungen mit anderen Serien desselben Vereins.",
  "winterdoppel.conflicts.none": "Keine Konflikte erkannt.",
  "winterdoppel.conflicts.sectionLocation": "Ort am selben Tag",
  "winterdoppel.conflicts.sectionLocationHint":
    "Spieler ist am selben Tag (Starter oder Warteliste) in Serien mit unterschiedlichem Ort eingeplant.",
  "winterdoppel.conflicts.sectionCoverage": "Unterbesetzung / Format",
  "winterdoppel.conflicts.sectionCoverageHint":
    "Zu wenig Spieler für volle Doppel: Vorschlag aus Einzel und Doppel, Überhang auf die Warteliste, ungenutzte Plätze entfallen für den Termin.",
  "winterdoppel.conflicts.colDate": "Datum",
  "winterdoppel.conflicts.colPlayer": "Spieler",
  "winterdoppel.conflicts.colDetails": "Betroffene Serien",
  "winterdoppel.conflicts.colIssue": "Hinweis",
  "winterdoppel.conflicts.locationEntry":
    "{{series}} · {{location}} · {{role}}",
  "winterdoppel.conflicts.roleStarter": "Starter",
  "winterdoppel.conflicts.roleReserve": "Warteliste",
  "winterdoppel.conflicts.coverage.threeInDouble":
    "Nur 3 Spieler für Doppel {{court}} – kein vierter aus der Warteliste.",
  "winterdoppel.conflicts.coverage.insufficientDoubles":
    "Nur {{pool}} Spieler für {{courts}} Doppel ({{needed}} nötig).",
  "winterdoppel.conflicts.coverage.insufficientPlayers":
    "Nur {{pool}} Spieler – weder Doppel noch Einzel möglich.",
  "winterdoppel.conflicts.coverage.courtMixSuggestion":
    "Vorschlag: {{doubles}} Doppel, {{singles}} Einzel, {{waitlist}} Warteliste{{unused}}.",
  "winterdoppel.conflicts.coverage.courtMixUnused":
    ", {{count}} Platz ungenutzt",
  "winterdoppel.conflicts.trainingSkip":
    "Deckungsprüfung für Doppel gilt nur im Modus „Freies Spielen“.",
  "winterdoppel.sessions.previewBanner":
    "Vorschau: Der Saisonplan ist noch nicht veröffentlicht. Termine sind hier bereits sichtbar; Zu- und Absagen starten nach der Veröffentlichung.",
  "winterdoppel.setup.title": "Einrichtung",
  "winterdoppel.setup.series": "Serie eingerichtet",
  "winterdoppel.setup.participants": "Teilnehmer angelegt oder eingeladen",
  "winterdoppel.setup.responses": "Verfügbarkeiten geprüft",
  "winterdoppel.setup.sessions": "Termine erzeugt",
  "winterdoppel.setup.planning": "Planung durchgeführt",
  "winterdoppel.setup.publish": "Saisonplan veröffentlicht",
  "winterdoppel.overview.dashboardPreparingTitle":
    "{{name}} ist noch in Vorbereitung",
  "winterdoppel.overview.dashboardPublishedNext":
    "Nächster Termin: {{date}}{{time}}",
  "winterdoppel.overview.statParticipants": "{{count}} Teilnehmer eingeladen",
  "winterdoppel.overview.statResponsesDone":
    "{{count}} Rückmeldungen vollständig",
  "winterdoppel.overview.statResponsesOpen": "{{count}} Rückmeldungen offen",
  "winterdoppel.overview.statSessions": "{{count}} Termine erzeugt",
  "winterdoppel.overview.statNotPublished":
    "Saisonplan noch nicht veröffentlicht",
  "winterdoppel.overview.statConfirmed": "{{count}} Zusagen",
  "winterdoppel.overview.statRsvpOpen": "{{count}} Antworten offen",
  "winterdoppel.overview.statWaitlist": "{{count}} auf der Warteliste",
  "winterdoppel.overview.actionOpenParticipants": "Offene Teilnehmer anzeigen",
  "winterdoppel.overview.actionReviewPlanning": "Saisonplanung prüfen",
  "winterdoppel.overview.actionPublish": "Saisonplan veröffentlichen",
  "winterdoppel.overview.actionOpenSession": "Termin öffnen",
  "winterdoppel.overview.actionOpenRsvp": "Offene Antworten anzeigen",
  "winterdoppel.overview.actionWhatsApp": "In WhatsApp öffnen",
  "winterdoppel.publishedChange.playerBlocked":
    "Diese Aktion ist nach Veröffentlichung nur mit Bestätigung möglich.",
  "winterdoppel.publishedChange.playerAdd":
    "Teilnehmer zur veröffentlichten Saison hinzufügen? Die Termin-Aufstellung bleibt unverändert. Kostenanteil (1/N) und Guthaben für die anderen entstehen erst, wenn der neue Spieler wirklich mitspielt.",
  "winterdoppel.publishedChange.playerRemove":
    "Teilnehmer aus der veröffentlichten Saison entfernen? Geplante Einsätze und Kostenanteile können betroffen sein.",
  "winterdoppel.publishedChange.sessionLineup":
    "Aufstellung ändern? Kostenanteile und bestehende Zu-/Absagen können sich verschieben.",
  "winterdoppel.publishedChange.sessionStatus":
    "Terminstatus ändern? Teilnehmer erhalten ggf. andere Einladungen.",
  "winterdoppel.publishedChange.sessionRsvpDecline":
    "Absage erfassen? Warteliste und Kostenverteilung können sich ändern.",
  "winterdoppel.publishedChange.sessionCosts":
    "Kostenanteile für diesen Termin anpassen? Die Saison-Summe bleibt gleich, die Verteilung unter den Spielern ändert sich.",
  "winterdoppel.publishedChange.groupMembers":
    "Gruppenmitglieder ändern? Offene und künftige Trainingstermine werden an die neue Gruppe angepasst. Vergangene Termine bleiben.",
  "winterdoppel.publishedChange.groupSwap":
    "Gruppen tauschen ab jetzt die Wochen? Der restliche Saisonplan (und TrainingsDesk) wird neu zugeordnet.",
  "winterdoppel.publishedChange.groupSwapOnce":
    "Nur das nächste Terminpaar tauschen? Danach gilt wieder der bisherige Rhythmus.",
  "winterdoppel.weekday.mon": "Mo",
  "winterdoppel.weekday.tue": "Di",
  "winterdoppel.weekday.wed": "Mi",
  "winterdoppel.weekday.thu": "Do",
  "winterdoppel.weekday.fri": "Fr",
  "winterdoppel.weekday.sat": "Sa",
  "winterdoppel.weekday.sun": "So",
  "winterdoppel.interest.yes": "Dabei",
  "winterdoppel.interest.maybe": "Gelegenheit gerne",
  "winterdoppel.interest.no": "Nein",
  "winterdoppel.participation.title": "Teilnahme-Ziel",
  "winterdoppel.participation.type": "Begrenzung",
  "winterdoppel.participation.value": "Wert",
  "winterdoppel.participation.none": "Unbegrenzt (wie „Dabei“)",
  "winterdoppel.participation.season": "Max. Einsätze in der Saison",
  "winterdoppel.participation.month": "Max. pro Kalendermonat",
  "winterdoppel.participation.weeks": "Mindestabstand (Wochen)",
  "winterdoppel.participation.maybeHint":
    "„Gelegenheit gerne“: Standard max. 1× pro Monat – unten anpassbar.",
  "winterdoppel.participation.list.none": "Unbegrenzt",
  "winterdoppel.participation.list.season": "Max. {{count}}× Saison",
  "winterdoppel.participation.list.month": "Max. {{count}}× / Monat",
  "winterdoppel.participation.list.weeks": "Alle {{count}} Wochen",
  "winterdoppel.participation.list.maybeDefault": "Gelegenheit (1× / Monat)",
  "winterdoppel.weekRule.all": "Jede Woche",
  "winterdoppel.weekRule.even_kw": "Nur gerade KW",
  "winterdoppel.weekRule.odd_kw": "Nur ungerade KW",
  "winterdoppel.status.proposed": "Vorgeschlagen",
  "winterdoppel.status.asked": "Angefragt",
  "winterdoppel.status.confirmed": "Bestätigt",
  "winterdoppel.status.cancelled": "Abgesagt",
  "winterdoppel.rsvp.pending": "Noch offen",
  "winterdoppel.rsvp.yes": "Dabei",
  "winterdoppel.rsvp.no": "Absagen",
  "winterdoppel.rsvp.maybe": "Vielleicht",
  "winterdoppel.overview.seriesHeading": "Deine Serien",
  "winterdoppel.overview.currentSeriesHeading": "Aktuelle Serie",
  "winterdoppel.overview.showAllSeries": "Alle Serien anzeigen",
  "winterdoppel.overview.seriesHint":
    "Wähle eine Serie, um Termine, Teilnehmer und Planung zu öffnen.",
  "winterdoppel.overview.hubTitle": "Serientermine",
  "winterdoppel.overview.hubSubtitle":
    "Alle Serien im Überblick — öffne eine Serie für Details und Termine.",
  "winterdoppel.overview.openSeries": "Serie öffnen",
  "winterdoppel.overview.newSeries": "Neue Serie",
  "winterdoppel.hub.hero.aria": "Serientermine starten",
  "winterdoppel.hub.hero.tagline": "Planen · Wiederholen · Spielen",
  "winterdoppel.hub.hero.title":
    "Regelmäßige Termine. Feste Gruppen. Deine Saison im Griff.",
  "winterdoppel.hub.hero.subtitle":
    "Bring dein Team zusammen. Serientermine organisieren die Runden.",
  "winterdoppel.hub.hero.ctaNew": "Neue Serie anlegen",
  "winterdoppel.hub.hero.ctaContinue": "Weiterplanen",
  "winterdoppel.hub.secondary.aria": "Weitere Aktionen",
  "winterdoppel.hub.secondary.participants": "Serie öffnen",
  "winterdoppel.hub.secondary.settings": "Neue Serie anlegen",
  "winterdoppel.hub.searchPlaceholder": "Serie suchen…",
  "winterdoppel.hub.filtersAria": "Serien nach Status filtern",
  "winterdoppel.hub.filter.all": "Alle",
  "winterdoppel.hub.filter.preparing": "In Vorbereitung",
  "winterdoppel.hub.filter.published": "Veröffentlicht",
  "winterdoppel.hub.view.aria": "Darstellung",
  "winterdoppel.hub.view.cards": "Kacheln",
  "winterdoppel.hub.view.list": "Liste",
  "winterdoppel.hub.sort.label": "Sortierung",
  "winterdoppel.hub.sort.aria": "Serien sortieren",
  "winterdoppel.hub.sort.nameAsc": "A–Z",
  "winterdoppel.hub.sort.nameDesc": "Z–A",
  "winterdoppel.hub.sort.dateAsc": "Älteste zuerst",
  "winterdoppel.hub.sort.dateDesc": "Neueste zuerst",
  "winterdoppel.hub.focus.emptyPublished":
    "Keine veröffentlichte Serie — starte eine neue Serie.",
  "winterdoppel.hub.emptyFiltered": "Keine Serien für diesen Filter.",
  "winterdoppel.hub.footer.tagline":
    "Gemeinsam spielen. Feste Termine. Neue Routinen.",
  "winterdoppel.overview.copySeries": "Kopieren",
  "winterdoppel.overview.copySeriesBusy": "Kopiert…",
  "winterdoppel.overview.copySeriesDone": "Serie kopiert.",
  "winterdoppel.overview.copySeriesName": "{{name}} (Kopie)",
  "winterdoppel.overview.deleteSeries": "Löschen",
  "winterdoppel.overview.deleteSeriesBusy": "Löscht…",
  "winterdoppel.overview.deleteSeriesConfirm":
    "Serie „{{name}}“ endgültig löschen? Es sind keine Spieler hinterlegt.",
  "winterdoppel.overview.deleteSeriesDone": "Serie gelöscht.",
  "winterdoppel.overview.archiveSeries": "Archivieren",
  "winterdoppel.overview.archiveSeriesBusy": "Archiviert…",
  "winterdoppel.overview.archiveSeriesConfirm":
    "Serie „{{name}}“ archivieren? Sie verschwindet aus der Liste, die Daten bleiben erhalten.",
  "winterdoppel.overview.archiveSeriesDone": "Serie archiviert.",
  "winterdoppel.series.deleteHasPlayers":
    "Serie mit Spielern kann nicht gelöscht werden – bitte archivieren.",
  "winterdoppel.overview.empty": "Noch keine Serie. Lege die erste an.",
  "winterdoppel.overview.playersCount": "{{count}} Spieler",
  "winterdoppel.overview.courtsCount": "{{count}} Plätze",
  "winterdoppel.overview.capacity": "Kapazität {{count}}",
  "winterdoppel.overview.viewToggleAria": "Ansicht wechseln",
  "winterdoppel.overview.viewList": "Liste",
  "winterdoppel.overview.viewCalendar": "Kalender",
  "winterdoppel.overview.upcomingEmpty": "Keine anstehenden Termine.",
  "winterdoppel.overview.calendarTitle": "Kalender",
  "winterdoppel.overview.calendarAllSeries": "Alle Serien anzeigen",
  "winterdoppel.overview.calendarPrev": "Vorheriger Monat",
  "winterdoppel.overview.calendarNext": "Nächster Monat",
  "winterdoppel.overview.calendarEmpty": "Noch keine Termine in dieser Serie.",
  "winterdoppel.overview.calendarEmptyAll": "Noch keine Termine in den Serien.",
  "winterdoppel.overview.calendarNoPlayers": "Noch keine Zuordnung",
  "winterdoppel.overview.nextSession": "Nächster Termin · {{date}}",
  "winterdoppel.overview.nextPlayers": "Spielen: {{names}}",
  "winterdoppel.overview.nextPlayersEmpty":
    "Noch keine Starter für den nächsten Termin.",
  "winterdoppel.overview.welcomeTitle": "Serientermine",
  "winterdoppel.overview.welcomeSubtitle":
    "Serientermine planen, Verfügbarkeit und Wochen-Check-in.",
  "winterdoppel.overview.welcomeSubtitleSeries":
    "{{mode}} · Nächster Termin, WhatsApp und Schnellzugriff.",
  "winterdoppel.overview.firstTitle": "Loslegen mit Serienterminen",
  "winterdoppel.overview.firstText":
    "Lege eine Serie an Ort und Wochentagen an – danach Spieler und Plan.",
  "winterdoppel.overview.planPendingTitle": "Planung noch offen",
  "winterdoppel.overview.planPendingText":
    "Bestätige den Plan, damit der nächste Termin und WhatsApp hier erscheinen.",
  "winterdoppel.overview.upcomingTitle": "Kommende Termine",
  "winterdoppel.overview.upcomingSubtitle":
    "Art, Uhrzeit und geplante Aufstellung",
  "winterdoppel.overview.upcomingBadgeDraft": "Entwurf",
  "winterdoppel.overview.upcomingRosterEmpty": "Noch keine Aufstellung",
  "winterdoppel.overview.upcomingRosterDraftOpen":
    "Aufstellung im Plan anlegen",
  "winterdoppel.overview.upcomingRosterDraft":
    "{{starters}}/{{capacity}} im Plan-Entwurf",
  "winterdoppel.overview.upcomingRosterWaitlist":
    "{{count}} auf der Warteliste",
  "winterdoppel.overview.upcomingRosterNames": "{{names}}",
  "winterdoppel.overview.upcomingRosterNamesMore": "{{names}} +{{rest}}",
  "winterdoppel.overview.quickTitle": "Schnellzugriff",
  "winterdoppel.overview.metricsAria": "Kennzahlen",
  "winterdoppel.overview.metricCourts": "Plätze",
  "winterdoppel.overview.metricUpcoming": "Anstehend",
  "winterdoppel.series.newTitle": "Neue Serie",
  "winterdoppel.series.editTitle": "Serie bearbeiten",
  "winterdoppel.series.lockedHint":
    "Der Saisonplan ist veröffentlicht – Rhythmus, Zeiten, Plätze und Saisonzeitraum sind gesperrt. Zum Ändern unter Saisonplanung den Plan zurücksetzen (nur vor dem ersten Termin). Name, Links und Hinweise bleiben editierbar.",
  "winterdoppel.series.section.basics": "Stammdaten",
  "winterdoppel.series.section.schedule": "Rhythmus & Saison",
  "winterdoppel.series.section.costs": "Plätze & Kosten",
  "winterdoppel.series.summaryAria": "Serien-Übersicht",
  "winterdoppel.series.summarySessions": "{{count}} Termine",
  "winterdoppel.series.summaryDuration": "{{hours}} Std. je Termin",
  "winterdoppel.series.summaryCourts": "{{count}} Plätze",
  "winterdoppel.series.summaryPerEvening": "Termin",
  "winterdoppel.series.summarySeasonTotal": "Saison gesamt",
  "winterdoppel.series.courtStepperDec": "Weniger Plätze",
  "winterdoppel.series.courtStepperInc": "Mehr Plätze",
  "winterdoppel.series.name": "Name",
  "winterdoppel.series.kind": "Art der Serie",
  "winterdoppel.series.kind.winter": "Winter-Serie",
  "winterdoppel.series.kind.summer": "Sommer-Serie",
  "winterdoppel.series.kind.custom": "Sonstige Serie",
  "winterdoppel.series.location": "Standort / Halle",
  "winterdoppel.series.locationNone": "Kein Standort",
  "winterdoppel.series.locationSearch.placeholder": "Standort suchen…",
  "winterdoppel.series.locationSearch.aria": "Standort suchen und auswählen",
  "winterdoppel.series.locationSearch.noResults": "Kein Standort gefunden.",
  "winterdoppel.series.locationSearch.clear": "Standort entfernen",
  "winterdoppel.series.startTime": "Beginn",
  "winterdoppel.series.endTime": "Ende",
  "winterdoppel.series.courtCount": "Anzahl Plätze",
  "winterdoppel.series.courtFee": "Platzpreis (EUR / Platz / Termin)",
  "winterdoppel.series.courtFeeHint":
    "Fallback, wenn kein Abo-Stundensatz hinterlegt ist: Preis × Anzahl Plätze je Termin.",
  "winterdoppel.series.hourlyRate": "Abo (EUR / Stunde / Platz, Saison)",
  "winterdoppel.series.hourlyRateHint":
    "Saison-Abo je Platz und Stunde. 570 × 2 h × 2 Plätze = 2.280 € für die ganze Saison; je Termin dann ÷ Anzahl Termine.",
  "winterdoppel.series.chargePlannedParticipants":
    "Abrechnung auch bei No-Show (geplante Teilnehmer)",
  "winterdoppel.series.chargePlannedParticipantsHint":
    "Nach Veröffentlichung erscheinen die Termine im TrainingsDesk. Geplante Spieler werden abgerechnet – unabhängig von der Anwesenheit.",
  "winterdoppel.series.participantPricingMode": "Teilnehmer-Abrechnung",
  "winterdoppel.series.participantPricingMode.hourly_split":
    "Gruppensatz teilen (abhängig von Gruppengröße)",
  "winterdoppel.series.participantPricingMode.per_participant_hourly":
    "Pauschale pro Kind und Stunde",
  "winterdoppel.series.participantPricingModeHint":
    "Pauschale: jedes Kind zahlt denselben Stundensatz – egal ob 3 oder 7 mitspielen.",
  "winterdoppel.series.participantHourlyRate":
    "Pauschale (EUR / Kind / Stunde)",
  "winterdoppel.series.participantHourlyRateHint":
    "Serien-Default, z. B. 6 €. Einzelne Gruppen können das unter Gruppen überschreiben.",
  "winterdoppel.group.participantHourlyRate": "Pauschale (EUR / Kind / Stunde)",
  "winterdoppel.group.participantHourlyRateHint":
    "Leer = Serien-Default. Überschreibt die Serien-Pauschale nur für diese Gruppe.",
  "winterdoppel.series.sessionCost": "Kosten je Termin: {{amount}}",
  "winterdoppel.series.sessionCostFormula":
    "{{rate}} × {{hours}} h × {{courts}} Plätze = {{amount}}",
  "winterdoppel.series.aboSeasonFormula":
    "Saison-Abo: {{rate}} × {{hours}} h × {{courts}} = {{season}} · je Termin ({{count}}×): {{evening}}",
  "winterdoppel.series.seasonCost":
    "Gesamtkosten Saison ({{count}} Termine): {{amount}}",
  "winterdoppel.series.hourlyNeedsTimes":
    "Für das Abo bitte Beginn und Ende setzen, sonst gilt der Platzpreis.",
  "winterdoppel.series.seasonStart": "Saison von",
  "winterdoppel.series.seasonEnd": "Saison bis",
  "winterdoppel.series.weekdays": "Wochentage",
  "winterdoppel.series.notes": "Notiz",
  "winterdoppel.series.saveAsNew": "Als neue Serie speichern",
  "winterdoppel.series.duplicate": "Serie duplizieren",
  "winterdoppel.series.duplicateConfirm":
    "Serie duplizieren? Es werden Stammdaten, Teilnehmer, Partnerwünsche, Gruppen und Abwesenheiten kopiert – ohne Termine und Saisonplan.",
  "winterdoppel.series.duplicateName": "{{name}} (Kopie)",
  "winterdoppel.series.duplicateDone": "Serie dupliziert.",
  "winterdoppel.series.created": "Serie angelegt.",
  "winterdoppel.series.saved": "Gespeichert.",
  "winterdoppel.series.inviteTitle": "Einladungslink",
  "winterdoppel.series.shareTitle": "Links teilen",
  "winterdoppel.series.shareHint":
    "Zum Versenden per WhatsApp oder E-Mail – Spieler brauchen keinen Login.",
  "winterdoppel.series.shareJoinTitle": "Anmeldung & Abwesenheiten",
  "winterdoppel.series.shareScheduleTitle": "Spielplan & Kosten",
  "winterdoppel.series.shareProtected": "Geschützt",
  "winterdoppel.series.shareOpen": "Offen",
  "winterdoppel.series.shareCopyJoin": "Einladungslink kopieren",
  "winterdoppel.series.shareCopySchedule": "Plan-Link kopieren",
  "winterdoppel.series.shareJoinPeekHint":
    "Zum Anmelden und Abwesenheiten pflegen. Passwortschutz in den Einstellungen.",
  "winterdoppel.series.shareSchedulePeekHint":
    "Zum Ansehen von Plan und Kosten. Passwortschutz in den Einstellungen.",
  "winterdoppel.series.shareShowLink": "Link anzeigen",
  "winterdoppel.series.shareHideLink": "Link ausblenden",
  "winterdoppel.series.sharePasswordSection": "Passwortschutz (optional)",
  "winterdoppel.series.inviteHint":
    "Link zum Anmelden und Abwesenheiten pflegen – ohne Login. Optional mit Passwort absichern (z. B. für WhatsApp).",
  "winterdoppel.series.joinPassword": "Passwort für den Join-Link",
  "winterdoppel.series.joinPasswordPlaceholder": "mind. 4 Zeichen",
  "winterdoppel.series.joinPasswordSave": "Passwort setzen",
  "winterdoppel.series.joinPasswordClear": "Passwort entfernen",
  "winterdoppel.series.joinPasswordGenerate": "Zufallspasswort",
  "winterdoppel.series.joinPasswordOn":
    "Passwortschutz ist aktiv – Anmeldung nur mit Passwort.",
  "winterdoppel.series.joinPasswordOff":
    "Aktuell ohne Passwort – jeder mit dem Link kann sich anmelden.",
  "winterdoppel.series.joinPasswordSaved":
    "Passwort für den Join-Link gespeichert.",
  "winterdoppel.series.joinPasswordCleared": "Join-Passwortschutz entfernt.",
  "winterdoppel.series.joinPasswordTooShort":
    "Passwort muss mindestens 4 Zeichen haben.",
  "winterdoppel.series.scheduleTitle": "Spielplan-Link",
  "winterdoppel.series.scheduleHint":
    "Link zum Ansehen von Plan und Kosten – ohne Login. Mit Passwort absichern.",
  "winterdoppel.series.copyScheduleLink": "Plan-Link kopieren",
  "winterdoppel.series.schedulePassword": "Passwort für den Link",
  "winterdoppel.series.schedulePasswordPlaceholder": "mind. 4 Zeichen",
  "winterdoppel.series.schedulePasswordSave": "Passwort setzen",
  "winterdoppel.series.schedulePasswordClear": "Passwort entfernen",
  "winterdoppel.series.schedulePasswordOn":
    "Passwortschutz ist aktiv – der Link öffnet nur mit Passwort.",
  "winterdoppel.series.schedulePasswordOff":
    "Aktuell ohne Passwort – jeder mit dem Link sieht den Plan.",
  "winterdoppel.series.schedulePasswordSaved":
    "Passwort für den Plan-Link gespeichert.",
  "winterdoppel.series.schedulePasswordCleared": "Passwortschutz entfernt.",
  "winterdoppel.series.schedulePasswordTooShort":
    "Passwort muss mindestens 4 Zeichen haben.",
  "winterdoppel.series.copyLink": "Link kopieren",
  "winterdoppel.series.copied": "Kopiert",
  "winterdoppel.series.exportTitle": "Export für TrainingsDesk",
  "winterdoppel.series.exportHint":
    "Snapshot aus Serie, Spielern, festen Partnern und Terminen – später in die wöchentliche TrainingsDesk-Planung übernehmbar.",
  "winterdoppel.series.exportCopy": "JSON kopieren",
  "winterdoppel.series.exportDownload": "JSON herunterladen",
  "winterdoppel.series.exportCopyFailed": "Export konnte nicht kopiert werden.",
  "winterdoppel.series.exportStats":
    "{{players}} Spieler · {{bonds}} Partnerpaare · {{groups}} Gruppen · {{sessions}} Termine",
  "winterdoppel.players.needSeries": "Bitte zuerst eine Serie anlegen.",
  "winterdoppel.players.addTitle": "Spieler anlegen",
  "winterdoppel.players.addSection": "Spieler hinzufügen",
  "winterdoppel.players.search": "Spieler suchen",
  "winterdoppel.players.createFromSearch":
    "„{{name}}“ als neuen Spieler anlegen",
  "winterdoppel.players.addFromDesk": "Aus TrainingsDesk übernehmen",
  "winterdoppel.players.addFromDeskHint":
    "Nur Personen deines Vereins (Tenant), die du im TrainingsDesk nutzen darfst. Bereits in der Serie stehende Personen sind ausgeblendet.",
  "winterdoppel.players.deskSearch": "Person suchen",
  "winterdoppel.players.addSelected": "Zur Serie hinzufügen",
  "winterdoppel.players.manualCreate": "Neuen Spieler manuell anlegen",
  "winterdoppel.players.deskNameMissing":
    "Für diese Person fehlt Vor- und Nachname.",
  "winterdoppel.players.linkedToDesk": "Mit TrainingsDesk-Person verknüpft.",
  "winterdoppel.players.fromDesk": "TrainingsDesk",
  "winterdoppel.player.clubPersonAlreadyInSeries":
    "Diese Person ist bereits in der Serie.",
  "winterdoppel.lineup.title": "Aufstellung vor der Planung",
  "winterdoppel.lineup.hint":
    "Partnerwünsche und feste Trainingsgruppen – optional, bevor der Plan erzeugt wird.",
  "winterdoppel.lineup.needPlayers":
    "Bitte zuerst unter Spieler mindestens zwei Personen zur Serie hinzufügen.",
  "winterdoppel.lineup.locked":
    "Planung bestätigt – Aufstellung kann nicht mehr geändert werden.",
  "winterdoppel.lineup.publishedHint":
    "Saisonplan ist veröffentlicht. Gruppenmitglieder und Wochenrhythmus kannst du weiterhin anpassen – künftige Termine werden neu zugeordnet.",
  "winterdoppel.players.publishedBanner":
    "Saisonplan ist veröffentlicht. Teilnehmer können weiter gepflegt werden; Neuanlage und Löschen erfordern eine Bestätigung.",
  "winterdoppel.players.lockedBanner":
    "Planung bestätigt – Spieler können für diese Runde nicht mehr hinzugefügt, bearbeitet oder gelöscht werden. Details lassen sich weiterhin ansehen.",
  "winterdoppel.players.viewTitle": "Spieler ansehen",
  "winterdoppel.players.viewHint":
    "Nur Ansicht – Änderungen sind nach Planbestätigung nicht möglich.",
  "winterdoppel.players.view": "Ansehen",
  "winterdoppel.players.copyWaLink": "WA-Link",
  "winterdoppel.players.copyUrl": "Link kopieren",
  "winterdoppel.players.waLinkCopied": "Kopiert",
  "winterdoppel.players.waLinkCopyFailed": "Kopieren fehlgeschlagen.",
  "winterdoppel.players.waLinkText":
    "Hallo {{name}},\n\nhier dein persönlicher Link für „{{series}}“ – Termine zusagen/absagen und Abwesenheiten pflegen:\n{{url}}\n",
  "winterdoppel.players.waLinkTextPlanner":
    "Hallo {{name}},\n\nhier dein persönlicher Link für „{{series}}“ – Termine pflegen und als Planer: Spieler ergänzen sowie den Saisonplan bestätigen:\n{{url}}\n",
  "winterdoppel.players.plannerBadge": "Planer",
  "winterdoppel.players.plannerToggle": "Planer",
  "winterdoppel.players.plannerToggleHint":
    "Mit dem persönlichen Link darf diese Person Spieler ergänzen und den Plan bestätigen.",
  "winterdoppel.players.plannerEnabled":
    "{{name}} kann über den persönlichen Link als Planer agieren.",
  "winterdoppel.players.plannerDisabled": "Planer-Recht für {{name}} entfernt.",
  "winterdoppel.planner.title": "Planer",
  "winterdoppel.planner.summaryHint": "Spieler ergänzen · Plan bestätigen",
  "winterdoppel.planner.hint":
    "Änderungen über diesen Link werden dir zugeordnet.",
  "winterdoppel.planner.addPlayer": "Spieler ergänzen",
  "winterdoppel.planner.addPlayerSubmit": "Hinzufügen",
  "winterdoppel.planner.playerAdded": "{{name}} wurde zur Serie hinzugefügt.",
  "winterdoppel.planner.nameRequired": "Bitte einen Namen eingeben.",
  "winterdoppel.planner.finalizeTitle": "Geplante Spiele bestätigen",
  "winterdoppel.planner.finalizeHint":
    "Fixiert die Grobplanung; Starter gelten als zugesagt.",
  "winterdoppel.planner.finalizeConfirm":
    "Saisonplan jetzt bestätigen? Starter-Termine werden auf „dabei“ gesetzt.",
  "winterdoppel.planner.finalizeSubmit": "Plan bestätigen",
  "winterdoppel.planner.finalizeDone": "Saisonplan ist bestätigt.",
  "winterdoppel.planner.alreadyFinal": "Der Saisonplan ist bereits bestätigt.",
  "winterdoppel.planner.openSchedule": "Öffentlichen Spielplan ansehen",
  "winterdoppel.planner.notAllowed": "Dieser Link hat keine Planer-Rechte.",
  "winterdoppel.plannerAudit.title": "Planer-Änderungsprotokoll",
  "winterdoppel.plannerAudit.hint":
    "Wer hat über einen Planer-Link oder die App was geändert – inkl. vergebener Planer-Rechte. Einträge bleiben auch nach Löschen des Spielers erhalten (Name als Snapshot).",
  "winterdoppel.plannerAudit.empty":
    "Noch keine Planer-Aktionen protokolliert.",
  "winterdoppel.plannerAudit.by": "von {{name}}",
  "winterdoppel.plannerAudit.unknownActor": "Unbekannt",
  "winterdoppel.plannerAudit.viaLink": "persönlicher Link",
  "winterdoppel.plannerAudit.viaApp": "App (eingeloggt)",
  "winterdoppel.plannerAudit.action.add_player": "Spieler hinzugefügt",
  "winterdoppel.plannerAudit.action.finalize_plan": "Saisonplan bestätigt",
  "winterdoppel.plannerAudit.action.grant_planner": "Planer-Recht vergeben",
  "winterdoppel.plannerAudit.action.revoke_planner": "Planer-Recht entzogen",
  "winterdoppel.plannerAudit.action.unknown": "Aktion",
  "winterdoppel.plannerAudit.detail.add_player": "Neuer Spieler: {{name}}",
  "winterdoppel.plannerAudit.detail.finalize_plan":
    "Grobplanung fixiert, Starter auf „dabei“.",
  "winterdoppel.plannerAudit.detail.planner_flag": "Betroffen: {{name}}",
  "winterdoppel.players.editTitle": "Spieler bearbeiten",
  "winterdoppel.players.stammdatenTitle": "Stammdaten",
  "winterdoppel.players.planningTitle": "Teilnahme & Spieltermine",
  "winterdoppel.players.name": "Name",
  "winterdoppel.players.phone": "Telefon / WhatsApp",
  "winterdoppel.players.bondPartner": "Fester Doppelpartner",
  "winterdoppel.players.bondNone": "Kein fester Partner",
  "winterdoppel.players.bondHint":
    "Wenn beide in derselben Starter-Runde landen, werden sie bevorzugt zusammen gepaart. Mehrere Wünsche pro Spieler sind möglich.",
  "winterdoppel.players.bondWith": "mit {{name}}",
  "winterdoppel.players.bondWithMany": "gerne mit {{names}}",
  "winterdoppel.players.bondSaved": "Partnerbindung gespeichert.",
  "winterdoppel.players.bondAdded": "Partnerwunsch hinzugefügt.",
  "winterdoppel.players.bondRemoved": "Partnerwunsch entfernt.",
  "winterdoppel.players.bondsTitle": "Partnerwünsche",
  "winterdoppel.players.bondsHint":
    "Wer gerne mit wem spielt: beliebig viele Paare. Pro Termin zieht das System höchstens einen Wunschpartner sanft nach und paart sie bevorzugt zusammen – nicht jede Woche zwingend alle Wünsche.",
  "winterdoppel.players.bondsEmpty": "Noch keine Partnerwünsche.",
  "winterdoppel.players.bondPlayerA": "Spieler 1",
  "winterdoppel.players.bondPlayerB": "Spieler 2",
  "winterdoppel.players.bondPick": "Spieler wählen…",
  "winterdoppel.players.bondAdd": "Wunsch hinzufügen",
  "winterdoppel.bond.invalid": "Ungültige Partnerbindung.",
  "winterdoppel.bond.playerAlreadyBound":
    "Dieses Paar ist bereits als Wunsch hinterlegt.",
  "winterdoppel.group.title": "Feste Trainingsgruppen",
  "winterdoppel.group.hint":
    "Saison-Abo läuft wöchentlich. Gruppen mit „alle 2 Wochen“ spielen im Wechsel (Gruppe 1 / Gruppe 2). In Schulferien und an Feiertagen entfällt der Termin.",
  "winterdoppel.group.name": "Gruppenname",
  "winterdoppel.group.intervalWeeks": "Intervall",
  "winterdoppel.group.intervalOption": "alle {{n}} Wochen",
  "winterdoppel.group.intervalWeekly": "jede Woche",
  "winterdoppel.group.weekday": "Wochentag",
  "winterdoppel.group.startTime": "Von",
  "winterdoppel.group.endTime": "Bis",
  "winterdoppel.group.scheduleStart": "Erster Termin ab",
  "winterdoppel.group.scheduleEnd": "Letzter Termin bis",
  "winterdoppel.group.holidayState": "Schulferien-Bundesland",
  "winterdoppel.group.excludeHolidays":
    "Termine in Schulferien und an Feiertagen auslassen",
  "winterdoppel.group.members": "Mitglieder",
  "winterdoppel.group.preview": "Vorschau: {{dates}}{{more}}",
  "winterdoppel.group.previewMore": " …",
  "winterdoppel.group.create": "Gruppe anlegen",
  "winterdoppel.group.update": "Gruppe speichern",
  "winterdoppel.group.saved": "Trainingsgruppe gespeichert.",
  "winterdoppel.group.deleted": "Trainingsgruppe gelöscht.",
  "winterdoppel.group.empty": "Noch keine festen Trainingsgruppen.",
  "winterdoppel.group.confirmDelete": "Trainingsgruppe wirklich löschen?",
  "winterdoppel.group.listMeta":
    "alle {{interval}} Wo. · {{weekday}} {{time}} · {{members}}",
  "winterdoppel.group.missingFields": "Bitte Name der Gruppe angeben.",
  "winterdoppel.group.needMembers": "Mindestens zwei Mitglieder wählen.",
  "winterdoppel.group.invalidSchedule":
    "Bitte gültigen Wochentag und Startdatum setzen.",
  "winterdoppel.group.scheduleOverlapHint":
    "Gleicher 2-Wochen-Rhythmus: Die Grobplanung versetzt die Gruppen automatisch (eine Woche Versatz), damit das wöchentliche Abo abwechselnd belegt wird.",
  "winterdoppel.group.swapPhases": "Wochenphasen tauschen",
  "winterdoppel.group.swapPhasesHint":
    "Gruppe 1 und 2 tauschen ihre Trainingssonntage (Woche A ↔ Woche B).",
  "winterdoppel.group.swapPhasesDone":
    "Wochenphasen getauscht – Trainingsplan neu berechnet.",
  "winterdoppel.group.swapPhasesUnavailable":
    "Phasentausch braucht mindestens zwei Gruppen mit gleichem 2-Wochen-Rhythmus.",
  "winterdoppel.group.swapPhasesOnce": "Nächstes Terminpaar tauschen",
  "winterdoppel.group.swapPhasesOnceHint":
    "Nur die nächsten zwei Termine tauschen (einmalig), danach bleibt der Rhythmus.",
  "winterdoppel.group.swapPhasesOnceDone": "Nächstes Terminpaar getauscht.",
  "winterdoppel.group.swapOnceUnavailable":
    "Kein künftiges Terminpaar zum Tausch gefunden.",
  "winterdoppel.group.savedPublished":
    "Gruppe gespeichert – künftige Termine neu zugeordnet.",
  "winterdoppel.training.notTrainingSeries":
    "Diese Aktion gilt nur für Trainings mit Trainern.",
  "winterdoppel.plan.addToSession": "Zu diesem Termin",
  "winterdoppel.plan.addToSessionPick": "Spieler hinzufügen",
  "winterdoppel.plan.removeFromSession": "Termin streichen",
  "winterdoppel.plan.lockedBannerTraining":
    "Plan veröffentlicht. Spieler kannst du je Termin ergänzen oder streichen. Gruppenwechsel und Wochentausch unter Aufstellung.",
  "winterdoppel.group.listFirstDate": "Erster Termin: {{date}}",
  "winterdoppel.group.trainer": "Trainer",
  "winterdoppel.group.trainerNone": "Kein Trainer",
  "winterdoppel.group.hourlyRate": "Stundensatz: {{rate}}",
  "winterdoppel.group.hourlyRateMissing": "Kein Stundensatz hinterlegt",
  "winterdoppel.group.costPreviewTitle": "Kostenschätzung",
  "winterdoppel.group.costTraining":
    "Trainingskosten: {{amount}} ({{sessions}}× {{hours}} h × {{rate}})",
  "winterdoppel.group.costHall": "Hallen-Abo (Serie): {{amount}}",
  "winterdoppel.group.costPerPlayer":
    "Je Mitglied: Training {{training}} · Halle {{hall}} · gesamt {{total}}",
  "winterdoppel.group.costGrand": "Gesamt (Gruppe + Hallenanteil): {{amount}}",
  "winterdoppel.group.listTrainer": "Trainer: {{name}}",
  "winterdoppel.group.listTrainingCost": "Training ca. {{amount}}",
  "winterdoppel.players.interest": "Interesse",
  "winterdoppel.players.weekRule": "Kalenderwochen",
  "winterdoppel.playLevel.label": "Spielstärke",
  "winterdoppel.playLevel.short": "Stärke",
  "winterdoppel.playLevel.inlineAria": "Spielstärke für {{name}}",
  "winterdoppel.playLevel.list": "Stärke {{level}}",
  "winterdoppel.playLevel.hint":
    "Ähnliche Spielstärken werden möglichst im selben Doppel gruppiert; stärkere Doppel landen tendenziell auf Platz 1.",
  "winterdoppel.playLevel.1": "1 – eher schwächer",
  "winterdoppel.playLevel.2": "2 – unter Mittel",
  "winterdoppel.playLevel.3": "3 – Mittelfeld (Standard)",
  "winterdoppel.playLevel.4": "4 – über Mittel",
  "winterdoppel.playLevel.5": "5 – eher stark",
  "winterdoppel.player.invalidPlayLevel":
    "Spielstärke muss zwischen 1 und 5 liegen.",
  "winterdoppel.players.cancelEdit": "Abbrechen",
  "winterdoppel.players.created": "Spieler angelegt.",
  "winterdoppel.players.saved": "Gespeichert.",
  "winterdoppel.players.confirmDelete": "Spieler wirklich löschen?",
  "winterdoppel.players.blocksTitle": "Abwesenheiten (Spieltermine)",
  "winterdoppel.players.blockFrom": "Von",
  "winterdoppel.players.blockTo": "Bis",
  "winterdoppel.players.blockReason": "Grund",
  "winterdoppel.players.addBlock": "Sperre hinzufügen",
  "winterdoppel.players.blockSaved":
    "Abwesenheiten gespeichert – Planung wird aktualisiert…",
  "winterdoppel.players.blockSavedFinal": "Abwesenheiten gespeichert.",
  "winterdoppel.players.blockSavedAndApplied":
    "Abwesenheiten gespeichert und Termine angepasst – Kosten bleiben unverändert.",
  "winterdoppel.players.replanning": "Grobplanung und Kosten werden berechnet…",
  "winterdoppel.players.savedAndReplanned":
    "Gespeichert, Grobplanung und Kosten aktualisiert.",
  "winterdoppel.players.listTitle": "Spieler ({{count}})",
  "winterdoppel.players.summaryMaybe": "{{count}} Gelegenheit gerne",
  "winterdoppel.players.summaryNo": "{{count}} abgesagt",
  "winterdoppel.players.selfService.done": "Selbst gepflegt",
  "winterdoppel.players.selfService.pending": "Noch offen",
  "winterdoppel.players.selfService.doneAt":
    "Zuletzt über Spieler-Link: {{date}}",
  "winterdoppel.players.selfService.summary":
    "{{done}} von {{total}} haben Verfügbarkeit selbst gepflegt",
  "winterdoppel.plan.matrix.selfServiceLegend": "Selbst gepflegt",
  "winterdoppel.players.empty": "Noch keine Spieler.",
  "winterdoppel.players.duplicateNames":
    "Doppelte Namen in dieser Serie: {{names}}. Bitte einen Eintrag löschen oder umbenennen, sonst wird derselbe Mensch doppelt eingeplant.",
  "winterdoppel.player.duplicateName":
    "In dieser Serie gibt es diesen Namen bereits.",
  "winterdoppel.player.invalidParticipationLimit":
    "Bitte einen gültigen Wert für die Teilnahme-Begrenzung eingeben.",
  "winterdoppel.absences.preplanBadge": "Vorplanung",
  "winterdoppel.absences.intro":
    "Termin antippen = abwesend. KW-Regel antippen = Ausnahme (doch dabei).",
  "winterdoppel.absences.hint":
    "Tippe auf einen Spieltermin, um Abwesenheit zu setzen oder zu entfernen. Termine außerhalb der KW-Regel kannst du als Ausnahme freischalten.",
  "winterdoppel.absences.bulkToggle":
    "Ferien & Zeiträume – mehrere Termine für die Planung",
  "winterdoppel.absences.bulkHint":
    "Betroffene Spieltermine werden automatisch als abwesend markiert.",
  "winterdoppel.absences.toolsTitle": "Regeln & Schnellwahl",
  "winterdoppel.absences.toolsHint":
    "Interesse und Kalenderwochen steuern die Termine. Ferien und Zeiträume markieren mehrere Abwesenheiten auf einmal.",
  "winterdoppel.absences.participationTitle": "Teilnahme",
  "winterdoppel.absences.bulkTitle": "Ferien & Zeitraum",
  "winterdoppel.absences.sessionsTitle": "Spieltermine",
  "winterdoppel.absences.sessionsLabel": "Spieltermine",
  "winterdoppel.absences.stateAbsent": "Abwesend",
  "winterdoppel.absences.stateAvailable": "Verfügbar",
  "winterdoppel.absences.stateWeekRule": "KW-Regel",
  "winterdoppel.absences.stateWeekOverride": "Ausnahme",
  "winterdoppel.absences.chipAbsent": "Abwesend: {{date}}",
  "winterdoppel.absences.chipAvailable": "Verfügbar: {{date}}",
  "winterdoppel.absences.chipWeekRule":
    "KW-Regel – antippen für Ausnahme: {{date}}",
  "winterdoppel.absences.chipWeekOverride":
    "Ausnahme (dabei trotz KW-Regel): {{date}}",
  "winterdoppel.absences.holidayHint":
    "Lass dir deine Ferien in deiner Region anzeigen. Klicke die Ferien an, in denen du sicher weg bist – sie werden oben in die Abwesenheiten (Spieltermine) übernommen. Nochmal tippen entfernt sie wieder.",
  "winterdoppel.absences.holidayState": "Bundesland (Schulferien)",
  "winterdoppel.absences.holidayStateNone": "Kein Bundesland",
  "winterdoppel.absences.holidayListLabel": "Schulferien auswählen",
  "winterdoppel.absences.holidaySelect": "Übernehmen",
  "winterdoppel.absences.holidaySelected": "Übernommen",
  "winterdoppel.absences.holidayNoneInSeason":
    "Keine Schulferien mit Spielterminen in dieser Saison.",
  "winterdoppel.absences.holidayNeedState":
    "Bitte zuerst ein Bundesland wählen.",
  "winterdoppel.absences.holidayLoadFailed":
    "Schulferien konnten nicht geladen werden.",
  "winterdoppel.absences.holidayApplied":
    "{{count}} Ferientermine als Abwesend gesetzt.",
  "winterdoppel.series.holidayState": "Bundesland (Schulferien)",
  "winterdoppel.series.holidayStateNone": "Kein Bundesland",
  "winterdoppel.series.holidayStateHint":
    "Für Spieler-Abwesenheiten: Schulferien dieses Bundeslands übernehmen.",
  "winterdoppel.absences.rangeHint":
    "Mehrere Termine auf einmal: Von–Bis nur innerhalb der Saison/Spieltermine wählen. Es werden nur echte Spieltermine (z. B. Montage) in diesem Zeitraum als abwesend markiert.",
  "winterdoppel.absences.rangeFrom": "Von",
  "winterdoppel.absences.rangeTo": "Bis (optional)",
  "winterdoppel.absences.applyRange": "Zeitraum übernehmen",
  "winterdoppel.absences.needSeason": "Serie ohne Saisonzeitraum.",
  "winterdoppel.absences.emptySessions":
    "Keine Spieltermine im Serienzeitraum.",
  "winterdoppel.plan.needSeries": "Bitte zuerst eine Serie wählen.",
  "winterdoppel.plan.title": "Saisonplan",
  "winterdoppel.plan.hint":
    "Planungsmodus: Starter (4 je Platz) plus Warteliste nach gewähltem Fairness-Modus. Im Trainingsmodus wöchentliches Abo, Gruppen im 2-Wochen-Wechsel; Ferien/Feiertage entfallen. Nach Bestätigung bleiben die Kosten fix.",
  "winterdoppel.plan.generate": "Termine erzeugen",
  "winterdoppel.plan.autofill": "Grobplanung (zufällig)",
  "winterdoppel.plan.autofill.never":
    "Noch keine Grobplanung – bitte einmal ausführen.",
  "winterdoppel.plan.autofill.empty":
    "Grobplanung ohne Einsätze – bitte erneut ausführen.",
  "winterdoppel.plan.autofill.upToDate":
    "Grobplanung ist aktuell (zuletzt {date}) – Neulauf jederzeit möglich.",
  "winterdoppel.plan.autofill.stale":
    "Neue Angaben von Teilnehmern seit {date} – Grobplanung aktualisieren.",
  "winterdoppel.plan.generated": "Termine angelegt.",
  "winterdoppel.plan.autofilled": "Grobplanung berechnet.",
  "winterdoppel.plan.empty": "Noch keine Termine – bitte erzeugen.",
  "winterdoppel.plan.openPlanningEmpty":
    "Keine offenen Termine mehr zur Planung – vergangene Termine sind ausgeblendet.",
  "winterdoppel.plan.starters": "Spieler",
  "winterdoppel.plan.reserves": "Ersatz",
  "winterdoppel.plan.waitlist": "Warteliste",
  "winterdoppel.plan.waitlistFairnessHint":
    "Reihenfolge nach Fairness (Geplant ÷ Verfügbar) – wird bei Nachrücken neu berechnet.",
  "winterdoppel.plan.mode.planning": "Planungsmodus",
  "winterdoppel.plan.mode.locked": "Kosten fixiert",
  "winterdoppel.plan.mode.detail": "Detailplanung",
  "winterdoppel.plan.eveningCost": "Termin {{amount}}",
  "winterdoppel.plan.eveningCostFormula":
    "Termin {{amount}} ({{rate}} × {{hours}} h × {{courts}})",
  "winterdoppel.plan.eveningCostAbo":
    "Termin {{amount}} (Saison-Abo {{season}} ÷ {{count}} Termine)",
  "winterdoppel.plan.pays": "zahlt {{amount}}",
  "winterdoppel.plan.finalize": "Saisonplan veröffentlichen",
  "winterdoppel.plan.finalizeConfirm":
    "Saisonplan veröffentlichen? Teilnehmer können danach ihre Termine zusagen oder absagen. Stammdaten der Serie bleiben danach eingeschränkt änderbar.",
  "winterdoppel.plan.finalized": "Saisonplan veröffentlicht.",
  "winterdoppel.plan.finalizedWithDesk":
    "Saisonplan veröffentlicht – Termine wurden im TrainingsDesk angelegt.",
  "winterdoppel.plan.reopen": "Saisonplan zurücksetzen",
  "winterdoppel.plan.reopenHint":
    "Vor dem ersten Termin kannst du den Plan wieder in den Entwurfsmodus setzen und neu planen.",
  "winterdoppel.plan.reopenConfirm":
    "Saisonplan zurücksetzen? Der Plan wird wieder zum Entwurf – danach kannst du die Grobplanung erneut ausführen. Zu-/Absagen bleiben erhalten, bis du neu planst.",
  "winterdoppel.plan.reopened": "Saisonplan ist wieder im Entwurfsmodus.",
  "winterdoppel.plan.reopenTooLate":
    "Zurücksetzen ist nur vor dem ersten Termin möglich.",
  "winterdoppel.plan.reopenDenied":
    "Saisonplan kann nicht zurückgesetzt werden.",
  "winterdoppel.deskSync.contactCreateFailed":
    "Kontakt für einen Spieler konnte nicht angelegt werden.",
  "winterdoppel.deskSync.sessionCreateFailed":
    "TrainingsDesk-Termin konnte nicht angelegt werden.",
  "winterdoppel.plan.autofillPublishedConfirm":
    "Grobplanung erneut ausführen? Bereits manuell bearbeitete Termine und Zu-/Absagen können überschrieben werden.",
  "winterdoppel.plan.notFound": "Termin oder Spieler nicht gefunden.",
  "winterdoppel.plan.statusDraftOnly":
    "Einzeltermine können erst nach Bestätigung der Saisonplanung angefragt oder bestätigt werden.",
  "winterdoppel.plan.locked":
    "Die Saisonplanung ist bestätigt – Spieler können für diese Runde nicht mehr geändert werden.",
  "winterdoppel.plan.lockedBanner":
    "Kosten sind fix. 0–4 Tage vor dem Termin: Absage rückt den Nächsten von der Warteliste nach.",
  "winterdoppel.plan.matrix.title": "Spielplan-Matrix",
  "winterdoppel.plan.matrix.titleTraining": "Trainingsplan-Matrix",
  "winterdoppel.plan.matrix.subtitle":
    "Saisonplan – Übersicht je Spieler und Termin",
  "winterdoppel.plan.matrix.print": "Als PDF drucken",
  "winterdoppel.plan.matrix.printHint":
    "Öffnet eine Druckvorschau mit farbiger Belegung und Warteliste (W). Optional: Querformat und „Hintergrund drucken“ für Farben.",
  "winterdoppel.plan.matrix.player": "Spieler",
  "winterdoppel.plan.matrix.filterLabel": "Spieler filtern / vergleichen",
  "winterdoppel.plan.matrix.filterPlaceholder": "Namen eingeben…",
  "winterdoppel.plan.matrix.filterHint":
    "Ein Name filtern – oder zwei Namen (Leerzeichen, Komma oder &) für Miteinander/Gegeneinander",
  "winterdoppel.plan.matrix.filterEmpty": "Kein Spieler passt zum Filter.",
  "winterdoppel.plan.matrix.pair.partners": "Miteinander (Partner)",
  "winterdoppel.plan.matrix.pair.opponents": "Gegeneinander",
  "winterdoppel.plan.matrix.pair.same_court": "Selbes Doppel (Paarung unklar)",
  "winterdoppel.plan.matrix.pair.other_court": "Gleicher Abend, anderes Doppel",
  "winterdoppel.plan.matrix.pair.summary":
    "{{a}} & {{b}}: Miteinander {{partners}}× · Gegeneinander {{opponents}}× · selbes Doppel {{sameCourt}}× · anderer Platz {{otherCourt}}×",
  "winterdoppel.plan.matrix.legendCourt": "Doppel {{court}}",
  "winterdoppel.plan.matrix.legendGroup": "Gruppe {{court}}",
  "winterdoppel.plan.matrix.legendTraining": "Training",
  "winterdoppel.plan.matrix.legendReserve": "Warteliste",
  "winterdoppel.plan.matrix.legendNone":
    "Nicht eingeplant (kein Doppel, nicht auf Warteliste)",
  "winterdoppel.plan.matrix.legendHoliday": "Ferien / kein Training",
  "winterdoppel.plan.matrix.legendHolidayNamed": "Ferien: {{name}}",
  "winterdoppel.plan.matrix.abbrLegendTitle": "Abkürzungen",
  "winterdoppel.plan.matrix.groupHeader": "Gruppe {{index}}: {{name}}",
  "winterdoppel.plan.matrix.groupHeaderWithMembers":
    "Gruppe {{index}}: {{name}} ({{members}})",
  "winterdoppel.plan.matrix.groupUngrouped": "Weitere Spieler",
  "winterdoppel.plan.matrix.manualOff": "Manuell ausgelassen",
  "winterdoppel.plan.matrix.manualOffShort": "Aus",
  "winterdoppel.plan.matrix.overrideIntro":
    "Datum anklicken: Ferien → doch Training, oder Training → auslassen. Erneut klicken setzt zurück.",
  "winterdoppel.plan.matrix.overrideHintForceOn":
    "Klicken: trotz Ferien Training anbieten",
  "winterdoppel.plan.matrix.overrideHintForceOff":
    "Klicken: diesen Termin auslassen",
  "winterdoppel.plan.matrix.overrideForcedOn":
    "Termin manuell eingeschaltet (trotz Ferien).",
  "winterdoppel.plan.matrix.overrideForcedOff": "Termin manuell ausgelassen.",
  "winterdoppel.plan.matrix.overrideReset": "Manuelle Ausnahme zurückgesetzt.",
  "winterdoppel.plan.unusedPlayers.title": "Ohne Trainingseinsatz",
  "winterdoppel.plan.unusedPlayers.hint":
    "Diese Spieler haben in der Grobplanung keinen Starter-Termin (z. B. keiner Gruppe zugeordnet). Unnötige Einträge kannst du entfernen.",
  "winterdoppel.plan.unusedPlayers.remove": "Aus Serie entfernen",
  "winterdoppel.plan.unusedPlayers.confirmDelete":
    "{{name}} wirklich aus dieser Serie entfernen?",
  "winterdoppel.plan.unusedPlayers.deleted": "{{name}} entfernt.",
  "winterdoppel.plan.group": "Gruppe {{court}}",
  "winterdoppel.plan.fullGroup": "Gesamtgruppe",
  "winterdoppel.plan.groupExtra": "Weitere Spieler",
  "winterdoppel.plan.court": "Platz {{court}}",
  "winterdoppel.plan.vs": "vs",
  "winterdoppel.whatsapp.groupHeading": "Gruppe {{court}}:",
  "winterdoppel.whatsapp.tone.plain.groupHeading": "Gruppe {{court}}:",
  "winterdoppel.whatsapp.tone.factual.groupHeading": "Gruppe {{court}}:",
  "winterdoppel.whatsapp.tone.emotional.default.groupHeading":
    "Gruppe {{court}}:",
  "winterdoppel.plan.matrix.legendElapsed": "Vergangen",
  "winterdoppel.plan.matrix.legendReservePos": "Warteliste Position {{rank}}",
  "winterdoppel.plan.matrix.warningsTitle": "Hinweise zur Belegung",
  "winterdoppel.plan.matrix.warning.threeInDouble":
    "{{date}}: Nur 3 Spieler für Doppel {{court}} – kein vierter Spieler (auch nicht aus der Warteliste).",
  "winterdoppel.plan.matrix.warning.insufficientDoubles":
    "{{date}}: Nur {{pool}} Spieler für {{courts}} Doppel ({{needed}} nötig).",
  "winterdoppel.plan.matrix.warning.insufficientPlayers":
    "{{date}}: Nur {{pool}} Spieler – weder Doppel noch Einzel möglich.",
  "winterdoppel.plan.matrix.warning.courtMixSuggestion":
    "{{date}}: Vorschlag: {{doubles}} Doppel, {{singles}} Einzel, {{waitlist}} Warteliste{{unused}}.",
  "winterdoppel.plan.matrix.warning.courtMixUnused":
    ", {{count}} Platz ungenutzt",
  "winterdoppel.plan.matrix.warning.columnMark": "Hinweis",
  "winterdoppel.plan.status.draft": "In Vorbereitung",
  "winterdoppel.plan.status.final": "Veröffentlicht",
  "winterdoppel.fairness.needSeries": "Bitte zuerst eine Serie wählen.",
  "winterdoppel.fairness.title": "Saison-Fairness",
  "winterdoppel.fairness.hint":
    "Geplant = aktive Starter (Absagen zählen nicht). Verfügbar = Termine ohne Abwesenheit/Wochenregel. Ziel max. = Obergrenze laut Teilnahme-Einstellung. Quote = Geplant ÷ min(Verfügbar, Ziel). Absagen = Rückmeldung Nein (nur nach Veröffentlichung).",
  "winterdoppel.fairness.modeActive.proportional":
    "Aktiver Modus: Prozentual (Quote Geplant ÷ Verfügbar).",
  "winterdoppel.fairness.modeActive.equal_load":
    "Aktiver Modus: Gleiche Belastung (möglichst gleiche Anzahl Einsätze; Verfügbarkeit begrenzt nur die Tage).",
  "winterdoppel.fairness.colCap": "Ziel max.",
  "winterdoppel.fairness.empty": "Noch keine Spieler in dieser Serie.",
  "winterdoppel.fairness.duplicateNames":
    "Doppelte Namen: {{names}}. Das sind getrennte Datensätze – bitte unter Spieler bereinigen.",
  "winterdoppel.fairness.colPlayer": "Spieler",
  "winterdoppel.fairness.colAvailable": "Verfügbar",
  "winterdoppel.fairness.colPlanned": "Geplant",
  "winterdoppel.fairness.colEinsaetze": "Geplant",
  "winterdoppel.fairness.colAbsagen": "Absagen",
  "winterdoppel.fairness.colQuote": "Quote",
  "winterdoppel.fairness.quoteValue": "{{percent}} %",
  "winterdoppel.fairness.quoteEmpty": "–",
  "winterdoppel.costs.needSeries": "Bitte zuerst eine Serie wählen.",
  "winterdoppel.costs.title": "Geplante Kosten",
  "winterdoppel.costs.hint":
    "Summe der Kostenanteile je Spieler nach Grobplanung. Beim Saison-Abo wird der Gesamtbetrag gleichmäßig auf alle Starter-Einsätze verteilt. Im Trainingsmodus zählen die Termine der Gruppen (Intervall + Ferien).",
  "winterdoppel.costs.lockedHint":
    "Fixierte Saisonkosten nach Plan-Bestätigung. Absage: kein Guthaben (Pech). Ungeplanter Neuzugang zahlt 1/N erst wenn er mitspielt; bestehende Spieler erhalten dann Guthaben. Offen = Zahlbetrag − Voraus.",
  "winterdoppel.costs.colCredit": "Guthaben",
  "winterdoppel.costs.colNet": "Zahlbetrag",
  "winterdoppel.costs.lateJoinerNote": "Nachzügler ({{count}})",
  "winterdoppel.costs.creditNote": "Guthaben (Neuzugang)",
  "winterdoppel.costs.incompleteCoverage":
    "Saison-Abo ist nicht vollständig verteilt – bitte Grobplanung erneut ausführen, dann bestätigen.",
  "winterdoppel.costs.lockedMismatch":
    "Warnung: Belastung minus Guthaben deckt das Saison-Abo nicht ab.",
  "winterdoppel.costs.evening": "Kosten je Termin: {{amount}}",
  "winterdoppel.costs.assignedTotal": "Zugewiesen gesamt: {{amount}}",
  "winterdoppel.costs.summaryAbo":
    "Saison-Abo {{season}} · je Termin {{evening}} ({{count}}×) · zugewiesen {{assigned}}",
  "winterdoppel.costs.summaryAboSlots":
    "Saison-Abo {{season}} · {{slots}} Starter-Einsätze · je Einsatz {{perSlot}} · zugewiesen {{assigned}}",
  "winterdoppel.costs.staleHint":
    "Die Spieleranteile passen nicht zum Saison-Abo – bitte neu berechnen.",
  "winterdoppel.costs.recompute": "Grobplanung & Kosten neu berechnen",
  "winterdoppel.costs.recomputed": "Kostenanteile aktualisiert.",
  "winterdoppel.costs.empty":
    "Noch keine Kostenanteile – zuerst Grobplanung ausführen.",
  "winterdoppel.costs.colPlayer": "Spieler",
  "winterdoppel.costs.colEvenings": "Termine",
  "winterdoppel.costs.colTotal": "Summe",
  "winterdoppel.costs.totalRow": "Gesamt",
  "winterdoppel.costs.prepayHint":
    "Vorauszahlungen der Stammspieler erfassen. Offen: rot Rückstand, grün Guthaben, schwarz ausgeglichen (Soll − gezahlt).",
  "winterdoppel.costs.colPrepaid": "Voraus",
  "winterdoppel.costs.colSettlement": "Offen",
  "winterdoppel.costs.payExtra": "Rückstand {{amount}}",
  "winterdoppel.costs.refundDue": "Guthaben {{amount}}",
  "winterdoppel.costs.settled": "ausgeglichen",
  "winterdoppel.costs.prepayAmount": "Betrag (€)",
  "winterdoppel.costs.prepayAdd": "Buchen",
  "winterdoppel.costs.prepayAdded": "Vorauszahlung erfasst.",
  "winterdoppel.costs.prepayDelete": "Vorauszahlung entfernen",
  "winterdoppel.costs.prepayInvalid": "Bitte einen Betrag größer 0 eingeben.",
  "winterdoppel.prepayment.freeModeOnly":
    "Vorauszahlungen gibt es nur bei Freiem Spiel.",
  "winterdoppel.prepayment.modeNotAllowed":
    "Vorauszahlungen sind für diesen Serienmodus nicht erlaubt.",
  "winterdoppel.prepayment.invalid": "Vorauszahlung ungültig.",
  "winterdoppel.costs.prepayHintTraining":
    "Vorauszahlungen der Teilnehmer erfassen. Bei Training wird der Betrag zusätzlich als Desk-Guthaben beim Gruppentrainer notiert und auf Rechnungen verrechnet.",
  "winterdoppel.week.needSeries": "Bitte zuerst eine Serie wählen.",
  "winterdoppel.week.empty": "Kein Termin vorhanden.",
  "winterdoppel.week.emptyHint": "Unter Plan Termine erzeugen und befüllen.",
  "winterdoppel.week.yesOfCapacity": "{{yes}} / {{capacity}} zugesagt",
  "winterdoppel.week.copyWhatsApp": "WhatsApp-Text kopieren",
  "winterdoppel.week.openWhatsApp": "In WhatsApp öffnen",
  "winterdoppel.week.openWhatsAppEmpty": "Kein Text zum Versenden.",
  "winterdoppel.week.copied": "In Zwischenablage kopiert",
  "winterdoppel.week.copyFailed": "Kopieren fehlgeschlagen.",
  "winterdoppel.week.whatsAppPreview": "WhatsApp-Nachricht",
  "winterdoppel.week.whatsAppHint":
    "Button kopiert in die Zwischenablage – hier zur Kontrolle und zum manuellen Kopieren.",
  "winterdoppel.week.showWhatsAppPreview": "Vorschau anzeigen",
  "winterdoppel.week.hideWhatsAppPreview": "Vorschau ausblenden",
  "winterdoppel.week.whatsAppTone": "Tonfall",
  "winterdoppel.week.whatsAppTone.plain": "Nüchtern",
  "winterdoppel.week.whatsAppTone.factual": "Sachlich",
  "winterdoppel.week.whatsAppTone.emotional": "Emotional",
  "winterdoppel.week.whatsAppTone.funny": "Lustig",
  "winterdoppel.week.whatsAppSeason": "Saison-Thema: {{season}}",
  "winterdoppel.week.whatsAppSeason.nikolaus": "Nikolaus",
  "winterdoppel.week.whatsAppSeason.christmas": "Weihnachten",
  "winterdoppel.week.whatsAppSeason.winter": "Winter",
  "winterdoppel.week.whatsAppSeason.spring": "Frühjahr",
  "winterdoppel.week.whatsAppSeason.autumn": "Herbst",
  "winterdoppel.week.whatsAppSeason.default": "Allgemein",
  "winterdoppel.week.markAsked": "Als angefragt markieren",
  "winterdoppel.week.toReserve": "→ Warteliste",
  "winterdoppel.week.toStarter": "→ Starter",
  "winterdoppel.week.waitlistPos": "Pos. {{rank}}",
  "winterdoppel.week.absences": "Absagen",
  "winterdoppel.week.restoreAbsence": "Wieder einplanen",
  "winterdoppel.week.detailBanner":
    "Detailplanung (0–4 Tage): Absage zieht den Nächsten von der Warteliste nach. Kosten gehen auf den Nachzügler über; der Absagende erhält kein Guthaben.",
  "winterdoppel.week.sessionCostsTitle": "Kostenanteile diesen Abend",
  "winterdoppel.week.dragSwapHint":
    "Spieler per Drag & Drop tauschen (auf einen anderen Namen ziehen).",
  "winterdoppel.week.sessionCostsHint":
    "Wenn kein volles Doppel zustande kommt oder ein Gast bar zahlt: Anteile neu verteilen.",
  "winterdoppel.week.sessionCostsEqual": "Gleichmäßig",
  "winterdoppel.week.sessionCostsSingles2": "2 Einzel (½ / ½)",
  "winterdoppel.week.sessionCostsGuestCash": "Gast bar an …",
  "winterdoppel.week.sessionCostsApplyGuest": "Anwenden",
  "winterdoppel.week.sessionCostsApplied": "Kostenanteile aktualisiert.",
  "winterdoppel.week.sessionCostsCollector": "Geld vom Gast bei",
  "winterdoppel.sessionCosts.freeModeOnly":
    "Flexible Abendanteile gibt es nur bei Freiem Spiel.",
  "winterdoppel.sessionCosts.needTwoPayers":
    "„2 Einzel“ braucht genau zwei aktive Spieler.",
  "winterdoppel.sessionCosts.needCollector":
    "Bitte wählen, wer das Gastgeld entgegengenommen hat.",
  "winterdoppel.sessionCosts.invalidPreset": "Unbekanntes Kosten-Preset.",
  "winterdoppel.week.lateJoinerTitle": "Nachzügler eintragen",
  "winterdoppel.week.lateJoinerHint":
    "Spieler, der bisher nicht am Termin war, übernimmt den Kostenanteil des Absagenden.",
  "winterdoppel.week.lateJoinerPlayer": "Spieler",
  "winterdoppel.week.lateJoinerReplaces": "Ersetzt",
  "winterdoppel.week.lateJoinerAdd": "Als Nachzügler eintragen",
  "winterdoppel.week.lateJoinerBadge": "Nachzügler",
  "winterdoppel.week.creditBadge": "Guthaben {{amount}}",
  "winterdoppel.week.replaces": "für {{name}}",
  "winterdoppel.lateJoiner.invalid": "Ungültige Eingabe für Nachzügler.",
  "winterdoppel.lateJoiner.needFinalPlan":
    "Nachzügler sind erst nach Plan-Bestätigung möglich.",
  "winterdoppel.lateJoiner.playerNotInSeries":
    "Spieler gehört nicht zur Serie.",
  "winterdoppel.lateJoiner.alreadyPlaying":
    "Spieler ist bereits am Termin eingeplant.",
  "winterdoppel.lateJoiner.invalidReplacement": "Absage nicht gefunden.",
  "winterdoppel.lateJoiner.noTransferableCost":
    "Für diese Absage wurde der Anteil bereits übertragen.",
  "winterdoppel.whatsapp.startersHeading": "Geplant:",
  "winterdoppel.whatsapp.reservesHeading": "Ersatz:",
  "winterdoppel.whatsapp.cta": "Bitte kurz melden: dabei / nicht dabei.",
  "winterdoppel.whatsapp.courtHeading": "Platz {{court}}:",
  "winterdoppel.whatsapp.unpairedHeading": "Ohne Paarung:",
  "winterdoppel.whatsapp.greeting.players": "Liebe Spieler,",
  "winterdoppel.whatsapp.greeting.servers": "Den Aufschlägern der Woche,",
  "winterdoppel.whatsapp.greeting.forehand":
    "An die mit der schnellsten Vorhand,",
  "winterdoppel.whatsapp.greeting.doubles": "Liebe Doppel-Fans,",
  "winterdoppel.whatsapp.greeting.court": "Hallo Hallen-Crew,",
  "winterdoppel.whatsapp.greeting.team": "Liebes Team,",
  "winterdoppel.whatsapp.greeting.hall": "Servus aus der Halle,",
  "winterdoppel.whatsapp.greeting.together": "Hallo zusammen,",
  "winterdoppel.whatsapp.greeting.champions": "An die Wochen-Champions,",
  "winterdoppel.whatsapp.tone.plain.intro": "Kurz zum Termin:",
  "winterdoppel.whatsapp.tone.plain.startersHeading": "Geplant:",
  "winterdoppel.whatsapp.tone.plain.reservesHeading": "Ersatz:",
  "winterdoppel.whatsapp.tone.plain.courtHeading": "Platz {{court}}:",
  "winterdoppel.whatsapp.tone.plain.unpairedHeading": "Ohne Paarung:",
  "winterdoppel.whatsapp.tone.plain.courtVs": "vs",
  "winterdoppel.whatsapp.tone.plain.cta":
    "Kurze Rückmeldung: dabei / nicht dabei.",
  "winterdoppel.whatsapp.tone.factual.intro":
    "Hier die Planung für kommende Woche am {{date}} um {{time}} Uhr:",
  "winterdoppel.whatsapp.tone.factual.startersHeading": "Geplante Starter:",
  "winterdoppel.whatsapp.tone.factual.reservesHeading": "Warteliste:",
  "winterdoppel.whatsapp.tone.factual.courtHeading": "Platz {{court}}:",
  "winterdoppel.whatsapp.tone.factual.unpairedHeading": "Noch ohne Paarung:",
  "winterdoppel.whatsapp.tone.factual.courtVs": "gegen",
  "winterdoppel.whatsapp.tone.factual.cta": "Passt euch?",
  "winterdoppel.whatsapp.tone.emotional.default.intro": "Freu mich auf euch!",
  "winterdoppel.whatsapp.tone.emotional.default.startersHeading": "Dabei sind:",
  "winterdoppel.whatsapp.tone.emotional.default.reservesHeading": "Als Ersatz:",
  "winterdoppel.whatsapp.tone.emotional.default.courtHeading":
    "Platz {{court}}:",
  "winterdoppel.whatsapp.tone.emotional.default.courtVs": "vs",
  "winterdoppel.whatsapp.tone.emotional.default.cta":
    "Sagt mir bitte kurz Bescheid, ob ihr dabei seid! 🎾",
  "winterdoppel.whatsapp.tone.emotional.winter.intro":
    "Endlich wieder Hallenluft! ❄️",
  "winterdoppel.whatsapp.tone.emotional.winter.cta":
    "Wer ist dabei? Meldet euch bitte – wir wärmen uns gemeinsam auf! 🧤",
  "winterdoppel.whatsapp.tone.emotional.autumn.intro":
    "Die Saison läuft – wer ist mit dabei?",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.intro":
    "Nikolaus checkt die Schläger! 🎅",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.cta":
    "Wer war brav und kommt? Bitte kurz melden! 🎁",
  "winterdoppel.whatsapp.tone.emotional.christmas.intro":
    "Alle Jahre wieder … 🎄",
  "winterdoppel.whatsapp.tone.emotional.christmas.cta":
    "Frohe Vorfreude – wer spielt mit? Bitte kurz antworten! ✨",
  "winterdoppel.whatsapp.tone.emotional.spring.intro":
    "Frühling in der Halle! 🌱",
  "winterdoppel.whatsapp.tone.funny.default.intro": "Achtung, Schläger alarm!",
  "winterdoppel.whatsapp.tone.funny.default.cta":
    "Wer kommt wirklich – und wer hat wieder Ausreden parat? 😄",
  "winterdoppel.whatsapp.tone.funny.winter.intro":
    "Frostbeule-Alarm – wer traut sich? 🥶",
  "winterdoppel.whatsapp.tone.funny.winter.cta":
    "Melden oder es gibt nur noch kalte Bälle. ❄️",
  "winterdoppel.whatsapp.tone.funny.autumn.intro":
    "Blätter fallen, Bälle fliegen.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro":
    "Ho ho ho – wer war brav und kommt zum Doppel? 🎅",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta":
    "Süßes oder saures Match? Bitte melden! 🍫",
  "winterdoppel.whatsapp.tone.funny.nikolaus.courtVs": "trifft auf",
  "winterdoppel.whatsapp.tone.funny.christmas.intro":
    "Alle Jahre wieder … wer vergisst die Tennisschuhe? 🎄",
  "winterdoppel.whatsapp.tone.funny.christmas.cta":
    "Engelsgeduld: bitte bis morgen melden, ob ihr dabei seid! 🎁",
  "winterdoppel.whatsapp.tone.funny.spring.intro":
    "Frühling! Die Netze sind aufgetaut. 🌷",
  "winterdoppel.schedule.title": "Spielplan",
  "winterdoppel.schedule.titleTraining": "Trainingsplan",
  "winterdoppel.schedule.rahmenplanTitle": "Rahmenplan",
  "winterdoppel.schedule.rahmenplanHint":
    "Termin antippen, um Schwerpunkt, Technik und Spielform zu sehen.",
  "winterdoppel.schedule.loading": "Laden…",
  "winterdoppel.schedule.notFound": "Spielplan nicht gefunden.",
  "winterdoppel.schedule.hint":
    "Übersicht der geplanten Termine und Zuordnungen.",
  "winterdoppel.schedule.planStatus.draftLabel": "Noch nicht fix",
  "winterdoppel.schedule.planStatus.draftTitle": "Planung noch nicht bestätigt",
  "winterdoppel.schedule.planStatus.draftHint":
    "Termine und Kosten können sich noch ändern, bis die Saisonplanung bestätigt ist.",
  "winterdoppel.schedule.planStatus.finalLabel": "Bestätigt",
  "winterdoppel.schedule.planStatus.finalTitle": "Planung bestätigt",
  "winterdoppel.schedule.planStatus.finalHint":
    "Termine und Kostenanteile sind fix.",
  "winterdoppel.schedule.planStatus.finalAck": "Verstanden",
  "winterdoppel.schedule.empty": "Noch keine Termine geplant.",
  "winterdoppel.schedule.noAssignments": "Noch keine Zuordnung",
  "winterdoppel.schedule.password": "Passwort",
  "winterdoppel.schedule.passwordHint":
    "Dieser Spielplan ist passwortgeschützt.",
  "winterdoppel.schedule.passwordRequired": "Bitte Passwort eingeben.",
  "winterdoppel.schedule.invalidPassword": "Passwort ist falsch.",
  "winterdoppel.schedule.unlock": "Öffnen",
  "winterdoppel.schedule.costsTitle": "Voraussichtliche Kosten je Empfänger",
  "winterdoppel.schedule.costsTitleFinal": "Kosten je Spieler",
  "winterdoppel.schedule.costsEmpty": "Noch keine Kostenanteile berechnet.",
  "winterdoppel.schedule.focusTitle": "Meine Kinder / Spieler",
  "winterdoppel.schedule.focusHint":
    "Ein Kind, mehrere Kinder, eine Gruppe oder dich als Empfänger wählen – dann nur diese Termine und Kosten.",
  "winterdoppel.schedule.focusAll": "Alle anzeigen",
  "winterdoppel.schedule.focusRecipient": "Spieler / Eltern",
  "winterdoppel.schedule.focusGroup": "Gruppe wählen…",
  "winterdoppel.schedule.focusPick": "Bitte wählen…",
  "winterdoppel.schedule.focusPlayers": "Spieler (Mehrfachauswahl)",
  "winterdoppel.schedule.focusShortcutRecipient": "Meine Kinder von {{name}}",
  "winterdoppel.schedule.focusShortcutGroup": "Gruppe {{name}}",
  "winterdoppel.schedule.myGroup": "Deine Gruppe: {{name}}",
  "winterdoppel.schedule.myGroupMembers": "Mit: {{names}}",
  "winterdoppel.schedule.myGroupNone": "Noch keiner festen Gruppe zugeordnet.",
  "winterdoppel.schedule.myPlanTitle": "Deine Termine",
  "winterdoppel.schedule.myPlanEmpty": "Keine Termine für diese Auswahl.",
  "winterdoppel.schedule.myPlanColDate": "Termin",
  "winterdoppel.schedule.myPlanColStatus": "Status",
  "winterdoppel.schedule.myRolePlaying": "Dabei",
  "winterdoppel.schedule.myRoleAbsent": "Abwesend",
  "winterdoppel.schedule.myRoleOff": "Nicht eingeplant",
  "winterdoppel.schedule.myStatusNamed": "{{name}}: {{status}}",
  "winterdoppel.schedule.costsMine": "Deine voraussichtlichen Kosten",
  "winterdoppel.schedule.costsMineFinal": "Deine Kosten",
  "winterdoppel.schedule.sessionPlanStatus": "Aktueller Planungsstand",
  "winterdoppel.schedule.groupsTitle": "Gruppen",
  "winterdoppel.schedule.groupLabel": "Gruppe {{index}}: {{name}}",
  "winterdoppel.schedule.groupPlays": "{{name}} spielt",
  "winterdoppel.schedule.mobilePlanTitle": "Spielplan nach Gruppe",
  "winterdoppel.schedule.mobilePlanTitleTraining": "Trainingsplan nach Gruppe",
  "winterdoppel.schedule.mobilePlanHint":
    "Wer trainiert an welchem Termin – kompakt fürs Handy.",
  "winterdoppel.schedule.mobilePlanColGroup": "Gruppe",
  "winterdoppel.join.title": "Anmeldung Serientermine",
  "winterdoppel.join.careTitle": "Dein Spielplan",
  "winterdoppel.join.profileToggle": "Kontaktdaten (optional)",
  "winterdoppel.join.profileHint":
    "Dein persönlicher Link reicht zum Mitplanen. Kontaktdaten sind freiwillig – sie helfen dem Organisator und dir bei Infos.",
  "winterdoppel.join.emailHint":
    "Damit der Organisator dich erreichen kann und du Hinweise (z. B. Plan-Updates) per Mail bekommen kannst. Bei öffentlicher Anmeldung brauchst du eine bestätigte E-Mail, um im Spielplan sichtbar zu sein.",
  "winterdoppel.join.phoneHint":
    "Für kurze Absprachen per Telefon oder WhatsApp – z. B. Absagen, Ersatzsuche oder Gruppeninfos.",
  "winterdoppel.join.preplanInterestHint":
    "Sag dem Organisator, ob du grundsätzlich dabei bist.",
  "winterdoppel.join.preplanWeekRuleHint":
    "Wenn du nur in geraden oder ungeraden Kalenderwochen kannst, wähle das hier. Einzelne Termine außerhalb der Regel kannst du als Ausnahme freischalten.",
  "winterdoppel.join.interestNoConfirm":
    "Wirklich zurückziehen? Mit „Nein“ meldest du dich für diese Serie ab – der Organisator sieht dich nicht mehr als dabei.",
  "winterdoppel.join.interestNoSaved":
    "Du hast dich abgemeldet. Du kannst das Interesse jederzeit wieder auf „Dabei“ setzen.",
  "winterdoppel.join.rosterTitle": "Aktuell dabei",
  "winterdoppel.join.rosterHint":
    "Spieler mit Interesse „Dabei“ oder „Vielleicht“ (sichtbar für die Serie).",
  "winterdoppel.join.rosterEmpty": "Noch niemand sichtbar dabei.",
  "winterdoppel.join.rosterMaybe": "Vielleicht",
  "winterdoppel.join.loading": "Laden…",
  "winterdoppel.join.notFound": "Einladung nicht gefunden.",
  "winterdoppel.join.passwordRequired": "Passwort erforderlich.",
  "winterdoppel.join.invalidPassword": "Passwort ungültig.",
  "winterdoppel.join.missingEmail": "Bitte eine gültige E-Mail angeben.",
  "winterdoppel.join.password": "Passwort",
  "winterdoppel.join.passwordHint": "Dieser Anmeldelink ist passwortgeschützt.",
  "winterdoppel.join.unlock": "Weiter",
  "winterdoppel.join.name": "Name",
  "winterdoppel.join.email": "E-Mail",
  "winterdoppel.join.phone": "Telefon / WhatsApp",
  "winterdoppel.join.submit": "Anmelden",
  "winterdoppel.join.saved": "Gespeichert. Danke!",
  "winterdoppel.join.confirmMailSent":
    "Gespeichert. Bitte bestätige deine E-Mail – erst dann erscheinst du im Spielplan.",
  "winterdoppel.join.confirmPending":
    "E-Mail noch nicht bestätigt – du bist im öffentlichen Spielplan noch unsichtbar.",
  "winterdoppel.join.resendConfirm": "Bestätigungsmail erneut senden",
  "winterdoppel.join.update": "Aktualisieren",
  "winterdoppel.confirm.title": "E-Mail bestätigen",
  "winterdoppel.confirm.loading": "Bestätigung läuft…",
  "winterdoppel.confirm.success": "E-Mail bestätigt. Danke!",
  "winterdoppel.confirm.already": "Diese E-Mail war bereits bestätigt.",
  "winterdoppel.confirm.failed": "Bestätigung fehlgeschlagen.",
  "winterdoppel.confirm.missingToken": "Bestätigungslink ungültig.",
  "winterdoppel.confirm.hint":
    "Du bist jetzt im öffentlichen Spielplan sichtbar.",
  "winterdoppel.players.emailPending": "E-Mail ausstehend",
  "winterdoppel.join.blocks": "Abwesenheiten (Spieltermine)",
  "winterdoppel.join.blocksLead":
    "Wann du grundsätzlich nicht kannst. Zusagen zu Einteilungen kommen erst nach Plan-Bestätigung.",
  "winterdoppel.join.blocksLeadFinal":
    "Nur noch zur Ansicht – nach Veröffentlichung der Saisonplanung nicht mehr änderbar.",
  "winterdoppel.join.blocksPreplan":
    "Das ist die Vorplanung: Hier trägst du ein, wann du grundsätzlich nicht kannst. Zusagen/Absagen für konkrete Einteilungen erscheinen erst, wenn der Organisator den Plan bestätigt hat.",
  "winterdoppel.join.rsvpTitle": "Meine Spieltermine",
  "winterdoppel.join.rsvpHint":
    "Bitte jeden Termin zusagen oder absagen ({{answered}}/{{total}}). Erst nach dem Speichern aller Antworten wird neu geplant.",
  "winterdoppel.join.rsvpHintWindow":
    "Absagen und Warteliste speichern sofort. Max. {{maxNo}} Absagen im Voraus (aktuell {{noCount}}). Zusagen in den nächsten {{window}} Terminen.",
  "winterdoppel.join.rsvpViewCalendar": "Kalender",
  "winterdoppel.join.rsvpViewList": "Liste",
  "winterdoppel.join.rsvpStatusYes": "Dabei",
  "winterdoppel.join.rsvpStatusNo": "Abgesagt",
  "winterdoppel.join.rsvpStatusOpen": "Bitte zusagen",
  "winterdoppel.join.rsvpStatusWaitlist": "Warteliste",
  "winterdoppel.join.rsvpStatusCancelledWaitlist": "Warteliste abgesagt",
  "winterdoppel.join.rsvpEmpty":
    "Noch keine Zuordnung – der Organisator muss zuerst die Grobplanung erstellen.",
  "winterdoppel.join.rsvpSave": "Änderungen speichern",
  "winterdoppel.join.rsvpIncomplete":
    "Bitte noch {{count}} Termin(e) zusagen oder absagen.",
  "winterdoppel.join.rsvpSaved": "Deine Änderungen wurden gespeichert.",
  "winterdoppel.join.rsvpSavedNotifyFailed":
    "Absage gespeichert, Benachrichtigung fehlgeschlagen ({{detail}}).",
  "winterdoppel.join.rsvpSavedComplete":
    "Gespeichert. Sobald alle Absagen verarbeitet sind, wird der Plan ggf. neu berechnet.",
  "winterdoppel.join.rsvpReplannedAll":
    "Absagen verarbeitet – Plan und Kosten wurden neu berechnet.",
  "winterdoppel.join.rsvpStarters": "Eingeplant: {{names}}",
  "winterdoppel.join.rsvpDoppelTitle": "Doppel {{court}}",
  "winterdoppel.join.rsvpGroupTitle": "Gruppe {{court}}",
  "winterdoppel.join.rsvpWaitlistHeading": "Warteliste",
  "winterdoppel.join.rsvpWaitlistOthers": "Warteliste: {{names}}",
  "winterdoppel.join.rsvpWaitlistSelf":
    "Du stehst auf der Warteliste (Platz {{rank}}).",
  "winterdoppel.join.rsvpWaitlistBefore": "Vor dir: {{names}}",
  "winterdoppel.join.rsvpWaitlistAfter": "Nach dir: {{names}}",
  "winterdoppel.join.rsvpNobody": "–",
  "winterdoppel.join.rsvpCancelWaitlist": "Von Warteliste nehmen",
  "winterdoppel.join.rsvpJoinWaitlist": "Auf Warteliste",
  "winterdoppel.join.rsvpJoinSibling": "Teilnehmen",
  "winterdoppel.join.rsvpSiblingBadge": "Andere Gruppe",
  "winterdoppel.join.rsvpSiblingHint":
    "Termin einer anderen Gruppe – du kannst dich eintragen (freier Platz oder Warteliste).",
  "winterdoppel.join.rsvpSiblingGroup": "Gruppe: {{name}}",
  "winterdoppel.join.rsvpMaxAdvanceNo":
    "Du kannst höchstens {{max}} kommende Termine im Voraus absagen.",
  "winterdoppel.join.rsvpOutsideWindow":
    "Zusagen sind nur in den nächsten Terminen möglich. Absagen und Warteliste gehen für alle kommenden Termine.",
  "winterdoppel.join.addBlock": "Sperre hinzufügen",
  "winterdoppel.join.blockFrom": "Von",
  "winterdoppel.join.blockTo": "Bis",
  "hub.minigames.title": "Mini-Games",
  "hub.minigames.subtitle": "Kleine Spiele und Challenges.",
  "hub.tennisLive.title": "Tennis Live",
  "hub.tennisLive.subtitle":
    "Tennis-Weltrangliste, aktuelle Spielpläne und Spiele.",
  "hub.tennisLive.comingSoon": "In Kürze verfügbar",
  "hub.tennisLive.comingSoonDesc":
    "Hier entsteht die Tennis-Live-App mit Weltrangliste, Spielplänen und Live-Spielen.",
  "hub.tennisLive.rankings.title": "Weltrangliste",
  "hub.tennisLive.rankings.atp": "ATP",
  "hub.tennisLive.rankings.wta": "WTA",
  "hub.tennisLive.rankings.loading": "Lade Rangliste …",
  "hub.tennisLive.rankings.error": "Rangliste konnte nicht geladen werden.",
  "hub.tennisLive.rankings.errorExternal":
    "Der StatPal-Dienst ist momentan nicht erreichbar. Bitte später erneut versuchen.",
  "hub.tennisLive.rankings.empty": "Keine Daten verfügbar.",
  "hub.tennisLive.tournaments.title": "Turnierliste",
  "hub.tennisLive.tournaments.loading": "Lade Turniere …",
  "hub.tennisLive.tournaments.error":
    "Turnierliste konnte nicht geladen werden.",
  "hub.tennisLive.tournaments.empty": "Keine Turniere verfügbar.",
  "hub.tennisLive.tournaments.col.name": "Turnier",
  "hub.tennisLive.tournaments.col.location": "Ort",
  "hub.tennisLive.tournaments.col.dates": "Termin",
  "hub.tennisLive.tournaments.col.surface": "Belag",
  "hub.apps.title": "Deine Apps",
  "hub.apps.open": "Öffnen →",
  "hub.apps.tagline.trainerstunden": "Training gemeinsam organisieren.",
  "hub.apps.tagline.trainer": "Ideen für dein nächstes Training.",
  "hub.apps.tagline.matchmixer": "Neue Paarungen. Gute Matches.",
  "hub.apps.tagline.clubmeisterschaft": "Dein Club. Euer Turnier.",
  "hub.apps.tagline.belegung": "Finde deinen Platz auf dem Court.",
  "hub.apps.tagline.winterdoppel": "Zusammen spielen. Regelmäßig.",
  "hub.apps.tagline.clubhub": "Verein verwalten. Mitglieder organisieren.",
  "hub.apps.tagline.tenniswelt": "Matches, Turniere, Lieblingsspieler.",
  "hub.apps.tagline.kalender": "Dein Tennis im Überblick.",
  "hub.apps.tagline.medenspiele": "Mannschaften. Termine. Einsätze.",
  "hub.apps.tagline.minigames": "Kleine Spiele. Großer Spaß.",
  "hub.apps.create.training": "+ Training anlegen",
  "hub.apps.create.plan": "+ Trainingsplan",
  "hub.apps.create.doubles": "+ Doppelrunde",
  "hub.apps.create.tournament": "+ Turnier erstellen",
  "hub.apps.create.booking": "+ Platz buchen",
  "hub.apps.create.series": "+ Regeltermin",
  "hub.hero.tagline": "Dein Tag. Dein Tennis.",
  "hub.hero.greeting.morning": "Guten Morgen, {name}.",
  "hub.hero.greeting.morningAnonymous": "Guten Morgen.",
  "hub.hero.greeting.afternoon": "Guten Tag, {name}.",
  "hub.hero.greeting.afternoonAnonymous": "Guten Tag.",
  "hub.hero.greeting.evening": "Guten Abend, {name}.",
  "hub.hero.greeting.eveningAnonymous": "Guten Abend.",
  "hub.layout.edit": "Startseite anpassen",
  "hub.layout.editShort": "Anpassen",
  "hub.layout.done": "Fertig",
  "hub.layout.title": "Startseite anpassen",
  "hub.layout.subtitle":
    "Lege fest, welche Bereiche du siehst und in welcher Reihenfolge.",
  "hub.layout.close": "Schließen",
  "hub.layout.sections": "Bereiche",
  "hub.layout.moveUp": "Nach oben",
  "hub.layout.moveDown": "Nach unten",
  "hub.layout.add": "Modul hinzufügen",
  "hub.layout.addSection": "Bereich hinzufügen",
  "hub.layout.addTitle": "Modul einbinden",
  "hub.layout.addSubtitle": "Wähle, was auf der Startseite erscheinen soll.",
  "hub.layout.addEmpty": "Alles ist bereits eingeblendet.",
  "hub.layout.emptyModule":
    "Gerade nichts offen — der Bereich bleibt in der normalen Ansicht ausgeblendet.",
  "hub.layout.remove": "Ausblenden",
  "hub.layout.dragHint": "Ziehen zum Verschieben",
  "hub.layout.dragCarry": "Loslassen zum Ablegen",
  "hub.layout.dropHere": "Hier ablegen",
  "hub.layout.dropFit": "Einpassen (Boxen werden schmaler)",
  "hub.layout.dropNewRow": "Als eigene Zeile einfügen",
  "hub.layout.dropAbove": "Über „{name}“ ablegen",
  "hub.layout.rowIndex": "Zeile {n}",
  "hub.layout.rowHeading": "{names}",
  "hub.layout.spanAria": "Widget-Größe",
  "hub.layout.span1": "1 Spalte breit",
  "hub.layout.span2": "2 Spalten breit",
  "hub.layout.span3": "Volle Breite",
  "hub.layout.sizeS": "Schmal (1/3)",
  "hub.layout.sizeM": "Mittel (2/3)",
  "hub.layout.sizeL": "Breit (volle Zeile)",
  "hub.layout.reset": "Standard wiederherstellen",
  "hub.layout.resetConfirmTitle": "Standard wiederherstellen?",
  "hub.layout.resetConfirmBody":
    "Deine Anpassungen an Sichtbarkeit und Reihenfolge werden zurückgesetzt.",
  "hub.layout.resetCancel": "Abbrechen",
  "hub.layout.resetConfirm": "Wiederherstellen",
  "hub.layout.section.attention": "Handlungsbedarf",
  "hub.layout.section.roleJobs": "Als Nächstes",
  "hub.layout.section.desk": "Schreibtisch",
  "hub.layout.section.apps": "Deine Apps",
  "hub.layout.section.weeklyDrill": "Wöchentlicher Drill",
  "hub.layout.section.clubExtras": "Vereinsaktivitäten",
  "hub.layout.widget.schedule": "Nächste Termine",
  "hub.layout.widget.trainerConfirm": "Trainings bestätigen",
  "hub.layout.widget.bookingRequests": "Buchungsanfragen",
  "hub.layout.widget.overdueBills": "Überfällige Rechnungen",
  "hub.layout.widget.tenniswelt": "Tenniswelt",
  "hub.next.title": "Dein nächster Termin",
  "hub.schedule.more": "Weitere Termine",
  "hub.schedule.moreShow": "Weitere Termine anzeigen",
  "hub.tenniswelt.title": "Tenniswelt",
  "hub.tenniswelt.subtitle":
    "Matches, Turniere und deine Lieblingsspieler verfolgen.",
  "hub.tenniswelt.open": "Tenniswelt öffnen",
  "tenniswelt.title": "Tenniswelt",
  "tenniswelt.open": "Tenniswelt öffnen",
  "tenniswelt.nav.aria": "Tenniswelt-Bereiche",
  "tenniswelt.nav.matches": "Matches",
  "tenniswelt.nav.tournaments": "Turniere",
  "tenniswelt.nav.favorites": "Favoriten",
  "tenniswelt.filter.all": "Alle",
  "tenniswelt.filter.atp": "ATP",
  "tenniswelt.filter.wta": "WTA",
  "tenniswelt.filter.challenger": "Challenger",
  "tenniswelt.filter.itf": "ITF",
  "tenniswelt.filter.utr": "UTR",
  "tenniswelt.tournaments.heading": "Turniere entdecken",
  "tenniswelt.tournaments.searchAria": "Turniere suchen",
  "tenniswelt.tournaments.searchPlaceholder": "Turnier suchen …",
  "tenniswelt.tournaments.statusAria": "Turnierstatus filtern",
  "tenniswelt.tournaments.status.all": "Alle Status",
  "tenniswelt.tournaments.status.live": "Laufend",
  "tenniswelt.tournaments.status.upcoming": "Kommend",
  "tenniswelt.tournaments.count": "{n} Turniere",
  "tenniswelt.tournaments.emptyFiltered":
    "Keine passenden Turniere für die aktuelle Suche und Filter.",
  "tenniswelt.tournaments.loadMore": "Weitere Turniere laden",
  "tenniswelt.tournaments.view": "Turnier ansehen",
  "tenniswelt.tournaments.favoriteAria": "{name} als Favorit merken",
  "tenniswelt.tournaments.unfavoriteAria":
    "{name} nicht mehr als Favorit merken",
  "tenniswelt.tournaments.summary.live": "{n} live",
  "tenniswelt.tournaments.summary.today": "{n} heute",
  "tenniswelt.tournaments.summary.upcoming": "{n} kommend",
  "tenniswelt.tournaments.summary.available": "{n} im Datenstand",
  "tenniswelt.tournaments.summaryNote":
    "Zahlen beziehen sich auf den aktuellen Match-Datenstand.",
  "tenniswelt.tournaments.armsCredit": "Wappen: {artist} · {license}",
  "tenniswelt.tournaments.travel.car": "Anreise Auto",
  "tenniswelt.tournaments.travel.loading": "Route wird berechnet …",
  "tenniswelt.tournaments.travel.result":
    "Ca. {duration} mit dem Auto ({distance})",
  "tenniswelt.tournaments.travel.map": "Karte öffnen",
  "tenniswelt.tournaments.travel.unavailable":
    "Für dieses Ziel ist gerade keine Autoroute verfügbar.",
  "tenniswelt.tournaments.travel.needLocation":
    "Für Anreisezeiten bitte einen Standort in den Einstellungen hinterlegen.",
  "tenniswelt.tournaments.travel.minutes": "{n} Min.",
  "tenniswelt.tournaments.travel.hours": "{n} Std.",
  "tenniswelt.tournaments.travel.hoursMinutes": "{h} Std. {m} Min.",
  "tenniswelt.tournaments.travel.meters": "{n} m",
  "tenniswelt.tournaments.travel.km": "{n} km",
  "tenniswelt.days.aria": "Spieltag wählen",
  "tenniswelt.days.prev": "Vorheriger Tag",
  "tenniswelt.days.next": "Nächster Tag",
  "tenniswelt.days.all": "Alle Tage",
  "tenniswelt.empty.favorites":
    "Deine Favoriten haben gerade keine laufende oder kommende Partie.",
  "tenniswelt.empty.countries":
    "Keine Matches mit Spielerinnen oder Spielern aus den gewählten Ländern.",
  "tenniswelt.filter.countriesAria": "Nach Spielerland filtern",
  "tenniswelt.filter.countriesLabel": "Länder",
  "tenniswelt.filter.countriesClear": "Länder zurücksetzen",
  "tenniswelt.empty.match":
    "Dieses Match ist im aktuellen Datenstand nicht enthalten.",
  "tenniswelt.empty.player":
    "Spielerprofil ist im aktuellen Datenstand unbekannt.",
  "tenniswelt.empty.playerMatches":
    "Keine laufenden oder kommenden Partien für diese Spielerin oder diesen Spieler.",
  "tenniswelt.empty.tournament":
    "Dieses Turnier hat im aktuellen Datenstand keine zugeordneten Matches.",
  "tenniswelt.tournaments.noDates":
    "Ein Zeitraum wird nur angezeigt, wenn die Quelle ihn liefert — nicht aus einzelnen Partien abgeleitet.",
  "tenniswelt.rounds.layoutAria": "Turnieransicht wählen",
  "tenniswelt.rounds.layoutRounds": "Nach Runden",
  "tenniswelt.rounds.layoutList": "Als Liste",
  "tenniswelt.rounds.partialNote":
    "Kein vollständiger Turnierbaum: nur beobachtete Matches aus dem aktuellen und gespeicherten Datenstand.",
  "tenniswelt.rounds.historyNote":
    "Enthält auch früher beobachtete Partien dieses Turniers (eigene Historisierung).",
  "tenniswelt.rounds.matchCount": "{n} Matches",
  "tenniswelt.rounds.unknown": "Ohne Runde",
  "tenniswelt.rounds.qualifyingOf": "Quali · {round}",
  "tenniswelt.rounds.R128": "1. Runde (R128)",
  "tenniswelt.rounds.R64": "1. Runde (R64)",
  "tenniswelt.rounds.R32": "Runde der letzten 32",
  "tenniswelt.rounds.R16": "Achtelfinale",
  "tenniswelt.rounds.QF": "Viertelfinale",
  "tenniswelt.rounds.SF": "Halbfinale",
  "tenniswelt.rounds.F": "Finale",
  "tenniswelt.rounds.RR": "Gruppenphase",
  "tenniswelt.rounds.Q": "Qualifikation",
  "tenniswelt.rounds.Q1": "Quali R1",
  "tenniswelt.rounds.Q2": "Quali R2",
  "tenniswelt.rounds.Q3": "Quali R3",
  "tenniswelt.status.walkover": "Walkover",
  "tenniswelt.status.retired": "Aufgabe",
  "tenniswelt.status.cancelled": "Abgesagt",
  "tenniswelt.status.postponed": "Verschoben",
  "tenniswelt.status.interrupted": "Unterbrochen",
  "tenniswelt.serve.p1": "Aufschlag Spieler 1",
  "tenniswelt.serve.p2": "Aufschlag Spieler 2",
  "tenniswelt.score.set": "S{n}",
  "tenniswelt.score.points": "Pkt",
  "tenniswelt.liveBadge": "Live",
  "tenniswelt.unknown": "unbekannt",
  "tenniswelt.breadcrumb.aria": "Brotkrumennavigation",
  "tenniswelt.player.title": "Spielerprofil",
  "tenniswelt.player.close": "Schließen",
  "tenniswelt.player.closeAria": "Spielerprofil schließen",
  "tenniswelt.player.follow": "Folgen",
  "tenniswelt.player.unfollow": "Nicht mehr folgen",
  "tenniswelt.player.factsTitle": "Steckbrief",
  "tenniswelt.player.bioTitle": "Kurzbiografie",
  "tenniswelt.player.bioLangEn": "Englisch",
  "tenniswelt.player.bioLoading": "Biografie wird geladen …",
  "tenniswelt.player.matchesTitle": "Aktuelle und nächste Matches",
  "tenniswelt.player.linksTitle": "Offizielle Profile",
  "tenniswelt.player.wikiSource": "Wikipedia",
  "tenniswelt.player.imageSource": "Quelle",
  "tenniswelt.player.imageCredit": "Foto: {artist} · Lizenz: {license}.",
  "tenniswelt.player.rankingStale":
    "Rangliste möglicherweise veraltet (Quelle vorübergehend nicht erreichbar).",
  "tenniswelt.player.fact.age": "Alter",
  "tenniswelt.player.fact.nationality": "Nationalität",
  "tenniswelt.player.fact.birthPlace": "Geburtsort",
  "tenniswelt.player.fact.height": "Größe",
  "tenniswelt.player.fact.hand": "Spielhand",
  "tenniswelt.player.fact.turnedPro": "Profi seit",
  "tenniswelt.player.fact.ranking": "Einzelrangliste",
  "tenniswelt.player.fact.careerHigh": "Beste Einzelrangliste",
  "tenniswelt.player.hand.right": "Rechts",
  "tenniswelt.player.hand.left": "Links",
  "tenniswelt.player.heightCm": "{cm} cm",
  "tenniswelt.player.rankingWithAsOf": "{rank} (Stand {date})",
  "tenniswelt.player.careerHighWithDate": "{rank} ({date})",
  "tenniswelt.player.link.atp": "ATP-Profil",
  "tenniswelt.player.link.wta": "WTA-Profil",
  "tenniswelt.player.link.itf": "ITF-Profil",
  "tenniswelt.player.link.wikipedia": "Wikipedia",
  "actions.newTournament": "Neues Turnier",
  "actions.openTournament": "Turnier öffnen",
  "actions.stats": "Statistik",
  "actions.settings": "Einstellungen",

  /* Hub – Marketplace-Kachel: locked-State */
  "hub.appCard.locked.badge": "Verfügbar",

  /* Hub – Profil/User-Menü oben rechts */
  "hub.userMenu.profile": "Profil & Einstellungen",
  "hub.userMenu.vereinsabo": "Vereinsabo",
  "hub.userMenu.locationWeather": "Standort & Wetter",
  "hub.userMenu.myClubs": "Meine Vereine",
  "hub.userMenu.connectClub": "Verein verbinden",
  "hub.userMenu.connectAnotherClub": "Weiteren Verein verbinden",
  "hub.userMenu.restoreOnboarding": "Onboarding wieder einblenden",
  "hub.userMenu.restoreOnboarding.hint":
    'Zeigt alle „Späta"-Aktivitäten wieder im Hero an.',
  "dev.qa.menuLabel": "QA / Tests",
  "dev.qa.title": "QA / Playwright",
  "dev.qa.lead":
    "Lokaler Dev-Desk: Report ansehen, Superadmin-Tests starten, Playwright-UI oder Browse öffnen.",
  "dev.qa.loadError":
    "QA-Status konnte nicht geladen werden. Bitte Dev neu starten (Automator / pnpm dev) — Web :3000 und API :5174. Dann „Aktualisieren“.",
  "dev.qa.actionError": "Aktion konnte nicht gestartet werden.",
  "dev.qa.actionStarted.run":
    "Superadmin-Tests gestartet. In ein paar Sekunden „Aktualisieren“, dann Report öffnen.",
  "dev.qa.actionStarted.ui":
    "Playwright-UI wird im Hintergrund geöffnet (eigenes Fenster).",
  "dev.qa.actionStarted.browse":
    "Chromium als Superadmin wird geöffnet (eigene Session).",
  "dev.qa.lastRun.title": "Letzter Lauf",
  "dev.qa.lastRun.reportReady": "HTML-Report vorhanden",
  "dev.qa.lastRun.empty":
    "Noch kein Report. Starte die Tests unten — danach erscheint der Report hier.",
  "dev.qa.openReport": "Report öffnen",
  "dev.qa.refresh": "Aktualisieren",
  "dev.qa.actions.title": "Aktionen",
  "dev.qa.actions.hint":
    "Nur auf localhost. Playwright-UI und Browse öffnen eigene Fenster.",
  "dev.qa.actions.run": "Superadmin-Tests starten",
  "dev.qa.actions.ui": "Playwright-UI öffnen",
  "dev.qa.actions.browse": "Als Superadmin browsen",
  "dev.qa.plan.title": "Plan & Doku",
  "dev.qa.plan.emptySpecs": "Keine Spec-Dateien unter tests/e2e gefunden.",
  "dev.qa.plan.emptyDocs": "Keine README unter tests/e2e gefunden.",
  "hub.myClubs.label": "Deine Vereine",
  "hub.myClubs.empty.label": "Noch kein Verein verbunden",
  "hub.myClubs.connectFirst": "Verein verbinden",
  "hub.myClubs.connectAnother": "Weiteren Verein verbinden",
  "hub.myClubs.fallbackName": "Verein (wird geladen…)",

  "hub.access.noApps.title": "Keine Apps freigeschaltet",
  "hub.access.noApps.hint":
    "Du hast aktuell keine aktiven Rollen. Bitte beantrage Zugriff oder warte auf die Freigabe durch den Club.",
  "hub.access.noApps.missingTable":
    "Rollen konnten gerade nicht geladen werden. Bitte Seite neu laden oder kurz warten.",
  "hub.access.noApps.noBindings":
    "Dir ist noch keine Rolle in einem Club zugeordnet. Bitte Zugriff beantragen oder eine Einladung annehmen.",
  "hub.access.noApps.matrixPending":
    "Du hast Rollen im Verein, aber noch keine freigegebenen Apps in der Matrix. Bitte den Vereinsadmin bitten, die Apps für deine Rollen freizuschalten – oder zusätzliche Apps beantragen.",
  "hub.access.noApps.requestCta": "Zugriff beantragen",
  "hub.requestAccess.title": "Zugriff beantragen",
  "hub.requestAccess.subtitle":
    "Rollen, Club-Kontext oder weitere Apps beantragen. Meine Anfragen ansehen und Berechtigungen ändern.",
  "hub.discoverApps.title": "Weitere Apps",
  "hub.discoverApps.subtitle": "Module entdecken und Zugriff anfragen.",
  "hub.discoverApps.cta": "Apps entdecken",

  /* Hub – Onboarding-Hero ("Deine Tenniswelt") */
  "hub.onboarding.hero.title": "Willkommen bei Tennis-Matches 🎾",
  "hub.onboarding.hero.titleWithName":
    "Hallo {name} – willkommen bei Tennis-Matches 🎾",
  "hub.onboarding.hero.subtitle":
    "Starte dein Tennisprofil und verbinde deine Tenniswelt.",
  "hub.onboarding.completed.title": "Dein Profil ist startklar.",
  "hub.onboarding.completed.subtitle": "Deine Aktivitäten sind angelegt.",
  "hub.onboarding.completed.hasDismissed":
    "Du hast {count} Aktivitäten ausgeblendet.",
  "hub.onboarding.completed.undismissAll": "Onboarding wieder einblenden",

  /* Hub – Banner: vom Trainer/Admin vorausgefüllte Vereinszuordnung bestätigen */
  "hub.onboarding.invitedClubs.title": "Bitte deine Vereine kurz bestätigen",
  "hub.onboarding.invitedClubs.leadOne":
    'Du wurdest dem Verein „{club}" zugeordnet. Stimmt das?',
  "hub.onboarding.invitedClubs.leadMany":
    "Du wurdest {count} Vereinen zugeordnet. Bitte kurz bestätigen, dass das passt.",
  "hub.onboarding.invitedClubs.confirm": "Stimmt",
  "hub.onboarding.invitedClubs.addAnother":
    "Anderen oder weiteren Verein hinzufügen",
  "hub.onboarding.activity.cta": "Loslegen",
  "hub.onboarding.activity.pending": "Anfrage läuft",
  "hub.onboarding.activity.completed": "Erledigt",
  "hub.onboarding.activity.later": "Brauche ich nicht",
  "hub.onboarding.activity.laterAria":
    "Diese Aktivität ausblenden – brauche ich nicht",
  "hub.onboarding.activity.connectClub.title": "Verein verbinden",
  "hub.onboarding.activity.connectClub.description":
    "Suche deinen Verein und verbinde dich direkt.",
  "hub.onboarding.activity.family.title": "Familie hinzufügen",
  "hub.onboarding.activity.family.description":
    "Verwalte Kinder oder weitere Spielerinnen und Spieler.",
  "hub.onboarding.activity.training.title": "Training entdecken",
  "hub.onboarding.activity.training.description":
    "Buche Trainings oder nimm an Gruppenstunden teil.",
  "hub.onboarding.activity.trainer.title": "Trainerfunktionen aktivieren",
  "hub.onboarding.activity.trainer.description":
    "Plane Trainings und verwalte deine Spielerinnen und Spieler.",

  "hub.trainerSetup.title": "Dein Trainer-Profil einrichten",
  "hub.trainerSetup.subtitle":
    "Diese Schritte bereiten TrainingsDesk für deine Arbeit vor.",
  "hub.trainerSetup.progress": "{done} von {total} erledigt",
  "hub.trainerSetup.cta": "Jetzt einrichten",
  "hub.trainerSetup.stepComplete": "Erledigt",
  "hub.trainerSetup.stepOpen": "Offen",
  "hub.trainerSetup.sheet.save": "Speichern",
  "hub.trainerSetup.sheet.selectPlaceholder": "Bitte wählen",
  "hub.trainerSetup.sheet.primaryClub": "Hauptverein",
  "hub.trainerSetup.sheet.noTrainer":
    "Trainer-Stammdatensatz fehlt noch. Bitte zuerst einen Verein verbinden oder die Seite neu laden.",
  "hub.trainerSetup.sheet.loadFailed":
    "Setup-Daten konnten nicht geladen werden. Bitte erneut versuchen.",
  "hub.trainerSetup.sheet.noClubs":
    "Noch kein Verein verbunden. Verbinde zuerst deinen Club, dann kannst du ihn hier als Trainingsstandort wählen.",
  "hub.trainerSetup.sheet.connectClubCta": "Verein verbinden",
  "hub.trainerSetup.sheet.ulpDeskHint":
    "Übungsleiterpauschale und Vertragsupload richtest du im TrainingsDesk unter Stammdaten ein.",

  "hub.trainerPostSetup.title": "Als Nächstes empfohlen",
  "hub.trainerPostSetup.subtitle":
    "Optional – macht TrainingsDesk im Alltag richtig rund.",
  "hub.trainerPostSetup.dismiss": "Hinweis ausblenden",
  "hub.trainerPostSetup.hints.contacts.title": "Kontakte anlegen",
  "hub.trainerPostSetup.hints.contacts.text":
    "Spieler und Eltern hinzufügen, damit du Termine und Rechnungen zuordnen kannst.",
  "hub.trainerPostSetup.hints.payment.title": "Zahlungsmethoden hinterlegen",
  "hub.trainerPostSetup.hints.payment.text":
    "IBAN oder PayPal für Rechnungen und Zahlungshinweise.",
  "hub.trainerPostSetup.hints.tennify.title": "Tennify verbinden",
  "hub.trainerPostSetup.hints.tennify.text":
    "Platzverfügbarkeit direkt bei der Terminplanung prüfen.",
  "hub.trainerPostSetup.hints.checkcourt.title": "CheckCourt verbinden",
  "hub.trainerPostSetup.hints.checkcourt.text":
    "Alternative Platzbuchung für deine Club-Standorte.",
  "hub.trainerPostSetup.hints.whatsapp.title": "WhatsApp-Erinnerungen",
  "hub.trainerPostSetup.hints.whatsapp.text":
    "Automatische Terminerinnerungen an Spieler und Eltern.",

  "hub.dualProgress.title": "Dein Onboarding-Fortschritt",
  "hub.dualProgress.playerLabel": "Spieler",
  "hub.dualProgress.trainerLabel": "Trainer",
  "hub.dualProgress.count": "{done} von {total}",

  /* Hub – Onboarding-Sheets */
  "hub.onboarding.sheet.connectClub.title": "Verein verbinden",
  "hub.onboarding.sheet.connectClub.subtitle":
    "Such deinen Verein. Ist er nicht dabei, legst du ihn in 30 Sekunden selbst an – du bist sofort verbunden.",
  "hub.onboarding.sheet.connectClub.prefilledHint":
    "Du hast bereits eine Terminanfrage bei {club} gestellt – verbinde den Verein mit einem Klick.",
  "hub.onboarding.sheet.connectClub.submitExisting": "Verbinden",
  "hub.onboarding.sheet.connectClub.submitNewClub":
    "Verein anlegen & verbinden",
  "hub.onboarding.sheet.connectClub.successExisting":
    "Du bist jetzt mit deinem Verein verbunden – du kannst loslegen.",
  "hub.onboarding.sheet.connectClub.successNewClub":
    "Dein Verein ist angelegt und du bist direkt verbunden. Wir prüfen die Angabe noch einmal in Ruhe.",
  "hub.onboarding.sheet.connectClub.limitRemaining":
    "Du kannst noch {remaining} von {max} Vereinen selbst anlegen.",
  "hub.onboarding.sheet.connectClub.limitReached":
    "Du hast bereits {max} Vereine angelegt. Für weitere bitte direkt an support@tennis-matches.de wenden.",
  "hub.onboarding.sheet.activate.connectClubFirst":
    "Verbinde dich zuerst mit deinem Verein, damit wir diese Funktion freischalten können.",
  "hub.onboarding.sheet.activate.connectClubCta": "Verein verbinden",
  "hub.onboarding.sheet.activate.scopePickerTitle": "Verein auswählen",
  "hub.onboarding.sheet.activate.rolePickerTitle": "Was möchtest du tun?",
  "hub.onboarding.sheet.activate.submit": "Aktivieren",
  "hub.onboarding.sheet.activate.success":
    "Rolle freigeschaltet – du kannst loslegen.",
  "hub.onboarding.sheet.activate.notMemberOfClub":
    "Du bist in diesem Verein noch nicht eingebunden. Bitte zuerst „Verein verbinden“ abschließen.",
  "hub.onboarding.sheet.activate.alreadyActive":
    "Du hast diese Rolle in diesem Verein bereits – du kannst Trainer- und Spieler-Sicht parallel nutzen.",
  "hub.onboarding.sheet.activate.playerProvisioned":
    "Spieler-Rolle wurde freigeschaltet – du kannst jetzt Training buchen oder für dein Kind planen.",
  "hub.onboarding.sheet.activate.singleClubHint": "Verein: {club}",
  "hub.onboarding.sheet.activate.grantFailed":
    "Die Rolle konnte gerade nicht freigeschaltet werden. Bitte kurz warten und erneut versuchen.",
  "hub.onboarding.sheet.activate.missingRoles":
    "Für dein Profil sind diese Rollen so nicht verfügbar. Bitte wähle eine andere Rolle oder wende dich an support@tennis-matches.de.",
  "hub.onboarding.sheet.activate.rpcMissing":
    "Die Freischaltung ist auf dem Server noch nicht verfügbar. Bitte später erneut versuchen oder support@tennis-matches.de kontaktieren.",

  "ai.panel.title": "KI-Assistent",
  "ai.context.hub": "Startseite",
  "ai.context.home": "Startseite",
  "ai.context.schleifchen.turnier": "Schleifchenturnier",
  "ai.context.clubmeisterschaft.turnier": "Clubmeisterschaft",
  "ai.context.trainer.dashboard": "Trainer-Dashboard",
  "ai.context.ltr": "Tennis Live",
  "ai.suggestions.hub.1": "Wie starte ich ein Schleifchenturnier?",
  "ai.suggestions.hub.2": "Clubmeisterschaft anlegen",
  "ai.suggestions.hub.3": "TrainingsDesk öffnen",
  "ai.suggestions.schleifchen.1": "Spieler hinzufügen",
  "ai.suggestions.schleifchen.2": "Spielplan erstellen",
  "ai.suggestions.schleifchen.3": "Ergebnisse eingeben",
  "ai.suggestions.clubmeisterschaft.1": "Gruppenphase konfigurieren",
  "ai.suggestions.clubmeisterschaft.2": "K.O.-Runde starten",
  "ai.suggestions.clubmeisterschaft.3": "Rangliste anzeigen",
  "ai.suggestions.trainer.dashboard.1": "Session planen",
  "ai.suggestions.trainer.dashboard.2": "Übungen anzeigen",
  "ai.suggestions.trainer.dashboard.3": "Schüler verwalten",
  "ai.suggestions.ltr.1": "Live-Spiele anzeigen",
  "ai.suggestions.ltr.2": "Begegnungen verfolgen",
  "ai.suggestions.ltr.3": "Rankings einsehen",
  "ai.suggestions.home.1": "Was kann ich hier tun?",
  "ai.suggestions.home.2": "Neues Turnier starten",
  "ai.suggestions.home.3": "Zuletzt verwendet",
  "ai.flow.common.planTournament": "Turnier planen",
  "ai.flow.common.cancel": "Abbrechen",
  "ai.flow.common.chooseModule.title": "Welches Modul möchtest du nutzen?",
  "ai.flow.common.chooseModule.schleifchen": "Schleifchenturnier",
  "ai.flow.common.chooseModule.clubmeisterschaft": "Clubmeisterschaft",
  "chat.suggest.openSchleifchen": "Schleifchenturnier öffnen",
  "chat.suggest.openTrainerstunden": "TrainingsDesk öffnen",
  "chat.suggest.openBilling": "Rechnungen öffnen",
  "chat.suggest.openHelp": "Hilfe öffnen",
  "chat.suggest.openClubmeisterschaft": "Clubmeisterschaft öffnen",
  "chat.suggest.openTennisLive": "Tennis Live öffnen",
  "chat.suggest.planTraining": "Training planen",
  "chat.suggest.showSchedule": "Terminplan anzeigen",
  "chat.suggest.newSchleifchen": "Neues Schleifchen starten",
  "chat.suggest.enterPlayers": "Spieler eingeben",
  "ai.quickReply.schleifchen.schedule": "Spielplan anzeigen",
  "ai.quickReply.schleifchen.changeMode": "Modus ändern",
  "ai.error.unreachable":
    "Die KI ist momentan nicht erreichbar. Bitte versuche es später erneut.",
  "ai.error.configMissing":
    "Die KI ist auf dem Server nicht konfiguriert (OPENAI_API_KEY fehlt). Bitte in server/.env oder .env.local eintragen und den API-Server neu starten.",
  "ai.error.unauthorized": "Anmeldung erforderlich.",
  "ai.error.tenantRequired":
    "Dein Konto ist keinem Verein zugeordnet. Bitte wende dich an den Administrator.",
  "ai.error.forbidden": "Du hast keine Berechtigung für diese Abfrage.",
  "ai.error.notEnabled":
    "Der KI-Assistent ist für dein Konto noch nicht freigeschaltet. Bitte wende dich an deinen Administrator.",
  "ai.error.serverError":
    "Die Abfrage konnte nicht ausgeführt werden. Bitte versuche es erneut.",
  "ai.error.rateLimited": "Zu viele Anfragen. Bitte warte kurz.",
  "ai.error.generic": "Ein Fehler ist aufgetreten.",
  "ai.fab.open": "KI-Chat öffnen",
  "ai.fab.close": "KI-Chat schließen",
  "ai.reset": "Chat zurücksetzen",
  "ai.empty.title": "Wobei kann ich helfen?",
  "ai.empty.subtitle": "Stelle eine Frage oder wähle einen Vorschlag.",
  "ai.empty.subtitleWithName":
    "Stelle eine Frage oder wähle einen Vorschlag, {name}.",
  "ai.input.placeholder": "Nachricht eingeben…",
  "ai.send": "Senden",
  "ai.chatWizard.summary.title": "Zusammenfassung",
  "ai.chatWizard.toWizard": "Zum Assistenten",
  "ai.chatWizard.cancel": "Abbrechen",
  "ai.chatWizard.start": "Assistent starten",
  "ai.scope.offTopic.body":
    "Ich bin auf Tennis, Turniere und Vereinsthemen spezialisiert. Wie kann ich dir in diesem Bereich helfen?",
  "ai.training.viewSession": "Session anzeigen",
  "ai.suggestedActions.title": "Vorgeschlagene Aktionen",
  "ai.suggestedActions.executedTitle": "Aktion ausgeführt",
  "ai.flow.action.continue": "Weiter",
  "ai.flow.action.openWizard": "Assistent öffnen",
  "ai.flow.action.saveDraft": "Entwurf speichern",
  "ai.flow.schleifchen.step.basics.title":
    "Grunddaten für dein Schleifchenturnier",
  "ai.flow.schleifchen.step.mode.title": "Welchen Modus möchtest du?",
  "ai.flow.schleifchen.step.players.title": "Wie viele Spieler?",
  "ai.flow.schleifchen.players.8": "8 Spieler",
  "ai.flow.schleifchen.players.12": "12 Spieler",
  "ai.flow.schleifchen.players.16": "16 Spieler",
  "ai.flow.schleifchen.review.title": "Alles bereit?",
  "ai.flow.club.step.basics.title": "Clubmeisterschaft – Grunddaten",
  "ai.flow.club.step.mode.title": "Gruppenphase oder K.O.?",
  "ai.flow.club.mode.groups": "Gruppen",
  "ai.flow.club.mode.ko": "K.O.-System",
  "ai.flow.club.step.groups.title": "Anzahl der Gruppen",
  "ai.flow.club.review.title": "Clubmeisterschaft – Überprüfung",
  "ai.context.kiAssistant": "KI-Assistent",
  "ai.suggestions.ki.1": "Wann ist Fabios nächste Trainingsstunde?",
  "ai.suggestions.ki.trainers": "Welche Trainer gibt es im Club?",
  "ai.suggestions.ki.2": "Wurde Michaels letzte Rechnung bezahlt?",
  "ai.suggestions.ki.3": "Unterrichtsstunde für morgen planen",
  "ai.training.confirm.yes": "Ja",
  "ai.training.confirm.no": "Nein, andere Person",
  "ai.training.askPlayerName":
    "Wie heißt der Spieler? Bitte Vor- und Nachname nennen.",
  "ai.context.coachdesk": "TrainingsDesk",
  "ai.suggestions.coachdesk.1":
    "Status zu einem Spieler: Termine, Rechnungen, Versand",
  "ai.suggestions.coachdesk.2":
    "Welche Rechnungsentwürfe gibt es für einen Spieler?",
  "ai.suggestions.coachdesk.3": "Neues Training für morgen um 17 Uhr anlegen",
  "ai.coachdesk.askPersonName":
    "Bitte nenne den Vor- und Nachnamen des Spielers.",
  "ai.coachdesk.askInvoicePersonName":
    "Bitte nenne den Vor- und Nachnamen der Person, deren Rechnungen du prüfen möchtest.",
  "ai.coachdesk.askPaymentKnowsName":
    "Kennst du den Namen der Person, für die du die Zahlung erfassen möchtest?",
  "ai.coachdesk.askPaymentPersonName":
    "Bitte nenne den Vor- und Nachnamen der Person.",
  "ai.coachdesk.paymentKnowsName.yes": "Ja",
  "ai.coachdesk.paymentKnowsName.no": "Nein, weiter",
  "hub.ki.title": "KI-Assistent",
  "hub.ki.subtitle":
    "Fragen zu Training, Terminen und Tennis-Matches – in natürlicher Sprache.",
  "hub.ki.page.title": "KI-Assistent",
  "hub.ki.page.subtitle": "Stelle Fragen zu Trainings, Spielern und Terminen.",
  "hub.ki.backToHub": "Zurück zum Hub",
  "hub.favorites.title": "Favoriten",
  "hub.pin.add": "Anheften",
  "hub.pin.remove": "Angeheftet",
  "hub.pin.app.add": "App anheften",
  "hub.pin.app.remove": "App lösen",
  "hub.appOrder.groupLabel": "App-Anordnung",
  "hub.appOrder.controlsLabel": "App verschieben",
  "hub.appOrder.start": "Apps anordnen",
  "hub.appOrder.done": "Fertig",
  "hub.appOrder.reset": "Standard wiederherstellen",
  "hub.appOrder.moveUp": "Nach oben",
  "hub.appOrder.moveDown": "Nach unten",
  "hub.appOrder.singleAppHint":
    "In dieser Kategorie gibt es aktuell nur eine App.",
  "hub.accessRequests.title": "Usermanagement",
  "hub.accessRequests.subtitle": "Nutzer hinzufügen & Berechtigungen pflegen",
  "hub.admin.title": "Verwaltung",
  "hub.clubhub.title": "ClubHub",
  "hub.clubhub.subtitle":
    "Vereinsverwaltung – Kontakte, Orte und Berechtigungen.",
  "hub.premium.clubhub.tagline": "Verein verwalten.\nMitglieder organisieren.",
  "clubhub.page.title": "ClubHub",
  "clubhub.page.subtitle":
    "Vereinsverwaltung – Kontakte, Orte und Berechtigungen.",
  "clubhub.section.modules": "Bereiche",
  "clubhub.stats.activeContacts": "Aktive Kontakte",
  "clubhub.stats.activeContactsDetail": "{count} inaktiv",
  "clubhub.stats.newContacts": "Neue Kontakte",
  "clubhub.stats.newContactsDetail": "In den letzten {days} Tagen",
  "clubhub.stats.players": "Spieler",
  "clubhub.stats.playersDetail": "Mit Geburtsjahr hinterlegt",
  "clubhub.stats.locations": "Orte",
  "clubhub.stats.locationsDetail": "Anlagen in der Stammdaten-Verwaltung",
  "clubhub.stats.pendingAccess": "Offene Zugangsanfragen",
  "clubhub.stats.pendingAccessDetail": "Warten auf Freigabe",
  "clubhub.module.contacts.title": "Kontakte",
  "clubhub.module.contacts.subtitle": "Personen und Kontakte verwalten",
  "clubhub.module.locations.title": "Orte",
  "clubhub.module.locations.subtitle": "Anlagen und Plätze verwalten",
  "clubhub.module.usermanagement.title": "Benutzer & Rollen",
  "clubhub.module.usermanagement.subtitle":
    "Zugriffe verwalten und Rollen zuweisen.",
  "hub.admin.people.title": "Kontakte",
  "hub.admin.people.subtitle": "Personen und Kontakte verwalten.",
  "hub.admin.locations.title": "Orte",
  "hub.admin.locations.subtitle": "Orte/Anlagen verwalten.",
  "hub.premium.workspace": "Tennis-Matches",
  "hub.premium.workspaceSubtitle": "Deine Tennis-Welt. Alles an einem Ort.",
  "hub.premium.welcomeBack": "Willkommen zurück, {name}! 👋",
  "hub.premium.greeting.welcomeBack": "Willkommen zurück, {name}! 👋",
  "hub.premium.greeting.welcomeBackAnonymous": "Willkommen zurück! 👋",
  "hub.premium.greeting.goodMorning":
    "Guten Morgen, {name}! Bereit fürs Warm-up? 🎾",
  "hub.premium.greeting.goodAfternoon": "Schön, dich zu sehen, {name}! 👋",
  "hub.premium.greeting.goodEvening":
    "Guten Abend, {name}! Noch ein Match im Kopf? 🌙",
  "hub.premium.greeting.frenchOpen":
    "Salut {name}! Roland-Garros-Feeling in deiner Tenniswelt? 🇫🇷",
  "hub.premium.greeting.wimbledon":
    "Welcome back, {name}! Heute mit Wimbledon-Vibes? 🌿",
  "hub.premium.greeting.australianOpen":
    "Servus {name}! Down-Under-Energie – lass uns loslegen! 🇦🇺",
  "hub.premium.greeting.usOpen": "Hey {name}! US-Open-Power für deinen Tag? 🗽",
  "hub.premium.greeting.cheerFight":
    "Auf geht's, {name}! Zeig heute dein bestes Tennis! 💪",
  "hub.premium.greeting.cheerBreakPoint":
    "{name}, heute ist Breakpoint-Chance – nutz sie! 🎯",
  "hub.premium.greeting.courtTime":
    "Aufschlag, {name}! Was steht heute auf deinem Court? 🎾",
  "hub.premium.greeting.clubReady":
    "Hallöchen {name}! Dein Club wartet schon auf dich. 👋",
  "hub.premium.showAll": "Alle anzeigen",
  "hub.premium.favorite": "Favorit",
  "hub.premium.stat.nextTraining": "Nächstes Training",
  "hub.premium.stat.today": "Heute",
  "hub.premium.stat.court": "Platz",
  "hub.premium.stat.nextTrainingEmpty": "Noch kein Training",
  "hub.premium.stat.nextTrainingEmptyCta": "Training entdecken",
  "hub.premium.stat.openMatches": "Offene Matches",
  "hub.premium.stat.showMatches": "Zeige deine Matches",
  "hub.premium.stat.openMatchesEmpty": "Noch keine Matches angelegt",
  "hub.premium.stat.activeTournaments": "Turniere aktiv",
  "hub.premium.stat.nextTrainingLinkAria": "Nächstes Training öffnen: {label}",
  "hub.premium.stat.activeTournamentsLinkAria":
    "{count} aktive Turniere anzeigen",
  "hub.premium.stat.showTournaments": "Deine Turniere",
  "hub.premium.stat.activeTournamentsEmpty": "Noch keine aktiven Turniere",
  "hub.tennisWorld.title": "Deine Tenniswelt",
  "hub.premium.trainerstunden.tagline": "Trainings buchen",
  "hub.premium.trainerstunden.taglineBook":
    "Trainings buchen und Termine einsehen.",
  "hub.premium.trainerstunden.taglineGive":
    "Gruppen, Termine und Abrechnung verwalten.",
  "nav.side.tier.explore": "Mehr entdecken",
  "hub.schedule.source.einzel": "Einzeltermin",
  "hub.schedule.source.serieTraining": "Serientermin",
  "hub.schedule.source.serieFree": "Freies Training",
  "hub.schedule.source.belegung": "Platzbuchung",
  "hub.schedule.source.unknown": "Termin",
  "mobile.hub.coachJobs.aria": "Trainer-Schnellzugriff",
  "mobile.hub.coachJobs.plan": "Planung",
  "mobile.hub.coachJobs.today": "Heute",
  "mobile.hub.coachJobs.backlog": "Bestätigen",
  "hub.roleJobs.aria": "Deine wichtigsten Aufgaben",
  "hub.roleJobs.title": "Als Nächstes",
  "hub.roleJobs.role.coach": "Trainer-Ansicht",
  "hub.roleJobs.role.coachSetup": "Trainer-Einrichtung",
  "hub.roleJobs.role.captain": "Mannschaftsführer",
  "hub.roleJobs.role.player": "Spieler-Ansicht",
  "hub.roleJobs.role.member": "Willkommen",
  "hub.roleJobs.coach.plan.title": "Trainingstermine",
  "hub.roleJobs.coach.plan.subtitle": "Heute planen und bestätigen",
  "hub.roleJobs.coach.calendar.title": "Kalender",
  "hub.roleJobs.coach.calendar.subtitle": "Alle Termine auf einen Blick",
  "hub.roleJobs.coach.series.title": "Serientermine",
  "hub.roleJobs.coach.series.subtitle": "Regelmäßige Gruppen",
  "hub.roleJobs.coach.billing.title": "Abrechnung",
  "hub.roleJobs.coach.billing.subtitle": "Rechnungen vorbereiten",
  "hub.roleJobs.coach.firstSession.title": "Ersten Termin anlegen",
  "hub.roleJobs.coach.firstSession.subtitle": "In unter einer Minute starten",
  "hub.roleJobs.captain.team.title": "TeamDesk",
  "hub.roleJobs.captain.team.subtitle": "Medenspiele steuern",
  "hub.roleJobs.captain.squad.title": "Kader",
  "hub.roleJobs.captain.squad.subtitle": "Spieler verwalten",
  "hub.roleJobs.captain.calendar.title": "Kalender",
  "hub.roleJobs.captain.calendar.subtitle": "Termine der Mannschaft",
  "hub.roleJobs.player.schedule.title": "Mein Kalender",
  "hub.roleJobs.player.schedule.subtitle": "Kommende Termine",
  "hub.roleJobs.player.book.title": "Training",
  "hub.roleJobs.player.book.subtitle": "TrainingsDesk öffnen",
  "hub.roleJobs.player.bookings.title": "Meine Buchungen",
  "hub.roleJobs.player.bookings.subtitle": "Platzreservierungen",
  "hub.roleJobs.member.connect.title": "Verein verbinden",
  "hub.roleJobs.member.connect.subtitle": "Zugang freischalten",
  "hub.roleJobs.member.calendar.title": "Kalender",
  "hub.roleJobs.member.calendar.subtitle": "Termine ansehen",
  "hub.premium.trainerstunden.cta.book": "TrainingsDesk öffnen",
  "hub.premium.trainerstunden.cta.give": "Trainingsverwaltung öffnen",
  "hub.premium.trainer.cta": "Training planen",
  "hub.premium.matchmixer.cta": "MatchMixer öffnen",
  "hub.premium.app.open": "Öffnen",
  "hub.premium.trainerstunden.stat.sessionsToday": "{count} Training heute",
  "hub.premium.trainerstunden.stat.sessionsToday_plural":
    "{count} Trainings heute",
  "hub.premium.trainerstunden.stat.openBills": "{count} Rechnungen offen",
  "hub.premium.matchmixer.tagline":
    "Doppelrunden organisieren und Turniere steuern.",
  "hub.premium.matchmixer.stat.activePlayers": "{count} Spieler aktiv",
  "hub.premium.matchmixer.stat.runningTournaments":
    "{count} laufendes Turnier von dir",
  "hub.premium.matchmixer.stat.runningTournaments_plural":
    "{count} laufende Turniere von dir",
  "hub.premium.clubmeisterschaft.tagline": "Turniere planen.\nMeister küren.",
  "hub.premium.clubmeisterschaft.stat.members": "{count} Mitglieder",
  "hub.premium.clubmeisterschaft.stat.eventsPlanned": "{count} Events geplant",
  "hub.premium.medenspiele.tagline":
    "Mannschaft aufstellen.\nErgebnisse melden.",
  "hub.premium.medenspiele.stat1": "4 Mannschaften",
  "hub.premium.medenspiele.stat2": "Nächstes Spiel So.",
  "hub.premium.belegung.tagline": "Plätze buchen.\nBelegung steuern.",
  "hub.premium.kalender.tagline": "Wer ist wann da.\nTermine im Blick.",
  "hub.premium.winterdoppel.tagline":
    "Serientermine planen.\nVerfügbarkeit klären.",
  "hub.premium.tennisLive.tagline":
    "Matches, Turniere und deine Lieblingsspieler verfolgen.",
  "hub.premium.tennisLive.stat1": "ATP · WTA",
  "hub.premium.tennisLive.stat2": "Scores live",
  "hub.premium.minigames.tagline": "Challenges spielen.\nSpaß haben.",
  "hub.premium.minigames.stat1": "3 Games",
  "hub.premium.minigames.stat2": "Bubble Tap neu",
  "hub.premium.live.title": "Live auf deinen Plätzen",
  "hub.premium.live.showAll": "Alle anzeigen",
  "hub.premium.live.courtsActive": "Courts aktiv",
  "hub.premium.live.recentlyActive": "Kürzlich aktiv",
  "hub.premium.live.playersOnline": "Spieler online",
  "hub.premium.live.liveMatches": "Live Matches",
  "hub.premium.live.emptyText":
    "Sobald in deinem Verein etwas passiert, siehst du es hier.",
  "hub.premium.nav.home": "Home",
  "hub.premium.nav.calendar": "Kalender",
  "hub.premium.nav.competitions": "Wettkämpfe",
  "hub.premium.nav.apps": "Apps",
  "status.running": "Läuft",
  "status.planned": "Geplant",
  "status.completed": "Abgeschlossen",
  "common.open": "Öffnen",
  "common.back": "Zurück",
  "common.reload": "Neu laden",
  "common.copy": "Kopieren",
  "subnav.sectionLabel": "Bereich",
  "subnav.closeSheet": "Schließen",
  "common.save": "Speichern",
  "common.share": "Teilen",
  "common.close": "Fertig",
  "common.cancel": "Abbrechen",
  "common.confirm": "Bestätigen",
  "common.edit": "Bearbeiten",
  "common.delete": "Löschen",
  "common.saving": "Speichere…",
  "common.decrement": "Verringern",
  "common.increment": "Erhöhen",

  "admin.people.title": "Kontakte",
  "admin.people.subtitle":
    "Spieler und Kontakte zentral verwalten – für alle Apps.",
  "contacts.list.view.cards": "Karten",
  "contacts.list.view.table": "Tabelle",
  "contacts.list.view.toggleAria": "Darstellung der Kontaktliste",
  "contacts.list.exportExcel": "Excel",
  "contacts.list.exportExcelAria":
    "Gefilterte Kontakte als Excel herunterladen",
  "contacts.list.exportExcelEmpty":
    "Keine Kontakte für die aktuelle Auswahl – nichts zu exportieren.",
  "contacts.list.exportExcelFailed":
    "Excel-Export fehlgeschlagen. Bitte erneut versuchen.",
  "admin.people.create": "Neuer Kontakt",
  "admin.people.empty": "Noch keine Kontakte angelegt.",
  "admin.people.loadFailed": "Kontakte konnten nicht geladen werden.",
  "admin.people.saveFailed": "Speichern fehlgeschlagen.",
  "admin.people.errors.billingRecipientAlreadyAssigned":
    "Für diesen Spieler ist bereits ein Rechnungsempfänger hinterlegt. Ein zweiter Empfänger im selben Verein ist nicht möglich.",
  "admin.people.errors.guardianAlreadyAssigned":
    "Für diesen Spieler ist bereits ein Erziehungsberechtigter hinterlegt. Eine zweite Zuordnung ist nicht möglich.",
  "admin.people.errors.managedChildBillingLocked":
    "Dieser Spieler ist einem Rechnungsempfänger zugeordnet und wird dort administriert. Die Abrechnungszuordnung kann hier nicht geändert werden.",
  "admin.people.errors.managedChildFamilyRoleLocked":
    "Dieser Spieler ist als Kind einem Rechnungsempfänger zugeordnet. Die Rolle Spieler/Rechnungsempfänger kann dabei nicht geändert werden.",
  "admin.people.deleteConfirm.title": "Kontakt löschen?",
  "admin.people.deleteConfirm.body":
    "Diese Aktion kann verknüpfte Daten entfernen.",
  "admin.people.deleteFailed": "Löschen fehlgeschlagen.",
  "contactsAdmin.card.appAccess": "App-Zugang",
  "admin.people.fields.firstName": "Vorname",
  "admin.people.fields.lastName": "Nachname",
  "admin.people.fields.birthYear": "Geburtsjahr",
  "admin.people.fields.email": "E-Mail",
  "admin.people.fields.phone": "Telefon",
  "admin.people.fields.notes": "Notizen",
  "admin.people.fields.inactive": "Inaktiv",
  "admin.people.search.placeholder":
    "Suchen (Name, Kontakt, Rechnung, Verknüpfungen)…",
  "admin.people.roleFilter.aria": "Nach Kontaktart filtern",
  "admin.people.roleFilter.all": "Alle",
  "admin.people.roleFilter.optionAria": "{label}, {count} Kontakte",
  "admin.people.roleFilter.noResults": "Keine Kontakte für diese Filter.",
  "admin.people.alphabet.aria": "Alphabetische Navigation",
  "admin.people.meta.birthYearShort": "Jg.",
  "admin.people.form.createTitle": "Neuen Kontakt anlegen",
  "admin.people.form.editTitle": "Kontakt bearbeiten: {name}",
  "admin.people.form.editScreenTitle": "Kontakt bearbeiten",
  "admin.people.form.hint":
    "Speichern schließt den Editor und kehrt zur Liste zurück. Schließen oder Abbrechen verwirft ungespeicherte Änderungen.",
  "admin.people.form.nameFallback": "–",
  "admin.people.form.detailModeAria": "Formularumfang beim Bearbeiten",
  "admin.people.form.detailModeSimple": "Einfach",
  "admin.people.form.detailModeExtended": "Erweitert",
  "admin.people.form.alternateRecipientHint":
    "Abweichender Rechnungsempfänger hinterlegt.",
  "admin.people.form.showExtendedForBilling": "Erweitert anzeigen",
  "admin.people.billing.sectionTitle": "Wer erhält Rechnungen?",
  "admin.people.billing.sectionHint": "Kurz für Verein und Trainer festhalten.",
  "admin.people.billing.recipientQuestion": "Wer bekommt die Rechnung?",
  "admin.people.billing.recipientSelf": "Diese Person selbst",
  "admin.people.billing.recipientOther": "Eine andere Person (z. B. Eltern)",
  "admin.people.billing.contactPickLabel": "Kontakt wählen oder neu eintragen",
  "admin.people.billing.contactPickHint":
    "Dieselbe Kontaktperson kann für mehrere Spieler gelten.",
  "admin.people.billing.relationLabel": "Beziehung zur Person",
  "admin.people.billing.relationPlaceholder": "z. B. Mutter, Vater",
  "admin.people.billing.contactFieldsLead": "Name und Erreichbarkeit",
  "admin.people.billing.contactFirstName": "Vorname",
  "admin.people.billing.contactLastName": "Nachname",
  "admin.people.billing.contactEmail": "E-Mail",
  "admin.people.billing.contactPhone": "Telefon",
  "admin.people.billing.optionalSectionTitle": "Übliche Abrechnung",
  "admin.people.billing.optionalBadge": "optional",
  "admin.people.billing.optionalHint": "Orientierung für Trainer und Verein.",
  "admin.people.billing.rhythmLabel": "Rhythmus",
  "admin.people.billing.timingLabel": "Zahlung",
  "admin.people.billing.selfReachabilityHint":
    "Bei „Diese Person selbst“ gelten die E-Mail und das Telefon oben im Formular als Erreichbarkeit für Rückfragen und Rechnungen.",
  "admin.people.billing.placeholderChoose": "Bitte wählen",
  "admin.people.billing.placeholderOptional": "Optional auswählen",
  "admin.people.billing.freqAfterSession": "Direkt nach der Stunde",
  "admin.people.billing.freqMonthly": "Pro Monat",
  "admin.people.billing.freqQuarterly": "Pro Quartal",
  "admin.people.billing.payAdvance": "Im Voraus",
  "admin.people.billing.payArrears": "Nachgelagert",

  "admin.people.editSection.baseTitle": "Basisdaten",
  "admin.people.editSection.billingTitle": "Rechnung",
  "admin.people.editSection.relationshipsTitle": "Beziehungen & Kontakte",
  "admin.people.editSection.communicationTitle": "Kommunikationsgruppen",
  "admin.people.editSection.doneEditingSection": "Fertig",
  "admin.people.editSection.manageCommunication": "Gruppen pflegen",
  "admin.people.editSection.billingRecipientSelfSummary":
    "Rechnung geht an diese Person.",
  "admin.people.editSection.billingRecipientOtherSummary":
    "Rechnung geht an {name}.",
  "admin.people.editSection.billingRecipientDraftSummary":
    "Rechnung an anderen Kontakt — Angaben im Bereich „Rechnung“ vervollständigen.",
  "admin.people.editSection.billingRhythmAndPaymentSummary":
    "{rhythm} · {payment}",
  "admin.people.editSection.optionalBillingEmptySummary":
    "Rhythmus und Zahlungszeitpunkt optional — im Bereich „Rechnung“ bearbeiten.",
  "admin.people.editSection.openBillingForRecipient": "Rechnung öffnen",

  "admin.people.listSheet.closeAria": "Menü schließen",
  "admin.people.listSheet.title": "{name}",
  "admin.people.listSheet.subtitle": "Was möchtest du tun?",
  "admin.people.listSheet.actionsAria": "Aktionen für diesen Kontakt",
  "admin.people.listSheet.moreAria": "Weitere Aktionen für {name}",
  "admin.people.listSheet.editStammdaten": "Stammdaten bearbeiten",
  "admin.people.listSheet.openProfile": "Profil anzeigen",
  "admin.people.listSheet.billingAndRhythm": "Rechnung & Abrechnung",
  "admin.people.listSheet.removeContact": "Kontakt entfernen",

  "admin.people.list.columns.title": "Spalten",
  "admin.people.list.columns.configure": "Spalten",
  "admin.people.list.columns.reset": "Standard wiederherstellen",
  "admin.people.list.columns.hint":
    "Wähle die sichtbaren Spalten in der Desktop-Tabelle.",
  "admin.people.list.columns.sectionColumns": "Spalten",
  "admin.people.list.columns.sectionOptions": "Optionen",
  "admin.people.list.columns.requiredBadge": "Pflicht",
  "admin.people.list.columns.name": "Name",
  "admin.people.list.columns.roles": "Rollen",
  "admin.people.list.columns.birthDate": "Geburtstag",
  "admin.people.list.columns.email": "E-Mail",
  "admin.people.list.columns.phone": "Telefon",
  "admin.people.list.columns.street": "Straße",
  "admin.people.list.columns.houseNumber": "Hausnummer",
  "admin.people.list.columns.postalCode": "PLZ",
  "admin.people.list.columns.city": "Stadt",
  "admin.people.list.columns.country": "Land",
  "admin.people.list.columns.notes": "Notizen",
  "admin.people.list.columns.billingRecipient": "Rechnungsempfänger",
  "admin.people.list.columns.billingFrequency": "Abrechnungsrhythmus",
  "admin.people.list.columns.billingPaymentTiming": "Zahlungszeitpunkt",
  "admin.people.list.columns.inactive": "Inaktiv",
  "admin.people.list.table.aria": "Kontaktliste als Tabelle",

  "admin.people.list.inlineEdit.enable": "Direkt in der Tabelle bearbeiten",
  "admin.people.list.inlineEdit.hint":
    "Felder per Klick bearbeiten — Enter speichert, Esc bricht ab.",
  "admin.people.list.inlineEdit.saveFailed":
    "Änderung konnte nicht gespeichert werden.",
  "admin.people.list.inlineEdit.fieldSaved": "{field} wurde gespeichert.",
  "admin.people.list.inlineEdit.cellAria": "{column} für {name} bearbeiten",

  "admin.people.trainerMirror.badge": "Trainer",
  "admin.people.contactRole.trainer": "Trainer",
  "admin.people.contactRole.trainerAssistant": "Assistent",
  "admin.people.contactRole.player": "Schüler",
  "admin.people.contactRole.billingRecipient": "Rechnungsempfänger",
  "admin.people.contactRole.billingRecipientCompact": "Rechnung",
  "admin.people.contactRole.vendor": "Händler / Lieferant",
  "admin.people.contactRole.vendorCompact": "Händler",
  "admin.people.trainerMirror.readOnlyHint":
    "Trainer-Stammdaten werden in TrainingsDesk gepflegt. Dieser Eintrag ist eine schreibgeschützte Spiegelung für die Kontaktliste.",
  "admin.people.trainerMirror.readOnlyWithBillingHint":
    "Trainer-Stammdaten werden in TrainingsDesk gepflegt. Rechnungsempfänger-Daten können hier bearbeitet werden.",
  "admin.people.trainerMirror.billingSectionTitle": "Rechnungsempfänger",
  "admin.people.trainerMirror.billingSectionHint":
    "Kontaktdaten für Rechnungen und Abrechnung (E-Mail, Telefon).",
  "admin.people.trainerMirror.editBillingRecipient":
    "Rechnungsempfänger bearbeiten",
  "admin.people.trainerMirror.editInTrainerstunden":
    "In TrainingsDesk bearbeiten",
  "admin.people.trainerMirror.alsoPlayerHint":
    "Dieselbe Person ist auch als Spieler/Kontakt erfasst – Spielerdaten weiterhin hier unter Kontakte pflegen.",
  "admin.people.trainerMirror.deleteForbidden":
    "Trainer können nicht aus der Kontaktliste entfernt werden. Bitte in TrainingsDesk deaktivieren.",

  "admin.people.nav.leaveModuleAria": "Zurück zur vorherigen Seite",

  "admin.people.billingMirrorUpsertFailed":
    "Der Rechnungskontakt konnte nicht in der Kontaktliste gespiegelt werden.",
  "admin.people.search.contextInvoiceTo": "Rechnung: {name}",
  "admin.people.search.contextBillingRecipientFor":
    "Rechnungsempfänger für {names}",

  "players.viewMode.label": "Ansicht",
  "players.viewMode.aria": "Darstellung der Spielerliste",
  "players.viewMode.compact": "Kompakt",
  "players.viewMode.relationships": "Beziehungen",

  "contacts.viewMode.label": "Ansicht",
  "contacts.viewMode.aria": "Darstellung der Kontaktliste",
  "contacts.viewMode.compact": "Kompakt",
  "contacts.viewMode.relationships": "Beziehungen & Netzwerk",

  "contacts.card.openDetailAria": "Kontaktdetails zu {name} öffnen",
  "contacts.card.editAria": "Kontakt bearbeiten",
  "contacts.card.deleteAria": "Kontakt löschen",
  "contacts.edit.dismiss": "Schließen",
  "contacts.edit.dismissAria": "Bearbeitung schließen",
  "contacts.edit.savedBrief": "Kontakt gespeichert.",

  "admin.contacts.list.rolesAria": "Rollen und Typen dieses Kontakts",

  "admin.contacts.badge.billingRecipient": "Rechnungskontakt",
  "admin.contacts.badge.trainerLink": "Trainer",
  "admin.contacts.badge.player": "Spieler",
  "admin.contacts.badge.guardianLinked": "{role} · {count} Spieler",
  "admin.contacts.badge.guardianWithBillingDelegation":
    "{role} · Rechnungskontakt · {count} Spieler",

  "admin.contacts.relationshipShort.child": "Kind",
  "admin.contacts.relationshipShort.parent": "Elternteil",
  "admin.contacts.relationshipShort.partner": "Partner/Ehepartner",
  "admin.contacts.relationshipShort.mother": "Mutter",
  "admin.contacts.relationshipShort.father": "Vater",
  "admin.contacts.relationshipShort.sibling": "Geschwister",
  "admin.contacts.relationshipShort.trainer": "Trainer",
  "admin.contacts.relationshipShort.emergencyContact": "Notfallkontakt",
  "admin.contacts.relationshipShort.payer": "Zahler",
  "admin.contacts.relationshipShort.mainContact": "Kontakt",
  "admin.contacts.relationshipShort.billingRecipient": "Rechnungsempfänger",
  "admin.contacts.relationshipShort.serviceRecipient": "Leistungsempfänger",
  "admin.contacts.relationshipShort.trainee": "Spieler",

  "admin.contacts.relationshipSearchKind.child": "Kind",
  "admin.contacts.relationshipSearchKind.parent": "Elternteil",
  "admin.contacts.relationshipSearchKind.partner": "Partner/Ehepartner",
  "admin.contacts.relationshipSearchKind.mother": "Mutter",
  "admin.contacts.relationshipSearchKind.father": "Vater",
  "admin.contacts.relationshipSearchKind.sibling": "Geschwister",
  "admin.contacts.relationshipSearchKind.trainer": "Trainer",
  "admin.contacts.relationshipSearchKind.mainContact": "Kontakt",
  "admin.contacts.relationshipSearchKind.emergencyContact": "Notfallkontakt",
  "admin.contacts.relationshipSearchKind.payer": "Zahler",
  "admin.contacts.relationshipSearchKind.billingRecipient":
    "Rechnungsempfänger",
  "admin.contacts.relationshipSearchKind.serviceRecipient":
    "Leistungsempfänger",
  "admin.contacts.relationshipSearchKind.trainee": "Spieler",
  "players.actions.edit": "Bearbeiten",
  "players.actions.delete": "Löschen",
  "players.relationship.child": "Kind: {name}",
  "players.relationship.parent": "Elternteil: {name}",
  "players.relationship.partner": "Partner/Ehepartner: {name}",
  "players.relationship.mother": "Mutter: {name}",
  "players.relationship.father": "Vater: {name}",
  "players.relationship.sibling": "Geschwister: {name}",
  "players.relationship.trainer": "Trainer: {name}",
  "players.relationship.emergencyContact": "Notfallkontakt: {name}",
  "players.relationship.payer": "Zahler: {name}",
  "players.relationship.mainContact": "Kontakt: {name}",
  "players.relationship.billingRecipient": "Rechnungsempfänger: {name}",
  "players.relationship.serviceRecipient": "Leistungsempfänger: {name}",
  "players.relationship.trainee": "Spieler: {name}",
  "players.relationship.inverse.child": "Kind",
  "players.relationship.inverse.parent": "Elternteil",
  "players.relationship.inverse.partner": "Partner/Ehepartner",
  "players.relationship.inverse.serviceRecipient": "Leistungsempfänger",
  "players.relationship.inverse.billedFor": "Rechnung für",
  "players.relationship.inverse.linkedPerson": "Verknüpft",
  "players.relationship.inverse.trainee": "Spieler",
  "players.relationship.inverse.sibling": "Geschwister",
  "players.relationships.inverseFromProfile":
    "Verknüpfung aus Stammdaten von {name}",
  "players.groups.family": "Familie",
  "players.groups.training": "Training",
  "players.groups.team": "Team",
  "players.groups.whatsapp": "WhatsApp",
  "players.groups.custom": "Gruppe",
  "players.groups.parents": "Eltern",
  "players.groups.carpool": "Fahrgemeinschaft",
  "players.groups.sectionTitle": "Kommunikationsgruppen",
  "players.groups.empty": "Noch keine Gruppe zugeordnet.",
  "players.groups.addExisting": "Bestehende Gruppe zuweisen",
  "players.groups.createNew": "Neue Gruppe anlegen",
  "players.groups.name": "Name der Gruppe",
  "players.groups.kind": "Art",
  "players.groups.inviteUrl": "Link / Einladungs-URL (optional)",
  "players.groups.assign": "Zuweisen",
  "players.groups.remove": "Entfernen",
  "players.groups.createAndAssign": "Anlegen und zuweisen",
  "players.groups.saveFailed":
    "Kommunikationsgruppen konnten nicht gespeichert werden.",
  "players.groups.loadFailed": "Gruppenliste konnte nicht geladen werden.",
  "players.detail.title": "Kontaktprofil",
  "players.detail.contact": "Kontakt",
  "players.detail.contactEmpty": "Keine Kontaktdaten hinterlegt.",
  "players.detail.fieldNotSet": "Nicht hinterlegt",
  "players.detail.billingRhythmNotSet": "Kein Abrechnungsrhythmus hinterlegt",
  "players.detail.relationships": "Beziehungen & Kontakte",
  "players.detail.groups": "Kommunikationsgruppen",
  "players.detail.plannedTrainings": "Geplante Trainings",
  "players.detail.noPlannedTrainings":
    "Keine geplanten Trainings mit diesem Kontakt.",
  "players.detail.trainingWith": "Mit: {names}",
  "players.detail.trainer": "Trainer: {name}",
  "players.detail.backToPlayers": "Zurück zur Kontaktliste",
  "players.detail.backNavAria":
    "Zurück zur vorherigen Seite oder zur Kontaktliste",
  "players.detail.editContact": "Bearbeiten",
  "players.detail.editContactAria": "Kontakt bearbeiten",
  "players.detail.coachDeskEmbedHeading": "Kontaktprofil",
  "players.detail.loadFailed": "Daten konnten nicht geladen werden.",
  "players.detail.notFound": "Kontakt nicht gefunden.",
  "players.detail.invalidRoute": "Ungültige Adresse.",
  "players.detail.relationshipsEmpty": "Keine verknüpften Kontakte hinterlegt.",
  "players.detail.groupsEmpty": "Keine Gruppen hinterlegt.",
  "players.detail.noGroups": "Keine Kommunikationsgruppen zugeordnet.",
  "players.detail.status.planned": "Geplant",
  "players.detail.status.completed": "Abgeschlossen",
  "players.detail.status.cancelled": "Abgesagt",
  "players.detail.status.other": "Status: {status}",
  "players.detail.trainingMonths": "Trainings nach Monat",
  "players.detail.pastTrainings": "Vergangene Trainings",
  "players.detail.editTraining": "Training bearbeiten",
  "players.detail.deleteTraining": "Training löschen",
  "players.detail.deleteTrainingConfirm":
    "Diesen Trainingstermin wirklich löschen? Die Buchung wird entfernt.",
  "players.detail.noUpcomingTrainings":
    "Keine anstehenden Trainings im nächsten Halbjahr.",
  "players.detail.deleteTrainingFailed":
    "Der Termin konnte nicht gelöscht werden.",
  "players.detail.laterPlannedTrainings":
    "Weitere geplante Termine (über sechs Monate hinaus)",
  "players.detail.trainingSheetSubtitle":
    "Trainingstermin bearbeiten oder löschen",
  "players.detail.trainingSheetActionsAria": "Aktionen für Trainingstermin",
  "players.contact.phoneShort": "Anrufen",
  "players.contact.emailShort": "E-Mail",
  "players.contact.phoneAria": "Telefon anrufen",
  "players.contact.emailAria": "E-Mail schreiben",
  "players.card.openDetailAria": "Details zu {name} öffnen",

  "players.relationships.group.family": "Familie",
  "players.relationships.group.training": "Training",
  "players.relationships.group.organization": "Organisation",
  "players.relationships.sectionTitle": "Beziehungen & Kontakte",
  "players.relationships.add": "Beziehung hinzufügen",
  "players.relationships.empty": "Noch keine Beziehungen erfasst.",
  "players.relationships.type": "Beziehung",
  "players.relationships.relatedPerson": "Person aus Vereinsliste",
  "players.relationships.relatedPersonNone": "Keine Auswahl",
  "players.relationships.relatedPersonSearchPlaceholder":
    "Name oder Kontakt suchen …",
  "players.relationships.relatedPersonComboboxAria":
    "Person aus Vereinsliste suchen",
  "players.relationships.relatedPersonClear": "Auswahl entfernen",
  "players.relationships.relatedPersonNoResults":
    "Keine passende Person gefunden.",
  "players.relationships.relatedPersonResultCount":
    "{count} Treffer – bei mehr Namen nach unten scrollen oder genauer suchen",
  "players.relationships.freeTextName": "Name (Freitext)",
  "players.relationships.phone": "Telefon",
  "players.relationships.email": "E-Mail",
  "players.relationships.mainContact": "Als Hauptkontakt markieren",
  "players.relationships.emergencyContact": "Als Notfallkontakt markieren",
  "players.relationships.remove": "Entfernen",
  "players.relationships.saveUnsupported":
    "Die Datenbank-Anbindung für Beziehungen folgt — Entwürfe werden vorübergehend nur in diesem Browser gespeichert.",
  "players.relationships.persistHint":
    "Beziehungen werden zusammen mit der Person gespeichert.",
  "players.relationships.saveSuccess": "Beziehungen wurden gespeichert.",
  "players.relationships.saveFailed":
    "Beziehungen konnten nicht gespeichert werden. Ein lokaler Entwurf wurde behalten.",
  "players.relationships.relatedPersonRequired":
    "Bitte eine Person aus der Vereinsliste wählen.",
  "players.relationships.billingRecipientCreateFailed":
    "Rechnungsempfänger konnte nicht angelegt werden. Bitte Name prüfen und erneut speichern.",
  "players.relationships.billingRecipientAssignFailed":
    "Beziehung gespeichert, aber die Rechnungszuordnung konnte nicht gesetzt werden.",
  "players.relationships.freeTextNameBillingHint":
    "Nicht in der Vereinsliste? Name hier eintragen — wird beim Speichern als Rechnungsempfänger angelegt.",
  "players.relationships.crossTenantNotAllowed":
    "Diese Person gehört zu einem anderen Verein und kann hier nicht verknüpft werden.",
  "players.relationships.forbidden":
    "Für die verknüpfte Person fehlt die Berechtigung zum Speichern der Gegenbeziehung.",
  "players.relationships.backendUnavailable":
    "Backend für Beziehungen ist nicht erreichbar — es wird ein lokaler Entwurf verwendet.",
  "players.relationships.loadFailed":
    "Beziehungen konnten nicht geladen werden; es werden ggf. lokale Entwürfe angezeigt.",
  "players.relationships.unnamed": "Ohne Namen",

  "admin.locations.title": "Orte",
  "admin.locations.subtitle": "Orte/Anlagen zentral verwalten – für alle Apps.",
  "admin.locations.create": "Neuer Ort",
  "admin.locations.empty": "Noch keine Orte angelegt.",
  "admin.locations.loadFailed": "Orte konnten nicht geladen werden.",
  "admin.locations.saveFailed": "Speichern fehlgeschlagen.",
  "admin.locations.deleteConfirm.title": "Ort löschen?",
  "admin.locations.deleteConfirm.body":
    "Diese Aktion kann verknüpfte Termine beeinflussen.",
  "admin.locations.deleteFailed": "Löschen fehlgeschlagen.",
  "admin.locations.fields.name": "Name",
  "admin.locations.fields.notes": "Notizen",
  "admin.locations.fields.street": "Straße",
  "admin.locations.fields.postalCode": "PLZ",
  "admin.locations.fields.city": "Ort",
  "admin.locations.fields.courtFee": "Platzkosten (€)",
  "admin.locations.fields.courtFeePlaceholder": "z. B. 20",
  "admin.locations.fields.courtFeeHint":
    "Default für TrainingsDesk-Termine an diesem Ort; am Termin überschreibbar.",
  "admin.locations.fields.courtFeeInvalid":
    "Bitte einen gültigen Betrag für die Platzkosten eingeben (0 oder größer).",
  "admin.locations.fields.guestFee": "Gastspielergebühr (€)",
  "admin.locations.fields.guestFeePlaceholder": "z. B. 8",
  "admin.locations.fields.guestFeeHint":
    "Default je Termin für Nicht-Mitglieder dieses Vereins; am Termin überschreibbar. Geht auf deren Elternrechnung.",
  "admin.locations.fields.guestFeeInvalid":
    "Bitte einen gültigen Betrag für die Gastspielergebühr eingeben (0 oder größer).",
  "admin.locations.fields.locationType": "Typ",
  "admin.locations.fields.locationType.outdoor": "Außenanlage",
  "admin.locations.fields.locationType.indoor": "Halle",
  "admin.locations.fields.locationType.clubhouse": "Vereinsheim",
  "admin.locations.fields.locationType.training_site": "Trainingsgelände",
  "admin.locations.fields.locationType.external": "Extern",
  "admin.locations.search.placeholder": "Suchen (Name, Adresse)…",
  "admin.locations.alphabet.aria": "Alphabetische Navigation",

  "featureSelection.title": "Feature-Auswahl",
  "featureSelection.description":
    "Wähle die Apps (Module), die für dich relevant sind. Du kannst das später jederzeit ändern.",
  "featureSelection.marketplace.title": "App-Marketplace",
  "featureSelection.marketplace.subtitle":
    "Entdecke weitere Module und beantrage zusätzliche Rollen oder Apps für deinen Verein. Bereits zugewiesene Rechte bleiben unverändert.",
  "featureSelection.marketplace.subtitleMinor":
    "Als Minderjährige:r kannst du hier zusätzliche Apps und optional die Rolle Mannschaftsführer beantragen. Bereits zugewiesene Rechte bleiben unverändert.",
  "onboarding.q1.titleMinor":
    "Welche zusätzlichen Rollen oder Apps brauchst du?",
  "featureSelection.loadError": "Fehler beim Laden der Features",
  "featureSelection.noMainFeatures":
    "Keine Features in der 'main'-Gruppe gefunden. Bitte Datenbank prüfen.",
  "featureSelection.noFeatures": "Keine Features verfügbar.",
  "featureSelection.noSelection": "Bitte wähle mindestens ein Feature aus.",
  "featureSelection.save": "Auswahl speichern",
  "featureSelection.saveError": "Fehler beim Speichern",
  "featureSelection.reset": "Auswahl zurücksetzen",
  "featureSelection.resetHint": "für Tests",
  "featureSelection.resetConfirm":
    "Möchtest du die Auswahl wirklich zurücksetzen?",
  "featureSelection.selectedCount": "{n} ausgewählt",
  "featureSelection.debug.cta": "Debug: API testen",
  "featureSelection.debug.alert":
    "Debug: loadMainFeatures() → {status}\n{count} Features (main, enabled)\n{reason}\nSiehe Konsole.",
  "featureSelection.debug.alertError": "Debug-Fehler: {msg}\nSiehe Konsole.",
  "featureSelection.debugInfo.title": "Debug-Info:",
  "featureSelection.debugInfo.openConsole":
    "Bitte Browser-Konsole (F12) öffnen und Logs prüfen.",
  "featureSelection.debugInfo.expected":
    "Erwartet: Features mit group_id='main' und enabled=true.",
  "featureSelection.superadminRedirect":
    "Als Superadmin brauchst du keinen Zugriffsantrag. Wir leiten dich zum Hub …",
  "featureSelection.superadminGoHub": "Zum Hub",

  "accessPending.title": "Zugriff angefragt",
  "accessPending.subtitle":
    "Deine Anfrage wurde übermittelt und wartet auf Freigabe durch einen Vereins- oder System-Administrator. Bis dahin ist keine weitere Anfrage nötig.",
  "accessPending.hintAfterApproval":
    "Sobald die Freigabe erteilt wurde, kannst du die Apps wie gewohnt über den Hub nutzen.",
  "accessPending.loadError":
    "Status konnte nicht geladen werden. Bitte später erneut versuchen.",
  "accessPending.reload": "Status aktualisieren",
  "accessPending.openMarketplace": "Details im App-Marketplace",
  "accessPending.signOut": "Abmelden",
  "accessPending.emptyDetails":
    "Es liegen keine Detaildaten zur Anzeige vor. Bitte „Status aktualisieren“ nutzen.",
  "accessPending.fields.createdAt": "Anfrage erstellt am:",
  "accessPending.section.registrationOnboarding":
    "Neuer Verein / Registrierung",
  "accessPending.section.accessRequests": "Zugriffsanfrage",
  "accessPending.fields.club": "Verein / Wunsch:",
  "accessPending.fields.status": "Status:",
  "accessPending.fields.roles": "Beantragte Rollen:",
  "accessPending.fields.apps": "Beantragte Apps:",
  "accessPending.fields.scope": "Bereich:",
  "accessPending.status.pending": "Ausstehend",

  "onboarding.title": "Zugriff beantragen",
  "onboarding.subtitle":
    "Beantrage Rollen und Club-Kontext. Deine Anfrage bleibt pending, bis sie vom Club freigegeben wird.",
  "onboarding.notLoggedIn": "Bitte einloggen, um eine Anfrage zu erstellen.",
  "onboarding.q1.title": "Wobei möchtest du tennis-matches nutzen?",
  "onboarding.q2.title": "Für welchen Club bist du tätig?",
  "onboarding.q2.titlePlayer": "Für welchen Verein spielst du?",
  "onboarding.marketplace.minorRolesHint":
    "Als Minderjährige:r kannst du hier die Rolle Spieler sowie optional Mannschaftsführer beantragen.",
  "onboarding.clubs.assignedTitle": "Deine Zuordnungen",
  "onboarding.clubs.noneAssigned":
    "Dir ist aktuell kein Verein zugeordnet. Wähle unten einen Club aus oder trage die technische Vereins-ID ein, falls du bereits eingeladen wurdest.",
  "onboarding.clubs.select.label": "Club auswählen",
  "onboarding.clubs.rolesSummary": "{{club}}: {{roles}}",
  "onboarding.clubs.scopeManualHint":
    "Falls dein Verein nicht in der Liste steht, kannst du die technische Vereins-ID eintragen (z. B. nach Einladung).",
  "onboarding.q3.title": "Koordinierst du andere Trainer?",
  "onboarding.apps.title": "Welche Apps brauchst du zusätzlich?",
  "onboarding.apps.noScope": "Bitte zuerst einen Club auswählen.",
  "onboarding.apps.loading": "Scope-Verfuegbarkeit wird geladen...",
  "onboarding.apps.noneAvailable":
    "Fuer diesen Scope sind aktuell keine zusaetzlichen Apps verfuegbar.",
  "onboarding.apps.hint":
    "Es werden nur scope-weit freigegebene Apps angeboten.",
  "onboarding.roles.trainer": "Trainer",
  "onboarding.roles.clubOfficial": "Vereinsfunktionär",
  "onboarding.roles.trainerCoordinator": "Trainingskoordinator",
  "onboarding.roles.sportwart": "Sportwart",
  "onboarding.roles.jugendwart": "Jugendwart",
  "onboarding.roles.vorstand": "Vorstand",
  "onboarding.roles.vereinsadmin": "Vereinsadmin",
  "onboarding.roles.kassenwart": "Kassenwart / Abrechnung",
  "onboarding.roles.eventOrganizer": "Turnier-/Eventorganisator",
  "onboarding.roles.teamCaptain": "Mannschaftsführer",
  "onboarding.roles.player": "Spieler",
  "onboarding.roles.parent": "Elternteil",
  "onboarding.roles.missing": "Bitte mindestens eine Rolle auswählen.",
  "onboarding.roles.assignedLock": "(zugewiesen)",
  "onboarding.roles.pendingLock": "(ausstehend)",
  "onboarding.apps.assignedLock": "(zugewiesen)",
  "onboarding.apps.pendingLock": "(ausstehend)",
  "onboarding.playerProfile.title": "Spielerdaten freigeben",
  "onboarding.playerProfile.hint":
    "Für {{apps}} werden Spielerdaten (Name, Altersklasse, Spielstärke) im Club-Kontext benötigt, damit du dich anmelden oder eingeplant werden kannst.",
  "onboarding.playerProfile.consent":
    "Meine Spielerdaten im Club-Kontext für die gewählten Apps freigeben",
  "onboarding.playerProfile.scopeHint":
    "Die Freigabe gilt nur für den ausgewählten Verein und die beantragten Apps. Du kannst sie später in „Meine Daten“ anpassen.",
  "onboarding.submit.nothingNew":
    "Keine neuen Rollen oder Apps ausgewählt. Bereits zugewiesene Rechte können hier nicht entfernt werden.",
  "onboarding.scopeId.label": "Club/Tenant ID",
  "onboarding.scopeId.placeholder": "z. B. vereinsweit",
  "onboarding.scopeId.hint": "Phase 1 minimal: technische Scope-ID (tenant).",
  "onboarding.scopeId.missing": "Bitte eine Scope-ID angeben.",
  "onboarding.coordination.none": "Nein, nur eigene Trainings",
  "onboarding.coordination.single": "Ja, einzelne Trainer",
  "onboarding.coordination.multiple": "Ja, mehrere Trainer/Gruppen",
  "onboarding.coordination.area": "Ja, ganzer Trainingsbereich",
  "onboarding.note.title": "Notiz (optional)",
  "onboarding.note.label": "Notiz",
  "onboarding.note.placeholder": "Optional",
  "onboarding.submit": "Anfrage erstellen",
  "onboarding.submit.hint":
    "Nur neue Rollen/Apps werden beantragt; bestehende Zuweisungen bleiben unverändert.",
  "onboarding.submit.created":
    "Anfrage erstellt. Status: pending. Freigabe erforderlich.",
  "onboarding.submit.blockedByPending":
    "Es liegt bereits eine ausstehende Zugriffs- oder Registrierungsanfrage vor. Bitte warte auf die Freigabe.",
  "onboarding.status.title": "Deine Anfrage",
  "onboarding.status.subtitle":
    "Deine Anfrage wurde übermittelt. Du kannst den Status hier einsehen.",
  "onboarding.status.submittedLead":
    "Deine Anfrage wurde erfolgreich übermittelt und wartet auf Freigabe.",
  "onboarding.status.reviewerSuperadmin":
    "Für diesen Verein ist noch kein Administrator hinterlegt. Ein Plattform-Administrator (Superadmin) prüft deine Anfrage.",
  "onboarding.status.reviewerClubAdmin":
    "Ein Vereins- oder System-Administrator prüft deine Anfrage.",
  "onboarding.extendRequest.summary": "Anfrage bei Bedarf erweitern",
  "onboarding.extendRequest.hint":
    "Optional: zusätzliche Rollen oder Apps beantragen, sobald die laufende Anfrage bearbeitet wurde.",
  "onboarding.clubs.searchNoResultsHint":
    "Kein passender Verein gefunden? Nutze „Mein Verein ist nicht dabei“, um einen neuen Verein als Wunsch einzureichen.",
  "onboarding.clubs.pickOrNewRequired":
    "Bitte einen bestehenden Verein aus der Suche wählen oder über „Mein Verein ist nicht dabei“ einen neuen Verein beantragen.",
  "onboarding.submit.failed": "Anfrage fehlgeschlagen ({reason}).",
  "onboarding.error.details": "Fehlerdetails anzeigen",
  "onboarding.myRequests.title": "Meine Anfragen",
  "onboarding.myRequests.empty": "Noch keine Anfragen.",

  "accessRequestsAdmin.title": "User & Access Management",
  "accessRequestsAdmin.subtitle":
    "Verwalte Zugriffsanfragen, Einladungen und App-Zugriffe für deinen Club/Bereich.",
  "accessRequestsAdmin.notLoggedIn": "Bitte einloggen.",
  "accessRequestsAdmin.scopeId.label": "Club / Bereich",
  "accessRequestsAdmin.scopeId.placeholder":
    "z. B. 00000000-0000-4000-8000-000000000000",
  "accessRequestsAdmin.scopeId.hint":
    "Berechtigungsbasierte Liste deiner Bereiche. Einträge mit „Scope:“-Präfix haben keine Mandantenzuordnung.",
  "accessRequestsAdmin.scopeId.select.label": "Meine Clubs/Bereiche",
  "accessRequestsAdmin.scopeId.select.hint":
    "Technischer Hinweis: Auflösung über resolve_tenant_scope_labels.",
  "accessRequestsAdmin.scopeId.picker.governanceScope": "Scope: {{name}}",
  "accessRequestsAdmin.scopeId.picker.mergedScopeIdsTitle":
    "Zusätzliche Kennungen für denselben Verein: {{ids}}",
  "accessRequestsAdmin.scopeId.picker.externalScope":
    "Aktueller Verein (nicht in Meine Vereine)",
  "accessRequestsAdmin.scopeId.search.placeholder": "Club suchen …",
  "accessRequestsAdmin.scopeId.search.aria": "Club suchen und auswählen",
  "accessRequestsAdmin.scopeId.search.noResults": "Kein Club gefunden.",
  "accessRequestsAdmin.scopeId.search.clear": "Clubauswahl löschen",
  "accessRequestsAdmin.tabs.clubs": "Alle Vereine",
  "accessRequestsAdmin.tabs.clubsWithCount": "Alle Vereine ({n})",
  "accessRequestsAdmin.clubs.title": "Alle Vereine ({n})",
  "accessRequestsAdmin.clubs.hint":
    "Übersicht aller Vereine in der Plattform. Wähle einen Verein, um ihn als Arbeitsbereich zu setzen.",
  "accessRequestsAdmin.clubs.searchLabel": "Suche",
  "accessRequestsAdmin.clubs.searchPlaceholder": "Name, Ort oder Kennung …",
  "accessRequestsAdmin.clubs.columnName": "Verein",
  "accessRequestsAdmin.clubs.columnCity": "Ort",
  "accessRequestsAdmin.clubs.columnMembers": "Nutzer",
  "accessRequestsAdmin.clubs.select": "Auswählen",
  "accessRequestsAdmin.clubs.selected": "Aktiv",
  "accessRequestsAdmin.clubs.selectAction": "Verein auswählen",
  "accessRequestsAdmin.clubs.empty": "Keine Vereine geladen.",
  "accessRequestsAdmin.clubs.emptySearch": "Keine Treffer für die Suche.",
  "accessRequestsAdmin.clubs.resultCount": "{shown} von {total} Vereinen",
  "accessRequestsAdmin.clubs.loadError":
    "Vereinsliste konnte nicht geladen werden.",
  "accessRequestsAdmin.clubs.loadErrorUnauthorized":
    "Keine Berechtigung für die Vereinsübersicht.",
  "accessRequestsAdmin.clubs.refresh": "Aktualisieren",
  "accessRequestsAdmin.decisionNote.label": "Notiz (optional)",
  "accessRequestsAdmin.decisionNote.placeholder": "Optional",
  "accessRequestsAdmin.tabs.aria": "Tabs: Berechtigungszentrale",
  "accessRequestsAdmin.tabs.pending": "Offene Anfragen",
  "accessRequestsAdmin.tabs.pendingWithCount": "Offene Anfragen ({n})",
  "accessRequestsAdmin.tabs.history": "Historie",
  "accessRequestsAdmin.tabs.members": "Aktive Personen",
  "accessRequestsAdmin.tabs.membersWithCount": "Aktive Personen ({n})",
  "accessRequestsAdmin.tabs.invites": "Einladungen",
  "accessRequestsAdmin.tabs.roles": "Rollen & Apps",
  "accessRequestsAdmin.debug.tab": "Governance Debug",
  "accessRequestsAdmin.debug.title": "Governance Debug",
  "accessRequestsAdmin.debug.description":
    "Diagnose-Ansicht: zeigt Governance-v2-Daten aus den bestehenden RPCs (ohne Änderungen).",
  "accessRequestsAdmin.debug.scopeId": "Scope-ID",
  "accessRequestsAdmin.debug.memberId": "Member-ID (UUID, optional)",
  "accessRequestsAdmin.debug.memberId.placeholder":
    "z. B. 00000000-0000-0000-0000-000000000000",
  "accessRequestsAdmin.debug.userId": "User-ID (UUID, optional)",
  "accessRequestsAdmin.debug.userId.placeholder":
    "später für erweiterte Diagnose",
  "accessRequestsAdmin.debug.userId.hint":
    "Hinweis: Noch keine Impersonation. Feld dient nur als Vorbereitung.",
  "accessRequestsAdmin.debug.load": "Debug laden",
  "accessRequestsAdmin.debug.scopeRefs": "Scope References",
  "accessRequestsAdmin.debug.memberRefs": "Member References",
  "accessRequestsAdmin.debug.effectivePermissions":
    "Effective Member Permissions",
  "accessRequestsAdmin.debug.memberExplanation": "Member Access Explanation",
  "accessRequestsAdmin.debug.trainingAdoptionRequests":
    "Training Adoption Requests (Scope)",
  "accessRequestsAdmin.debug.audit": "Access Grant Audit (Scope)",
  "accessRequestsAdmin.debug.empty": "Keine Daten.",
  "accessRequestsAdmin.debug.error": "Fehler beim Laden dieses Blocks.",
  "accessRequestsAdmin.debug.block.idle": "idle",
  "accessRequestsAdmin.debug.block.loading": "loading",
  "accessRequestsAdmin.debug.block.ok": "ok",
  "accessRequestsAdmin.debug.block.error": "error",
  "accessRequestsAdmin.debug.block.details": "Details anzeigen",
  "accessRequestsAdmin.debug.block.data": "JSON anzeigen",
  "accessRequestsAdmin.debug.status.missingScope":
    "Bitte zuerst eine Scope-ID auswählen.",
  "accessRequestsAdmin.debug.status.invalidMemberId":
    "Member-ID ist kein gültiges UUID-Format.",
  "accessRequestsAdmin.debug.status.invalidUserId":
    "User-ID ist kein gültiges UUID-Format.",
  "accessRequestsAdmin.debug.status.loaded": "Debug-Daten geladen.",
  "accessRequestsAdmin.superadminDeleteUser.title":
    "User vollständig löschen (Superadmin)",
  "accessRequestsAdmin.superadminDeleteUser.warning":
    "Löscht den Auth-User und zugehörige Governance-Daten unwiderruflich. Nur nutzen, wenn der Account wirklich entfernt werden soll. Du kannst dich selbst nicht löschen.",
  "accessRequestsAdmin.superadminDeleteUser.emailLabel":
    "E-Mail-Adresse des zu löschenden Users",
  "accessRequestsAdmin.superadminDeleteUser.emailPlaceholder":
    "name@beispiel.de",
  "accessRequestsAdmin.superadminDeleteUser.previewButton": "Prüfen (Vorschau)",
  "accessRequestsAdmin.superadminDeleteUser.previewTitle": "Vorschau (JSON)",
  "accessRequestsAdmin.superadminDeleteUser.previewJsonToggle":
    "Vorschau-Daten",
  "accessRequestsAdmin.superadminDeleteUser.previewJsonTechnical":
    "Technische Details (JSON)",
  "accessRequestsAdmin.superadminDeleteUser.previewDone":
    "Vorschau geladen. Bitte Daten prüfen, dann E-Mail zur Bestätigung erneut eingeben.",
  "accessRequestsAdmin.superadminDeleteUser.previewDoneWithErrors":
    "Vorschau geladen, aber einige Tabellen liefern harte Fehler — Löschen ist blockiert, bis die Vorschau fehlerfrei ist.",
  "accessRequestsAdmin.superadminDeleteUser.previewDoneNoDelete":
    "Vorschau geladen. Für diese E-Mail ist keine Lösch-Aktion freigeschaltet (kein Auth-User und keine orphanen Datensätze, oder keine berechenbare Löschmenge).",
  "accessRequestsAdmin.superadminDeleteUser.summary.aria":
    "Auswertung Superadmin-Löschvorschau",
  "accessRequestsAdmin.superadminDeleteUser.summary.title": "Kurzfassung",
  "accessRequestsAdmin.superadminDeleteUser.summary.emailNormalized":
    "Normalisierte E-Mail",
  "accessRequestsAdmin.superadminDeleteUser.summary.statusUser":
    "Status (Konto)",
  "accessRequestsAdmin.superadminDeleteUser.summary.valueFound": "Gefunden",
  "accessRequestsAdmin.superadminDeleteUser.summary.valueNotFound":
    "Nicht gefunden",
  "accessRequestsAdmin.superadminDeleteUser.summary.authUser":
    "Auth-User (auth.users)",
  "accessRequestsAdmin.superadminDeleteUser.summary.uniqueAppGovernanceRows":
    "Eindeutige App-/Governance-Datensätze (ohne auth.users; doppelte Treffer über mehrere Prädikate dedupliziert)",
  "accessRequestsAdmin.superadminDeleteUser.summary.warningsTitle":
    "Technische Hinweise (Vorschau)",
  "accessRequestsAdmin.superadminDeleteUser.summary.warningRow":
    "{table}: {reason}",
  "accessRequestsAdmin.superadminDeleteUser.summary.skipReason.noUserFkColumn":
    "Keine passende User-FK-Spalte — für die Vorschau übersprungen (optional).",
  "accessRequestsAdmin.superadminDeleteUser.summary.skipReason.tableMissing":
    "Tabelle fehlt — übersprungen.",
  "accessRequestsAdmin.superadminDeleteUser.summary.deletePossible":
    "Vollständiges Löschen möglich",
  "accessRequestsAdmin.superadminDeleteUser.summary.valueYes": "Ja",
  "accessRequestsAdmin.superadminDeleteUser.summary.valueNo": "Nein",
  "accessRequestsAdmin.superadminDeleteUser.emptyState.hint":
    "Für diese E-Mail liegt kein löschbares Konto mit Daten vor. Es gibt hier nichts Bestätigendes zu löschen — bei Bedarf erneut prüfen oder andere E-Mail eingeben.",
  "accessRequestsAdmin.superadminDeleteUser.previewPartialTitle":
    "Einige Bereiche der Vorschau ließen sich nicht auswerten:",
  "accessRequestsAdmin.superadminDeleteUser.previewPartialRow":
    "{table}: {hint}",
  "accessRequestsAdmin.superadminDeleteUser.error.deleteBlocked":
    "Lösch-Aktion blockiert: Vorschau meldet harte Tabellenfehler, oder es fehlen Auth-User und löschbare Datensätze. Bitte erneut „Prüfen (Vorschau)“ ausführen.",
  "accessRequestsAdmin.superadminDeleteUser.confirmLabel":
    "E-Mail zur Bestätigung erneut eingeben",
  "accessRequestsAdmin.superadminDeleteUser.confirmPlaceholder":
    "exakt dieselbe E-Mail",
  "accessRequestsAdmin.superadminDeleteUser.confirmHint":
    "Die Bestätigung muss mit der oberen E-Mail identisch sein (nach Normalisierung).",
  "accessRequestsAdmin.superadminDeleteUser.deleteButton": "Endgültig löschen",
  "accessRequestsAdmin.superadminDeleteUser.deleteDone":
    "User und zugehörige Daten wurden gelöscht.",
  "accessRequestsAdmin.superadminDeleteUser.deleteNoAuthUser":
    "Kein Auth-User mit dieser E-Mail. Offene Einladungen für diese E-Mail entfernt: {invites}.",
  "accessRequestsAdmin.superadminDeleteUser.error.invalidEmail":
    "Bitte eine gültige E-Mail-Adresse eingeben.",
  "accessRequestsAdmin.superadminDeleteUser.error.confirmMismatch":
    "Die Bestätigungs-E-Mail stimmt nicht mit der Ziel-E-Mail überein.",
  "accessRequestsAdmin.emailProbeAbuse.title":
    "Login-E-Mail-Prüfung (Missbrauch)",
  "accessRequestsAdmin.emailProbeAbuse.description":
    "Verdächtige IPs beim Prüfen von Registrierungs-E-Mails (Rate-Limit / Blacklist). Abgefragte Adressen und Entsperren für den Login.",
  "accessRequestsAdmin.emailProbeAbuse.refresh": "Aktualisieren",
  "accessRequestsAdmin.emailProbeAbuse.empty":
    "Keine gemeldeten Missbrauchs-Fälle.",
  "accessRequestsAdmin.emailProbeAbuse.unblock": "IP entsperren",
  "accessRequestsAdmin.emailProbeAbuse.recentLog": "Letzte Abfragen",
  "accessRequestsAdmin.emailProbeAbuse.badge.blacklisted": "Blacklist",
  "accessRequestsAdmin.emailProbeAbuse.badge.blockedUntil":
    "Gesperrt bis {until}",
  "accessRequestsAdmin.emailProbeAbuse.col.strikes": "Strikes",
  "accessRequestsAdmin.emailProbeAbuse.col.updated": "Zuletzt aktiv",
  "accessRequestsAdmin.emailProbeAbuse.col.probedEmails":
    "Abgefragte E-Mail-Adressen",
  "accessRequestsAdmin.emailProbeAbuse.status.unblocked":
    "IP {ip} wurde entsperrt.",
  "accessRequestsAdmin.emailProbeAbuse.error.load":
    "Missbrauchsliste konnte nicht geladen werden.",
  "accessRequestsAdmin.emailProbeAbuse.error.unblock":
    "IP konnte nicht entsperrt werden.",
  "accessRequestsAdmin.userMonitoring.title":
    "Superadmin-Monitoring (Usermanagement)",
  "accessRequestsAdmin.userMonitoring.description":
    "Monitoring für ungewöhnliche externe Zugriffe sowie Registrierungsversuche und bereits registrierte Accounts.",
  "accessRequestsAdmin.userMonitoring.refresh": "Aktualisieren",
  "accessRequestsAdmin.userMonitoring.empty": "Keine Einträge vorhanden.",
  "accessRequestsAdmin.userMonitoring.error.load":
    "Monitoring-Daten konnten nicht geladen werden.",
  "accessRequestsAdmin.userMonitoring.kpi.externalActiveIps":
    "Externe auffällige IPs: {count}",
  "accessRequestsAdmin.userMonitoring.kpi.blacklistedIps":
    "Davon Blacklist: {count}",
  "accessRequestsAdmin.userMonitoring.kpi.attempts24h":
    "Registrierungsversuche (24h): {count}",
  "accessRequestsAdmin.userMonitoring.kpi.blocked24h":
    "Geblockte Versuche (24h): {count}",
  "accessRequestsAdmin.userMonitoring.kpi.registered24h":
    "Neu registriert (24h): {count}",
  "accessRequestsAdmin.userMonitoring.kpi.registered7d":
    "Neu registriert (7 Tage): {count}",
  "accessRequestsAdmin.userMonitoring.section.suspiciousIps":
    "Ungewöhnliche Zugriffe von außen ({count})",
  "accessRequestsAdmin.userMonitoring.section.registrationAttempts":
    "Registrierungsversuche ({count})",
  "accessRequestsAdmin.userMonitoring.section.recentRegistrations":
    "Bereits registrierte Accounts ({count})",
  "accessRequestsAdmin.userMonitoring.col.strikes": "Strikes",
  "accessRequestsAdmin.userMonitoring.col.blockedUntil": "Gesperrt bis",
  "accessRequestsAdmin.userMonitoring.col.outcome": "Ergebnis",
  "accessRequestsAdmin.userMonitoring.col.registeredAt": "Registriert am",
  "accessRequestsAdmin.userMonitoring.col.confirmedAt": "E-Mail bestätigt am",
  "accessRequestsAdmin.userMonitoring.badge.blacklisted": "Blacklist",
  "accessRequestsAdmin.superadminDeleteUser.error.forbidden":
    "Keine Berechtigung (nur globaler Superadmin).",
  "accessRequestsAdmin.superadminDeleteUser.error.self":
    "Der aktuell eingeloggte Superadmin-Account kann hier nicht gelöscht werden.",
  "accessRequestsAdmin.superadminDeleteUser.error.ambiguousEmail":
    "Mehrere Auth-User mit derselben E-Mail – bitte manuell in der Datenbank klären.",
  "accessRequestsAdmin.superadminDeleteUser.error.rpc":
    "RPC fehlgeschlagen. Details siehe Konsole oder Support.",

  "accessRequestsAdmin.pending.title": "Offene Anfragen ({n})",
  "accessRequestsAdmin.pending.hint":
    "Hier kannst du Anfragen prüfen und entscheiden.",
  "accessRequestsAdmin.pending.empty": "Keine offenen Anfragen.",
  "accessRequestsAdmin.pending.scopeTitle":
    "Offene Anfragen für gewählten Verein ({n})",
  "accessRequestsAdmin.pending.scopeHint":
    "Nur für den aktuell gewählten Club/Bereich im Dropdown.",
  "accessRequestsAdmin.pending.allOpenTitle":
    "Alle offenen Anfragen (Summe) ({n})",
  "accessRequestsAdmin.pending.allOpenHint":
    "Alle wartenden Zugriffsanfragen über alle Bereiche (Superadmin-Sicht).",
  "accessRequestsAdmin.requestStatus.pending": "Ausstehend",
  "accessRequestsAdmin.requestStatus.approved": "Genehmigt",
  "accessRequestsAdmin.requestStatus.rejected": "Abgelehnt",
  "accessRequestsAdmin.fields.apps": "Apps",
  "accessRequestsAdmin.fields.coordination": "Koordination",
  "accessRequestsAdmin.globalOnboarding.title":
    "Neue Vereine – Plattform ({n})",
  "accessRequestsAdmin.globalOnboarding.hint":
    "Neue Vereine aus der Registrierung: Mit „Genehmigen“ legt das System den Verein automatisch an oder ordnet ihn per Namensabgleich zu.",
  "accessRequestsAdmin.globalOnboarding.approveHint":
    "Rollen und Vereinsdaten kommen aus der Anfrage – keine manuelle Auswahl nötig.",
  "accessRequestsAdmin.globalOnboarding.flowExplain":
    "Ohne Ziel-Verein: automatischer Namensabgleich oder neuer Tenant. Mit Ziel-Verein: Zuordnung zum gewählten Verein.",
  "accessRequestsAdmin.globalOnboarding.requestedAppsLabel": "Gewünschte Apps",
  "accessRequestsAdmin.globalOnboarding.empty":
    "Keine globalen Neu-Verein-Anfragen.",
  "accessRequestsAdmin.placeholderClub.title":
    "Neu-Verein (älterer Platzhalter-Scope) ({n})",
  "accessRequestsAdmin.placeholderClub.hint":
    "Ältere Anfragen ohne Vereinszuordnung. Beim Genehmigen bitte den Ziel-Verein wählen.",
  "accessRequestsAdmin.placeholderClub.newClubWishHint":
    "Wunschverein aus der Registrierung (Freitext). Ohne automatischen Treffer muss ein bestehender Ziel-Verein gewählt werden.",
  "accessRequestsAdmin.placeholderClub.empty":
    "Keine Platzhalter-Neu-Verein-Anfragen.",
  "accessRequestsAdmin.placeholderClub.badge": "Platzhalter",
  "accessRequestsAdmin.orphanPending.title":
    "Anfragen ohne Vereins-Administrator ({n})",
  "accessRequestsAdmin.orphanPending.hint":
    "Diese Zugriffsanfragen betreffen Vereine, für die noch kein Administrator hinterlegt ist. Club-Admins bearbeiten Anfragen für ihren Verein selbst.",
  "accessRequestsAdmin.orphanPending.badge": "Ohne Vereins-Admin",
  "accessRequestsAdmin.globalOnboarding.badgeNewClub": "Neuer Verein",
  "accessRequestsAdmin.globalOnboarding.fields.displayName": "Name",
  "accessRequestsAdmin.globalOnboarding.fields.email": "E-Mail",
  "accessRequestsAdmin.globalOnboarding.fields.clubAndCity":
    "Gewünschter Verein",
  "accessRequestsAdmin.globalOnboarding.correctClubName.label":
    "Vereinsname (Korrektur bei Freigabe)",
  "accessRequestsAdmin.globalOnboarding.correctClubCity.label":
    "Ort (Korrektur bei Freigabe)",
  "accessRequestsAdmin.globalOnboarding.correctClubHint":
    "Optional: Name/Ort vor der Freigabe korrigieren. Alternativ unten einen bestehenden Verein als Ziel wählen (Migration).",
  "accessRequestsAdmin.globalOnboarding.requestedRolesLabel":
    "Gewünschte Rollen (Selbstauswahl)",
  "accessRequestsAdmin.globalOnboarding.finalRolesLabel":
    "Finale Rollen für Freigabe",
  "accessRequestsAdmin.globalOnboarding.finalRolesRequired":
    "Bitte mindestens eine Rolle für die Freigabe auswählen.",
  "accessRequestsAdmin.globalOnboarding.approveFailed":
    "Freigabe Neu-Verein fehlgeschlagen ({reason}).",
  "accessRequestsAdmin.globalOnboarding.approved": "Neu-Verein freigegeben.",
  "accessRequestsAdmin.globalOnboarding.rejectFailed":
    "Ablehnung Neu-Verein fehlgeschlagen ({reason}).",
  "accessRequestsAdmin.globalOnboarding.rejected":
    "Neu-Verein-Anfrage abgelehnt.",
  "accessRequestsAdmin.scopeTarget.label": "Ziel-Verein (Scope)",
  "accessRequestsAdmin.scopeTarget.auto":
    "Automatisch (Anfrage / neuer Verein)",
  "accessRequestsAdmin.scopeTarget.hintOnApprove":
    "Bei „Automatisch“ entscheidet die Freigabe-Logik (Namensabgleich oder ggf. neuer Tenant). Wählst du einen Ziel-Verein, wird nur diesem bestehenden Tenant zugeordnet – die Auswahl legt keinen separaten Anlage-Schritt fest.",
  "accessRequestsAdmin.reassign.open": "Verein ändern",
  "accessRequestsAdmin.reassign.cancel": "Abbrechen",
  "accessRequestsAdmin.reassign.targetScope": "Neuer Verein (Scope)",
  "accessRequestsAdmin.reassign.pickScope": "Bitte Ziel-Verein wählen",
  "accessRequestsAdmin.reassign.rolesLabel": "Rollen im neuen Verein",
  "accessRequestsAdmin.reassign.save": "Speichern",
  "accessRequestsAdmin.reassign.hint":
    "Alle Rollen und App-Zugriffe im bisherigen Verein werden für diesen User entfernt; im gewählten Verein werden Rollen neu gesetzt, App-Zugriffe werden übernommen.",
  "accessRequestsAdmin.reassign.missing":
    "Bitte Ziel-Verein und mindestens eine Rolle auswählen.",
  "accessRequestsAdmin.reassign.failed":
    "Vereinswechsel fehlgeschlagen ({reason}).",
  "accessRequestsAdmin.reassign.ok": "Vereinszuordnung aktualisiert.",
  "accessRequestsAdmin.debug.governanceSnapshot.title":
    "Governance-Kurzüberblick",
  "accessRequestsAdmin.debug.governanceSnapshot.globalPendingOnboarding":
    "Globale ausstehende Neu-Verein-Anfragen",
  "accessRequestsAdmin.debug.governanceSnapshot.superadminBindings":
    "Superadmin-Rollen (global)",
  "accessRequestsAdmin.debug.governanceSnapshot.manageableScopes":
    "Sichtbare Tenant-Scope-IDs",
  "accessRequestsAdmin.debug.governanceSnapshot.authUserId": "Aktuelle User-ID",
  "accessRequestsAdmin.debug.governanceSnapshot.isGlobalSuperadmin":
    "Globaler Superadmin",
  "accessRequestsAdmin.debug.governanceSnapshot.boolYes": "ja",
  "accessRequestsAdmin.debug.governanceSnapshot.boolNo": "nein",
  "accessRequestsAdmin.debug.governanceSnapshot.selectedScopeId":
    "Gewählter Scope (Dropdown)",
  "accessRequestsAdmin.debug.governanceSnapshot.scopePendingAccessCount":
    "Offene Zugriffsanfragen (gewählter Scope)",
  "accessRequestsAdmin.debug.governanceSnapshot.lastPendingSamples":
    "Letzte pending-Stichprobe (Anzahl Zeilen)",
  "governance.registrationOnboarding.submittedBanner":
    "Deine Registrierung wurde eingereicht. Ein Plattform-Admin prüft deinen Verein und deine Rollen.",
  "accessRequestsAdmin.actions.approve": "Genehmigen",
  "accessRequestsAdmin.actions.reject": "Ablehnen",
  "accessRequestsAdmin.fields.requester": "Antragsteller",
  "accessRequestsAdmin.fields.target": "Person",
  "accessRequestsAdmin.fields.scope": "Scope",
  "accessRequestsAdmin.fields.roles": "Rollen",
  "accessRequestsAdmin.fields.capabilities": "Capabilities",
  "accessRequestsAdmin.fields.superadminLead": "Review-Lead",
  "accessRequestsAdmin.superadminLead.awaiting":
    "Superadmin übernimmt vorläufig die Freigabe (Verein ohne bestätigten Admin).",
  "accessRequestsAdmin.fields.createdAt": "Erstellt",
  "accessRequestsAdmin.fields.note": "Notiz",
  "accessRequestsAdmin.lastApproval.title": "Letztes Approval Ergebnis",
  "accessRequestsAdmin.lastApproval.hint":
    "Details zur letzten Entscheidung (zur Kontrolle).",
  "accessRequestsAdmin.status.loadFailed": "Laden fehlgeschlagen ({reason}).",
  "accessRequestsAdmin.status.loaded": "Geladen ({n}).",
  "accessRequestsAdmin.status.approveFailed":
    "Genehmigen fehlgeschlagen ({reason}).",
  "accessRequestsAdmin.status.approved": "Genehmigt.",
  "accessRequestsAdmin.status.rejectFailed":
    "Ablehnen fehlgeschlagen ({reason}).",
  "accessRequestsAdmin.status.rejected": "Abgelehnt.",

  "accessRequestsAdmin.history.title": "Historie ({n})",
  "accessRequestsAdmin.history.hint":
    "Vergangene Entscheidungen in deinem Club/Bereich.",
  "accessRequestsAdmin.history.empty": "Keine Einträge.",
  "accessRequestsAdmin.history.fields.target": "Target",
  "accessRequestsAdmin.history.fields.roles": "Rollen",
  "accessRequestsAdmin.history.fields.scope": "Scope",
  "accessRequestsAdmin.history.fields.decidedBy": "Entschieden von",
  "accessRequestsAdmin.history.fields.decidedAt": "Entschieden am",
  "accessRequestsAdmin.history.fields.decisionNote": "Notiz",
  "accessRequestsAdmin.history.fields.resulting": "Berechtigungs-IDs",

  "accessRequestsAdmin.members.title": "Aktive Personen ({n})",
  "accessRequestsAdmin.members.hint":
    "Plattform-Nutzer mit aktiver Rolle im gewählten Verein. Globale Superadmins sind ausgeblendet. Trainer ohne Plattform-Zugang stehen unten; offene Einladungen darunter bzw. unter „Einladungen“.",
  "accessRequestsAdmin.members.trainerStewardship.title":
    "Trainer ohne Plattform-Zugang ({n})",
  "accessRequestsAdmin.members.trainerStewardship.hint":
    "Diese Trainer sind im Verein aktiv (TrainingsDesk-Stammdaten), haben aber noch keine Plattform-Rolle. Du kannst sie hier verwalten und optional einladen — auch wenn sie sich nicht selbst registrieren möchten.",
  "accessRequestsAdmin.members.trainerStewardship.empty":
    "Keine Trainer ohne Plattform-Zugang in diesem Verein.",
  "accessRequestsAdmin.members.trainerStewardship.fields.loginEmail":
    "Login-E-Mail",
  "accessRequestsAdmin.members.trainerStewardship.fields.loginStatus":
    "Login-Status",
  "accessRequestsAdmin.members.trainerStewardship.fields.stammdatenRole":
    "Stammdaten-Rolle",
  "accessRequestsAdmin.members.trainerStewardship.actions.openStammdaten":
    "In TrainingsDesk öffnen",
  "accessRequestsAdmin.members.trainerStewardship.actions.platformInvite":
    "Plattform einladen",
  "accessRequestsAdmin.members.trainerStewardship.status.noEmail":
    "Keine Login-E-Mail hinterlegt",
  "accessRequestsAdmin.members.loadError":
    "Die Liste der aktiven Personen konnte nicht geladen werden ({reason}{detail}).",
  "accessRequestsAdmin.members.emptyAfterError":
    "Es wurden keine Rollen-Zuordnungen angezeigt. Bitte die Fehlermeldung prüfen und erneut laden.",
  "accessRequestsAdmin.members.empty": "Keine aktiven Personen im Scope.",
  "accessRequestsAdmin.members.fields.userId": "Person",
  "accessRequestsAdmin.members.fields.roles": "Rollen",
  "accessRequestsAdmin.members.fields.scope": "Club / Bereich",
  "accessRequestsAdmin.members.fields.createdAt": "Seit",
  "accessRequestsAdmin.members.fields.updatedAt": "Aktualisiert",
  "accessRequestsAdmin.members.actions.showApps": "Apps anzeigen",
  "accessRequestsAdmin.members.actions.hideApps": "Apps ausblenden",
  "accessRequestsAdmin.members.apps.title": "Apps aus Rollen",
  "accessRequestsAdmin.members.apps.none": "Keine Apps sichtbar.",
  "accessRequestsAdmin.members.apps.hint":
    "Aus der Rollen-&-Apps-Matrix (global → Verein) für die Rollen dieser Person. Entspricht den angehakten Marketplace-Apps unten, die über die Matrix kommen.",
  "accessRequestsAdmin.members.apps.extra.title": "App-Zugriff",
  "accessRequestsAdmin.members.apps.extra.label": "Apps auswählen",
  "accessRequestsAdmin.members.apps.extra.hint":
    "Angehakt = effektiv zugeordnet (Rollen-Matrix und/oder persönliche Freigabe). Abwählen sperrt die App für diese Person lokal — auch wenn sie über eine Rolle freigegeben ist. Anklicken hebt eine lokale Sperre auf oder vergibt eine zusätzliche Freigabe.",
  "accessRequestsAdmin.members.apps.extra.loading":
    "Scope-Verfuegbarkeit wird geladen...",
  "accessRequestsAdmin.members.apps.extra.noneAvailable":
    "Keine zusaetzlichen Apps fuer diesen Scope verfuegbar.",
  "accessRequestsAdmin.members.apps.extra.unavailableAssigned":
    "Bereits vergebene Apps ausserhalb Scope-Verfuegbarkeit",
  "accessRequestsAdmin.members.apps.extra.status.ok":
    "App-Zugriff aktualisiert.",

  "accessRequestsAdmin.members.deactivate": "Deaktivieren",
  "accessRequestsAdmin.members.clubPolicy.lockSelfService":
    "Vereinszuordnung nur durch Admin (kein Self-Service)",
  "accessRequestsAdmin.members.clubPolicy.lockSelfServiceHint":
    "Der Nutzer kann keine weiteren Vereine selbst verbinden oder anlegen. Zugeordnete Vereine und Rollen verwaltest du hier im Usermanagement.",
  "accessRequestsAdmin.members.clubPolicy.lockedSaved":
    "Self-Service für Vereinszuordnung ist gesperrt.",
  "accessRequestsAdmin.members.clubPolicy.unlockedSaved":
    "Self-Service für Vereinszuordnung ist wieder erlaubt.",
  "accessRequestsAdmin.members.clubPolicy.saveFailed":
    "Vereins-Self-Service-Einstellung konnte nicht gespeichert werden ({{reason}}).",
  "accessRequestsAdmin.members.deactivate.confirm.title":
    "Person deaktivieren?",
  "accessRequestsAdmin.members.deactivate.confirm.text":
    "Die Person verliert den Zugriff auf alle Apps in diesem Bereich. Die Mitgliedschaft bleibt erhalten und kann jederzeit reaktiviert werden.",
  "accessRequestsAdmin.members.deactivate.confirm.ok": "Ja, deaktivieren",
  "accessRequestsAdmin.members.deactivate.confirm.cancel": "Abbrechen",
  "accessRequestsAdmin.members.deactivate.success": "Person wurde deaktiviert.",
  "accessRequestsAdmin.members.deactivate.error":
    "Fehler beim Deaktivieren ({reason}).",
  "accessRequestsAdmin.members.reactivate": "Reaktivieren",
  "accessRequestsAdmin.members.reactivate.confirm.title":
    "Person reaktivieren?",
  "accessRequestsAdmin.members.reactivate.confirm.text":
    "Die Person erhält wieder Zugriff auf alle zugewiesenen Apps und Rollen in diesem Bereich.",
  "accessRequestsAdmin.members.reactivate.confirm.ok": "Ja, reaktivieren",
  "accessRequestsAdmin.members.reactivate.success": "Person wurde reaktiviert.",
  "accessRequestsAdmin.members.reactivate.error":
    "Fehler beim Reaktivieren ({reason}).",
  "accessRequestsAdmin.members.badge.deactivated": "Deaktiviert",
  "accessRequestsAdmin.members.anonymize": "Anonymisieren",
  "accessRequestsAdmin.members.anonymize.confirm.title":
    "Person anonymisieren?",
  "accessRequestsAdmin.members.anonymize.confirm.text":
    "Alle personenbezogenen Daten (Name, E-Mail) werden unwiderruflich durch anonyme Platzhalter ersetzt. Rechnungen, Turniere und Sessions bleiben erhalten. Dieser Vorgang kann NICHT rückgängig gemacht werden.",
  "accessRequestsAdmin.members.anonymize.confirm.doubleCheck":
    'Bitte zur Bestätigung "ANONYMISIEREN" eingeben:',
  "accessRequestsAdmin.members.anonymize.confirm.ok":
    "Unwiderruflich anonymisieren",
  "accessRequestsAdmin.members.anonymize.confirm.cancel": "Abbrechen",
  "accessRequestsAdmin.members.anonymize.success": "Person wurde anonymisiert.",
  "accessRequestsAdmin.members.anonymize.error":
    "Fehler beim Anonymisieren ({reason}).",
  "accessRequestsAdmin.members.apps.extra.status.failed":
    "App-Zugriff fehlgeschlagen ({reason}).",
  "accessRequestsAdmin.members.ballmatesKi.title": "KI-Assistent",
  "accessRequestsAdmin.members.ballmatesKi.hint":
    "Freigabe für den KI-Assistenten (Chat, Trainingsabfragen, Rechnungsstatus, Stundenplanung). Standard: aus.",
  "accessRequestsAdmin.members.ballmatesKi.label": "KI-Assistent freigeben",
  "accessRequestsAdmin.members.ballmatesKi.status.ok":
    "KI-Assistent-Freigabe aktualisiert.",
  "accessRequestsAdmin.members.ballmatesKi.status.failed":
    "KI-Assistent-Freigabe fehlgeschlagen ({reason}).",
  "accessRequestsAdmin.members.grant.title": "Zugriff ohne Anfrage vergeben",
  "accessRequestsAdmin.members.grant.roles.label": "Rollen auswählen",
  "accessRequestsAdmin.members.grant.cta": "Zugriff speichern",
  "accessRequestsAdmin.members.grant.hint":
    "Rollen an- oder abwählen und speichern: neue Rollen werden vergeben, abgewählte bestehende Rollen entzogen. Keine Inhalte werden geteilt.",
  "accessRequestsAdmin.members.grant.revoke.status.ok": "Rollen entzogen.",
  "accessRequestsAdmin.members.grant.revoke.status.failed":
    "Rollen entziehen fehlgeschlagen ({reason}).",
  "accessRequestsAdmin.members.grant.status.missingFields":
    "Bitte Scope-ID, Person und Rollen ausfüllen.",
  "accessRequestsAdmin.members.grant.status.failed":
    "Zugriff vergeben fehlgeschlagen ({reason}).",
  "accessRequestsAdmin.members.grant.status.ok": "Zugriff vergeben.",
  "accessRequestsAdmin.members.grant.error.detailsToggle":
    "Fehlerdetails anzeigen",
  "accessRequestsAdmin.members.grant.result.detailsToggle": "Ergebnis anzeigen",
  "accessRequestsAdmin.members.invited.title":
    "Eingeladen (noch nicht aktiv) ({n})",
  "accessRequestsAdmin.members.invited.hint":
    "Diese Personen wurden eingeladen, sind aber noch nicht beigetreten. Nach Annahme erscheinen sie oben als aktive Personen.",
  "accessRequestsAdmin.members.invited.since": "Eingeladen am",
  "accessRequestsAdmin.members.invited.noRoles": "Keine Rollen ausgewählt.",

  "access.roles.admin": "Admin",
  "access.roles.owner": "Owner",

  "accessInvites.title": "Einladungen ({n})",
  "accessInvites.hint":
    "Du kannst Personen per E-Mail einladen. Die Einladung wird automatisch per E-Mail versendet (sofern SMTP konfiguriert ist). Annahme erfordert Login und passende E-Mail-Adresse.",
  "accessInvites.empty": "Keine Einladungen.",
  "accessInvites.actions.revoke": "Widerrufen",
  "accessInvites.fields.email": "E-Mail",
  "accessInvites.fields.roles": "Rollen",
  "accessInvites.fields.invitedAt": "Eingeladen am",
  "accessInvites.fields.token": "Token",
  "accessInvites.form.email.label": "E-Mail",
  "accessInvites.form.email.placeholder": "z. B. name+test1@example.com",
  "accessInvites.form.email.hint":
    "Bitte echte E-Mail-Adresse oder Plus-Alias verwenden, z. B. name+test1@example.com.",
  "accessInvites.form.roles.label": "Rollen auswählen",
  "accessInvites.form.roles.hint": "Bitte Rollen auswählen (Allowlist).",
  "accessInvites.form.note.label": "Notiz (optional)",
  "accessInvites.form.note.placeholder": "Optional",
  "accessInvites.form.create": "Einladung erstellen",
  "accessInvites.status.missingFields":
    "Bitte Scope-ID, E-Mail und Rollen ausfüllen.",
  "accessInvites.status.invalidEmail":
    "Diese E-Mail kann nicht fuer die Kontoaktivierung genutzt werden. Bitte echte E-Mail-Adresse oder Plus-Alias verwenden, z. B. name+test1@example.com.",
  "accessInvites.status.created": "Einladung erstellt.",
  "accessInvites.status.sentSuccess":
    "Einladung erfolgreich an {email} versendet.",
  "accessInvites.status.sentMock":
    "Einladung erstellt, aber kein echter E-Mail-Versand (Server-Modus: mock/simulation). Bitte Link unten manuell teilen.",
  "accessInvites.status.sentFailed":
    "Einladung erstellt, E-Mail-Versand fehlgeschlagen ({reason}). Bitte Link unten manuell teilen.",
  "accessInvites.groups.pending": "Offen ({n})",
  "accessInvites.groups.accepted": "Angenommen ({n})",
  "accessInvites.groups.revoked": "Widerrufen ({n})",
  "accessInvites.groups.other": "Sonstige ({n})",
  "accessInvites.status.createFailed": "Einladung fehlgeschlagen ({reason}).",
  "accessInvites.status.revokeFailed": "Widerruf fehlgeschlagen ({reason}).",
  "accessInvites.status.revoked": "Einladung widerrufen.",
  "accessInvites.created.token": "Token",
  "accessInvites.created.link": "Link",
  "accessInvites.error.detailsToggle": "Fehlerdetails anzeigen",
  "accessInvites.error.reason": "Reason",
  "accessInvites.error.message": "Message",
  "accessInvites.error.code": "Code",
  "accessInvites.error.details": "Details",
  "accessInvites.error.hint": "Hint",

  "accessRequestsAdmin.roles.title": "Rollen & App-Zugriff",
  "accessRequestsAdmin.roles.hint":
    "Rollen × Apps: Global = Defaults (Superadmin), Club = lokale Anpassung nur für vergebene Rollen.",
  "accessRequestsAdmin.roles.scopeMode.label": "Modus",
  "accessRequestsAdmin.roles.scopeMode.tenant": "Club / Bereich",
  "accessRequestsAdmin.roles.scopeMode.global": "Globale Apps",
  "accessRequestsAdmin.globalApps.intro":
    "Steuere, welche Apps plattformweit nutzbar sind. Ausgeschaltete Apps verschwinden im Hub und App-Launcher für alle Nutzer — unabhängig von Rollen.",
  "accessRequestsAdmin.globalApps.loading":
    "App-Einstellungen werden geladen …",
  "accessRequestsAdmin.globalApps.saved": "Gespeichert.",
  "accessRequestsAdmin.globalApps.saveFailed":
    "Speichern fehlgeschlagen ({reason}).",
  "accessRequestsAdmin.globalApps.minigames.sectionTitle":
    "Einzelne Mini-Games",
  "accessRequestsAdmin.globalApps.minigames.reaction": "Reaktionsspiel",
  "accessRequestsAdmin.globalApps.minigames.memory": "Memory",
  "accessRequestsAdmin.globalApps.minigames.bubbleTap": "Bubble Tap",
  "accessRequestsAdmin.roles.scopeMode.hint":
    "Global: Apps ein-/ausschalten. Club: feinere Rollen-Matrix nur für diesen Verein.",
  "accessRequestsAdmin.roles.scopeMode.tenantLockedHint":
    "Zugriffsmatrix für den gewählten Club. Globale Defaults separat bearbeiten.",
  "accessRequestsAdmin.roles.scopeMode.editGlobal":
    "Globale Defaults bearbeiten",
  "accessRequestsAdmin.roles.scopeMode.clubDisabledHint":
    "Im globalen Modus gilt der Club nicht — nur plattformweite Defaults.",
  "accessRequestsAdmin.roles.matrix.title": "Zugriffsmatrix",
  "accessRequestsAdmin.roles.matrix.loadFailed":
    "Konnte Rollen-/App-Zugriffe nicht laden.",
  "accessRequestsAdmin.roles.matrix.loaded": "Zugriffsmatrix geladen.",
  "accessRequestsAdmin.roles.matrix.saveFailed": "Speichern fehlgeschlagen.",
  "accessRequestsAdmin.roles.matrix.saved": "Gespeichert.",
  "accessRequestsAdmin.roles.matrix.legend.inherited": "Von global übernommen",
  "accessRequestsAdmin.roles.matrix.legend.override": "Lokal angepasst",
  "accessRequestsAdmin.roles.matrix.tenantHint":
    "Nur global freigegebene Apps; im Club optional lokal anpassen.",
  "accessRequestsAdmin.roles.matrix.hubVsMatrixHint":
    "Debug: Hub zeigt ggf. mehr Apps als diese Matrix. DB-Aliase: MatchMixer=schleifchen, TeamDesk=medenspiele.",
  "accessRequestsAdmin.roles.matrix.roleEmpty": "Alles über Global geregelt.",
  "accessRequestsAdmin.roles.matrix.noOccupiedRoles":
    "Keine Rollen mit aktiven Personen in diesem Club.",
  "accessRequestsAdmin.roles.matrix.noAppsForClubRoles":
    "Für die vergebenen Rollen sind global noch keine Apps freigegeben. Zuerst „Globale Defaults bearbeiten“.",
  "accessRequestsAdmin.roles.matrix.badge.inherited": "Global",
  "accessRequestsAdmin.roles.matrix.badge.override": "Lokal",

  "acceptInvite.title": "Einladung annehmen",
  "acceptInvite.subtitle":
    "Einladung pruefen, dann mit der eingeladenen E-Mail einloggen oder registrieren und danach annehmen.",
  "acceptInvite.subtitleInviteOnly":
    "Einladung fuer {inviteEmail}. Du kannst sie annehmen oder ablehnen.",
  "acceptInvite.fields.token": "Token",
  "acceptInvite.fields.scope": "Scope",
  "acceptInvite.fields.email": "E-Mail",
  "acceptInvite.fields.password": "Passwort vergeben",
  "acceptInvite.fields.passwordConfirm": "Passwort bestaetigen",
  "acceptInvite.fields.roles": "Rollen",
  "acceptInvite.fields.expiresAt": "Gueltig bis",
  "acceptInvite.fields.status": "Status",
  "acceptInvite.actions.accept": "Einladung annehmen",
  "acceptInvite.actions.acceptInvite": "Einladung akzeptieren",
  "acceptInvite.actions.declineInvite": "Einladung ablehnen",
  "acceptInvite.actions.setPasswordAndAccept":
    "Passwort vergeben und Einladung annehmen",
  "acceptInvite.actions.openLoginOrRegister": "Registrieren oder einloggen",
  "acceptInvite.actions.loginWithInvitedEmail": "Mit dieser E-Mail anmelden",
  "acceptInvite.actions.registerWithInviteEmail":
    "Mit dieser E-Mail registrieren",
  "acceptInvite.actions.createAccountAndAccept":
    "Konto erstellen und Einladung annehmen",
  "acceptInvite.actions.switchAccount": "Mit anderer E-Mail einloggen",
  "acceptInvite.actions.goHub": "Zum Hub",
  "acceptInvite.status.missingToken": "Token fehlt.",
  "acceptInvite.status.notFound": "Einladung wurde nicht gefunden.",
  "acceptInvite.status.publicLookupUnavailable":
    "Die Einladung kann aktuell nicht oeffentlich geprueft werden. Bitte spaeter erneut versuchen.",
  "acceptInvite.status.lookupUnavailable":
    "Einladung konnte nicht geprueft werden.",
  "acceptInvite.status.loadFailed":
    "Einladung konnte nicht geladen werden ({reason}).",
  "acceptInvite.status.acceptFailed": "Annahme fehlgeschlagen ({reason}).",
  "acceptInvite.status.declineFailed": "Ablehnung fehlgeschlagen ({reason}).",
  "acceptInvite.status.declined": "Einladung abgelehnt.",
  "acceptInvite.status.accepted":
    "Einladung angenommen. Du wurdest dem Bereich/Club zugeordnet.",
  "acceptInvite.status.acceptedAndAssigned":
    "Einladung angenommen. Du wurdest dem Bereich/Club zugeordnet.",
  "acceptInvite.status.passwordTooShort":
    "Bitte ein Passwort mit mindestens 8 Zeichen vergeben.",
  "acceptInvite.status.passwordMismatch":
    "Die Passwoerter stimmen nicht ueberein.",
  "acceptInvite.status.accountActivationFailed":
    "Konto konnte nicht aktiviert werden ({reason}).",
  "acceptInvite.status.inviteEmailInvalidForAuth":
    "Die eingeladene E-Mail {inviteEmail} ist fuer die Kontoaktivierung ungueltig. Bitte den Admin um eine neue Einladung mit gueltiger E-Mail bitten.",
  "acceptInvite.status.emailRateLimitExceeded":
    "Zu viele Aktivierungsversuche. Bitte einige Minuten warten.",
  "acceptInvite.status.activationTemporarilyBlocked":
    "Bitte kurz warten ({seconds}s), bevor du es erneut versuchst.",
  "acceptInvite.status.verifyEmailRequired":
    "Wir haben dir eine Aktivierungs-Mail geschickt. Bitte bestaetige deine E-Mail-Adresse und oeffne danach den Einladungslink erneut.",
  "acceptInvite.status.accountAlreadyExists":
    "Fuer diese E-Mail existiert bereits ein Konto. Bitte Passwort pruefen oder zuerst die Bestaetigungs-Mail oeffnen.",
  "acceptInvite.status.loginRequired":
    "Zum Annehmen bitte zuerst einloggen oder registrieren.",
  "acceptInvite.status.onboardingHint":
    "Diese Einladung ist fuer {inviteEmail}. Erstelle mit dieser E-Mail ein Konto oder melde dich mit ihr an.",
  "acceptInvite.status.onboardingRequired":
    "Diese Einladung ist fuer {inviteEmail}. Erstelle mit dieser E-Mail ein Konto oder melde dich mit ihr an.",
  "acceptInvite.status.notPending": "Diese Einladung ist nicht mehr offen.",
  "acceptInvite.status.emailMismatch":
    "Diese Einladung wurde fuer {inviteEmail} erstellt. Bitte mit dieser E-Mail-Adresse einloggen.",
  "acceptInvite.status.inviteExpired":
    "Diese Einladung ist abgelaufen oder nicht mehr gueltig. Bitte eine neue Einladung anfordern.",
  "acceptInvite.actions.signOutDifferentAccount":
    "Abmelden und mit eingeladener E-Mail anmelden",
  "acceptInvite.hint.pendingSelfRequestsMayRemain":
    "Hinweis: Es kann weiterhin offene Selbst-Anfragen auf Zugriff geben. Diese werden durch die Einladung nicht automatisch geloescht; du kannst sie unter Zugriff beantragen / Admin einsehen.",
  "acceptInvite.result.title": "Ergebnis",
  "finish.title": "Abgeschlossen",
  "finish.title.aborted": "Zwischenstand bei Abbruch",
  "finish.subtitle": "Finales Ergebnis und Rangliste",
  "finish.subtitle.aborted":
    "Bisher gespielte Ergebnisse und Zwischenrangliste",
  "finish.rankingRules":
    "Rangfolge: Punkte, dann Spieldifferenz (GD), dann gewonnene Spiele (GF). Bei Gleichstand teilen sich die Plätze die bessere Position.",
  "finish.incompleteResults":
    "Unvollständige Ergebnisse: {done} von {total} Begegnungen mit Ergebnis.",
  "finish.podium": "Podest",
  "finish.pointsLabel": "{n} Punkte",
  "finish.none": "—",
  "finish.ranking": "Rangliste",
  "finish.player": "Spieler",
  "finish.points": "Punkte",
  "finish.print": "Drucken",
  "finish.back": "Zurück zur Startseite",
  "finish.pdfHint": "Seite als PDF drucken oder teilen.",
  "finish.schedule": "Spielplan",
  "finish.scheduleHint": "Alle Runden und Ergebnisse.",
  "finish.court": "Platz {n}",

  "ranking.title": "Rangliste",
  "ranking.col.rank": "#",
  "ranking.col.player": "Spieler",
  "ranking.col.team": "Team",
  "ranking.col.points": "Punkte",
  "ranking.col.played": "Sp.",
  "ranking.col.w": "S",
  "ranking.col.d": "U",
  "ranking.col.l": "N",
  "ranking.col.gf": "GF",
  "ranking.col.ga": "GA",
  "ranking.col.gd": "GD",
  "ranking.legend.title": "Legende",
  "ranking.legend.gf": "Erzielt",
  "ranking.legend.ga": "Gegen",
  "ranking.legend.gd": "Diff.",
  "ranking.legend.subtitle":
    "GF: Gewonnene Spiele · GA: Verlorene Spiele · GD: Spiel-Differenz",
  "ranking.legend.subtitleGames":
    "Sortiert nach gewonnenen Spielen (GF), dann Differenz.",
  "ranking.sort.aria": "Rangliste sortieren",
  "ranking.sort.points": "Punkte",
  "ranking.sort.games": "Gewonnene Spiele",
  "ranking.legend.subtitleWithProgress":
    "{progress} · GF: Gewonnene Spiele · GA: Verlorene Spiele · GD: Spiel-Differenz",
  "ranking.progress": "{done}/{total} Spiele",
  "ranking.empty.noPlayers": "Keine Spieler.",

  "hub.schleifchen.lastTournaments": "Deine letzten MatchMixer-Turniere",
  "hub.schleifchen.empty": "Noch keine Turniere in MatchMixer.",

  "minigames.title": "Mini-Games",
  "minigames.subtitle": "Kleine Spiele und Challenges für zwischendurch.",
  "minigames.reaction.title": "Reaktionsspiel",
  "minigames.reaction.description":
    "Teste deine Reaktionszeit! Klicke so schnell wie möglich auf das erscheinende Ziel.",
  "minigames.reaction.start": "Starten",
  "minigames.memory.title": "Memory-Spiel",
  "minigames.memory.description":
    "Merke dir die Reihenfolge der Schläge und gib sie korrekt wieder.",
  "minigames.memory.start": "Starten",
  "minigames.bubbleTap.title": "Bubble Tap Game",
  "minigames.bubbleTap.description":
    "Halte den Tennisball mit der Leertaste in der Luft und weiche den Lasern aus.",
  "minigames.bubbleTap.start": "Starten",
  "minigames.bubbleTap.subtitle":
    "Tennisball oben halten und Lasern ausweichen.",
  "minigames.bubbleTap.ready": "Leertaste drücken oder tippen, um zu starten",
  "minigames.bubbleTap.instructions":
    "Halte die Leertaste (oder den Finger auf dem Feld), damit der Ball oben bleibt. Weiche den Lasern aus!",
  "minigames.bubbleTap.score": "Punkte",
  "minigames.bubbleTap.level": "Level",
  "minigames.bubbleTap.lives": "Leben",
  "minigames.bubbleTap.levelUp": "Level {level}!",
  "minigames.bubbleTap.gameOver": "Spiel beendet!",
  "minigames.bubbleTap.playAgain": "Nochmal spielen",
  "minigames.bubbleTap.toOverview": "Zurück zu allen Mini-Games",
  "minigames.bubbleTap.statsTitle": "Deine Rekorde",
  "minigames.bubbleTap.statsDay": "Heute",
  "minigames.bubbleTap.statsWeek": "Diese Woche",
  "minigames.bubbleTap.statsMonth": "Dieser Monat",
  "minigames.bubbleTap.statsAllTime": "Allzeit",
  "minigames.bubbleTap.statsGames": "Spiele",
  "minigames.bubbleTap.statsBestScore": "Bester Score",
  "minigames.bubbleTap.statsBestLevel": "Höchstes Level",
  "minigames.bubbleTap.statsError": "Fehler beim Laden der Statistiken",
  "minigames.bubbleTap.finalScore": "Endpunktzahl",
  "minigames.bubbleTap.finalLevel": "Erreichtes Level",
  "minigames.bubbleTap.globalTitle": "Weltbestleistung",
  "minigames.bubbleTap.globalBestScore": "Höchster Score",
  "minigames.bubbleTap.globalBestPlayer": "Bester Spieler",
  "minigames.bubbleTap.globalBestLevel": "Höchstes Level",
  "minigames.bubbleTap.globalTotalGames": "Gespielte Runden",

  "mobile.auth.title": "Anmelden",
  "mobile.auth.subtitle": "Melde dich mit deinem Tennis-Matches-Konto an.",
  "mobile.auth.emailLabel": "E-Mail",
  "mobile.auth.emailPlaceholder": "name@verein.de",
  "mobile.auth.passwordLabel": "Passwort",
  "mobile.auth.signIn": "Anmelden",
  "mobile.auth.signOut": "Abmelden",
  "mobile.auth.error.missingFields": "Bitte E-Mail und Passwort eingeben.",
  "mobile.auth.error.failed": "Anmeldung fehlgeschlagen.",
  "mobile.auth.loading": "Sitzung wird geladen…",
  "mobile.auth.googleUnavailable":
    "Google-Anmeldung in der App ist demnächst verfügbar.",
  "mobile.auth.oauthSafariHint":
    "Anmeldung im Systemdialog abschließen — du kehrst danach automatisch in die App zurück.",
  "mobile.auth.oauthTimeout":
    "Anmeldung nicht abgeschlossen. Bitte erneut versuchen.",
  "mobile.hub.appCard.openHint": "App öffnen",
  "mobile.hub.trainerDrills.value": "Übungen",
  "mobile.hub.trainerDrills.detail": "Katalog nativ durchsuchen",
  "mobile.home.signedInAs": "Angemeldet als {email}",
  "mobile.home.modules": "Module",
  "mobile.home.modulesLoading": "Berechtigungen werden geladen…",
  "mobile.home.noModules":
    "Keine Module freigegeben. Bitte wende dich an deinen Verein.",
  "mobile.home.matchmixerSubtitle": "Turnier per Code laden",
  "mobile.home.trainerstundenSubtitle": "Training planen & abrechnen",
  "mobile.home.webModuleSubtitle": "Web-Modul in der App",
  "mobile.trainingsdesk.intro":
    "Dein TrainingsDesk-Hub – Kennzahlen und Termine nativ in der App.",
  "mobile.trainingsdesk.loading": "TrainingsDesk wird geladen…",
  "mobile.trainingsdesk.retry": "Erneut laden",
  "mobile.trainingsdesk.openInWeb": "Weitere Optionen im Web öffnen",
  "mobile.trainingsdesk.loadError.sessions":
    "Trainings konnten nicht geladen werden.",
  "mobile.trainingsdesk.loadError.generic":
    "Daten konnten nicht geladen werden.",
  "mobile.trainingsdesk.actionsTitle": "Bereiche",
  "mobile.trainingsdesk.action.agendaTitle": "Termine",
  "mobile.trainingsdesk.action.agendaSubtitle": "Anstehende Trainings",
  "mobile.trainingsdesk.action.planningTitle": "Trainingsplanung",
  "mobile.trainingsdesk.action.planningSubtitle":
    "Termine planen und bearbeiten (Web)",
  "mobile.trainingsdesk.action.planningSubtitleNative":
    "Terminübersicht nativ im Tab Termine",
  "mobile.trainingsdesk.action.planningCreateSubtitleNative":
    "Neuen Termin nativ anlegen",
  "mobile.trainingsdesk.action.billingTitle": "Rechnungen",
  "mobile.trainingsdesk.action.billingSubtitleNative":
    "Offene Rechnungen und Entwürfe nativ",
  "mobile.trainingsdesk.billing.navTitle": "Rechnungen",
  "mobile.trainingsdesk.billing.intro":
    "Übersicht offener und geplanter Rechnungen. Zahlungen und Details über die nativen Finanz-Screens.",
  "mobile.trainingsdesk.billing.filterOpen": "Offen",
  "mobile.trainingsdesk.billing.filterDrafts": "Entwürfe",
  "mobile.trainingsdesk.billing.filterAll": "Alle",
  "mobile.trainingsdesk.billing.empty": "Keine Rechnungen in dieser Ansicht.",
  "mobile.trainingsdesk.billing.openAmount": "Offen: {amount}",
  "mobile.trainingsdesk.billing.totalAmount": "{amount}",
  "mobile.trainingsdesk.billing.openPayments": "Zahlungen",
  "mobile.trainingsdesk.payments.navTitle": "Zahlungen",
  "mobile.trainingsdesk.payments.intro":
    "Offene Forderungen nativ — Rechnung antippen für Details.",
  "mobile.trainingsdesk.payments.empty":
    "Keine offenen Zahlungen für diesen Filter.",
  "mobile.trainingsdesk.payments.filterOverdue": "Nur überfällig",
  "mobile.trainingsdesk.payments.filterAllMonths": "Alle Monate",
  "mobile.trainingsdesk.payments.overdueBadge": "Überfällig",
  "mobile.trainingsdesk.payments.webOnlyTitle": "Noch nicht nativ verfügbar",
  "mobile.trainingsdesk.payments.webOnlyNotice":
    "Zahlung bearbeiten, Mahnwesen, Versand per E-Mail, Storno, Korrekturen und Trainer-Filter.",
  "mobile.trainingsdesk.billing.statement.navTitle": "Rechnung",
  "mobile.trainingsdesk.billing.statement.intro":
    "Rechnungsdetails mit Positionen und Zahlungseingängen.",
  "mobile.trainingsdesk.billing.statement.notFound": "Rechnung nicht gefunden.",
  "mobile.trainingsdesk.billing.statement.period": "Abrechnungszeitraum",
  "mobile.trainingsdesk.billing.statement.status": "Status",
  "mobile.trainingsdesk.billing.statement.invoiceNumber": "Rechnungsnummer",
  "mobile.trainingsdesk.billing.statement.total": "Gesamtbetrag",
  "mobile.trainingsdesk.billing.statement.open": "Offen",
  "mobile.trainingsdesk.billing.statement.paid": "Bezahlt",
  "mobile.trainingsdesk.billing.statement.itemsTitle": "Positionen",
  "mobile.trainingsdesk.billing.statement.paymentsTitle": "Zahlungseingänge",
  "mobile.trainingsdesk.billing.statement.paymentLine": "Zahlung ({method})",
  "mobile.trainingsdesk.billing.statement.paymentLineGeneric": "Zahlung",
  "mobile.trainingsdesk.billing.statement.pdfShare": "Rechnung als PDF teilen",
  "mobile.trainingsdesk.billing.statement.pdfLoading": "PDF wird geladen…",
  "mobile.trainingsdesk.billing.statement.shareUnavailable":
    "Teilen ist auf diesem Gerät nicht verfügbar.",
  "mobile.trainingsdesk.billing.payment.recordAction": "Zahlung erfassen",
  "mobile.trainingsdesk.billing.payment.title": "Neue Zahlung",
  "mobile.trainingsdesk.billing.payment.amountLabel": "Betrag (€)",
  "mobile.trainingsdesk.billing.payment.amountPlaceholder": "0,00",
  "mobile.trainingsdesk.billing.payment.dateLabel": "Datum",
  "mobile.trainingsdesk.billing.payment.methodLabel": "Zahlungsart",
  "mobile.trainingsdesk.billing.payment.hintMaxOpen":
    "Max. offener Betrag: {amount} €",
  "mobile.trainingsdesk.billing.payment.save": "Zahlung speichern",
  "mobile.trainingsdesk.billing.payment.saving": "Wird gespeichert…",
  "mobile.trainingsdesk.billing.payment.cancel": "Abbrechen",
  "mobile.trainingsdesk.billing.payment.errorNoStatement":
    "Rechnung nicht gefunden.",
  "mobile.trainingsdesk.billing.payment.errorCancelled":
    "Diese Rechnung ist storniert — keine Zahlung möglich.",
  "mobile.trainingsdesk.billing.payment.errorNotPayable":
    "Zu dieser Rechnung kann keine Zahlung erfasst werden.",
  "mobile.trainingsdesk.billing.payment.errorPerson":
    "Zahler:in konnte nicht ermittelt werden.",
  "mobile.trainingsdesk.billing.payment.errorDate": "Bitte ein Datum wählen.",
  "mobile.trainingsdesk.billing.payment.errorAmountPositive":
    "Bitte einen Betrag größer als 0 eingeben.",
  "mobile.trainingsdesk.billing.payment.errorAmountMax":
    "Der Betrag darf den offenen Betrag nicht überschreiten.",
  "mobile.trainingsdesk.billing.payment.errorSave":
    "Zahlung konnte nicht gespeichert werden.",
  "mobile.trainingsdesk.billing.statement.webOnlyTitle":
    "Noch nicht nativ verfügbar",
  "mobile.trainingsdesk.billing.statement.webOnlyNotice":
    "Versand per E-Mail, Mahnwesen, Storno, Korrekturen, Bestätigungslink, WhatsApp-Versand und Streitfall-Prüfung.",
  "mobile.trainingsdesk.billing.statement.openWeb": "Im Web bearbeiten",
  "mobile.trainingsdesk.action.paymentsTitle": "Zahlungen",
  "mobile.trainingsdesk.action.paymentsSubtitle":
    "Offene Forderungen und Zahlungseingänge",
  "mobile.trainingsdesk.action.masterdataTitle": "Stammdaten",
  "mobile.trainingsdesk.action.masterdataSubtitle":
    "Spieler und Kontakte verwalten",
  "mobile.trainingsdesk.action.bookingRequestsTitle": "Anfragen",
  "mobile.trainingsdesk.action.bookingRequestsSubtitle":
    "Buchungsanfragen prüfen",
  "mobile.trainingsdesk.bookingRequests.navTitle": "Anfragen",
  "mobile.trainingsdesk.bookingRequests.empty":
    "Aktuell keine offenen Buchungsanfragen.",
  "mobile.trainingsdesk.bookingRequests.cta": "Jetzt prüfen",
  "mobile.trainingsdesk.masterdata.navTitle": "Stammdaten",
  "mobile.trainingsdesk.masterdata.intro":
    "Spieler und Kontakte nativ anlegen und pflegen.",
  "mobile.trainingsdesk.masterdata.createButton": "Neue Person",
  "mobile.trainingsdesk.masterdata.filterActive": "Aktiv",
  "mobile.trainingsdesk.masterdata.filterInactive": "Inaktiv",
  "mobile.trainingsdesk.masterdata.filterAll": "Alle",
  "mobile.trainingsdesk.masterdata.searchPlaceholder":
    "Name, E-Mail oder Telefon",
  "mobile.trainingsdesk.masterdata.empty": "Keine Personen in dieser Ansicht.",
  "mobile.trainingsdesk.masterdata.searchEmpty":
    "Keine Treffer für diese Suche.",
  "mobile.trainingsdesk.masterdata.inactiveBadge": "Inaktiv",
  "mobile.trainingsdesk.masterdata.form.createNavTitle": "Neue Person",
  "mobile.trainingsdesk.masterdata.form.editNavTitle": "Person bearbeiten",
  "mobile.trainingsdesk.masterdata.form.firstNameLabel": "Vorname",
  "mobile.trainingsdesk.masterdata.form.lastNameLabel": "Nachname",
  "mobile.trainingsdesk.masterdata.form.emailLabel": "E-Mail",
  "mobile.trainingsdesk.masterdata.form.phoneLabel": "Telefon",
  "mobile.trainingsdesk.masterdata.form.notesLabel": "Notizen",
  "mobile.trainingsdesk.masterdata.form.statusLabel": "Status",
  "mobile.trainingsdesk.masterdata.form.statusActive": "Aktiv",
  "mobile.trainingsdesk.masterdata.form.statusInactive": "Inaktiv",
  "mobile.trainingsdesk.masterdata.form.save": "Speichern",
  "mobile.trainingsdesk.masterdata.form.saveEdit": "Änderungen speichern",
  "mobile.trainingsdesk.masterdata.form.delete": "Person löschen",
  "mobile.trainingsdesk.masterdata.form.deleting": "Wird gelöscht…",
  "mobile.trainingsdesk.masterdata.form.deleteConfirmTitle": "Person löschen?",
  "mobile.trainingsdesk.masterdata.form.deleteConfirmMessage":
    "Diese Aktion kann nicht rückgängig gemacht werden.",
  "mobile.trainingsdesk.masterdata.form.deleteConfirmCancel": "Abbrechen",
  "mobile.trainingsdesk.masterdata.form.deleteConfirmAction": "Löschen",
  "mobile.trainingsdesk.masterdata.form.nameRequired":
    "Bitte Vor- oder Nachname angeben.",
  "mobile.trainingsdesk.masterdata.form.duplicateName":
    "Es gibt bereits eine aktive Person mit diesem Namen.",
  "mobile.trainingsdesk.masterdata.form.saveFailed":
    "Speichern fehlgeschlagen. Bitte erneut versuchen.",
  "mobile.trainingsdesk.masterdata.form.deleteFailed":
    "Löschen fehlgeschlagen. Bitte erneut versuchen.",
  "mobile.trainingsdesk.masterdata.form.notFound": "Person nicht gefunden.",
  "mobile.clubhub.contacts.intro":
    "Kontakte und Spieler deines Vereins nativ anlegen und pflegen.",
  "mobile.clubhub.locations.intro":
    "Orte und Anlagen deines Vereins nativ verwalten.",
  "mobile.clubhub.accessDenied.title": "Kein Zugriff auf ClubHub",
  "mobile.clubhub.accessDenied.body":
    "Dein Konto hat aktuell keine Berechtigung fuer diesen Bereich.",
  "mobile.accessDenied.title": "Kein Zugriff",
  "mobile.accessDenied.body":
    "Dein Konto hat aktuell keine Berechtigung fuer diesen Bereich.",
  "mobile.medenspiele.accessDenied.title": "Kein Zugriff auf Medenspiele",
  "mobile.medenspiele.accessDenied.body":
    "Dein Konto hat aktuell keine Berechtigung fuer diesen Bereich.",
  "mobile.tennisLive.accessDenied.title": "Kein Zugriff auf Tennis Live",
  "mobile.tennisLive.accessDenied.body":
    "Dein Konto hat aktuell keine Berechtigung fuer diesen Bereich.",
  "mobile.clubhub.locations.form.nameRequired": "Bitte einen Namen angeben.",
  "mobile.clubhub.locations.form.notFound": "Ort nicht gefunden.",
  "mobile.medenspiele.home.teamsSubtitle": "Mannschaften anlegen und verwalten",
  "mobile.medenspiele.home.squadSubtitle":
    "Kader für die Saison zusammenstellen",
  "mobile.medenspiele.home.sessionsSubtitle":
    "Zu- und Absagen fürs Freie Training",
  "mobile.medenspiele.home.planningSubtitle": "Freies Training planen",
  "mobile.medenspiele.planning.createCta": "Neuer Termin",
  "mobile.medenspiele.planning.empty":
    "Noch keine Termine geplant. Lege oben deinen ersten Termin an.",
  "mobile.trainingsdesk.billing.draftsHint": "{count} Entwürfe",
  "mobile.trainingsdesk.billing.recipientUnknown": "Rechnungsempfänger",
  "mobile.trainer.loading": "Übungen werden geladen…",
  "mobile.trainer.loadError": "Übungen konnten nicht geladen werden.",
  "mobile.trainer.retry": "Erneut laden",
  "mobile.trainer.drills.intro":
    "Übungskatalog, Bearbeitung, Medien und Unterrichtspläne nativ verwalten.",
  "mobile.trainer.drills.empty": "Keine Übungen zu dieser Auswahl.",
  "mobile.trainer.drills.openVideo": "Video auf YouTube öffnen",
  "mobile.trainer.action.openStudioWeb": "Trainer Studio im Web",
  "mobile.trainer.lessonPlans.loading": "Unterrichtspläne werden geladen…",
  "mobile.trainer.lessonPlans.loadError":
    "Unterrichtspläne konnten nicht geladen werden.",
  "mobile.trainer.repository.overallTitle": "Übungen gesamt",
  "mobile.trainer.repository.totalExercises": "Übungen im Repository",
  "mobile.trainer.repository.fillLevel": "Ø Füllgrad {percent} %",
  "mobile.trainer.repository.videoActive":
    "{count} von {total} mit aktivem Video",
  "mobile.trainer.repository.actualCount": "{count} Übungen",
  "mobile.trainer.repository.avgFill": "Ø Füllgrad {percent} %",
  "mobile.trainer.repository.import.title": "Massenupload (JSON)",
  "mobile.trainer.repository.import.intro":
    "Füge ein JSON-Array mit Übungen ein (Schema siehe Web-Massenupload). Pflichtfelder: title, category, level, difficulty, idealPlayerCounts, durationMinutesMin/Max, description.",
  "mobile.trainer.repository.import.placeholder": '[ { "title": "…", … } ]',
  "mobile.trainer.repository.import.validate": "Prüfen",
  "mobile.trainer.repository.import.submit": "Importieren",
  "mobile.trainer.repository.import.importing": "Wird importiert…",
  "mobile.trainer.repository.import.preview":
    "{count} Übungen gültig, bereit zum Import.",
  "mobile.trainer.repository.import.error.jsonInvalid": "Ungültiges JSON.",
  "mobile.trainer.repository.import.error.jsonNotArray":
    "Erwartet ein JSON-Array von Übungen.",
  "mobile.trainer.repository.import.error.jsonEmpty":
    "Keine gültigen Zeilen im JSON gefunden.",
  "mobile.trainer.repository.import.error.rows":
    "{count} Zeile(n) mit Fehlern — bitte korrigieren.",
  "mobile.trainer.repository.import.result":
    "{created} Übung(en) importiert, {failed} fehlgeschlagen.",
  "mobile.trainingsdesk.agenda.navTitle": "Termine",
  "mobile.trainingsdesk.agenda.empty": "Keine anstehenden Trainings.",
  "mobile.trainingsdesk.agenda.searchEmpty": "Keine Trainings zu dieser Suche.",
  "mobile.trainingsdesk.backlog.empty": "Keine offenen Bestätigungen.",
  "mobile.trainingsdesk.session.navTitle": "Training",
  "mobile.trainingsdesk.session.notFound": "Training nicht gefunden.",
  "mobile.trainingsdesk.create.navTitle": "Neuer Termin",
  "mobile.trainingsdesk.create.editNavTitle": "Termin bearbeiten",
  "mobile.trainingsdesk.create.editIntro":
    "Datum, Uhrzeit, Ort und Notizen anpassen. Teilnehmer und erweiterte Serien-Optionen in der Web-Planung.",
  "mobile.trainingsdesk.create.intro":
    "Schnell anlegen — optional als wöchentliche Serie bis zu einem Enddatum.",
  "mobile.trainingsdesk.create.save": "Termin anlegen",
  "mobile.trainingsdesk.create.saveEdit": "Änderungen speichern",
  "mobile.trainingsdesk.create.advancedWeb": "Erweitert (Web)",
  "mobile.trainingsdesk.create.fullEditorTitle": "Trainingsplanung",
  "mobile.trainingsdesk.create.recurrenceOnce": "Einzeltermin",
  "mobile.trainingsdesk.create.recurrenceWeekly": "Wöchentlich",
  "mobile.trainingsdesk.create.dateUntil": "Serie bis (Datum)",
  "mobile.trainingsdesk.create.targetGroup": "Zielgruppe",
  "mobile.trainingsdesk.create.formModeLabel": "Formular-Modus",
  "mobile.trainingsdesk.create.formModeStandard": "Standard",
  "mobile.trainingsdesk.create.formModeIndividual": "Individuell",
  "mobile.trainingsdesk.create.formModeHint":
    "Individuell wird als dein neuer Standard für „Neues Training“ gespeichert.",
  "mobile.trainingsdesk.create.fieldVisible": "Sichtbar",
  "mobile.trainingsdesk.create.fieldHidden": "Ausgeblendet",
  "mobile.trainingsdesk.create.notes": "Notizen",
  "mobile.trainingsdesk.create.seriesSummary": "{count} Termine in der Serie",
  "mobile.trainingsdesk.create.seriesEditHint":
    "Dieser Termin gehört zu einer Serie. Hier nur Einzeltermin anpassen — Serien-Regeln in der Web-Planung.",
  "mobile.trainingsdesk.create.error.dateUntil":
    "Bitte ein gültiges Enddatum für die Serie eingeben (nicht vor dem Start).",
  "mobile.trainingsdesk.create.error.seriesTooLong":
    "Serie zu lang (max. 52 Termine). Enddatum verkürzen.",
  "mobile.trainingsdesk.create.yes": "Ja",
  "mobile.trainingsdesk.create.no": "Nein",
  "mobile.trainingsdesk.session.cancel.button": "Termin stornieren",
  "mobile.trainingsdesk.session.cancel.title": "Termin stornieren",
  "mobile.trainingsdesk.session.cancel.reasonLabel": "Absagegrund",
  "mobile.trainingsdesk.session.cancel.reasonLabelOptional":
    "Absagegrund (optional)",
  "mobile.trainingsdesk.session.cancel.noteLabel": "Notiz (optional)",
  "mobile.trainingsdesk.session.cancel.notePlaceholder":
    "z. B. Details zur Absage",
  "mobile.trainingsdesk.session.cancel.confirm": "Stornieren",
  "mobile.trainingsdesk.session.cancel.saving": "Wird storniert…",
  "mobile.trainingsdesk.session.cancel.cancelAction": "Abbrechen",
  "mobile.trainingsdesk.session.cancel.errorReason":
    "Bitte einen Absagegrund auswählen.",
  "mobile.trainingsdesk.session.cancel.errorSave":
    "Stornieren fehlgeschlagen. Bitte erneut versuchen.",
  "mobile.trainingsdesk.session.cancel.success": "Termin wurde storniert.",
  "mobile.trainingsdesk.session.cancel.blockedHint":
    "Dieser Termin kann nativ nicht storniert werden (bereits abgerechnet/bestätigt). Bitte im Web bearbeiten.",
  "mobile.trainingsdesk.session.edit": "Bearbeiten",
  "mobile.trainingsdesk.session.editSubtitle":
    "Datum, Uhrzeit und Notizen nativ anpassen",
  "mobile.trainingsdesk.session.actionsTitle": "Aktionen",
  "mobile.trainingsdesk.session.planningWebSubtitle":
    "Teilnehmer, Ferien, Assistenz und erweiterte Serien",
  "mobile.trainingsdesk.session.seriesExtendTitle": "Serie verlängern",
  "mobile.trainingsdesk.session.seriesExtendHint":
    "Neues Enddatum wählen — fehlende Termine werden automatisch angelegt.",
  "mobile.trainingsdesk.session.seriesExtendButton": "Serie verlängern",
  "mobile.trainingsdesk.session.seriesExtendSuccess":
    "{count} neue Termine angelegt.",
  "mobile.trainingsdesk.session.seriesExtendNoNewSessions":
    "Enddatum aktualisiert, keine neuen Termine nötig.",
  "mobile.trainingsdesk.session.seriesExtendInvalidDate":
    "Bitte ein gültiges neues Enddatum wählen.",
  "mobile.trainingsdesk.session.seriesExtendNotFurther":
    "Das neue Enddatum muss nach dem aktuellen Serienende liegen.",
  "mobile.trainingsdesk.session.seriesExtendUnsupported":
    "Diese Serie hat ein Muster, das nur in der Web-Planung verlängert werden kann.",
  "mobile.trainingsdesk.create.titleLabel": "Titel (optional)",
  "mobile.trainingsdesk.create.trainerFixed": "Trainer: {name}",
  "mobile.trainingsdesk.create.error.date":
    "Bitte ein gültiges Datum eingeben (JJJJ-MM-TT).",
  "mobile.trainingsdesk.create.error.time":
    "Bitte eine gültige Uhrzeit eingeben (HH:MM).",
  "mobile.trainingsdesk.create.error.duration":
    "Bitte eine gültige Dauer wählen.",
  "mobile.trainingsdesk.create.error.trainer":
    "Kein Trainer hinterlegt. Bitte zuerst Stammdaten pflegen.",
  "mobile.trainingsdesk.create.error.participants":
    "Bitte mindestens einen Teilnehmer auswählen.",
  "mobile.trainingsdesk.create.participantsLabel": "Spieler",
  "mobile.trainingsdesk.create.participantsNoneSelected":
    "Keine Teilnehmer ausgewählt.",
  "mobile.trainingsdesk.create.participantsSearchPlaceholder":
    "Spieler suchen…",
  "mobile.trainingsdesk.create.participantsEmpty": "Keine Spieler gefunden.",
  "mobile.trainingsdesk.session.participantsLine": "Teilnehmer: {names}",
  "mobile.trainingsdesk.session.noParticipants": "Keine Teilnehmer geplant.",
  "mobile.trainingsdesk.create.assistantLabel": "Assistenz",
  "mobile.trainingsdesk.create.assistantNone": "Kein Assistent",
  "mobile.trainingsdesk.create.assistantHonorarLabel":
    "Honorar-Anteil Assistenz (€)",
  "mobile.trainingsdesk.create.assistantHonorarHint":
    "Max. {max} € (Brutto-Honorar der Session)",
  "mobile.trainingsdesk.create.error.assistant":
    "Assistenz-Zuweisung ungültig. Bitte anderen Trainer wählen.",
  "mobile.trainingsdesk.session.assistantLine":
    "Assistenz: {name} ({amount} €)",
  "mobile.trainingsdesk.create.holidayLabel": "Ferien-Terminierung",
  "mobile.trainingsdesk.create.holidayModeExclude": "Nur außerhalb der Ferien",
  "mobile.trainingsdesk.create.holidayModeInclude": "Auch in den Ferien",
  "mobile.trainingsdesk.create.holidayHintSomeExclude":
    "{count} von {total} Terminen fallen in die Ferien ({state}) und werden als „Ferien“ markiert.",
  "mobile.trainingsdesk.create.holidayHintSomeInclude":
    "{count} von {total} Terminen fallen in die Ferien ({state}), finden aber trotzdem statt.",
  "mobile.trainingsdesk.create.holidayHintNone":
    "Keine Termine fallen in die Ferien ({state}).",
  "mobile.trainingsdesk.create.weekdaysLabel": "Wochentage",
  "mobile.trainingsdesk.create.weekdayMon": "Mo",
  "mobile.trainingsdesk.create.weekdayTue": "Di",
  "mobile.trainingsdesk.create.weekdayWed": "Mi",
  "mobile.trainingsdesk.create.weekdayThu": "Do",
  "mobile.trainingsdesk.create.weekdayFri": "Fr",
  "mobile.trainingsdesk.create.weekdaySat": "Sa",
  "mobile.trainingsdesk.create.weekdaySun": "So",
  "mobile.trainingsdesk.create.intervalWeeksLabel": "Rhythmus",
  "mobile.trainingsdesk.create.intervalWeeksEvery": "Jede Woche",
  "mobile.trainingsdesk.create.intervalWeeksEveryN": "Alle {n} Wochen",
  "mobile.trainingsdesk.create.editScopeLabel": "Änderung gilt für",
  "mobile.trainingsdesk.create.editScopeSingle": "Nur diesen Termin",
  "mobile.trainingsdesk.create.editScopeSeriesRest":
    "Diesen und alle folgenden Termine",
  "mobile.trainingsdesk.create.error.rate":
    "Bitte einen gültigen Stundensatz eingeben.",
  "mobile.trainingsdesk.create.rateLabel": "Stundensatz (€)",
  "mobile.trainingsdesk.create.rateHint":
    "Leer lassen für automatische Berechnung aus den Trainer-Stammdaten.",
  "mobile.trainingsdesk.create.seriesBillingModeLabel":
    "Abrechnungsmodus Serie",
  "mobile.trainingsdesk.create.seriesBillingModeTrainerDefaults":
    "Trainer-Standard",
  "mobile.trainingsdesk.create.seriesBillingModeSeasonFlat": "Saison-Pauschale",
  "mobile.trainingsdesk.create.seriesBillingTotalLabel":
    "Saison-Pauschale gesamt (€)",
  "mobile.trainingsdesk.create.seriesBillingTotalHint":
    "Leer lassen für automatische Berechnung aus Stundensatz × Termine.",
  "mobile.trainingsdesk.create.seriesBillingPaymentTimingLabel":
    "Zahlungszeitpunkt",
  "mobile.trainingsdesk.create.seriesBillingPaymentTimingArrears":
    "Nachträglich",
  "mobile.trainingsdesk.create.seriesBillingPaymentTimingAdvance": "Vorab",
  "mobile.trainingsdesk.create.seriesBillingPreview":
    "{units} Termine · Gesamt {total} € · {sharePerPerson} € je Teilnehmer ({playerCount})",
  "mobile.settings.title": "Einstellungen",
  "mobile.settings.headerAction": "Profil",
  "mobile.settings.account": "Konto",
  "mobile.settings.email": "E-Mail",
  "mobile.settings.app": "App",
  "mobile.settings.version": "Version",
  "mobile.settings.buildVariant": "Build",
  "mobile.settings.buildNumber": "Build-Nr.",
  "mobile.settings.apiBase": "API (Dev)",
  "mobile.settings.webBase": "Web (Dev)",
  "mobile.schleifchen.load.navTitle": "Laden",
  "mobile.schleifchen.setup.navTitle": "Setup",
  "mobile.schleifchen.schedule.navTitle": "Spielplan",
  "mobile.webApp.loading": "Wird geladen…",
  "mobile.webApp.error": "Seite konnte nicht geladen werden.",
  "mobile.webApp.reload": "Erneut laden",
  "mobile.webApp.authRequired": "Bitte zuerst anmelden.",
  "mobile.webApp.defaultTitle": "Web-Modul",
  "mobile.matchmixer.intro": "Turnier laden oder neuen Spielplan erstellen.",
  "mobile.matchmixer.action.loadTitle": "Turnier laden",
  "mobile.matchmixer.action.loadSubtitle": "Per Code aus der Cloud",
  "mobile.matchmixer.action.setupTitle": "Neues Turnier",
  "mobile.matchmixer.action.setupSubtitle": "Spieler, Runden und Plätze planen",
  "mobile.schleifchen.load.goSetup": "Neues Turnier planen",
  "mobile.home.deepLink": "Deep Link",

  "mobile.schleifchen.load.intro": "Turnier per Code laden.",
  "mobile.schleifchen.load.codeLabel": "Turnier-Code",
  "mobile.schleifchen.load.codePlaceholder": "z.B. ABCD12",
  "mobile.schleifchen.load.paste": "Einfügen",
  "mobile.schleifchen.load.load": "Laden",
  "mobile.schleifchen.load.status.loading": "Lade…",
  "mobile.schleifchen.load.status.notFound": "Nicht gefunden.",
  "mobile.schleifchen.load.status.loadError": "Fehler beim Laden.",
  "mobile.schleifchen.load.status.noSchedule":
    "Turnier gefunden, aber ohne Spielplan.",
  "mobile.schleifchen.load.cachedTitle": "Zuletzt geöffnet",
  "mobile.schleifchen.load.openCached": "Spielplan öffnen ({code})",
  "mobile.schleifchen.load.cachedHint": "Offline verfügbar · zuletzt {date}",
  "mobile.schleifchen.schedule.offlineHint":
    "Offline-Ansicht · zuletzt synchronisiert {date}",
  "mobile.schleifchen.setup.intro":
    "Setup → Plan generieren → Spielplan ansehen.",
  "mobile.schleifchen.setup.section.format": "Format",
  "mobile.schleifchen.setup.format.doubles": "Doppel",
  "mobile.schleifchen.setup.format.singles": "Einzel",
  "mobile.schleifchen.setup.section.players": "Spieler",
  "mobile.schleifchen.setup.players.countLabel": "Anzahl (4–24)",
  "mobile.schleifchen.setup.players.countPlaceholder": "12",
  "mobile.schleifchen.setup.players.activeHint": "Aktiv: {n}",
  "mobile.schleifchen.setup.players.namesOptional": "Namen (optional)",
  "mobile.schleifchen.setup.players.playerPlaceholder": "Spieler {n}",
  "mobile.schleifchen.setup.section.roundsCourts": "Runden & Plätze",
  "mobile.schleifchen.setup.rounds.label": "Runden",
  "mobile.schleifchen.setup.rounds.placeholder": "6",
  "mobile.schleifchen.setup.rounds.activeHint": "Aktiv: {n}",
  "mobile.schleifchen.setup.courts.label": "Plätze (Komma-getrennt)",
  "mobile.schleifchen.setup.courts.placeholder": "1, 2, 3",
  "mobile.schleifchen.setup.courts.hint": "→ {v}",
  "mobile.schleifchen.setup.createPlan": "Plan erstellen",
  "mobile.schleifchen.schedule.codeLabel": "Code",
  "mobile.schleifchen.schedule.title": "Schleifchen Spielplan.",
  "mobile.schleifchen.schedule.copy": "Kopieren",
  "mobile.schleifchen.schedule.save": "Speichern",
  "mobile.schleifchen.schedule.saveOk": "In der Cloud gespeichert.",
  "mobile.schleifchen.schedule.saveError": "Speichern fehlgeschlagen.",
  "mobile.schleifchen.schedule.saving": "Speichern…",
  "mobile.schleifchen.schedule.emptyTitle": "Kein Spielplan",
  "mobile.schleifchen.schedule.emptyHint":
    "Lade ein Turnier per Code oder erstelle einen neuen Spielplan.",
  "mobile.schleifchen.schedule.loadAction": "Turnier laden",
  "mobile.schleifchen.schedule.setupAction": "Neues Turnier",
  "mobile.schleifchen.schedule.round": "Runde {n}",
  "mobile.schleifchen.schedule.badge.completed": "Abgeschlossen",
  "mobile.schleifchen.schedule.badge.current": "Aktuell",
  "mobile.schleifchen.schedule.badge.upcoming": "Geplant",
  "mobile.schleifchen.schedule.court": "Platz {n}",
  "mobile.schleifchen.schedule.result": "Ergebnis {v}",
  "mobile.schleifchen.schedule.open": "offen",
  "mobile.schleifchen.schedule.enterResults": "Ergebnisse eintragen",
  "mobile.schleifchen.schedule.editResults": "Ergebnisse bearbeiten",
  "mobile.schleifchen.schedule.showFinish": "Abschlusstabelle ansehen",
  "mobile.common.vs": "vs",

  "mobile.schleifchen.results.navTitle": "Ergebnisse",
  "mobile.schleifchen.results.intro": "Ergebnisse für Runde {n} eintragen.",
  "mobile.schleifchen.results.save": "Speichern",
  "mobile.schleifchen.results.finish": "Turnier abschließen",
  "mobile.schleifchen.results.emptyTitle": "Keine Spiele in dieser Runde.",
  "mobile.schleifchen.results.unsupportedMode":
    "Dieses Turnier nutzt einen erweiterten Modus (z. B. Playoffs) — Ergebnisse bitte im Web eintragen.",
  "mobile.schleifchen.results.err.required": "Bitte eintragen.",
  "mobile.schleifchen.results.err.saveFailed": "Speichern fehlgeschlagen.",

  "mobile.schleifchen.finish.navTitle": "Abschluss",
  "mobile.schleifchen.finish.intro": "Turnier beendet — Abschlusstabelle.",
  "mobile.schleifchen.finish.rankingTitle": "Rangliste",
  "mobile.schleifchen.finish.stats": "S{w} U{d} N{l} · {gd}",
  "mobile.schleifchen.finish.points": "{n} Pkt.",
  "mobile.schleifchen.finish.backToHome": "Zurück zum Hub",

  "mobile.home.aiAssistant": "KI-Assistent",
  "mobile.home.aiAssistantRoute": "ki-assistent",
  "mobile.home.aiContext": "Tennis & Turniere",
  "mobile.ai.offlineHint": "Offline — gespeicherter Chat-Verlauf.",

  "belegung.brand": "BELEGUNG",
  "belegung.brandClubFallback": "Mein Verein",
  "belegung.nav.aria": "Belegung Navigation",
  "belegung.nav.overview": "Übersicht",
  "belegung.nav.club": "Mein Verein",
  "belegung.nav.schedule": "Belegungsplan",
  "belegung.nav.myBookings": "Meine Buchungen",
  "belegung.nav.teams": "Mannschaft",
  "belegung.nav.trainer": "Trainer",
  "belegung.nav.settings": "Einstellungen",
  "belegung.nav.admin": "Admin",
  "belegung.nav.help": "Hilfe",
  "belegung.nav.logout": "Abmelden",
  "belegung.memberViewBanner": "Du siehst die App aktuell als Mitglied.",
  "belegung.action.bookCourt": "Platz buchen",
  "belegung.action.viewAsMember": "Als Mitglied ansehen",
  "belegung.action.exitMemberView": "Admin-Ansicht",
  "belegung.overview.greeting": "Hallo, {name}",
  "belegung.overview.you": "du",
  "belegung.overview.freeSummary": "{free} von {total} Plätzen frei",
  "belegung.overview.nextBookings": "Nächste Buchungen",
  "belegung.overview.showAll": "Alle anzeigen →",
  "belegung.overview.empty": "Keine anstehenden Buchungen.",
  "belegung.overview.openPlan": "Zum Plan",
  "belegung.overview.noCourtsHint":
    "Lege unter Admin die Plätze für diesen Verein an – danach füllt der Tagesplan diese Fläche.",
  "belegung.overview.goAdmin": "Zu Admin",
  "belegung.status.free": "Frei",
  "belegung.status.busy": "Belegt",
  "belegung.schedule.title": "Belegungsplan",
  "belegung.schedule.today": "Heute",
  "belegung.schedule.prev": "Vorheriger Tag",
  "belegung.schedule.next": "Nächster Tag",
  "belegung.schedule.noCourts":
    "Noch keine Plätze angelegt. Unter Admin Plätze hinzufügen.",
  "belegung.bookingType.regular": "Regulär",
  "belegung.bookingType.training": "Training",
  "belegung.bookingType.team": "Mannschaft",
  "belegung.bookingType.match": "Medenspiele / LK-Turniere",
  "belegung.bookingType.blocked": "Gesperrt",
  "belegung.surface.sand": "Sand",
  "belegung.surface.carpet": "Teppich",
  "belegung.surface.hard": "Hartplatz",
  "belegung.surface.grass": "Rasen",
  "belegung.surface.other": "Sonstiges",
  "belegung.bookModal.title": "Platz buchen",
  "belegung.bookModal.court": "Platz",
  "belegung.bookModal.date": "Datum",
  "belegung.bookModal.from": "Von",
  "belegung.bookModal.to": "Bis",
  "belegung.bookModal.type": "Buchungsart",
  "belegung.bookModal.team": "Mannschaft",
  "belegung.bookModal.choose": "Wählen…",
  "belegung.bookModal.participants": "Mitspieler / Gäste",
  "belegung.bookModal.member": "Mitglied",
  "belegung.bookModal.guest": "Gast",
  "belegung.bookModal.searchMember": "Mitglied suchen",
  "belegung.bookModal.searchPlaceholder": "Mitglied suchen…",
  "belegung.bookModal.guestName": "Gastname",
  "belegung.bookModal.participantsOptional":
    "Mitspieler oder Gäste sind optional",
  "belegung.bookModal.submit": "Jetzt buchen",
  "belegung.booking.overlap":
    "Der Platz ist in diesem Zeitraum bereits belegt.",
  "belegung.booking.saveError": "Buchung konnte nicht gespeichert werden.",
  "belegung.booking.trainingTitle": "Training",
  "belegung.myBookings.title": "Meine Buchungen",
  "belegung.myBookings.empty": "Keine Buchungen vorhanden.",
  "belegung.myBookings.saveCalendar": "Im Kalender speichern",
  "belegung.myBookings.cancel": "Stornieren",
  "belegung.myBookings.cancelConfirm": "Buchung wirklich stornieren?",
  "belegung.myBookings.badgeTrainer": "Trainer",
  "belegung.myBookings.badgeBooking": "Buchung",
  "belegung.teams.title": "Mannschaften",
  "belegung.teams.subtitle": "Übersicht über alle Mannschaften im Verein",
  "belegung.teams.create": "Neue Mannschaft",
  "belegung.teams.name": "Name",
  "belegung.teams.category": "Kategorie",
  "belegung.teams.league": "Liga",
  "belegung.teams.noLeague": "Keine Liga hinterlegt",
  "belegung.teams.memberCount": "{count} Mitglieder",
  "belegung.teams.delete": "Löschen",
  "belegung.teams.deleteConfirm": "Mannschaft wirklich löschen?",
  "belegung.teams.empty": "Noch keine Mannschaften.",
  "belegung.teamCategory.damen": "Damen",
  "belegung.teamCategory.herren": "Herren",
  "belegung.teamCategory.jugend": "Jugend",
  "belegung.teamCategory.mixed": "Mixed",
  "belegung.teamCategory.other": "Sonstiges",
  "belegung.trainerBlocks.title": "Trainer-Blöcke",
  "belegung.trainerBlocks.create": "Neuer Block",
  "belegung.trainerBlocks.name": "Titel",
  "belegung.trainerBlocks.weekday": "Wochentag",
  "belegung.trainerBlocks.validFrom": "Gültig von",
  "belegung.trainerBlocks.validTo": "Gültig bis",
  "belegung.trainerBlocks.season": "Saisonblock",
  "belegung.trainerBlocks.every": "Jeden {weekday} · {court} · {from} – {to}",
  "belegung.trainerBlocks.until": "bis",
  "belegung.trainerBlocks.delete": "Löschen",
  "belegung.trainerBlocks.deleteConfirm": "Trainer-Block wirklich löschen?",
  "belegung.trainerBlocks.empty": "Noch keine Trainer-Blöcke.",
  "belegung.weekday.0": "Sonntag",
  "belegung.weekday.1": "Montag",
  "belegung.weekday.2": "Dienstag",
  "belegung.weekday.3": "Mittwoch",
  "belegung.weekday.4": "Donnerstag",
  "belegung.weekday.5": "Freitag",
  "belegung.weekday.6": "Samstag",
  "belegung.admin.title": "Admin",
  "belegung.admin.subtitle": "Plätze und Belegung verwalten",
  "belegung.admin.memberDenied":
    "Admin-Bereich ist in der Mitgliederansicht nicht verfügbar.",
  "belegung.admin.newCourt": "Neuen Platz anlegen",
  "belegung.admin.location": "Ort / Anlage",
  "belegung.admin.courtName": "Platzname",
  "belegung.admin.surface": "Belag",
  "belegung.admin.createCourt": "Platz anlegen",
  "belegung.admin.inactive": "Inaktiv",
  "belegung.admin.activate": "Aktivieren",
  "belegung.admin.deactivate": "Deaktivieren",
  "belegung.admin.delete": "Löschen",
  "belegung.admin.deleteConfirm": "Platz wirklich löschen?",
  "belegung.settings.title": "Einstellungen",
  "belegung.settings.subtitle": "Öffnungszeiten und Vorgaben",
  "belegung.settings.hoursHint":
    "Standard-Fenster für den Belegungsplan (lokal in der App).",
  "belegung.settings.hoursValue": "08:00 – 22:00",
  "belegung.club.title": "Mein Verein",
  "belegung.club.subtitle": "Anlagen und Orte aus den Stammdaten",
  "belegung.club.noAddress": "Keine Adresse hinterlegt",
  "belegung.club.empty": "Keine Orte gefunden. Orte bitte im ClubHub anlegen.",
  "belegung.club.switch": "Verein",
  "belegung.club.switchAria": "Verein wechseln",
  "belegung.planning.courtLabel": "Platz im Belegungsplan",
  "belegung.planning.courtNone": "Platz wählen…",
  "belegung.planning.enableLabel": "Training im Belegungsplan hinterlegen",
  "belegung.planning.enableHint":
    "Reserviert den gewählten Platz in der App Belegung für diesen Termin.",
  "belegung.planning.noCourts":
    "Noch keine Plätze in Belegung. Bitte unter Belegung → Admin anlegen.",
  "belegung.planning.syncOk": "Platz in Belegung reserviert",
  "belegung.planning.syncOverlap":
    "Platz in Belegung belegt — bitte anderen wählen",
  "belegung.planning.syncError": "Belegung konnte nicht aktualisiert werden",
  "trainerstunden.settings.belegung.title": "Belegung",
  "trainerstunden.settings.belegung.enabled":
    "Trainings im Belegungsplan hinterlegen",
  "trainerstunden.settings.belegung.hint":
    "In der Planung kannst du beim Anlegen eines Trainings einen Platz im Belegungsplan mitreservieren.",
  "trainerstunden.hub.inbox.provider.belegung": "Belegung",
  "trainerstunden.hub.inbox.provider.belegungShort": "Belegung",

  ...trainerDe,
  ...marketingDe,
  ...matchflowDe,
  ...winterdoppelSwapDe,
  ...winterdoppelWhatsappDe,
  "winterdoppel.plan.unpaired": "Ohne Paarung",
};
